import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: any; output: any; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: any; output: any; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /** The day, does not include a time. */
  Date: { input: any; output: any; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /**
   * A JSON Web Token defined by [RFC 7519](https://tools.ietf.org/html/rfc7519)
   * which securely represents claims between two parties.
   */
  JwtToken: { input: any; output: any; }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: any; output: any; }
};

/** All input for the `acceptInvitationToGroup` mutation. */
export type AcceptInvitationToGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['UUID']['input'];
};

/** The output of our `acceptInvitationToGroup` mutation. */
export type AcceptInvitationToGroupPayload = {
  __typename?: 'AcceptInvitationToGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type AccountBillingAccount = {
  __typename?: 'AccountBillingAccount';
  name?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
};

export type AccountBillingAddress = {
  __typename?: 'AccountBillingAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export enum AccountBillingAvailability {
  Available = 'AVAILABLE',
  Incomplete = 'INCOMPLETE',
  IntegrationNotConfigured = 'INTEGRATION_NOT_CONFIGURED',
  Loading = 'LOADING',
  MappingConflict = 'MAPPING_CONFLICT',
  NotConfigured = 'NOT_CONFIGURED',
  Unavailable = 'UNAVAILABLE'
}

export type AccountBillingCustomer = {
  __typename?: 'AccountBillingCustomer';
  debtorAccount?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalCustomerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AccountBillingDunning = {
  __typename?: 'AccountBillingDunning';
  level?: Maybe<Scalars['Int']['output']>;
  remaining?: Maybe<Scalars['String']['output']>;
  since?: Maybe<Scalars['Datetime']['output']>;
};

export type AccountBillingInvoice = {
  __typename?: 'AccountBillingInvoice';
  currency: Scalars['String']['output'];
  documentDate: Scalars['Date']['output'];
  dueDate?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  totalGross: Scalars['String']['output'];
};

export type AccountBillingInvoicePage = {
  __typename?: 'AccountBillingInvoicePage';
  items: Array<AccountBillingInvoice>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type AccountBillingLedgerEntry = {
  __typename?: 'AccountBillingLedgerEntry';
  amount?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  paymentTransactionStatus?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AccountBillingLedgerPage = {
  __typename?: 'AccountBillingLedgerPage';
  items: Array<AccountBillingLedgerEntry>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type AccountBillingPeriod = {
  __typename?: 'AccountBillingPeriod';
  quantity?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type AccountBillingProfile = {
  __typename?: 'AccountBillingProfile';
  address?: Maybe<AccountBillingAddress>;
  buyerReference?: Maybe<Scalars['String']['output']>;
  debtorAccount?: Maybe<Scalars['String']['output']>;
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalCustomerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export type AccountBillingSubscription = {
  __typename?: 'AccountBillingSubscription';
  balance?: Maybe<Scalars['String']['output']>;
  billedUntil?: Maybe<Scalars['Datetime']['output']>;
  billingPeriod?: Maybe<AccountBillingPeriod>;
  billingSuspended?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dunning?: Maybe<AccountBillingDunning>;
  endDate?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  lastBillingDate?: Maybe<Scalars['Datetime']['output']>;
  lifecycleStatus?: Maybe<Scalars['String']['output']>;
  nextBillingDate?: Maybe<Scalars['Datetime']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  planVariantId?: Maybe<Scalars['String']['output']>;
  recurringPaymentsPaused?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Datetime']['output']>;
};

export type AccountBillingSubscriptionPage = {
  __typename?: 'AccountBillingSubscriptionPage';
  items: Array<AccountBillingSubscription>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type AccountContact = {
  __typename?: 'AccountContact';
  contactId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  invitationState: AccountContactInvitationState;
  name: Scalars['String']['output'];
};

export enum AccountContactInvitationState {
  AmbiguousEmail = 'AMBIGUOUS_EMAIL',
  Available = 'AVAILABLE',
  InvalidEmail = 'INVALID_EMAIL',
  LoginConflict = 'LOGIN_CONFLICT',
  MissingEmail = 'MISSING_EMAIL',
  Pending = 'PENDING',
  Registered = 'REGISTERED'
}

export type AccountData = {
  __typename?: 'AccountData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AccountLicence = {
  __typename?: 'AccountLicence';
  accountLinkState: AccountLicenceAccountLinkState;
  activatedAt?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  currentItem?: Maybe<AccountLicenceCrmItem>;
  endDate?: Maybe<Scalars['String']['output']>;
  initialItem?: Maybe<AccountLicenceInitialItem>;
  lastContactAt?: Maybe<Scalars['String']['output']>;
  licenseState: AccountLicenceState;
  portalId: Scalars['UUID']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  tabletFacilityState: AccountLicenceTabletFacilityState;
  tabletName?: Maybe<Scalars['String']['output']>;
};

export enum AccountLicenceAccountLinkState {
  OtherAccount = 'OTHER_ACCOUNT',
  SameAccount = 'SAME_ACCOUNT',
  Unverified = 'UNVERIFIED'
}

export type AccountLicenceCrmItem = {
  __typename?: 'AccountLicenceCrmItem';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AccountLicenceInitialItem = {
  __typename?: 'AccountLicenceInitialItem';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum AccountLicenceState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Missing = 'MISSING'
}

export enum AccountLicenceTabletFacilityState {
  NoLinkedFacility = 'NO_LINKED_FACILITY',
  OtherFacility = 'OTHER_FACILITY',
  SameFacility = 'SAME_FACILITY',
  Unknown = 'UNKNOWN'
}

export type AccountLicenseManager = {
  __typename?: 'AccountLicenseManager';
  contactId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AccountManager = {
  __typename?: 'AccountManager';
  email?: Maybe<Scalars['String']['output']>;
  lastSignInAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  registeredAt: Scalars['String']['output'];
  userId: Scalars['UUID']['output'];
};

export type AccountManagerInvitation = {
  __typename?: 'AccountManagerInvitation';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
};

export type AccountManagerOrganization = {
  __typename?: 'AccountManagerOrganization';
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** All input for the `activateEncryptionForSenior` mutation. */
export type ActivateEncryptionForSeniorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mode: EncryptionMode;
  seniorId: Scalars['UUID']['input'];
};

/** The output of our `activateEncryptionForSenior` mutation. */
export type ActivateEncryptionForSeniorPayload = {
  __typename?: 'ActivateEncryptionForSeniorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `activateLicense` mutation. */
export type ActivateLicenseInput = {
  appFlavour?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  licenseId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `activateLicense` mutation. */
export type ActivateLicensePayload = {
  __typename?: 'ActivateLicensePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  licenseResponse?: Maybe<LicenseResponse>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Activity` values. */
export type ActivitiesConnection = {
  __typename?: 'ActivitiesConnection';
  /** A list of edges which contains the `Activity` and cursor to aid in pagination. */
  edges: Array<ActivitiesEdge>;
  /** A list of `Activity` objects. */
  nodes: Array<Activity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Activity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Activity` edge in the connection. */
export type ActivitiesEdge = {
  __typename?: 'ActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Activity` at the end of the edge. */
  node: Activity;
};

/** Methods to use when ordering `Activity`. */
export enum ActivitiesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Activity = Node & {
  __typename?: 'Activity';
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessions: ActivitySessionsConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsList: Array<ActivitySession>;
  /**
   * Reads and enables pagination through a set of `ContentActivity`.
   * @deprecated Please use contentActivity instead
   */
  contentActivities: ContentActivitiesConnection;
  /** Reads a single `ContentActivity` that is related to this `Activity`. */
  contentActivity?: Maybe<ContentActivity>;
  /**
   * Reads and enables pagination through a set of `CustomActivity`.
   * @deprecated Please use customActivity instead
   */
  customActivities: CustomActivitiesConnection;
  /** Reads a single `CustomActivity` that is related to this `Activity`. */
  customActivity?: Maybe<CustomActivity>;
  /**
   * Reads and enables pagination through a set of `FeatureActivity`.
   * @deprecated Please use featureActivity instead
   */
  featureActivities: FeatureActivitiesConnection;
  /** Reads a single `FeatureActivity` that is related to this `Activity`. */
  featureActivity?: Maybe<FeatureActivity>;
  id: Scalars['UUID']['output'];
  kind: ActivityKind;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByActivitySessionActivityIdAndProcedureId: ActivityProceduresByActivitySessionActivityIdAndProcedureIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByActivitySessionActivityIdAndProcedureIdList: Array<Procedure>;
  /** Reads and enables pagination through a set of `User`. */
  usersByActivitySessionActivityIdAndCaregiverId: ActivityUsersByActivitySessionActivityIdAndCaregiverIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByActivitySessionActivityIdAndCaregiverIdList: Array<User>;
};


export type ActivityActivitySessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


export type ActivityActivitySessionsListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


export type ActivityContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentActivitiesOrderBy>>;
};


export type ActivityCustomActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomActivitiesOrderBy>>;
};


export type ActivityFeatureActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FeatureActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeatureActivitiesOrderBy>>;
};


export type ActivityProceduresByActivitySessionActivityIdAndProcedureIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


export type ActivityProceduresByActivitySessionActivityIdAndProcedureIdListArgs = {
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


export type ActivityUsersByActivitySessionActivityIdAndCaregiverIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type ActivityUsersByActivitySessionActivityIdAndCaregiverIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** The fields on `activity` to look up the row to connect. */
export type ActivityActivityPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `activity` to look up the row to delete. */
export type ActivityActivityPkeyDelete = {
  id: Scalars['UUID']['input'];
};

export type ActivityCategory = {
  __typename?: 'ActivityCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * A condition to be used against `Activity` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ActivityCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActivityDocumentationManualNoteState = {
  __typename?: 'ActivityDocumentationManualNoteState';
  included: Scalars['Boolean']['output'];
  seniorId: Scalars['UUID']['output'];
};

export type ActivityGoal = Node & {
  __typename?: 'ActivityGoal';
  id: Scalars['UUID']['output'];
  kind: ActivityGoalEnum;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `ActivityGoal`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
  weeklyGoal?: Maybe<Scalars['Int']['output']>;
};

/** The fields on `activityGoal` to look up the row to connect. */
export type ActivityGoalActivityGoalPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `activityGoal` to look up the row to delete. */
export type ActivityGoalActivityGoalPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** The fields on `activityGoal` to look up the row to connect. */
export type ActivityGoalActivityGoalUserIdKindKeyConnect = {
  kind: ActivityGoalEnum;
  userId: Scalars['UUID']['input'];
};

/** The fields on `activityGoal` to look up the row to delete. */
export type ActivityGoalActivityGoalUserIdKindKeyDelete = {
  kind: ActivityGoalEnum;
  userId: Scalars['UUID']['input'];
};

/**
 * A condition to be used against `ActivityGoal` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ActivityGoalCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum ActivityGoalEnum {
  Cognitive = 'COGNITIVE',
  MentalWellbeing = 'MENTAL_WELLBEING',
  Pastime = 'PASTIME',
  Physical = 'PHYSICAL',
  SocialAndCommunicative = 'SOCIAL_AND_COMMUNICATIVE'
}

/** An input for mutations affecting `ActivityGoal` */
export type ActivityGoalInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: ActivityGoalEnum;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<ActivityGoalUserIdFkeyInput>;
  weeklyGoal?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivityGoalItem = {
  id: Scalars['UUID']['input'];
  kind: ActivityGoalEnum;
  userId: Scalars['UUID']['input'];
  weeklyGoal: Scalars['Int']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type ActivityGoalNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `activityGoal` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ActivityGoalNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `activityGoal` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ActivityGoalOnActivityGoalForActivityGoalUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `activityGoal` to look up the row to update. */
export type ActivityGoalOnActivityGoalForActivityGoalUserIdFkeyUsingActivityGoalPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activityGoal` being updated. */
  patch: UpdateActivityGoalOnActivityGoalForActivityGoalUserIdFkeyPatch;
};

/** The fields on `activityGoal` to look up the row to update. */
export type ActivityGoalOnActivityGoalForActivityGoalUserIdFkeyUsingActivityGoalUserIdKindKeyUpdate = {
  kind: ActivityGoalEnum;
  /** An object where the defined keys will be set on the `activityGoal` being updated. */
  patch: UpdateActivityGoalOnActivityGoalForActivityGoalUserIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `ActivityGoal`. Fields that are set will be updated. */
export type ActivityGoalPatch = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<ActivityGoalEnum>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<ActivityGoalUserIdFkeyInput>;
  weeklyGoal?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivityGoalProgress = {
  __typename?: 'ActivityGoalProgress';
  doneMinutes: Scalars['Int']['output'];
  kind: ActivityGoalEnum;
  weeklyGoalMinutes: Scalars['Int']['output'];
};

/** The `activityGoal` to be created by this mutation. */
export type ActivityGoalUserIdFkeyActivityGoalCreateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: ActivityGoalEnum;
  userToUserId?: InputMaybe<ActivityGoalUserIdFkeyInput>;
  weeklyGoal?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for the nested mutation of `user` in the `ActivityGoalInput` mutation. */
export type ActivityGoalUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ActivityGoalUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnActivityGoalForActivityGoalUserIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActivityGoalOnActivityGoalForActivityGoalUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `activityGoal` in the `UserInput` mutation. */
export type ActivityGoalUserIdFkeyInverseInput = {
  /** The primary key(s) for `activityGoal` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ActivityGoalActivityGoalPkeyConnect>>;
  /** The primary key(s) for `activityGoal` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ActivityGoalNodeIdConnect>>;
  /** The primary key(s) for `activityGoal` for the far side of the relationship. */
  connectByUserIdAndKind?: InputMaybe<Array<ActivityGoalActivityGoalUserIdKindKeyConnect>>;
  /** A `ActivityGoalInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ActivityGoalUserIdFkeyActivityGoalCreateInput>>;
  /** The primary key(s) for `activityGoal` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ActivityGoalActivityGoalPkeyDelete>>;
  /** The primary key(s) for `activityGoal` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ActivityGoalNodeIdDelete>>;
  /** The primary key(s) for `activityGoal` for the far side of the relationship. */
  deleteByUserIdAndKind?: InputMaybe<Array<ActivityGoalActivityGoalUserIdKindKeyDelete>>;
  /** Flag indicating whether all other `activityGoal` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `activityGoal` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ActivityGoalOnActivityGoalForActivityGoalUserIdFkeyUsingActivityGoalPkeyUpdate>>;
  /** The primary key(s) and patch data for `activityGoal` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnActivityGoalForActivityGoalUserIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `activityGoal` for the far side of the relationship. */
  updateByUserIdAndKind?: InputMaybe<Array<ActivityGoalOnActivityGoalForActivityGoalUserIdFkeyUsingActivityGoalUserIdKindKeyUpdate>>;
};

/** The `user` to be created by this mutation. */
export type ActivityGoalUserIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `ActivityGoal` values. */
export type ActivityGoalsConnection = {
  __typename?: 'ActivityGoalsConnection';
  /** A list of edges which contains the `ActivityGoal` and cursor to aid in pagination. */
  edges: Array<ActivityGoalsEdge>;
  /** A list of `ActivityGoal` objects. */
  nodes: Array<ActivityGoal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActivityGoal` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActivityGoal` edge in the connection. */
export type ActivityGoalsEdge = {
  __typename?: 'ActivityGoalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActivityGoal` at the end of the edge. */
  node: ActivityGoal;
};

export type ActivityGoalsInput = {
  activityGoals: Array<ActivityGoalItem>;
};

/** Methods to use when ordering `ActivityGoal`. */
export enum ActivityGoalsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** An input for mutations affecting `Activity` */
export type ActivityInput = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: ActivityKind;
};

export enum ActivityKind {
  Content = 'CONTENT',
  Custom = 'CUSTOM',
  Feature = 'FEATURE'
}

/** The globally unique `ID` look up for the row to connect. */
export type ActivityNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `activity` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ActivityNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `activity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ActivityOnActivitySessionForActivitySessionActivityIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activitySession` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: ActivitySessionPatch;
};

/** The fields on `activity` to look up the row to update. */
export type ActivityOnActivitySessionForActivitySessionActivityIdFkeyUsingActivityPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activity` being updated. */
  patch: UpdateActivityOnActivitySessionForActivitySessionActivityIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ActivityOnContentActivityForContentActivityActivityIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contentActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `contentActivity` being updated. */
  patch: ContentActivityPatch;
};

/** The fields on `activity` to look up the row to update. */
export type ActivityOnContentActivityForContentActivityActivityIdFkeyUsingActivityPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activity` being updated. */
  patch: UpdateActivityOnContentActivityForContentActivityActivityIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ActivityOnCustomActivityForCustomActivityFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `customActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `customActivity` being updated. */
  patch: CustomActivityPatch;
};

/** The fields on `activity` to look up the row to update. */
export type ActivityOnCustomActivityForCustomActivityFkeyUsingActivityPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activity` being updated. */
  patch: UpdateActivityOnCustomActivityForCustomActivityFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ActivityOnFeatureActivityForFeatureActivityFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `featureActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `featureActivity` being updated. */
  patch: FeatureActivityPatch;
};

/** The fields on `activity` to look up the row to update. */
export type ActivityOnFeatureActivityForFeatureActivityFkeyUsingActivityPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activity` being updated. */
  patch: UpdateActivityOnFeatureActivityForFeatureActivityFkeyPatch;
};

export type ActivityParticipant = Node & {
  __typename?: 'ActivityParticipant';
  /** Reads a single `ActivitySession` that is related to this `ActivityParticipant`. */
  activitySession?: Maybe<ActivitySession>;
  activitySessionId: Scalars['UUID']['output'];
  /** When this participant's Activity documentation was filed. NULL means their part is still a draft. */
  documentationPublishedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `ActivityParticipant`. */
  senior?: Maybe<User>;
  seniorId: Scalars['UUID']['output'];
};

/** The fields on `activityParticipant` to look up the row to connect. */
export type ActivityParticipantActivityParticipantPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `activityParticipant` to look up the row to delete. */
export type ActivityParticipantActivityParticipantPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** The fields on `activityParticipant` to look up the row to connect. */
export type ActivityParticipantActivityParticipantSessionSeniorUniqueConnect = {
  activitySessionId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};

/** The fields on `activityParticipant` to look up the row to delete. */
export type ActivityParticipantActivityParticipantSessionSeniorUniqueDelete = {
  activitySessionId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};

/** The `activityParticipant` to be created by this mutation. */
export type ActivityParticipantActivitySessionIdFkeyActivityParticipantCreateInput = {
  activitySessionToActivitySessionId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  noteUsingActivitySessionIdAndSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInverseInput>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorId?: InputMaybe<ActivityParticipantSeniorIdFkeyInput>;
};

/** The `activitySession` to be created by this mutation. */
export type ActivityParticipantActivitySessionIdFkeyActivitySessionCreateInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: SessionKind;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** Input for the nested mutation of `activitySession` in the `ActivityParticipantInput` mutation. */
export type ActivityParticipantActivitySessionIdFkeyInput = {
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectById?: InputMaybe<ActivitySessionActivitySessionPkeyConnect>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ActivitySessionNodeIdConnect>;
  /** A `ActivitySessionInput` object that will be created and connected to this object. */
  create?: InputMaybe<ActivityParticipantActivitySessionIdFkeyActivitySessionCreateInput>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteById?: InputMaybe<ActivitySessionActivitySessionPkeyDelete>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ActivitySessionNodeIdDelete>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateById?: InputMaybe<ActivitySessionOnActivityParticipantForActivityParticipantActivitySessionIdFkeyUsingActivitySessionPkeyUpdate>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActivityParticipantOnActivityParticipantForActivityParticipantActivitySessionIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `activityParticipant` in the `ActivitySessionInput` mutation. */
export type ActivityParticipantActivitySessionIdFkeyInverseInput = {
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  connectByActivitySessionIdAndSeniorId?: InputMaybe<Array<ActivityParticipantActivityParticipantSessionSeniorUniqueConnect>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ActivityParticipantActivityParticipantPkeyConnect>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ActivityParticipantNodeIdConnect>>;
  /** A `ActivityParticipantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ActivityParticipantActivitySessionIdFkeyActivityParticipantCreateInput>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  deleteByActivitySessionIdAndSeniorId?: InputMaybe<Array<ActivityParticipantActivityParticipantSessionSeniorUniqueDelete>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ActivityParticipantActivityParticipantPkeyDelete>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ActivityParticipantNodeIdDelete>>;
  /** Flag indicating whether all other `activityParticipant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `activityParticipant` for the far side of the relationship. */
  updateByActivitySessionIdAndSeniorId?: InputMaybe<Array<ActivityParticipantOnActivityParticipantForActivityParticipantActivitySessionIdFkeyUsingActivityParticipantSessionSeniorUniqueUpdate>>;
  /** The primary key(s) and patch data for `activityParticipant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ActivityParticipantOnActivityParticipantForActivityParticipantActivitySessionIdFkeyUsingActivityParticipantPkeyUpdate>>;
  /** The primary key(s) and patch data for `activityParticipant` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ActivitySessionOnActivityParticipantForActivityParticipantActivitySessionIdFkeyNodeIdUpdate>>;
};

/**
 * A condition to be used against `ActivityParticipant` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ActivityParticipantCondition = {
  /** Checks for equality with the object’s `activitySessionId` field. */
  activitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `seniorId` field. */
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `ActivityParticipant` */
export type ActivityParticipantInput = {
  activitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  activitySessionToActivitySessionId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  noteUsingActivitySessionIdAndSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInverseInput>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorId?: InputMaybe<ActivityParticipantSeniorIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ActivityParticipantNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `activityParticipant` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ActivityParticipantNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `activityParticipant` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ActivityParticipantOnActivityParticipantForActivityParticipantActivitySessionIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activitySession` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: ActivitySessionPatch;
};

/** The fields on `activityParticipant` to look up the row to update. */
export type ActivityParticipantOnActivityParticipantForActivityParticipantActivitySessionIdFkeyUsingActivityParticipantPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activityParticipant` being updated. */
  patch: UpdateActivityParticipantOnActivityParticipantForActivityParticipantActivitySessionIdFkeyPatch;
};

/** The fields on `activityParticipant` to look up the row to update. */
export type ActivityParticipantOnActivityParticipantForActivityParticipantActivitySessionIdFkeyUsingActivityParticipantSessionSeniorUniqueUpdate = {
  activitySessionId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activityParticipant` being updated. */
  patch: UpdateActivityParticipantOnActivityParticipantForActivityParticipantActivitySessionIdFkeyPatch;
  seniorId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ActivityParticipantOnActivityParticipantForActivityParticipantSeniorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `activityParticipant` to look up the row to update. */
export type ActivityParticipantOnActivityParticipantForActivityParticipantSeniorIdFkeyUsingActivityParticipantPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activityParticipant` being updated. */
  patch: UpdateActivityParticipantOnActivityParticipantForActivityParticipantSeniorIdFkeyPatch;
};

/** The fields on `activityParticipant` to look up the row to update. */
export type ActivityParticipantOnActivityParticipantForActivityParticipantSeniorIdFkeyUsingActivityParticipantSessionSeniorUniqueUpdate = {
  activitySessionId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activityParticipant` being updated. */
  patch: UpdateActivityParticipantOnActivityParticipantForActivityParticipantSeniorIdFkeyPatch;
  seniorId: Scalars['UUID']['input'];
};

/** Represents an update to a `ActivityParticipant`. Fields that are set will be updated. */
export type ActivityParticipantPatch = {
  activitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  activitySessionToActivitySessionId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  noteUsingActivitySessionIdAndSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInverseInput>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorId?: InputMaybe<ActivityParticipantSeniorIdFkeyInput>;
};

/** The `activityParticipant` to be created by this mutation. */
export type ActivityParticipantSeniorIdFkeyActivityParticipantCreateInput = {
  activitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  activitySessionToActivitySessionId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  noteUsingActivitySessionIdAndSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInverseInput>;
  userToSeniorId?: InputMaybe<ActivityParticipantSeniorIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `ActivityParticipantInput` mutation. */
export type ActivityParticipantSeniorIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ActivityParticipantSeniorIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnActivityParticipantForActivityParticipantSeniorIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActivityParticipantOnActivityParticipantForActivityParticipantSeniorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `activityParticipant` in the `UserInput` mutation. */
export type ActivityParticipantSeniorIdFkeyInverseInput = {
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  connectByActivitySessionIdAndSeniorId?: InputMaybe<Array<ActivityParticipantActivityParticipantSessionSeniorUniqueConnect>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ActivityParticipantActivityParticipantPkeyConnect>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ActivityParticipantNodeIdConnect>>;
  /** A `ActivityParticipantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ActivityParticipantSeniorIdFkeyActivityParticipantCreateInput>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  deleteByActivitySessionIdAndSeniorId?: InputMaybe<Array<ActivityParticipantActivityParticipantSessionSeniorUniqueDelete>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ActivityParticipantActivityParticipantPkeyDelete>>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ActivityParticipantNodeIdDelete>>;
  /** Flag indicating whether all other `activityParticipant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `activityParticipant` for the far side of the relationship. */
  updateByActivitySessionIdAndSeniorId?: InputMaybe<Array<ActivityParticipantOnActivityParticipantForActivityParticipantSeniorIdFkeyUsingActivityParticipantSessionSeniorUniqueUpdate>>;
  /** The primary key(s) and patch data for `activityParticipant` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ActivityParticipantOnActivityParticipantForActivityParticipantSeniorIdFkeyUsingActivityParticipantPkeyUpdate>>;
  /** The primary key(s) and patch data for `activityParticipant` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnActivityParticipantForActivityParticipantSeniorIdFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type ActivityParticipantSeniorIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `ActivityParticipant` values. */
export type ActivityParticipantsConnection = {
  __typename?: 'ActivityParticipantsConnection';
  /** A list of edges which contains the `ActivityParticipant` and cursor to aid in pagination. */
  edges: Array<ActivityParticipantsEdge>;
  /** A list of `ActivityParticipant` objects. */
  nodes: Array<ActivityParticipant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActivityParticipant` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActivityParticipant` edge in the connection. */
export type ActivityParticipantsEdge = {
  __typename?: 'ActivityParticipantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActivityParticipant` at the end of the edge. */
  node: ActivityParticipant;
};

/** Methods to use when ordering `ActivityParticipant`. */
export enum ActivityParticipantsOrderBy {
  ActivitySessionIdAsc = 'ACTIVITY_SESSION_ID_ASC',
  ActivitySessionIdDesc = 'ACTIVITY_SESSION_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SeniorIdAsc = 'SENIOR_ID_ASC',
  SeniorIdDesc = 'SENIOR_ID_DESC'
}

/** Represents an update to a `Activity`. Fields that are set will be updated. */
export type ActivityPatch = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<ActivityKind>;
};

/** A connection to a list of `Procedure` values, with data from `ActivitySession`. */
export type ActivityProceduresByActivitySessionActivityIdAndProcedureIdManyToManyConnection = {
  __typename?: 'ActivityProceduresByActivitySessionActivityIdAndProcedureIdManyToManyConnection';
  /** A list of edges which contains the `Procedure`, info from the `ActivitySession`, and the cursor to aid in pagination. */
  edges: Array<ActivityProceduresByActivitySessionActivityIdAndProcedureIdManyToManyEdge>;
  /** A list of `Procedure` objects. */
  nodes: Array<Procedure>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Procedure` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Procedure` edge in the connection, with data from `ActivitySession`. */
export type ActivityProceduresByActivitySessionActivityIdAndProcedureIdManyToManyEdge = {
  __typename?: 'ActivityProceduresByActivitySessionActivityIdAndProcedureIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessions: ActivitySessionsConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsList: Array<ActivitySession>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Procedure` at the end of the edge. */
  node: Procedure;
};


/** A `Procedure` edge in the connection, with data from `ActivitySession`. */
export type ActivityProceduresByActivitySessionActivityIdAndProcedureIdManyToManyEdgeActivitySessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** A `Procedure` edge in the connection, with data from `ActivitySession`. */
export type ActivityProceduresByActivitySessionActivityIdAndProcedureIdManyToManyEdgeActivitySessionsListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};

export type ActivityRecommendation = {
  __typename?: 'ActivityRecommendation';
  cmsContentId: Scalars['Int']['output'];
  cmsContentKind: Scalars['String']['output'];
  contentUuid: Scalars['UUID']['output'];
  durationMinutes: Scalars['Int']['output'];
  isPlanned: Scalars['Boolean']['output'];
  kind: ActivityGoalEnum;
  thumbnailFilename?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ActivitySession = Node & {
  __typename?: 'ActivitySession';
  /** Reads a single `Activity` that is related to this `ActivitySession`. */
  activity?: Maybe<Activity>;
  /** Inclusion state for each resident-specific manual note in this draft. */
  activityDocumentationManualNoteStates: Array<ActivityDocumentationManualNoteState>;
  activityId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `ActivityParticipant`. */
  activityParticipants: ActivityParticipantsConnection;
  /** Reads and enables pagination through a set of `ActivityParticipant`. */
  activityParticipantsList: Array<ActivityParticipant>;
  beganAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `ActivitySession`. */
  caregiver?: Maybe<User>;
  caregiverId?: Maybe<Scalars['UUID']['output']>;
  /** When the caregiver finalized this Activity documentation. NULL means the aggregate is still a draft. */
  documentationPublishedAt?: Maybe<Scalars['Datetime']['output']>;
  endedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  kind: SessionKind;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Note`. */
  noteList: Array<Note>;
  positionInProcedure?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Procedure` that is related to this `ActivitySession`. */
  procedure?: Maybe<Procedure>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: Maybe<Scalars['UUID']['output']>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: Maybe<SessionStatus>;
  /** Reads and enables pagination through a set of `User`. */
  usersByActivityParticipantActivitySessionIdAndSeniorId: ActivitySessionUsersByActivityParticipantActivitySessionIdAndSeniorIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByActivityParticipantActivitySessionIdAndSeniorIdList: Array<User>;
};


export type ActivitySessionActivityParticipantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivityParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityParticipantsOrderBy>>;
};


export type ActivitySessionActivityParticipantsListArgs = {
  condition?: InputMaybe<ActivityParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityParticipantsOrderBy>>;
};


export type ActivitySessionNoteListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivitySessionUsersByActivityParticipantActivitySessionIdAndSeniorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type ActivitySessionUsersByActivityParticipantActivitySessionIdAndSeniorIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** The `activity` to be created by this mutation. */
export type ActivitySessionActivityIdFkeyActivityCreateInput = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: ActivityKind;
};

/** The `activitySession` to be created by this mutation. */
export type ActivitySessionActivityIdFkeyActivitySessionCreateInput = {
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: SessionKind;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** Input for the nested mutation of `activity` in the `ActivitySessionInput` mutation. */
export type ActivitySessionActivityIdFkeyInput = {
  /** The primary key(s) for `activity` for the far side of the relationship. */
  connectById?: InputMaybe<ActivityActivityPkeyConnect>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ActivityNodeIdConnect>;
  /** A `ActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<ActivitySessionActivityIdFkeyActivityCreateInput>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  deleteById?: InputMaybe<ActivityActivityPkeyDelete>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ActivityNodeIdDelete>;
  /** The primary key(s) and patch data for `activity` for the far side of the relationship. */
  updateById?: InputMaybe<ActivityOnActivitySessionForActivitySessionActivityIdFkeyUsingActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `activity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActivitySessionOnActivitySessionForActivitySessionActivityIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `activitySession` in the `ActivityInput` mutation. */
export type ActivitySessionActivityIdFkeyInverseInput = {
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ActivitySessionActivitySessionPkeyConnect>>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ActivitySessionNodeIdConnect>>;
  /** A `ActivitySessionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ActivitySessionActivityIdFkeyActivitySessionCreateInput>>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ActivitySessionActivitySessionPkeyDelete>>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ActivitySessionNodeIdDelete>>;
  /** Flag indicating whether all other `activitySession` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ActivitySessionOnActivitySessionForActivitySessionActivityIdFkeyUsingActivitySessionPkeyUpdate>>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ActivityOnActivitySessionForActivitySessionActivityIdFkeyNodeIdUpdate>>;
};

/** The fields on `activitySession` to look up the row to connect. */
export type ActivitySessionActivitySessionPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `activitySession` to look up the row to delete. */
export type ActivitySessionActivitySessionPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** The `activitySession` to be created by this mutation. */
export type ActivitySessionCaregiverIdFkeyActivitySessionCreateInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: SessionKind;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `ActivitySessionInput` mutation. */
export type ActivitySessionCaregiverIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ActivitySessionCaregiverIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnActivitySessionForActivitySessionCaregiverIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActivitySessionOnActivitySessionForActivitySessionCaregiverIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `activitySession` in the `UserInput` mutation. */
export type ActivitySessionCaregiverIdFkeyInverseInput = {
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ActivitySessionActivitySessionPkeyConnect>>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ActivitySessionNodeIdConnect>>;
  /** A `ActivitySessionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ActivitySessionCaregiverIdFkeyActivitySessionCreateInput>>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ActivitySessionActivitySessionPkeyDelete>>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ActivitySessionNodeIdDelete>>;
  /** Flag indicating whether all other `activitySession` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ActivitySessionOnActivitySessionForActivitySessionCaregiverIdFkeyUsingActivitySessionPkeyUpdate>>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnActivitySessionForActivitySessionCaregiverIdFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type ActivitySessionCaregiverIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/**
 * A condition to be used against `ActivitySession` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ActivitySessionCondition = {
  /** Checks for equality with the object’s `activityId` field. */
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `beganAt` field. */
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `caregiverId` field. */
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `procedureId` field. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `sessionStatus` field. */
  sessionStatus?: InputMaybe<SessionStatus>;
};

/** An input for mutations affecting `ActivitySession` */
export type ActivitySessionInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: SessionKind;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ActivitySessionNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `activitySession` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ActivitySessionNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `activitySession` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ActivitySessionOnActivityParticipantForActivityParticipantActivitySessionIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activityParticipant` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activityParticipant` being updated. */
  patch: ActivityParticipantPatch;
};

/** The fields on `activitySession` to look up the row to update. */
export type ActivitySessionOnActivityParticipantForActivityParticipantActivitySessionIdFkeyUsingActivitySessionPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: UpdateActivitySessionOnActivityParticipantForActivityParticipantActivitySessionIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ActivitySessionOnActivitySessionForActivitySessionActivityIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activity` being updated. */
  patch: ActivityPatch;
};

/** The fields on `activitySession` to look up the row to update. */
export type ActivitySessionOnActivitySessionForActivitySessionActivityIdFkeyUsingActivitySessionPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: UpdateActivitySessionOnActivitySessionForActivitySessionActivityIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ActivitySessionOnActivitySessionForActivitySessionCaregiverIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `activitySession` to look up the row to update. */
export type ActivitySessionOnActivitySessionForActivitySessionCaregiverIdFkeyUsingActivitySessionPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: UpdateActivitySessionOnActivitySessionForActivitySessionCaregiverIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ActivitySessionOnActivitySessionForActivitySessionProcedureIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `procedure` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: ProcedurePatch;
};

/** The fields on `activitySession` to look up the row to update. */
export type ActivitySessionOnActivitySessionForActivitySessionProcedureIdFkeyUsingActivitySessionPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: UpdateActivitySessionOnActivitySessionForActivitySessionProcedureIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `noteActivitySession` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `noteActivitySession` being updated. */
  patch: NoteActivitySessionPatch;
};

/** The fields on `activitySession` to look up the row to update. */
export type ActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyUsingActivitySessionPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: UpdateActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyPatch;
};

export type ActivitySessionOutput = {
  __typename?: 'ActivitySessionOutput';
  activity_categories?: Maybe<Array<ActivityCategory>>;
  activity_detail: Scalars['String']['output'];
  activity_kind: Scalars['String']['output'];
  activity_title?: Maybe<Scalars['String']['output']>;
  began_at: Scalars['String']['output'];
  caregiver_id: Scalars['String']['output'];
  caregiver_name: Scalars['String']['output'];
  ended_at: Scalars['String']['output'];
  participant_id: Scalars['String']['output'];
  participant_name: Scalars['String']['output'];
  session_id: Scalars['String']['output'];
  session_kind: Scalars['String']['output'];
};

/** Represents an update to a `ActivitySession`. Fields that are set will be updated. */
export type ActivitySessionPatch = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<SessionKind>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

export enum ActivitySessionPosition {
  First = 'FIRST',
  Last = 'LAST',
  Middle = 'MIDDLE'
}

/** The `activitySession` to be created by this mutation. */
export type ActivitySessionProcedureIdFkeyActivitySessionCreateInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: SessionKind;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** Input for the nested mutation of `procedure` in the `ActivitySessionInput` mutation. */
export type ActivitySessionProcedureIdFkeyInput = {
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectById?: InputMaybe<ProcedureProcedurePkeyConnect>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProcedureNodeIdConnect>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureChkProcedureExternalIdSourceConnect>;
  /** A `ProcedureInput` object that will be created and connected to this object. */
  create?: InputMaybe<ActivitySessionProcedureIdFkeyProcedureCreateInput>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteById?: InputMaybe<ProcedureProcedurePkeyDelete>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProcedureNodeIdDelete>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureChkProcedureExternalIdSourceDelete>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateById?: InputMaybe<ProcedureOnActivitySessionForActivitySessionProcedureIdFkeyUsingProcedurePkeyUpdate>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActivitySessionOnActivitySessionForActivitySessionProcedureIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureOnActivitySessionForActivitySessionProcedureIdFkeyUsingChkProcedureExternalIdSourceUpdate>;
};

/** Input for the nested mutation of `activitySession` in the `ProcedureInput` mutation. */
export type ActivitySessionProcedureIdFkeyInverseInput = {
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ActivitySessionActivitySessionPkeyConnect>>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ActivitySessionNodeIdConnect>>;
  /** A `ActivitySessionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ActivitySessionProcedureIdFkeyActivitySessionCreateInput>>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ActivitySessionActivitySessionPkeyDelete>>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ActivitySessionNodeIdDelete>>;
  /** Flag indicating whether all other `activitySession` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ActivitySessionOnActivitySessionForActivitySessionProcedureIdFkeyUsingActivitySessionPkeyUpdate>>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProcedureOnActivitySessionForActivitySessionProcedureIdFkeyNodeIdUpdate>>;
};

/** The `procedure` to be created by this mutation. */
export type ActivitySessionProcedureIdFkeyProcedureCreateInput = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `User` values, with data from `ActivityParticipant`. */
export type ActivitySessionUsersByActivityParticipantActivitySessionIdAndSeniorIdManyToManyConnection = {
  __typename?: 'ActivitySessionUsersByActivityParticipantActivitySessionIdAndSeniorIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `ActivityParticipant`, and the cursor to aid in pagination. */
  edges: Array<ActivitySessionUsersByActivityParticipantActivitySessionIdAndSeniorIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `ActivityParticipant`. */
export type ActivitySessionUsersByActivityParticipantActivitySessionIdAndSeniorIdManyToManyEdge = {
  __typename?: 'ActivitySessionUsersByActivityParticipantActivitySessionIdAndSeniorIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** When this participant's Activity documentation was filed. NULL means their part is still a draft. */
  documentationPublishedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  /** The `User` at the end of the edge. */
  node: User;
};

/** A connection to a list of `ActivitySession` values. */
export type ActivitySessionsConnection = {
  __typename?: 'ActivitySessionsConnection';
  /** A list of edges which contains the `ActivitySession` and cursor to aid in pagination. */
  edges: Array<ActivitySessionsEdge>;
  /** A list of `ActivitySession` objects. */
  nodes: Array<ActivitySession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActivitySession` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActivitySession` edge in the connection. */
export type ActivitySessionsEdge = {
  __typename?: 'ActivitySessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActivitySession` at the end of the edge. */
  node: ActivitySession;
};

/** Methods to use when ordering `ActivitySession`. */
export enum ActivitySessionsOrderBy {
  ActivityIdAsc = 'ACTIVITY_ID_ASC',
  ActivityIdDesc = 'ACTIVITY_ID_DESC',
  BeganAtAsc = 'BEGAN_AT_ASC',
  BeganAtDesc = 'BEGAN_AT_DESC',
  CaregiverIdAsc = 'CAREGIVER_ID_ASC',
  CaregiverIdDesc = 'CAREGIVER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcedureIdAsc = 'PROCEDURE_ID_ASC',
  ProcedureIdDesc = 'PROCEDURE_ID_DESC',
  SessionStatusAsc = 'SESSION_STATUS_ASC',
  SessionStatusDesc = 'SESSION_STATUS_DESC'
}

/** A connection to a list of `User` values, with data from `ActivitySession`. */
export type ActivityUsersByActivitySessionActivityIdAndCaregiverIdManyToManyConnection = {
  __typename?: 'ActivityUsersByActivitySessionActivityIdAndCaregiverIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `ActivitySession`, and the cursor to aid in pagination. */
  edges: Array<ActivityUsersByActivitySessionActivityIdAndCaregiverIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `ActivitySession`. */
export type ActivityUsersByActivitySessionActivityIdAndCaregiverIdManyToManyEdge = {
  __typename?: 'ActivityUsersByActivitySessionActivityIdAndCaregiverIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsByCaregiverId: ActivitySessionsConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsByCaregiverIdList: Array<ActivitySession>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};


/** A `User` edge in the connection, with data from `ActivitySession`. */
export type ActivityUsersByActivitySessionActivityIdAndCaregiverIdManyToManyEdgeActivitySessionsByCaregiverIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** A `User` edge in the connection, with data from `ActivitySession`. */
export type ActivityUsersByActivitySessionActivityIdAndCaregiverIdManyToManyEdgeActivitySessionsByCaregiverIdListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};

export type AddActivitySessionToNoteInput = {
  noteId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type AddMediaToAlbumInput = {
  albumId: Scalars['UUID']['input'];
  mediaItemIds: Array<Scalars['UUID']['input']>;
};

/** All input for the `addUserDevice` mutation. */
export type AddUserDeviceInput = {
  appFlavour?: InputMaybe<Scalars['String']['input']>;
  appPackageId?: InputMaybe<Scalars['String']['input']>;
  appPackageName?: InputMaybe<Scalars['String']['input']>;
  appSigning?: InputMaybe<Scalars['String']['input']>;
  appSwMode?: InputMaybe<Scalars['String']['input']>;
  appUpdateMode?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  chromeVersion?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentVersion?: InputMaybe<Scalars['String']['input']>;
  deviceIccid?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  deviceImei?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceSerialNo?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<DevicePlatform>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  supportsEncryption?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  videocallVersion?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `addUserDevice` mutation. */
export type AddUserDevicePayload = {
  __typename?: 'AddUserDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type AdminMfaResponse = {
  __typename?: 'AdminMfaResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  challengeToken?: Maybe<Scalars['String']['output']>;
  otpauthUri?: Maybe<Scalars['String']['output']>;
  recoveryCodes?: Maybe<Array<Scalars['String']['output']>>;
  retryAfterSeconds?: Maybe<Scalars['Int']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
  status: AdminMfaStatus;
};

export type AdminMfaSettings = {
  __typename?: 'AdminMfaSettings';
  enabled: Scalars['Boolean']['output'];
};

export enum AdminMfaStatus {
  Authenticated = 'authenticated',
  Disabled = 'disabled',
  EnrollmentRequired = 'enrollmentRequired',
  Expired = 'expired',
  InvalidCode = 'invalidCode',
  Locked = 'locked',
  VerificationRequired = 'verificationRequired'
}

export enum AdminPortalFeedbackCategory {
  Bug = 'BUG',
  Idea = 'IDEA',
  Other = 'OTHER',
  Question = 'QUESTION'
}

export type AlbumDeletedForUserPayload = {
  __typename?: 'AlbumDeletedForUserPayload';
  album: MediaAlbum;
};

export type AlbumMedia = Node & {
  __typename?: 'AlbumMedia';
  /** Reads a single `MediaAlbum` that is related to this `AlbumMedia`. */
  album?: Maybe<MediaAlbum>;
  albumId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  /** Reads a single `Media` that is related to this `AlbumMedia`. */
  media?: Maybe<Media>;
  mediaId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** Input for the nested mutation of `mediaAlbum` in the `AlbumMediaInput` mutation. */
export type AlbumMediaAlbumIdFkeyInput = {
  /** The primary key(s) for `mediaAlbum` for the far side of the relationship. */
  connectById?: InputMaybe<MediaAlbumMediaAlbumPkeyConnect>;
  /** The primary key(s) for `mediaAlbum` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MediaAlbumNodeIdConnect>;
  /** A `MediaAlbumInput` object that will be created and connected to this object. */
  create?: InputMaybe<AlbumMediaAlbumIdFkeyMediaAlbumCreateInput>;
  /** The primary key(s) and patch data for `mediaAlbum` for the far side of the relationship. */
  updateById?: InputMaybe<MediaAlbumOnAlbumMediaForAlbumMediaAlbumIdFkeyUsingMediaAlbumPkeyUpdate>;
  /** The primary key(s) and patch data for `mediaAlbum` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AlbumMediaOnAlbumMediaForAlbumMediaAlbumIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `albumMedia` in the `MediaAlbumInput` mutation. */
export type AlbumMediaAlbumIdFkeyInverseInput = {
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AlbumMediaAlbumMediaPkeyConnect>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  connectByMediaIdAndAlbumId?: InputMaybe<Array<AlbumMediaUniqueMediaInAlbumConnect>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AlbumMediaNodeIdConnect>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AlbumMediaAlbumMediaPkeyDelete>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  deleteByMediaIdAndAlbumId?: InputMaybe<Array<AlbumMediaUniqueMediaInAlbumDelete>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AlbumMediaNodeIdDelete>>;
  /** Flag indicating whether all other `albumMedia` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `albumMedia` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AlbumMediaOnAlbumMediaForAlbumMediaAlbumIdFkeyUsingAlbumMediaPkeyUpdate>>;
  /** The primary key(s) and patch data for `albumMedia` for the far side of the relationship. */
  updateByMediaIdAndAlbumId?: InputMaybe<Array<AlbumMediaOnAlbumMediaForAlbumMediaAlbumIdFkeyUsingUniqueMediaInAlbumUpdate>>;
  /** The primary key(s) and patch data for `albumMedia` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<MediaAlbumOnAlbumMediaForAlbumMediaAlbumIdFkeyNodeIdUpdate>>;
};

/** The `mediaAlbum` to be created by this mutation. */
export type AlbumMediaAlbumIdFkeyMediaAlbumCreateInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaAlbumIdFkeyInverseInput>;
  albumName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaAlbumKind>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<MediaAlbumUserIdFkeyInput>;
};

/** The fields on `albumMedia` to look up the row to connect. */
export type AlbumMediaAlbumMediaPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `albumMedia` to look up the row to delete. */
export type AlbumMediaAlbumMediaPkeyDelete = {
  id: Scalars['UUID']['input'];
};

export type AlbumMediaChangesPayload = {
  __typename?: 'AlbumMediaChangesPayload';
  album?: Maybe<MediaAlbum>;
};

/** Input for the nested mutation of `media` in the `AlbumMediaInput` mutation. */
export type AlbumMediaMediaIdFkeyInput = {
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectById?: InputMaybe<MediaMediaPkeyConnect>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MediaNodeIdConnect>;
  /** A `MediaInput` object that will be created and connected to this object. */
  create?: InputMaybe<AlbumMediaMediaIdFkeyMediaCreateInput>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteById?: InputMaybe<MediaMediaPkeyDelete>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<MediaNodeIdDelete>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateById?: InputMaybe<MediaOnAlbumMediaForAlbumMediaMediaIdFkeyUsingMediaPkeyUpdate>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AlbumMediaOnAlbumMediaForAlbumMediaMediaIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `albumMedia` in the `MediaInput` mutation. */
export type AlbumMediaMediaIdFkeyInverseInput = {
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AlbumMediaAlbumMediaPkeyConnect>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  connectByMediaIdAndAlbumId?: InputMaybe<Array<AlbumMediaUniqueMediaInAlbumConnect>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AlbumMediaNodeIdConnect>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AlbumMediaAlbumMediaPkeyDelete>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  deleteByMediaIdAndAlbumId?: InputMaybe<Array<AlbumMediaUniqueMediaInAlbumDelete>>;
  /** The primary key(s) for `albumMedia` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AlbumMediaNodeIdDelete>>;
  /** Flag indicating whether all other `albumMedia` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `albumMedia` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AlbumMediaOnAlbumMediaForAlbumMediaMediaIdFkeyUsingAlbumMediaPkeyUpdate>>;
  /** The primary key(s) and patch data for `albumMedia` for the far side of the relationship. */
  updateByMediaIdAndAlbumId?: InputMaybe<Array<AlbumMediaOnAlbumMediaForAlbumMediaMediaIdFkeyUsingUniqueMediaInAlbumUpdate>>;
  /** The primary key(s) and patch data for `albumMedia` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<MediaOnAlbumMediaForAlbumMediaMediaIdFkeyNodeIdUpdate>>;
};

/** The `media` to be created by this mutation. */
export type AlbumMediaMediaIdFkeyMediaCreateInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AlbumMediaNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `albumMedia` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type AlbumMediaNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `albumMedia` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type AlbumMediaOnAlbumMediaForAlbumMediaAlbumIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `mediaAlbum` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `mediaAlbum` being updated. */
  patch: MediaAlbumPatch;
};

/** The fields on `albumMedia` to look up the row to update. */
export type AlbumMediaOnAlbumMediaForAlbumMediaAlbumIdFkeyUsingAlbumMediaPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `albumMedia` being updated. */
  patch: UpdateAlbumMediaOnAlbumMediaForAlbumMediaAlbumIdFkeyPatch;
};

/** The fields on `albumMedia` to look up the row to update. */
export type AlbumMediaOnAlbumMediaForAlbumMediaAlbumIdFkeyUsingUniqueMediaInAlbumUpdate = {
  albumId: Scalars['UUID']['input'];
  mediaId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `albumMedia` being updated. */
  patch: UpdateAlbumMediaOnAlbumMediaForAlbumMediaAlbumIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type AlbumMediaOnAlbumMediaForAlbumMediaMediaIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `media` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: MediaPatch;
};

/** The fields on `albumMedia` to look up the row to update. */
export type AlbumMediaOnAlbumMediaForAlbumMediaMediaIdFkeyUsingAlbumMediaPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `albumMedia` being updated. */
  patch: UpdateAlbumMediaOnAlbumMediaForAlbumMediaMediaIdFkeyPatch;
};

/** The fields on `albumMedia` to look up the row to update. */
export type AlbumMediaOnAlbumMediaForAlbumMediaMediaIdFkeyUsingUniqueMediaInAlbumUpdate = {
  albumId: Scalars['UUID']['input'];
  mediaId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `albumMedia` being updated. */
  patch: UpdateAlbumMediaOnAlbumMediaForAlbumMediaMediaIdFkeyPatch;
};

/** Represents an update to a `AlbumMedia`. Fields that are set will be updated. */
export type AlbumMediaPatch = {
  albumId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  mediaAlbumToAlbumId?: InputMaybe<AlbumMediaAlbumIdFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  mediaToMediaId?: InputMaybe<AlbumMediaMediaIdFkeyInput>;
};

/** The fields on `albumMedia` to look up the row to connect. */
export type AlbumMediaUniqueMediaInAlbumConnect = {
  albumId: Scalars['UUID']['input'];
  mediaId: Scalars['UUID']['input'];
};

/** The fields on `albumMedia` to look up the row to delete. */
export type AlbumMediaUniqueMediaInAlbumDelete = {
  albumId: Scalars['UUID']['input'];
  mediaId: Scalars['UUID']['input'];
};

export type Announcement = {
  __typename?: 'Announcement';
  activeFrom: Scalars['Datetime']['output'];
  activeUntil?: Maybe<Scalars['Datetime']['output']>;
  displayType?: Maybe<AnnouncementDisplayType>;
  id: Scalars['Int']['output'];
  richText: RichText;
};

export enum AnnouncementDisplayType {
  Banner = 'banner',
  Modal = 'modal',
  Standard = 'standard'
}

export type AnnouncementV2 = {
  __typename?: 'AnnouncementV2';
  activeFrom: Scalars['Datetime']['output'];
  activeUntil: Scalars['Datetime']['output'];
  displayType: AnnouncementDisplayType;
  id: Scalars['Int']['output'];
  pages: Array<Page>;
  thumbnail: ContentMedia;
  title: Scalars['String']['output'];
};

export enum AppFeature {
  AudioMessage = 'AUDIO_MESSAGE',
  CheckInV1 = 'CHECK_IN_V1',
  GroupVideocall = 'GROUP_VIDEOCALL',
  MessageEncryption = 'MESSAGE_ENCRYPTION',
  VideoMessage = 'VIDEO_MESSAGE'
}

export type AppParameters = {
  appVersion: Scalars['String']['input'];
  applicationId?: InputMaybe<Scalars['String']['input']>;
  cmsEnvironment: CmsEnvironment;
  contentVersion: Scalars['Int']['input'];
  environment: Environment;
  flavour: Flavour;
  fromDate?: InputMaybe<Scalars['Datetime']['input']>;
  isLicensing: Scalars['Boolean']['input'];
  swMode: SwMode;
  updateMode: UpdateMode;
};

export type AppSetting = Node & {
  __typename?: 'AppSetting';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  passwordHash?: Maybe<Scalars['String']['output']>;
  settingType: AppSettingEnum;
  /** Reads a single `User` that is related to this `AppSetting`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** The fields on `appSetting` to look up the row to connect. */
export type AppSettingAppSettingPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `appSetting` to look up the row to delete. */
export type AppSettingAppSettingPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** The fields on `appSetting` to look up the row to connect. */
export type AppSettingAppSettingUserIdSettingTypeKeyConnect = {
  settingType: AppSettingEnum;
  userId: Scalars['UUID']['input'];
};

/** The fields on `appSetting` to look up the row to delete. */
export type AppSettingAppSettingUserIdSettingTypeKeyDelete = {
  settingType: AppSettingEnum;
  userId: Scalars['UUID']['input'];
};

/**
 * A condition to be used against `AppSetting` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AppSettingCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum AppSettingEnum {
  /** show announcements */
  Announcement = 'ANNOUNCEMENT',
  /** lock app settings screen with pw */
  AppSettings = 'APP_SETTINGS',
  /** accept call automatically */
  AutomaticVideoCall = 'AUTOMATIC_VIDEO_CALL',
  /** app button style */
  ButtonStyle = 'BUTTON_STYLE',
  /** enable document assistant */
  DocAssistant = 'DOC_ASSISTANT',
  /** app font type */
  Font = 'FONT',
  /** show group activities */
  GroupActivity = 'GROUP_ACTIVITY',
  /** lock the from user the browser */
  Internet = 'INTERNET',
  /** User interface language */
  Language = 'LANGUAGE',
  /** enable meta bot */
  MetaBot = 'META_BOT',
  /** enable new keyboard */
  NewKeyboard = 'NEW_KEYBOARD',
  /** show photo frame */
  PhotoFrame = 'PHOTO_FRAME',
  /** show photo gallery */
  PhotoGallery = 'PHOTO_GALLERY',
  /** show relatives area */
  RelativesArea = 'RELATIVES_AREA',
  /** show relative area as start screen */
  RelativesAreaAsStartScreen = 'RELATIVES_AREA_AS_START_SCREEN',
  /** Enable senior profiles feature */
  SeniorProfiles = 'SENIOR_PROFILES',
  /** Speech recognition engine mode */
  SpeechRecognitionMode = 'SPEECH_RECOGNITION_MODE',
  /** app theme (light/dark) */
  Theme = 'THEME',
  /** enable translation feature */
  Translation = 'TRANSLATION',
  /** Translation engine mode */
  TranslationMode = 'TRANSLATION_MODE',
  /** lock the senior profiles area */
  VideoVisit = 'VIDEO_VISIT'
}

/** An input for mutations affecting `AppSetting` */
export type AppSettingInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  settingType: AppSettingEnum;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<AppSettingUserIdFkeyInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AppSettingNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `appSetting` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type AppSettingNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `appSetting` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type AppSettingOnAppSettingForAppSettingUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `appSetting` to look up the row to update. */
export type AppSettingOnAppSettingForAppSettingUserIdFkeyUsingAppSettingPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `appSetting` being updated. */
  patch: UpdateAppSettingOnAppSettingForAppSettingUserIdFkeyPatch;
};

/** The fields on `appSetting` to look up the row to update. */
export type AppSettingOnAppSettingForAppSettingUserIdFkeyUsingAppSettingUserIdSettingTypeKeyUpdate = {
  /** An object where the defined keys will be set on the `appSetting` being updated. */
  patch: UpdateAppSettingOnAppSettingForAppSettingUserIdFkeyPatch;
  settingType: AppSettingEnum;
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `AppSetting`. Fields that are set will be updated. */
export type AppSettingPatch = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  settingType?: InputMaybe<AppSettingEnum>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<AppSettingUserIdFkeyInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The `appSetting` to be created by this mutation. */
export type AppSettingUserIdFkeyAppSettingCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  settingType: AppSettingEnum;
  userToUserId?: InputMaybe<AppSettingUserIdFkeyInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Input for the nested mutation of `user` in the `AppSettingInput` mutation. */
export type AppSettingUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<AppSettingUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnAppSettingForAppSettingUserIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AppSettingOnAppSettingForAppSettingUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `appSetting` in the `UserInput` mutation. */
export type AppSettingUserIdFkeyInverseInput = {
  /** The primary key(s) for `appSetting` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AppSettingAppSettingPkeyConnect>>;
  /** The primary key(s) for `appSetting` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AppSettingNodeIdConnect>>;
  /** The primary key(s) for `appSetting` for the far side of the relationship. */
  connectByUserIdAndSettingType?: InputMaybe<Array<AppSettingAppSettingUserIdSettingTypeKeyConnect>>;
  /** A `AppSettingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AppSettingUserIdFkeyAppSettingCreateInput>>;
  /** The primary key(s) for `appSetting` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AppSettingAppSettingPkeyDelete>>;
  /** The primary key(s) for `appSetting` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AppSettingNodeIdDelete>>;
  /** The primary key(s) for `appSetting` for the far side of the relationship. */
  deleteByUserIdAndSettingType?: InputMaybe<Array<AppSettingAppSettingUserIdSettingTypeKeyDelete>>;
  /** Flag indicating whether all other `appSetting` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `appSetting` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AppSettingOnAppSettingForAppSettingUserIdFkeyUsingAppSettingPkeyUpdate>>;
  /** The primary key(s) and patch data for `appSetting` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnAppSettingForAppSettingUserIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `appSetting` for the far side of the relationship. */
  updateByUserIdAndSettingType?: InputMaybe<Array<AppSettingOnAppSettingForAppSettingUserIdFkeyUsingAppSettingUserIdSettingTypeKeyUpdate>>;
};

/** The `user` to be created by this mutation. */
export type AppSettingUserIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `AppSetting` values. */
export type AppSettingsConnection = {
  __typename?: 'AppSettingsConnection';
  /** A list of edges which contains the `AppSetting` and cursor to aid in pagination. */
  edges: Array<AppSettingsEdge>;
  /** A list of `AppSetting` objects. */
  nodes: Array<AppSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AppSetting` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AppSetting` edge in the connection. */
export type AppSettingsEdge = {
  __typename?: 'AppSettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AppSetting` at the end of the edge. */
  node: AppSetting;
};

/** Methods to use when ordering `AppSetting`. */
export enum AppSettingsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type AssignmentResult = {
  __typename?: 'AssignmentResult';
  assignment: LearningAssignment;
};

export enum AssistantInteractionKind {
  Action = 'action',
  Open = 'open',
  Outcome = 'outcome'
}

export type Attachment = Node & {
  __typename?: 'Attachment';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  kind: AttachmentKind;
  /** Reads a single `Media` that is related to this `Attachment`. */
  media?: Maybe<Media>;
  /** Reads a single `Message` that is related to this `Attachment`. */
  message?: Maybe<Message>;
  messageId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** The fields on `attachment` to look up the row to connect. */
export type AttachmentAttachmentPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `attachment` to look up the row to delete. */
export type AttachmentAttachmentPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/**
 * A condition to be used against `Attachment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AttachmentCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `messageId` field. */
  messageId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `Attachment` */
export type AttachmentInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<FkAttachmentMediaInput>;
  messageId?: InputMaybe<Scalars['UUID']['input']>;
  messageToMessageId?: InputMaybe<AttachmentMessageIdInput>;
};

export enum AttachmentKind {
  Aac = 'AAC',
  Gif = 'GIF',
  Jpg = 'JPG',
  M4A = 'M4A',
  Mp3 = 'MP3',
  Mp4 = 'MP4',
  Png = 'PNG'
}

/** The `attachment` to be created by this mutation. */
export type AttachmentMessageIdAttachmentCreateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<FkAttachmentMediaInput>;
  messageToMessageId?: InputMaybe<AttachmentMessageIdInput>;
};

/** Input for the nested mutation of `message` in the `AttachmentInput` mutation. */
export type AttachmentMessageIdInput = {
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectById?: InputMaybe<MessageMessagePkeyConnect>;
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MessageNodeIdConnect>;
  /** The primary key(s) for `message` for the far side of the relationship. */
  deleteById?: InputMaybe<MessageMessagePkeyDelete>;
  /** The primary key(s) for `message` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<MessageNodeIdDelete>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateById?: InputMaybe<MessageOnAttachmentForAttachmentMessageIdUsingMessagePkeyUpdate>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AttachmentOnAttachmentForAttachmentMessageIdNodeIdUpdate>;
};

/** Input for the nested mutation of `attachment` in the `MessageInput` mutation. */
export type AttachmentMessageIdInverseInput = {
  /** The primary key(s) for `attachment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AttachmentAttachmentPkeyConnect>>;
  /** The primary key(s) for `attachment` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AttachmentNodeIdConnect>>;
  /** A `AttachmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AttachmentMessageIdAttachmentCreateInput>>;
  /** The primary key(s) for `attachment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AttachmentAttachmentPkeyDelete>>;
  /** The primary key(s) for `attachment` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AttachmentNodeIdDelete>>;
  /** Flag indicating whether all other `attachment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `attachment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AttachmentOnAttachmentForAttachmentMessageIdUsingAttachmentPkeyUpdate>>;
  /** The primary key(s) and patch data for `attachment` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<MessageOnAttachmentForAttachmentMessageIdNodeIdUpdate>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AttachmentNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `attachment` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type AttachmentNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `attachment` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type AttachmentOnAttachmentForAttachmentMessageIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `message` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: MessagePatch;
};

/** The fields on `attachment` to look up the row to update. */
export type AttachmentOnAttachmentForAttachmentMessageIdUsingAttachmentPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `attachment` being updated. */
  patch: UpdateAttachmentOnAttachmentForAttachmentMessageIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type AttachmentOnAttachmentForFkAttachmentMediaNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `media` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: MediaPatch;
};

/** The fields on `attachment` to look up the row to update. */
export type AttachmentOnAttachmentForFkAttachmentMediaUsingAttachmentPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `attachment` being updated. */
  patch: UpdateAttachmentOnAttachmentForFkAttachmentMediaPatch;
};

/** Represents an update to a `Attachment`. Fields that are set will be updated. */
export type AttachmentPatch = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<FkAttachmentMediaInput>;
  messageId?: InputMaybe<Scalars['UUID']['input']>;
  messageToMessageId?: InputMaybe<AttachmentMessageIdInput>;
};

/** A connection to a list of `Attachment` values. */
export type AttachmentsConnection = {
  __typename?: 'AttachmentsConnection';
  /** A list of edges which contains the `Attachment` and cursor to aid in pagination. */
  edges: Array<AttachmentsEdge>;
  /** A list of `Attachment` objects. */
  nodes: Array<Attachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Attachment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Attachment` edge in the connection. */
export type AttachmentsEdge = {
  __typename?: 'AttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Attachment` at the end of the edge. */
  node: Attachment;
};

/** Methods to use when ordering `Attachment`. */
export enum AttachmentsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MessageIdAsc = 'MESSAGE_ID_ASC',
  MessageIdDesc = 'MESSAGE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type AttachmentsUsingId = {
  create?: InputMaybe<Array<InputMaybe<FullAttachment>>>;
};

export enum AuthStatus {
  Blocked = 'BLOCKED',
  CredentialsSet = 'CREDENTIALS_SET',
  NoCredentials = 'NO_CREDENTIALS',
  ValidationCodePending = 'VALIDATION_CODE_PENDING'
}

export type AvatarMediaInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  md5?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the `belongsToSameWorkgroup` mutation. */
export type BelongsToSameWorkgroupInput = {
  caregiverId1?: InputMaybe<Scalars['UUID']['input']>;
  caregiverId2?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `belongsToSameWorkgroup` mutation. */
export type BelongsToSameWorkgroupPayload = {
  __typename?: 'BelongsToSameWorkgroupPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export enum BillingAvailability {
  Available = 'AVAILABLE',
  Disabled = 'DISABLED',
  NotConfigured = 'NOT_CONFIGURED'
}

export type BillingCustomer = {
  __typename?: 'BillingCustomer';
  debtorAccount?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalCustomerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  currency: Scalars['String']['output'];
  documentDate: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  totalGross: Scalars['String']['output'];
};

export type BillingInvoiceDownload = {
  __typename?: 'BillingInvoiceDownload';
  expiresAt: Scalars['Datetime']['output'];
  url: Scalars['String']['output'];
};

export type BillingSalesforceAccount = {
  __typename?: 'BillingSalesforceAccount';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BillwerkCustomerListState = {
  __typename?: 'BillwerkCustomerListState';
  /** When this answer was made. Each backend instance keeps its own list, so a reload passes this as refreshAfter. */
  checkedAt: Scalars['Datetime']['output'];
  contracts: BillwerkListStatus;
  customerCount?: Maybe<Scalars['Int']['output']>;
  /** When the last read failed; null unless UNAVAILABLE. */
  failedAt?: Maybe<Scalars['Datetime']['output']>;
  /** When the customer list was read; null unless READY. */
  loadedAt?: Maybe<Scalars['Datetime']['output']>;
  status: BillwerkListStatus;
};

export type BillwerkCustomerMatch = {
  __typename?: 'BillwerkCustomerMatch';
  billwerk: BillwerkCustomerListState;
  /** The rows of each group and reason, whatever the filter. */
  counts: Array<BillwerkCustomerMatchCount>;
  rows: Array<BillwerkCustomerMatchRow>;
  salesforceSync: BillwerkCustomerMatchSync;
  /** The rows of the filter, not only this page. */
  totalCount: Scalars['Int']['output'];
  /** True while a field the match needs is unreadable or not yet copied: then no row is shown. */
  withheld: Scalars['Boolean']['output'];
};

export type BillwerkCustomerMatchCount = {
  __typename?: 'BillwerkCustomerMatchCount';
  count: Scalars['Int']['output'];
  group: BillwerkCustomerMatchGroup;
  reason: BillwerkCustomerMatchReason;
};

/** Where a row of the Billwerk customer match belongs. */
export enum BillwerkCustomerMatchGroup {
  Conflict = 'CONFLICT',
  Matched = 'MATCHED',
  OnlyInBillwerk = 'ONLY_IN_BILLWERK',
  OnlyInSalesforce = 'ONLY_IN_SALESFORCE'
}

/** Why a row belongs to its group. Matched: FACILITY_MAPPING, DEBITOR_ID, VIA_PAYER (Abrechnung_via__c), VIA_PARENT (Billtoparent__c). Only in Salesforce: DEBITOR_ID_EMPTY, DEBITOR_ID_UNKNOWN. Only in Billwerk: NO_SALESFORCE_ACCOUNT, DEBITOR_ID_ON_FACILITY (only a facility billed through another payer holds the number). Conflicts: the rest. */
export enum BillwerkCustomerMatchReason {
  DebitorId = 'DEBITOR_ID',
  DebitorIdEmpty = 'DEBITOR_ID_EMPTY',
  DebitorIdOnFacility = 'DEBITOR_ID_ON_FACILITY',
  DebitorIdUnknown = 'DEBITOR_ID_UNKNOWN',
  DuplicateBillwerk = 'DUPLICATE_BILLWERK',
  DuplicateSalesforce = 'DUPLICATE_SALESFORCE',
  FacilityMapping = 'FACILITY_MAPPING',
  MappingCustomerMissing = 'MAPPING_CUSTOMER_MISSING',
  MappingDisagrees = 'MAPPING_DISAGREES',
  NoSalesforceAccount = 'NO_SALESFORCE_ACCOUNT',
  PayerLoop = 'PAYER_LOOP',
  PayerNotFound = 'PAYER_NOT_FOUND',
  PayerWithoutDebitorId = 'PAYER_WITHOUT_DEBITOR_ID',
  ViaParent = 'VIA_PARENT',
  ViaPayer = 'VIA_PAYER'
}

export type BillwerkCustomerMatchRow = {
  __typename?: 'BillwerkCustomerMatchRow';
  accounts: Array<BillwerkMatchAccount>;
  /** A payer's facilities with a billed item of their own. */
  billedFacilities: Scalars['Int']['output'];
  customers: Array<BillwerkMatchCustomer>;
  /** The Debitoren-Id the row is about. */
  debitorAccount?: Maybe<Scalars['String']['output']>;
  /** Null while Billwerk is not loaded: the row is a Salesforce payer. */
  group?: Maybe<BillwerkCustomerMatchGroup>;
  /** The Billwerk customers the account's facility mappings name. */
  mappedCustomerIds: Array<Scalars['String']['output']>;
  /** The account that pays for a facility, or the last account a broken payer chain reached. */
  payer?: Maybe<BillwerkMatchAccount>;
  reason?: Maybe<BillwerkCustomerMatchReason>;
};

export type BillwerkCustomerMatchSync = {
  __typename?: 'BillwerkCustomerMatchSync';
  /** Whether the CRM copy holds the Account billing fields: false until a sync has copied them, after migration 0480 or while they are unreadable. */
  accountFieldsCopied: Scalars['Boolean']['output'];
  /** When the last successful CRM sync finished; null when none did. */
  lastSucceededAt?: Maybe<Scalars['Datetime']['output']>;
  /** The fields the match reads that the last successful CRM sync could not read, as Object.Field. */
  unreadableFields: Array<Scalars['String']['output']>;
};

/** The state of the live Billwerk list. */
export enum BillwerkListStatus {
  Loading = 'LOADING',
  NotConfigured = 'NOT_CONFIGURED',
  Ready = 'READY',
  Unavailable = 'UNAVAILABLE'
}

/** A Salesforce account of the CRM copy. */
export type BillwerkMatchAccount = {
  __typename?: 'BillwerkMatchAccount';
  /** A person account, or a B2C or PersonAccount record type, as the CRM's B2C list counts it. */
  b2c: Scalars['Boolean']['output'];
  /** The account has a billed contract item of its own. */
  billed: Scalars['Boolean']['output'];
  /** Abrechnung_Kundennummer_neu__c. */
  debitorAccount?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Abrechnung_Kundennummer__c. */
  oldCustomerNumber?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
};

/** A Billwerk customer, read live. */
export type BillwerkMatchCustomer = {
  __typename?: 'BillwerkMatchCustomer';
  /** Whether a contract is Active or InTrial; null until the contract list has loaded. */
  activeContract?: Maybe<Scalars['Boolean']['output']>;
  /** DebitorAccount, the Debitoren-Id. */
  debitorAccount?: Maybe<Scalars['String']['output']>;
  externalCustomerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The custom field BillomatDebitor ("Kundennummer alt"). */
  oldCustomerNumber?: Maybe<Scalars['String']['output']>;
  /** The customer in the Billwerk web app. */
  url?: Maybe<Scalars['String']['output']>;
};

export type BillwerkPlanVariant = {
  __typename?: 'BillwerkPlanVariant';
  /** Product2.Billwerk_Plan_ID__c of the product. */
  billwerkPlanId?: Maybe<Scalars['String']['output']>;
  /** Billwerk offers a hidden variant for no new order; null unless KNOWN. */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Billwerk's internal name of the variant; null unless KNOWN. */
  name?: Maybe<Scalars['String']['output']>;
  planVariantId?: Maybe<Scalars['String']['output']>;
  priceBookId?: Maybe<Scalars['String']['output']>;
  priceBookName?: Maybe<Scalars['String']['output']>;
  state: BillwerkPlanVariantState;
  /** The variant in the Billwerk web app; null when Billwerk does not know it. */
  url?: Maybe<Scalars['String']['output']>;
};

export type BillwerkPlanVariantCount = {
  __typename?: 'BillwerkPlanVariantCount';
  count: Scalars['Int']['output'];
  state: BillwerkPlanVariantState;
};

/** A billing-relevant contract item: billed now, or with an open Finance notification. */
export type BillwerkPlanVariantItem = {
  __typename?: 'BillwerkPlanVariantItem';
  accountName?: Maybe<Scalars['String']['output']>;
  billed: Scalars['Boolean']['output'];
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openNotification: Scalars['Boolean']['output'];
  planVariant: BillwerkPlanVariant;
  productName?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  salesforceUrl: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type BillwerkPlanVariantListState = {
  __typename?: 'BillwerkPlanVariantListState';
  /** When the plan variant list was read; null unless READY. It is kept for a minute. */
  loadedAt?: Maybe<Scalars['Datetime']['output']>;
  /** NOT_CONFIGURED, READY or UNAVAILABLE; LOADING while Billwerk takes longer than three seconds to answer, so ask again. */
  status: BillwerkListStatus;
  variantCount?: Maybe<Scalars['Int']['output']>;
};

/** Which Billwerk plan variant a contract item bills with: the Billwerk_PlanvariantID__c of the price book entry of its product in its contract's price book. Only KNOWN can be billed. KNOWN: Billwerk knows the variant. UNCHECKED: the Billwerk list could not be read, or not within three seconds. NOT_IN_BILLWERK: Billwerk does not know the variant. MISSING: the entry names no variant. AMBIGUOUS: the price book holds the product several times (one entry per currency), and the entries do not all name the same variant. NOT_IN_PRICE_BOOK, NO_PRICE_BOOK, NO_PRODUCT, NO_CONTRACT: the item does not lead to an entry. WITHHELD: the CRM copy cannot say yet. */
export enum BillwerkPlanVariantState {
  Ambiguous = 'AMBIGUOUS',
  Known = 'KNOWN',
  Missing = 'MISSING',
  NotInBillwerk = 'NOT_IN_BILLWERK',
  NotInPriceBook = 'NOT_IN_PRICE_BOOK',
  NoContract = 'NO_CONTRACT',
  NoPriceBook = 'NO_PRICE_BOOK',
  NoProduct = 'NO_PRODUCT',
  Unchecked = 'UNCHECKED',
  Withheld = 'WITHHELD'
}

export type BillwerkPlanVariantSync = {
  __typename?: 'BillwerkPlanVariantSync';
  /** False until a sync has copied a price book entry: after migration 0481, or while the entries cannot be read. */
  entriesCopied: Scalars['Boolean']['output'];
  /** When the last successful CRM sync finished; null when none did. */
  lastSucceededAt?: Maybe<Scalars['Datetime']['output']>;
  /** The objects and fields the page reads that the last successful CRM sync could not read, as Object or Object.Field. */
  unreadableFields: Array<Scalars['String']['output']>;
};

/** ENTRIES: every price book entry. ITEMS: the billing-relevant contract items whose plan variant does not resolve. */
export enum BillwerkPlanVariantView {
  Entries = 'ENTRIES',
  Items = 'ITEMS'
}

export type BillwerkPlanVariants = {
  __typename?: 'BillwerkPlanVariants';
  billwerk: BillwerkPlanVariantListState;
  /** Empty unless the view is ENTRIES. */
  entries: Array<BillwerkPriceBookEntry>;
  /** The entries of each state, whatever the filter. */
  entryCounts: Array<BillwerkPlanVariantCount>;
  /** The listed items of each state, whatever the filter. */
  itemCounts: Array<BillwerkPlanVariantCount>;
  /** Empty unless the view is ITEMS. */
  items: Array<BillwerkPlanVariantItem>;
  salesforceSync: BillwerkPlanVariantSync;
  /** The rows of the view and filter, not only this page. */
  totalCount: Scalars['Int']['output'];
  /** True while an input of the resolution is unreadable or not yet copied: then no row is shown. */
  withheld: Scalars['Boolean']['output'];
};

/** A Salesforce price book entry: a product in a price book. */
export type BillwerkPriceBookEntry = {
  __typename?: 'BillwerkPriceBookEntry';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** The billing-relevant contract items of contracts with this price book and product. */
  billingItems: Scalars['Int']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  planVariant: BillwerkPlanVariant;
  priceBookActive?: Maybe<Scalars['Boolean']['output']>;
  priceBookId: Scalars['String']['output'];
  priceBookName?: Maybe<Scalars['String']['output']>;
  priceBookStandard?: Maybe<Scalars['Boolean']['output']>;
  productFamily?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  salesforceUrl: Scalars['String']['output'];
};

export type CallKpiAgent = {
  __typename?: 'CallKpiAgent';
  /** The provider's user UUID of the agent. */
  agentKey: Scalars['String']['output'];
  /** Inbound calls the agent answered. */
  answered: Scalars['Int']['output'];
  averageHandleSeconds?: Maybe<Scalars['Float']['output']>;
  /** The portal user linked to the agent's Webex account; only linked agents are listed. */
  name: Scalars['String']['output'];
  /** Outbound calls the agent placed. */
  outbound: Scalars['Int']['output'];
};

export enum CallKpiRange {
  /** The last seven Berlin days, today included. */
  Last_7Days = 'LAST_7_DAYS',
  /** The last thirty Berlin days, today included. */
  Last_30Days = 'LAST_30_DAYS',
  /** Today, in Berlin time. */
  Today = 'TODAY'
}

/** The hotline's calls in a range, counted from the stored call history: inbound calls dialled to a hotline number and outbound calls of agents who connected the portal phone. */
export type CallKpis = {
  __typename?: 'CallKpis';
  /** Queued calls that ended before an agent was rung. */
  abandoned: Scalars['Int']['output'];
  /** Agents who answered or placed calls, most answered first. */
  agents: Array<CallKpiAgent>;
  answered: Scalars['Int']['output'];
  /** Answered inbound calls. */
  averageHandleSeconds?: Maybe<Scalars['Float']['output']>;
  /** Inbound queued calls. */
  averageWaitSeconds?: Maybe<Scalars['Float']['output']>;
  /** Whether a hotline number is stored on the Integrationen page; without one no inbound call counts. */
  hotlineConfigured: Scalars['Boolean']['output'];
  /** Inbound calls that queued or reached an agent. */
  inbound: Scalars['Int']['output'];
  maxWaitSeconds?: Maybe<Scalars['Int']['output']>;
  /** Calls that rang an agent, with or without a queue, and were not answered. */
  missed: Scalars['Int']['output'];
  /** Calls that ended before a queue or an agent, for example in the menu. */
  notRouted: Scalars['Int']['output'];
  outbound: Scalars['Int']['output'];
  /** Answered divided by inbound among the calls within the opening hours, 0 to 1; null when there were none. */
  reachability?: Maybe<Scalars['Float']['output']>;
  /** The code of the last failed read; null after a successful one. */
  syncError?: Maybe<Scalars['String']['output']>;
  /** Calls are complete up to this moment. */
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
};

/** The calls behind a KPI tile; each filter lists exactly the calls its tile counts. */
export enum CallListFilter {
  /** The abandoned tile. */
  Abandoned = 'ABANDONED',
  /** The answered tile. */
  Answered = 'ANSWERED',
  /** The inbound tile. */
  Inbound = 'INBOUND',
  /** The missed tile. */
  Missed = 'MISSED',
  /** The not routed tile. */
  NotRouted = 'NOT_ROUTED',
  /** The outbound tile. */
  Outbound = 'OUTBOUND',
  /** The inbound calls the reachability is measured over: those that started within the opening hours. */
  WithinOpeningHours = 'WITHIN_OPENING_HOURS'
}

export type CancelLogisticsShippingLabelInput = {
  /** Exact displayed label target: required during the pilot, checked when supplied in owned/local mode. */
  labelId?: InputMaybe<Scalars['UUID']['input']>;
  orderId: Scalars['UUID']['input'];
  /** Stable caller UUID required during the pilot; reuse it after a lost response. */
  requestId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CaregiverDevicePractitioner = {
  __typename?: 'CaregiverDevicePractitioner';
  id: Scalars['UUID']['output'];
  status: PractitionerStatusEnum;
  user: CaregiverDevicePractitionerUser;
};

export type CaregiverDevicePractitionerUser = {
  __typename?: 'CaregiverDevicePractitionerUser';
  avatar?: Maybe<Scalars['UUID']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type CaregiverDeviceTokenResponse = {
  __typename?: 'CaregiverDeviceTokenResponse';
  deviceToken: Scalars['String']['output'];
};

export enum CaregiverPractitionerAuthStatus {
  Blocked = 'BLOCKED',
  CredentialsSet = 'CREDENTIALS_SET',
  NoCredentials = 'NO_CREDENTIALS',
  ValidationCodePending = 'VALIDATION_CODE_PENDING'
}

export type CaregiverProfile = Node & {
  __typename?: 'CaregiverProfile';
  createdAt: Scalars['Datetime']['output'];
  facilityName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  role: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `CaregiverProfile`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/** The fields on `caregiverProfile` to look up the row to connect. */
export type CaregiverProfileCaregiverProfilePkeyConnect = {
  userId: Scalars['UUID']['input'];
};

export type CaregiverProfileDetail = {
  facilityName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type CaregiverProfileNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `caregiverProfile` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type CaregiverProfileOnCaregiverProfileForCaregiverProfileUserIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `caregiverProfile` to look up the row to update. */
export type CaregiverProfileOnCaregiverProfileForCaregiverProfileUserIdUsingCaregiverProfilePkeyUpdate = {
  /** An object where the defined keys will be set on the `caregiverProfile` being updated. */
  patch: UpdateCaregiverProfileOnCaregiverProfileForCaregiverProfileUserIdPatch;
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `CaregiverProfile`. Fields that are set will be updated. */
export type CaregiverProfilePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  facilityName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<CaregiverProfileUserIdInput>;
};

/** Input for the nested mutation of `user` in the `CaregiverProfileInput` mutation. */
export type CaregiverProfileUserIdInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<CaregiverProfileUserIdUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnCaregiverProfileForCaregiverProfileUserIdUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CaregiverProfileOnCaregiverProfileForCaregiverProfileUserIdNodeIdUpdate>;
};

/** Input for the nested mutation of `caregiverProfile` in the `UserInput` mutation. */
export type CaregiverProfileUserIdInverseInput = {
  /** The primary key(s) for `caregiverProfile` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CaregiverProfileNodeIdConnect>;
  /** The primary key(s) for `caregiverProfile` for the far side of the relationship. */
  connectByUserId?: InputMaybe<CaregiverProfileCaregiverProfilePkeyConnect>;
  /** The primary key(s) and patch data for `caregiverProfile` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserOnCaregiverProfileForCaregiverProfileUserIdNodeIdUpdate>;
  /** The primary key(s) and patch data for `caregiverProfile` for the far side of the relationship. */
  updateByUserId?: InputMaybe<CaregiverProfileOnCaregiverProfileForCaregiverProfileUserIdUsingCaregiverProfilePkeyUpdate>;
};

/** The `user` to be created by this mutation. */
export type CaregiverProfileUserIdUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

export type CaregiverSenior = Node & {
  __typename?: 'CaregiverSenior';
  /** Reads a single `User` that is related to this `CaregiverSenior`. */
  caregiver?: Maybe<User>;
  caregiverId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `CaregiverSenior`. */
  senior?: Maybe<User>;
  seniorId: Scalars['UUID']['output'];
};

/** The fields on `caregiverSenior` to look up the row to connect. */
export type CaregiverSeniorCaregiverSeniorsPkeyConnect = {
  caregiverId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};

/** The fields on `caregiverSenior` to look up the row to delete. */
export type CaregiverSeniorCaregiverSeniorsPkeyDelete = {
  caregiverId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};

/**
 * A condition to be used against `CaregiverSenior` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CaregiverSeniorCondition = {
  /** Checks for equality with the object’s `caregiverId` field. */
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `seniorId` field. */
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `CaregiverSenior` */
export type CaregiverSeniorInput = {
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToCaregiverId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInput>;
  userToSeniorId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CaregiverSeniorNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `caregiverSenior` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CaregiverSeniorNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `caregiverSenior` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type CaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `caregiverSenior` to look up the row to update. */
export type CaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyUsingCaregiverSeniorsPkeyUpdate = {
  caregiverId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `caregiverSenior` being updated. */
  patch: UpdateCaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyPatch;
  seniorId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type CaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `caregiverSenior` to look up the row to update. */
export type CaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyUsingCaregiverSeniorsPkeyUpdate = {
  caregiverId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `caregiverSenior` being updated. */
  patch: UpdateCaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyPatch;
  seniorId: Scalars['UUID']['input'];
};

/** Represents an update to a `CaregiverSenior`. Fields that are set will be updated. */
export type CaregiverSeniorPatch = {
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToCaregiverId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInput>;
  userToSeniorId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInput>;
};

/** The `caregiverSenior` to be created by this mutation. */
export type CaregiverSeniorsCaregiverIdFkeyCaregiverSeniorsCreateInput = {
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToCaregiverId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInput>;
  userToSeniorId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `CaregiverSeniorInput` mutation. */
export type CaregiverSeniorsCaregiverIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `caregiverSenior` in the `UserInput` mutation. */
export type CaregiverSeniorsCaregiverIdFkeyInverseInput = {
  /** The primary key(s) for `caregiverSenior` for the far side of the relationship. */
  connectByCaregiverIdAndSeniorId?: InputMaybe<Array<CaregiverSeniorCaregiverSeniorsPkeyConnect>>;
  /** The primary key(s) for `caregiverSenior` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CaregiverSeniorNodeIdConnect>>;
  /** A `CaregiverSeniorInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CaregiverSeniorsCaregiverIdFkeyCaregiverSeniorsCreateInput>>;
  /** The primary key(s) for `caregiverSenior` for the far side of the relationship. */
  deleteByCaregiverIdAndSeniorId?: InputMaybe<Array<CaregiverSeniorCaregiverSeniorsPkeyDelete>>;
  /** The primary key(s) for `caregiverSenior` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CaregiverSeniorNodeIdDelete>>;
  /** Flag indicating whether all other `caregiverSenior` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `caregiverSenior` for the far side of the relationship. */
  updateByCaregiverIdAndSeniorId?: InputMaybe<Array<CaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyUsingCaregiverSeniorsPkeyUpdate>>;
  /** The primary key(s) and patch data for `caregiverSenior` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type CaregiverSeniorsCaregiverIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `CaregiverSenior` values. */
export type CaregiverSeniorsConnection = {
  __typename?: 'CaregiverSeniorsConnection';
  /** A list of edges which contains the `CaregiverSenior` and cursor to aid in pagination. */
  edges: Array<CaregiverSeniorsEdge>;
  /** A list of `CaregiverSenior` objects. */
  nodes: Array<CaregiverSenior>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CaregiverSenior` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CaregiverSenior` edge in the connection. */
export type CaregiverSeniorsEdge = {
  __typename?: 'CaregiverSeniorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CaregiverSenior` at the end of the edge. */
  node: CaregiverSenior;
};

/** Methods to use when ordering `CaregiverSenior`. */
export enum CaregiverSeniorsOrderBy {
  CaregiverIdAsc = 'CAREGIVER_ID_ASC',
  CaregiverIdDesc = 'CAREGIVER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SeniorIdAsc = 'SENIOR_ID_ASC',
  SeniorIdDesc = 'SENIOR_ID_DESC'
}

/** The `caregiverSenior` to be created by this mutation. */
export type CaregiverSeniorsSeniorIdFkeyCaregiverSeniorsCreateInput = {
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  userToCaregiverId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInput>;
  userToSeniorId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `CaregiverSeniorInput` mutation. */
export type CaregiverSeniorsSeniorIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<CaregiverSeniorsSeniorIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `caregiverSenior` in the `UserInput` mutation. */
export type CaregiverSeniorsSeniorIdFkeyInverseInput = {
  /** The primary key(s) for `caregiverSenior` for the far side of the relationship. */
  connectByCaregiverIdAndSeniorId?: InputMaybe<Array<CaregiverSeniorCaregiverSeniorsPkeyConnect>>;
  /** The primary key(s) for `caregiverSenior` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CaregiverSeniorNodeIdConnect>>;
  /** A `CaregiverSeniorInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CaregiverSeniorsSeniorIdFkeyCaregiverSeniorsCreateInput>>;
  /** The primary key(s) for `caregiverSenior` for the far side of the relationship. */
  deleteByCaregiverIdAndSeniorId?: InputMaybe<Array<CaregiverSeniorCaregiverSeniorsPkeyDelete>>;
  /** The primary key(s) for `caregiverSenior` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CaregiverSeniorNodeIdDelete>>;
  /** Flag indicating whether all other `caregiverSenior` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `caregiverSenior` for the far side of the relationship. */
  updateByCaregiverIdAndSeniorId?: InputMaybe<Array<CaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyUsingCaregiverSeniorsPkeyUpdate>>;
  /** The primary key(s) and patch data for `caregiverSenior` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type CaregiverSeniorsSeniorIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** All input for the `changePassword` mutation. */
export type ChangePasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
};

/** The output of our `changePassword` mutation. */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ChatWithBot = {
  __typename?: 'ChatWithBot';
  chatId: Scalars['UUID']['output'];
};

export type CheckIn = Node & {
  __typename?: 'CheckIn';
  /** Reads a single `User` that is related to this `CheckIn`. */
  author?: Maybe<User>;
  authorId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `CheckInMessage`. */
  checkInMessages: CheckInMessagesConnection;
  /** Reads and enables pagination through a set of `CheckInMessage`. */
  checkInMessagesList: Array<CheckInMessage>;
  checkInStatus: CheckInStatusEnum;
  createdAt: Scalars['Datetime']['output'];
  expiresAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `CheckIn`. */
  senior?: Maybe<User>;
  seniorId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `User`. */
  usersByCheckInMessageCheckInIdAndAuthorId: CheckInUsersByCheckInMessageCheckInIdAndAuthorIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByCheckInMessageCheckInIdAndAuthorIdList: Array<User>;
};


export type CheckInCheckInMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};


export type CheckInCheckInMessagesListArgs = {
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};


export type CheckInUsersByCheckInMessageCheckInIdAndAuthorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type CheckInUsersByCheckInMessageCheckInIdAndAuthorIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** The `checkIn` to be created by this mutation. */
export type CheckInAuthorFkeyCheckInCreateInput = {
  checkInMessagesUsingId?: InputMaybe<CheckInMessageCheckInFkeyInverseInput>;
  checkInStatus: CheckInStatusEnum;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<CheckInAuthorFkeyInput>;
  userToSeniorId?: InputMaybe<CheckInSeniorFkeyInput>;
};

/** Input for the nested mutation of `user` in the `CheckInInput` mutation. */
export type CheckInAuthorFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<CheckInAuthorFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnCheckInForCheckInAuthorFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CheckInOnCheckInForCheckInAuthorFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `checkIn` in the `UserInput` mutation. */
export type CheckInAuthorFkeyInverseInput = {
  /** The primary key(s) for `checkIn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CheckInCheckInPkeyConnect>>;
  /** The primary key(s) for `checkIn` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CheckInNodeIdConnect>>;
  /** A `CheckInInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CheckInAuthorFkeyCheckInCreateInput>>;
  /** The primary key(s) and patch data for `checkIn` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CheckInOnCheckInForCheckInAuthorFkeyUsingCheckInPkeyUpdate>>;
  /** The primary key(s) and patch data for `checkIn` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnCheckInForCheckInAuthorFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type CheckInAuthorFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The fields on `checkIn` to look up the row to connect. */
export type CheckInCheckInPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A condition to be used against `CheckIn` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CheckInCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `seniorId` field. */
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `CheckIn` */
export type CheckInInput = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageCheckInFkeyInverseInput>;
  checkInStatus: CheckInStatusEnum;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<CheckInAuthorFkeyInput>;
  userToSeniorId?: InputMaybe<CheckInSeniorFkeyInput>;
};

export type CheckInMessage = Node & {
  __typename?: 'CheckInMessage';
  /** Reads a single `User` that is related to this `CheckInMessage`. */
  author?: Maybe<User>;
  authorId: Scalars['UUID']['output'];
  /** Reads a single `CheckIn` that is related to this `CheckInMessage`. */
  checkIn?: Maybe<CheckIn>;
  checkInId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  secondMessage?: Maybe<Scalars['String']['output']>;
};

/** The `checkInMessage` to be created by this mutation. */
export type CheckInMessageAuthorFkeyCheckInMessageCreateInput = {
  checkInId?: InputMaybe<Scalars['UUID']['input']>;
  checkInToCheckInId?: InputMaybe<CheckInMessageCheckInFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  secondMessage?: InputMaybe<Scalars['String']['input']>;
  userToAuthorId?: InputMaybe<CheckInMessageAuthorFkeyInput>;
};

/** Input for the nested mutation of `user` in the `CheckInMessageInput` mutation. */
export type CheckInMessageAuthorFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<CheckInMessageAuthorFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnCheckInMessageForCheckInMessageAuthorFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CheckInMessageOnCheckInMessageForCheckInMessageAuthorFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `checkInMessage` in the `UserInput` mutation. */
export type CheckInMessageAuthorFkeyInverseInput = {
  /** The primary key(s) for `checkInMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CheckInMessageCheckInMessagePkeyConnect>>;
  /** The primary key(s) for `checkInMessage` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CheckInMessageNodeIdConnect>>;
  /** A `CheckInMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CheckInMessageAuthorFkeyCheckInMessageCreateInput>>;
  /** The primary key(s) for `checkInMessage` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CheckInMessageCheckInMessagePkeyDelete>>;
  /** The primary key(s) for `checkInMessage` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CheckInMessageNodeIdDelete>>;
  /** Flag indicating whether all other `checkInMessage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `checkInMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CheckInMessageOnCheckInMessageForCheckInMessageAuthorFkeyUsingCheckInMessagePkeyUpdate>>;
  /** The primary key(s) and patch data for `checkInMessage` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnCheckInMessageForCheckInMessageAuthorFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type CheckInMessageAuthorFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The `checkIn` to be created by this mutation. */
export type CheckInMessageCheckInFkeyCheckInCreateInput = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageCheckInFkeyInverseInput>;
  checkInStatus: CheckInStatusEnum;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<CheckInAuthorFkeyInput>;
  userToSeniorId?: InputMaybe<CheckInSeniorFkeyInput>;
};

/** The `checkInMessage` to be created by this mutation. */
export type CheckInMessageCheckInFkeyCheckInMessageCreateInput = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInToCheckInId?: InputMaybe<CheckInMessageCheckInFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  secondMessage?: InputMaybe<Scalars['String']['input']>;
  userToAuthorId?: InputMaybe<CheckInMessageAuthorFkeyInput>;
};

/** Input for the nested mutation of `checkIn` in the `CheckInMessageInput` mutation. */
export type CheckInMessageCheckInFkeyInput = {
  /** The primary key(s) for `checkIn` for the far side of the relationship. */
  connectById?: InputMaybe<CheckInCheckInPkeyConnect>;
  /** The primary key(s) for `checkIn` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CheckInNodeIdConnect>;
  /** A `CheckInInput` object that will be created and connected to this object. */
  create?: InputMaybe<CheckInMessageCheckInFkeyCheckInCreateInput>;
  /** The primary key(s) and patch data for `checkIn` for the far side of the relationship. */
  updateById?: InputMaybe<CheckInOnCheckInMessageForCheckInMessageCheckInFkeyUsingCheckInPkeyUpdate>;
  /** The primary key(s) and patch data for `checkIn` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CheckInMessageOnCheckInMessageForCheckInMessageCheckInFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `checkInMessage` in the `CheckInInput` mutation. */
export type CheckInMessageCheckInFkeyInverseInput = {
  /** The primary key(s) for `checkInMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CheckInMessageCheckInMessagePkeyConnect>>;
  /** The primary key(s) for `checkInMessage` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CheckInMessageNodeIdConnect>>;
  /** A `CheckInMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CheckInMessageCheckInFkeyCheckInMessageCreateInput>>;
  /** The primary key(s) for `checkInMessage` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CheckInMessageCheckInMessagePkeyDelete>>;
  /** The primary key(s) for `checkInMessage` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<CheckInMessageNodeIdDelete>>;
  /** Flag indicating whether all other `checkInMessage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `checkInMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CheckInMessageOnCheckInMessageForCheckInMessageCheckInFkeyUsingCheckInMessagePkeyUpdate>>;
  /** The primary key(s) and patch data for `checkInMessage` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<CheckInOnCheckInMessageForCheckInMessageCheckInFkeyNodeIdUpdate>>;
};

/** The fields on `checkInMessage` to look up the row to connect. */
export type CheckInMessageCheckInMessagePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `checkInMessage` to look up the row to delete. */
export type CheckInMessageCheckInMessagePkeyDelete = {
  id: Scalars['UUID']['input'];
};

/**
 * A condition to be used against `CheckInMessage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CheckInMessageCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `checkInId` field. */
  checkInId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `CheckInMessage` */
export type CheckInMessageInput = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInId?: InputMaybe<Scalars['UUID']['input']>;
  checkInToCheckInId?: InputMaybe<CheckInMessageCheckInFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  secondMessage?: InputMaybe<Scalars['String']['input']>;
  userToAuthorId?: InputMaybe<CheckInMessageAuthorFkeyInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type CheckInMessageNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `checkInMessage` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CheckInMessageNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `checkInMessage` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type CheckInMessageOnCheckInMessageForCheckInMessageAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `checkInMessage` to look up the row to update. */
export type CheckInMessageOnCheckInMessageForCheckInMessageAuthorFkeyUsingCheckInMessagePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `checkInMessage` being updated. */
  patch: UpdateCheckInMessageOnCheckInMessageForCheckInMessageAuthorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CheckInMessageOnCheckInMessageForCheckInMessageCheckInFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `checkIn` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `checkIn` being updated. */
  patch: CheckInPatch;
};

/** The fields on `checkInMessage` to look up the row to update. */
export type CheckInMessageOnCheckInMessageForCheckInMessageCheckInFkeyUsingCheckInMessagePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `checkInMessage` being updated. */
  patch: UpdateCheckInMessageOnCheckInMessageForCheckInMessageCheckInFkeyPatch;
};

/** Represents an update to a `CheckInMessage`. Fields that are set will be updated. */
export type CheckInMessagePatch = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInId?: InputMaybe<Scalars['UUID']['input']>;
  checkInToCheckInId?: InputMaybe<CheckInMessageCheckInFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  secondMessage?: InputMaybe<Scalars['String']['input']>;
  userToAuthorId?: InputMaybe<CheckInMessageAuthorFkeyInput>;
};

/** A connection to a list of `CheckInMessage` values. */
export type CheckInMessagesConnection = {
  __typename?: 'CheckInMessagesConnection';
  /** A list of edges which contains the `CheckInMessage` and cursor to aid in pagination. */
  edges: Array<CheckInMessagesEdge>;
  /** A list of `CheckInMessage` objects. */
  nodes: Array<CheckInMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckInMessage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CheckInMessage` edge in the connection. */
export type CheckInMessagesEdge = {
  __typename?: 'CheckInMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CheckInMessage` at the end of the edge. */
  node: CheckInMessage;
};

/** Methods to use when ordering `CheckInMessage`. */
export enum CheckInMessagesOrderBy {
  AuthorIdAsc = 'AUTHOR_ID_ASC',
  AuthorIdDesc = 'AUTHOR_ID_DESC',
  CheckInIdAsc = 'CHECK_IN_ID_ASC',
  CheckInIdDesc = 'CHECK_IN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** The globally unique `ID` look up for the row to connect. */
export type CheckInNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `checkIn` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type CheckInOnCheckInForCheckInAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `checkIn` to look up the row to update. */
export type CheckInOnCheckInForCheckInAuthorFkeyUsingCheckInPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `checkIn` being updated. */
  patch: UpdateCheckInOnCheckInForCheckInAuthorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CheckInOnCheckInForCheckInSeniorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `checkIn` to look up the row to update. */
export type CheckInOnCheckInForCheckInSeniorFkeyUsingCheckInPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `checkIn` being updated. */
  patch: UpdateCheckInOnCheckInForCheckInSeniorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type CheckInOnCheckInMessageForCheckInMessageCheckInFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `checkInMessage` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `checkInMessage` being updated. */
  patch: CheckInMessagePatch;
};

/** The fields on `checkIn` to look up the row to update. */
export type CheckInOnCheckInMessageForCheckInMessageCheckInFkeyUsingCheckInPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `checkIn` being updated. */
  patch: UpdateCheckInOnCheckInMessageForCheckInMessageCheckInFkeyPatch;
};

/** Represents an update to a `CheckIn`. Fields that are set will be updated. */
export type CheckInPatch = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageCheckInFkeyInverseInput>;
  checkInStatus?: InputMaybe<CheckInStatusEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<CheckInAuthorFkeyInput>;
  userToSeniorId?: InputMaybe<CheckInSeniorFkeyInput>;
};

/** The `checkIn` to be created by this mutation. */
export type CheckInSeniorFkeyCheckInCreateInput = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageCheckInFkeyInverseInput>;
  checkInStatus: CheckInStatusEnum;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<CheckInAuthorFkeyInput>;
  userToSeniorId?: InputMaybe<CheckInSeniorFkeyInput>;
};

/** Input for the nested mutation of `user` in the `CheckInInput` mutation. */
export type CheckInSeniorFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<CheckInSeniorFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnCheckInForCheckInSeniorFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CheckInOnCheckInForCheckInSeniorFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `checkIn` in the `UserInput` mutation. */
export type CheckInSeniorFkeyInverseInput = {
  /** The primary key(s) for `checkIn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CheckInCheckInPkeyConnect>>;
  /** The primary key(s) for `checkIn` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<CheckInNodeIdConnect>>;
  /** A `CheckInInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CheckInSeniorFkeyCheckInCreateInput>>;
  /** The primary key(s) and patch data for `checkIn` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CheckInOnCheckInForCheckInSeniorFkeyUsingCheckInPkeyUpdate>>;
  /** The primary key(s) and patch data for `checkIn` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnCheckInForCheckInSeniorFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type CheckInSeniorFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

export enum CheckInStatusEnum {
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  Ongoing = 'ONGOING'
}

/** A connection to a list of `User` values, with data from `CheckInMessage`. */
export type CheckInUsersByCheckInMessageCheckInIdAndAuthorIdManyToManyConnection = {
  __typename?: 'CheckInUsersByCheckInMessageCheckInIdAndAuthorIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `CheckInMessage`, and the cursor to aid in pagination. */
  edges: Array<CheckInUsersByCheckInMessageCheckInIdAndAuthorIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `CheckInMessage`. */
export type CheckInUsersByCheckInMessageCheckInIdAndAuthorIdManyToManyEdge = {
  __typename?: 'CheckInUsersByCheckInMessageCheckInIdAndAuthorIdManyToManyEdge';
  /** Reads and enables pagination through a set of `CheckInMessage`. */
  authoredCheckInMessages: CheckInMessagesConnection;
  /** Reads and enables pagination through a set of `CheckInMessage`. */
  authoredCheckInMessagesList: Array<CheckInMessage>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};


/** A `User` edge in the connection, with data from `CheckInMessage`. */
export type CheckInUsersByCheckInMessageCheckInIdAndAuthorIdManyToManyEdgeAuthoredCheckInMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};


/** A `User` edge in the connection, with data from `CheckInMessage`. */
export type CheckInUsersByCheckInMessageCheckInIdAndAuthorIdManyToManyEdgeAuthoredCheckInMessagesListArgs = {
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};

/** A connection to a list of `CheckIn` values. */
export type CheckInsConnection = {
  __typename?: 'CheckInsConnection';
  /** A list of edges which contains the `CheckIn` and cursor to aid in pagination. */
  edges: Array<CheckInsEdge>;
  /** A list of `CheckIn` objects. */
  nodes: Array<CheckIn>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckIn` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CheckIn` edge in the connection. */
export type CheckInsEdge = {
  __typename?: 'CheckInsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CheckIn` at the end of the edge. */
  node: CheckIn;
};

/** Methods to use when ordering `CheckIn`. */
export enum CheckInsOrderBy {
  AuthorIdAsc = 'AUTHOR_ID_ASC',
  AuthorIdDesc = 'AUTHOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SeniorIdAsc = 'SENIOR_ID_ASC',
  SeniorIdDesc = 'SENIOR_ID_DESC'
}

export type CompanySignInResult = {
  __typename?: 'CompanySignInResult';
  email?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['String']['output']>;
  status: CompanySignInStatus;
};

export type CompanySignInStart = {
  __typename?: 'CompanySignInStart';
  authorizationUrl: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export enum CompanySignInStatus {
  Authenticated = 'authenticated',
  Failed = 'failed',
  NoAccess = 'noAccess'
}

export type CompleteAdminMfaInput = {
  challengeToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
  recovery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompleteCompanySignInInput = {
  /** The query string the identity provider sent the browser back with. */
  query: Scalars['String']['input'];
};

export type CompleteLearningLessonInput = {
  clientEventId: Scalars['UUID']['input'];
  completedAt: Scalars['Datetime']['input'];
  courseId: Scalars['UUID']['input'];
  courseVersion: Scalars['String']['input'];
  lessonId: Scalars['UUID']['input'];
};

export type CompleteOnboardingInput = {
  locations: Array<OnboardingLocationInput>;
  organizationId: Scalars['UUID']['input'];
  patients: Array<OnboardingPatientInput>;
  practitioners: Array<OnboardingPractitionerInput>;
};

export type CompleteOnboardingPayload = {
  __typename?: 'CompleteOnboardingPayload';
  locationIds: Array<Scalars['ID']['output']>;
  patientIds: Array<Scalars['ID']['output']>;
  practitionerIds: Array<Scalars['ID']['output']>;
};

export type CompletePlacetelPhoneSignInInput = {
  /** The query string Webex sent the browser back with. */
  query: Scalars['String']['input'];
};

export type Content = Node & {
  __typename?: 'Content';
  cmsContentId?: Maybe<Scalars['Int']['output']>;
  cmsContentKind?: Maybe<Scalars['String']['output']>;
  cmsNextContentId?: Maybe<Scalars['Int']['output']>;
  cmsNextContentKind?: Maybe<Scalars['String']['output']>;
  /**
   * Reads and enables pagination through a set of `ContentActivity`.
   * @deprecated Please use contentActivity instead
   */
  contentActivities: ContentActivitiesConnection;
  /** Reads a single `ContentActivity` that is related to this `Content`. */
  contentActivity?: Maybe<ContentActivity>;
  /** Reads and enables pagination through a set of `MetaTag`. */
  contentItems: ContentContentItemsManyToManyConnection;
  /** Reads and enables pagination through a set of `MetaTag`. */
  contentItemsList: Array<MetaTag>;
  /** Difficulty levels for different aspects: cognitive, motor, speech, vision, hearing. Values: easy, medium, hard */
  difficultyLevel?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `ContentMetaTag`. */
  metaTags: ContentMetaTagsConnection;
  /** Reads and enables pagination through a set of `ContentMetaTag`. */
  metaTagsList: Array<ContentMetaTag>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** CMS game model key; null for non-game content or unavailable metadata. */
  subtype?: Maybe<Scalars['String']['output']>;
  /**
   * Filename of the content's CMS thumbnail, resolved from the in-repo content
   * catalogue (same source the activityRecommendations endpoint uses). Combine
   * with CMS_MEDIA_BASE_URL on the client to build the image URL.
   */
  thumbnailFilename?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivities: UserContentActivitiesConnection;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesList: Array<UserContentActivity>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentActivityContentIdAndSeniorProfileId: ContentUsersByUserContentActivityContentIdAndSeniorProfileIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentActivityContentIdAndSeniorProfileIdList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentActivityContentIdAndUserId: ContentUsersByUserContentActivityContentIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentActivityContentIdAndUserIdList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentFavoriteContentIdAndUserId: ContentUsersByUserContentFavoriteContentIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentFavoriteContentIdAndUserIdList: Array<User>;
};


export type ContentContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentActivitiesOrderBy>>;
};


export type ContentContentItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetaTagCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetaTagsOrderBy>>;
};


export type ContentContentItemsListArgs = {
  condition?: InputMaybe<MetaTagCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetaTagsOrderBy>>;
};


export type ContentMetaTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentMetaTagCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetaTagsOrderBy>>;
};


export type ContentMetaTagsListArgs = {
  condition?: InputMaybe<ContentMetaTagCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetaTagsOrderBy>>;
};


export type ContentUserContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


export type ContentUserContentActivitiesListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


export type ContentUsersByUserContentActivityContentIdAndSeniorProfileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type ContentUsersByUserContentActivityContentIdAndSeniorProfileIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type ContentUsersByUserContentActivityContentIdAndUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type ContentUsersByUserContentActivityContentIdAndUserIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type ContentUsersByUserContentFavoriteContentIdAndUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type ContentUsersByUserContentFavoriteContentIdAndUserIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A connection to a list of `ContentActivity` values. */
export type ContentActivitiesConnection = {
  __typename?: 'ContentActivitiesConnection';
  /** A list of edges which contains the `ContentActivity` and cursor to aid in pagination. */
  edges: Array<ContentActivitiesEdge>;
  /** A list of `ContentActivity` objects. */
  nodes: Array<ContentActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContentActivity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ContentActivity` edge in the connection. */
export type ContentActivitiesEdge = {
  __typename?: 'ContentActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ContentActivity` at the end of the edge. */
  node: ContentActivity;
};

/** Methods to use when ordering `ContentActivity`. */
export enum ContentActivitiesOrderBy {
  ActivityIdAsc = 'ACTIVITY_ID_ASC',
  ActivityIdDesc = 'ACTIVITY_ID_DESC',
  ContentIdAsc = 'CONTENT_ID_ASC',
  ContentIdDesc = 'CONTENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ContentActivity = Node & {
  __typename?: 'ContentActivity';
  /** Reads a single `Activity` that is related to this `ContentActivity`. */
  activity?: Maybe<Activity>;
  activityId: Scalars['UUID']['output'];
  /** Reads a single `Content` that is related to this `ContentActivity`. */
  content?: Maybe<Content>;
  contentId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** The `activity` to be created by this mutation. */
export type ContentActivityActivityIdFkeyActivityCreateInput = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: ActivityKind;
};

/** The `contentActivity` to be created by this mutation. */
export type ContentActivityActivityIdFkeyContentActivityCreateInput = {
  activityToActivityId?: InputMaybe<ContentActivityActivityIdFkeyInput>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<ContentActivityContentIdFkeyInput>;
};

/** Input for the nested mutation of `activity` in the `ContentActivityInput` mutation. */
export type ContentActivityActivityIdFkeyInput = {
  /** The primary key(s) for `activity` for the far side of the relationship. */
  connectById?: InputMaybe<ActivityActivityPkeyConnect>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ActivityNodeIdConnect>;
  /** A `ActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContentActivityActivityIdFkeyActivityCreateInput>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  deleteById?: InputMaybe<ActivityActivityPkeyDelete>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ActivityNodeIdDelete>;
  /** The primary key(s) and patch data for `activity` for the far side of the relationship. */
  updateById?: InputMaybe<ActivityOnContentActivityForContentActivityActivityIdFkeyUsingActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `activity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ContentActivityOnContentActivityForContentActivityActivityIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `contentActivity` in the `ActivityInput` mutation. */
export type ContentActivityActivityIdFkeyInverseInput = {
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  connectByActivityId?: InputMaybe<ContentActivityContentActivityPkeyConnect>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  connectByContentId?: InputMaybe<ContentActivityContentActivityContentIdKeyConnect>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContentActivityNodeIdConnect>;
  /** A `ContentActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContentActivityActivityIdFkeyContentActivityCreateInput>>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  deleteByActivityId?: InputMaybe<ContentActivityContentActivityPkeyDelete>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  deleteByContentId?: InputMaybe<ContentActivityContentActivityContentIdKeyDelete>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContentActivityNodeIdDelete>;
  /** Flag indicating whether all other `contentActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `contentActivity` for the far side of the relationship. */
  updateByActivityId?: InputMaybe<ContentActivityOnContentActivityForContentActivityActivityIdFkeyUsingContentActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `contentActivity` for the far side of the relationship. */
  updateByContentId?: InputMaybe<ContentActivityOnContentActivityForContentActivityActivityIdFkeyUsingContentActivityContentIdKeyUpdate>;
  /** The primary key(s) and patch data for `contentActivity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActivityOnContentActivityForContentActivityActivityIdFkeyNodeIdUpdate>;
};

/**
 * A condition to be used against `ContentActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ContentActivityCondition = {
  /** Checks for equality with the object’s `activityId` field. */
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `contentId` field. */
  contentId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `contentActivity` to look up the row to connect. */
export type ContentActivityContentActivityContentIdKeyConnect = {
  contentId: Scalars['UUID']['input'];
};

/** The fields on `contentActivity` to look up the row to delete. */
export type ContentActivityContentActivityContentIdKeyDelete = {
  contentId: Scalars['UUID']['input'];
};

/** The fields on `contentActivity` to look up the row to connect. */
export type ContentActivityContentActivityPkeyConnect = {
  activityId: Scalars['UUID']['input'];
};

/** The fields on `contentActivity` to look up the row to delete. */
export type ContentActivityContentActivityPkeyDelete = {
  activityId: Scalars['UUID']['input'];
};

/** The `contentActivity` to be created by this mutation. */
export type ContentActivityContentIdFkeyContentActivityCreateInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityToActivityId?: InputMaybe<ContentActivityActivityIdFkeyInput>;
  contentToContentId?: InputMaybe<ContentActivityContentIdFkeyInput>;
};

/** Input for the nested mutation of `content` in the `ContentActivityInput` mutation. */
export type ContentActivityContentIdFkeyInput = {
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByCmsContentIdAndCmsContentKind?: InputMaybe<ContentUniqueContentItemsConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByCmsNextContentIdAndCmsNextContentKind?: InputMaybe<ContentUniqueCmsNextContentItemsConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectById?: InputMaybe<ContentContentPkeyConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContentNodeIdConnect>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByCmsContentIdAndCmsContentKind?: InputMaybe<ContentOnContentActivityForContentActivityContentIdFkeyUsingUniqueContentItemsUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByCmsNextContentIdAndCmsNextContentKind?: InputMaybe<ContentOnContentActivityForContentActivityContentIdFkeyUsingUniqueCmsNextContentItemsUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateById?: InputMaybe<ContentOnContentActivityForContentActivityContentIdFkeyUsingContentPkeyUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ContentActivityOnContentActivityForContentActivityContentIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `contentActivity` in the `ContentInput` mutation. */
export type ContentActivityContentIdFkeyInverseInput = {
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  connectByActivityId?: InputMaybe<ContentActivityContentActivityPkeyConnect>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  connectByContentId?: InputMaybe<ContentActivityContentActivityContentIdKeyConnect>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContentActivityNodeIdConnect>;
  /** A `ContentActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContentActivityContentIdFkeyContentActivityCreateInput>>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  deleteByActivityId?: InputMaybe<ContentActivityContentActivityPkeyDelete>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  deleteByContentId?: InputMaybe<ContentActivityContentActivityContentIdKeyDelete>;
  /** The primary key(s) for `contentActivity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ContentActivityNodeIdDelete>;
  /** Flag indicating whether all other `contentActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `contentActivity` for the far side of the relationship. */
  updateByActivityId?: InputMaybe<ContentActivityOnContentActivityForContentActivityContentIdFkeyUsingContentActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `contentActivity` for the far side of the relationship. */
  updateByContentId?: InputMaybe<ContentActivityOnContentActivityForContentActivityContentIdFkeyUsingContentActivityContentIdKeyUpdate>;
  /** The primary key(s) and patch data for `contentActivity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ContentOnContentActivityForContentActivityContentIdFkeyNodeIdUpdate>;
};

/** An input for mutations affecting `ContentActivity` */
export type ContentActivityInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityToActivityId?: InputMaybe<ContentActivityActivityIdFkeyInput>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<ContentActivityContentIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ContentActivityNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `contentActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ContentActivityNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `contentActivity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContentActivityOnContentActivityForContentActivityActivityIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activity` being updated. */
  patch: ActivityPatch;
};

/** The fields on `contentActivity` to look up the row to update. */
export type ContentActivityOnContentActivityForContentActivityActivityIdFkeyUsingContentActivityContentIdKeyUpdate = {
  contentId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `contentActivity` being updated. */
  patch: UpdateContentActivityOnContentActivityForContentActivityActivityIdFkeyPatch;
};

/** The fields on `contentActivity` to look up the row to update. */
export type ContentActivityOnContentActivityForContentActivityActivityIdFkeyUsingContentActivityPkeyUpdate = {
  activityId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `contentActivity` being updated. */
  patch: UpdateContentActivityOnContentActivityForContentActivityActivityIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ContentActivityOnContentActivityForContentActivityContentIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `content` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: ContentPatch;
};

/** The fields on `contentActivity` to look up the row to update. */
export type ContentActivityOnContentActivityForContentActivityContentIdFkeyUsingContentActivityContentIdKeyUpdate = {
  contentId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `contentActivity` being updated. */
  patch: UpdateContentActivityOnContentActivityForContentActivityContentIdFkeyPatch;
};

/** The fields on `contentActivity` to look up the row to update. */
export type ContentActivityOnContentActivityForContentActivityContentIdFkeyUsingContentActivityPkeyUpdate = {
  activityId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `contentActivity` being updated. */
  patch: UpdateContentActivityOnContentActivityForContentActivityContentIdFkeyPatch;
};

/** Represents an update to a `ContentActivity`. Fields that are set will be updated. */
export type ContentActivityPatch = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityToActivityId?: InputMaybe<ContentActivityActivityIdFkeyInput>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<ContentActivityContentIdFkeyInput>;
};

export type ContentActivitySessionInput = {
  activityKind: ActivityKind;
  beganAt: Scalars['Datetime']['input'];
  cmsContentId: Scalars['Int']['input'];
  cmsContentKind: Scalars['String']['input'];
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  seniorProfileIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sessionId: Scalars['UUID']['input'];
  sessionKind: SessionKind;
  sessionStatus?: InputMaybe<SessionStatus>;
};

export type ContentActivitySessionInputV2 = {
  activityKind: ActivityKind;
  beganAt: Scalars['Datetime']['input'];
  contentId: Scalars['UUID']['input'];
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  lifecycleAction?: InputMaybe<ProcedureLifecycleAction>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  positionInSession?: InputMaybe<ActivitySessionPosition>;
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sessionId: Scalars['UUID']['input'];
  sessionKind: SessionKind;
  sessionStatus?: InputMaybe<SessionStatus>;
};

export type ContentAnalyticsItem = {
  __typename?: 'ContentAnalyticsItem';
  completedSessionCount: Scalars['BigInt']['output'];
  contentId: Scalars['UUID']['output'];
  contentKind: Scalars['String']['output'];
  contentSubtype?: Maybe<Scalars['String']['output']>;
  sessionCount: Scalars['BigInt']['output'];
  thumbnailFilename?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  unfinishedSessionCount: Scalars['BigInt']['output'];
};

export enum ContentAnalyticsMode {
  LeastUsed = 'LEAST_USED',
  MostUsed = 'MOST_USED',
  Overview = 'OVERVIEW'
}

export type ContentAnalyticsOverviewItem = {
  __typename?: 'ContentAnalyticsOverviewItem';
  completedSessionCount: Scalars['BigInt']['output'];
  contentKind: Scalars['String']['output'];
  sessionCount: Scalars['BigInt']['output'];
  unfinishedSessionCount: Scalars['BigInt']['output'];
};

export type ContentAnalyticsReport = {
  __typename?: 'ContentAnalyticsReport';
  contentSubtypes: Array<Scalars['String']['output']>;
  contentTypes: Array<Scalars['String']['output']>;
  items: Array<ContentAnalyticsItem>;
  /**
   * Latest recorded usage date within the requested period and catalogue filters
   * for relevant analytics apps; null when no applicable daily data exists.
   */
  latestDataDate?: Maybe<Scalars['Date']['output']>;
  overview: Array<ContentAnalyticsOverviewItem>;
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  totalCount: Scalars['Int']['output'];
  unusedCount: Scalars['Int']['output'];
  usedCount: Scalars['Int']['output'];
};

/** A condition to be used against `Content` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ContentCondition = {
  /** Checks for equality with the object’s `cmsContentId` field. */
  cmsContentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cmsNextContentId` field. */
  cmsNextContentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `MetaTag` values, with data from `ContentMetaTag`. */
export type ContentContentItemsManyToManyConnection = {
  __typename?: 'ContentContentItemsManyToManyConnection';
  /** A list of edges which contains the `MetaTag`, info from the `ContentMetaTag`, and the cursor to aid in pagination. */
  edges: Array<ContentContentItemsManyToManyEdge>;
  /** A list of `MetaTag` objects. */
  nodes: Array<MetaTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MetaTag` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MetaTag` edge in the connection, with data from `ContentMetaTag`. */
export type ContentContentItemsManyToManyEdge = {
  __typename?: 'ContentContentItemsManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  id: Scalars['UUID']['output'];
  /** The `MetaTag` at the end of the edge. */
  node: MetaTag;
};

/** The fields on `content` to look up the row to connect. */
export type ContentContentPkeyConnect = {
  id: Scalars['UUID']['input'];
};

export type ContentFavorite = {
  cmsContentId: Scalars['Int']['input'];
  cmsContentKind: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ContentFavoriteReturn = {
  __typename?: 'ContentFavoriteReturn';
  cmsContentId: Scalars['Int']['output'];
  cmsContentKind: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type ContentFavoriteReturnV2 = {
  __typename?: 'ContentFavoriteReturnV2';
  contentId: Scalars['UUID']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type ContentFavoriteV2 = {
  contentId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type ContentInfo = {
  beganAt: Scalars['String']['input'];
  cmsContentId: Scalars['Int']['input'];
  cmsContentKind: Scalars['String']['input'];
  customActivityName?: InputMaybe<Scalars['String']['input']>;
  endedAt: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ContentMedia = {
  __typename?: 'ContentMedia';
  url: Scalars['String']['output'];
};

export type ContentMetaTag = Node & {
  __typename?: 'ContentMetaTag';
  /** Reads a single `Content` that is related to this `ContentMetaTag`. */
  content?: Maybe<Content>;
  contentId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `MetaTag` that is related to this `ContentMetaTag`. */
  metaTag?: Maybe<MetaTag>;
  metaTagId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `ContentMetaTag` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ContentMetaTagCondition = {
  /** Checks for equality with the object’s `contentId` field. */
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `metaTagId` field. */
  metaTagId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The `contentMetaTag` to be created by this mutation. */
export type ContentMetaTagContentIdFkeyContentMetaTagCreateInput = {
  contentToContentId?: InputMaybe<ContentMetaTagContentIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTagId?: InputMaybe<Scalars['UUID']['input']>;
  metaTagToMetaTagId?: InputMaybe<ContentMetaTagMetaTagIdFkeyInput>;
};

/** Input for the nested mutation of `content` in the `ContentMetaTagInput` mutation. */
export type ContentMetaTagContentIdFkeyInput = {
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByCmsContentIdAndCmsContentKind?: InputMaybe<ContentUniqueContentItemsConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByCmsNextContentIdAndCmsNextContentKind?: InputMaybe<ContentUniqueCmsNextContentItemsConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectById?: InputMaybe<ContentContentPkeyConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContentNodeIdConnect>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByCmsContentIdAndCmsContentKind?: InputMaybe<ContentOnContentMetaTagForContentMetaTagContentIdFkeyUsingUniqueContentItemsUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByCmsNextContentIdAndCmsNextContentKind?: InputMaybe<ContentOnContentMetaTagForContentMetaTagContentIdFkeyUsingUniqueCmsNextContentItemsUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateById?: InputMaybe<ContentOnContentMetaTagForContentMetaTagContentIdFkeyUsingContentPkeyUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ContentMetaTagOnContentMetaTagForContentMetaTagContentIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `contentMetaTag` in the `ContentInput` mutation. */
export type ContentMetaTagContentIdFkeyInverseInput = {
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  connectByContentIdAndMetaTagId?: InputMaybe<Array<ContentMetaTagContentMetaTagContentIdMetaTagIdKeyConnect>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContentMetaTagContentMetaTagPkeyConnect>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ContentMetaTagNodeIdConnect>>;
  /** A `ContentMetaTagInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContentMetaTagContentIdFkeyContentMetaTagCreateInput>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  deleteByContentIdAndMetaTagId?: InputMaybe<Array<ContentMetaTagContentMetaTagContentIdMetaTagIdKeyDelete>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContentMetaTagContentMetaTagPkeyDelete>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ContentMetaTagNodeIdDelete>>;
  /** Flag indicating whether all other `contentMetaTag` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `contentMetaTag` for the far side of the relationship. */
  updateByContentIdAndMetaTagId?: InputMaybe<Array<ContentMetaTagOnContentMetaTagForContentMetaTagContentIdFkeyUsingContentMetaTagContentIdMetaTagIdKeyUpdate>>;
  /** The primary key(s) and patch data for `contentMetaTag` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContentMetaTagOnContentMetaTagForContentMetaTagContentIdFkeyUsingContentMetaTagPkeyUpdate>>;
  /** The primary key(s) and patch data for `contentMetaTag` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContentOnContentMetaTagForContentMetaTagContentIdFkeyNodeIdUpdate>>;
};

/** The fields on `contentMetaTag` to look up the row to connect. */
export type ContentMetaTagContentMetaTagContentIdMetaTagIdKeyConnect = {
  contentId: Scalars['UUID']['input'];
  metaTagId: Scalars['UUID']['input'];
};

/** The fields on `contentMetaTag` to look up the row to delete. */
export type ContentMetaTagContentMetaTagContentIdMetaTagIdKeyDelete = {
  contentId: Scalars['UUID']['input'];
  metaTagId: Scalars['UUID']['input'];
};

/** The fields on `contentMetaTag` to look up the row to connect. */
export type ContentMetaTagContentMetaTagPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `contentMetaTag` to look up the row to delete. */
export type ContentMetaTagContentMetaTagPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** An input for mutations affecting `ContentMetaTag` */
export type ContentMetaTagInput = {
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<ContentMetaTagContentIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTagId?: InputMaybe<Scalars['UUID']['input']>;
  metaTagToMetaTagId?: InputMaybe<ContentMetaTagMetaTagIdFkeyInput>;
};

/** The `contentMetaTag` to be created by this mutation. */
export type ContentMetaTagMetaTagIdFkeyContentMetaTagCreateInput = {
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<ContentMetaTagContentIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTagToMetaTagId?: InputMaybe<ContentMetaTagMetaTagIdFkeyInput>;
};

/** Input for the nested mutation of `metaTag` in the `ContentMetaTagInput` mutation. */
export type ContentMetaTagMetaTagIdFkeyInput = {
  /** The primary key(s) for `metaTag` for the far side of the relationship. */
  connectById?: InputMaybe<MetaTagMetaTagPkeyConnect>;
  /** The primary key(s) for `metaTag` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MetaTagNodeIdConnect>;
  /** The primary key(s) for `metaTag` for the far side of the relationship. */
  connectByTagAndKind?: InputMaybe<MetaTagMetaTagTagKindKeyConnect>;
  /** The primary key(s) and patch data for `metaTag` for the far side of the relationship. */
  updateById?: InputMaybe<MetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyUsingMetaTagPkeyUpdate>;
  /** The primary key(s) and patch data for `metaTag` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ContentMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `metaTag` for the far side of the relationship. */
  updateByTagAndKind?: InputMaybe<MetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyUsingMetaTagTagKindKeyUpdate>;
};

/** Input for the nested mutation of `contentMetaTag` in the `MetaTagInput` mutation. */
export type ContentMetaTagMetaTagIdFkeyInverseInput = {
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  connectByContentIdAndMetaTagId?: InputMaybe<Array<ContentMetaTagContentMetaTagContentIdMetaTagIdKeyConnect>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContentMetaTagContentMetaTagPkeyConnect>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ContentMetaTagNodeIdConnect>>;
  /** A `ContentMetaTagInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContentMetaTagMetaTagIdFkeyContentMetaTagCreateInput>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  deleteByContentIdAndMetaTagId?: InputMaybe<Array<ContentMetaTagContentMetaTagContentIdMetaTagIdKeyDelete>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContentMetaTagContentMetaTagPkeyDelete>>;
  /** The primary key(s) for `contentMetaTag` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ContentMetaTagNodeIdDelete>>;
  /** Flag indicating whether all other `contentMetaTag` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `contentMetaTag` for the far side of the relationship. */
  updateByContentIdAndMetaTagId?: InputMaybe<Array<ContentMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyUsingContentMetaTagContentIdMetaTagIdKeyUpdate>>;
  /** The primary key(s) and patch data for `contentMetaTag` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContentMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyUsingContentMetaTagPkeyUpdate>>;
  /** The primary key(s) and patch data for `contentMetaTag` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<MetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyNodeIdUpdate>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ContentMetaTagNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `contentMetaTag` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ContentMetaTagNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `contentMetaTag` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContentMetaTagOnContentMetaTagForContentMetaTagContentIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `content` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: ContentPatch;
};

/** The fields on `contentMetaTag` to look up the row to update. */
export type ContentMetaTagOnContentMetaTagForContentMetaTagContentIdFkeyUsingContentMetaTagContentIdMetaTagIdKeyUpdate = {
  contentId: Scalars['UUID']['input'];
  metaTagId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `contentMetaTag` being updated. */
  patch: UpdateContentMetaTagOnContentMetaTagForContentMetaTagContentIdFkeyPatch;
};

/** The fields on `contentMetaTag` to look up the row to update. */
export type ContentMetaTagOnContentMetaTagForContentMetaTagContentIdFkeyUsingContentMetaTagPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `contentMetaTag` being updated. */
  patch: UpdateContentMetaTagOnContentMetaTagForContentMetaTagContentIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ContentMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `metaTag` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `metaTag` being updated. */
  patch: MetaTagPatch;
};

/** The fields on `contentMetaTag` to look up the row to update. */
export type ContentMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyUsingContentMetaTagContentIdMetaTagIdKeyUpdate = {
  contentId: Scalars['UUID']['input'];
  metaTagId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `contentMetaTag` being updated. */
  patch: UpdateContentMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyPatch;
};

/** The fields on `contentMetaTag` to look up the row to update. */
export type ContentMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyUsingContentMetaTagPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `contentMetaTag` being updated. */
  patch: UpdateContentMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyPatch;
};

/** Represents an update to a `ContentMetaTag`. Fields that are set will be updated. */
export type ContentMetaTagPatch = {
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<ContentMetaTagContentIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTagId?: InputMaybe<Scalars['UUID']['input']>;
  metaTagToMetaTagId?: InputMaybe<ContentMetaTagMetaTagIdFkeyInput>;
};

/** A connection to a list of `ContentMetaTag` values. */
export type ContentMetaTagsConnection = {
  __typename?: 'ContentMetaTagsConnection';
  /** A list of edges which contains the `ContentMetaTag` and cursor to aid in pagination. */
  edges: Array<ContentMetaTagsEdge>;
  /** A list of `ContentMetaTag` objects. */
  nodes: Array<ContentMetaTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContentMetaTag` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ContentMetaTag` edge in the connection. */
export type ContentMetaTagsEdge = {
  __typename?: 'ContentMetaTagsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ContentMetaTag` at the end of the edge. */
  node: ContentMetaTag;
};

/** Methods to use when ordering `ContentMetaTag`. */
export enum ContentMetaTagsOrderBy {
  ContentIdAsc = 'CONTENT_ID_ASC',
  ContentIdDesc = 'CONTENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetaTagIdAsc = 'META_TAG_ID_ASC',
  MetaTagIdDesc = 'META_TAG_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum ContentMode {
  Beta = 'beta',
  Draft = 'draft',
  Published = 'published',
  Release = 'release'
}

/** The globally unique `ID` look up for the row to connect. */
export type ContentNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `content` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ContentOnContentActivityForContentActivityContentIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contentActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `contentActivity` being updated. */
  patch: ContentActivityPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnContentActivityForContentActivityContentIdFkeyUsingContentPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnContentActivityForContentActivityContentIdFkeyPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnContentActivityForContentActivityContentIdFkeyUsingUniqueCmsNextContentItemsUpdate = {
  cmsNextContentId: Scalars['Int']['input'];
  cmsNextContentKind: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnContentActivityForContentActivityContentIdFkeyPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnContentActivityForContentActivityContentIdFkeyUsingUniqueContentItemsUpdate = {
  cmsContentId: Scalars['Int']['input'];
  cmsContentKind: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnContentActivityForContentActivityContentIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ContentOnContentMetaTagForContentMetaTagContentIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contentMetaTag` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `contentMetaTag` being updated. */
  patch: ContentMetaTagPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnContentMetaTagForContentMetaTagContentIdFkeyUsingContentPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnContentMetaTagForContentMetaTagContentIdFkeyPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnContentMetaTagForContentMetaTagContentIdFkeyUsingUniqueCmsNextContentItemsUpdate = {
  cmsNextContentId: Scalars['Int']['input'];
  cmsNextContentKind: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnContentMetaTagForContentMetaTagContentIdFkeyPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnContentMetaTagForContentMetaTagContentIdFkeyUsingUniqueContentItemsUpdate = {
  cmsContentId: Scalars['Int']['input'];
  cmsContentKind: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnContentMetaTagForContentMetaTagContentIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ContentOnUserContentActivityForUserContentActivityContentIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userContentActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `userContentActivity` being updated. */
  patch: UserContentActivityPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnUserContentActivityForUserContentActivityContentIdFkeyUsingContentPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnUserContentActivityForUserContentActivityContentIdFkeyPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnUserContentActivityForUserContentActivityContentIdFkeyUsingUniqueCmsNextContentItemsUpdate = {
  cmsNextContentId: Scalars['Int']['input'];
  cmsNextContentKind: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnUserContentActivityForUserContentActivityContentIdFkeyPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnUserContentActivityForUserContentActivityContentIdFkeyUsingUniqueContentItemsUpdate = {
  cmsContentId: Scalars['Int']['input'];
  cmsContentKind: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnUserContentActivityForUserContentActivityContentIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userContentFavorite` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `userContentFavorite` being updated. */
  patch: UserContentFavoritePatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingContentPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingUniqueCmsNextContentItemsUpdate = {
  cmsNextContentId: Scalars['Int']['input'];
  cmsNextContentKind: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyPatch;
};

/** The fields on `content` to look up the row to update. */
export type ContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingUniqueContentItemsUpdate = {
  cmsContentId: Scalars['Int']['input'];
  cmsContentKind: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: UpdateContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyPatch;
};

/** Represents an update to a `Content`. Fields that are set will be updated. */
export type ContentPatch = {
  cmsContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsContentKind?: InputMaybe<Scalars['String']['input']>;
  cmsNextContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsNextContentKind?: InputMaybe<Scalars['String']['input']>;
  contentActivityUsingId?: InputMaybe<ContentActivityContentIdFkeyInverseInput>;
  /** Difficulty levels for different aspects: cognitive, motor, speech, vision, hearing. Values: easy, medium, hard */
  difficultyLevel?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTags?: InputMaybe<ContentMetaTagContentIdFkeyInverseInput>;
  /** CMS game model key; null for non-game content or unavailable metadata. */
  subtype?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesUsingId?: InputMaybe<UserContentActivityContentIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteContentIdFkeyInverseInput>;
};

export enum ContentRelease {
  Beta = 'beta',
  Prod = 'prod'
}

/** The fields on `content` to look up the row to connect. */
export type ContentUniqueCmsNextContentItemsConnect = {
  cmsNextContentId: Scalars['Int']['input'];
  cmsNextContentKind: Scalars['String']['input'];
};

/** The fields on `content` to look up the row to connect. */
export type ContentUniqueContentItemsConnect = {
  cmsContentId: Scalars['Int']['input'];
  cmsContentKind: Scalars['String']['input'];
};

export type ContentUrlParams = {
  activeVersion?: InputMaybe<Scalars['Int']['input']>;
  appEnvironment?: InputMaybe<Environment>;
  appVersion: Scalars['String']['input'];
  cmsEnvironment: CmsEnvironment;
  contentGroupName?: InputMaybe<Scalars['String']['input']>;
  contentMode: ContentMode;
  flavour: Flavour;
  region: Region;
  relativePath: Scalars['Boolean']['input'];
};

export type ContentUrls = {
  __typename?: 'ContentUrls';
  annualHistory?: Maybe<Scalars['String']['output']>;
  assets?: Maybe<Scalars['String']['output']>;
  audioButtonGroups?: Maybe<Scalars['String']['output']>;
  audioItems?: Maybe<Scalars['String']['output']>;
  christmasCalendars?: Maybe<Scalars['String']['output']>;
  contentSequences?: Maybe<Scalars['String']['output']>;
  conversationGuides?: Maybe<Scalars['String']['output']>;
  dailyContentList?: Maybe<Scalars['String']['output']>;
  dailyQuestionsList?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Scalars['String']['output']>;
  externalApps?: Maybe<Scalars['String']['output']>;
  forms?: Maybe<Scalars['String']['output']>;
  galleries?: Maybe<Scalars['String']['output']>;
  games?: Maybe<Scalars['String']['output']>;
  horoscopes?: Maybe<Scalars['String']['output']>;
  mediaList?: Maybe<Scalars['String']['output']>;
  metaTags?: Maybe<Scalars['String']['output']>;
  moderationCards?: Maybe<Scalars['String']['output']>;
  navigations?: Maybe<Scalars['String']['output']>;
  richTexts?: Maybe<Scalars['String']['output']>;
  searchIndex?: Maybe<Scalars['String']['output']>;
  sequences?: Maybe<Scalars['String']['output']>;
  textbooks?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Scalars['String']['output']>;
  websites?: Maybe<Scalars['String']['output']>;
  weeklyContentTrains?: Maybe<Scalars['String']['output']>;
  zodiacSigns?: Maybe<Scalars['String']['output']>;
};

export type ContentUrlsParamsV2 = {
  cmsEnvironment: CmsEnvironment;
  contentMode: ContentMode;
  flavour: Flavour;
};

export type ContentUrlsV2 = {
  __typename?: 'ContentUrlsV2';
  annualHistories: Scalars['String']['output'];
  assets: Scalars['String']['output'];
  audioButtonGroups: Scalars['String']['output'];
  audios: Scalars['String']['output'];
  christmasCalendars: Scalars['String']['output'];
  contentDocuments: Scalars['String']['output'];
  conversationGuides: Scalars['String']['output'];
  courses: Scalars['String']['output'];
  dailyContents: Scalars['String']['output'];
  dailyQuestions: Scalars['String']['output'];
  externalApps: Scalars['String']['output'];
  forms: Scalars['String']['output'];
  galleries: Scalars['String']['output'];
  games: Scalars['String']['output'];
  horoscopes: Scalars['String']['output'];
  learningPaths: Scalars['String']['output'];
  mediaList: Scalars['String']['output'];
  metaTags: Scalars['String']['output'];
  moderationCards: Scalars['String']['output'];
  navigations: Scalars['String']['output'];
  richTexts: Scalars['String']['output'];
  searchIndexes: Scalars['String']['output'];
  sequences: Scalars['String']['output'];
  videos: Scalars['String']['output'];
  websites: Scalars['String']['output'];
  weeklyContentTrains: Scalars['String']['output'];
  zodiacSigns: Scalars['String']['output'];
};

/** A connection to a list of `ContentUsageDaily` values. */
export type ContentUsageDailiesConnection = {
  __typename?: 'ContentUsageDailiesConnection';
  /** A list of edges which contains the `ContentUsageDaily` and cursor to aid in pagination. */
  edges: Array<ContentUsageDailiesEdge>;
  /** A list of `ContentUsageDaily` objects. */
  nodes: Array<ContentUsageDaily>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContentUsageDaily` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ContentUsageDaily` edge in the connection. */
export type ContentUsageDailiesEdge = {
  __typename?: 'ContentUsageDailiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ContentUsageDaily` at the end of the edge. */
  node: ContentUsageDaily;
};

/** Methods to use when ordering `ContentUsageDaily`. */
export enum ContentUsageDailiesOrderBy {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ContentUsageDaily = Node & {
  __typename?: 'ContentUsageDaily';
  appId: Scalars['String']['output'];
  cmsContentKind: Scalars['String']['output'];
  completedDurationSecondsSum: Scalars['BigInt']['output'];
  completedDurationSessionCount: Scalars['Int']['output'];
  completedSessionCount: Scalars['Int']['output'];
  contentId: Scalars['UUID']['output'];
  /** CMS game model key; null for non-game content or unavailable metadata. */
  contentSubtype?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  unfinishedSessionCount: Scalars['Int']['output'];
};

/**
 * A condition to be used against `ContentUsageDaily` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ContentUsageDailyCondition = {
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
};

export type ContentUsageInfo = {
  __typename?: 'ContentUsageInfo';
  content: Content;
  visitCount: Scalars['Int']['output'];
};

/** A connection to a list of `User` values, with data from `UserContentActivity`. */
export type ContentUsersByUserContentActivityContentIdAndSeniorProfileIdManyToManyConnection = {
  __typename?: 'ContentUsersByUserContentActivityContentIdAndSeniorProfileIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UserContentActivity`, and the cursor to aid in pagination. */
  edges: Array<ContentUsersByUserContentActivityContentIdAndSeniorProfileIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type ContentUsersByUserContentActivityContentIdAndSeniorProfileIdManyToManyEdge = {
  __typename?: 'ContentUsersByUserContentActivityContentIdAndSeniorProfileIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesBySeniorProfileId: UserContentActivitiesConnection;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesBySeniorProfileIdList: Array<UserContentActivity>;
};


/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type ContentUsersByUserContentActivityContentIdAndSeniorProfileIdManyToManyEdgeUserContentActivitiesBySeniorProfileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type ContentUsersByUserContentActivityContentIdAndSeniorProfileIdManyToManyEdgeUserContentActivitiesBySeniorProfileIdListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UserContentActivity`. */
export type ContentUsersByUserContentActivityContentIdAndUserIdManyToManyConnection = {
  __typename?: 'ContentUsersByUserContentActivityContentIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UserContentActivity`, and the cursor to aid in pagination. */
  edges: Array<ContentUsersByUserContentActivityContentIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type ContentUsersByUserContentActivityContentIdAndUserIdManyToManyEdge = {
  __typename?: 'ContentUsersByUserContentActivityContentIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivities: UserContentActivitiesConnection;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesList: Array<UserContentActivity>;
};


/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type ContentUsersByUserContentActivityContentIdAndUserIdManyToManyEdgeUserContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type ContentUsersByUserContentActivityContentIdAndUserIdManyToManyEdgeUserContentActivitiesListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UserContentFavorite`. */
export type ContentUsersByUserContentFavoriteContentIdAndUserIdManyToManyConnection = {
  __typename?: 'ContentUsersByUserContentFavoriteContentIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UserContentFavorite`, and the cursor to aid in pagination. */
  edges: Array<ContentUsersByUserContentFavoriteContentIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `UserContentFavorite`. */
export type ContentUsersByUserContentFavoriteContentIdAndUserIdManyToManyEdge = {
  __typename?: 'ContentUsersByUserContentFavoriteContentIdAndUserIdManyToManyEdge';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  id: Scalars['UUID']['output'];
  /** The `User` at the end of the edge. */
  node: User;
};

export type ContentVersion = {
  __typename?: 'ContentVersion';
  contentGroupUrl?: Maybe<Scalars['String']['output']>;
  contentUrls?: Maybe<ContentUrls>;
  minAppVersions?: Maybe<MinAppVersionInfo>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `Content`. */
export enum ContentsOrderBy {
  CmsContentIdAsc = 'CMS_CONTENT_ID_ASC',
  CmsContentIdDesc = 'CMS_CONTENT_ID_DESC',
  CmsNextContentIdAsc = 'CMS_NEXT_CONTENT_ID_ASC',
  CmsNextContentIdDesc = 'CMS_NEXT_CONTENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum ContractStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Inactive = 'Inactive'
}

export type CourseAssignmentInput = {
  courseId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

/** All input for the create `ActivityGoal` mutation. */
export type CreateActivityGoalInput = {
  /** The `ActivityGoal` to be created by this mutation. */
  activityGoal: ActivityGoalInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ActivityGoal` mutation. */
export type CreateActivityGoalPayload = {
  __typename?: 'CreateActivityGoalPayload';
  /** The `ActivityGoal` that was created by this mutation. */
  activityGoal?: Maybe<ActivityGoal>;
  /** An edge for our `ActivityGoal`. May be used by Relay 1. */
  activityGoalEdge?: Maybe<ActivityGoalsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ActivityGoal`. */
  user?: Maybe<User>;
};


/** The output of our create `ActivityGoal` mutation. */
export type CreateActivityGoalPayloadActivityGoalEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivityGoalsOrderBy>>;
};

/** All input for the create `Activity` mutation. */
export type CreateActivityInput = {
  /** The `Activity` to be created by this mutation. */
  activity: ActivityInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the create `ActivityParticipant` mutation. */
export type CreateActivityParticipantInput = {
  /** The `ActivityParticipant` to be created by this mutation. */
  activityParticipant: ActivityParticipantInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ActivityParticipant` mutation. */
export type CreateActivityParticipantPayload = {
  __typename?: 'CreateActivityParticipantPayload';
  /** The `ActivityParticipant` that was created by this mutation. */
  activityParticipant?: Maybe<ActivityParticipant>;
  /** An edge for our `ActivityParticipant`. May be used by Relay 1. */
  activityParticipantEdge?: Maybe<ActivityParticipantsEdge>;
  /** Reads a single `ActivitySession` that is related to this `ActivityParticipant`. */
  activitySession?: Maybe<ActivitySession>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ActivityParticipant`. */
  senior?: Maybe<User>;
};


/** The output of our create `ActivityParticipant` mutation. */
export type CreateActivityParticipantPayloadActivityParticipantEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivityParticipantsOrderBy>>;
};

/** The output of our create `Activity` mutation. */
export type CreateActivityPayload = {
  __typename?: 'CreateActivityPayload';
  /** The `Activity` that was created by this mutation. */
  activity?: Maybe<Activity>;
  /** An edge for our `Activity`. May be used by Relay 1. */
  activityEdge?: Maybe<ActivitiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Activity` mutation. */
export type CreateActivityPayloadActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivitiesOrderBy>>;
};

/** All input for the create `ActivitySession` mutation. */
export type CreateActivitySessionInput = {
  /** The `ActivitySession` to be created by this mutation. */
  activitySession: ActivitySessionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ActivitySession` mutation. */
export type CreateActivitySessionPayload = {
  __typename?: 'CreateActivitySessionPayload';
  /** Reads a single `Activity` that is related to this `ActivitySession`. */
  activity?: Maybe<Activity>;
  /** The `ActivitySession` that was created by this mutation. */
  activitySession?: Maybe<ActivitySession>;
  /** An edge for our `ActivitySession`. May be used by Relay 1. */
  activitySessionEdge?: Maybe<ActivitySessionsEdge>;
  /** Reads a single `User` that is related to this `ActivitySession`. */
  caregiver?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Procedure` that is related to this `ActivitySession`. */
  procedure?: Maybe<Procedure>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ActivitySession` mutation. */
export type CreateActivitySessionPayloadActivitySessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};

export type CreateAndAddMediaToAlbumInput = {
  albumId: Scalars['UUID']['input'];
  mediaItems: Array<MediaItem>;
};

/** All input for the create `AppSetting` mutation. */
export type CreateAppSettingInput = {
  /** The `AppSetting` to be created by this mutation. */
  appSetting: AppSettingInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AppSetting` mutation. */
export type CreateAppSettingPayload = {
  __typename?: 'CreateAppSettingPayload';
  /** The `AppSetting` that was created by this mutation. */
  appSetting?: Maybe<AppSetting>;
  /** An edge for our `AppSetting`. May be used by Relay 1. */
  appSettingEdge?: Maybe<AppSettingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `AppSetting`. */
  user?: Maybe<User>;
};


/** The output of our create `AppSetting` mutation. */
export type CreateAppSettingPayloadAppSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<AppSettingsOrderBy>>;
};

/** All input for the create `Attachment` mutation. */
export type CreateAttachmentInput = {
  /** The `Attachment` to be created by this mutation. */
  attachment: AttachmentInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `Attachment` mutation. */
export type CreateAttachmentPayload = {
  __typename?: 'CreateAttachmentPayload';
  /** The `Attachment` that was created by this mutation. */
  attachment?: Maybe<Attachment>;
  /** An edge for our `Attachment`. May be used by Relay 1. */
  attachmentEdge?: Maybe<AttachmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Media` that is related to this `Attachment`. */
  media?: Maybe<Media>;
  /** Reads a single `Message` that is related to this `Attachment`. */
  message?: Maybe<Message>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Attachment` mutation. */
export type CreateAttachmentPayloadAttachmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AttachmentsOrderBy>>;
};

export type CreateAvatarFromUrlInput = {
  url: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

/** All input for the create `CaregiverSenior` mutation. */
export type CreateCaregiverSeniorInput = {
  /** The `CaregiverSenior` to be created by this mutation. */
  caregiverSenior: CaregiverSeniorInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CaregiverSenior` mutation. */
export type CreateCaregiverSeniorPayload = {
  __typename?: 'CreateCaregiverSeniorPayload';
  /** Reads a single `User` that is related to this `CaregiverSenior`. */
  caregiver?: Maybe<User>;
  /** The `CaregiverSenior` that was created by this mutation. */
  caregiverSenior?: Maybe<CaregiverSenior>;
  /** An edge for our `CaregiverSenior`. May be used by Relay 1. */
  caregiverSeniorEdge?: Maybe<CaregiverSeniorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CaregiverSenior`. */
  senior?: Maybe<User>;
};


/** The output of our create `CaregiverSenior` mutation. */
export type CreateCaregiverSeniorPayloadCaregiverSeniorEdgeArgs = {
  orderBy?: InputMaybe<Array<CaregiverSeniorsOrderBy>>;
};

/** All input for the create `CheckIn` mutation. */
export type CreateCheckInInput = {
  /** The `CheckIn` to be created by this mutation. */
  checkIn: CheckInInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the create `CheckInMessage` mutation. */
export type CreateCheckInMessageInput = {
  /** The `CheckInMessage` to be created by this mutation. */
  checkInMessage: CheckInMessageInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CheckInMessage` mutation. */
export type CreateCheckInMessagePayload = {
  __typename?: 'CreateCheckInMessagePayload';
  /** Reads a single `User` that is related to this `CheckInMessage`. */
  author?: Maybe<User>;
  /** Reads a single `CheckIn` that is related to this `CheckInMessage`. */
  checkIn?: Maybe<CheckIn>;
  /** The `CheckInMessage` that was created by this mutation. */
  checkInMessage?: Maybe<CheckInMessage>;
  /** An edge for our `CheckInMessage`. May be used by Relay 1. */
  checkInMessageEdge?: Maybe<CheckInMessagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CheckInMessage` mutation. */
export type CreateCheckInMessagePayloadCheckInMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};

/** The output of our create `CheckIn` mutation. */
export type CreateCheckInPayload = {
  __typename?: 'CreateCheckInPayload';
  /** Reads a single `User` that is related to this `CheckIn`. */
  author?: Maybe<User>;
  /** The `CheckIn` that was created by this mutation. */
  checkIn?: Maybe<CheckIn>;
  /** An edge for our `CheckIn`. May be used by Relay 1. */
  checkInEdge?: Maybe<CheckInsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CheckIn`. */
  senior?: Maybe<User>;
};


/** The output of our create `CheckIn` mutation. */
export type CreateCheckInPayloadCheckInEdgeArgs = {
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};

/** All input for the create `ContentActivity` mutation. */
export type CreateContentActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ContentActivity` to be created by this mutation. */
  contentActivity: ContentActivityInput;
};

/** The output of our create `ContentActivity` mutation. */
export type CreateContentActivityPayload = {
  __typename?: 'CreateContentActivityPayload';
  /** Reads a single `Activity` that is related to this `ContentActivity`. */
  activity?: Maybe<Activity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `ContentActivity`. */
  content?: Maybe<Content>;
  /** The `ContentActivity` that was created by this mutation. */
  contentActivity?: Maybe<ContentActivity>;
  /** An edge for our `ContentActivity`. May be used by Relay 1. */
  contentActivityEdge?: Maybe<ContentActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ContentActivity` mutation. */
export type CreateContentActivityPayloadContentActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<ContentActivitiesOrderBy>>;
};

/** All input for the create `ContentMetaTag` mutation. */
export type CreateContentMetaTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ContentMetaTag` to be created by this mutation. */
  contentMetaTag: ContentMetaTagInput;
};

/** The output of our create `ContentMetaTag` mutation. */
export type CreateContentMetaTagPayload = {
  __typename?: 'CreateContentMetaTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `ContentMetaTag`. */
  content?: Maybe<Content>;
  /** The `ContentMetaTag` that was created by this mutation. */
  contentMetaTag?: Maybe<ContentMetaTag>;
  /** An edge for our `ContentMetaTag`. May be used by Relay 1. */
  contentMetaTagEdge?: Maybe<ContentMetaTagsEdge>;
  /** Reads a single `MetaTag` that is related to this `ContentMetaTag`. */
  metaTag?: Maybe<MetaTag>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ContentMetaTag` mutation. */
export type CreateContentMetaTagPayloadContentMetaTagEdgeArgs = {
  orderBy?: InputMaybe<Array<ContentMetaTagsOrderBy>>;
};

/** All input for the create `CustomActivity` mutation. */
export type CreateCustomActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CustomActivity` to be created by this mutation. */
  customActivity: CustomActivityInput;
};

/** The output of our create `CustomActivity` mutation. */
export type CreateCustomActivityPayload = {
  __typename?: 'CreateCustomActivityPayload';
  /** Reads a single `Activity` that is related to this `CustomActivity`. */
  activity?: Maybe<Activity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CustomActivity` that was created by this mutation. */
  customActivity?: Maybe<CustomActivity>;
  /** An edge for our `CustomActivity`. May be used by Relay 1. */
  customActivityEdge?: Maybe<CustomActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CustomActivity` mutation. */
export type CreateCustomActivityPayloadCustomActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomActivitiesOrderBy>>;
};

export type CreateDeviceEnrollmentTokenInput = {
  expiresAt: Scalars['Datetime']['input'];
  /**
   * Omit for a token that covers the whole organization; otherwise a SITE,
   * DEPARTMENT or WARD of that organization.
   */
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Maximum redemptions; null means unlimited until expiry. */
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['UUID']['input'];
};

export type CreateDeviceEnrollmentTokenResponse = {
  __typename?: 'CreateDeviceEnrollmentTokenResponse';
  code: Scalars['String']['output'];
  qrPayload: Scalars['String']['output'];
  token: DeviceEnrollmentToken;
};

/** All input for the create `Device` mutation. */
export type CreateDeviceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Device` to be created by this mutation. */
  device: DeviceInput;
};

/** The output of our create `Device` mutation. */
export type CreateDevicePayload = {
  __typename?: 'CreateDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Device` that was created by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Reads a single `Location` that is related to this `Device`. */
  location?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Device`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Device` mutation. */
export type CreateDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** All input for the create `FamilyMemberSenior` mutation. */
export type CreateFamilyMemberSeniorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FamilyMemberSenior` to be created by this mutation. */
  familyMemberSenior: FamilyMemberSeniorInput;
};

/** The output of our create `FamilyMemberSenior` mutation. */
export type CreateFamilyMemberSeniorPayload = {
  __typename?: 'CreateFamilyMemberSeniorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `FamilyMemberSenior`. */
  familyMember?: Maybe<User>;
  /** The `FamilyMemberSenior` that was created by this mutation. */
  familyMemberSenior?: Maybe<FamilyMemberSenior>;
  /** An edge for our `FamilyMemberSenior`. May be used by Relay 1. */
  familyMemberSeniorEdge?: Maybe<FamilyMemberSeniorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FamilyMemberSenior`. */
  senior?: Maybe<User>;
};


/** The output of our create `FamilyMemberSenior` mutation. */
export type CreateFamilyMemberSeniorPayloadFamilyMemberSeniorEdgeArgs = {
  orderBy?: InputMaybe<Array<FamilyMemberSeniorsOrderBy>>;
};

/** All input for the create `FeatureActivity` mutation. */
export type CreateFeatureActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FeatureActivity` to be created by this mutation. */
  featureActivity: FeatureActivityInput;
};

/** The output of our create `FeatureActivity` mutation. */
export type CreateFeatureActivityPayload = {
  __typename?: 'CreateFeatureActivityPayload';
  /** Reads a single `Activity` that is related to this `FeatureActivity`. */
  activity?: Maybe<Activity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `FeatureActivity` that was created by this mutation. */
  featureActivity?: Maybe<FeatureActivity>;
  /** An edge for our `FeatureActivity`. May be used by Relay 1. */
  featureActivityEdge?: Maybe<FeatureActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FeatureActivity` mutation. */
export type CreateFeatureActivityPayloadFeatureActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureActivitiesOrderBy>>;
};

/** All input for the create `Feedback` mutation. */
export type CreateFeedbackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Feedback` to be created by this mutation. */
  feedback: FeedbackInput;
};

/** The output of our create `Feedback` mutation. */
export type CreateFeedbackPayload = {
  __typename?: 'CreateFeedbackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Feedback` that was created by this mutation. */
  feedback?: Maybe<Feedback>;
  /** An edge for our `Feedback`. May be used by Relay 1. */
  feedbackEdge?: Maybe<FeedbacksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Feedback`. */
  user?: Maybe<User>;
};


/** The output of our create `Feedback` mutation. */
export type CreateFeedbackPayloadFeedbackEdgeArgs = {
  orderBy?: InputMaybe<Array<FeedbacksOrderBy>>;
};

/** All input for the create `Group` mutation. */
export type CreateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Group` to be created by this mutation. */
  group: GroupInput;
};

/** The output of our create `Group` mutation. */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Group` that was created by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Media` that is related to this `Group`. */
  mediaByAvatar?: Maybe<Media>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Group` mutation. */
export type CreateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the create `HandshakeCode` mutation. */
export type CreateHandshakeCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `HandshakeCode` to be created by this mutation. */
  handshakeCode: HandshakeCodeInput;
};

/** The output of our create `HandshakeCode` mutation. */
export type CreateHandshakeCodePayload = {
  __typename?: 'CreateHandshakeCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `HandshakeCode` that was created by this mutation. */
  handshakeCode?: Maybe<HandshakeCode>;
  /** An edge for our `HandshakeCode`. May be used by Relay 1. */
  handshakeCodeEdge?: Maybe<HandshakeCodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workgroup` that is related to this `HandshakeCode`. */
  workgroup?: Maybe<Workgroup>;
};


/** The output of our create `HandshakeCode` mutation. */
export type CreateHandshakeCodePayloadHandshakeCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<HandshakeCodesOrderBy>>;
};

/** All input for the create `KorianUser` mutation. */
export type CreateKorianUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `KorianUser` to be created by this mutation. */
  korianUser: KorianUserInput;
};

/** The output of our create `KorianUser` mutation. */
export type CreateKorianUserPayload = {
  __typename?: 'CreateKorianUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `KorianUser` that was created by this mutation. */
  korianUser?: Maybe<KorianUser>;
  /** An edge for our `KorianUser`. May be used by Relay 1. */
  korianUserEdge?: Maybe<KorianUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `KorianUser`. */
  user?: Maybe<User>;
};


/** The output of our create `KorianUser` mutation. */
export type CreateKorianUserPayloadKorianUserEdgeArgs = {
  orderBy?: InputMaybe<Array<KorianUsersOrderBy>>;
};

/** All input for the create `Location` mutation. */
export type CreateLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Location` to be created by this mutation. */
  location: LocationInput;
};

/** The output of our create `Location` mutation. */
export type CreateLocationPayload = {
  __typename?: 'CreateLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Location` that was created by this mutation. */
  location?: Maybe<Location>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge?: Maybe<LocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Location` that is related to this `Location`. */
  partOf?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Location` mutation. */
export type CreateLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

export type CreateLogisticsShippingLabelInput = {
  orderId: Scalars['UUID']['input'];
  /** Stable caller UUID required in the production pilot. Reuse it after a lost answer. */
  requestId?: InputMaybe<Scalars['UUID']['input']>;
  /** Also create a return label for an Order that does not get one anyway. Exchange and Partial Exchange Orders always get one. */
  returnLabel?: InputMaybe<Scalars['Boolean']['input']>;
};

/** All input for the create `MediaAlbum` mutation. */
export type CreateMediaAlbumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MediaAlbum` to be created by this mutation. */
  mediaAlbum: MediaAlbumInput;
};

/** The output of our create `MediaAlbum` mutation. */
export type CreateMediaAlbumPayload = {
  __typename?: 'CreateMediaAlbumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MediaAlbum` that was created by this mutation. */
  mediaAlbum?: Maybe<MediaAlbum>;
  /** An edge for our `MediaAlbum`. May be used by Relay 1. */
  mediaAlbumEdge?: Maybe<MediaAlbumsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `MediaAlbum`. */
  user?: Maybe<User>;
};


/** The output of our create `MediaAlbum` mutation. */
export type CreateMediaAlbumPayloadMediaAlbumEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaAlbumsOrderBy>>;
};

export type CreateMediaAlbumsInput = {
  albums: Array<MediaAlbumBatchInput>;
};

export type CreateMediaAlbumsPayload = {
  __typename?: 'CreateMediaAlbumsPayload';
  albums: Array<MediaAlbum>;
};

/** All input for the create `Media` mutation. */
export type CreateMediaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Media` to be created by this mutation. */
  media: MediaInput;
};

/** All input for the create `MediaNote` mutation. */
export type CreateMediaNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MediaNote` to be created by this mutation. */
  mediaNote: MediaNoteInput;
};

/** The output of our create `MediaNote` mutation. */
export type CreateMediaNotePayload = {
  __typename?: 'CreateMediaNotePayload';
  /** Reads a single `User` that is related to this `MediaNote`. */
  author?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Media` that is related to this `MediaNote`. */
  media?: Maybe<Media>;
  /** The `MediaNote` that was created by this mutation. */
  mediaNote?: Maybe<MediaNote>;
  /** An edge for our `MediaNote`. May be used by Relay 1. */
  mediaNoteEdge?: Maybe<MediaNotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MediaNote` mutation. */
export type CreateMediaNotePayloadMediaNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaNotesOrderBy>>;
};

/** The output of our create `Media` mutation. */
export type CreateMediaPayload = {
  __typename?: 'CreateMediaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Media` that was created by this mutation. */
  media?: Maybe<Media>;
  /** An edge for our `Media`. May be used by Relay 1. */
  mediaEdge?: Maybe<MediaEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Media` mutation. */
export type CreateMediaPayloadMediaEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};

/** All input for the create `MediaVoiceRecording` mutation. */
export type CreateMediaVoiceRecordingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `MediaVoiceRecording` to be created by this mutation. */
  mediaVoiceRecording: MediaVoiceRecordingInput;
};

/** The output of our create `MediaVoiceRecording` mutation. */
export type CreateMediaVoiceRecordingPayload = {
  __typename?: 'CreateMediaVoiceRecordingPayload';
  /** Reads a single `User` that is related to this `MediaVoiceRecording`. */
  author?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Media` that is related to this `MediaVoiceRecording`. */
  media?: Maybe<Media>;
  /** The `MediaVoiceRecording` that was created by this mutation. */
  mediaVoiceRecording?: Maybe<MediaVoiceRecording>;
  /** An edge for our `MediaVoiceRecording`. May be used by Relay 1. */
  mediaVoiceRecordingEdge?: Maybe<MediaVoiceRecordingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Media` that is related to this `MediaVoiceRecording`. */
  voiceRecording?: Maybe<Media>;
};


/** The output of our create `MediaVoiceRecording` mutation. */
export type CreateMediaVoiceRecordingPayloadMediaVoiceRecordingEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaVoiceRecordingsOrderBy>>;
};

/** All input for the create `Membership` mutation. */
export type CreateMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Membership` to be created by this mutation. */
  membership: MembershipInput;
};

/** The output of our create `Membership` mutation. */
export type CreateMembershipPayload = {
  __typename?: 'CreateMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `Membership`. */
  group?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Membership`. */
  member?: Maybe<User>;
  /** The `Membership` that was created by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Membership` mutation. */
export type CreateMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

export type CreateMessageInput = {
  message?: InputMaybe<FullMessage>;
};

export type CreateMessagePayload = {
  __typename?: 'CreateMessagePayload';
  message?: Maybe<Message>;
};

/** All input for the create `Note` mutation. */
export type CreateNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Note` to be created by this mutation. */
  note: NoteInput;
};

/** The output of our create `Note` mutation. */
export type CreateNotePayload = {
  __typename?: 'CreateNotePayload';
  /** Reads a single `User` that is related to this `Note`. */
  author?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Note` that was created by this mutation. */
  note?: Maybe<Note>;
  /** An edge for our `Note`. May be used by Relay 1. */
  noteEdge?: Maybe<NotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Note` mutation. */
export type CreateNotePayloadNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};

/** All input for the `createOrRetrievePrivateChat` mutation. */
export type CreateOrRetrievePrivateChatInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId1?: InputMaybe<Scalars['UUID']['input']>;
  memberId2?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `createOrRetrievePrivateChat` mutation. */
export type CreateOrRetrievePrivateChatPayload = {
  __typename?: 'CreateOrRetrievePrivateChatPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Media` that is related to this `Group`. */
  mediaByAvatar?: Maybe<Media>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createOrRetrievePrivateChat` mutation. */
export type CreateOrRetrievePrivateChatPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the create `Procedure` mutation. */
export type CreateProcedureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Procedure` to be created by this mutation. */
  procedure: ProcedureInput;
};

/** All input for the create `ProcedureParticipant` mutation. */
export type CreateProcedureParticipantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ProcedureParticipant` to be created by this mutation. */
  procedureParticipant: ProcedureParticipantInput;
};

/** The output of our create `ProcedureParticipant` mutation. */
export type CreateProcedureParticipantPayload = {
  __typename?: 'CreateProcedureParticipantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Patient` that is related to this `ProcedureParticipant`. */
  patient?: Maybe<Patient>;
  /** Reads a single `Procedure` that is related to this `ProcedureParticipant`. */
  procedure?: Maybe<Procedure>;
  /** The `ProcedureParticipant` that was created by this mutation. */
  procedureParticipant?: Maybe<ProcedureParticipant>;
  /** An edge for our `ProcedureParticipant`. May be used by Relay 1. */
  procedureParticipantEdge?: Maybe<ProcedureParticipantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProcedureParticipant` mutation. */
export type CreateProcedureParticipantPayloadProcedureParticipantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcedureParticipantsOrderBy>>;
};

/** The output of our create `Procedure` mutation. */
export type CreateProcedurePayload = {
  __typename?: 'CreateProcedurePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Procedure`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Practitioner` that is related to this `Procedure`. */
  performer?: Maybe<Practitioner>;
  /** The `Procedure` that was created by this mutation. */
  procedure?: Maybe<Procedure>;
  /** An edge for our `Procedure`. May be used by Relay 1. */
  procedureEdge?: Maybe<ProceduresEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Procedure` mutation. */
export type CreateProcedurePayloadProcedureEdgeArgs = {
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};

export type CreateProgrammeProcedureInput = {
  activities: Array<ProgrammeProcedureActivityInput>;
  expectedDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  procedureId: Scalars['UUID']['input'];
  seniorIds: Array<Scalars['UUID']['input']>;
  startedAt: Scalars['Datetime']['input'];
  title: Scalars['String']['input'];
};

export type CreateProgrammeProcedurePayload = {
  __typename?: 'CreateProgrammeProcedurePayload';
  procedureId: Scalars['UUID']['output'];
};

/** All input for the create `SenderKey` mutation. */
export type CreateSenderKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SenderKey` to be created by this mutation. */
  senderKey: SenderKeyInput;
};

/** The output of our create `SenderKey` mutation. */
export type CreateSenderKeyPayload = {
  __typename?: 'CreateSenderKeyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `SenderKey`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SenderKey` that was created by this mutation. */
  senderKey?: Maybe<SenderKey>;
  /** An edge for our `SenderKey`. May be used by Relay 1. */
  senderKeyEdge?: Maybe<SenderKeysEdge>;
};


/** The output of our create `SenderKey` mutation. */
export type CreateSenderKeyPayloadSenderKeyEdgeArgs = {
  orderBy?: InputMaybe<Array<SenderKeysOrderBy>>;
};

/** All input for the `createSenior` mutation. */
export type CreateSeniorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flavour?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** The output of our `createSenior` mutation. */
export type CreateSeniorPayload = {
  __typename?: 'CreateSeniorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createSystemMessage` mutation. */
export type CreateSystemMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<SystemMessageType>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  receiverId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `createSystemMessage` mutation. */
export type CreateSystemMessagePayload = {
  __typename?: 'CreateSystemMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `UserContentActivity` mutation. */
export type CreateUserContentActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserContentActivity` to be created by this mutation. */
  userContentActivity: UserContentActivityInput;
};

/** The output of our create `UserContentActivity` mutation. */
export type CreateUserContentActivityPayload = {
  __typename?: 'CreateUserContentActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `UserContentActivity`. */
  content?: Maybe<Content>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserContentActivity`. */
  seniorProfile?: Maybe<User>;
  /** Reads a single `User` that is related to this `UserContentActivity`. */
  user?: Maybe<User>;
  /** The `UserContentActivity` that was created by this mutation. */
  userContentActivity?: Maybe<UserContentActivity>;
  /** An edge for our `UserContentActivity`. May be used by Relay 1. */
  userContentActivityEdge?: Maybe<UserContentActivitiesEdge>;
};


/** The output of our create `UserContentActivity` mutation. */
export type CreateUserContentActivityPayloadUserContentActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Media` that is related to this `User`. */
  mediaByAvatar?: Maybe<Media>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `UserSetting` mutation. */
export type CreateUserSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserSetting` to be created by this mutation. */
  userSetting: UserSettingInput;
};

/** The output of our create `UserSetting` mutation. */
export type CreateUserSettingPayload = {
  __typename?: 'CreateUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  user?: Maybe<User>;
  /** The `UserSetting` that was created by this mutation. */
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our create `UserSetting` mutation. */
export type CreateUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

/** All input for the create `Website` mutation. */
export type CreateWebsiteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Website` to be created by this mutation. */
  website: WebsiteInput;
};

/** The output of our create `Website` mutation. */
export type CreateWebsitePayload = {
  __typename?: 'CreateWebsitePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Website`. */
  user?: Maybe<User>;
  /** The `Website` that was created by this mutation. */
  website?: Maybe<Website>;
  /** An edge for our `Website`. May be used by Relay 1. */
  websiteEdge?: Maybe<WebsitesEdge>;
};


/** The output of our create `Website` mutation. */
export type CreateWebsitePayloadWebsiteEdgeArgs = {
  orderBy?: InputMaybe<Array<WebsitesOrderBy>>;
};

export type CreateWorkgroupAndCodeResponse = {
  __typename?: 'CreateWorkgroupAndCodeResponse';
  code: Scalars['String']['output'];
  workgroupId: Scalars['UUID']['output'];
};

/** All input for the create `Workgroup` mutation. */
export type CreateWorkgroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Workgroup` to be created by this mutation. */
  workgroup: WorkgroupInput;
};

/** All input for the create `WorkgroupMembership` mutation. */
export type CreateWorkgroupMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `WorkgroupMembership` to be created by this mutation. */
  workgroupMembership: WorkgroupMembershipInput;
};

/** The output of our create `WorkgroupMembership` mutation. */
export type CreateWorkgroupMembershipPayload = {
  __typename?: 'CreateWorkgroupMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `WorkgroupMembership`. */
  member?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workgroup` that is related to this `WorkgroupMembership`. */
  workgroup?: Maybe<Workgroup>;
  /** The `WorkgroupMembership` that was created by this mutation. */
  workgroupMembership?: Maybe<WorkgroupMembership>;
  /** An edge for our `WorkgroupMembership`. May be used by Relay 1. */
  workgroupMembershipEdge?: Maybe<WorkgroupMembershipsEdge>;
};


/** The output of our create `WorkgroupMembership` mutation. */
export type CreateWorkgroupMembershipPayloadWorkgroupMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkgroupMembershipsOrderBy>>;
};

/** The output of our create `Workgroup` mutation. */
export type CreateWorkgroupPayload = {
  __typename?: 'CreateWorkgroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workgroup` that was created by this mutation. */
  workgroup?: Maybe<Workgroup>;
  /** An edge for our `Workgroup`. May be used by Relay 1. */
  workgroupEdge?: Maybe<WorkgroupsEdge>;
};


/** The output of our create `Workgroup` mutation. */
export type CreateWorkgroupPayloadWorkgroupEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkgroupsOrderBy>>;
};

export type CrmAccountBilling = {
  __typename?: 'CrmAccountBilling';
  account: AccountBillingAccount;
  availability: AccountBillingAvailability;
  billedThrough?: Maybe<AccountBillingAccount>;
  customer?: Maybe<AccountBillingCustomer>;
  invoices?: Maybe<AccountBillingInvoicePage>;
  ledger?: Maybe<AccountBillingLedgerPage>;
  matchingReason?: Maybe<BillwerkCustomerMatchReason>;
  profile?: Maybe<AccountBillingProfile>;
  subscriptions?: Maybe<AccountBillingSubscriptionPage>;
};


export type CrmAccountBillingInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type CrmAccountBillingLedgerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};


export type CrmAccountBillingSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};

export type CrmAppOrganization = {
  __typename?: 'CrmAppOrganization';
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum CrmCallProvider {
  Natterbox = 'NATTERBOX',
  Placetel = 'PLACETEL'
}

export type CrmColumn = {
  __typename?: 'CrmColumn';
  key: Scalars['String']['output'];
  type: CrmFieldType;
};

export type CrmContractItemAsset = {
  __typename?: 'CrmContractItemAsset';
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  hardware?: Maybe<CrmInventoryUnit>;
  name?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  sim?: Maybe<CrmInventoryUnit>;
  tablet?: Maybe<CrmInventoryUnit>;
};

export type CrmContractItemInventoryHistory = {
  __typename?: 'CrmContractItemInventoryHistory';
  atClientDate?: Maybe<Scalars['Date']['output']>;
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  inStockDate?: Maybe<Scalars['Date']['output']>;
  inventory: CrmInventoryUnit;
  removedFromClientDate?: Maybe<Scalars['Date']['output']>;
};

export type CrmContractItemOrder = {
  __typename?: 'CrmContractItemOrder';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  exchangeStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderRejected?: Maybe<Scalars['Boolean']['output']>;
  orderSalesforceId?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CrmCount = {
  __typename?: 'CrmCount';
  count: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type CrmDayCount = {
  __typename?: 'CrmDayCount';
  day: Scalars['Date']['output'];
  inbound: Scalars['Int']['output'];
  outbound: Scalars['Int']['output'];
};

export type CrmDuplicateAddress = {
  __typename?: 'CrmDuplicateAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type CrmDuplicateCandidate = {
  __typename?: 'CrmDuplicateCandidate';
  fingerprint: Scalars['String']['output'];
  id: Scalars['String']['output'];
  left: CrmDuplicateRecord;
  reasons: Array<CrmDuplicateReason>;
  reviewedAt?: Maybe<Scalars['Datetime']['output']>;
  reviewedBy?: Maybe<Scalars['UUID']['output']>;
  right: CrmDuplicateRecord;
  score: Scalars['Int']['output'];
  status: CrmDuplicateStatus;
};

export type CrmDuplicateList = {
  __typename?: 'CrmDuplicateList';
  candidates: Array<CrmDuplicateCandidate>;
  scanState: CrmDuplicateScanState;
  scannedAt?: Maybe<Scalars['Datetime']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type CrmDuplicateListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  object?: InputMaybe<CrmObject>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CrmDuplicateStatusFilter>;
};

export type CrmDuplicateNormalizedAddress = {
  __typename?: 'CrmDuplicateNormalizedAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  house?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type CrmDuplicateNormalizedRecord = {
  __typename?: 'CrmDuplicateNormalizedRecord';
  addresses: Array<CrmDuplicateNormalizedAddress>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<CrmDuplicatePhone>;
};

export type CrmDuplicatePhone = {
  __typename?: 'CrmDuplicatePhone';
  base: Scalars['String']['output'];
  extension?: Maybe<Scalars['String']['output']>;
};

export type CrmDuplicateReason = {
  __typename?: 'CrmDuplicateReason';
  code: Scalars['String']['output'];
  similarity?: Maybe<Scalars['Float']['output']>;
};

export type CrmDuplicateRecord = {
  __typename?: 'CrmDuplicateRecord';
  addresses: Array<CrmDuplicateAddress>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  normalized: CrmDuplicateNormalizedRecord;
  object: CrmObject;
  phone?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
};

export type CrmDuplicateReviewInput = {
  expectedFingerprint: Scalars['String']['input'];
  id: Scalars['String']['input'];
  status: CrmDuplicateReviewStatus;
};

export enum CrmDuplicateReviewStatus {
  Confirmed = 'CONFIRMED',
  Deferred = 'DEFERRED',
  Dismissed = 'DISMISSED'
}

export enum CrmDuplicateScanState {
  NotScanned = 'NOT_SCANNED',
  Ready = 'READY',
  Suppressed = 'SUPPRESSED'
}

export enum CrmDuplicateStatus {
  Confirmed = 'CONFIRMED',
  Deferred = 'DEFERRED',
  Dismissed = 'DISMISSED',
  Pending = 'PENDING'
}

export enum CrmDuplicateStatusFilter {
  All = 'ALL',
  Confirmed = 'CONFIRMED',
  Deferred = 'DEFERRED',
  Dismissed = 'DISMISSED',
  Pending = 'PENDING'
}

export enum CrmFieldType {
  Boolean = 'BOOLEAN',
  /** Whether a person may be contacted: badges as codes separated by semicolons, NO_EMAIL, NO_CALLS, NO_NEWSLETTER, and EMAIL_BOUNCED=<ISO time of the bounce>|<reason, when known>. Null when no badge applies, which does not mean contact is allowed. */
  Consent = 'CONSENT',
  Currency = 'CURRENCY',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Email = 'EMAIL',
  LongText = 'LONG_TEXT',
  MultiPicklist = 'MULTI_PICKLIST',
  Number = 'NUMBER',
  /** A CrmObject, such as whether a campaign member is a lead or a contact. */
  Object = 'OBJECT',
  Phone = 'PHONE',
  Picklist = 'PICKLIST',
  Reference = 'REFERENCE',
  Text = 'TEXT',
  Url = 'URL'
}

/** Narrows a list to rows whose field has a value, or no value when value is null; or, with fromMonth, to rows whose date falls in that range of calendar months in Europe/Berlin. */
export type CrmFilterInput = {
  /** The first month, as YYYY-MM. */
  fromMonth?: InputMaybe<Scalars['String']['input']>;
  /** A field of the listed object. */
  key: Scalars['String']['input'];
  /** The last month, as YYYY-MM; fromMonth when null. */
  toMonth?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CrmInventoryUnit = {
  __typename?: 'CrmInventoryUnit';
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  hardwareSerialNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  simIccid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CrmList = {
  __typename?: 'CrmList';
  columns: Array<CrmColumn>;
  listView: Scalars['String']['output'];
  listViews: Array<Scalars['String']['output']>;
  object: CrmObject;
  rows: Array<CrmRow>;
  totalCount: Scalars['Int']['output'];
};

export type CrmListInput = {
  /** Every filter applies. */
  filters?: InputMaybe<Array<CrmFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listView?: InputMaybe<Scalars['String']['input']>;
  object: CrmObject;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Lists the records of one related list of a record instead. */
  related?: InputMaybe<CrmRelatedInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<CrmSortDirection>;
  sortKey?: InputMaybe<Scalars['String']['input']>;
};

export type CrmMergeTarget = {
  __typename?: 'CrmMergeTarget';
  salesforceId: Scalars['String']['output'];
  /** Null when the CRM copy does not hold the account. */
  title?: Maybe<Scalars['String']['output']>;
};

/** A Salesforce object Customer Service can look up in the crm copy. */
export enum CrmObject {
  Account = 'ACCOUNT',
  Campaign = 'CAMPAIGN',
  CampaignMember = 'CAMPAIGN_MEMBER',
  Case = 'CASE',
  Contact = 'CONTACT',
  Contract = 'CONTRACT',
  ContractItem = 'CONTRACT_ITEM',
  Lead = 'LEAD',
  LeadProduct = 'LEAD_PRODUCT',
  Opportunity = 'OPPORTUNITY',
  Order = 'ORDER'
}

export type CrmPath = {
  __typename?: 'CrmPath';
  current?: Maybe<Scalars['String']['output']>;
  stages: Array<Scalars['String']['output']>;
};

export type CrmRecord = {
  __typename?: 'CrmRecord';
  /** Facilities of the app that belong to this account or bill to it. */
  appOrganizations: Array<CrmAppOrganization>;
  /** The exact linked asset, only for contract items. This does not imply current inventory placement. */
  contractItemAsset?: Maybe<CrmContractItemAsset>;
  contractItemInventoryHistory: Array<CrmContractItemInventoryHistory>;
  contractItemOrders: Array<CrmContractItemOrder>;
  /** When the sync found the record deleted in Salesforce; null while Salesforce holds it. */
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  hasTimeline: Scalars['Boolean']['output'];
  highlights: Array<CrmValue>;
  /** The account a Salesforce merge kept, for an account the merge deleted. */
  mergedInto?: Maybe<CrmMergeTarget>;
  object: CrmObject;
  path?: Maybe<CrmPath>;
  related: Array<CrmRelatedList>;
  salesforceId: Scalars['String']['output'];
  salesforceUrl: Scalars['String']['output'];
  sections: Array<CrmSection>;
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
  title: Scalars['String']['output'];
};

export type CrmRelatedInput = {
  key: Scalars['String']['input'];
  object: CrmObject;
  salesforceId: Scalars['String']['input'];
};

export type CrmRelatedList = {
  __typename?: 'CrmRelatedList';
  columns: Array<CrmColumn>;
  key: Scalars['String']['output'];
  object: CrmObject;
  /** The first related records; totalCount counts all of them. */
  rows: Array<CrmRow>;
  totalCount: Scalars['Int']['output'];
};

export type CrmRow = {
  __typename?: 'CrmRow';
  /** When the sync found the record deleted in Salesforce; null while Salesforce holds it. */
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  salesforceId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  values: Array<CrmValue>;
};

export type CrmSearchHit = {
  __typename?: 'CrmSearchHit';
  /** When the sync found the record deleted in Salesforce; null while Salesforce holds it. */
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  object: CrmObject;
  salesforceId: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CrmSection = {
  __typename?: 'CrmSection';
  key: Scalars['String']['output'];
  values: Array<CrmValue>;
};

export type CrmServiceOverview = {
  __typename?: 'CrmServiceOverview';
  /** The last 14 Berlin days. Counts the Salesforce call records and, while the Placetel integration is on, the provider's calls: inbound calls dialled to a hotline number that queued or reached an agent, and outbound calls of agents who connected the portal phone. */
  callsPerDay: Array<CrmDayCount>;
  closedToday: Scalars['Int']['output'];
  createdToday: Scalars['Int']['output'];
  escalatedCases: Scalars['Int']['output'];
  oldestOpen: Array<CrmRow>;
  openByOwner: Array<CrmCount>;
  openByStatus: Array<CrmCount>;
  openByType: Array<CrmCount>;
  openCases: Scalars['Int']['output'];
  outsideSlaCases: Scalars['Int']['output'];
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
  waitingCases: Scalars['Int']['output'];
};

export enum CrmSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** A timeline entry to continue after: its time, kind and salesforceId as the entry returned it. */
export type CrmTimelineCursorInput = {
  at?: InputMaybe<Scalars['Datetime']['input']>;
  kind: CrmTimelineKind;
  salesforceId: Scalars['String']['input'];
};

export type CrmTimelineEntry = {
  __typename?: 'CrmTimelineEntry';
  actor?: Maybe<Scalars['String']['output']>;
  at?: Maybe<Scalars['Datetime']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  /** The email body was omitted by the retention policy. */
  bodyNotImported: Scalars['Boolean']['output'];
  caseId?: Maybe<Scalars['String']['output']>;
  caseTitle?: Maybe<Scalars['String']['output']>;
  counterpart?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  inbound?: Maybe<Scalars['Boolean']['output']>;
  kind: CrmTimelineKind;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  /** The phone system a call came from. */
  provider?: Maybe<CrmCallProvider>;
  recorded?: Maybe<Scalars['Boolean']['output']>;
  /** The entry's Salesforce id. A call made on the portal's phone (provider PLACETEL) has no Salesforce id, so it carries its PlacetelCall id, which addPlacetelCallNote takes as callId, not its portalCallId. */
  salesforceId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export enum CrmTimelineKind {
  Call = 'CALL',
  CaseOpened = 'CASE_OPENED',
  Comment = 'COMMENT',
  Email = 'EMAIL',
  StatusChange = 'STATUS_CHANGE'
}

/** One field of a record. */
export type CrmValue = {
  __typename?: 'CrmValue';
  key: Scalars['String']['output'];
  referenceObject?: Maybe<CrmObject>;
  referenceTitle?: Maybe<Scalars['String']['output']>;
  type: CrmFieldType;
  /** The value as text: ISO dates and timestamps, numbers as written, true or false, or the referenced Salesforce id. Null when empty or not readable in Salesforce. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `CustomActivity` values. */
export type CustomActivitiesConnection = {
  __typename?: 'CustomActivitiesConnection';
  /** A list of edges which contains the `CustomActivity` and cursor to aid in pagination. */
  edges: Array<CustomActivitiesEdge>;
  /** A list of `CustomActivity` objects. */
  nodes: Array<CustomActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomActivity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CustomActivity` edge in the connection. */
export type CustomActivitiesEdge = {
  __typename?: 'CustomActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CustomActivity` at the end of the edge. */
  node: CustomActivity;
};

/** Methods to use when ordering `CustomActivity`. */
export enum CustomActivitiesOrderBy {
  ActivityIdAsc = 'ACTIVITY_ID_ASC',
  ActivityIdDesc = 'ACTIVITY_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CustomActivity = Node & {
  __typename?: 'CustomActivity';
  /** Reads a single `Activity` that is related to this `CustomActivity`. */
  activity?: Maybe<Activity>;
  activityId: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `CustomActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CustomActivityCondition = {
  /** Checks for equality with the object’s `activityId` field. */
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The fields on `customActivity` to look up the row to connect. */
export type CustomActivityCustomActivityNameKeyConnect = {
  name: Scalars['String']['input'];
};

/** The fields on `customActivity` to look up the row to delete. */
export type CustomActivityCustomActivityNameKeyDelete = {
  name: Scalars['String']['input'];
};

/** The fields on `customActivity` to look up the row to connect. */
export type CustomActivityCustomActivityPkeyConnect = {
  activityId: Scalars['UUID']['input'];
};

/** The fields on `customActivity` to look up the row to delete. */
export type CustomActivityCustomActivityPkeyDelete = {
  activityId: Scalars['UUID']['input'];
};

/** The `activity` to be created by this mutation. */
export type CustomActivityFkeyActivityCreateInput = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: ActivityKind;
};

/** The `customActivity` to be created by this mutation. */
export type CustomActivityFkeyCustomActivityCreateInput = {
  activityToActivityId?: InputMaybe<CustomActivityFkeyInput>;
  name: Scalars['String']['input'];
};

/** Input for the nested mutation of `activity` in the `CustomActivityInput` mutation. */
export type CustomActivityFkeyInput = {
  /** The primary key(s) for `activity` for the far side of the relationship. */
  connectById?: InputMaybe<ActivityActivityPkeyConnect>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ActivityNodeIdConnect>;
  /** A `ActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<CustomActivityFkeyActivityCreateInput>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  deleteById?: InputMaybe<ActivityActivityPkeyDelete>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ActivityNodeIdDelete>;
  /** The primary key(s) and patch data for `activity` for the far side of the relationship. */
  updateById?: InputMaybe<ActivityOnCustomActivityForCustomActivityFkeyUsingActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `activity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<CustomActivityOnCustomActivityForCustomActivityFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `customActivity` in the `ActivityInput` mutation. */
export type CustomActivityFkeyInverseInput = {
  /** The primary key(s) for `customActivity` for the far side of the relationship. */
  connectByActivityId?: InputMaybe<CustomActivityCustomActivityPkeyConnect>;
  /** The primary key(s) for `customActivity` for the far side of the relationship. */
  connectByName?: InputMaybe<CustomActivityCustomActivityNameKeyConnect>;
  /** The primary key(s) for `customActivity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<CustomActivityNodeIdConnect>;
  /** A `CustomActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CustomActivityFkeyCustomActivityCreateInput>>;
  /** The primary key(s) for `customActivity` for the far side of the relationship. */
  deleteByActivityId?: InputMaybe<CustomActivityCustomActivityPkeyDelete>;
  /** The primary key(s) for `customActivity` for the far side of the relationship. */
  deleteByName?: InputMaybe<CustomActivityCustomActivityNameKeyDelete>;
  /** The primary key(s) for `customActivity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<CustomActivityNodeIdDelete>;
  /** Flag indicating whether all other `customActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `customActivity` for the far side of the relationship. */
  updateByActivityId?: InputMaybe<CustomActivityOnCustomActivityForCustomActivityFkeyUsingCustomActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `customActivity` for the far side of the relationship. */
  updateByName?: InputMaybe<CustomActivityOnCustomActivityForCustomActivityFkeyUsingCustomActivityNameKeyUpdate>;
  /** The primary key(s) and patch data for `customActivity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActivityOnCustomActivityForCustomActivityFkeyNodeIdUpdate>;
};

/** An input for mutations affecting `CustomActivity` */
export type CustomActivityInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityToActivityId?: InputMaybe<CustomActivityFkeyInput>;
  name: Scalars['String']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type CustomActivityNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `customActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type CustomActivityNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `customActivity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type CustomActivityOnCustomActivityForCustomActivityFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activity` being updated. */
  patch: ActivityPatch;
};

/** The fields on `customActivity` to look up the row to update. */
export type CustomActivityOnCustomActivityForCustomActivityFkeyUsingCustomActivityNameKeyUpdate = {
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `customActivity` being updated. */
  patch: UpdateCustomActivityOnCustomActivityForCustomActivityFkeyPatch;
};

/** The fields on `customActivity` to look up the row to update. */
export type CustomActivityOnCustomActivityForCustomActivityFkeyUsingCustomActivityPkeyUpdate = {
  activityId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `customActivity` being updated. */
  patch: UpdateCustomActivityOnCustomActivityForCustomActivityFkeyPatch;
};

/** Represents an update to a `CustomActivity`. Fields that are set will be updated. */
export type CustomActivityPatch = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityToActivityId?: InputMaybe<CustomActivityFkeyInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CustomActivitySessionInput = {
  activityKind: ActivityKind;
  beganAt: Scalars['Datetime']['input'];
  endedAt: Scalars['Datetime']['input'];
  name: Scalars['String']['input'];
  seniorProfileIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sessionId: Scalars['UUID']['input'];
  sessionKind: SessionKind;
};

export type Customer = {
  __typename?: 'Customer';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomerServiceAccountLicences = {
  __typename?: 'CustomerServiceAccountLicences';
  contacts: Array<AccountContact>;
  licences: Array<AccountLicence>;
  organization?: Maybe<AccountManagerOrganization>;
  salesforceAccountId: Scalars['String']['output'];
  unmatchedItems: Array<AccountLicenceCrmItem>;
};

/**
 * A Salesforce account's facility, the contacts who can be invited
 * to manage it, the invitations sent and the managers who registered. Only
 * B2B accounts in the crm copy are eligible; others come back empty.
 */
export type CustomerServiceAccountManagers = {
  __typename?: 'CustomerServiceAccountManagers';
  /** Whether the account provides ambulant care. */
  ambulant: Scalars['Boolean']['output'];
  contacts: Array<AccountContact>;
  eligible: Scalars['Boolean']['output'];
  invitations: Array<AccountManagerInvitation>;
  /** @deprecated Use contacts */
  licenseManagers: Array<AccountLicenseManager>;
  managers: Array<AccountManager>;
  organization?: Maybe<AccountManagerOrganization>;
  salesforceAccountId: Scalars['String']['output'];
};

/** A facility and the Salesforce account it is linked to, if any. */
export type CustomerServiceOrganizationAccount = {
  __typename?: 'CustomerServiceOrganizationAccount';
  organizationId: Scalars['UUID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceAccountName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `Daily` values. */
export type DailiesConnection = {
  __typename?: 'DailiesConnection';
  /** A list of edges which contains the `Daily` and cursor to aid in pagination. */
  edges: Array<DailiesEdge>;
  /** A list of `Daily` objects. */
  nodes: Array<Daily>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Daily` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Daily` edge in the connection. */
export type DailiesEdge = {
  __typename?: 'DailiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Daily` at the end of the edge. */
  node: Daily;
};

/** Methods to use when ordering `Daily`. */
export enum DailiesOrderBy {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Daily = Node & {
  __typename?: 'Daily';
  activeDevices: Scalars['Int']['output'];
  appId: Scalars['String']['output'];
  b2BSeniorsCreated: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  dau: Scalars['Int']['output'];
  mau: Scalars['Int']['output'];
  messagesSent: Scalars['Int']['output'];
  newUsersCreated: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  notesCreated: Scalars['Int']['output'];
  picturesSent: Scalars['Int']['output'];
};

/** A condition to be used against `Daily` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DailyCondition = {
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
};

/** Enum for tracking data sources across integrations and FHIR entities */
export enum DataSource {
  M4C = 'M4C',
  MedifoxDan = 'MEDIFOX_DAN',
  Mynerva = 'MYNERVA',
  Senso = 'SENSO',
  Vivendi = 'VIVENDI'
}

/** All input for the `deleteActivityByNodeId` mutation. */
export type DeleteActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Activity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteActivityGoalByNodeId` mutation. */
export type DeleteActivityGoalByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActivityGoal` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteActivityGoalByUserIdAndKind` mutation. */
export type DeleteActivityGoalByUserIdAndKindInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  kind: ActivityGoalEnum;
  userId: Scalars['UUID']['input'];
};

/** All input for the `deleteActivityGoal` mutation. */
export type DeleteActivityGoalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ActivityGoal` mutation. */
export type DeleteActivityGoalPayload = {
  __typename?: 'DeleteActivityGoalPayload';
  /** The `ActivityGoal` that was deleted by this mutation. */
  activityGoal?: Maybe<ActivityGoal>;
  /** An edge for our `ActivityGoal`. May be used by Relay 1. */
  activityGoalEdge?: Maybe<ActivityGoalsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedActivityGoalNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ActivityGoal`. */
  user?: Maybe<User>;
};


/** The output of our delete `ActivityGoal` mutation. */
export type DeleteActivityGoalPayloadActivityGoalEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivityGoalsOrderBy>>;
};

/** All input for the `deleteActivity` mutation. */
export type DeleteActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

export type DeleteActivityManualNoteInput = {
  seniorId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type DeleteActivityMdDocumentationInput = {
  seniorId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

/** All input for the `deleteActivityParticipantByActivitySessionIdAndSeniorId` mutation. */
export type DeleteActivityParticipantByActivitySessionIdAndSeniorIdInput = {
  activitySessionId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  seniorId: Scalars['UUID']['input'];
};

/** All input for the `deleteActivityParticipantByNodeId` mutation. */
export type DeleteActivityParticipantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActivityParticipant` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteActivityParticipant` mutation. */
export type DeleteActivityParticipantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ActivityParticipant` mutation. */
export type DeleteActivityParticipantPayload = {
  __typename?: 'DeleteActivityParticipantPayload';
  /** The `ActivityParticipant` that was deleted by this mutation. */
  activityParticipant?: Maybe<ActivityParticipant>;
  /** An edge for our `ActivityParticipant`. May be used by Relay 1. */
  activityParticipantEdge?: Maybe<ActivityParticipantsEdge>;
  /** Reads a single `ActivitySession` that is related to this `ActivityParticipant`. */
  activitySession?: Maybe<ActivitySession>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedActivityParticipantNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ActivityParticipant`. */
  senior?: Maybe<User>;
};


/** The output of our delete `ActivityParticipant` mutation. */
export type DeleteActivityParticipantPayloadActivityParticipantEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivityParticipantsOrderBy>>;
};

/** The output of our delete `Activity` mutation. */
export type DeleteActivityPayload = {
  __typename?: 'DeleteActivityPayload';
  /** The `Activity` that was deleted by this mutation. */
  activity?: Maybe<Activity>;
  /** An edge for our `Activity`. May be used by Relay 1. */
  activityEdge?: Maybe<ActivitiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedActivityNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Activity` mutation. */
export type DeleteActivityPayloadActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivitiesOrderBy>>;
};

/** All input for the `deleteActivitySessionByNodeId` mutation. */
export type DeleteActivitySessionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActivitySession` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteActivitySession` mutation. */
export type DeleteActivitySessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ActivitySession` mutation. */
export type DeleteActivitySessionPayload = {
  __typename?: 'DeleteActivitySessionPayload';
  /** Reads a single `Activity` that is related to this `ActivitySession`. */
  activity?: Maybe<Activity>;
  /** The `ActivitySession` that was deleted by this mutation. */
  activitySession?: Maybe<ActivitySession>;
  /** An edge for our `ActivitySession`. May be used by Relay 1. */
  activitySessionEdge?: Maybe<ActivitySessionsEdge>;
  /** Reads a single `User` that is related to this `ActivitySession`. */
  caregiver?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedActivitySessionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Procedure` that is related to this `ActivitySession`. */
  procedure?: Maybe<Procedure>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ActivitySession` mutation. */
export type DeleteActivitySessionPayloadActivitySessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};

/** All input for the `deleteAlbumMediaByMediaIdAndAlbumId` mutation. */
export type DeleteAlbumMediaByMediaIdAndAlbumIdInput = {
  albumId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mediaId: Scalars['UUID']['input'];
};

/** All input for the `deleteAlbumMediaByNodeId` mutation. */
export type DeleteAlbumMediaByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AlbumMedia` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteAlbumMedia` mutation. */
export type DeleteAlbumMediaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `AlbumMedia` mutation. */
export type DeleteAlbumMediaPayload = {
  __typename?: 'DeleteAlbumMediaPayload';
  /** Reads a single `MediaAlbum` that is related to this `AlbumMedia`. */
  album?: Maybe<MediaAlbum>;
  /** The `AlbumMedia` that was deleted by this mutation. */
  albumMedia?: Maybe<AlbumMedia>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAlbumMediaNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Media` that is related to this `AlbumMedia`. */
  media?: Maybe<Media>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteAppSettingByNodeId` mutation. */
export type DeleteAppSettingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AppSetting` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteAppSettingByUserIdAndSettingType` mutation. */
export type DeleteAppSettingByUserIdAndSettingTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  settingType: AppSettingEnum;
  userId: Scalars['UUID']['input'];
};

/** All input for the `deleteAppSetting` mutation. */
export type DeleteAppSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `AppSetting` mutation. */
export type DeleteAppSettingPayload = {
  __typename?: 'DeleteAppSettingPayload';
  /** The `AppSetting` that was deleted by this mutation. */
  appSetting?: Maybe<AppSetting>;
  /** An edge for our `AppSetting`. May be used by Relay 1. */
  appSettingEdge?: Maybe<AppSettingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAppSettingNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `AppSetting`. */
  user?: Maybe<User>;
};


/** The output of our delete `AppSetting` mutation. */
export type DeleteAppSettingPayloadAppSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<AppSettingsOrderBy>>;
};

/** All input for the `deleteAttachmentByNodeId` mutation. */
export type DeleteAttachmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Attachment` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteAttachment` mutation. */
export type DeleteAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Attachment` mutation. */
export type DeleteAttachmentPayload = {
  __typename?: 'DeleteAttachmentPayload';
  /** The `Attachment` that was deleted by this mutation. */
  attachment?: Maybe<Attachment>;
  /** An edge for our `Attachment`. May be used by Relay 1. */
  attachmentEdge?: Maybe<AttachmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAttachmentNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Media` that is related to this `Attachment`. */
  media?: Maybe<Media>;
  /** Reads a single `Message` that is related to this `Attachment`. */
  message?: Maybe<Message>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Attachment` mutation. */
export type DeleteAttachmentPayloadAttachmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AttachmentsOrderBy>>;
};

/** All input for the `deleteCaregiverSeniorByNodeId` mutation. */
export type DeleteCaregiverSeniorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CaregiverSenior` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCaregiverSenior` mutation. */
export type DeleteCaregiverSeniorInput = {
  caregiverId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  seniorId: Scalars['UUID']['input'];
};

/** The output of our delete `CaregiverSenior` mutation. */
export type DeleteCaregiverSeniorPayload = {
  __typename?: 'DeleteCaregiverSeniorPayload';
  /** Reads a single `User` that is related to this `CaregiverSenior`. */
  caregiver?: Maybe<User>;
  /** The `CaregiverSenior` that was deleted by this mutation. */
  caregiverSenior?: Maybe<CaregiverSenior>;
  /** An edge for our `CaregiverSenior`. May be used by Relay 1. */
  caregiverSeniorEdge?: Maybe<CaregiverSeniorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCaregiverSeniorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CaregiverSenior`. */
  senior?: Maybe<User>;
};


/** The output of our delete `CaregiverSenior` mutation. */
export type DeleteCaregiverSeniorPayloadCaregiverSeniorEdgeArgs = {
  orderBy?: InputMaybe<Array<CaregiverSeniorsOrderBy>>;
};

/** All input for the `deleteCheckInMessageByNodeId` mutation. */
export type DeleteCheckInMessageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CheckInMessage` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCheckInMessage` mutation. */
export type DeleteCheckInMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `CheckInMessage` mutation. */
export type DeleteCheckInMessagePayload = {
  __typename?: 'DeleteCheckInMessagePayload';
  /** Reads a single `User` that is related to this `CheckInMessage`. */
  author?: Maybe<User>;
  /** Reads a single `CheckIn` that is related to this `CheckInMessage`. */
  checkIn?: Maybe<CheckIn>;
  /** The `CheckInMessage` that was deleted by this mutation. */
  checkInMessage?: Maybe<CheckInMessage>;
  /** An edge for our `CheckInMessage`. May be used by Relay 1. */
  checkInMessageEdge?: Maybe<CheckInMessagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCheckInMessageNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CheckInMessage` mutation. */
export type DeleteCheckInMessagePayloadCheckInMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};

/** All input for the `deleteContentActivityByContentId` mutation. */
export type DeleteContentActivityByContentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['UUID']['input'];
};

/** All input for the `deleteContentActivityByNodeId` mutation. */
export type DeleteContentActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ContentActivity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteContentActivity` mutation. */
export type DeleteContentActivityInput = {
  activityId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our delete `ContentActivity` mutation. */
export type DeleteContentActivityPayload = {
  __typename?: 'DeleteContentActivityPayload';
  /** Reads a single `Activity` that is related to this `ContentActivity`. */
  activity?: Maybe<Activity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `ContentActivity`. */
  content?: Maybe<Content>;
  /** The `ContentActivity` that was deleted by this mutation. */
  contentActivity?: Maybe<ContentActivity>;
  /** An edge for our `ContentActivity`. May be used by Relay 1. */
  contentActivityEdge?: Maybe<ContentActivitiesEdge>;
  deletedContentActivityNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ContentActivity` mutation. */
export type DeleteContentActivityPayloadContentActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<ContentActivitiesOrderBy>>;
};

/** All input for the `deleteContentMetaTagByContentIdAndMetaTagId` mutation. */
export type DeleteContentMetaTagByContentIdAndMetaTagIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['UUID']['input'];
  metaTagId: Scalars['UUID']['input'];
};

/** All input for the `deleteContentMetaTagByNodeId` mutation. */
export type DeleteContentMetaTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ContentMetaTag` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteContentMetaTag` mutation. */
export type DeleteContentMetaTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ContentMetaTag` mutation. */
export type DeleteContentMetaTagPayload = {
  __typename?: 'DeleteContentMetaTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `ContentMetaTag`. */
  content?: Maybe<Content>;
  /** The `ContentMetaTag` that was deleted by this mutation. */
  contentMetaTag?: Maybe<ContentMetaTag>;
  /** An edge for our `ContentMetaTag`. May be used by Relay 1. */
  contentMetaTagEdge?: Maybe<ContentMetaTagsEdge>;
  deletedContentMetaTagNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `MetaTag` that is related to this `ContentMetaTag`. */
  metaTag?: Maybe<MetaTag>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ContentMetaTag` mutation. */
export type DeleteContentMetaTagPayloadContentMetaTagEdgeArgs = {
  orderBy?: InputMaybe<Array<ContentMetaTagsOrderBy>>;
};

/** All input for the `deleteCustomActivityByName` mutation. */
export type DeleteCustomActivityByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** All input for the `deleteCustomActivityByNodeId` mutation. */
export type DeleteCustomActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CustomActivity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCustomActivity` mutation. */
export type DeleteCustomActivityInput = {
  activityId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our delete `CustomActivity` mutation. */
export type DeleteCustomActivityPayload = {
  __typename?: 'DeleteCustomActivityPayload';
  /** Reads a single `Activity` that is related to this `CustomActivity`. */
  activity?: Maybe<Activity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CustomActivity` that was deleted by this mutation. */
  customActivity?: Maybe<CustomActivity>;
  /** An edge for our `CustomActivity`. May be used by Relay 1. */
  customActivityEdge?: Maybe<CustomActivitiesEdge>;
  deletedCustomActivityNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CustomActivity` mutation. */
export type DeleteCustomActivityPayloadCustomActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomActivitiesOrderBy>>;
};

/** All input for the `deleteDeviceByNodeId` mutation. */
export type DeleteDeviceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Device` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteDevice` mutation. */
export type DeleteDeviceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Device` mutation. */
export type DeleteDevicePayload = {
  __typename?: 'DeleteDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDeviceNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Device` that was deleted by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Reads a single `Location` that is related to this `Device`. */
  location?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Device`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Device` mutation. */
export type DeleteDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** All input for the `deleteFamilyMemberSeniorByNodeId` mutation. */
export type DeleteFamilyMemberSeniorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `FamilyMemberSenior` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteFamilyMemberSenior` mutation. */
export type DeleteFamilyMemberSeniorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  familyMemberId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};

/** The output of our delete `FamilyMemberSenior` mutation. */
export type DeleteFamilyMemberSeniorPayload = {
  __typename?: 'DeleteFamilyMemberSeniorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFamilyMemberSeniorNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `User` that is related to this `FamilyMemberSenior`. */
  familyMember?: Maybe<User>;
  /** The `FamilyMemberSenior` that was deleted by this mutation. */
  familyMemberSenior?: Maybe<FamilyMemberSenior>;
  /** An edge for our `FamilyMemberSenior`. May be used by Relay 1. */
  familyMemberSeniorEdge?: Maybe<FamilyMemberSeniorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FamilyMemberSenior`. */
  senior?: Maybe<User>;
};


/** The output of our delete `FamilyMemberSenior` mutation. */
export type DeleteFamilyMemberSeniorPayloadFamilyMemberSeniorEdgeArgs = {
  orderBy?: InputMaybe<Array<FamilyMemberSeniorsOrderBy>>;
};

/** All input for the `deleteFeatureActivityByKind` mutation. */
export type DeleteFeatureActivityByKindInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  kind: FeatureActivityKind;
};

/** All input for the `deleteFeatureActivityByNodeId` mutation. */
export type DeleteFeatureActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `FeatureActivity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteFeatureActivity` mutation. */
export type DeleteFeatureActivityInput = {
  activityId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our delete `FeatureActivity` mutation. */
export type DeleteFeatureActivityPayload = {
  __typename?: 'DeleteFeatureActivityPayload';
  /** Reads a single `Activity` that is related to this `FeatureActivity`. */
  activity?: Maybe<Activity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFeatureActivityNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `FeatureActivity` that was deleted by this mutation. */
  featureActivity?: Maybe<FeatureActivity>;
  /** An edge for our `FeatureActivity`. May be used by Relay 1. */
  featureActivityEdge?: Maybe<FeatureActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FeatureActivity` mutation. */
export type DeleteFeatureActivityPayloadFeatureActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureActivitiesOrderBy>>;
};

/** All input for the `deleteFeedbackByNodeId` mutation. */
export type DeleteFeedbackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Feedback` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteFeedback` mutation. */
export type DeleteFeedbackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `Feedback` mutation. */
export type DeleteFeedbackPayload = {
  __typename?: 'DeleteFeedbackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFeedbackNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Feedback` that was deleted by this mutation. */
  feedback?: Maybe<Feedback>;
  /** An edge for our `Feedback`. May be used by Relay 1. */
  feedbackEdge?: Maybe<FeedbacksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Feedback`. */
  user?: Maybe<User>;
};


/** The output of our delete `Feedback` mutation. */
export type DeleteFeedbackPayloadFeedbackEdgeArgs = {
  orderBy?: InputMaybe<Array<FeedbacksOrderBy>>;
};

/** All input for the `deleteHandshakeCodeByCode` mutation. */
export type DeleteHandshakeCodeByCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
};

/** All input for the `deleteHandshakeCodeByNodeId` mutation. */
export type DeleteHandshakeCodeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `HandshakeCode` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteHandshakeCodeByWorkgroupIdAndInitiatorId` mutation. */
export type DeleteHandshakeCodeByWorkgroupIdAndInitiatorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  initiatorId: Scalars['UUID']['input'];
  workgroupId: Scalars['UUID']['input'];
};

/** All input for the `deleteHandshakeCode` mutation. */
export type DeleteHandshakeCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `HandshakeCode` mutation. */
export type DeleteHandshakeCodePayload = {
  __typename?: 'DeleteHandshakeCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedHandshakeCodeNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `HandshakeCode` that was deleted by this mutation. */
  handshakeCode?: Maybe<HandshakeCode>;
  /** An edge for our `HandshakeCode`. May be used by Relay 1. */
  handshakeCodeEdge?: Maybe<HandshakeCodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workgroup` that is related to this `HandshakeCode`. */
  workgroup?: Maybe<Workgroup>;
};


/** The output of our delete `HandshakeCode` mutation. */
export type DeleteHandshakeCodePayloadHandshakeCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<HandshakeCodesOrderBy>>;
};

/** All input for the `deleteInvitationByNodeId` mutation. */
export type DeleteInvitationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Invitation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteInvitation` mutation. */
export type DeleteInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Invitation` mutation. */
export type DeleteInvitationPayload = {
  __typename?: 'DeleteInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedInvitationNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Group` that is related to this `Invitation`. */
  groupByInvitedTo?: Maybe<Group>;
  /** The `Invitation` that was deleted by this mutation. */
  invitation?: Maybe<Invitation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Invitation`. */
  userByInvitedBy?: Maybe<User>;
};

/** All input for the `deleteLocationByNodeId` mutation. */
export type DeleteLocationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Location` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteLocationBySourceSystemAndExternalIdAndTypeAndOrganizationId` mutation. */
export type DeleteLocationBySourceSystemAndExternalIdAndTypeAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
};

/** All input for the `deleteLocation` mutation. */
export type DeleteLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Location` mutation. */
export type DeleteLocationPayload = {
  __typename?: 'DeleteLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLocationNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Location` that was deleted by this mutation. */
  location?: Maybe<Location>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge?: Maybe<LocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Location` that is related to this `Location`. */
  partOf?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Location` mutation. */
export type DeleteLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

export type DeleteMediaAlbumInput = {
  albumId: Scalars['UUID']['input'];
  deleteMedia: Scalars['Boolean']['input'];
};

/** All input for the `deleteMediaByNodeId` mutation. */
export type DeleteMediaByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Media` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

export type DeleteMediaInAlbumsInput = {
  mediaItemIds: Array<Scalars['UUID']['input']>;
};

/** All input for the `deleteMedia` mutation. */
export type DeleteMediaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** All input for the `deleteMediaNoteByNodeId` mutation. */
export type DeleteMediaNoteByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `MediaNote` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteMediaNote` mutation. */
export type DeleteMediaNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `MediaNote` mutation. */
export type DeleteMediaNotePayload = {
  __typename?: 'DeleteMediaNotePayload';
  /** Reads a single `User` that is related to this `MediaNote`. */
  author?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMediaNoteNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Media` that is related to this `MediaNote`. */
  media?: Maybe<Media>;
  /** The `MediaNote` that was deleted by this mutation. */
  mediaNote?: Maybe<MediaNote>;
  /** An edge for our `MediaNote`. May be used by Relay 1. */
  mediaNoteEdge?: Maybe<MediaNotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `MediaNote` mutation. */
export type DeleteMediaNotePayloadMediaNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaNotesOrderBy>>;
};

/** The output of our delete `Media` mutation. */
export type DeleteMediaPayload = {
  __typename?: 'DeleteMediaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMediaNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Media` that was deleted by this mutation. */
  media?: Maybe<Media>;
  /** An edge for our `Media`. May be used by Relay 1. */
  mediaEdge?: Maybe<MediaEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Media` mutation. */
export type DeleteMediaPayloadMediaEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};

/** All input for the `deleteMediaVoiceRecordingByNodeId` mutation. */
export type DeleteMediaVoiceRecordingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `MediaVoiceRecording` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteMediaVoiceRecording` mutation. */
export type DeleteMediaVoiceRecordingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `MediaVoiceRecording` mutation. */
export type DeleteMediaVoiceRecordingPayload = {
  __typename?: 'DeleteMediaVoiceRecordingPayload';
  /** Reads a single `User` that is related to this `MediaVoiceRecording`. */
  author?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMediaVoiceRecordingNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Media` that is related to this `MediaVoiceRecording`. */
  media?: Maybe<Media>;
  /** The `MediaVoiceRecording` that was deleted by this mutation. */
  mediaVoiceRecording?: Maybe<MediaVoiceRecording>;
  /** An edge for our `MediaVoiceRecording`. May be used by Relay 1. */
  mediaVoiceRecordingEdge?: Maybe<MediaVoiceRecordingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Media` that is related to this `MediaVoiceRecording`. */
  voiceRecording?: Maybe<Media>;
};


/** The output of our delete `MediaVoiceRecording` mutation. */
export type DeleteMediaVoiceRecordingPayloadMediaVoiceRecordingEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaVoiceRecordingsOrderBy>>;
};

/** All input for the `deleteMessageByNodeId` mutation. */
export type DeleteMessageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Message` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteMessage` mutation. */
export type DeleteMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Message` mutation. */
export type DeleteMessagePayload = {
  __typename?: 'DeleteMessagePayload';
  /** Reads a single `User` that is related to this `Message`. */
  author?: Maybe<User>;
  /** Reads a single `Group` that is related to this `Message`. */
  chat?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMessageNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Message` that was deleted by this mutation. */
  message?: Maybe<Message>;
  /** An edge for our `Message`. May be used by Relay 1. */
  messageEdge?: Maybe<MessagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Message` mutation. */
export type DeleteMessagePayloadMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};

export type DeleteMessageSubscriptionPayload = {
  __typename?: 'DeleteMessageSubscriptionPayload';
  chatId: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
};

/** All input for the `deleteNoteByNodeId` mutation. */
export type DeleteNoteByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Note` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteNote` mutation. */
export type DeleteNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Note` mutation. */
export type DeleteNotePayload = {
  __typename?: 'DeleteNotePayload';
  /** Reads a single `User` that is related to this `Note`. */
  author?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedNoteNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Note` that was deleted by this mutation. */
  note?: Maybe<Note>;
  /** An edge for our `Note`. May be used by Relay 1. */
  noteEdge?: Maybe<NotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Note` mutation. */
export type DeleteNotePayloadNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};

/** All input for the `deleteProcedureByNodeId` mutation. */
export type DeleteProcedureByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Procedure` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteProcedureBySourceSystemAndExternalIdAndOrganizationId` mutation. */
export type DeleteProcedureBySourceSystemAndExternalIdAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

export type DeleteProcedureDocumentationNoteInput = {
  kind: ProcedureDocumentationNoteKind;
  procedureId: Scalars['UUID']['input'];
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
};

/** All input for the `deleteProcedure` mutation. */
export type DeleteProcedureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** All input for the `deleteProcedureParticipantByNodeId` mutation. */
export type DeleteProcedureParticipantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ProcedureParticipant` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteProcedureParticipant` mutation. */
export type DeleteProcedureParticipantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reference to a participating patient */
  patientId: Scalars['UUID']['input'];
  /** Reference to the procedure */
  procedureId: Scalars['UUID']['input'];
};

/** The output of our delete `ProcedureParticipant` mutation. */
export type DeleteProcedureParticipantPayload = {
  __typename?: 'DeleteProcedureParticipantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedProcedureParticipantNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Patient` that is related to this `ProcedureParticipant`. */
  patient?: Maybe<Patient>;
  /** Reads a single `Procedure` that is related to this `ProcedureParticipant`. */
  procedure?: Maybe<Procedure>;
  /** The `ProcedureParticipant` that was deleted by this mutation. */
  procedureParticipant?: Maybe<ProcedureParticipant>;
  /** An edge for our `ProcedureParticipant`. May be used by Relay 1. */
  procedureParticipantEdge?: Maybe<ProcedureParticipantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ProcedureParticipant` mutation. */
export type DeleteProcedureParticipantPayloadProcedureParticipantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcedureParticipantsOrderBy>>;
};

/** The output of our delete `Procedure` mutation. */
export type DeleteProcedurePayload = {
  __typename?: 'DeleteProcedurePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedProcedureNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `Procedure`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Practitioner` that is related to this `Procedure`. */
  performer?: Maybe<Practitioner>;
  /** The `Procedure` that was deleted by this mutation. */
  procedure?: Maybe<Procedure>;
  /** An edge for our `Procedure`. May be used by Relay 1. */
  procedureEdge?: Maybe<ProceduresEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Procedure` mutation. */
export type DeleteProcedurePayloadProcedureEdgeArgs = {
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};

/** All input for the `deleteUserByNodeId` mutation. */
export type DeleteUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUserContentActivityByNodeId` mutation. */
export type DeleteUserContentActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserContentActivity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUserContentActivity` mutation. */
export type DeleteUserContentActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `UserContentActivity` mutation. */
export type DeleteUserContentActivityPayload = {
  __typename?: 'DeleteUserContentActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `UserContentActivity`. */
  content?: Maybe<Content>;
  deletedUserContentActivityNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserContentActivity`. */
  seniorProfile?: Maybe<User>;
  /** Reads a single `User` that is related to this `UserContentActivity`. */
  user?: Maybe<User>;
  /** The `UserContentActivity` that was deleted by this mutation. */
  userContentActivity?: Maybe<UserContentActivity>;
  /** An edge for our `UserContentActivity`. May be used by Relay 1. */
  userContentActivityEdge?: Maybe<UserContentActivitiesEdge>;
};


/** The output of our delete `UserContentActivity` mutation. */
export type DeleteUserContentActivityPayloadUserContentActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};

/** All input for the `deleteUserContentFavoriteByNodeId` mutation. */
export type DeleteUserContentFavoriteByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserContentFavorite` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUserContentFavoriteByUserIdAndContentId` mutation. */
export type DeleteUserContentFavoriteByUserIdAndContentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

/** All input for the `deleteUserContentFavorite` mutation. */
export type DeleteUserContentFavoriteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `UserContentFavorite` mutation. */
export type DeleteUserContentFavoritePayload = {
  __typename?: 'DeleteUserContentFavoritePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `UserContentFavorite`. */
  content?: Maybe<Content>;
  deletedUserContentFavoriteNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserContentFavorite`. */
  user?: Maybe<User>;
  /** The `UserContentFavorite` that was deleted by this mutation. */
  userContentFavorite?: Maybe<UserContentFavorite>;
  /** An edge for our `UserContentFavorite`. May be used by Relay 1. */
  userContentFavoriteEdge?: Maybe<UserContentFavoritesEdge>;
};


/** The output of our delete `UserContentFavorite` mutation. */
export type DeleteUserContentFavoritePayloadUserContentFavoriteEdgeArgs = {
  orderBy?: InputMaybe<Array<UserContentFavoritesOrderBy>>;
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Media` that is related to this `User`. */
  mediaByAvatar?: Maybe<Media>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUserSettingByNodeId` mutation. */
export type DeleteUserSettingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserSetting` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUserSetting` mutation. */
export type DeleteUserSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};

/** The output of our delete `UserSetting` mutation. */
export type DeleteUserSettingPayload = {
  __typename?: 'DeleteUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserSettingNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  user?: Maybe<User>;
  /** The `UserSetting` that was deleted by this mutation. */
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our delete `UserSetting` mutation. */
export type DeleteUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

/** All input for the `deleteWebsiteByNodeId` mutation. */
export type DeleteWebsiteByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Website` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteWebsite` mutation. */
export type DeleteWebsiteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `Website` mutation. */
export type DeleteWebsitePayload = {
  __typename?: 'DeleteWebsitePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWebsiteNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Website`. */
  user?: Maybe<User>;
  /** The `Website` that was deleted by this mutation. */
  website?: Maybe<Website>;
  /** An edge for our `Website`. May be used by Relay 1. */
  websiteEdge?: Maybe<WebsitesEdge>;
};


/** The output of our delete `Website` mutation. */
export type DeleteWebsitePayloadWebsiteEdgeArgs = {
  orderBy?: InputMaybe<Array<WebsitesOrderBy>>;
};

/** All input for the `deleteWorkgroupByNodeId` mutation. */
export type DeleteWorkgroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Workgroup` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteWorkgroup` mutation. */
export type DeleteWorkgroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** All input for the `deleteWorkgroupMembershipByNodeId` mutation. */
export type DeleteWorkgroupMembershipByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WorkgroupMembership` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteWorkgroupMembership` mutation. */
export type DeleteWorkgroupMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['UUID']['input'];
  workgroupId: Scalars['UUID']['input'];
};

/** The output of our delete `WorkgroupMembership` mutation. */
export type DeleteWorkgroupMembershipPayload = {
  __typename?: 'DeleteWorkgroupMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWorkgroupMembershipNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `User` that is related to this `WorkgroupMembership`. */
  member?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workgroup` that is related to this `WorkgroupMembership`. */
  workgroup?: Maybe<Workgroup>;
  /** The `WorkgroupMembership` that was deleted by this mutation. */
  workgroupMembership?: Maybe<WorkgroupMembership>;
  /** An edge for our `WorkgroupMembership`. May be used by Relay 1. */
  workgroupMembershipEdge?: Maybe<WorkgroupMembershipsEdge>;
};


/** The output of our delete `WorkgroupMembership` mutation. */
export type DeleteWorkgroupMembershipPayloadWorkgroupMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkgroupMembershipsOrderBy>>;
};

/** The output of our delete `Workgroup` mutation. */
export type DeleteWorkgroupPayload = {
  __typename?: 'DeleteWorkgroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWorkgroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workgroup` that was deleted by this mutation. */
  workgroup?: Maybe<Workgroup>;
  /** An edge for our `Workgroup`. May be used by Relay 1. */
  workgroupEdge?: Maybe<WorkgroupsEdge>;
};


/** The output of our delete `Workgroup` mutation. */
export type DeleteWorkgroupPayloadWorkgroupEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkgroupsOrderBy>>;
};

/** All input for the `deregisterPushNotificationDevice` mutation. */
export type DeregisterPushNotificationDeviceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `deregisterPushNotificationDevice` mutation. */
export type DeregisterPushNotificationDevicePayload = {
  __typename?: 'DeregisterPushNotificationDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Device = Node & {
  __typename?: 'Device';
  appPackageId?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  contentVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  deviceId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `Location` that is related to this `Device`. */
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['UUID']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Device`. */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['UUID']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /** Terminal enrollment timestamp. Once set, the device is permanently unenrolled and retained only as historical enrollment data. */
  unenrolledAt?: Maybe<Scalars['Datetime']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/** A condition to be used against `Device` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DeviceCondition = {
  /** Filters devices by enrollment status. */
  enrollmentStatus?: InputMaybe<DeviceEnrollmentStatus>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `unenrolledAt` field. */
  unenrolledAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The fields on `device` to look up the row to connect. */
export type DeviceDevicePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `device` to look up the row to delete. */
export type DeviceDevicePkeyDelete = {
  id: Scalars['UUID']['input'];
};

export type DeviceEnrollmentActor = {
  __typename?: 'DeviceEnrollmentActor';
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DeviceEnrollmentDeviceInput = {
  appPackageId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  contentVersion?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  osVersion?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceEnrollmentEmailDelivery = {
  __typename?: 'DeviceEnrollmentEmailDelivery';
  failedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  queuedAt: Scalars['Datetime']['output'];
  recipientEmail: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['Datetime']['output']>;
  sentBy?: Maybe<DeviceEnrollmentActor>;
  status: DeviceEnrollmentEmailDeliveryStatus;
};

export enum DeviceEnrollmentEmailDeliveryStatus {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Sent = 'SENT'
}

export type DeviceEnrollmentLocation = {
  __typename?: 'DeviceEnrollmentLocation';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  type: LocationTypeEnum;
};

export type DeviceEnrollmentOrganization = {
  __typename?: 'DeviceEnrollmentOrganization';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/**
 * One consumed use of a token. It outlives the device it enrolled and the
 * location it targeted, so both are null once that row was deleted.
 */
export type DeviceEnrollmentRedemption = {
  __typename?: 'DeviceEnrollmentRedemption';
  device?: Maybe<DeviceEnrollmentRedemptionDevice>;
  id: Scalars['UUID']['output'];
  redeemedAt: Scalars['Datetime']['output'];
  targetLocation?: Maybe<DeviceEnrollmentLocation>;
};

export type DeviceEnrollmentRedemptionDevice = {
  __typename?: 'DeviceEnrollmentRedemptionDevice';
  deviceId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type DeviceEnrollmentResponse = {
  __typename?: 'DeviceEnrollmentResponse';
  deviceId: Scalars['UUID']['output'];
  deviceToken: Scalars['String']['output'];
  locationId: Scalars['UUID']['output'];
  organizationId: Scalars['UUID']['output'];
};

export enum DeviceEnrollmentScopeType {
  Department = 'DEPARTMENT',
  Organization = 'ORGANIZATION',
  Site = 'SITE',
  Ward = 'WARD'
}

export enum DeviceEnrollmentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unenrolled = 'UNENROLLED'
}

export type DeviceEnrollmentTarget = {
  __typename?: 'DeviceEnrollmentTarget';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  type: DeviceEnrollmentTargetType;
};

export enum DeviceEnrollmentTargetType {
  Department = 'DEPARTMENT',
  Organization = 'ORGANIZATION',
  Site = 'SITE',
  Ward = 'WARD'
}

export type DeviceEnrollmentToken = {
  __typename?: 'DeviceEnrollmentToken';
  /**
   * The typed code, available only through the single-token query while ACTIVE
   * to the organization's manager or staff who manage device enrollment.
   * Always null in summaries.
   */
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<DeviceEnrollmentActor>;
  emailDeliveries: Array<DeviceEnrollmentEmailDelivery>;
  expiresAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  implicit: Scalars['Boolean']['output'];
  maxUses?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['UUID']['output'];
  /** The payload the tablet scans, readable under the same rule as code. */
  qrPayload?: Maybe<Scalars['String']['output']>;
  redemptions: Array<DeviceEnrollmentRedemption>;
  revokedAt?: Maybe<Scalars['Datetime']['output']>;
  scopeLocation?: Maybe<DeviceEnrollmentLocation>;
  scopeType: DeviceEnrollmentScopeType;
  status: DeviceEnrollmentTokenStatus;
  useCount: Scalars['Int']['output'];
};

export enum DeviceEnrollmentTokenStatus {
  Active = 'ACTIVE',
  Exhausted = 'EXHAUSTED',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
  ScopeInvalid = 'SCOPE_INVALID'
}

/** An input for mutations affecting `Device` */
export type DeviceInput = {
  appPackageId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  contentVersion?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<DeviceLocationIdFkeyInput>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<DeviceOrganizationIdFkeyInput>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The `device` to be created by this mutation. */
export type DeviceLocationIdFkeyDeviceCreateInput = {
  appPackageId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  contentVersion?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<DeviceLocationIdFkeyInput>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<DeviceOrganizationIdFkeyInput>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Input for the nested mutation of `location` in the `DeviceInput` mutation. */
export type DeviceLocationIdFkeyInput = {
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectById?: InputMaybe<LocationLocationPkeyConnect>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<LocationNodeIdConnect>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationUqLocationExternalIdConnect>;
  /** A `LocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<DeviceLocationIdFkeyLocationCreateInput>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteById?: InputMaybe<LocationLocationPkeyDelete>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<LocationNodeIdDelete>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationUqLocationExternalIdDelete>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateById?: InputMaybe<LocationOnDeviceForDeviceLocationIdFkeyUsingLocationPkeyUpdate>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DeviceOnDeviceForDeviceLocationIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationOnDeviceForDeviceLocationIdFkeyUsingUqLocationExternalIdUpdate>;
};

/** Input for the nested mutation of `device` in the `LocationInput` mutation. */
export type DeviceLocationIdFkeyInverseInput = {
  /** The primary key(s) for `device` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DeviceDevicePkeyConnect>>;
  /** The primary key(s) for `device` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DeviceNodeIdConnect>>;
  /** A `DeviceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DeviceLocationIdFkeyDeviceCreateInput>>;
  /** The primary key(s) for `device` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<DeviceDevicePkeyDelete>>;
  /** The primary key(s) for `device` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<DeviceNodeIdDelete>>;
  /** Flag indicating whether all other `device` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `device` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DeviceOnDeviceForDeviceLocationIdFkeyUsingDevicePkeyUpdate>>;
  /** The primary key(s) and patch data for `device` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<LocationOnDeviceForDeviceLocationIdFkeyNodeIdUpdate>>;
};

/** The `location` to be created by this mutation. */
export type DeviceLocationIdFkeyLocationCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type DeviceNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `device` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type DeviceNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `device` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type DeviceOnDeviceForDeviceLocationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `location` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: LocationPatch;
};

/** The fields on `device` to look up the row to update. */
export type DeviceOnDeviceForDeviceLocationIdFkeyUsingDevicePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `device` being updated. */
  patch: UpdateDeviceOnDeviceForDeviceLocationIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type DeviceOnDeviceForDeviceOrganizationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organization` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: OrganizationPatch;
};

/** The fields on `device` to look up the row to update. */
export type DeviceOnDeviceForDeviceOrganizationIdFkeyUsingDevicePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `device` being updated. */
  patch: UpdateDeviceOnDeviceForDeviceOrganizationIdFkeyPatch;
};

/** The `device` to be created by this mutation. */
export type DeviceOrganizationIdFkeyDeviceCreateInput = {
  appPackageId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  contentVersion?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<DeviceLocationIdFkeyInput>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationToOrganizationId?: InputMaybe<DeviceOrganizationIdFkeyInput>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Input for the nested mutation of `organization` in the `DeviceInput` mutation. */
export type DeviceOrganizationIdFkeyInput = {
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByExternalId?: InputMaybe<OrganizationOrganizationExternalIdKeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectById?: InputMaybe<OrganizationOrganizationPkeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrganizationNodeIdConnect>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByExternalId?: InputMaybe<OrganizationOnDeviceForDeviceOrganizationIdFkeyUsingOrganizationExternalIdKeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateById?: InputMaybe<OrganizationOnDeviceForDeviceOrganizationIdFkeyUsingOrganizationPkeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DeviceOnDeviceForDeviceOrganizationIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `device` in the `OrganizationInput` mutation. */
export type DeviceOrganizationIdFkeyInverseInput = {
  /** The primary key(s) for `device` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DeviceDevicePkeyConnect>>;
  /** The primary key(s) for `device` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DeviceNodeIdConnect>>;
  /** A `DeviceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DeviceOrganizationIdFkeyDeviceCreateInput>>;
  /** The primary key(s) for `device` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<DeviceDevicePkeyDelete>>;
  /** The primary key(s) for `device` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<DeviceNodeIdDelete>>;
  /** Flag indicating whether all other `device` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `device` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DeviceOnDeviceForDeviceOrganizationIdFkeyUsingDevicePkeyUpdate>>;
  /** The primary key(s) and patch data for `device` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrganizationOnDeviceForDeviceOrganizationIdFkeyNodeIdUpdate>>;
};

/** Represents an update to a `Device`. Fields that are set will be updated. */
export type DevicePatch = {
  appPackageId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  contentVersion?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<DeviceLocationIdFkeyInput>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<DeviceOrganizationIdFkeyInput>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

/** A connection to a list of `Device` values. */
export type DevicesConnection = {
  __typename?: 'DevicesConnection';
  /** A list of edges which contains the `Device` and cursor to aid in pagination. */
  edges: Array<DevicesEdge>;
  /** A list of `Device` objects. */
  nodes: Array<Device>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Device` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Device` edge in the connection. */
export type DevicesEdge = {
  __typename?: 'DevicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Device` at the end of the edge. */
  node: Device;
};

/** Methods to use when ordering `Device`. */
export enum DevicesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LocationIdAsc = 'LOCATION_ID_ASC',
  LocationIdDesc = 'LOCATION_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UnenrolledAtAsc = 'UNENROLLED_AT_ASC',
  UnenrolledAtDesc = 'UNENROLLED_AT_DESC'
}

export type DisableAdminMfaInput = {
  code: Scalars['String']['input'];
  currentPassword: Scalars['String']['input'];
  recovery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Distribution = Node & {
  __typename?: 'Distribution';
  appId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  dimension: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `Distribution` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DistributionCondition = {
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
};

/** A connection to a list of `Distribution` values. */
export type DistributionsConnection = {
  __typename?: 'DistributionsConnection';
  /** A list of edges which contains the `Distribution` and cursor to aid in pagination. */
  edges: Array<DistributionsEdge>;
  /** A list of `Distribution` objects. */
  nodes: Array<Distribution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Distribution` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Distribution` edge in the connection. */
export type DistributionsEdge = {
  __typename?: 'DistributionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Distribution` at the end of the edge. */
  node: Distribution;
};

/** Methods to use when ordering `Distribution`. */
export enum DistributionsOrderBy {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Export of a documentation note (Bericht) or procedure acknowledgement (Quittierung) to the resident's care-documentation provider. */
export type DocumentationSync = Node & {
  __typename?: 'DocumentationSync';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  kind: DocumentationSyncKind;
  /** Provider or backend error of the latest failed attempt. */
  lastError?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Note` that is related to this `DocumentationSync`. */
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['UUID']['output']>;
  /** When the latest outcome happened. For a provider report this is when the provider answered, not when the report arrived. */
  outcomeAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Procedure` that is related to this `DocumentationSync`. */
  procedure?: Maybe<Procedure>;
  procedureId?: Maybe<Scalars['UUID']['output']>;
  provider?: Maybe<DataSource>;
  seniorId?: Maybe<Scalars['UUID']['output']>;
  /** When the provider accepted the export. */
  sentAt?: Maybe<Scalars['Datetime']['output']>;
  skipReason?: Maybe<DocumentationSyncSkipReason>;
  status: DocumentationSyncStatus;
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `DocumentationSync` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentationSyncCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `noteId` field. */
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `procedureId` field. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `seniorId` field. */
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `documentationSync` to look up the row to connect. */
export type DocumentationSyncDocumentationSyncPkeyConnect = {
  id: Scalars['UUID']['input'];
};

export enum DocumentationSyncKind {
  Bericht = 'BERICHT',
  Quittierung = 'QUITTIERUNG'
}

/** The globally unique `ID` look up for the row to connect. */
export type DocumentationSyncNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `documentationSync` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** Input for the nested mutation of `note` in the `DocumentationSyncInput` mutation. */
export type DocumentationSyncNoteIdFkeyInput = {
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectById?: InputMaybe<NoteNotePkeyConnect>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<NoteNodeIdConnect>;
  /** A `NoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentationSyncNoteIdFkeyNoteCreateInput>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteById?: InputMaybe<NoteNotePkeyDelete>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<NoteNodeIdDelete>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateById?: InputMaybe<NoteOnDocumentationSyncForDocumentationSyncNoteIdFkeyUsingNotePkeyUpdate>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentationSyncOnDocumentationSyncForDocumentationSyncNoteIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `documentationSync` in the `NoteInput` mutation. */
export type DocumentationSyncNoteIdFkeyInverseInput = {
  /** The primary key(s) for `documentationSync` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DocumentationSyncDocumentationSyncPkeyConnect>>;
  /** The primary key(s) for `documentationSync` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentationSyncNodeIdConnect>>;
  /** The primary key(s) and patch data for `documentationSync` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DocumentationSyncOnDocumentationSyncForDocumentationSyncNoteIdFkeyUsingDocumentationSyncPkeyUpdate>>;
  /** The primary key(s) and patch data for `documentationSync` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<NoteOnDocumentationSyncForDocumentationSyncNoteIdFkeyNodeIdUpdate>>;
};

/** The `note` to be created by this mutation. */
export type DocumentationSyncNoteIdFkeyNoteCreateInput = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to update. */
export type DocumentationSyncOnDocumentationSyncForDocumentationSyncNoteIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `note` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: NotePatch;
};

/** The fields on `documentationSync` to look up the row to update. */
export type DocumentationSyncOnDocumentationSyncForDocumentationSyncNoteIdFkeyUsingDocumentationSyncPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `documentationSync` being updated. */
  patch: UpdateDocumentationSyncOnDocumentationSyncForDocumentationSyncNoteIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type DocumentationSyncOnDocumentationSyncForDocumentationSyncProcedureIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `procedure` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: ProcedurePatch;
};

/** The fields on `documentationSync` to look up the row to update. */
export type DocumentationSyncOnDocumentationSyncForDocumentationSyncProcedureIdFkeyUsingDocumentationSyncPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `documentationSync` being updated. */
  patch: UpdateDocumentationSyncOnDocumentationSyncForDocumentationSyncProcedureIdFkeyPatch;
};

export enum DocumentationSyncOutcome {
  Failed = 'failed',
  Sent = 'sent'
}

/** Represents an update to a `DocumentationSync`. Fields that are set will be updated. */
export type DocumentationSyncPatch = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<DocumentationSyncKind>;
  /** Provider or backend error of the latest failed attempt. */
  lastError?: InputMaybe<Scalars['String']['input']>;
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  noteToNoteId?: InputMaybe<DocumentationSyncNoteIdFkeyInput>;
  /** When the latest outcome happened. For a provider report this is when the provider answered, not when the report arrived. */
  outcomeAt?: InputMaybe<Scalars['Datetime']['input']>;
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<DocumentationSyncProcedureIdFkeyInput>;
  provider?: InputMaybe<DataSource>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  /** When the provider accepted the export. */
  sentAt?: InputMaybe<Scalars['Datetime']['input']>;
  skipReason?: InputMaybe<DocumentationSyncSkipReason>;
  status?: InputMaybe<DocumentationSyncStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Input for the nested mutation of `procedure` in the `DocumentationSyncInput` mutation. */
export type DocumentationSyncProcedureIdFkeyInput = {
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectById?: InputMaybe<ProcedureProcedurePkeyConnect>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProcedureNodeIdConnect>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureChkProcedureExternalIdSourceConnect>;
  /** A `ProcedureInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentationSyncProcedureIdFkeyProcedureCreateInput>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteById?: InputMaybe<ProcedureProcedurePkeyDelete>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProcedureNodeIdDelete>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureChkProcedureExternalIdSourceDelete>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateById?: InputMaybe<ProcedureOnDocumentationSyncForDocumentationSyncProcedureIdFkeyUsingProcedurePkeyUpdate>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DocumentationSyncOnDocumentationSyncForDocumentationSyncProcedureIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureOnDocumentationSyncForDocumentationSyncProcedureIdFkeyUsingChkProcedureExternalIdSourceUpdate>;
};

/** Input for the nested mutation of `documentationSync` in the `ProcedureInput` mutation. */
export type DocumentationSyncProcedureIdFkeyInverseInput = {
  /** The primary key(s) for `documentationSync` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DocumentationSyncDocumentationSyncPkeyConnect>>;
  /** The primary key(s) for `documentationSync` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DocumentationSyncNodeIdConnect>>;
  /** The primary key(s) and patch data for `documentationSync` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DocumentationSyncOnDocumentationSyncForDocumentationSyncProcedureIdFkeyUsingDocumentationSyncPkeyUpdate>>;
  /** The primary key(s) and patch data for `documentationSync` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProcedureOnDocumentationSyncForDocumentationSyncProcedureIdFkeyNodeIdUpdate>>;
};

/** The `procedure` to be created by this mutation. */
export type DocumentationSyncProcedureIdFkeyProcedureCreateInput = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

export enum DocumentationSyncSkipReason {
  MissingAuthorExternalId = 'MISSING_AUTHOR_EXTERNAL_ID',
  MissingResidentExternalId = 'MISSING_RESIDENT_EXTERNAL_ID',
  NotIntegrated = 'NOT_INTEGRATED',
  NoContent = 'NO_CONTENT'
}

export enum DocumentationSyncStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT',
  Skipped = 'SKIPPED'
}

/** A connection to a list of `DocumentationSync` values. */
export type DocumentationSyncsConnection = {
  __typename?: 'DocumentationSyncsConnection';
  /** A list of edges which contains the `DocumentationSync` and cursor to aid in pagination. */
  edges: Array<DocumentationSyncsEdge>;
  /** A list of `DocumentationSync` objects. */
  nodes: Array<DocumentationSync>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentationSync` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DocumentationSync` edge in the connection. */
export type DocumentationSyncsEdge = {
  __typename?: 'DocumentationSyncsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DocumentationSync` at the end of the edge. */
  node: DocumentationSync;
};

/** Methods to use when ordering `DocumentationSync`. */
export enum DocumentationSyncsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NoteIdAsc = 'NOTE_ID_ASC',
  NoteIdDesc = 'NOTE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcedureIdAsc = 'PROCEDURE_ID_ASC',
  ProcedureIdDesc = 'PROCEDURE_ID_DESC',
  SeniorIdAsc = 'SENIOR_ID_ASC',
  SeniorIdDesc = 'SENIOR_ID_DESC'
}

export enum EmailStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export enum EncryptionMode {
  All = 'ALL',
  Message = 'MESSAGE',
  None = 'NONE'
}

export type EndProcedureExecutionActivitySessionInput = {
  sessionId: Scalars['UUID']['input'];
  sessionStatus: SessionStatus;
};

export type EndProcedureExecutionInput = {
  activeSession?: InputMaybe<EndProcedureExecutionActivitySessionInput>;
  intent: ProcedureExecutionEndIntent;
  performedEnd: Scalars['Datetime']['input'];
  procedureId: Scalars['UUID']['input'];
};

export type EndProcedureExecutionPayload = {
  __typename?: 'EndProcedureExecutionPayload';
  acknowledgedAt?: Maybe<Scalars['Datetime']['output']>;
  completedActivityCount: Scalars['Int']['output'];
  performedEnd?: Maybe<Scalars['Datetime']['output']>;
  status: ProcedureExecutionEndStatus;
};

export type EnrollDeviceAsManagerInput = {
  device: DeviceEnrollmentDeviceInput;
  /** A WARD or the organization root, in the manager's own organization. */
  targetLocationId: Scalars['UUID']['input'];
};

export type EnrollmentResult = {
  __typename?: 'EnrollmentResult';
  assignment: LearningAssignment;
};

export enum Environment {
  Dev = 'dev',
  Local = 'local',
  Prod = 'prod',
  Stage = 'stage'
}

export type FamilyMemberSenior = Node & {
  __typename?: 'FamilyMemberSenior';
  /** Reads a single `User` that is related to this `FamilyMemberSenior`. */
  familyMember?: Maybe<User>;
  familyMemberId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `FamilyMemberSenior`. */
  senior?: Maybe<User>;
  seniorId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `FamilyMemberSenior` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FamilyMemberSeniorCondition = {
  /** Checks for equality with the object’s `familyMemberId` field. */
  familyMemberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `seniorId` field. */
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `familyMemberSenior` to look up the row to connect. */
export type FamilyMemberSeniorFamilyMemberSeniorsPkeyConnect = {
  familyMemberId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};

/** The fields on `familyMemberSenior` to look up the row to delete. */
export type FamilyMemberSeniorFamilyMemberSeniorsPkeyDelete = {
  familyMemberId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};

/** An input for mutations affecting `FamilyMemberSenior` */
export type FamilyMemberSeniorInput = {
  familyMemberId?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToFamilyMemberId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInput>;
  userToSeniorId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type FamilyMemberSeniorNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `familyMemberSenior` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type FamilyMemberSeniorNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `familyMemberSenior` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type FamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `familyMemberSenior` to look up the row to update. */
export type FamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyUsingFamilyMemberSeniorsPkeyUpdate = {
  familyMemberId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `familyMemberSenior` being updated. */
  patch: UpdateFamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyPatch;
  seniorId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type FamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `familyMemberSenior` to look up the row to update. */
export type FamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyUsingFamilyMemberSeniorsPkeyUpdate = {
  familyMemberId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `familyMemberSenior` being updated. */
  patch: UpdateFamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyPatch;
  seniorId: Scalars['UUID']['input'];
};

/** Represents an update to a `FamilyMemberSenior`. Fields that are set will be updated. */
export type FamilyMemberSeniorPatch = {
  familyMemberId?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToFamilyMemberId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInput>;
  userToSeniorId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInput>;
};

/** A connection to a list of `FamilyMemberSenior` values. */
export type FamilyMemberSeniorsConnection = {
  __typename?: 'FamilyMemberSeniorsConnection';
  /** A list of edges which contains the `FamilyMemberSenior` and cursor to aid in pagination. */
  edges: Array<FamilyMemberSeniorsEdge>;
  /** A list of `FamilyMemberSenior` objects. */
  nodes: Array<FamilyMemberSenior>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FamilyMemberSenior` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FamilyMemberSenior` edge in the connection. */
export type FamilyMemberSeniorsEdge = {
  __typename?: 'FamilyMemberSeniorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FamilyMemberSenior` at the end of the edge. */
  node: FamilyMemberSenior;
};

/** The `familyMemberSenior` to be created by this mutation. */
export type FamilyMemberSeniorsFamilyMemberIdFkeyFamilyMemberSeniorsCreateInput = {
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToFamilyMemberId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInput>;
  userToSeniorId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `FamilyMemberSeniorInput` mutation. */
export type FamilyMemberSeniorsFamilyMemberIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `familyMemberSenior` in the `UserInput` mutation. */
export type FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput = {
  /** The primary key(s) for `familyMemberSenior` for the far side of the relationship. */
  connectByFamilyMemberIdAndSeniorId?: InputMaybe<Array<FamilyMemberSeniorFamilyMemberSeniorsPkeyConnect>>;
  /** The primary key(s) for `familyMemberSenior` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<FamilyMemberSeniorNodeIdConnect>>;
  /** A `FamilyMemberSeniorInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FamilyMemberSeniorsFamilyMemberIdFkeyFamilyMemberSeniorsCreateInput>>;
  /** The primary key(s) for `familyMemberSenior` for the far side of the relationship. */
  deleteByFamilyMemberIdAndSeniorId?: InputMaybe<Array<FamilyMemberSeniorFamilyMemberSeniorsPkeyDelete>>;
  /** The primary key(s) for `familyMemberSenior` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<FamilyMemberSeniorNodeIdDelete>>;
  /** Flag indicating whether all other `familyMemberSenior` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `familyMemberSenior` for the far side of the relationship. */
  updateByFamilyMemberIdAndSeniorId?: InputMaybe<Array<FamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyUsingFamilyMemberSeniorsPkeyUpdate>>;
  /** The primary key(s) and patch data for `familyMemberSenior` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type FamilyMemberSeniorsFamilyMemberIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** Methods to use when ordering `FamilyMemberSenior`. */
export enum FamilyMemberSeniorsOrderBy {
  FamilyMemberIdAsc = 'FAMILY_MEMBER_ID_ASC',
  FamilyMemberIdDesc = 'FAMILY_MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SeniorIdAsc = 'SENIOR_ID_ASC',
  SeniorIdDesc = 'SENIOR_ID_DESC'
}

/** The `familyMemberSenior` to be created by this mutation. */
export type FamilyMemberSeniorsSeniorIdFkeyFamilyMemberSeniorsCreateInput = {
  familyMemberId?: InputMaybe<Scalars['UUID']['input']>;
  userToFamilyMemberId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInput>;
  userToSeniorId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `FamilyMemberSeniorInput` mutation. */
export type FamilyMemberSeniorsSeniorIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `familyMemberSenior` in the `UserInput` mutation. */
export type FamilyMemberSeniorsSeniorIdFkeyInverseInput = {
  /** The primary key(s) for `familyMemberSenior` for the far side of the relationship. */
  connectByFamilyMemberIdAndSeniorId?: InputMaybe<Array<FamilyMemberSeniorFamilyMemberSeniorsPkeyConnect>>;
  /** The primary key(s) for `familyMemberSenior` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<FamilyMemberSeniorNodeIdConnect>>;
  /** A `FamilyMemberSeniorInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FamilyMemberSeniorsSeniorIdFkeyFamilyMemberSeniorsCreateInput>>;
  /** The primary key(s) for `familyMemberSenior` for the far side of the relationship. */
  deleteByFamilyMemberIdAndSeniorId?: InputMaybe<Array<FamilyMemberSeniorFamilyMemberSeniorsPkeyDelete>>;
  /** The primary key(s) for `familyMemberSenior` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<FamilyMemberSeniorNodeIdDelete>>;
  /** Flag indicating whether all other `familyMemberSenior` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `familyMemberSenior` for the far side of the relationship. */
  updateByFamilyMemberIdAndSeniorId?: InputMaybe<Array<FamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyUsingFamilyMemberSeniorsPkeyUpdate>>;
  /** The primary key(s) and patch data for `familyMemberSenior` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type FamilyMemberSeniorsSeniorIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `FeatureActivity` values. */
export type FeatureActivitiesConnection = {
  __typename?: 'FeatureActivitiesConnection';
  /** A list of edges which contains the `FeatureActivity` and cursor to aid in pagination. */
  edges: Array<FeatureActivitiesEdge>;
  /** A list of `FeatureActivity` objects. */
  nodes: Array<FeatureActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeatureActivity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FeatureActivity` edge in the connection. */
export type FeatureActivitiesEdge = {
  __typename?: 'FeatureActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FeatureActivity` at the end of the edge. */
  node: FeatureActivity;
};

/** Methods to use when ordering `FeatureActivity`. */
export enum FeatureActivitiesOrderBy {
  ActivityIdAsc = 'ACTIVITY_ID_ASC',
  ActivityIdDesc = 'ACTIVITY_ID_DESC',
  KindAsc = 'KIND_ASC',
  KindDesc = 'KIND_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type FeatureActivity = Node & {
  __typename?: 'FeatureActivity';
  /** Reads a single `Activity` that is related to this `FeatureActivity`. */
  activity?: Maybe<Activity>;
  activityId: Scalars['UUID']['output'];
  kind: FeatureActivityKind;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `FeatureActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FeatureActivityCondition = {
  /** Checks for equality with the object’s `activityId` field. */
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<FeatureActivityKind>;
};

/** The fields on `featureActivity` to look up the row to connect. */
export type FeatureActivityFeatureActivityKindKeyConnect = {
  kind: FeatureActivityKind;
};

/** The fields on `featureActivity` to look up the row to delete. */
export type FeatureActivityFeatureActivityKindKeyDelete = {
  kind: FeatureActivityKind;
};

/** The fields on `featureActivity` to look up the row to connect. */
export type FeatureActivityFeatureActivityPkeyConnect = {
  activityId: Scalars['UUID']['input'];
};

/** The fields on `featureActivity` to look up the row to delete. */
export type FeatureActivityFeatureActivityPkeyDelete = {
  activityId: Scalars['UUID']['input'];
};

/** The `activity` to be created by this mutation. */
export type FeatureActivityFkeyActivityCreateInput = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: ActivityKind;
};

/** The `featureActivity` to be created by this mutation. */
export type FeatureActivityFkeyFeatureActivityCreateInput = {
  activityToActivityId?: InputMaybe<FeatureActivityFkeyInput>;
  kind: FeatureActivityKind;
};

/** Input for the nested mutation of `activity` in the `FeatureActivityInput` mutation. */
export type FeatureActivityFkeyInput = {
  /** The primary key(s) for `activity` for the far side of the relationship. */
  connectById?: InputMaybe<ActivityActivityPkeyConnect>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ActivityNodeIdConnect>;
  /** A `ActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeatureActivityFkeyActivityCreateInput>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  deleteById?: InputMaybe<ActivityActivityPkeyDelete>;
  /** The primary key(s) for `activity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ActivityNodeIdDelete>;
  /** The primary key(s) and patch data for `activity` for the far side of the relationship. */
  updateById?: InputMaybe<ActivityOnFeatureActivityForFeatureActivityFkeyUsingActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `activity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FeatureActivityOnFeatureActivityForFeatureActivityFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `featureActivity` in the `ActivityInput` mutation. */
export type FeatureActivityFkeyInverseInput = {
  /** The primary key(s) for `featureActivity` for the far side of the relationship. */
  connectByActivityId?: InputMaybe<FeatureActivityFeatureActivityPkeyConnect>;
  /** The primary key(s) for `featureActivity` for the far side of the relationship. */
  connectByKind?: InputMaybe<FeatureActivityFeatureActivityKindKeyConnect>;
  /** The primary key(s) for `featureActivity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<FeatureActivityNodeIdConnect>;
  /** A `FeatureActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FeatureActivityFkeyFeatureActivityCreateInput>>;
  /** The primary key(s) for `featureActivity` for the far side of the relationship. */
  deleteByActivityId?: InputMaybe<FeatureActivityFeatureActivityPkeyDelete>;
  /** The primary key(s) for `featureActivity` for the far side of the relationship. */
  deleteByKind?: InputMaybe<FeatureActivityFeatureActivityKindKeyDelete>;
  /** The primary key(s) for `featureActivity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<FeatureActivityNodeIdDelete>;
  /** Flag indicating whether all other `featureActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `featureActivity` for the far side of the relationship. */
  updateByActivityId?: InputMaybe<FeatureActivityOnFeatureActivityForFeatureActivityFkeyUsingFeatureActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `featureActivity` for the far side of the relationship. */
  updateByKind?: InputMaybe<FeatureActivityOnFeatureActivityForFeatureActivityFkeyUsingFeatureActivityKindKeyUpdate>;
  /** The primary key(s) and patch data for `featureActivity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ActivityOnFeatureActivityForFeatureActivityFkeyNodeIdUpdate>;
};

/** An input for mutations affecting `FeatureActivity` */
export type FeatureActivityInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityToActivityId?: InputMaybe<FeatureActivityFkeyInput>;
  kind: FeatureActivityKind;
};

export enum FeatureActivityKind {
  AnnualHistory = 'ANNUAL_HISTORY',
  Assessment = 'ASSESSMENT',
  Chat = 'CHAT',
  ConversationGuide = 'CONVERSATION_GUIDE',
  EndlessQuiz = 'ENDLESS_QUIZ',
  Horoscope = 'HOROSCOPE',
  PhotoAlbum = 'PHOTO_ALBUM',
  Questionnaire = 'QUESTIONNAIRE',
  Videochat = 'VIDEOCHAT'
}

/** The globally unique `ID` look up for the row to connect. */
export type FeatureActivityNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `featureActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type FeatureActivityNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `featureActivity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type FeatureActivityOnFeatureActivityForFeatureActivityFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activity` being updated. */
  patch: ActivityPatch;
};

/** The fields on `featureActivity` to look up the row to update. */
export type FeatureActivityOnFeatureActivityForFeatureActivityFkeyUsingFeatureActivityKindKeyUpdate = {
  kind: FeatureActivityKind;
  /** An object where the defined keys will be set on the `featureActivity` being updated. */
  patch: UpdateFeatureActivityOnFeatureActivityForFeatureActivityFkeyPatch;
};

/** The fields on `featureActivity` to look up the row to update. */
export type FeatureActivityOnFeatureActivityForFeatureActivityFkeyUsingFeatureActivityPkeyUpdate = {
  activityId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `featureActivity` being updated. */
  patch: UpdateFeatureActivityOnFeatureActivityForFeatureActivityFkeyPatch;
};

/** Represents an update to a `FeatureActivity`. Fields that are set will be updated. */
export type FeatureActivityPatch = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityToActivityId?: InputMaybe<FeatureActivityFkeyInput>;
  kind?: InputMaybe<FeatureActivityKind>;
};

export type FeatureActivitySessionInput = {
  activityKind: ActivityKind;
  beganAt: Scalars['Datetime']['input'];
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  featureKind: FeatureActivityKind;
  seniorProfileIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sessionId: Scalars['UUID']['input'];
  sessionKind: SessionKind;
  sessionStatus?: InputMaybe<SessionStatus>;
};

export type Feedback = Node & {
  __typename?: 'Feedback';
  createdAt: Scalars['Datetime']['output'];
  deviceId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  params?: Maybe<Scalars['JSON']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `Feedback`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `Feedback` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FeedbackCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `targetType` field. */
  targetType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `feedback` to look up the row to connect. */
export type FeedbackFeedbackPkeyConnect = {
  id: Scalars['Int']['input'];
};

/** The fields on `feedback` to look up the row to delete. */
export type FeedbackFeedbackPkeyDelete = {
  id: Scalars['Int']['input'];
};

/** An input for mutations affecting `Feedback` */
export type FeedbackInput = {
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<FeedbackUserIdInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type FeedbackNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `feedback` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type FeedbackNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `feedback` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type FeedbackOnFeedbackForFeedbackUserIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `feedback` to look up the row to update. */
export type FeedbackOnFeedbackForFeedbackUserIdUsingFeedbackPkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `feedback` being updated. */
  patch: UpdateFeedbackOnFeedbackForFeedbackUserIdPatch;
};

/** Represents an update to a `Feedback`. Fields that are set will be updated. */
export type FeedbackPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<FeedbackUserIdInput>;
};

/** The `feedback` to be created by this mutation. */
export type FeedbackUserIdFeedbackCreateInput = {
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
  userToUserId?: InputMaybe<FeedbackUserIdInput>;
};

/** Input for the nested mutation of `user` in the `FeedbackInput` mutation. */
export type FeedbackUserIdInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeedbackUserIdUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFeedbackForFeedbackUserIdUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FeedbackOnFeedbackForFeedbackUserIdNodeIdUpdate>;
};

/** Input for the nested mutation of `feedback` in the `UserInput` mutation. */
export type FeedbackUserIdInverseInput = {
  /** The primary key(s) for `feedback` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FeedbackFeedbackPkeyConnect>>;
  /** The primary key(s) for `feedback` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<FeedbackNodeIdConnect>>;
  /** A `FeedbackInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FeedbackUserIdFeedbackCreateInput>>;
  /** The primary key(s) for `feedback` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FeedbackFeedbackPkeyDelete>>;
  /** The primary key(s) for `feedback` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<FeedbackNodeIdDelete>>;
  /** Flag indicating whether all other `feedback` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `feedback` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FeedbackOnFeedbackForFeedbackUserIdUsingFeedbackPkeyUpdate>>;
  /** The primary key(s) and patch data for `feedback` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnFeedbackForFeedbackUserIdNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type FeedbackUserIdUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `Feedback` values. */
export type FeedbacksConnection = {
  __typename?: 'FeedbacksConnection';
  /** A list of edges which contains the `Feedback` and cursor to aid in pagination. */
  edges: Array<FeedbacksEdge>;
  /** A list of `Feedback` objects. */
  nodes: Array<Feedback>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Feedback` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Feedback` edge in the connection. */
export type FeedbacksEdge = {
  __typename?: 'FeedbacksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Feedback` at the end of the edge. */
  node: Feedback;
};

/** Methods to use when ordering `Feedback`. */
export enum FeedbacksOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TargetTypeAsc = 'TARGET_TYPE_ASC',
  TargetTypeDesc = 'TARGET_TYPE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type FinanceAccountRef = {
  __typename?: 'FinanceAccountRef';
  name?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Billwerk contracts that need attention. DUNNING: an open dunning. BILLING_SUSPENDED: active with billing suspended. ENDING_SOON: active and ending within 30 days. */
export enum FinanceBillwerkCheck {
  BillingSuspended = 'BILLING_SUSPENDED',
  Dunning = 'DUNNING',
  EndingSoon = 'ENDING_SOON'
}

export type FinanceBillwerkCheckCount = {
  __typename?: 'FinanceBillwerkCheckCount';
  /** The unpaid dunning amount; 0 for other checks. */
  amount: Scalars['Float']['output'];
  check: FinanceBillwerkCheck;
  count: Scalars['Int']['output'];
};

export type FinanceBillwerkContract = {
  __typename?: 'FinanceBillwerkContract';
  /** The Salesforce accounts the reconciliation pairs with the customer. */
  accounts: Array<FinanceAccountRef>;
  billingSuspended: Scalars['Boolean']['output'];
  customer: FinanceCustomerRef;
  dunningLevel?: Maybe<Scalars['Int']['output']>;
  dunningRemaining?: Maybe<Scalars['Float']['output']>;
  dunningSince?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lifecycleStatus?: Maybe<Scalars['String']['output']>;
  planVariantId?: Maybe<Scalars['String']['output']>;
  planVariantName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  /** As Billwerk gives them, ISO 8601. */
  startDate?: Maybe<Scalars['String']['output']>;
};

export type FinanceCheckItem = {
  __typename?: 'FinanceCheckItem';
  accountName?: Maybe<Scalars['String']['output']>;
  billingTool?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractUrl?: Maybe<Scalars['String']['output']>;
  /** CreatedDate. */
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  salesforceUrl: Scalars['String']['output'];
  /** YYYY-MM-DD. */
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** A Salesforce contract item as the Finance inbox shows it. */
export type FinanceContractItem = {
  __typename?: 'FinanceContractItem';
  accountName?: Maybe<Scalars['String']['output']>;
  accountRecordType?: Maybe<Scalars['String']['output']>;
  billingStartDate?: Maybe<Scalars['Date']['output']>;
  billingStarted?: Maybe<Scalars['Boolean']['output']>;
  billingStopped?: Maybe<Scalars['Boolean']['output']>;
  billingTool?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationType?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The Billwerk plan variant the item bills with, or why it has none. Only KNOWN can be billed. */
  planVariant: BillwerkPlanVariant;
  price?: Maybe<Scalars['BigFloat']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  salesforceUrl: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type FinanceCustomerRef = {
  __typename?: 'FinanceCustomerRef';
  debitorAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FinanceNotification = {
  __typename?: 'FinanceNotification';
  /** Billing stop rule: the day after the end date at 00:00 Europe/Berlin. Null for other rules. */
  billwerkEffectiveFrom?: Maybe<Scalars['Datetime']['output']>;
  /** Contract change rule: the new item. */
  changedInto?: Maybe<FinanceContractItem>;
  handledAt?: Maybe<Scalars['Datetime']['output']>;
  handledEndDate?: Maybe<Scalars['Date']['output']>;
  /** Cancellation withdrawn and end date changed rules: the state when the cancellation was handled. */
  handledStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Null when the item is no longer in the CRM copy. */
  item?: Maybe<FinanceContractItem>;
  /** Billing stop rule: the item holds hardware and has no completed Client Return. False for other rules. */
  noCompletedReturn: Scalars['Boolean']['output'];
  openedAt: Scalars['Datetime']['output'];
  /** Billing stop rule: the item's Client Return Order, the latest completed or else the latest created. Null for other rules or without one. */
  returnOrder?: Maybe<FinanceReturnOrder>;
  rule: FinanceNotificationRule;
};

export type FinanceNotificationDismissal = {
  __typename?: 'FinanceNotificationDismissal';
  dismissedAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
};

export type FinanceNotificationPage = {
  __typename?: 'FinanceNotificationPage';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<FinanceNotification>;
  sync: FinanceNotificationSync;
  /** The open notifications of the rule filter, not only this page. */
  totalCount: Scalars['Int']['output'];
};

/** The rule that opened a Finance notification. */
export enum FinanceNotificationRule {
  BillingStartDue = 'BILLING_START_DUE',
  BillingStopNeeded = 'BILLING_STOP_NEEDED',
  CancellationWithdrawn = 'CANCELLATION_WITHDRAWN',
  ContractChangeDue = 'CONTRACT_CHANGE_DUE',
  EndDateChanged = 'END_DATE_CHANGED'
}

/** The state of the Salesforce sync the notifications come from. */
export type FinanceNotificationSync = {
  __typename?: 'FinanceNotificationSync';
  /** Whether the most recent finished sync failed. */
  lastRunFailed: Scalars['Boolean']['output'];
  /** When the last successful sync finished; null when none did. */
  lastSucceededAt?: Maybe<Scalars['Datetime']['output']>;
  /** Contract_Item__c fields the notification rules read that the last successful sync could not read. The rules that read them were held in that sync: their notifications were neither opened nor resolved. */
  unreadableFields: Array<Scalars['String']['output']>;
};

export type FinanceOverview = {
  __typename?: 'FinanceOverview';
  billwerk: FinanceOverviewBillwerk;
  /** Empty unless the list is BILLWERK. */
  billwerkContracts: Array<FinanceBillwerkContract>;
  billwerkCounts: Array<FinanceBillwerkCheckCount>;
  kpis: FinanceOverviewKpis;
  planVariantGaps: FinancePlanVariantGaps;
  /** How many days recentOnly looks back. */
  recentDays: Scalars['Int']['output'];
  /** Empty unless the list is RECONCILIATION. */
  reconciliation: Array<FinanceReconciliationRow>;
  reconciliationCounts: Array<FinanceReconciliationCount>;
  salesforceCounts: Array<FinanceSalesforceCheckCount>;
  /** Empty unless the list is SALESFORCE. */
  salesforceItems: Array<FinanceCheckItem>;
  salesforceSync: FinanceOverviewSync;
  toDos: Array<FinanceOverviewToDo>;
  /** The rows of the list and filter, not only this page. */
  totalCount: Scalars['Int']['output'];
  /** True while the CRM copy cannot pair accounts or resolve plan variants: then the reconciliation shows no row. */
  withheld: Scalars['Boolean']['output'];
};

export type FinanceOverviewBillwerk = {
  __typename?: 'FinanceOverviewBillwerk';
  contractCount?: Maybe<Scalars['Int']['output']>;
  /** The contract list, which loads after the customers. */
  contracts: BillwerkListStatus;
  customerCount?: Maybe<Scalars['Int']['output']>;
  loadedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The customer list: NOT_CONFIGURED, LOADING (ask again), READY or UNAVAILABLE. */
  status: BillwerkListStatus;
};

export type FinanceOverviewKpis = {
  __typename?: 'FinanceOverviewKpis';
  billedItems: Scalars['Int']['output'];
  /** The monthly prices of the billed Salesforce subscription items. */
  billedMonthlyValue: Scalars['Float']['output'];
  billwerkActiveContracts?: Maybe<Scalars['Int']['output']>;
  billwerkActiveCustomers?: Maybe<Scalars['Int']['output']>;
  dunningContracts?: Maybe<Scalars['Int']['output']>;
  /** The amount still unpaid of every open dunning. */
  dunningRemaining?: Maybe<Scalars['Float']['output']>;
};

/** RECONCILIATION: per Billwerk customer, what Salesforce bills against the active Billwerk contracts. SALESFORCE: contract items of a Salesforce check. BILLWERK: Billwerk contracts of a Billwerk check. */
export enum FinanceOverviewList {
  Billwerk = 'BILLWERK',
  Reconciliation = 'RECONCILIATION',
  Salesforce = 'SALESFORCE'
}

/** FINDING: by finding and amount. NEWEST: what changed last first: in the reconciliation the newer of the newest billed Salesforce item's CreatedDate and the newest active Billwerk contract's start (a future start counts as now); Salesforce items by CreatedDate; Billwerk contracts by their start, dunning by its date. */
export enum FinanceOverviewSort {
  Finding = 'FINDING',
  Newest = 'NEWEST'
}

export type FinanceOverviewSync = {
  __typename?: 'FinanceOverviewSync';
  lastSucceededAt?: Maybe<Scalars['Datetime']['output']>;
  /** The fields the overview needs that the last successful CRM sync could not read, as Object or Object.Field. */
  unreadableFields: Array<Scalars['String']['output']>;
};

/** The open Finance notifications of a rule: what Finance has to do in Billwerk. */
export type FinanceOverviewToDo = {
  __typename?: 'FinanceOverviewToDo';
  count: Scalars['Int']['output'];
  /** Notifications whose item date is more than a year ago. */
  legacy: Scalars['Int']['output'];
  monthlyValue: Scalars['Float']['output'];
  rule: FinanceNotificationRule;
  /** Notifications whose item date is still to come. */
  upcoming: Scalars['Int']['output'];
};

export type FinancePlanVariantGaps = {
  __typename?: 'FinancePlanVariantGaps';
  count: Scalars['Int']['output'];
  monthlyValue: Scalars['Float']['output'];
};

export type FinanceReconciliationCount = {
  __typename?: 'FinanceReconciliationCount';
  count: Scalars['Int']['output'];
  monthlyValue: Scalars['Float']['output'];
  status: FinanceReconciliationStatus;
};

export type FinanceReconciliationRow = {
  __typename?: 'FinanceReconciliationRow';
  accounts: Array<FinanceAccountRef>;
  billwerkContracts: Scalars['Int']['output'];
  /** The newest active Billwerk contract's start. */
  billwerkStartedAt?: Maybe<Scalars['Datetime']['output']>;
  customer?: Maybe<FinanceCustomerRef>;
  debitorAccount?: Maybe<Scalars['String']['output']>;
  matchGroup?: Maybe<BillwerkCustomerMatchGroup>;
  matchReason?: Maybe<BillwerkCustomerMatchReason>;
  monthlyValue: Scalars['Float']['output'];
  /** The newest billed Salesforce item's CreatedDate. */
  salesforceCreatedAt?: Maybe<Scalars['Datetime']['output']>;
  salesforceItems: Scalars['Int']['output'];
  status: FinanceReconciliationStatus;
  variants: Array<FinanceReconciliationVariant>;
};

/** SALESFORCE_ONLY: billed in Salesforce, but the customer has no active Billwerk contract. BILLWERK_ONLY: an active Billwerk contract, but nothing billed in Salesforce. VARIANTS_DIFFER: both bill, but not the same plan variants and quantities. NO_BILLWERK_CUSTOMER: billed in Salesforce, but no Billwerk customer is found for the payer. NO_SALESFORCE_ACCOUNT: a Billwerk customer with an active contract, but no Salesforce account. UNCLEAR: the customer match has a conflict here. IN_SYNC: both bill the same. */
export enum FinanceReconciliationStatus {
  BillwerkOnly = 'BILLWERK_ONLY',
  InSync = 'IN_SYNC',
  NoBillwerkCustomer = 'NO_BILLWERK_CUSTOMER',
  NoSalesforceAccount = 'NO_SALESFORCE_ACCOUNT',
  SalesforceOnly = 'SALESFORCE_ONLY',
  Unclear = 'UNCLEAR',
  VariantsDiffer = 'VARIANTS_DIFFER'
}

export type FinanceReconciliationVariant = {
  __typename?: 'FinanceReconciliationVariant';
  billwerkContracts: Scalars['Int']['output'];
  /** The summed quantity of the active Billwerk contracts on this variant. */
  billwerkQuantity: Scalars['Int']['output'];
  /** Whether Billwerk knows the variant; null while its list is not read. */
  known?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Null for the Salesforce items whose price book entry names no variant. */
  planVariantId?: Maybe<Scalars['String']['output']>;
  salesforceItems: Scalars['Int']['output'];
  salesforceMonthlyValue: Scalars['Float']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FinanceReturnOrder = {
  __typename?: 'FinanceReturnOrder';
  completedDate?: Maybe<Scalars['Date']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** Null for an order Operations created in the backend after the logistics cutover. */
  salesforceId?: Maybe<Scalars['String']['output']>;
  salesforceUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Subscription items that look wrong in Salesforce. ACTIVE_STOPPED_WITHOUT_END: active, billing stopped, no end date. BILLED_NOT_ACTIVE: billed, but a draft, pending or ended item without an open Finance notification. ZERO_PRICE: active and billed at price 0. BILLOMAT: active and still billed through Billomat. */
export enum FinanceSalesforceCheck {
  ActiveStoppedWithoutEnd = 'ACTIVE_STOPPED_WITHOUT_END',
  BilledNotActive = 'BILLED_NOT_ACTIVE',
  Billomat = 'BILLOMAT',
  ZeroPrice = 'ZERO_PRICE'
}

export type FinanceSalesforceCheckCount = {
  __typename?: 'FinanceSalesforceCheckCount';
  check: FinanceSalesforceCheck;
  count: Scalars['Int']['output'];
  monthlyValue: Scalars['Float']['output'];
};

export type FinishActivitySessionInput = {
  endedAt: Scalars['Datetime']['input'];
  lifecycleAction?: InputMaybe<ProcedureLifecycleAction>;
  positionInSession?: InputMaybe<ActivitySessionPosition>;
  sessionId: Scalars['UUID']['input'];
  sessionStatus: SessionStatus;
};

/** The `attachment` to be created by this mutation. */
export type FkAttachmentMediaAttachmentCreateInput = {
  media?: InputMaybe<FkAttachmentMediaInput>;
  messageId?: InputMaybe<Scalars['UUID']['input']>;
  messageToMessageId?: InputMaybe<AttachmentMessageIdInput>;
};

/** Input for the nested mutation of `media` in the `AttachmentInput` mutation. */
export type FkAttachmentMediaInput = {
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectById?: InputMaybe<MediaMediaPkeyConnect>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MediaNodeIdConnect>;
  /** A `MediaInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkAttachmentMediaMediaCreateInput>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteById?: InputMaybe<MediaMediaPkeyDelete>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<MediaNodeIdDelete>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateById?: InputMaybe<MediaOnAttachmentForFkAttachmentMediaUsingMediaPkeyUpdate>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AttachmentOnAttachmentForFkAttachmentMediaNodeIdUpdate>;
};

/** Input for the nested mutation of `attachment` in the `MediaInput` mutation. */
export type FkAttachmentMediaInverseInput = {
  /** The primary key(s) for `attachment` for the far side of the relationship. */
  connectById?: InputMaybe<AttachmentAttachmentPkeyConnect>;
  /** The primary key(s) for `attachment` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AttachmentNodeIdConnect>;
  /** A `AttachmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FkAttachmentMediaAttachmentCreateInput>>;
  /** The primary key(s) for `attachment` for the far side of the relationship. */
  deleteById?: InputMaybe<AttachmentAttachmentPkeyDelete>;
  /** The primary key(s) for `attachment` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<AttachmentNodeIdDelete>;
  /** Flag indicating whether all other `attachment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `attachment` for the far side of the relationship. */
  updateById?: InputMaybe<AttachmentOnAttachmentForFkAttachmentMediaUsingAttachmentPkeyUpdate>;
  /** The primary key(s) and patch data for `attachment` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MediaOnAttachmentForFkAttachmentMediaNodeIdUpdate>;
};

/** The `media` to be created by this mutation. */
export type FkAttachmentMediaMediaCreateInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for the nested mutation of `organization` in the `LocationInput` mutation. */
export type FkLocationOrganizationInput = {
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByExternalId?: InputMaybe<OrganizationOrganizationExternalIdKeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectById?: InputMaybe<OrganizationOrganizationPkeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrganizationNodeIdConnect>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByExternalId?: InputMaybe<OrganizationOnLocationForFkLocationOrganizationUsingOrganizationExternalIdKeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateById?: InputMaybe<OrganizationOnLocationForFkLocationOrganizationUsingOrganizationPkeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<LocationOnLocationForFkLocationOrganizationNodeIdUpdate>;
};

/** Input for the nested mutation of `location` in the `OrganizationInput` mutation. */
export type FkLocationOrganizationInverseInput = {
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LocationLocationPkeyConnect>>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<LocationNodeIdConnect>>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<Array<LocationUqLocationExternalIdConnect>>;
  /** A `LocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FkLocationOrganizationLocationCreateInput>>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LocationLocationPkeyDelete>>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<LocationNodeIdDelete>>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<Array<LocationUqLocationExternalIdDelete>>;
  /** Flag indicating whether all other `location` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LocationOnLocationForFkLocationOrganizationUsingLocationPkeyUpdate>>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrganizationOnLocationForFkLocationOrganizationNodeIdUpdate>>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<Array<LocationOnLocationForFkLocationOrganizationUsingUqLocationExternalIdUpdate>>;
};

/** The `location` to be created by this mutation. */
export type FkLocationOrganizationLocationCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name: Scalars['String']['input'];
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Input for the nested mutation of `location` in the `LocationInput` mutation. */
export type FkLocationPartOfInput = {
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectById?: InputMaybe<LocationLocationPkeyConnect>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<LocationNodeIdConnect>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationUqLocationExternalIdConnect>;
  /** A `LocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkLocationPartOfLocationCreateInput>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteById?: InputMaybe<LocationLocationPkeyDelete>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<LocationNodeIdDelete>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationUqLocationExternalIdDelete>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateById?: InputMaybe<LocationOnLocationForFkLocationPartOfUsingLocationPkeyUpdate>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<LocationOnLocationForFkLocationPartOfNodeIdUpdate>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationOnLocationForFkLocationPartOfUsingUqLocationExternalIdUpdate>;
};

/** The `location` to be created by this mutation. */
export type FkLocationPartOfLocationCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Input for the nested mutation of `location` in the `LocationPractitionerInput` mutation. */
export type FkLocationPractitionersLocationInput = {
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectById?: InputMaybe<LocationLocationPkeyConnect>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<LocationNodeIdConnect>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationUqLocationExternalIdConnect>;
  /** A `LocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkLocationPractitionersLocationLocationCreateInput>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteById?: InputMaybe<LocationLocationPkeyDelete>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<LocationNodeIdDelete>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationUqLocationExternalIdDelete>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateById?: InputMaybe<LocationOnLocationPractitionerForFkLocationPractitionersLocationUsingLocationPkeyUpdate>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<LocationPractitionerOnLocationPractitionerForFkLocationPractitionersLocationNodeIdUpdate>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationOnLocationPractitionerForFkLocationPractitionersLocationUsingUqLocationExternalIdUpdate>;
};

/** Input for the nested mutation of `locationPractitioner` in the `LocationInput` mutation. */
export type FkLocationPractitionersLocationInverseInput = {
  /** The primary key(s) for `locationPractitioner` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<LocationPractitionerNodeIdConnect>>;
  /** The primary key(s) for `locationPractitioner` for the far side of the relationship. */
  connectByPractitionerIdAndLocationId?: InputMaybe<Array<LocationPractitionerLocationPractitionersPkeyConnect>>;
  /** The primary key(s) and patch data for `locationPractitioner` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<LocationOnLocationPractitionerForFkLocationPractitionersLocationNodeIdUpdate>>;
  /** The primary key(s) and patch data for `locationPractitioner` for the far side of the relationship. */
  updateByPractitionerIdAndLocationId?: InputMaybe<Array<LocationPractitionerOnLocationPractitionerForFkLocationPractitionersLocationUsingLocationPractitionersPkeyUpdate>>;
};

/** The `location` to be created by this mutation. */
export type FkLocationPractitionersLocationLocationCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Input for the nested mutation of `practitioner` in the `LocationPractitionerInput` mutation. */
export type FkLocationPractitionersPractitionerInput = {
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectById?: InputMaybe<PractitionerPractitionerPkeyConnect>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<PractitionerNodeIdConnect>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PractitionerUqPractitionerExternalIdConnect>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectByUserId?: InputMaybe<PractitionerPractitionerUserIdKeyConnect>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateById?: InputMaybe<PractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerUsingPractitionerPkeyUpdate>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<LocationPractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerNodeIdUpdate>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerUsingUqPractitionerExternalIdUpdate>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateByUserId?: InputMaybe<PractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerUsingPractitionerUserIdKeyUpdate>;
};

/** Input for the nested mutation of `locationPractitioner` in the `PractitionerInput` mutation. */
export type FkLocationPractitionersPractitionerInverseInput = {
  /** The primary key(s) for `locationPractitioner` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<LocationPractitionerNodeIdConnect>>;
  /** The primary key(s) for `locationPractitioner` for the far side of the relationship. */
  connectByPractitionerIdAndLocationId?: InputMaybe<Array<LocationPractitionerLocationPractitionersPkeyConnect>>;
  /** The primary key(s) and patch data for `locationPractitioner` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<PractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerNodeIdUpdate>>;
  /** The primary key(s) and patch data for `locationPractitioner` for the far side of the relationship. */
  updateByPractitionerIdAndLocationId?: InputMaybe<Array<LocationPractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerUsingLocationPractitionersPkeyUpdate>>;
};

/** Input for the nested mutation of `organization` in the `OrganizationPractitionerInput` mutation. */
export type FkOrganizationInput = {
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByExternalId?: InputMaybe<OrganizationOrganizationExternalIdKeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectById?: InputMaybe<OrganizationOrganizationPkeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrganizationNodeIdConnect>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByExternalId?: InputMaybe<OrganizationOnOrganizationPractitionerForFkOrganizationUsingOrganizationExternalIdKeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateById?: InputMaybe<OrganizationOnOrganizationPractitionerForFkOrganizationUsingOrganizationPkeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrganizationPractitionerOnOrganizationPractitionerForFkOrganizationNodeIdUpdate>;
};

/** Input for the nested mutation of `organizationPractitioner` in the `OrganizationInput` mutation. */
export type FkOrganizationInverseInput = {
  /** The primary key(s) for `organizationPractitioner` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OrganizationPractitionerNodeIdConnect>>;
  /** The primary key(s) for `organizationPractitioner` for the far side of the relationship. */
  connectByPractitionerIdAndOrganizationId?: InputMaybe<Array<OrganizationPractitionerOrganizationPractitionersPkeyConnect>>;
  /** The primary key(s) and patch data for `organizationPractitioner` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrganizationOnOrganizationPractitionerForFkOrganizationNodeIdUpdate>>;
  /** The primary key(s) and patch data for `organizationPractitioner` for the far side of the relationship. */
  updateByPractitionerIdAndOrganizationId?: InputMaybe<Array<OrganizationPractitionerOnOrganizationPractitionerForFkOrganizationUsingOrganizationPractitionersPkeyUpdate>>;
};

/** Input for the nested mutation of `organization` in the `PatientInput` mutation. */
export type FkPatientOrganizationInput = {
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByExternalId?: InputMaybe<OrganizationOrganizationExternalIdKeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectById?: InputMaybe<OrganizationOrganizationPkeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrganizationNodeIdConnect>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByExternalId?: InputMaybe<OrganizationOnPatientForFkPatientOrganizationUsingOrganizationExternalIdKeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateById?: InputMaybe<OrganizationOnPatientForFkPatientOrganizationUsingOrganizationPkeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<PatientOnPatientForFkPatientOrganizationNodeIdUpdate>;
};

/** Input for the nested mutation of `patient` in the `OrganizationInput` mutation. */
export type FkPatientOrganizationInverseInput = {
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PatientPkFhirPatientConnect>>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<PatientNodeIdConnect>>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<PatientUqPatientExternalIdConnect>>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByUserId?: InputMaybe<Array<PatientUqPatientUserIdConnect>>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PatientOnPatientForFkPatientOrganizationUsingPkFhirPatientUpdate>>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrganizationOnPatientForFkPatientOrganizationNodeIdUpdate>>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<PatientOnPatientForFkPatientOrganizationUsingUqPatientExternalIdUpdate>>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByUserId?: InputMaybe<Array<PatientOnPatientForFkPatientOrganizationUsingUqPatientUserIdUpdate>>;
};

/** Input for the nested mutation of `user` in the `OrganizationPractitionerInput` mutation. */
export type FkPractitionerInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkPractitionerUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnOrganizationPractitionerForFkPractitionerUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrganizationPractitionerOnOrganizationPractitionerForFkPractitionerNodeIdUpdate>;
};

/** Input for the nested mutation of `organizationPractitioner` in the `UserInput` mutation. */
export type FkPractitionerInverseInput = {
  /** The primary key(s) for `organizationPractitioner` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OrganizationPractitionerNodeIdConnect>>;
  /** The primary key(s) for `organizationPractitioner` for the far side of the relationship. */
  connectByPractitionerIdAndOrganizationId?: InputMaybe<Array<OrganizationPractitionerOrganizationPractitionersPkeyConnect>>;
  /** The primary key(s) and patch data for `organizationPractitioner` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnOrganizationPractitionerForFkPractitionerNodeIdUpdate>>;
  /** The primary key(s) and patch data for `organizationPractitioner` for the far side of the relationship. */
  updateByPractitionerIdAndOrganizationId?: InputMaybe<Array<OrganizationPractitionerOnOrganizationPractitionerForFkPractitionerUsingOrganizationPractitionersPkeyUpdate>>;
};

/** The `user` to be created by this mutation. */
export type FkPractitionerUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** Input for the nested mutation of `user` in the `PatientInput` mutation. */
export type FkUserInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkUserUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPatientForFkUserUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<PatientOnPatientForFkUserNodeIdUpdate>;
};

/** Input for the nested mutation of `patient` in the `UserInput` mutation. */
export type FkUserInverseInput = {
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectById?: InputMaybe<PatientPkFhirPatientConnect>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<PatientNodeIdConnect>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PatientUqPatientExternalIdConnect>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByUserId?: InputMaybe<PatientUqPatientUserIdConnect>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateById?: InputMaybe<PatientOnPatientForFkUserUsingPkFhirPatientUpdate>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserOnPatientForFkUserNodeIdUpdate>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PatientOnPatientForFkUserUsingUqPatientExternalIdUpdate>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByUserId?: InputMaybe<PatientOnPatientForFkUserUsingUqPatientUserIdUpdate>;
};

/** The `user` to be created by this mutation. */
export type FkUserUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

export enum Flavour {
  B2b = 'b2b',
  B2bBasic = 'b2bBasic',
  B2c = 'b2c',
  Caregiver = 'caregiver',
  Games = 'games',
  Korian = 'korian',
  Redurisk = 'redurisk'
}

/** All input for the `forgotPassword` mutation. */
export type ForgotPasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `forgotPassword` mutation. */
export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type FormQuestionResponseInput = {
  authorId: Scalars['UUID']['input'];
  formId: Scalars['Int']['input'];
  id: Scalars['UUID']['input'];
  questionId: Scalars['Int']['input'];
  response: Array<Scalars['String']['input']>;
};

export type FormResponse = Node & {
  __typename?: 'FormResponse';
  /** Reads a single `User` that is related to this `FormResponse`. */
  author?: Maybe<User>;
  authorId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  formId: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  questionId: Scalars['Int']['output'];
  response: Array<Maybe<Scalars['String']['output']>>;
  updatedAt: Scalars['Datetime']['output'];
};

/** Input for the nested mutation of `user` in the `FormResponseInput` mutation. */
export type FormResponseAuthorFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormResponseAuthorFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFormResponseForFormResponseAuthorFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<FormResponseOnFormResponseForFormResponseAuthorFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `formResponse` in the `UserInput` mutation. */
export type FormResponseAuthorFkeyInverseInput = {
  /** The primary key(s) for `formResponse` for the far side of the relationship. */
  connectByAuthorIdAndFormIdAndQuestionId?: InputMaybe<Array<FormResponseUniqueFormResponseConnect>>;
  /** The primary key(s) for `formResponse` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormResponseFormResponsePkeyConnect>>;
  /** The primary key(s) for `formResponse` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<FormResponseNodeIdConnect>>;
  /** The primary key(s) and patch data for `formResponse` for the far side of the relationship. */
  updateByAuthorIdAndFormIdAndQuestionId?: InputMaybe<Array<FormResponseOnFormResponseForFormResponseAuthorFkeyUsingUniqueFormResponseUpdate>>;
  /** The primary key(s) and patch data for `formResponse` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormResponseOnFormResponseForFormResponseAuthorFkeyUsingFormResponsePkeyUpdate>>;
  /** The primary key(s) and patch data for `formResponse` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnFormResponseForFormResponseAuthorFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type FormResponseAuthorFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/**
 * A condition to be used against `FormResponse` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FormResponseCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `formResponse` to look up the row to connect. */
export type FormResponseFormResponsePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type FormResponseNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `formResponse` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type FormResponseOnFormResponseForFormResponseAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `formResponse` to look up the row to update. */
export type FormResponseOnFormResponseForFormResponseAuthorFkeyUsingFormResponsePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `formResponse` being updated. */
  patch: UpdateFormResponseOnFormResponseForFormResponseAuthorFkeyPatch;
};

/** The fields on `formResponse` to look up the row to update. */
export type FormResponseOnFormResponseForFormResponseAuthorFkeyUsingUniqueFormResponseUpdate = {
  authorId: Scalars['UUID']['input'];
  formId: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `formResponse` being updated. */
  patch: UpdateFormResponseOnFormResponseForFormResponseAuthorFkeyPatch;
  questionId: Scalars['Int']['input'];
};

/** Represents an update to a `FormResponse`. Fields that are set will be updated. */
export type FormResponsePatch = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<FormResponseAuthorFkeyInput>;
};

/** The fields on `formResponse` to look up the row to connect. */
export type FormResponseUniqueFormResponseConnect = {
  authorId: Scalars['UUID']['input'];
  formId: Scalars['Int']['input'];
  questionId: Scalars['Int']['input'];
};

/** A connection to a list of `FormResponse` values. */
export type FormResponsesConnection = {
  __typename?: 'FormResponsesConnection';
  /** A list of edges which contains the `FormResponse` and cursor to aid in pagination. */
  edges: Array<FormResponsesEdge>;
  /** A list of `FormResponse` objects. */
  nodes: Array<FormResponse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FormResponse` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FormResponse` edge in the connection. */
export type FormResponsesEdge = {
  __typename?: 'FormResponsesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FormResponse` at the end of the edge. */
  node: FormResponse;
};

/** Methods to use when ordering `FormResponse`. */
export enum FormResponsesOrderBy {
  AuthorIdAsc = 'AUTHOR_ID_ASC',
  AuthorIdDesc = 'AUTHOR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type FullAttachment = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: AttachmentKind;
  md5?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type FullMessage = {
  attachmentsUsingId?: InputMaybe<AttachmentsUsingId>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  chatId?: InputMaybe<Scalars['UUID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  senderKeyId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum GenderEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type GenerateToyDatasetFromFamilyReturn = {
  __typename?: 'GenerateToyDatasetFromFamilyReturn';
  invitedRelativeEmails: Array<Maybe<Scalars['String']['output']>>;
  recoveryKey: Scalars['String']['output'];
  relativeEmails: Array<Maybe<Scalars['String']['output']>>;
};

export type GetContentUrlsReturn = {
  __typename?: 'GetContentUrlsReturn';
  contentVersionInfo?: Maybe<ContentVersion>;
  newContent: Scalars['Boolean']['output'];
};

export type GetContentUrlsReturnV2 = {
  __typename?: 'GetContentUrlsReturnV2';
  contentUrls: ContentUrlsV2;
  contentVersion: Scalars['String']['output'];
};

export type GrantResult = {
  __typename?: 'GrantResult';
  grant: LearningGrant;
};

export type Group = Node & {
  __typename?: 'Group';
  avatar?: Maybe<Scalars['UUID']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  kind: GroupType;
  /** Returns the current user's last message for the given group */
  lastMessageForCurrentUser?: Maybe<Message>;
  /** Returns the minimum last_read timestamp of all members of the given group */
  lastReadByAll?: Maybe<Scalars['Datetime']['output']>;
  /** Returns the current user's last read timestamp for the given group */
  lastReadTimestampForCurrentUser?: Maybe<Scalars['Datetime']['output']>;
  /** Returns the minimum last_received timestamp of all members of the given group */
  lastReceivedByAll?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Media` that is related to this `Group`. */
  mediaByAvatar?: Maybe<Media>;
  memberDevices?: Maybe<Array<Maybe<MemberDevice>>>;
  /** Reads and enables pagination through a set of `User`. */
  members: GroupMembersManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  membersList: Array<User>;
  /** Reads and enables pagination through a set of `Membership`. */
  memberships: MembershipsConnection;
  /** Reads and enables pagination through a set of `Membership`. */
  membershipsList: Array<Membership>;
  /** Reads and enables pagination through a set of `Message`. */
  messages: MessagesConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesList: Array<Message>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  relatedSeniorEncryptionMode?: Maybe<EncryptionMode>;
  /** Reads and enables pagination through a set of `SenderKey`. */
  senderKeys: SenderKeysConnection;
  /** Reads and enables pagination through a set of `SenderKey`. */
  senderKeysList: Array<SenderKey>;
  supportedFeatures?: Maybe<Array<Maybe<AppFeature>>>;
  /** Returns the current user's unread messages count for the given group */
  unreadCountForCurrentUser?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `User`. */
  usersByInvitationInvitedToAndInvitedBy: GroupUsersByInvitationInvitedToAndInvitedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByInvitationInvitedToAndInvitedByList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByMessageChatIdAndAuthorId: GroupUsersByMessageChatIdAndAuthorIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByMessageChatIdAndAuthorIdList: Array<User>;
};


export type GroupMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GroupMembersListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GroupMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type GroupMembershipsListArgs = {
  condition?: InputMaybe<MembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type GroupMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type GroupMessagesListArgs = {
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type GroupSenderKeysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SenderKeyCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SenderKeysOrderBy>>;
};


export type GroupSenderKeysListArgs = {
  condition?: InputMaybe<SenderKeyCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SenderKeysOrderBy>>;
};


export type GroupUsersByInvitationInvitedToAndInvitedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GroupUsersByInvitationInvitedToAndInvitedByListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GroupUsersByMessageChatIdAndAuthorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GroupUsersByMessageChatIdAndAuthorIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** The `group` to be created by this mutation. */
export type GroupAvatarMediaFkeyGroupCreateInput = {
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind: GroupType;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** Input for the nested mutation of `media` in the `GroupInput` mutation. */
export type GroupAvatarMediaFkeyInput = {
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectById?: InputMaybe<MediaMediaPkeyConnect>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MediaNodeIdConnect>;
  /** A `MediaInput` object that will be created and connected to this object. */
  create?: InputMaybe<GroupAvatarMediaFkeyMediaCreateInput>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteById?: InputMaybe<MediaMediaPkeyDelete>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<MediaNodeIdDelete>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateById?: InputMaybe<MediaOnGroupForGroupAvatarMediaFkeyUsingMediaPkeyUpdate>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<GroupOnGroupForGroupAvatarMediaFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `group` in the `MediaInput` mutation. */
export type GroupAvatarMediaFkeyInverseInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GroupGroupPkeyConnect>>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<GroupNodeIdConnect>>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<GroupAvatarMediaFkeyGroupCreateInput>>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GroupOnGroupForGroupAvatarMediaFkeyUsingGroupPkeyUpdate>>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<MediaOnGroupForGroupAvatarMediaFkeyNodeIdUpdate>>;
};

/** The `media` to be created by this mutation. */
export type GroupAvatarMediaFkeyMediaCreateInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Group` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GroupCondition = {
  /** Checks for equality with the object’s `avatar` field. */
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<GroupType>;
};

/** The fields on `group` to look up the row to connect. */
export type GroupGroupPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** An input for mutations affecting `Group` */
export type GroupInput = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind: GroupType;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** A connection to a list of `User` values, with data from `Membership`. */
export type GroupMembersManyToManyConnection = {
  __typename?: 'GroupMembersManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Membership`, and the cursor to aid in pagination. */
  edges: Array<GroupMembersManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `Membership`. */
export type GroupMembersManyToManyEdge = {
  __typename?: 'GroupMembersManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastRead: Scalars['Datetime']['output'];
  lastReceived?: Maybe<Scalars['Datetime']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** The globally unique `ID` look up for the row to connect. */
export type GroupNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type GroupOnGroupForGroupAvatarMediaFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `media` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: MediaPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnGroupForGroupAvatarMediaFkeyUsingGroupPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnGroupForGroupAvatarMediaFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type GroupOnInvitationForInvitationInvitedToFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `invitation` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `invitation` being updated. */
  patch: InvitationPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnInvitationForInvitationInvitedToFkeyUsingGroupPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnInvitationForInvitationInvitedToFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type GroupOnMembershipForMembershipGroupIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `membership` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `membership` being updated. */
  patch: MembershipPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnMembershipForMembershipGroupIdUsingGroupPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnMembershipForMembershipGroupIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type GroupOnMessageForMessageChatIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `message` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: MessagePatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnMessageForMessageChatIdUsingGroupPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnMessageForMessageChatIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type GroupOnSenderKeyForSenderKeyGroupIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `senderKey` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `senderKey` being updated. */
  patch: SenderKeyPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnSenderKeyForSenderKeyGroupIdUsingGroupPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnSenderKeyForSenderKeyGroupIdPatch;
};

/** Represents an update to a `Group`. Fields that are set will be updated. */
export type GroupPatch = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind?: InputMaybe<GroupType>;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

export type GroupProfileInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  avatarMedia?: InputMaybe<AvatarMediaInput>;
  kind?: InputMaybe<GroupType>;
  name: Scalars['String']['input'];
};

export type GroupSubscriptionPayload = {
  __typename?: 'GroupSubscriptionPayload';
  group: Group;
};

export enum GroupType {
  FamilyChat = 'FAMILY_CHAT',
  GroupChat = 'GROUP_CHAT',
  PrivateChat = 'PRIVATE_CHAT',
  ReduriskChat = 'REDURISK_CHAT'
}

/** A connection to a list of `User` values, with data from `Invitation`. */
export type GroupUsersByInvitationInvitedToAndInvitedByManyToManyConnection = {
  __typename?: 'GroupUsersByInvitationInvitedToAndInvitedByManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Invitation`, and the cursor to aid in pagination. */
  edges: Array<GroupUsersByInvitationInvitedToAndInvitedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `Invitation`. */
export type GroupUsersByInvitationInvitedToAndInvitedByManyToManyEdge = {
  __typename?: 'GroupUsersByInvitationInvitedToAndInvitedByManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Reads and enables pagination through a set of `Invitation`. */
  invitationsByInvitedBy: InvitationsConnection;
  /** Reads and enables pagination through a set of `Invitation`. */
  invitationsByInvitedByList: Array<Invitation>;
  /** The `User` at the end of the edge. */
  node: User;
};


/** A `User` edge in the connection, with data from `Invitation`. */
export type GroupUsersByInvitationInvitedToAndInvitedByManyToManyEdgeInvitationsByInvitedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvitationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};


/** A `User` edge in the connection, with data from `Invitation`. */
export type GroupUsersByInvitationInvitedToAndInvitedByManyToManyEdgeInvitationsByInvitedByListArgs = {
  condition?: InputMaybe<InvitationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};

/** A connection to a list of `User` values, with data from `Message`. */
export type GroupUsersByMessageChatIdAndAuthorIdManyToManyConnection = {
  __typename?: 'GroupUsersByMessageChatIdAndAuthorIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Message`, and the cursor to aid in pagination. */
  edges: Array<GroupUsersByMessageChatIdAndAuthorIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `Message`. */
export type GroupUsersByMessageChatIdAndAuthorIdManyToManyEdge = {
  __typename?: 'GroupUsersByMessageChatIdAndAuthorIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Reads and enables pagination through a set of `Message`. */
  messagesAuthored: MessagesConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesAuthoredList: Array<Message>;
  /** The `User` at the end of the edge. */
  node: User;
};


/** A `User` edge in the connection, with data from `Message`. */
export type GroupUsersByMessageChatIdAndAuthorIdManyToManyEdgeMessagesAuthoredArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


/** A `User` edge in the connection, with data from `Message`. */
export type GroupUsersByMessageChatIdAndAuthorIdManyToManyEdgeMessagesAuthoredListArgs = {
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};

/** A connection to a list of `Group` values. */
export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  /** A list of edges which contains the `Group` and cursor to aid in pagination. */
  edges: Array<GroupsEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Group>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Group` edge in the connection. */
export type GroupsEdge = {
  __typename?: 'GroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Group` at the end of the edge. */
  node: Group;
};

/** Methods to use when ordering `Group`. */
export enum GroupsOrderBy {
  AvatarAsc = 'AVATAR_ASC',
  AvatarDesc = 'AVATAR_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KindAsc = 'KIND_ASC',
  KindDesc = 'KIND_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type HandshakeCode = Node & {
  __typename?: 'HandshakeCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  expiresAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  initiatorId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Workgroup` that is related to this `HandshakeCode`. */
  workgroup?: Maybe<Workgroup>;
  workgroupId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `HandshakeCode` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type HandshakeCodeCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `workgroupId` field. */
  workgroupId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `handshakeCode` to look up the row to connect. */
export type HandshakeCodeHandshakeCodesPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `handshakeCode` to look up the row to delete. */
export type HandshakeCodeHandshakeCodesPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** An input for mutations affecting `HandshakeCode` */
export type HandshakeCodeInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt: Scalars['Datetime']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  initiatorId: Scalars['UUID']['input'];
  workgroupId?: InputMaybe<Scalars['UUID']['input']>;
  workgroupToWorkgroupId?: InputMaybe<HandshakeCodesWorkgroupIdInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type HandshakeCodeNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `handshakeCode` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type HandshakeCodeNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `handshakeCode` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type HandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `workgroup` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `workgroup` being updated. */
  patch: WorkgroupPatch;
};

/** The fields on `handshakeCode` to look up the row to update. */
export type HandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdUsingHandshakeCodesPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `handshakeCode` being updated. */
  patch: UpdateHandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdPatch;
};

/** The fields on `handshakeCode` to look up the row to update. */
export type HandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdUsingUnqHandshakeCodesCodeUpdate = {
  code: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `handshakeCode` being updated. */
  patch: UpdateHandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdPatch;
};

/** The fields on `handshakeCode` to look up the row to update. */
export type HandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdUsingUnqHandshakeCodesInitiatorUpdate = {
  initiatorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `handshakeCode` being updated. */
  patch: UpdateHandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdPatch;
  workgroupId: Scalars['UUID']['input'];
};

/** Represents an update to a `HandshakeCode`. Fields that are set will be updated. */
export type HandshakeCodePatch = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  initiatorId?: InputMaybe<Scalars['UUID']['input']>;
  workgroupId?: InputMaybe<Scalars['UUID']['input']>;
  workgroupToWorkgroupId?: InputMaybe<HandshakeCodesWorkgroupIdInput>;
};

/** The fields on `handshakeCode` to look up the row to connect. */
export type HandshakeCodeUnqHandshakeCodesCodeConnect = {
  code: Scalars['String']['input'];
};

/** The fields on `handshakeCode` to look up the row to delete. */
export type HandshakeCodeUnqHandshakeCodesCodeDelete = {
  code: Scalars['String']['input'];
};

/** The fields on `handshakeCode` to look up the row to connect. */
export type HandshakeCodeUnqHandshakeCodesInitiatorConnect = {
  initiatorId: Scalars['UUID']['input'];
  workgroupId: Scalars['UUID']['input'];
};

/** The fields on `handshakeCode` to look up the row to delete. */
export type HandshakeCodeUnqHandshakeCodesInitiatorDelete = {
  initiatorId: Scalars['UUID']['input'];
  workgroupId: Scalars['UUID']['input'];
};

/** A connection to a list of `HandshakeCode` values. */
export type HandshakeCodesConnection = {
  __typename?: 'HandshakeCodesConnection';
  /** A list of edges which contains the `HandshakeCode` and cursor to aid in pagination. */
  edges: Array<HandshakeCodesEdge>;
  /** A list of `HandshakeCode` objects. */
  nodes: Array<HandshakeCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HandshakeCode` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `HandshakeCode` edge in the connection. */
export type HandshakeCodesEdge = {
  __typename?: 'HandshakeCodesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `HandshakeCode` at the end of the edge. */
  node: HandshakeCode;
};

/** Methods to use when ordering `HandshakeCode`. */
export enum HandshakeCodesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WorkgroupIdAsc = 'WORKGROUP_ID_ASC',
  WorkgroupIdDesc = 'WORKGROUP_ID_DESC'
}

/** The `handshakeCode` to be created by this mutation. */
export type HandshakeCodesWorkgroupIdHandshakeCodesCreateInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt: Scalars['Datetime']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  initiatorId: Scalars['UUID']['input'];
  workgroupToWorkgroupId?: InputMaybe<HandshakeCodesWorkgroupIdInput>;
};

/** Input for the nested mutation of `workgroup` in the `HandshakeCodeInput` mutation. */
export type HandshakeCodesWorkgroupIdInput = {
  /** The primary key(s) for `workgroup` for the far side of the relationship. */
  connectById?: InputMaybe<WorkgroupWorkgroupPkeyConnect>;
  /** The primary key(s) for `workgroup` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<WorkgroupNodeIdConnect>;
  /** A `WorkgroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<HandshakeCodesWorkgroupIdWorkgroupCreateInput>;
  /** The primary key(s) for `workgroup` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkgroupWorkgroupPkeyDelete>;
  /** The primary key(s) for `workgroup` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<WorkgroupNodeIdDelete>;
  /** The primary key(s) and patch data for `workgroup` for the far side of the relationship. */
  updateById?: InputMaybe<WorkgroupOnHandshakeCodeForHandshakeCodesWorkgroupIdUsingWorkgroupPkeyUpdate>;
  /** The primary key(s) and patch data for `workgroup` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<HandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdNodeIdUpdate>;
};

/** Input for the nested mutation of `handshakeCode` in the `WorkgroupInput` mutation. */
export type HandshakeCodesWorkgroupIdInverseInput = {
  /** The primary key(s) for `handshakeCode` for the far side of the relationship. */
  connectByCode?: InputMaybe<Array<HandshakeCodeUnqHandshakeCodesCodeConnect>>;
  /** The primary key(s) for `handshakeCode` for the far side of the relationship. */
  connectById?: InputMaybe<Array<HandshakeCodeHandshakeCodesPkeyConnect>>;
  /** The primary key(s) for `handshakeCode` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<HandshakeCodeNodeIdConnect>>;
  /** The primary key(s) for `handshakeCode` for the far side of the relationship. */
  connectByWorkgroupIdAndInitiatorId?: InputMaybe<Array<HandshakeCodeUnqHandshakeCodesInitiatorConnect>>;
  /** A `HandshakeCodeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<HandshakeCodesWorkgroupIdHandshakeCodesCreateInput>>;
  /** The primary key(s) for `handshakeCode` for the far side of the relationship. */
  deleteByCode?: InputMaybe<Array<HandshakeCodeUnqHandshakeCodesCodeDelete>>;
  /** The primary key(s) for `handshakeCode` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<HandshakeCodeHandshakeCodesPkeyDelete>>;
  /** The primary key(s) for `handshakeCode` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<HandshakeCodeNodeIdDelete>>;
  /** The primary key(s) for `handshakeCode` for the far side of the relationship. */
  deleteByWorkgroupIdAndInitiatorId?: InputMaybe<Array<HandshakeCodeUnqHandshakeCodesInitiatorDelete>>;
  /** Flag indicating whether all other `handshakeCode` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `handshakeCode` for the far side of the relationship. */
  updateByCode?: InputMaybe<Array<HandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdUsingUnqHandshakeCodesCodeUpdate>>;
  /** The primary key(s) and patch data for `handshakeCode` for the far side of the relationship. */
  updateById?: InputMaybe<Array<HandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdUsingHandshakeCodesPkeyUpdate>>;
  /** The primary key(s) and patch data for `handshakeCode` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<WorkgroupOnHandshakeCodeForHandshakeCodesWorkgroupIdNodeIdUpdate>>;
  /** The primary key(s) and patch data for `handshakeCode` for the far side of the relationship. */
  updateByWorkgroupIdAndInitiatorId?: InputMaybe<Array<HandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdUsingUnqHandshakeCodesInitiatorUpdate>>;
};

/** The `workgroup` to be created by this mutation. */
export type HandshakeCodesWorkgroupIdWorkgroupCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  handshakeCodesUsingId?: InputMaybe<HandshakeCodesWorkgroupIdInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipWorkgroupIdInverseInput>;
};

export type IncludeProcedureManualNoteInput = {
  included: Scalars['Boolean']['input'];
  procedureId: Scalars['UUID']['input'];
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type IntegrationConnectionCheck = {
  __typename?: 'IntegrationConnectionCheck';
  durationMs: Scalars['Int']['output'];
  error?: Maybe<IntegrationConnectionError>;
  httpStatus?: Maybe<Scalars['Int']['output']>;
  locationCount?: Maybe<Scalars['Int']['output']>;
  ok: Scalars['Boolean']['output'];
  provider?: Maybe<IntegrationProvider>;
  stage?: Maybe<IntegrationConnectionStage>;
};

export enum IntegrationConnectionError {
  Credentials = 'credentials',
  HttpError = 'http_error',
  InvalidResponse = 'invalid_response',
  NotConfigured = 'not_configured',
  Timeout = 'timeout',
  Tls = 'tls',
  Unknown = 'unknown',
  Unreachable = 'unreachable',
  Unsupported = 'unsupported'
}

export enum IntegrationConnectionStage {
  Read = 'read',
  Token = 'token'
}

export type IntegrationCredentials = {
  __typename?: 'IntegrationCredentials';
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  serverUrl?: Maybe<Scalars['String']['output']>;
};

export type IntegrationCredentialsInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  serverUrl?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationExecution = {
  __typename?: 'IntegrationExecution';
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  kind: IntegrationExecutionKind;
  organizationId: Scalars['UUID']['output'];
  provider: IntegrationProvider;
  result?: Maybe<IntegrationExecutionResult>;
  startedAt: Scalars['Datetime']['output'];
  status: IntegrationExecutionStatus;
  summary?: Maybe<Scalars['JSON']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export enum IntegrationExecutionKind {
  Import = 'import',
  Preview = 'preview'
}

export enum IntegrationExecutionResult {
  Error = 'error',
  Success = 'success',
  Warning = 'warning'
}

export enum IntegrationExecutionStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Running = 'running'
}

export type IntegrationExecutionsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationImportPreview = {
  __typename?: 'IntegrationImportPreview';
  createdAt: Scalars['Datetime']['output'];
  executionId: Scalars['UUID']['output'];
  expiresAt: Scalars['Datetime']['output'];
  failures: Array<IntegrationPreviewIssue>;
  locations: Array<IntegrationPreviewLocation>;
  organizationId: Scalars['UUID']['output'];
  patients: Array<IntegrationPreviewPerson>;
  practitioners: Array<IntegrationPreviewPerson>;
  procedureCount: Scalars['Int']['output'];
  provider: IntegrationProvider;
  warnings: Array<IntegrationPreviewIssue>;
};

export type IntegrationImportPreviewCounts = {
  __typename?: 'IntegrationImportPreviewCounts';
  locations: IntegrationPreviewCounts;
  patients: IntegrationPreviewCounts;
  practitioners: IntegrationPreviewCounts;
};

export enum IntegrationPreviewChange {
  Changed = 'changed',
  Failed = 'failed',
  New = 'new',
  Unchanged = 'unchanged'
}

export type IntegrationPreviewCounts = {
  __typename?: 'IntegrationPreviewCounts';
  changed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  unchanged: Scalars['Int']['output'];
};

export type IntegrationPreviewIssue = {
  __typename?: 'IntegrationPreviewIssue';
  entity: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
};

export type IntegrationPreviewLocation = {
  __typename?: 'IntegrationPreviewLocation';
  change: IntegrationPreviewChange;
  externalId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<IntegrationPreviewLocationRef>;
  type: LocationTypeEnum;
};

export type IntegrationPreviewLocationRef = {
  __typename?: 'IntegrationPreviewLocationRef';
  externalId: Scalars['String']['output'];
  type: LocationTypeEnum;
};

export type IntegrationPreviewPerson = {
  __typename?: 'IntegrationPreviewPerson';
  change: IntegrationPreviewChange;
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  locations: Array<IntegrationPreviewLocationRef>;
  number?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationProvider {
  MedifoxDan = 'MedifoxDan',
  Senso = 'Senso',
  Vivendi = 'Vivendi'
}

export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  credentials: IntegrationCredentials;
  hasClientSecret: Scalars['Boolean']['output'];
  organizationId: Scalars['UUID']['output'];
  provider: IntegrationProvider;
};

export type InvalidateContentUrlsCacheInput = {
  cmsEnvironment: CmsEnvironment;
  contentMode: ContentMode;
  flavour: Flavour;
};

export type Invitation = Node & {
  __typename?: 'Invitation';
  createdAt: Scalars['Datetime']['output'];
  email: Scalars['String']['output'];
  errorMsg?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `Invitation`. */
  groupByInvitedTo?: Maybe<Group>;
  id: Scalars['UUID']['output'];
  invitationKind?: Maybe<UserType>;
  invitedBy?: Maybe<Scalars['UUID']['output']>;
  invitedTo?: Maybe<Scalars['UUID']['output']>;
  /** Deprecated and no longer read: the account's ambulant setting applies. */
  managerOrganizationAmbulant: Scalars['Boolean']['output'];
  /** Salesforce account (crm.account) whose licence manager this manager invitation is for. No foreign key. */
  managerSalesforceAccountId?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  status: EmailStatus;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Invitation`. */
  userByInvitedBy?: Maybe<User>;
};

/**
 * A condition to be used against `Invitation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type InvitationCondition = {
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `invitationKind` field. */
  invitationKind?: InputMaybe<UserType>;
  /** Checks for equality with the object’s `invitedBy` field. */
  invitedBy?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `invitedTo` field. */
  invitedTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `managerSalesforceAccountId` field. */
  managerSalesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<EmailStatus>;
};

/** The fields on `invitation` to look up the row to connect. */
export type InvitationInvitationPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `invitation` to look up the row to delete. */
export type InvitationInvitationPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `user` in the `InvitationInput` mutation. */
export type InvitationInvitedByFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<InvitationInvitedByFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnInvitationForInvitationInvitedByFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InvitationOnInvitationForInvitationInvitedByFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `invitation` in the `UserInput` mutation. */
export type InvitationInvitedByFkeyInverseInput = {
  /** The primary key(s) for `invitation` for the far side of the relationship. */
  connectById?: InputMaybe<Array<InvitationInvitationPkeyConnect>>;
  /** The primary key(s) for `invitation` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<InvitationNodeIdConnect>>;
  /** The primary key(s) for `invitation` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<InvitationInvitationPkeyDelete>>;
  /** The primary key(s) for `invitation` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<InvitationNodeIdDelete>>;
  /** Flag indicating whether all other `invitation` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `invitation` for the far side of the relationship. */
  updateById?: InputMaybe<Array<InvitationOnInvitationForInvitationInvitedByFkeyUsingInvitationPkeyUpdate>>;
  /** The primary key(s) and patch data for `invitation` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnInvitationForInvitationInvitedByFkeyNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type InvitationInvitedByFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The `group` to be created by this mutation. */
export type InvitationInvitedToFkeyGroupCreateInput = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind: GroupType;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** Input for the nested mutation of `group` in the `InvitationInput` mutation. */
export type InvitationInvitedToFkeyInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<GroupNodeIdConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<InvitationInvitedToFkeyGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnInvitationForInvitationInvitedToFkeyUsingGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<InvitationOnInvitationForInvitationInvitedToFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `invitation` in the `GroupInput` mutation. */
export type InvitationInvitedToFkeyInverseInput = {
  /** The primary key(s) for `invitation` for the far side of the relationship. */
  connectById?: InputMaybe<Array<InvitationInvitationPkeyConnect>>;
  /** The primary key(s) for `invitation` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<InvitationNodeIdConnect>>;
  /** The primary key(s) for `invitation` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<InvitationInvitationPkeyDelete>>;
  /** The primary key(s) for `invitation` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<InvitationNodeIdDelete>>;
  /** Flag indicating whether all other `invitation` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `invitation` for the far side of the relationship. */
  updateById?: InputMaybe<Array<InvitationOnInvitationForInvitationInvitedToFkeyUsingInvitationPkeyUpdate>>;
  /** The primary key(s) and patch data for `invitation` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<GroupOnInvitationForInvitationInvitedToFkeyNodeIdUpdate>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type InvitationNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `invitation` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type InvitationNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `invitation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type InvitationOnInvitationForInvitationInvitedByFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `invitation` to look up the row to update. */
export type InvitationOnInvitationForInvitationInvitedByFkeyUsingInvitationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `invitation` being updated. */
  patch: UpdateInvitationOnInvitationForInvitationInvitedByFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type InvitationOnInvitationForInvitationInvitedToFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: GroupPatch;
};

/** The fields on `invitation` to look up the row to update. */
export type InvitationOnInvitationForInvitationInvitedToFkeyUsingInvitationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `invitation` being updated. */
  patch: UpdateInvitationOnInvitationForInvitationInvitedToFkeyPatch;
};

/** Represents an update to a `Invitation`. Fields that are set will be updated. */
export type InvitationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  groupToInvitedTo?: InputMaybe<InvitationInvitedToFkeyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationKind?: InputMaybe<UserType>;
  invitedBy?: InputMaybe<Scalars['UUID']['input']>;
  invitedTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Deprecated and no longer read: the account's ambulant setting applies. */
  managerOrganizationAmbulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Salesforce account (crm.account) whose licence manager this manager invitation is for. No foreign key. */
  managerSalesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmailStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToInvitedBy?: InputMaybe<InvitationInvitedByFkeyInput>;
};

export type InvitationSubscriptionPayload = {
  __typename?: 'InvitationSubscriptionPayload';
  invitation: Invitation;
};

/** A connection to a list of `Invitation` values. */
export type InvitationsConnection = {
  __typename?: 'InvitationsConnection';
  /** A list of edges which contains the `Invitation` and cursor to aid in pagination. */
  edges: Array<InvitationsEdge>;
  /** A list of `Invitation` objects. */
  nodes: Array<Invitation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Invitation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Invitation` edge in the connection. */
export type InvitationsEdge = {
  __typename?: 'InvitationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Invitation` at the end of the edge. */
  node: Invitation;
};

/** Methods to use when ordering `Invitation`. */
export enum InvitationsOrderBy {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InvitationKindAsc = 'INVITATION_KIND_ASC',
  InvitationKindDesc = 'INVITATION_KIND_DESC',
  InvitedByAsc = 'INVITED_BY_ASC',
  InvitedByDesc = 'INVITED_BY_DESC',
  InvitedToAsc = 'INVITED_TO_ASC',
  InvitedToDesc = 'INVITED_TO_DESC',
  ManagerSalesforceAccountIdAsc = 'MANAGER_SALESFORCE_ACCOUNT_ID_ASC',
  ManagerSalesforceAccountIdDesc = 'MANAGER_SALESFORCE_ACCOUNT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** All input for the `invite` mutation. */
export type InviteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `invite` mutation. */
export type InvitePayload = {
  __typename?: 'InvitePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `isAndroidDeviceSupported` mutation. */
export type IsAndroidDeviceSupportedInput = {
  androidVersion?: InputMaybe<Scalars['String']['input']>;
  chromeVersion?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hwModel?: InputMaybe<Scalars['String']['input']>;
  utilizationMode?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `isAndroidDeviceSupported` mutation. */
export type IsAndroidDeviceSupportedPayload = {
  __typename?: 'IsAndroidDeviceSupportedPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `isTabletUpdatable` mutation. */
export type IsTabletUpdatableInput = {
  androidVersion?: InputMaybe<Scalars['String']['input']>;
  chromeVersion?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hwModel?: InputMaybe<Scalars['String']['input']>;
  utilizationMode?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `isTabletUpdatable` mutation. */
export type IsTabletUpdatablePayload = {
  __typename?: 'IsTabletUpdatablePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `isUserInWorkgroup` mutation. */
export type IsUserInWorkgroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  workgroupId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `isUserInWorkgroup` mutation. */
export type IsUserInWorkgroupPayload = {
  __typename?: 'IsUserInWorkgroupPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `ismanagerofcaregiver` mutation. */
export type IsmanagerofcaregiverInput = {
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `ismanagerofcaregiver` mutation. */
export type IsmanagerofcaregiverPayload = {
  __typename?: 'IsmanagerofcaregiverPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type JoinWorkGroupInput = {
  code: Scalars['String']['input'];
};

export type JoinWorkGroupResponse = {
  __typename?: 'JoinWorkGroupResponse';
  workgroupId: Scalars['UUID']['output'];
};

export type KeyChecksumPair = {
  key: Scalars['String']['input'];
  md5: Scalars['String']['input'];
};

export type KorianUser = Node & {
  __typename?: 'KorianUser';
  createdAt: Scalars['Datetime']['output'];
  facilityId?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `KorianUser`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `KorianUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type KorianUserCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for the nested mutation of `user` in the `KorianUserInput` mutation. */
export type KorianUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<KorianUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnKorianUserForKorianUserIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<KorianUserOnKorianUserForKorianUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `korianUser` in the `UserInput` mutation. */
export type KorianUserIdFkeyInverseInput = {
  /** The primary key(s) for `korianUser` for the far side of the relationship. */
  connectById?: InputMaybe<KorianUserKorianUserPkeyConnect>;
  /** The primary key(s) for `korianUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<KorianUserNodeIdConnect>;
  /** The primary key(s) for `korianUser` for the far side of the relationship. */
  connectByUserId?: InputMaybe<KorianUserUniqueUserConnect>;
  /** A `KorianUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<KorianUserIdFkeyKorianUserCreateInput>>;
  /** The primary key(s) and patch data for `korianUser` for the far side of the relationship. */
  updateById?: InputMaybe<KorianUserOnKorianUserForKorianUserIdFkeyUsingKorianUserPkeyUpdate>;
  /** The primary key(s) and patch data for `korianUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserOnKorianUserForKorianUserIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `korianUser` for the far side of the relationship. */
  updateByUserId?: InputMaybe<KorianUserOnKorianUserForKorianUserIdFkeyUsingUniqueUserUpdate>;
};

/** The `korianUser` to be created by this mutation. */
export type KorianUserIdFkeyKorianUserCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  facilityId?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<KorianUserIdFkeyInput>;
};

/** The `user` to be created by this mutation. */
export type KorianUserIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An input for mutations affecting `KorianUser` */
export type KorianUserInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  facilityId?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<KorianUserIdFkeyInput>;
};

/** The fields on `korianUser` to look up the row to connect. */
export type KorianUserKorianUserPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type KorianUserNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `korianUser` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type KorianUserOnKorianUserForKorianUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `korianUser` to look up the row to update. */
export type KorianUserOnKorianUserForKorianUserIdFkeyUsingKorianUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `korianUser` being updated. */
  patch: UpdateKorianUserOnKorianUserForKorianUserIdFkeyPatch;
};

/** The fields on `korianUser` to look up the row to update. */
export type KorianUserOnKorianUserForKorianUserIdFkeyUsingUniqueUserUpdate = {
  /** An object where the defined keys will be set on the `korianUser` being updated. */
  patch: UpdateKorianUserOnKorianUserForKorianUserIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `KorianUser`. Fields that are set will be updated. */
export type KorianUserPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  facilityId?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<KorianUserIdFkeyInput>;
};

/** The fields on `korianUser` to look up the row to connect. */
export type KorianUserUniqueUserConnect = {
  userId: Scalars['UUID']['input'];
};

/** A connection to a list of `KorianUser` values. */
export type KorianUsersConnection = {
  __typename?: 'KorianUsersConnection';
  /** A list of edges which contains the `KorianUser` and cursor to aid in pagination. */
  edges: Array<KorianUsersEdge>;
  /** A list of `KorianUser` objects. */
  nodes: Array<KorianUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `KorianUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `KorianUser` edge in the connection. */
export type KorianUsersEdge = {
  __typename?: 'KorianUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `KorianUser` at the end of the edge. */
  node: KorianUser;
};

/** Methods to use when ordering `KorianUser`. */
export enum KorianUsersOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type LearningAssignment = {
  __typename?: 'LearningAssignment';
  active: Scalars['Boolean']['output'];
  assignedAt?: Maybe<Scalars['Datetime']['output']>;
  assignedBy?: Maybe<Scalars['UUID']['output']>;
  courseId?: Maybe<Scalars['UUID']['output']>;
  enrollmentIds: Array<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  itemKind: LearningItemKind;
  kind: LearningAssignmentKind;
  learningPathId?: Maybe<Scalars['UUID']['output']>;
  learningPathVersion?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['UUID']['output'];
  unassignedAt?: Maybe<Scalars['Datetime']['output']>;
  unassignedBy?: Maybe<Scalars['UUID']['output']>;
  userId: Scalars['UUID']['output'];
};

export enum LearningAssignmentKind {
  Manager = 'MANAGER',
  Self = 'SELF'
}

export type LearningAuthPayload = {
  __typename?: 'LearningAuthPayload';
  token: Scalars['String']['output'];
  viewer: LearningViewer;
};

export type LearningCaregiver = {
  __typename?: 'LearningCaregiver';
  displayName: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locationNames: Array<Scalars['String']['output']>;
  organizationId: Scalars['UUID']['output'];
  userId: Scalars['UUID']['output'];
};

export type LearningCatalog = {
  __typename?: 'LearningCatalog';
  courseAccess: Array<LearningCourseAccess>;
  courses: Array<LearningCourseMetadata>;
  learningPaths: Array<LearningPathMetadata>;
  selfEnrollCourseIds: Array<Scalars['UUID']['output']>;
  selfEnrollPathIds: Array<Scalars['UUID']['output']>;
};

export type LearningChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type LearningCourseAccess = {
  __typename?: 'LearningCourseAccess';
  courseId: Scalars['UUID']['output'];
  currentVersion: Scalars['String']['output'];
  directAccess: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  pathAccess: Scalars['Boolean']['output'];
  selfAccess: Scalars['Boolean']['output'];
};

export type LearningCourseMetadata = {
  __typename?: 'LearningCourseMetadata';
  description: Scalars['String']['output'];
  estimatedDurationMinutes: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  lessonCount: Scalars['Int']['output'];
  locale: Scalars['String']['output'];
  passingScorePercent: Scalars['Int']['output'];
  tags: Array<Scalars['String']['output']>;
  thumbnailFilename: Scalars['String']['output'];
  title: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type LearningCoursePayload = {
  __typename?: 'LearningCoursePayload';
  courseId: Scalars['UUID']['output'];
  payload: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type LearningCourseProgress = {
  __typename?: 'LearningCourseProgress';
  activeCourseVersion?: Maybe<Scalars['String']['output']>;
  bestScorePercent?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  courseId: Scalars['UUID']['output'];
  enrollmentId: Scalars['UUID']['output'];
  firstStartedAt?: Maybe<Scalars['Datetime']['output']>;
  lessons: Array<LearningLessonProgress>;
  organizationId: Scalars['UUID']['output'];
  quizAttempts: Array<LearningQuizAttempt>;
  status: LearningEnrollmentStatus;
  userId: Scalars['UUID']['output'];
  versions: Array<LearningCourseVersionProgress>;
};

export type LearningCourseVersionProgress = {
  __typename?: 'LearningCourseVersionProgress';
  bestScorePercent?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  courseVersion: Scalars['String']['output'];
  startedAt: Scalars['Datetime']['output'];
};

export enum LearningEnrollmentStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type LearningGrant = {
  __typename?: 'LearningGrant';
  active: Scalars['Boolean']['output'];
  courseId?: Maybe<Scalars['UUID']['output']>;
  grantedAt?: Maybe<Scalars['Datetime']['output']>;
  grantedBy?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  itemKind: LearningItemKind;
  learningPathId?: Maybe<Scalars['UUID']['output']>;
  organizationId: Scalars['UUID']['output'];
  revokedAt?: Maybe<Scalars['Datetime']['output']>;
  revokedBy?: Maybe<Scalars['UUID']['output']>;
};

export enum LearningItemKind {
  Course = 'COURSE',
  LearningPath = 'LEARNING_PATH'
}

export type LearningLessonProgress = {
  __typename?: 'LearningLessonProgress';
  completedAt: Scalars['Datetime']['output'];
  courseVersion: Scalars['String']['output'];
  lessonId: Scalars['UUID']['output'];
};

export type LearningLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LearningOrganization = {
  __typename?: 'LearningOrganization';
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LearningPathCourseMetadata = {
  __typename?: 'LearningPathCourseMetadata';
  courseId: Scalars['UUID']['output'];
  position: Scalars['Int']['output'];
};

export type LearningPathMetadata = {
  __typename?: 'LearningPathMetadata';
  courses: Array<LearningPathCourseMetadata>;
  description: Scalars['String']['output'];
  enforceOrder: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  locale: Scalars['String']['output'];
  thumbnailFilename: Scalars['String']['output'];
  title: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum LearningProgressEffect {
  CourseVersionStarted = 'COURSE_VERSION_STARTED',
  LessonCompleted = 'LESSON_COMPLETED',
  NoOp = 'NO_OP',
  QuizAttemptRecorded = 'QUIZ_ATTEMPT_RECORDED'
}

export type LearningProgressFilter = {
  courseIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type LearningProgressReport = {
  __typename?: 'LearningProgressReport';
  entries: Array<LearningCourseProgress>;
};

export type LearningQuizAnswerInput = {
  answerId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type LearningQuizAttempt = {
  __typename?: 'LearningQuizAttempt';
  clientAttemptId: Scalars['UUID']['output'];
  courseVersion: Scalars['String']['output'];
  finishedAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  lessonsCompletedBeforeAttempt: Scalars['Boolean']['output'];
  receivedAt: Scalars['Datetime']['output'];
  serverCorrect: Scalars['Int']['output'];
  serverPassed: Scalars['Boolean']['output'];
  serverScorePercent: Scalars['Float']['output'];
  serverTotal: Scalars['Int']['output'];
  startedAt: Scalars['Datetime']['output'];
};

export type LearningResetPasswordInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type LearningViewer = {
  __typename?: 'LearningViewer';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['UUID']['output'];
};

export type LeastUsedContentItem = {
  __typename?: 'LeastUsedContentItem';
  contentId: Scalars['UUID']['output'];
  contentKind: Scalars['String']['output'];
  contentSubtype?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['Datetime']['output']>;
  sessionCount: Scalars['BigInt']['output'];
  title: Scalars['String']['output'];
};

export type LeastUsedContentReport = {
  __typename?: 'LeastUsedContentReport';
  contentTypes: Array<Scalars['String']['output']>;
  items: Array<LeastUsedContentItem>;
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  totalCount: Scalars['Int']['output'];
};

export type LessonProgressResult = {
  __typename?: 'LessonProgressResult';
  completedAt: Scalars['Datetime']['output'];
  courseId: Scalars['UUID']['output'];
  courseVersion: Scalars['String']['output'];
  effect: LearningProgressEffect;
  lessonId: Scalars['UUID']['output'];
  progress: LearningCourseProgress;
};

export type LicenseData = {
  __typename?: 'LicenseData';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  active: Scalars['Boolean']['output'];
  appUrl?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  flavour: Flavour;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  plan?: Maybe<Plan>;
  qrCodeUrl?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  tabletName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type LicenseResponse = {
  __typename?: 'LicenseResponse';
  alreadyActive?: Maybe<Scalars['Boolean']['output']>;
  contentGroup?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  contractName?: Maybe<Scalars['String']['output']>;
  flavour?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  latestContractId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
};

export type Location = Node & {
  __typename?: 'Location';
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Device`. */
  devices: DevicesConnection;
  /** Reads and enables pagination through a set of `Device`. */
  devicesList: Array<Device>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `LocationPractitioner`. */
  locationPractitioners: LocationPractitionersConnection;
  /** Reads and enables pagination through a set of `LocationPractitioner`. */
  locationPractitionersList: Array<LocationPractitioner>;
  /** Reads and enables pagination through a set of `Practitioner`. */
  locations: LocationLocationsManyToManyConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByPartOfId: LocationsConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByPartOfIdList: Array<Location>;
  /** Reads and enables pagination through a set of `Practitioner`. */
  locationsList: Array<Practitioner>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode: LocationModeEnum;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Location`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByDeviceLocationIdAndOrganizationId: LocationOrganizationsByDeviceLocationIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByDeviceLocationIdAndOrganizationIdList: Array<Organization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByLocationPartOfIdAndOrganizationId: LocationOrganizationsByLocationPartOfIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByLocationPartOfIdAndOrganizationIdList: Array<Organization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByPatientLocationIdAndOrganizationId: LocationOrganizationsByPatientLocationIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByPatientLocationIdAndOrganizationIdList: Array<Organization>;
  /** Reads a single `Location` that is related to this `Location`. */
  partOf?: Maybe<Location>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: Maybe<Scalars['UUID']['output']>;
  /** Reads and enables pagination through a set of `Patient`. */
  patients: PatientsConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsList: Array<Patient>;
  /** Returns practitioners assigned to this location and all ancestor locations in the hierarchy. */
  practitionersWithAncestors: LocationPractitionersConnection;
  /** Returns practitioners assigned to this location and all ancestor locations in the hierarchy. */
  practitionersWithAncestorsList?: Maybe<Array<LocationPractitioner>>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  status?: Maybe<Scalars['String']['output']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
  /** Timestamp of last update */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};


export type LocationDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


export type LocationDevicesListArgs = {
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


export type LocationLocationPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationPractitionersOrderBy>>;
};


export type LocationLocationPractitionersListArgs = {
  condition?: InputMaybe<LocationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationPractitionersOrderBy>>;
};


export type LocationLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PractitionersOrderBy>>;
};


export type LocationLocationsByPartOfIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type LocationLocationsByPartOfIdListArgs = {
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type LocationLocationsListArgs = {
  condition?: InputMaybe<PractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PractitionersOrderBy>>;
};


export type LocationOrganizationsByDeviceLocationIdAndOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type LocationOrganizationsByDeviceLocationIdAndOrganizationIdListArgs = {
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type LocationOrganizationsByLocationPartOfIdAndOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type LocationOrganizationsByLocationPartOfIdAndOrganizationIdListArgs = {
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type LocationOrganizationsByPatientLocationIdAndOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type LocationOrganizationsByPatientLocationIdAndOrganizationIdListArgs = {
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type LocationPatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


export type LocationPatientsListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


export type LocationPractitionersWithAncestorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationPractitionersOrderBy>>;
};


export type LocationPractitionersWithAncestorsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationPractitionersOrderBy>>;
};

/**
 * A condition to be used against `Location` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LocationCondition = {
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `partOfId` field. */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `sourceSystem` field. */
  sourceSystem?: InputMaybe<DataSource>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LocationTypeEnum>;
};

/** An input for mutations affecting `Location` */
export type LocationInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The fields on `location` to look up the row to connect. */
export type LocationLocationPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `location` to look up the row to delete. */
export type LocationLocationPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `Practitioner` values, with data from `LocationPractitioner`. */
export type LocationLocationsManyToManyConnection = {
  __typename?: 'LocationLocationsManyToManyConnection';
  /** A list of edges which contains the `Practitioner`, info from the `LocationPractitioner`, and the cursor to aid in pagination. */
  edges: Array<LocationLocationsManyToManyEdge>;
  /** A list of `Practitioner` objects. */
  nodes: Array<Practitioner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Practitioner` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Practitioner` edge in the connection, with data from `LocationPractitioner`. */
export type LocationLocationsManyToManyEdge = {
  __typename?: 'LocationLocationsManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Practitioner` at the end of the edge. */
  node: Practitioner;
};

export enum LocationModeEnum {
  Instance = 'INSTANCE',
  Kind = 'KIND'
}

/** The globally unique `ID` look up for the row to connect. */
export type LocationNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `location` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type LocationNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `location` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type LocationOnDeviceForDeviceLocationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `device` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `device` being updated. */
  patch: DevicePatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnDeviceForDeviceLocationIdFkeyUsingLocationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnDeviceForDeviceLocationIdFkeyPatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnDeviceForDeviceLocationIdFkeyUsingUqLocationExternalIdUpdate = {
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnDeviceForDeviceLocationIdFkeyPatch;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
};

/** The globally unique `ID` look up for the row to update. */
export type LocationOnLocationForFkLocationOrganizationNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organization` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: OrganizationPatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnLocationForFkLocationOrganizationUsingLocationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnLocationForFkLocationOrganizationPatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnLocationForFkLocationOrganizationUsingUqLocationExternalIdUpdate = {
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnLocationForFkLocationOrganizationPatch;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
};

/** The globally unique `ID` look up for the row to update. */
export type LocationOnLocationForFkLocationPartOfNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `location` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: LocationPatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnLocationForFkLocationPartOfUsingLocationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnLocationForFkLocationPartOfPatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnLocationForFkLocationPartOfUsingUqLocationExternalIdUpdate = {
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnLocationForFkLocationPartOfPatch;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
};

/** The globally unique `ID` look up for the row to update. */
export type LocationOnLocationPractitionerForFkLocationPractitionersLocationNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `locationPractitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `locationPractitioner` being updated. */
  patch: LocationPractitionerPatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnLocationPractitionerForFkLocationPractitionersLocationUsingLocationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnLocationPractitionerForFkLocationPractitionersLocationPatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnLocationPractitionerForFkLocationPractitionersLocationUsingUqLocationExternalIdUpdate = {
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnLocationPractitionerForFkLocationPractitionersLocationPatch;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
};

/** The globally unique `ID` look up for the row to update. */
export type LocationOnPatientForPatientLocationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `patient` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: PatientPatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnPatientForPatientLocationIdFkeyUsingLocationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnPatientForPatientLocationIdFkeyPatch;
};

/** The fields on `location` to look up the row to update. */
export type LocationOnPatientForPatientLocationIdFkeyUsingUqLocationExternalIdUpdate = {
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: UpdateLocationOnPatientForPatientLocationIdFkeyPatch;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
};

/** A connection to a list of `Organization` values, with data from `Device`. */
export type LocationOrganizationsByDeviceLocationIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'LocationOrganizationsByDeviceLocationIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `Device`, and the cursor to aid in pagination. */
  edges: Array<LocationOrganizationsByDeviceLocationIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organization` edge in the connection, with data from `Device`. */
export type LocationOrganizationsByDeviceLocationIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'LocationOrganizationsByDeviceLocationIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Reads and enables pagination through a set of `Device`. */
  devices: DevicesConnection;
  /** Reads and enables pagination through a set of `Device`. */
  devicesList: Array<Device>;
  /** The `Organization` at the end of the edge. */
  node: Organization;
};


/** A `Organization` edge in the connection, with data from `Device`. */
export type LocationOrganizationsByDeviceLocationIdAndOrganizationIdManyToManyEdgeDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `Device`. */
export type LocationOrganizationsByDeviceLocationIdAndOrganizationIdManyToManyEdgeDevicesListArgs = {
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `Location`. */
export type LocationOrganizationsByLocationPartOfIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'LocationOrganizationsByLocationPartOfIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `Location`, and the cursor to aid in pagination. */
  edges: Array<LocationOrganizationsByLocationPartOfIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organization` edge in the connection, with data from `Location`. */
export type LocationOrganizationsByLocationPartOfIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'LocationOrganizationsByLocationPartOfIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Reads and enables pagination through a set of `Location`. */
  locations: LocationsConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsList: Array<Location>;
  /** The `Organization` at the end of the edge. */
  node: Organization;
};


/** A `Organization` edge in the connection, with data from `Location`. */
export type LocationOrganizationsByLocationPartOfIdAndOrganizationIdManyToManyEdgeLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `Location`. */
export type LocationOrganizationsByLocationPartOfIdAndOrganizationIdManyToManyEdgeLocationsListArgs = {
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `Patient`. */
export type LocationOrganizationsByPatientLocationIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'LocationOrganizationsByPatientLocationIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `Patient`, and the cursor to aid in pagination. */
  edges: Array<LocationOrganizationsByPatientLocationIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organization` edge in the connection, with data from `Patient`. */
export type LocationOrganizationsByPatientLocationIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'LocationOrganizationsByPatientLocationIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Organization` at the end of the edge. */
  node: Organization;
  /** Reads and enables pagination through a set of `Patient`. */
  patients: PatientsConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsList: Array<Patient>;
};


/** A `Organization` edge in the connection, with data from `Patient`. */
export type LocationOrganizationsByPatientLocationIdAndOrganizationIdManyToManyEdgePatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `Patient`. */
export type LocationOrganizationsByPatientLocationIdAndOrganizationIdManyToManyEdgePatientsListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};

/** Represents an update to a `Location`. Fields that are set will be updated. */
export type LocationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type?: InputMaybe<LocationTypeEnum>;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type LocationPractitioner = Node & {
  __typename?: 'LocationPractitioner';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Location` that is related to this `LocationPractitioner`. */
  location?: Maybe<Location>;
  locationId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Practitioner` that is related to this `LocationPractitioner`. */
  practitioner?: Maybe<Practitioner>;
  practitionerId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `LocationPractitioner` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LocationPractitionerCondition = {
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `practitionerId` field. */
  practitionerId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `locationPractitioner` to look up the row to connect. */
export type LocationPractitionerLocationPractitionersPkeyConnect = {
  locationId: Scalars['UUID']['input'];
  practitionerId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type LocationPractitionerNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `locationPractitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type LocationPractitionerOnLocationPractitionerForFkLocationPractitionersLocationNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `location` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: LocationPatch;
};

/** The fields on `locationPractitioner` to look up the row to update. */
export type LocationPractitionerOnLocationPractitionerForFkLocationPractitionersLocationUsingLocationPractitionersPkeyUpdate = {
  locationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `locationPractitioner` being updated. */
  patch: UpdateLocationPractitionerOnLocationPractitionerForFkLocationPractitionersLocationPatch;
  practitionerId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type LocationPractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `practitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: PractitionerPatch;
};

/** The fields on `locationPractitioner` to look up the row to update. */
export type LocationPractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerUsingLocationPractitionersPkeyUpdate = {
  locationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `locationPractitioner` being updated. */
  patch: UpdateLocationPractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerPatch;
  practitionerId: Scalars['UUID']['input'];
};

/** Represents an update to a `LocationPractitioner`. Fields that are set will be updated. */
export type LocationPractitionerPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<FkLocationPractitionersLocationInput>;
  practitionerId?: InputMaybe<Scalars['UUID']['input']>;
  practitionerToPractitionerId?: InputMaybe<FkLocationPractitionersPractitionerInput>;
};

/** A connection to a list of `LocationPractitioner` values. */
export type LocationPractitionersConnection = {
  __typename?: 'LocationPractitionersConnection';
  /** A list of edges which contains the `LocationPractitioner` and cursor to aid in pagination. */
  edges: Array<LocationPractitionersEdge>;
  /** A list of `LocationPractitioner` objects. */
  nodes: Array<LocationPractitioner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LocationPractitioner` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LocationPractitioner` edge in the connection. */
export type LocationPractitionersEdge = {
  __typename?: 'LocationPractitionersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LocationPractitioner` at the end of the edge. */
  node: LocationPractitioner;
};

/** Methods to use when ordering `LocationPractitioner`. */
export enum LocationPractitionersOrderBy {
  LocationIdAsc = 'LOCATION_ID_ASC',
  LocationIdDesc = 'LOCATION_ID_DESC',
  Natural = 'NATURAL',
  PractitionerIdAsc = 'PRACTITIONER_ID_ASC',
  PractitionerIdDesc = 'PRACTITIONER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type LocationResponse = {
  __typename?: 'LocationResponse';
  id: Scalars['ID']['output'];
};

/** A connection to a list of `LocationSummary` values. */
export type LocationSummariesConnection = {
  __typename?: 'LocationSummariesConnection';
  /** A list of edges which contains the `LocationSummary` and cursor to aid in pagination. */
  edges: Array<LocationSummariesEdge>;
  /** A list of `LocationSummary` objects. */
  nodes: Array<LocationSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LocationSummary` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LocationSummary` edge in the connection. */
export type LocationSummariesEdge = {
  __typename?: 'LocationSummariesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LocationSummary` at the end of the edge. */
  node: LocationSummary;
};

/** Methods to use when ordering `LocationSummary`. */
export enum LocationSummariesOrderBy {
  NameAsc = 'NAME_ASC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Authorized live descendant counts for Admin dashboard locations. */
export type LocationSummary = Node & {
  __typename?: 'LocationSummary';
  deviceCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  immediateChildCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organizationId?: Maybe<Scalars['UUID']['output']>;
  partOfId?: Maybe<Scalars['UUID']['output']>;
  patientCount?: Maybe<Scalars['Int']['output']>;
  practitionerCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<LocationTypeEnum>;
};

/**
 * A condition to be used against `LocationSummary` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LocationSummaryCondition = {
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<LocationTypeEnum>;
};

export enum LocationTypeEnum {
  Bed = 'BED',
  Department = 'DEPARTMENT',
  Organization = 'ORGANIZATION',
  Room = 'ROOM',
  Site = 'SITE',
  Ward = 'WARD'
}

/** The fields on `location` to look up the row to connect. */
export type LocationUqLocationExternalIdConnect = {
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
};

/** The fields on `location` to look up the row to delete. */
export type LocationUqLocationExternalIdDelete = {
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
};

/** A connection to a list of `Location` values. */
export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  /** A list of edges which contains the `Location` and cursor to aid in pagination. */
  edges: Array<LocationsEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Location>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Location` edge in the connection. */
export type LocationsEdge = {
  __typename?: 'LocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Location` at the end of the edge. */
  node: Location;
};

/** Methods to use when ordering `Location`. */
export enum LocationsOrderBy {
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PartOfIdAsc = 'PART_OF_ID_ASC',
  PartOfIdDesc = 'PART_OF_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceSystemAsc = 'SOURCE_SYSTEM_ASC',
  SourceSystemDesc = 'SOURCE_SYSTEM_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

export type LogAssistantInteractionInput = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  contentUuid?: InputMaybe<Scalars['String']['input']>;
  kind: AssistantInteractionKind;
  language?: InputMaybe<Scalars['String']['input']>;
  outcomeStatus?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
};

/** All input for the `login` mutation. */
export type LoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `loginOrCreateSenior` mutation. */
export type LoginOrCreateSeniorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serialNumber: Scalars['String']['input'];
};

/** The output of our `loginOrCreateSenior` mutation. */
export type LoginOrCreateSeniorPayload = {
  __typename?: 'LoginOrCreateSeniorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `login` mutation. */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type LoginPractitionerInput = {
  deviceToken: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** All input for the `loginSenior` mutation. */
export type LoginSeniorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  licence: Scalars['String']['input'];
};

/** The output of our `loginSenior` mutation. */
export type LoginSeniorPayload = {
  __typename?: 'LoginSeniorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export enum LoginStatus {
  Registered = 'registered',
  Registering = 'registering',
  ResettingPassword = 'resettingPassword',
  Unknown = 'unknown'
}

export type LoginUserInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginUserResponse = {
  __typename?: 'LoginUserResponse';
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  loginStatus: LoginStatus;
  mfa?: Maybe<AdminMfaResponse>;
};

/** The newest order with an item that names the asset (Asset__c). It can be a return; recordType tells. */
export type LogisticsAssetOrder = {
  __typename?: 'LogisticsAssetOrder';
  completedDate?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** The developer name of the order's record type, such as One_Way_Shipping. */
  recordType?: Maybe<Scalars['String']['output']>;
  /** Null for an order the backend created that Salesforce does not hold yet. */
  salesforceId?: Maybe<Scalars['String']['output']>;
  shippingDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** The field of the asset that names the unit: Asset.Tablet__c, SIM__c or Hardware__c. */
export enum LogisticsAssetSlot {
  Hardware = 'HARDWARE',
  Sim = 'SIM',
  Tablet = 'TABLET'
}

/**
 * The account part of the DHL settings. Secrets are write-only: only whether
 * they are set is returned.
 */
export type LogisticsDhlAccountSettings = {
  __typename?: 'LogisticsDhlAccountSettings';
  billingNumberPaket?: Maybe<Scalars['String']['output']>;
  billingNumberPaketInternational?: Maybe<Scalars['String']['output']>;
  billingNumberRetoure?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  gateway: LogisticsDhlGateway;
  hasClientSecret: Scalars['Boolean']['output'];
  hasPassword: Scalars['Boolean']['output'];
  /** What labels still lack: the account settings and the shipper. */
  missingSettings: Array<LogisticsDhlSetting>;
  /** The receiver id of the Austrian return location. */
  returnReceiverIdAustria?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** A sender or return address on a DHL label. */
export type LogisticsDhlAddress = {
  __typename?: 'LogisticsDhlAddress';
  city: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type LogisticsDhlAddressInput = {
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

/** The answer of the DHL connection check. */
export type LogisticsDhlConnectionCheck = {
  __typename?: 'LogisticsDhlConnectionCheck';
  /** The receivers of return parcels from Austria, to choose the return receiver id from. */
  austrianReturnReceivers: Array<LogisticsDhlReturnReceiver>;
  failure?: Maybe<LogisticsDhlConnectionFailure>;
  gateway: LogisticsDhlGateway;
  /** The credentials that are missing when failure is NOT_CONFIGURED. */
  missingSettings: Array<LogisticsDhlSetting>;
  /** Whether DHL accepted the credentials and listed the receivers. */
  ok: Scalars['Boolean']['output'];
  /** Whether the saved Austrian return receiver id is one of them. */
  storedReturnReceiverFound: Scalars['Boolean']['output'];
};

/** Why the DHL connection check failed. */
export enum LogisticsDhlConnectionFailure {
  /** DHL's answer could not be read. */
  InvalidResponse = 'INVALID_RESPONSE',
  /** The client, the user or one of their secrets is not saved; DHL was not called. */
  NotConfigured = 'NOT_CONFIGURED',
  /** DHL answered with an error of its own. */
  ProviderError = 'PROVIDER_ERROR',
  /** DHL asked the backend to slow down; try again in a minute. */
  RateLimited = 'RATE_LIMITED',
  /** DHL refused the credentials. */
  Unauthorized = 'UNAUTHORIZED',
  /** DHL did not answer in time or the connection broke off. */
  Unreachable = 'UNREACHABLE'
}

/** The DHL gateway the backend uses, which follows its environment. */
export enum LogisticsDhlGateway {
  /** The live DHL: production only. */
  Production = 'PRODUCTION',
  /** DHL's sandbox: every environment except production. */
  Sandbox = 'SANDBOX'
}

/** A message DHL returned, in German as DHL words it. */
export type LogisticsDhlMessage = {
  __typename?: 'LogisticsDhlMessage';
  message: Scalars['String']['output'];
  /** The request field the message is about. */
  property?: Maybe<Scalars['String']['output']>;
  /** DHL's validation state, such as Error or Warning. */
  state?: Maybe<Scalars['String']['output']>;
};

/** A receiver of return parcels that DHL lists for the account. */
export type LogisticsDhlReturnReceiver = {
  __typename?: 'LogisticsDhlReturnReceiver';
  billingNumber?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The id that the return receiver id setting takes. */
  receiverId: Scalars['String']['output'];
  shipperCountry?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

/** A DHL setting, named without its value. */
export enum LogisticsDhlSetting {
  BillingNumberPaket = 'BILLING_NUMBER_PAKET',
  BillingNumberPaketInternational = 'BILLING_NUMBER_PAKET_INTERNATIONAL',
  BillingNumberRetoure = 'BILLING_NUMBER_RETOURE',
  ClientId = 'CLIENT_ID',
  ClientSecret = 'CLIENT_SECRET',
  LabelPrintFormat = 'LABEL_PRINT_FORMAT',
  Password = 'PASSWORD',
  ReturnCity = 'RETURN_CITY',
  ReturnLabelPrintFormat = 'RETURN_LABEL_PRINT_FORMAT',
  ReturnName = 'RETURN_NAME',
  ReturnPostalCode = 'RETURN_POSTAL_CODE',
  ReturnReceiverIdAt = 'RETURN_RECEIVER_ID_AT',
  ReturnStreet = 'RETURN_STREET',
  ShipperCity = 'SHIPPER_CITY',
  ShipperName = 'SHIPPER_NAME',
  ShipperPostalCode = 'SHIPPER_POSTAL_CODE',
  ShipperStreet = 'SHIPPER_STREET',
  Username = 'USERNAME'
}

/** The shipping part of the DHL settings: who ships and how labels print. */
export type LogisticsDhlShippingSettings = {
  __typename?: 'LogisticsDhlShippingSettings';
  /** The print format of the label: the saved one, or the default. */
  labelPrintFormat: Scalars['String']['output'];
  /** The print formats labelPrintFormat accepts. */
  labelPrintFormats: Array<Scalars['String']['output']>;
  /** What labels still lack: the account settings and the shipper. */
  missingSettings: Array<LogisticsDhlSetting>;
  /** Where DHL Retoure parcels go; null leaves it to DHL, which uses the shipper. */
  returnAddress?: Maybe<LogisticsDhlAddress>;
  /** The print format of the Austrian return label: the saved one, or the default. */
  returnLabelPrintFormat: Scalars['String']['output'];
  /** The print formats returnLabelPrintFormat accepts. */
  returnLabelPrintFormats: Array<Scalars['String']['output']>;
  /** The sender on every label; null until it is saved. */
  shipper?: Maybe<LogisticsDhlAddress>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/** Read-only Hexnode metadata matched by inventory serial number. Separate from inventory status and staging quality checks. */
export type LogisticsHexnodeDevice = {
  __typename?: 'LogisticsHexnodeDevice';
  active?: Maybe<Scalars['Boolean']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  enrollmentStatus?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['Datetime']['output']>;
  stale: Scalars['Boolean']['output'];
  state: LogisticsHexnodeState;
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum LogisticsHexnodeState {
  Ambiguous = 'AMBIGUOUS',
  Linked = 'LINKED',
  MissingSerial = 'MISSING_SERIAL',
  NotConfigured = 'NOT_CONFIGURED',
  Unavailable = 'UNAVAILABLE',
  Unlinked = 'UNLINKED'
}

/** The asset (Salesforce Asset) that names a unit. */
export type LogisticsInventoryAsset = {
  __typename?: 'LogisticsInventoryAsset';
  assetType?: Maybe<Scalars['String']['output']>;
  latestOrder?: Maybe<LogisticsAssetOrder>;
  name?: Maybe<Scalars['String']['output']>;
  /** Null for an asset the backend created that Salesforce does not hold yet. */
  salesforceUrl?: Maybe<Scalars['String']['output']>;
  slot: LogisticsAssetSlot;
};

export type LogisticsInventoryCount = {
  __typename?: 'LogisticsInventoryCount';
  count: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum LogisticsInventoryDeviceFilter {
  InactiveManaged = 'INACTIVE_MANAGED',
  UnknownLastSeenManaged = 'UNKNOWN_LAST_SEEN_MANAGED',
  WorkspaceOne = 'WORKSPACE_ONE'
}

export enum LogisticsInventoryDeviceFilterProvider {
  Hexnode = 'HEXNODE',
  Whereversim = 'WHEREVERSIM',
  WorkspaceOne = 'WORKSPACE_ONE'
}

export type LogisticsInventoryDeviceFilterSource = {
  __typename?: 'LogisticsInventoryDeviceFilterSource';
  provider: LogisticsInventoryDeviceFilterProvider;
  /** Null for SIM cache: the cache has no freshness observation. */
  stale?: Maybe<Scalars['Boolean']['output']>;
  state: LogisticsInventoryDeviceFilterSourceState;
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
};

export enum LogisticsInventoryDeviceFilterSourceState {
  Available = 'AVAILABLE',
  Cached = 'CACHED',
  NotConfigured = 'NOT_CONFIGURED',
  NotScanned = 'NOT_SCANNED',
  Unavailable = 'UNAVAILABLE'
}

/** Where a unit has been (Salesforce Inventory_History__c). */
export type LogisticsInventoryHistoryEntry = {
  __typename?: 'LogisticsInventoryHistoryEntry';
  accountName?: Maybe<Scalars['String']['output']>;
  accountSalesforceId?: Maybe<Scalars['String']['output']>;
  atClientDate?: Maybe<Scalars['Date']['output']>;
  contractItemName?: Maybe<Scalars['String']['output']>;
  contractItemSalesforceId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractSalesforceId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** When the sync found the record deleted in Salesforce; null while Salesforce holds it. */
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  endUserChange?: Maybe<Scalars['Boolean']['output']>;
  inStockDate?: Maybe<Scalars['Date']['output']>;
  removedFromClientDate?: Maybe<Scalars['Date']['output']>;
  salesforceId?: Maybe<Scalars['String']['output']>;
  shippingDate?: Maybe<Scalars['Date']['output']>;
};

export type LogisticsInventoryInput = {
  deviceFilter?: InputMaybe<LogisticsInventoryDeviceFilter>;
  /** Inactivity threshold in days, default 30; integer from 1 to 3650. Unknown last contact is a separate filter. */
  inactiveDays?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Part of the name, IMEI, hardware serial number, serial number or ICCID. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Only units in this status. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Only units in this stock state; combines with the type, status and search. */
  stockState?: InputMaybe<LogisticsInventoryStockState>;
  /** Only units of this type. */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LogisticsInventoryItem = {
  __typename?: 'LogisticsInventoryItem';
  appFlavour?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  contentVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** When the sync found the record deleted in Salesforce; null while Salesforce holds it. */
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  hardwareSerialNumber?: Maybe<Scalars['String']['output']>;
  hexnode?: Maybe<LogisticsHexnodeDevice>;
  /** Newest first. */
  history: Array<LogisticsInventoryHistoryEntry>;
  id: Scalars['UUID']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  inactiveDate?: Maybe<Scalars['Date']['output']>;
  inactiveReason?: Maybe<Scalars['String']['output']>;
  lastInStockAt?: Maybe<Scalars['Datetime']['output']>;
  lastInTransferAt?: Maybe<Scalars['Datetime']['output']>;
  /** Null when the unit is at no client: no history, or the newest entry Salesforce still holds has a removed-from-client or in-stock date or no account. */
  location?: Maybe<LogisticsInventoryLocation>;
  modifiedAt?: Maybe<Scalars['Datetime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newDevice?: Maybe<Scalars['Boolean']['output']>;
  qualityCheck: LogisticsQualityCheck;
  /** Null for a unit the backend created that Salesforce does not hold yet. */
  salesforceUrl?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  simIccid?: Maybe<Scalars['String']['output']>;
  /** WhereverSIM's facts for a SIM unit; null for other types and before the first complete scan. */
  simProvider?: Maybe<LogisticsSimProvider>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** Read-only Workspace ONE facts for tablets, matched by globally unique IMEI; null for other inventory types. */
  workspaceOne?: Maybe<LogisticsWorkspaceOneMatch>;
};

export type LogisticsInventoryList = {
  __typename?: 'LogisticsInventoryList';
  /** Every unit by type and status, whatever the filters. */
  counts: Array<LogisticsInventoryCount>;
  /** Sources used by the device filter, including unavailable coverage; empty without a device filter. CACHED describes SIM provenance, not freshness. */
  deviceFilterSources: Array<LogisticsInventoryDeviceFilterSource>;
  /** Last changed first. */
  rows: Array<LogisticsInventoryRow>;
  /** Every type with In Stock units, whatever the filters. */
  stock: Array<LogisticsInventoryStock>;
  /** When the last logistics sync succeeded; null before the first. */
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The units of the filters and search, not only this page. */
  totalCount: Scalars['Int']['output'];
};

/** Where a unit is now: the account, contract and contract item of its newest history entry while that entry has neither a removed-from-client nor an in-stock date. */
export type LogisticsInventoryLocation = {
  __typename?: 'LogisticsInventoryLocation';
  /** Null when the crm copy does not hold the account; the same for the other names. */
  accountName?: Maybe<Scalars['String']['output']>;
  accountSalesforceId: Scalars['String']['output'];
  /** The newest asset of the account that names the unit as its tablet, SIM or hardware; null when none does. Salesforce leaves returned units on their old assets, so only the account's asset counts. */
  asset?: Maybe<LogisticsInventoryAsset>;
  atClientDate?: Maybe<Scalars['Date']['output']>;
  contractItemName?: Maybe<Scalars['String']['output']>;
  contractItemSalesforceId?: Maybe<Scalars['String']['output']>;
  contractItemStatus?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractSalesforceId?: Maybe<Scalars['String']['output']>;
};

/** An inventory unit (Salesforce Inventory__c): a tablet, TV box, SIM, hardware or Aktivitätstisch. */
export type LogisticsInventoryRow = {
  __typename?: 'LogisticsInventoryRow';
  appVersion?: Maybe<Scalars['String']['output']>;
  /** When the sync found the record deleted in Salesforce; null while Salesforce holds it. */
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  hardwareSerialNumber?: Maybe<Scalars['String']['output']>;
  hexnode?: Maybe<LogisticsHexnodeDevice>;
  id: Scalars['UUID']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  lastInStockAt?: Maybe<Scalars['Datetime']['output']>;
  /** Salesforce's last change of the unit (SystemModstamp). */
  modifiedAt?: Maybe<Scalars['Datetime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qualityCheckDoneAt?: Maybe<Scalars['Datetime']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  simIccid?: Maybe<Scalars['String']['output']>;
  /** WhereverSIM's facts for a SIM unit; null for other types and before the first complete scan. */
  simProvider?: Maybe<LogisticsSimProvider>;
  status?: Maybe<Scalars['String']['output']>;
  /** Inventory__c.Type__c, such as Tablet, TV Box, SIM, Hardware or Aktivitätstisch. */
  type?: Maybe<Scalars['String']['output']>;
  /** Read-only Workspace ONE facts for tablets, matched by globally unique IMEI; null for other inventory types. */
  workspaceOne?: Maybe<LogisticsWorkspaceOneMatch>;
};

/** The In Stock units of a type, split by whether their newest history entry places them at a client. */
export type LogisticsInventoryStock = {
  __typename?: 'LogisticsInventoryStock';
  /** In Stock, and the newest history entry does not place the unit at a client. */
  free: Scalars['Int']['output'];
  /** In Stock, but the newest history entry still places the unit at a client. */
  inStockAtClient: Scalars['Int']['output'];
  /** Free Tablets and TV Boxes that still need staging. Null for the other types. */
  needsStaging?: Maybe<Scalars['Int']['output']>;
  /** Free Tablets and TV Boxes whose staging quality check was done since they last came into stock. Null for the other types, which have no staging. */
  readyToShip?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** The stock state of a unit: what the free, ready to ship, needs staging and In Stock at a client counts count. */
export enum LogisticsInventoryStockState {
  /** In Stock, and the newest history entry does not place the unit at a client. */
  Free = 'FREE',
  /** In Stock, but the newest history entry still places the unit at a client. */
  InStockAtClient = 'IN_STOCK_AT_CLIENT',
  /** Free Tablets and TV Boxes that still need staging. */
  NeedsStaging = 'NEEDS_STAGING',
  /** Free Tablets and TV Boxes whose staging quality check was done since they last came into stock. */
  ReadyToShip = 'READY_TO_SHIP'
}

export enum LogisticsOrderCommandState {
  Refused = 'REFUSED',
  Rejected = 'REJECTED',
  Synced = 'SYNCED',
  Unknown = 'UNKNOWN',
  Updating = 'UPDATING'
}

/** Read-only outcome of an Order's pilot command, including whether a later Salesforce import covered it. */
export type LogisticsOrderCommandStatus = {
  __typename?: 'LogisticsOrderCommandStatus';
  commandId: Scalars['UUID']['output'];
  messages: Array<Scalars['String']['output']>;
  orderId: Scalars['UUID']['output'];
  refusal?: Maybe<Scalars['String']['output']>;
  state: LogisticsOrderCommandState;
};

/** The staging quality check of a unit. */
export type LogisticsQualityCheck = {
  __typename?: 'LogisticsQualityCheck';
  accessPointConfigured?: Maybe<Scalars['Boolean']['output']>;
  appAsStartApp?: Maybe<Scalars['Boolean']['output']>;
  cameraInAppAllowed?: Maybe<Scalars['Boolean']['output']>;
  doneAt?: Maybe<Scalars['Datetime']['output']>;
  doneBy?: Maybe<Scalars['String']['output']>;
  knoxRemoved?: Maybe<Scalars['Boolean']['output']>;
  mdmRemoved?: Maybe<Scalars['Boolean']['output']>;
  noOpenAndroidUpdates?: Maybe<Scalars['Boolean']['output']>;
  roamingActive?: Maybe<Scalars['Boolean']['output']>;
  screenTimeout30Min?: Maybe<Scalars['Boolean']['output']>;
  sticker?: Maybe<Scalars['Boolean']['output']>;
  unknownSourcesAllowed?: Maybe<Scalars['Boolean']['output']>;
};

/** A shipping field of the Order that a label needs and that is missing. */
export enum LogisticsShippingAddressField {
  /** The shipping city is empty. */
  City = 'CITY',
  /** The first street line does not end in a house number of at most 10 characters after the street, which the Austrian return label needs. */
  HouseNumber = 'HOUSE_NUMBER',
  /** The shipping postal code is empty. */
  PostalCode = 'POSTAL_CODE',
  /** Neither a shipping recipient nor an account name. */
  Recipient = 'RECIPIENT',
  /** The shipping street has no non-empty line. */
  Street = 'STREET'
}

/** A DHL label of an Order with its return label, if any. */
export type LogisticsShippingLabel = {
  __typename?: 'LogisticsShippingLabel';
  /** When DHL cancelled the label; null while it is active. */
  cancelledAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** The label PDF, base64 encoded. */
  labelPdf: Scalars['String']['output'];
  orderId: Scalars['UUID']['output'];
  /** The DHL print format of the label. */
  printFormat: Scalars['String']['output'];
  /** The DHL product: V01PAK for Germany or V53WPAK for Austria. */
  product: Scalars['String']['output'];
  /** The return label PDF, base64 encoded. */
  returnLabelPdf?: Maybe<Scalars['String']['output']>;
  /** The DHL print format of the return label. */
  returnPrintFormat?: Maybe<Scalars['String']['output']>;
  /** The tracking number of the return label; null without one. */
  returnShipmentNumber?: Maybe<Scalars['String']['output']>;
  /** DHL's shipment number, which is the outbound tracking number. */
  shipmentNumber: Scalars['String']['output'];
  weightKg: Scalars['Float']['output'];
};

export type LogisticsShippingLabelAttempt = {
  __typename?: 'LogisticsShippingLabelAttempt';
  command: Scalars['String']['output'];
  /** The issuing user's bound label target for same-key cancellation recovery. */
  labelId?: Maybe<Scalars['UUID']['output']>;
  messages: Array<Scalars['String']['output']>;
  outcome: LogisticsShippingLabelPilotOutcome;
  refusal?: Maybe<Scalars['String']['output']>;
  /** Resumable UUID is returned only to the staff user who issued it. */
  requestId?: Maybe<Scalars['UUID']['output']>;
  /** The issuing user's original create flag for same-key recovery; null for another user or cancellation. */
  returnLabel?: Maybe<Scalars['Boolean']['output']>;
  salesforceCommandId?: Maybe<Scalars['UUID']['output']>;
};

/** Why DHL gave no usable answer to a label command. */
export enum LogisticsShippingLabelFailure {
  /** DHL's answer could not be read. DHL may still have acted on the request: check the DHL business customer portal before trying again. */
  InvalidResponse = 'INVALID_RESPONSE',
  /** DHL answered with an error of its own or an answer the backend did not expect. DHL may still have acted on the request: check the DHL business customer portal before trying again, and tell IT if it keeps happening. */
  ProviderError = 'PROVIDER_ERROR',
  /** DHL asked the backend to slow down; try again in a minute. */
  RateLimited = 'RATE_LIMITED',
  /** DHL refused the backend's credentials; the DHL settings need fixing. */
  Unauthorized = 'UNAUTHORIZED',
  /** DHL did not answer in time or the connection broke off. DHL may still have acted on the request: check the DHL business customer portal before trying again. */
  Unreachable = 'UNREACHABLE'
}

/** What happened to a DHL label command. */
export enum LogisticsShippingLabelOutcome {
  /** DHL cancelled the active label. */
  Cancelled = 'CANCELLED',
  /** DHL created the label and the backend stored it. */
  Created = 'CREATED',
  /** The Order already has an active label; DHL was not called. */
  Existing = 'EXISTING',
  /** DHL gave no usable answer; failure says why. DHL may still have acted. A pilot's durable attempt fences automatic retries. */
  Failed = 'FAILED',
  /** The backend did not call DHL, for the reason in refusal. */
  Refused = 'REFUSED',
  /** DHL answered with a validation error; its messages say what to fix. */
  Rejected = 'REJECTED',
  /** No final durable DHL or storage outcome is available. Read pilot for progress or uncertainty; do not resend an unknown effect. */
  Unknown = 'UNKNOWN'
}

export enum LogisticsShippingLabelPilotOutcome {
  InProgress = 'IN_PROGRESS',
  Refused = 'REFUSED',
  Rejected = 'REJECTED',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type LogisticsShippingLabelPilotResult = {
  __typename?: 'LogisticsShippingLabelPilotResult';
  messages: Array<Scalars['String']['output']>;
  outcome: LogisticsShippingLabelPilotOutcome;
  refusal?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['UUID']['output']>;
  salesforceCommandId?: Maybe<Scalars['UUID']['output']>;
};

/** Why the backend did not call DHL. */
export enum LogisticsShippingLabelRefusal {
  /** The recipient, street, postal code or city is missing, or an Austrian return label lacks a house number. */
  AddressIncomplete = 'ADDRESS_INCOMPLETE',
  /** The shipping country is neither Germany nor Austria. */
  CountryNotSupported = 'COUNTRY_NOT_SUPPORTED',
  /** The DHL settings of the backend are missing or invalid. */
  NotConfigured = 'NOT_CONFIGURED',
  /** The production pilot is disabled before the logistics cutover. */
  NotEnabled = 'NOT_ENABLED',
  /** The Order's status is not Ready for Shipping. */
  NotReadyForShipping = 'NOT_READY_FOR_SHIPPING',
  /** The Order has no active label to cancel. */
  NoActiveLabel = 'NO_ACTIVE_LABEL',
  /** The Order's record type has no outbound DHL label, such as a Client Return or an Aktivitätstisch. */
  NoLabelForRecordType = 'NO_LABEL_FOR_RECORD_TYPE',
  /** No such Order, or Salesforce deleted it. */
  OrderNotFound = 'ORDER_NOT_FOUND',
  /** The production pilot refused the command; pilot.refusal contains the specific reason. */
  PilotRefused = 'PILOT_REFUSED'
}

/** The answer to a DHL label command. */
export type LogisticsShippingLabelResult = {
  __typename?: 'LogisticsShippingLabelResult';
  /** Set when the outcome is FAILED. */
  failure?: Maybe<LogisticsShippingLabelFailure>;
  /** The label the command created, found or cancelled. */
  label?: Maybe<LogisticsShippingLabel>;
  /** DHL's messages: warnings of a created label or the errors of a rejection. */
  messages: Array<LogisticsDhlMessage>;
  /** With refusal ADDRESS_INCOMPLETE: the Order's shipping fields to fill in; empty otherwise. */
  missingAddressFields: Array<LogisticsShippingAddressField>;
  outcome: LogisticsShippingLabelOutcome;
  /** Durable pilot/Salesforce outcome, separate from the DHL outcome. */
  pilot?: Maybe<LogisticsShippingLabelPilotResult>;
  /** Set when the outcome is REFUSED. */
  refusal?: Maybe<LogisticsShippingLabelRefusal>;
};

export type LogisticsShippingLabelState = {
  __typename?: 'LogisticsShippingLabelState';
  attempt?: Maybe<LogisticsShippingLabelAttempt>;
  enabled: Scalars['Boolean']['output'];
  label?: Maybe<LogisticsShippingLabel>;
  orderId: Scalars['UUID']['output'];
  pilot: Scalars['Boolean']['output'];
  refusal?: Maybe<Scalars['String']['output']>;
};

/** What WhereverSIM, our SIM provider, listed for a SIM unit at the latest complete scan (NG-9674). */
export type LogisticsSimProvider = {
  __typename?: 'LogisticsSimProvider';
  /** When the SIM's connectivity was last checked. */
  checkedAt?: Maybe<Scalars['Datetime']['output']>;
  /** ONLINE, ATTACHED, OFFLINE or BLOCKED at the latest connectivity check; null before the first check or without a device. */
  connectivityStatus?: Maybe<Scalars['String']['output']>;
  /** The latest check that found the device ONLINE, or the network's last data registration; null when never seen. */
  lastOnlineAt?: Maybe<Scalars['Datetime']['output']>;
  /** False when the latest complete scan did not list the unit's ICCID; the facts are then null. */
  listed: Scalars['Boolean']['output'];
  /** When the latest complete SIM scan started. */
  scannedAt: Scalars['Datetime']['output'];
  /** The SIM's status as WhereverSIM names it, such as Activated or Suspended. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Everything WhereverSIM returns for a SIM unit, read live (NG-9674). A section is null when there is nothing to call for it, such as the device of a SIM without one. */
export type LogisticsWhereverSimDetails = {
  __typename?: 'LogisticsWhereverSimDetails';
  /** The device's connectivity. */
  connectivity?: Maybe<LogisticsWhereverSimSection>;
  /** The device WhereverSIM calls an endpoint. */
  endpoint?: Maybe<LogisticsWhereverSimSection>;
  /** The SIM. */
  sim?: Maybe<LogisticsWhereverSimSection>;
  state: LogisticsWhereverSimDetailsState;
};

/** Why a SIM unit has, or has not, live WhereverSIM details. */
export enum LogisticsWhereverSimDetailsState {
  /** The sections hold what WhereverSIM returned. */
  Available = 'AVAILABLE',
  /** The backend has no WhereverSIM application token. */
  NotConfigured = 'NOT_CONFIGURED',
  /** The latest complete scan did not list the unit's ICCID. */
  NotListed = 'NOT_LISTED',
  /** WhereverSIM's SIM list has not been read completely yet. */
  NotScanned = 'NOT_SCANNED',
  /** The unit does not exist or is not a SIM. */
  NotSim = 'NOT_SIM'
}

/** What one WhereverSIM call returned. */
export type LogisticsWhereverSimSection = {
  __typename?: 'LogisticsWhereverSimSection';
  /** What WhereverSIM returned, without cell-level location and coordinates. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Set when the call failed: unauthorized, rate-limited, not-found, provider-error, unreachable or invalid-response. */
  errorCode?: Maybe<Scalars['String']['output']>;
};

export type LogisticsWorkspaceOneApp = {
  __typename?: 'LogisticsWorkspaceOneApp';
  appUuid: Scalars['String']['output'];
  assignedVersion?: Maybe<Scalars['String']['output']>;
  assignmentStatus?: Maybe<Scalars['String']['output']>;
  bundleId: Scalars['String']['output'];
  installedStatus?: Maybe<Scalars['String']['output']>;
  installedVersion?: Maybe<Scalars['String']['output']>;
  lastReportedAt?: Maybe<Scalars['Datetime']['output']>;
};

export enum LogisticsWorkspaceOneContradiction {
  Ambiguous = 'AMBIGUOUS',
  ClosedPlacementEnrolled = 'CLOSED_PLACEMENT_ENROLLED',
  MdmRemovedEnrolled = 'MDM_REMOVED_ENROLLED',
  NoInventory = 'NO_INVENTORY'
}

export type LogisticsWorkspaceOneCustomer = {
  __typename?: 'LogisticsWorkspaceOneCustomer';
  accountName?: Maybe<Scalars['String']['output']>;
  accountSalesforceId: Scalars['String']['output'];
};

export type LogisticsWorkspaceOneDevice = {
  __typename?: 'LogisticsWorkspaceOneDevice';
  apps: Array<LogisticsWorkspaceOneApp>;
  complianceStatus?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  deviceUuid: Scalars['String']['output'];
  enrollmentStatus?: Maybe<Scalars['String']['output']>;
  imei?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['Datetime']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  operatingSystem?: Maybe<Scalars['String']['output']>;
  organizationGroupName?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum LogisticsWorkspaceOneFleetState {
  Available = 'AVAILABLE',
  NotConfigured = 'NOT_CONFIGURED',
  Unavailable = 'UNAVAILABLE'
}

export type LogisticsWorkspaceOneInventoryUnit = {
  __typename?: 'LogisticsWorkspaceOneInventoryUnit';
  deletedInSalesforceAt?: Maybe<Scalars['Datetime']['output']>;
  hardwareSerialNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Read-only provider facts; ambiguity never exposes device metadata. Separate from inventory and staging status. */
export type LogisticsWorkspaceOneMatch = {
  __typename?: 'LogisticsWorkspaceOneMatch';
  device?: Maybe<LogisticsWorkspaceOneDevice>;
  stale: Scalars['Boolean']['output'];
  state: LogisticsWorkspaceOneMatchState;
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
};

export enum LogisticsWorkspaceOneMatchState {
  Ambiguous = 'AMBIGUOUS',
  Linked = 'LINKED',
  NotConfigured = 'NOT_CONFIGURED',
  Unavailable = 'UNAVAILABLE',
  Unlinked = 'UNLINKED'
}

/** A complete cached Workspace ONE snapshot, including devices without a unique inventory match. */
export type LogisticsWorkspaceOneOverview = {
  __typename?: 'LogisticsWorkspaceOneOverview';
  devices: Array<LogisticsWorkspaceOneOverviewDevice>;
  stale: Scalars['Boolean']['output'];
  state: LogisticsWorkspaceOneFleetState;
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
};

/** Each provider device retains its facts; inventory and customer are null for ambiguous or missing IMEI matches. */
export type LogisticsWorkspaceOneOverviewDevice = {
  __typename?: 'LogisticsWorkspaceOneOverviewDevice';
  contradictions: Array<LogisticsWorkspaceOneContradiction>;
  customer?: Maybe<LogisticsWorkspaceOneCustomer>;
  device: LogisticsWorkspaceOneDevice;
  inventory?: Maybe<LogisticsWorkspaceOneInventoryUnit>;
  matchState: LogisticsWorkspaceOneMatchState;
};

export type ManagerInvitation = {
  __typename?: 'ManagerInvitation';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The Salesforce account whose contact was invited. */
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  /** The account's name; null when the account is not in the crm copy. */
  salesforceAccountName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ManagerRegistrationCandidate = {
  __typename?: 'ManagerRegistrationCandidate';
  managerName: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
};

/** All input for the `markAsRead` mutation. */
export type MarkAsReadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `markAsRead` mutation. */
export type MarkAsReadPayload = {
  __typename?: 'MarkAsReadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['Datetime']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `markAsReceived` mutation. */
export type MarkAsReceivedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `markAsReceived` mutation. */
export type MarkAsReceivedPayload = {
  __typename?: 'MarkAsReceivedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['Datetime']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type MarketingCount = {
  __typename?: 'MarketingCount';
  count: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type MarketingDeliveryProviderOption = {
  __typename?: 'MarketingDeliveryProviderOption';
  name: Scalars['String']['output'];
  type: MarketingDeliveryProviderType;
};

export enum MarketingDeliveryProviderType {
  Fake = 'FAKE'
}

export type MarketingDeliverySettings = {
  __typename?: 'MarketingDeliverySettings';
  allowedRecipients: Array<Scalars['String']['output']>;
  availableProviders: Array<MarketingDeliveryProviderOption>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  hasApiKey: Scalars['Boolean']['output'];
  hasApiSecret: Scalars['Boolean']['output'];
  hasWebhookSecret: Scalars['Boolean']['output'];
  provider?: Maybe<MarketingDeliveryProviderType>;
  recipientsRestricted: Scalars['Boolean']['output'];
  replyToAddress?: Maybe<Scalars['String']['output']>;
  sendingDomain?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type MarketingDeliverySettingsInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  fromAddress: Scalars['String']['input'];
  fromName: Scalars['String']['input'];
  provider: MarketingDeliveryProviderType;
  replyToAddress?: InputMaybe<Scalars['String']['input']>;
  sendingDomain: Scalars['String']['input'];
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketingDnsPurpose {
  Dkim = 'DKIM',
  Dmarc = 'DMARC',
  Spf = 'SPF'
}

export type MarketingDnsRecord = {
  __typename?: 'MarketingDnsRecord';
  found: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  purpose: MarketingDnsPurpose;
  status: MarketingDnsRecordStatus;
  type: MarketingDnsRecordType;
  value: Scalars['String']['output'];
};

export enum MarketingDnsRecordStatus {
  Inherited = 'INHERITED',
  Mismatch = 'MISMATCH',
  Missing = 'MISSING',
  Unknown = 'UNKNOWN',
  Verified = 'VERIFIED'
}

export enum MarketingDnsRecordType {
  Cname = 'CNAME',
  Txt = 'TXT'
}

/** Leads of the last twelve calendar months in Berlin, the current one last. */
export type MarketingOverview = {
  __typename?: 'MarketingOverview';
  /** Leads converted per month, by what they convert to. */
  conversions: Array<MarketingSeries>;
  /** Median days from creation to conversion of the leads converted in these months. */
  medianDaysToConvert?: Maybe<Scalars['Float']['output']>;
  medianDaysToConvertByMonth: Array<Maybe<Scalars['Float']['output']>>;
  /** YYYY-MM, oldest first. */
  months: Array<Scalars['String']['output']>;
  /** Leads created per month, by lead source. */
  newLeads: Array<MarketingSourceSeries>;
  /** Leads not converted, by status. */
  openByStatus: Array<MarketingCount>;
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type MarketingSendingDomain = {
  __typename?: 'MarketingSendingDomain';
  checkedAt: Scalars['Datetime']['output'];
  domain: Scalars['String']['output'];
  records: Array<MarketingDnsRecord>;
};

/** One row of a monthly table: its label, null for leads without a value, and a count per month, oldest first. */
export type MarketingSeries = {
  __typename?: 'MarketingSeries';
  label?: Maybe<Scalars['String']['output']>;
  months: Array<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type MarketingSourceSeries = {
  __typename?: 'MarketingSourceSeries';
  /** The same leads by source detail. */
  details: Array<MarketingSeries>;
  label?: Maybe<Scalars['String']['output']>;
  months: Array<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type MarketingTestEmailInput = {
  to: Scalars['String']['input'];
};

export type MarketingTestEmailResult = {
  __typename?: 'MarketingTestEmailResult';
  errorCode?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  providerMessageId?: Maybe<Scalars['String']['output']>;
};

/** The B2C web orders of the last twelve weeks in Berlin. */
export type MarketingWebOrders = {
  __typename?: 'MarketingWebOrders';
  /** Newest first. */
  orders: Array<WebOrder>;
  /** False while no lead has plan variant ids: until Salesforce grants them, converted web orders are missing. */
  planVariantIdsKnown: Scalars['Boolean']['output'];
  stuckAfterMinutes: Scalars['Int']['output'];
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Oldest first; the last is this week. */
  weeks: Array<WebOrderWeek>;
};

export type Media = Node & {
  __typename?: 'Media';
  /** Reads a single `Attachment` that is related to this `Media`. */
  attachment?: Maybe<Attachment>;
  createdAt: Scalars['Datetime']['output'];
  dateOfCapture?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  featuredPeople?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  kind?: Maybe<MediaKind>;
  location?: Maybe<Scalars['String']['output']>;
  md5?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `MediaNote`. */
  mediaNotes: MediaNotesConnection;
  /** Reads and enables pagination through a set of `MediaNote`. */
  mediaNotesList: Array<MediaNote>;
  /** Reads and enables pagination through a set of `MediaVoiceRecording`. */
  mediaVoiceRecordings: MediaVoiceRecordingsConnection;
  /** Reads and enables pagination through a set of `MediaVoiceRecording`. */
  mediaVoiceRecordingsList: Array<MediaVoiceRecording>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type MediaMediaNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MediaNoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaNotesOrderBy>>;
};


export type MediaMediaNotesListArgs = {
  condition?: InputMaybe<MediaNoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaNotesOrderBy>>;
};


export type MediaMediaVoiceRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MediaVoiceRecordingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaVoiceRecordingsOrderBy>>;
};


export type MediaMediaVoiceRecordingsListArgs = {
  condition?: InputMaybe<MediaVoiceRecordingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaVoiceRecordingsOrderBy>>;
};

export type MediaAlbum = Node & {
  __typename?: 'MediaAlbum';
  albumName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Attachment`. */
  attachments: AttachmentsConnection;
  /** Reads and enables pagination through a set of `Attachment`. */
  attachmentsList: Array<Attachment>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  creatorId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  kind: MediaAlbumKind;
  /** Reads and enables pagination through a set of `Media`. */
  mediaItemList: Array<Media>;
  /** Reads and enables pagination through a set of `Media`. */
  mediaItems: MediaAlbumMediaItemsManyToManyConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `MediaAlbum`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};


export type MediaAlbumAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MediaAlbumAttachmentsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MediaAlbumMediaItemListArgs = {
  condition?: InputMaybe<MediaCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};


export type MediaAlbumMediaItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MediaCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};

export type MediaAlbumBatchInput = {
  albumName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id: Scalars['UUID']['input'];
  kind: MediaAlbumKind;
  userId: Scalars['UUID']['input'];
};

/**
 * A condition to be used against `MediaAlbum` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MediaAlbumCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `MediaAlbum` */
export type MediaAlbumInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaAlbumIdFkeyInverseInput>;
  albumName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaAlbumKind>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<MediaAlbumUserIdFkeyInput>;
};

export enum MediaAlbumKind {
  SystemAlbum = 'SYSTEM_ALBUM',
  UserAlbum = 'USER_ALBUM'
}

/** The fields on `mediaAlbum` to look up the row to connect. */
export type MediaAlbumMediaAlbumPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `Media` values, with data from `AlbumMedia`. */
export type MediaAlbumMediaItemsManyToManyConnection = {
  __typename?: 'MediaAlbumMediaItemsManyToManyConnection';
  /** A list of edges which contains the `Media`, info from the `AlbumMedia`, and the cursor to aid in pagination. */
  edges: Array<MediaAlbumMediaItemsManyToManyEdge>;
  /** A list of `Media` objects. */
  nodes: Array<Media>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Media` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Media` edge in the connection, with data from `AlbumMedia`. */
export type MediaAlbumMediaItemsManyToManyEdge = {
  __typename?: 'MediaAlbumMediaItemsManyToManyEdge';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  id: Scalars['UUID']['output'];
  /** The `Media` at the end of the edge. */
  node: Media;
};

/** The globally unique `ID` look up for the row to connect. */
export type MediaAlbumNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `mediaAlbum` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type MediaAlbumOnAlbumMediaForAlbumMediaAlbumIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `albumMedia` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `albumMedia` being updated. */
  patch: AlbumMediaPatch;
};

/** The fields on `mediaAlbum` to look up the row to update. */
export type MediaAlbumOnAlbumMediaForAlbumMediaAlbumIdFkeyUsingMediaAlbumPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `mediaAlbum` being updated. */
  patch: UpdateMediaAlbumOnAlbumMediaForAlbumMediaAlbumIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaAlbumOnMediaAlbumForMediaAlbumUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `mediaAlbum` to look up the row to update. */
export type MediaAlbumOnMediaAlbumForMediaAlbumUserIdFkeyUsingMediaAlbumPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `mediaAlbum` being updated. */
  patch: UpdateMediaAlbumOnMediaAlbumForMediaAlbumUserIdFkeyPatch;
};

/** Represents an update to a `MediaAlbum`. Fields that are set will be updated. */
export type MediaAlbumPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaAlbumIdFkeyInverseInput>;
  albumName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaAlbumKind>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<MediaAlbumUserIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `MediaAlbumInput` mutation. */
export type MediaAlbumUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<MediaAlbumUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnMediaAlbumForMediaAlbumUserIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MediaAlbumOnMediaAlbumForMediaAlbumUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `mediaAlbum` in the `UserInput` mutation. */
export type MediaAlbumUserIdFkeyInverseInput = {
  /** The primary key(s) for `mediaAlbum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MediaAlbumMediaAlbumPkeyConnect>>;
  /** The primary key(s) for `mediaAlbum` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MediaAlbumNodeIdConnect>>;
  /** A `MediaAlbumInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MediaAlbumUserIdFkeyMediaAlbumCreateInput>>;
  /** The primary key(s) and patch data for `mediaAlbum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MediaAlbumOnMediaAlbumForMediaAlbumUserIdFkeyUsingMediaAlbumPkeyUpdate>>;
  /** The primary key(s) and patch data for `mediaAlbum` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnMediaAlbumForMediaAlbumUserIdFkeyNodeIdUpdate>>;
};

/** The `mediaAlbum` to be created by this mutation. */
export type MediaAlbumUserIdFkeyMediaAlbumCreateInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaAlbumIdFkeyInverseInput>;
  albumName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaAlbumKind>;
  userToUserId?: InputMaybe<MediaAlbumUserIdFkeyInput>;
};

/** The `user` to be created by this mutation. */
export type MediaAlbumUserIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `MediaAlbum` values. */
export type MediaAlbumsConnection = {
  __typename?: 'MediaAlbumsConnection';
  /** A list of edges which contains the `MediaAlbum` and cursor to aid in pagination. */
  edges: Array<MediaAlbumsEdge>;
  /** A list of `MediaAlbum` objects. */
  nodes: Array<MediaAlbum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MediaAlbum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MediaAlbum` edge in the connection. */
export type MediaAlbumsEdge = {
  __typename?: 'MediaAlbumsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MediaAlbum` at the end of the edge. */
  node: MediaAlbum;
};

/** Methods to use when ordering `MediaAlbum`. */
export enum MediaAlbumsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A condition to be used against `Media` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MediaCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `Media` values. */
export type MediaConnection = {
  __typename?: 'MediaConnection';
  /** A list of edges which contains the `Media` and cursor to aid in pagination. */
  edges: Array<MediaEdge>;
  /** A list of `Media` objects. */
  nodes: Array<Media>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Media` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Media` edge in the connection. */
export type MediaEdge = {
  __typename?: 'MediaEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Media` at the end of the edge. */
  node: Media;
};

export type MediaImage = {
  __typename?: 'MediaImage';
  id: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type MediaImageWithExtension = {
  __typename?: 'MediaImageWithExtension';
  ext: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** An input for mutations affecting `Media` */
export type MediaInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MediaItem = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  md5?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum MediaKind {
  Aac = 'AAC',
  Gif = 'GIF',
  Jpg = 'JPG',
  M4A = 'M4A',
  Mp3 = 'MP3',
  Mp4 = 'MP4',
  Png = 'PNG'
}

/** The fields on `media` to look up the row to connect. */
export type MediaMediaPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `media` to look up the row to delete. */
export type MediaMediaPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type MediaNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `media` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type MediaNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `media` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

export type MediaNote = Node & {
  __typename?: 'MediaNote';
  /** Reads a single `User` that is related to this `MediaNote`. */
  author?: Maybe<User>;
  authorId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `Media` that is related to this `MediaNote`. */
  media?: Maybe<Media>;
  mediaId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

/** Input for the nested mutation of `user` in the `MediaNoteInput` mutation. */
export type MediaNoteAuthorFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<MediaNoteAuthorFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnMediaNoteForMediaNoteAuthorFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MediaNoteOnMediaNoteForMediaNoteAuthorFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `mediaNote` in the `UserInput` mutation. */
export type MediaNoteAuthorFkeyInverseInput = {
  /** The primary key(s) for `mediaNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MediaNoteMediaNotePkeyConnect>>;
  /** The primary key(s) for `mediaNote` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MediaNoteNodeIdConnect>>;
  /** A `MediaNoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MediaNoteAuthorFkeyMediaNoteCreateInput>>;
  /** The primary key(s) for `mediaNote` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MediaNoteMediaNotePkeyDelete>>;
  /** The primary key(s) for `mediaNote` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<MediaNoteNodeIdDelete>>;
  /** Flag indicating whether all other `mediaNote` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `mediaNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MediaNoteOnMediaNoteForMediaNoteAuthorFkeyUsingMediaNotePkeyUpdate>>;
  /** The primary key(s) and patch data for `mediaNote` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnMediaNoteForMediaNoteAuthorFkeyNodeIdUpdate>>;
};

/** The `mediaNote` to be created by this mutation. */
export type MediaNoteAuthorFkeyMediaNoteCreateInput = {
  author?: InputMaybe<MediaNoteAuthorFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<MediaNoteMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  text: Scalars['String']['input'];
};

/** The `user` to be created by this mutation. */
export type MediaNoteAuthorFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/**
 * A condition to be used against `MediaNote` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MediaNoteCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `mediaId` field. */
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `MediaNote` */
export type MediaNoteInput = {
  author?: InputMaybe<MediaNoteAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<MediaNoteMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  text: Scalars['String']['input'];
};

/** Input for the nested mutation of `media` in the `MediaNoteInput` mutation. */
export type MediaNoteMediaFkeyInput = {
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectById?: InputMaybe<MediaMediaPkeyConnect>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MediaNodeIdConnect>;
  /** A `MediaInput` object that will be created and connected to this object. */
  create?: InputMaybe<MediaNoteMediaFkeyMediaCreateInput>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteById?: InputMaybe<MediaMediaPkeyDelete>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<MediaNodeIdDelete>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateById?: InputMaybe<MediaOnMediaNoteForMediaNoteMediaFkeyUsingMediaPkeyUpdate>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MediaNoteOnMediaNoteForMediaNoteMediaFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `mediaNote` in the `MediaInput` mutation. */
export type MediaNoteMediaFkeyInverseInput = {
  /** The primary key(s) for `mediaNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MediaNoteMediaNotePkeyConnect>>;
  /** The primary key(s) for `mediaNote` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MediaNoteNodeIdConnect>>;
  /** A `MediaNoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MediaNoteMediaFkeyMediaNoteCreateInput>>;
  /** The primary key(s) for `mediaNote` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MediaNoteMediaNotePkeyDelete>>;
  /** The primary key(s) for `mediaNote` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<MediaNoteNodeIdDelete>>;
  /** Flag indicating whether all other `mediaNote` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `mediaNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MediaNoteOnMediaNoteForMediaNoteMediaFkeyUsingMediaNotePkeyUpdate>>;
  /** The primary key(s) and patch data for `mediaNote` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<MediaOnMediaNoteForMediaNoteMediaFkeyNodeIdUpdate>>;
};

/** The `media` to be created by this mutation. */
export type MediaNoteMediaFkeyMediaCreateInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** The `mediaNote` to be created by this mutation. */
export type MediaNoteMediaFkeyMediaNoteCreateInput = {
  author?: InputMaybe<MediaNoteAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<MediaNoteMediaFkeyInput>;
  text: Scalars['String']['input'];
};

/** The fields on `mediaNote` to look up the row to connect. */
export type MediaNoteMediaNotePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `mediaNote` to look up the row to delete. */
export type MediaNoteMediaNotePkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type MediaNoteNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `mediaNote` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type MediaNoteNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `mediaNote` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type MediaNoteOnMediaNoteForMediaNoteAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `mediaNote` to look up the row to update. */
export type MediaNoteOnMediaNoteForMediaNoteAuthorFkeyUsingMediaNotePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `mediaNote` being updated. */
  patch: UpdateMediaNoteOnMediaNoteForMediaNoteAuthorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaNoteOnMediaNoteForMediaNoteMediaFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `media` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: MediaPatch;
};

/** The fields on `mediaNote` to look up the row to update. */
export type MediaNoteOnMediaNoteForMediaNoteMediaFkeyUsingMediaNotePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `mediaNote` being updated. */
  patch: UpdateMediaNoteOnMediaNoteForMediaNoteMediaFkeyPatch;
};

/** Represents an update to a `MediaNote`. Fields that are set will be updated. */
export type MediaNotePatch = {
  author?: InputMaybe<MediaNoteAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<MediaNoteMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `MediaNote` values. */
export type MediaNotesConnection = {
  __typename?: 'MediaNotesConnection';
  /** A list of edges which contains the `MediaNote` and cursor to aid in pagination. */
  edges: Array<MediaNotesEdge>;
  /** A list of `MediaNote` objects. */
  nodes: Array<MediaNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MediaNote` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MediaNote` edge in the connection. */
export type MediaNotesEdge = {
  __typename?: 'MediaNotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MediaNote` at the end of the edge. */
  node: MediaNote;
};

/** Methods to use when ordering `MediaNote`. */
export enum MediaNotesOrderBy {
  AuthorIdAsc = 'AUTHOR_ID_ASC',
  AuthorIdDesc = 'AUTHOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MediaIdAsc = 'MEDIA_ID_ASC',
  MediaIdDesc = 'MEDIA_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** The globally unique `ID` look up for the row to update. */
export type MediaOnAlbumMediaForAlbumMediaMediaIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `albumMedia` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `albumMedia` being updated. */
  patch: AlbumMediaPatch;
};

/** The fields on `media` to look up the row to update. */
export type MediaOnAlbumMediaForAlbumMediaMediaIdFkeyUsingMediaPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: UpdateMediaOnAlbumMediaForAlbumMediaMediaIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaOnAttachmentForFkAttachmentMediaNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `attachment` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `attachment` being updated. */
  patch: AttachmentPatch;
};

/** The fields on `media` to look up the row to update. */
export type MediaOnAttachmentForFkAttachmentMediaUsingMediaPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: UpdateMediaOnAttachmentForFkAttachmentMediaPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaOnGroupForGroupAvatarMediaFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: GroupPatch;
};

/** The fields on `media` to look up the row to update. */
export type MediaOnGroupForGroupAvatarMediaFkeyUsingMediaPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: UpdateMediaOnGroupForGroupAvatarMediaFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaOnMediaNoteForMediaNoteMediaFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `mediaNote` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `mediaNote` being updated. */
  patch: MediaNotePatch;
};

/** The fields on `media` to look up the row to update. */
export type MediaOnMediaNoteForMediaNoteMediaFkeyUsingMediaPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: UpdateMediaOnMediaNoteForMediaNoteMediaFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaOnMediaVoiceRecordingForVoiceRecordingAudioFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `mediaVoiceRecording` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `mediaVoiceRecording` being updated. */
  patch: MediaVoiceRecordingPatch;
};

/** The fields on `media` to look up the row to update. */
export type MediaOnMediaVoiceRecordingForVoiceRecordingAudioFkeyUsingMediaPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: UpdateMediaOnMediaVoiceRecordingForVoiceRecordingAudioFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaOnMediaVoiceRecordingForVoiceRecordingMediaFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `mediaVoiceRecording` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `mediaVoiceRecording` being updated. */
  patch: MediaVoiceRecordingPatch;
};

/** The fields on `media` to look up the row to update. */
export type MediaOnMediaVoiceRecordingForVoiceRecordingMediaFkeyUsingMediaPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: UpdateMediaOnMediaVoiceRecordingForVoiceRecordingMediaFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaOnUserForUserAvatarMediaFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `media` to look up the row to update. */
export type MediaOnUserForUserAvatarMediaFkeyUsingMediaPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: UpdateMediaOnUserForUserAvatarMediaFkeyPatch;
};

/** Methods to use when ordering `Media`. */
export enum MediaOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `Media`. Fields that are set will be updated. */
export type MediaPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MediaVoiceRecording = Node & {
  __typename?: 'MediaVoiceRecording';
  audioId: Scalars['UUID']['output'];
  /** Reads a single `User` that is related to this `MediaVoiceRecording`. */
  author?: Maybe<User>;
  authorId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `Media` that is related to this `MediaVoiceRecording`. */
  media?: Maybe<Media>;
  mediaId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Media` that is related to this `MediaVoiceRecording`. */
  voiceRecording?: Maybe<Media>;
};

/**
 * A condition to be used against `MediaVoiceRecording` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type MediaVoiceRecordingCondition = {
  /** Checks for equality with the object’s `audioId` field. */
  audioId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `mediaId` field. */
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `MediaVoiceRecording` */
export type MediaVoiceRecordingInput = {
  audioId?: InputMaybe<Scalars['UUID']['input']>;
  author?: InputMaybe<VoiceRecordingAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<VoiceRecordingMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  voiceRecording?: InputMaybe<VoiceRecordingAudioFkeyInput>;
};

/** The fields on `mediaVoiceRecording` to look up the row to connect. */
export type MediaVoiceRecordingMediaVoiceRecordingPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `mediaVoiceRecording` to look up the row to delete. */
export type MediaVoiceRecordingMediaVoiceRecordingPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type MediaVoiceRecordingNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `mediaVoiceRecording` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type MediaVoiceRecordingNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `mediaVoiceRecording` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAudioFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `media` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: MediaPatch;
};

/** The fields on `mediaVoiceRecording` to look up the row to update. */
export type MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAudioFkeyUsingMediaVoiceRecordingPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `mediaVoiceRecording` being updated. */
  patch: UpdateMediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAudioFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `mediaVoiceRecording` to look up the row to update. */
export type MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyUsingMediaVoiceRecordingPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `mediaVoiceRecording` being updated. */
  patch: UpdateMediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingMediaFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `media` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: MediaPatch;
};

/** The fields on `mediaVoiceRecording` to look up the row to update. */
export type MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingMediaFkeyUsingMediaVoiceRecordingPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `mediaVoiceRecording` being updated. */
  patch: UpdateMediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingMediaFkeyPatch;
};

/** Represents an update to a `MediaVoiceRecording`. Fields that are set will be updated. */
export type MediaVoiceRecordingPatch = {
  audioId?: InputMaybe<Scalars['UUID']['input']>;
  author?: InputMaybe<VoiceRecordingAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<VoiceRecordingMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  voiceRecording?: InputMaybe<VoiceRecordingAudioFkeyInput>;
};

/** A connection to a list of `MediaVoiceRecording` values. */
export type MediaVoiceRecordingsConnection = {
  __typename?: 'MediaVoiceRecordingsConnection';
  /** A list of edges which contains the `MediaVoiceRecording` and cursor to aid in pagination. */
  edges: Array<MediaVoiceRecordingsEdge>;
  /** A list of `MediaVoiceRecording` objects. */
  nodes: Array<MediaVoiceRecording>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MediaVoiceRecording` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MediaVoiceRecording` edge in the connection. */
export type MediaVoiceRecordingsEdge = {
  __typename?: 'MediaVoiceRecordingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MediaVoiceRecording` at the end of the edge. */
  node: MediaVoiceRecording;
};

/** Methods to use when ordering `MediaVoiceRecording`. */
export enum MediaVoiceRecordingsOrderBy {
  AudioIdAsc = 'AUDIO_ID_ASC',
  AudioIdDesc = 'AUDIO_ID_DESC',
  AuthorIdAsc = 'AUTHOR_ID_ASC',
  AuthorIdDesc = 'AUTHOR_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MediaIdAsc = 'MEDIA_ID_ASC',
  MediaIdDesc = 'MEDIA_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type MediaWithCaption = {
  __typename?: 'MediaWithCaption';
  caption?: Maybe<Scalars['String']['output']>;
  media: MediaImageWithExtension;
};

export type MediaWithCaptionV2 = {
  __typename?: 'MediaWithCaptionV2';
  caption?: Maybe<Scalars['String']['output']>;
  media: ContentMedia;
};

export type MemberDevice = {
  __typename?: 'MemberDevice';
  deviceId: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type Membership = Node & {
  __typename?: 'Membership';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Group` that is related to this `Membership`. */
  group?: Maybe<Group>;
  groupId: Scalars['UUID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastRead: Scalars['Datetime']['output'];
  lastReceived?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `Membership`. */
  member?: Maybe<User>;
  memberId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `Membership` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MembershipCondition = {
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `lastRead` field. */
  lastRead?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The `group` to be created by this mutation. */
export type MembershipGroupIdGroupCreateInput = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind: GroupType;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** Input for the nested mutation of `group` in the `MembershipInput` mutation. */
export type MembershipGroupIdInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<GroupNodeIdConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<MembershipGroupIdGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnMembershipForMembershipGroupIdUsingGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MembershipOnMembershipForMembershipGroupIdNodeIdUpdate>;
};

/** Input for the nested mutation of `membership` in the `GroupInput` mutation. */
export type MembershipGroupIdInverseInput = {
  /** The primary key(s) for `membership` for the far side of the relationship. */
  connectByGroupIdAndMemberId?: InputMaybe<Array<MembershipMembershipPkeyConnect>>;
  /** The primary key(s) for `membership` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MembershipNodeIdConnect>>;
  /** A `MembershipInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MembershipGroupIdMembershipCreateInput>>;
  /** The primary key(s) and patch data for `membership` for the far side of the relationship. */
  updateByGroupIdAndMemberId?: InputMaybe<Array<MembershipOnMembershipForMembershipGroupIdUsingMembershipPkeyUpdate>>;
  /** The primary key(s) and patch data for `membership` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<GroupOnMembershipForMembershipGroupIdNodeIdUpdate>>;
};

/** The `membership` to be created by this mutation. */
export type MembershipGroupIdMembershipCreateInput = {
  groupToGroupId?: InputMaybe<MembershipGroupIdInput>;
  lastReceived?: InputMaybe<Scalars['Datetime']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  userToMemberId?: InputMaybe<MembershipMemberIdInput>;
};

/** An input for mutations affecting `Membership` */
export type MembershipInput = {
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupToGroupId?: InputMaybe<MembershipGroupIdInput>;
  lastReceived?: InputMaybe<Scalars['Datetime']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  userToMemberId?: InputMaybe<MembershipMemberIdInput>;
};

/** Input for the nested mutation of `user` in the `MembershipInput` mutation. */
export type MembershipMemberIdInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<MembershipMemberIdUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnMembershipForMembershipMemberIdUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MembershipOnMembershipForMembershipMemberIdNodeIdUpdate>;
};

/** Input for the nested mutation of `membership` in the `UserInput` mutation. */
export type MembershipMemberIdInverseInput = {
  /** The primary key(s) for `membership` for the far side of the relationship. */
  connectByGroupIdAndMemberId?: InputMaybe<Array<MembershipMembershipPkeyConnect>>;
  /** The primary key(s) for `membership` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MembershipNodeIdConnect>>;
  /** A `MembershipInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MembershipMemberIdMembershipCreateInput>>;
  /** The primary key(s) and patch data for `membership` for the far side of the relationship. */
  updateByGroupIdAndMemberId?: InputMaybe<Array<MembershipOnMembershipForMembershipMemberIdUsingMembershipPkeyUpdate>>;
  /** The primary key(s) and patch data for `membership` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnMembershipForMembershipMemberIdNodeIdUpdate>>;
};

/** The `membership` to be created by this mutation. */
export type MembershipMemberIdMembershipCreateInput = {
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupToGroupId?: InputMaybe<MembershipGroupIdInput>;
  lastReceived?: InputMaybe<Scalars['Datetime']['input']>;
  userToMemberId?: InputMaybe<MembershipMemberIdInput>;
};

/** The `user` to be created by this mutation. */
export type MembershipMemberIdUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The fields on `membership` to look up the row to connect. */
export type MembershipMembershipPkeyConnect = {
  groupId: Scalars['UUID']['input'];
  memberId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type MembershipNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `membership` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type MembershipOnMembershipForMembershipGroupIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: GroupPatch;
};

/** The fields on `membership` to look up the row to update. */
export type MembershipOnMembershipForMembershipGroupIdUsingMembershipPkeyUpdate = {
  groupId: Scalars['UUID']['input'];
  memberId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `membership` being updated. */
  patch: UpdateMembershipOnMembershipForMembershipGroupIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MembershipOnMembershipForMembershipMemberIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `membership` to look up the row to update. */
export type MembershipOnMembershipForMembershipMemberIdUsingMembershipPkeyUpdate = {
  groupId: Scalars['UUID']['input'];
  memberId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `membership` being updated. */
  patch: UpdateMembershipOnMembershipForMembershipMemberIdPatch;
};

/** Represents an update to a `Membership`. Fields that are set will be updated. */
export type MembershipPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupToGroupId?: InputMaybe<MembershipGroupIdInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastRead?: InputMaybe<Scalars['Datetime']['input']>;
  lastReceived?: InputMaybe<Scalars['Datetime']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  userToMemberId?: InputMaybe<MembershipMemberIdInput>;
};

/** A connection to a list of `Membership` values. */
export type MembershipsConnection = {
  __typename?: 'MembershipsConnection';
  /** A list of edges which contains the `Membership` and cursor to aid in pagination. */
  edges: Array<MembershipsEdge>;
  /** A list of `Membership` objects. */
  nodes: Array<Membership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Membership` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Membership` edge in the connection. */
export type MembershipsEdge = {
  __typename?: 'MembershipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Membership` at the end of the edge. */
  node: Membership;
};

/** Methods to use when ordering `Membership`. */
export enum MembershipsOrderBy {
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  LastReadAsc = 'LAST_READ_ASC',
  LastReadDesc = 'LAST_READ_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Message = Node & {
  __typename?: 'Message';
  /** Reads and enables pagination through a set of `Attachment`. */
  attachments: AttachmentsConnection;
  /** Reads and enables pagination through a set of `Attachment`. */
  attachmentsList: Array<Attachment>;
  /** Reads a single `User` that is related to this `Message`. */
  author?: Maybe<User>;
  authorId: Scalars['UUID']['output'];
  /** Reads a single `Group` that is related to this `Message`. */
  chat?: Maybe<Group>;
  chatId: Scalars['UUID']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  senderKeyId?: Maybe<Scalars['UUID']['output']>;
};


export type MessageAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AttachmentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttachmentsOrderBy>>;
};


export type MessageAttachmentsListArgs = {
  condition?: InputMaybe<AttachmentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttachmentsOrderBy>>;
};

/** Input for the nested mutation of `user` in the `MessageInput` mutation. */
export type MessageAuthorIdInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<MessageAuthorIdUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnMessageForMessageAuthorIdUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MessageOnMessageForMessageAuthorIdNodeIdUpdate>;
};

/** Input for the nested mutation of `message` in the `UserInput` mutation. */
export type MessageAuthorIdInverseInput = {
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageMessagePkeyConnect>>;
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MessageNodeIdConnect>>;
  /** The primary key(s) for `message` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MessageMessagePkeyDelete>>;
  /** The primary key(s) for `message` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<MessageNodeIdDelete>>;
  /** Flag indicating whether all other `message` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MessageOnMessageForMessageAuthorIdUsingMessagePkeyUpdate>>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnMessageForMessageAuthorIdNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type MessageAuthorIdUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The `group` to be created by this mutation. */
export type MessageChatIdGroupCreateInput = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind: GroupType;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** Input for the nested mutation of `group` in the `MessageInput` mutation. */
export type MessageChatIdInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<GroupNodeIdConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<MessageChatIdGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnMessageForMessageChatIdUsingGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MessageOnMessageForMessageChatIdNodeIdUpdate>;
};

/** Input for the nested mutation of `message` in the `GroupInput` mutation. */
export type MessageChatIdInverseInput = {
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageMessagePkeyConnect>>;
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MessageNodeIdConnect>>;
  /** The primary key(s) for `message` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MessageMessagePkeyDelete>>;
  /** The primary key(s) for `message` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<MessageNodeIdDelete>>;
  /** Flag indicating whether all other `message` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MessageOnMessageForMessageChatIdUsingMessagePkeyUpdate>>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<GroupOnMessageForMessageChatIdNodeIdUpdate>>;
};

/** A condition to be used against `Message` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MessageCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `chatId` field. */
  chatId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `message` to look up the row to connect. */
export type MessageMessagePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `message` to look up the row to delete. */
export type MessageMessagePkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type MessageNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `message` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type MessageNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `message` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type MessageOnAttachmentForAttachmentMessageIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `attachment` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `attachment` being updated. */
  patch: AttachmentPatch;
};

/** The fields on `message` to look up the row to update. */
export type MessageOnAttachmentForAttachmentMessageIdUsingMessagePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: UpdateMessageOnAttachmentForAttachmentMessageIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MessageOnMessageForMessageAuthorIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `message` to look up the row to update. */
export type MessageOnMessageForMessageAuthorIdUsingMessagePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: UpdateMessageOnMessageForMessageAuthorIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type MessageOnMessageForMessageChatIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: GroupPatch;
};

/** The fields on `message` to look up the row to update. */
export type MessageOnMessageForMessageChatIdUsingMessagePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: UpdateMessageOnMessageForMessageChatIdPatch;
};

/** Represents an update to a `Message`. Fields that are set will be updated. */
export type MessagePatch = {
  attachmentsUsingId?: InputMaybe<AttachmentMessageIdInverseInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  chatId?: InputMaybe<Scalars['UUID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  groupToChatId?: InputMaybe<MessageChatIdInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  senderKeyId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<MessageAuthorIdInput>;
};

export type MessageSubscriptionPayload = {
  __typename?: 'MessageSubscriptionPayload';
  message: Message;
};

/** A connection to a list of `Message` values. */
export type MessagesConnection = {
  __typename?: 'MessagesConnection';
  /** A list of edges which contains the `Message` and cursor to aid in pagination. */
  edges: Array<MessagesEdge>;
  /** A list of `Message` objects. */
  nodes: Array<Message>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Message` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Message` edge in the connection. */
export type MessagesEdge = {
  __typename?: 'MessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Message` at the end of the edge. */
  node: Message;
};

/** Methods to use when ordering `Message`. */
export enum MessagesOrderBy {
  AuthorIdAsc = 'AUTHOR_ID_ASC',
  AuthorIdDesc = 'AUTHOR_ID_DESC',
  ChatIdAsc = 'CHAT_ID_ASC',
  ChatIdDesc = 'CHAT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type MetaTag = Node & {
  __typename?: 'MetaTag';
  /** Reads and enables pagination through a set of `ContentMetaTag`. */
  contentItems: ContentMetaTagsConnection;
  /** Reads and enables pagination through a set of `ContentMetaTag`. */
  contentItemsList: Array<ContentMetaTag>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  kind: MetaTagKind;
  /** Reads and enables pagination through a set of `Content`. */
  metaTags: MetaTagMetaTagsManyToManyConnection;
  /** Reads and enables pagination through a set of `Content`. */
  metaTagsList: Array<Content>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  tag: Scalars['String']['output'];
};


export type MetaTagContentItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentMetaTagCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetaTagsOrderBy>>;
};


export type MetaTagContentItemsListArgs = {
  condition?: InputMaybe<ContentMetaTagCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetaTagsOrderBy>>;
};


export type MetaTagMetaTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentsOrderBy>>;
};


export type MetaTagMetaTagsListArgs = {
  condition?: InputMaybe<ContentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentsOrderBy>>;
};

/** A condition to be used against `MetaTag` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MetaTagCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<MetaTagKind>;
  /** Checks for equality with the object’s `tag` field. */
  tag?: InputMaybe<Scalars['String']['input']>;
};

export enum MetaTagKind {
  ActivitySetting = 'ACTIVITY_SETTING',
  ActivityType = 'ACTIVITY_TYPE',
  Category = 'CATEGORY',
  CognitiveTraining = 'COGNITIVE_TRAINING',
  Keyword = 'KEYWORD'
}

/** The fields on `metaTag` to look up the row to connect. */
export type MetaTagMetaTagPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `metaTag` to look up the row to connect. */
export type MetaTagMetaTagTagKindKeyConnect = {
  kind: MetaTagKind;
  tag: Scalars['String']['input'];
};

/** A connection to a list of `Content` values, with data from `ContentMetaTag`. */
export type MetaTagMetaTagsManyToManyConnection = {
  __typename?: 'MetaTagMetaTagsManyToManyConnection';
  /** A list of edges which contains the `Content`, info from the `ContentMetaTag`, and the cursor to aid in pagination. */
  edges: Array<MetaTagMetaTagsManyToManyEdge>;
  /** A list of `Content` objects. */
  nodes: Array<Content>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Content` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Content` edge in the connection, with data from `ContentMetaTag`. */
export type MetaTagMetaTagsManyToManyEdge = {
  __typename?: 'MetaTagMetaTagsManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  id: Scalars['UUID']['output'];
  /** The `Content` at the end of the edge. */
  node: Content;
};

/** The globally unique `ID` look up for the row to connect. */
export type MetaTagNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `metaTag` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type MetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `contentMetaTag` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `contentMetaTag` being updated. */
  patch: ContentMetaTagPatch;
};

/** The fields on `metaTag` to look up the row to update. */
export type MetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyUsingMetaTagPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `metaTag` being updated. */
  patch: UpdateMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyPatch;
};

/** The fields on `metaTag` to look up the row to update. */
export type MetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyUsingMetaTagTagKindKeyUpdate = {
  kind: MetaTagKind;
  /** An object where the defined keys will be set on the `metaTag` being updated. */
  patch: UpdateMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyPatch;
  tag: Scalars['String']['input'];
};

/** Represents an update to a `MetaTag`. Fields that are set will be updated. */
export type MetaTagPatch = {
  contentItems?: InputMaybe<ContentMetaTagMetaTagIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MetaTagKind>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

/** Methods to use when ordering `MetaTag`. */
export enum MetaTagsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KindAsc = 'KIND_ASC',
  KindDesc = 'KIND_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TagAsc = 'TAG_ASC',
  TagDesc = 'TAG_DESC'
}

export type Metadata = {
  __typename?: 'Metadata';
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type MinAppVersionInfo = {
  __typename?: 'MinAppVersionInfo';
  dev: Scalars['String']['output'];
  prod: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

export type MostUsedYoutubeContentItem = {
  __typename?: 'MostUsedYoutubeContentItem';
  averageCompletedDurationSeconds?: Maybe<Scalars['Float']['output']>;
  completedSessionCount: Scalars['BigInt']['output'];
  contentId: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  unfinishedSessionCount: Scalars['BigInt']['output'];
};

export type MoveMediaToAlbumInput = {
  mediaItemIds: Array<Scalars['UUID']['input']>;
  sourceAlbumId: Scalars['UUID']['input'];
  targetAlbumId: Scalars['UUID']['input'];
};

export type MoveMediaToTrashInput = {
  mediaItemIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  userId: Scalars['UUID']['input'];
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitationOnBehalf: Scalars['Boolean']['output'];
  /** Accepts the given invitation to a group if the invited user is logged in */
  acceptInvitationToGroup?: Maybe<AcceptInvitationToGroupPayload>;
  activateEncryptionForSenior?: Maybe<ActivateEncryptionForSeniorPayload>;
  /** Activates a license for a device. If app_flavour is provided and does not match the contract flavour, raises "flavour mismatch" error. */
  activateLicense?: Maybe<ActivateLicensePayload>;
  addActivityGoals?: Maybe<Scalars['Boolean']['output']>;
  addActivitySessionToNote?: Maybe<Scalars['Boolean']['output']>;
  addContentActivitySession: Scalars['Boolean']['output'];
  addContentActivitySessionV2: Scalars['Boolean']['output'];
  addCustomActivitySession: Scalars['Boolean']['output'];
  addFeatureActivitySession: Scalars['Boolean']['output'];
  addMediaToAlbum?: Maybe<Scalars['Boolean']['output']>;
  addPlacetelCallNote: PlacetelCallNote;
  addSettings?: Maybe<Scalars['Boolean']['output']>;
  /** Gives a staff user a role. The backend applies it on their next request. */
  addStaffRole: Scalars['Boolean']['output'];
  /** Add or update a user device */
  addUserDevice?: Maybe<AddUserDevicePayload>;
  assignLearningCourse: AssignmentResult;
  assignLearningPath: AssignmentResult;
  beginAdminMfaEnrollment: AdminMfaResponse;
  beginCompanySignIn: CompanySignInStart;
  beginPlacetelPhoneSignIn: PlacetelPhoneSignInStart;
  belongsToSameWorkgroup?: Maybe<BelongsToSameWorkgroupPayload>;
  cancelAdminMfaEnrollment: Scalars['Boolean']['output'];
  /** Cancels the bound pilot label, or the active owned/local label of an Order. DHL cancels until its end-of-day close; afterwards it refuses and its German message comes back as REJECTED. An existing export marker is preserved and continues to block a replacement pilot label. */
  cancelLogisticsShippingLabel: LogisticsShippingLabelResult;
  cancelPlannedProcedureActivities: Scalars['Boolean']['output'];
  /** Cancels an open staff invitation; its emailed code stops working. */
  cancelStaffInvitation: Scalars['Boolean']['output'];
  changeAdminPassword: Scalars['Boolean']['output'];
  changeDevice: LicenseData;
  /** Changes current user password */
  changePassword?: Maybe<ChangePasswordPayload>;
  checkLastOTP: Scalars['String']['output'];
  /**
   * Asks DHL for a token and the return receivers of the account with the saved
   * credentials. Needs dhl_integration.manage.
   */
  checkLogisticsDhlConnection: LogisticsDhlConnectionCheck;
  checkPlacetelConnection: PlacetelConnectionResult;
  checkSalesforceConnection: SalesforceConnectionCheck;
  checkValidationCode: Scalars['Boolean']['output'];
  checkValidationCodeForUserId: Scalars['Boolean']['output'];
  completeAdminMfa: AdminMfaResponse;
  completeCompanySignIn: CompanySignInResult;
  completeLearningLesson: LessonProgressResult;
  completeOnboarding: CompleteOnboardingPayload;
  completePlacetelPhoneSignIn: PlacetelPhoneSignInResult;
  createAccountBillingInvoiceDownload: BillingInvoiceDownload;
  /** Creates a single `Activity`. */
  createActivity?: Maybe<CreateActivityPayload>;
  /** Creates a single `ActivityGoal`. */
  createActivityGoal?: Maybe<CreateActivityGoalPayload>;
  /** Creates a single `ActivityParticipant`. */
  createActivityParticipant?: Maybe<CreateActivityParticipantPayload>;
  /** Creates a single `ActivitySession`. */
  createActivitySession?: Maybe<CreateActivitySessionPayload>;
  createAndAddMediaToAlbum?: Maybe<Scalars['Boolean']['output']>;
  /** Creates a single `AppSetting`. */
  createAppSetting?: Maybe<CreateAppSettingPayload>;
  /** Creates a single `Attachment`. */
  createAttachment?: Maybe<CreateAttachmentPayload>;
  createAvatarFromUrl: Scalars['Boolean']['output'];
  createBillingInvoiceDownload: BillingInvoiceDownload;
  /** Creates a single `CaregiverSenior`. */
  createCaregiverSenior?: Maybe<CreateCaregiverSeniorPayload>;
  createChatWithBot: ChatWithBot;
  /** Creates a single `CheckIn`. */
  createCheckIn?: Maybe<CreateCheckInPayload>;
  /** Creates a single `CheckInMessage`. */
  createCheckInMessage?: Maybe<CreateCheckInMessagePayload>;
  /** Creates a single `ContentActivity`. */
  createContentActivity?: Maybe<CreateContentActivityPayload>;
  /** Creates a single `ContentMetaTag`. */
  createContentMetaTag?: Maybe<CreateContentMetaTagPayload>;
  /** Creates a single `CustomActivity`. */
  createCustomActivity?: Maybe<CreateCustomActivityPayload>;
  /** Creates a single `Device`. */
  createDevice?: Maybe<CreateDevicePayload>;
  createDeviceEnrollmentToken: CreateDeviceEnrollmentTokenResponse;
  /** Creates a single `FamilyMemberSenior`. */
  createFamilyMemberSenior?: Maybe<CreateFamilyMemberSeniorPayload>;
  /** Creates a single `FeatureActivity`. */
  createFeatureActivity?: Maybe<CreateFeatureActivityPayload>;
  /** Creates a single `Feedback`. */
  createFeedback?: Maybe<CreateFeedbackPayload>;
  /** Creates a single `Group`. */
  createGroup?: Maybe<CreateGroupPayload>;
  /** Creates a single `HandshakeCode`. */
  createHandshakeCode?: Maybe<CreateHandshakeCodePayload>;
  /** Creates a single `KorianUser`. */
  createKorianUser?: Maybe<CreateKorianUserPayload>;
  createLicensingManagerFixture: Scalars['String']['output'];
  /** Creates a single `Location`. */
  createLocation?: Maybe<CreateLocationPayload>;
  /** Creates the DHL label of a Ready for Shipping Order, with a return label for an exchange or when asked for. Calling it again returns the active label. */
  createLogisticsShippingLabel: LogisticsShippingLabelResult;
  /** Creates a single `Media`. */
  createMedia?: Maybe<CreateMediaPayload>;
  /** Creates a single `MediaAlbum`. */
  createMediaAlbum?: Maybe<CreateMediaAlbumPayload>;
  createMediaAlbums: CreateMediaAlbumsPayload;
  /** Creates a single `MediaNote`. */
  createMediaNote?: Maybe<CreateMediaNotePayload>;
  /** Creates a single `MediaVoiceRecording`. */
  createMediaVoiceRecording?: Maybe<CreateMediaVoiceRecordingPayload>;
  /** Creates a single `Membership`. */
  createMembership?: Maybe<CreateMembershipPayload>;
  createMessage?: Maybe<CreateMessagePayload>;
  /** Creates a single `Note`. */
  createNote?: Maybe<CreateNotePayload>;
  /** Creates or returns the private chat between the two given users */
  createOrRetrievePrivateChat?: Maybe<CreateOrRetrievePrivateChatPayload>;
  createPlannedProcedureActivitySession: Scalars['Boolean']['output'];
  /** Creates a single `Procedure`. */
  createProcedure?: Maybe<CreateProcedurePayload>;
  /** Creates a single `ProcedureParticipant`. */
  createProcedureParticipant?: Maybe<CreateProcedureParticipantPayload>;
  /**
   * Saves a programme run started on the tablet as a planned M4c procedure with one
   * planned activity per programme activity. Idempotent on the client-supplied ids.
   */
  createProgrammeProcedure: CreateProgrammeProcedurePayload;
  /** Creates a single `SenderKey`. */
  createSenderKey?: Maybe<CreateSenderKeyPayload>;
  /** Creates a new account for a senior */
  createSenior?: Maybe<CreateSeniorPayload>;
  createSeniorProfile: NewProfile;
  /** Send system message to a user */
  createSystemMessage?: Maybe<CreateSystemMessagePayload>;
  createTestCustomer: Scalars['Boolean']['output'];
  createTestLicensingCustomer: Scalars['String']['output'];
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `UserContentActivity`. */
  createUserContentActivity?: Maybe<CreateUserContentActivityPayload>;
  createUserContentFavorite: ContentFavoriteReturn;
  createUserContentFavoriteV2: ContentFavoriteReturnV2;
  /** Creates a single `UserSetting`. */
  createUserSetting?: Maybe<CreateUserSettingPayload>;
  createUserWithValidationCode: TokenResponse;
  createValidationCode: Scalars['Boolean']['output'];
  /** Creates a single `Website`. */
  createWebsite?: Maybe<CreateWebsitePayload>;
  /** Creates a single `Workgroup`. */
  createWorkgroup?: Maybe<CreateWorkgroupPayload>;
  createWorkgroupAndCode?: Maybe<CreateWorkgroupAndCodeResponse>;
  /** Creates a single `WorkgroupMembership`. */
  createWorkgroupMembership?: Maybe<CreateWorkgroupMembershipPayload>;
  /** Deletes a single `Activity` using a unique key. */
  deleteActivity?: Maybe<DeleteActivityPayload>;
  /** Deletes a single `Activity` using its globally unique id. */
  deleteActivityByNodeId?: Maybe<DeleteActivityPayload>;
  /** Deletes a single `ActivityGoal` using a unique key. */
  deleteActivityGoal?: Maybe<DeleteActivityGoalPayload>;
  /** Deletes a single `ActivityGoal` using its globally unique id. */
  deleteActivityGoalByNodeId?: Maybe<DeleteActivityGoalPayload>;
  /** Deletes a single `ActivityGoal` using a unique key. */
  deleteActivityGoalByUserIdAndKind?: Maybe<DeleteActivityGoalPayload>;
  /** Deletes one resident's manual note from an Activity draft. */
  deleteActivityManualNote: Scalars['Boolean']['output'];
  /** Deletes one resident's MD documentation from an Activity draft. */
  deleteActivityMdDocumentation: Scalars['Boolean']['output'];
  /** Deletes a single `ActivityParticipant` using a unique key. */
  deleteActivityParticipant?: Maybe<DeleteActivityParticipantPayload>;
  /** Deletes a single `ActivityParticipant` using a unique key. */
  deleteActivityParticipantByActivitySessionIdAndSeniorId?: Maybe<DeleteActivityParticipantPayload>;
  /** Deletes a single `ActivityParticipant` using its globally unique id. */
  deleteActivityParticipantByNodeId?: Maybe<DeleteActivityParticipantPayload>;
  /** Deletes a single `ActivitySession` using a unique key. */
  deleteActivitySession?: Maybe<DeleteActivitySessionPayload>;
  /** Deletes a single `ActivitySession` using its globally unique id. */
  deleteActivitySessionByNodeId?: Maybe<DeleteActivitySessionPayload>;
  /** Deletes a single `AlbumMedia` using a unique key. */
  deleteAlbumMedia?: Maybe<DeleteAlbumMediaPayload>;
  /** Deletes a single `AlbumMedia` using a unique key. */
  deleteAlbumMediaByMediaIdAndAlbumId?: Maybe<DeleteAlbumMediaPayload>;
  /** Deletes a single `AlbumMedia` using its globally unique id. */
  deleteAlbumMediaByNodeId?: Maybe<DeleteAlbumMediaPayload>;
  /** Deletes a single `AppSetting` using a unique key. */
  deleteAppSetting?: Maybe<DeleteAppSettingPayload>;
  /** Deletes a single `AppSetting` using its globally unique id. */
  deleteAppSettingByNodeId?: Maybe<DeleteAppSettingPayload>;
  /** Deletes a single `AppSetting` using a unique key. */
  deleteAppSettingByUserIdAndSettingType?: Maybe<DeleteAppSettingPayload>;
  /** Deletes a single `Attachment` using a unique key. */
  deleteAttachment?: Maybe<DeleteAttachmentPayload>;
  /** Deletes a single `Attachment` using its globally unique id. */
  deleteAttachmentByNodeId?: Maybe<DeleteAttachmentPayload>;
  /** Deletes a single `CaregiverSenior` using a unique key. */
  deleteCaregiverSenior?: Maybe<DeleteCaregiverSeniorPayload>;
  /** Deletes a single `CaregiverSenior` using its globally unique id. */
  deleteCaregiverSeniorByNodeId?: Maybe<DeleteCaregiverSeniorPayload>;
  /** Deletes a single `CheckInMessage` using a unique key. */
  deleteCheckInMessage?: Maybe<DeleteCheckInMessagePayload>;
  /** Deletes a single `CheckInMessage` using its globally unique id. */
  deleteCheckInMessageByNodeId?: Maybe<DeleteCheckInMessagePayload>;
  /** Deletes a single `ContentActivity` using a unique key. */
  deleteContentActivity?: Maybe<DeleteContentActivityPayload>;
  /** Deletes a single `ContentActivity` using a unique key. */
  deleteContentActivityByContentId?: Maybe<DeleteContentActivityPayload>;
  /** Deletes a single `ContentActivity` using its globally unique id. */
  deleteContentActivityByNodeId?: Maybe<DeleteContentActivityPayload>;
  /** Deletes a single `ContentMetaTag` using a unique key. */
  deleteContentMetaTag?: Maybe<DeleteContentMetaTagPayload>;
  /** Deletes a single `ContentMetaTag` using a unique key. */
  deleteContentMetaTagByContentIdAndMetaTagId?: Maybe<DeleteContentMetaTagPayload>;
  /** Deletes a single `ContentMetaTag` using its globally unique id. */
  deleteContentMetaTagByNodeId?: Maybe<DeleteContentMetaTagPayload>;
  /** Deletes a single `CustomActivity` using a unique key. */
  deleteCustomActivity?: Maybe<DeleteCustomActivityPayload>;
  /** Deletes a single `CustomActivity` using a unique key. */
  deleteCustomActivityByName?: Maybe<DeleteCustomActivityPayload>;
  /** Deletes a single `CustomActivity` using its globally unique id. */
  deleteCustomActivityByNodeId?: Maybe<DeleteCustomActivityPayload>;
  /** Deletes a single `Device` using a unique key. */
  deleteDevice?: Maybe<DeleteDevicePayload>;
  /** Deletes a single `Device` using its globally unique id. */
  deleteDeviceByNodeId?: Maybe<DeleteDevicePayload>;
  /** Deletes a single `FamilyMemberSenior` using a unique key. */
  deleteFamilyMemberSenior?: Maybe<DeleteFamilyMemberSeniorPayload>;
  /** Deletes a single `FamilyMemberSenior` using its globally unique id. */
  deleteFamilyMemberSeniorByNodeId?: Maybe<DeleteFamilyMemberSeniorPayload>;
  /** Deletes a single `FeatureActivity` using a unique key. */
  deleteFeatureActivity?: Maybe<DeleteFeatureActivityPayload>;
  /** Deletes a single `FeatureActivity` using a unique key. */
  deleteFeatureActivityByKind?: Maybe<DeleteFeatureActivityPayload>;
  /** Deletes a single `FeatureActivity` using its globally unique id. */
  deleteFeatureActivityByNodeId?: Maybe<DeleteFeatureActivityPayload>;
  /** Deletes a single `Feedback` using a unique key. */
  deleteFeedback?: Maybe<DeleteFeedbackPayload>;
  /** Deletes a single `Feedback` using its globally unique id. */
  deleteFeedbackByNodeId?: Maybe<DeleteFeedbackPayload>;
  /** Deletes a single `HandshakeCode` using a unique key. */
  deleteHandshakeCode?: Maybe<DeleteHandshakeCodePayload>;
  /** Deletes a single `HandshakeCode` using a unique key. */
  deleteHandshakeCodeByCode?: Maybe<DeleteHandshakeCodePayload>;
  /** Deletes a single `HandshakeCode` using its globally unique id. */
  deleteHandshakeCodeByNodeId?: Maybe<DeleteHandshakeCodePayload>;
  /** Deletes a single `HandshakeCode` using a unique key. */
  deleteHandshakeCodeByWorkgroupIdAndInitiatorId?: Maybe<DeleteHandshakeCodePayload>;
  /** Deletes a single `Invitation` using a unique key. */
  deleteInvitation?: Maybe<DeleteInvitationPayload>;
  /** Deletes a single `Invitation` using its globally unique id. */
  deleteInvitationByNodeId?: Maybe<DeleteInvitationPayload>;
  /** Deletes a single `Location` using a unique key. */
  deleteLocation?: Maybe<DeleteLocationPayload>;
  /** Deletes a single `Location` using its globally unique id. */
  deleteLocationByNodeId?: Maybe<DeleteLocationPayload>;
  /** Deletes a single `Location` using a unique key. */
  deleteLocationBySourceSystemAndExternalIdAndTypeAndOrganizationId?: Maybe<DeleteLocationPayload>;
  /** Deletes a single `Media` using a unique key. */
  deleteMedia?: Maybe<DeleteMediaPayload>;
  deleteMediaAlbum?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a single `Media` using its globally unique id. */
  deleteMediaByNodeId?: Maybe<DeleteMediaPayload>;
  deleteMediaInAlbums?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a single `MediaNote` using a unique key. */
  deleteMediaNote?: Maybe<DeleteMediaNotePayload>;
  /** Deletes a single `MediaNote` using its globally unique id. */
  deleteMediaNoteByNodeId?: Maybe<DeleteMediaNotePayload>;
  /** Deletes a single `MediaVoiceRecording` using a unique key. */
  deleteMediaVoiceRecording?: Maybe<DeleteMediaVoiceRecordingPayload>;
  /** Deletes a single `MediaVoiceRecording` using its globally unique id. */
  deleteMediaVoiceRecordingByNodeId?: Maybe<DeleteMediaVoiceRecordingPayload>;
  /** Deletes a single `Message` using a unique key. */
  deleteMessage?: Maybe<DeleteMessagePayload>;
  /** Deletes a single `Message` using its globally unique id. */
  deleteMessageByNodeId?: Maybe<DeleteMessagePayload>;
  /** Deletes a single `Note` using a unique key. */
  deleteNote?: Maybe<DeleteNotePayload>;
  /** Deletes a single `Note` using its globally unique id. */
  deleteNoteByNodeId?: Maybe<DeleteNotePayload>;
  /** Deletes a single `Procedure` using a unique key. */
  deleteProcedure?: Maybe<DeleteProcedurePayload>;
  /** Deletes a single `Procedure` using its globally unique id. */
  deleteProcedureByNodeId?: Maybe<DeleteProcedurePayload>;
  /** Deletes a single `Procedure` using a unique key. */
  deleteProcedureBySourceSystemAndExternalIdAndOrganizationId?: Maybe<DeleteProcedurePayload>;
  deleteProcedureDocumentationNote: Scalars['Boolean']['output'];
  /** Deletes a single `ProcedureParticipant` using a unique key. */
  deleteProcedureParticipant?: Maybe<DeleteProcedureParticipantPayload>;
  /** Deletes a single `ProcedureParticipant` using its globally unique id. */
  deleteProcedureParticipantByNodeId?: Maybe<DeleteProcedureParticipantPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUserByNodeId?: Maybe<DeleteUserPayload>;
  /** Deletes a single `UserContentActivity` using a unique key. */
  deleteUserContentActivity?: Maybe<DeleteUserContentActivityPayload>;
  /** Deletes a single `UserContentActivity` using its globally unique id. */
  deleteUserContentActivityByNodeId?: Maybe<DeleteUserContentActivityPayload>;
  /** Deletes a single `UserContentFavorite` using a unique key. */
  deleteUserContentFavorite?: Maybe<DeleteUserContentFavoritePayload>;
  /** Deletes a single `UserContentFavorite` using its globally unique id. */
  deleteUserContentFavoriteByNodeId?: Maybe<DeleteUserContentFavoritePayload>;
  /** Deletes a single `UserContentFavorite` using a unique key. */
  deleteUserContentFavoriteByUserIdAndContentId?: Maybe<DeleteUserContentFavoritePayload>;
  /** Deletes a single `UserSetting` using a unique key. */
  deleteUserSetting?: Maybe<DeleteUserSettingPayload>;
  /** Deletes a single `UserSetting` using its globally unique id. */
  deleteUserSettingByNodeId?: Maybe<DeleteUserSettingPayload>;
  /** Deletes a single `Website` using a unique key. */
  deleteWebsite?: Maybe<DeleteWebsitePayload>;
  /** Deletes a single `Website` using its globally unique id. */
  deleteWebsiteByNodeId?: Maybe<DeleteWebsitePayload>;
  /** Deletes a single `Workgroup` using a unique key. */
  deleteWorkgroup?: Maybe<DeleteWorkgroupPayload>;
  /** Deletes a single `Workgroup` using its globally unique id. */
  deleteWorkgroupByNodeId?: Maybe<DeleteWorkgroupPayload>;
  /** Deletes a single `WorkgroupMembership` using a unique key. */
  deleteWorkgroupMembership?: Maybe<DeleteWorkgroupMembershipPayload>;
  /** Deletes a single `WorkgroupMembership` using its globally unique id. */
  deleteWorkgroupMembershipByNodeId?: Maybe<DeleteWorkgroupMembershipPayload>;
  /** Deregisters a device from receiving push notifications */
  deregisterPushNotificationDevice?: Maybe<DeregisterPushNotificationDevicePayload>;
  disableAdminMfa: AdminMfaResponse;
  disconnectPlacetelPhone: PlacetelPhoneAccount;
  /** Dismisses an open Finance notification with a reason. The dismissal holds while the notification's key dates stay the same. Needs billing_notifications.handle. */
  dismissFinanceNotification: FinanceNotificationDismissal;
  endProcedureExecution: EndProcedureExecutionPayload;
  /**
   * The manager credential path: enrolls a device through the same
   * mechanism, using a one-minute implicit token that is never handed out.
   */
  enrollDeviceAsManager: DeviceEnrollmentResponse;
  finishActivitySession: Scalars['Boolean']['output'];
  /** Sends a password reset email if the given email address is known */
  forgotPassword?: Maybe<ForgotPasswordPayload>;
  generateTestLicense: TestLicenseResponse;
  generateToyDataset: Scalars['Boolean']['output'];
  generateToyDatasetFromFamily: GenerateToyDatasetFromFamilyReturn;
  getInvitationOtp: Scalars['String']['output'];
  grantLearningCourse: GrantResult;
  grantLearningPath: GrantResult;
  includeProcedureManualNote: Scalars['Boolean']['output'];
  invalidateContentUrlsCache: Scalars['Boolean']['output'];
  /** Sends an invitation email */
  invite?: Maybe<InvitePayload>;
  inviteManager: Scalars['Boolean']['output'];
  /** Invites a staff user by email. They get the roles when they register. */
  inviteStaff: Scalars['Boolean']['output'];
  /** Checks if the android device is supported to run versions greater than 3.x */
  isAndroidDeviceSupported?: Maybe<IsAndroidDeviceSupportedPayload>;
  /** Checks eligibility of a tablet for update to 3.x */
  isTabletUpdatable?: Maybe<IsTabletUpdatablePayload>;
  isUserInWorkgroup?: Maybe<IsUserInWorkgroupPayload>;
  ismanagerofcaregiver?: Maybe<IsmanagerofcaregiverPayload>;
  issueCaregiverDeviceToken: CaregiverDeviceTokenResponse;
  issuePlacetelPhoneAccessToken: PlacetelPhoneAccessToken;
  joinWorkgroup?: Maybe<JoinWorkGroupResponse>;
  learningChangePassword: LearningAuthPayload;
  learningLogin: LearningAuthPayload;
  learningRequestPasswordReset: Scalars['Boolean']['output'];
  learningResetPassword: LearningAuthPayload;
  leaveWorkgroup?: Maybe<Scalars['Boolean']['output']>;
  logAssistantInteraction?: Maybe<Scalars['Boolean']['output']>;
  /** Authenticates the user */
  login?: Maybe<LoginPayload>;
  loginCaregiverWithPin: PractitionerLoginOutcome;
  /** Logs in or creates a senior, given a device serial number and a name */
  loginOrCreateSenior?: Maybe<LoginOrCreateSeniorPayload>;
  /** @deprecated Use loginCaregiverWithPin. */
  loginPractitioner: PractitionerLoginResponse;
  /** Authenticates a senior user given a licence */
  loginSenior?: Maybe<LoginSeniorPayload>;
  loginUser: LoginUserResponse;
  /** Sets the `last_read` timestamp of a user in chat as defined by the given `message_id`. */
  markAsRead?: Maybe<MarkAsReadPayload>;
  /** Sets the `last_received` timestamp of a user in chat as defined by the given `message_id`. */
  markAsReceived?: Maybe<MarkAsReceivedPayload>;
  moveMediaToAlbum?: Maybe<Scalars['Boolean']['output']>;
  moveMediaToTrash?: Maybe<Scalars['Boolean']['output']>;
  planRecommendedActivity: PlanRecommendedActivityResult;
  previewIntegrationImport: IntegrationExecution;
  /**
   * Finalizes an Activity's documentation once its auto-generated summary is
   * complete. Publishes exactly the selected blocks and queues their care-system
   * sync. Idempotent replays return the original finalized result.
   */
  publishActivityDocumentation?: Maybe<PublishActivityDocumentationPayload>;
  publishProcedureDocumentation: PublishProcedureDocumentationPayload;
  recordIntegrationImportPreview: IntegrationImportPreviewCounts;
  /**
   * Records one step of a call the portal's phone handled. Several tabs of one
   * agent may report the same call in any order: the first start and answer
   * times are kept, an answer outranks a missed, rejected or failed end
   * whichever arrives first, and an answered outcome is final. An event that
   * carries a record replaces the call's links.
   */
  recordPlacetelCallEvent: PlacetelCall;
  /**
   * Unauthenticated: consumes one use of the code and returns the device
   * credential the tablet stores.
   */
  redeemDeviceEnrollmentToken: DeviceEnrollmentResponse;
  refreshAccessToken?: Maybe<Scalars['String']['output']>;
  registerPushNotificationDevice?: Maybe<RegisterPushNotificationDevicePayload>;
  /** Creates a new user, given that the current jwt sub corresponds to a valid invitation */
  registerUser?: Maybe<RegisterUserPayload>;
  rejectInvitationToGroup: Scalars['Boolean']['output'];
  removeActivitySessionFromNote?: Maybe<Scalars['Boolean']['output']>;
  removeMediaFromAlbum?: Maybe<Scalars['Boolean']['output']>;
  removePlannedProcedureActivitySession: Scalars['Boolean']['output'];
  /** Takes a role from a staff user. The last Admin keeps the Admin role. */
  removeStaffRole: Scalars['Boolean']['output'];
  reportDocumentationSync: Scalars['Boolean']['output'];
  requestPasswordResetOTP: Scalars['Boolean']['output'];
  requestPractitionerPasswordResetOTP: RequestPractitionerPasswordResetOtpResponse;
  /** Resend invitation email for a given id */
  resendInvitation?: Maybe<ResendInvitationPayload>;
  /** Resets a password, given a valid password request */
  resetPassword?: Maybe<ResetPasswordPayload>;
  resetPasswordWithValidationCode: TokenResponse;
  resetPasswordWithValidationCodeForUserId: Scalars['Boolean']['output'];
  resetPractitionerPasswordOTP: ResetPasswordOtpResponse;
  /**
   * Unauthenticated: tells a tablet which organization and final scope a
   * code belongs to, without enrolling anything.
   */
  resolveDeviceEnrollmentToken: ResolvedDeviceEnrollmentToken;
  revealPractitionerPasswordOTP: RevealPractitionerPasswordOtpResponse;
  reviewCustomerServiceCrmDuplicate: CrmDuplicateCandidate;
  revokeDeviceEnrollmentToken: DeviceEnrollmentToken;
  revokeLearningCourse: GrantResult;
  revokeLearningPath: GrantResult;
  saveFormResponse?: Maybe<Scalars['Boolean']['output']>;
  saveIntegrationSettings: IntegrationSettings;
  /** Add or update mdapp backup */
  saveMdappBackup?: Maybe<SaveMdappBackupPayload>;
  saveProcedureDocumentationNote: SaveProcedureDocumentationNotePayload;
  selfEnrollLearningCourse: EnrollmentResult;
  selfEnrollLearningPath: EnrollmentResult;
  sendDeviceEnrollmentTokenEmail: DeviceEnrollmentEmailDelivery;
  sendInstallationInstructions?: Maybe<Scalars['Boolean']['output']>;
  sendInstructions?: Maybe<Scalars['Boolean']['output']>;
  sendLicensingPortalInvitation?: Maybe<SendLicensingPortalInvitationPayload>;
  sendMarketingTestEmail: MarketingTestEmailResult;
  sendQrCodeSalesforce?: Maybe<SendQrCodeSalesforcePayload>;
  sendQrcode?: Maybe<SendQrcodePayload>;
  /** Sends a video call event to a group. */
  sendVideocallEvent?: Maybe<SendVideocallEventPayload>;
  /**
   * Sets whether the B2B account provides ambulant care, and copies it to
   * the account's facility.
   */
  setAccountAmbulant: Scalars['Boolean']['output'];
  /** Includes or excludes the Activity's manual note while it is a draft. */
  setActivityDocumentationManualNoteIncluded: Scalars['Boolean']['output'];
  setOrganizationBillingAccess: OrganizationBillingAccess;
  setOrganizationBillingAccount: OrganizationBillingAccess;
  /**
   * Links an unlinked organization only when the B2B account has no tenant.
   * Repeating the same link is safe; replacing an existing link is forbidden.
   */
  setOrganizationSalesforceAccount: Scalars['Boolean']['output'];
  /**
   * Sets up the B2B account's internal tenant without inviting a manager.
   * Repeated setup preserves the existing tenant and its settings.
   */
  setupAccountPortalAccess: Scalars['UUID']['output'];
  /**
   * Queues a run that reads every Salesforce record, as the first run did,
   * and applies the deletion rule to what Salesforce no longer holds.
   */
  startFullSalesforceSync: Scalars['Boolean']['output'];
  startLearningCourse: StartedLearningCourse;
  startPlannedActivitySession: Scalars['Boolean']['output'];
  startSalesforceSync: Scalars['Boolean']['output'];
  stopProcedure: Scalars['Boolean']['output'];
  submitAdminPortalFeedback: SubmitAdminPortalFeedbackPayload;
  submitLearningQuizAttempt: QuizAttemptResult;
  syncContractItemSalesforce: LicenseData;
  syncIntegrationData: IntegrationExecution;
  syncPublishedContentList: Scalars['Boolean']['output'];
  /** (Testing Environment) Sets the `last_read` timestamp of a user in chat. */
  testEnvUpdateLastRead?: Maybe<TestEnvUpdateLastReadPayload>;
  /** (Testing Environment) Sets the `created_at` timestamp of message. */
  testEnvUpdateMessageCreatedAt?: Maybe<TestEnvUpdateMessageCreatedAtPayload>;
  testIntegrationConnection: IntegrationConnectionCheck;
  trackContentUsage: Scalars['Boolean']['output'];
  translateText: TranslateTextResponse;
  unassignLearningCourse: AssignmentResult;
  unassignLearningPath: AssignmentResult;
  unenrollDevice: UnenrollDeviceResult;
  unlinkLicense: Scalars['String']['output'];
  /** Updates a single `Activity` using a unique key and a patch. */
  updateActivity?: Maybe<UpdateActivityPayload>;
  /** Updates a single `Activity` using its globally unique id and a patch. */
  updateActivityByNodeId?: Maybe<UpdateActivityPayload>;
  /** Updates a single `ActivityGoal` using a unique key and a patch. */
  updateActivityGoal?: Maybe<UpdateActivityGoalPayload>;
  /** Updates a single `ActivityGoal` using its globally unique id and a patch. */
  updateActivityGoalByNodeId?: Maybe<UpdateActivityGoalPayload>;
  /** Updates a single `ActivityGoal` using a unique key and a patch. */
  updateActivityGoalByUserIdAndKind?: Maybe<UpdateActivityGoalPayload>;
  /** Updates a single `ActivityParticipant` using a unique key and a patch. */
  updateActivityParticipant?: Maybe<UpdateActivityParticipantPayload>;
  /** Updates a single `ActivityParticipant` using a unique key and a patch. */
  updateActivityParticipantByActivitySessionIdAndSeniorId?: Maybe<UpdateActivityParticipantPayload>;
  /** Updates a single `ActivityParticipant` using its globally unique id and a patch. */
  updateActivityParticipantByNodeId?: Maybe<UpdateActivityParticipantPayload>;
  /** Updates a single `ActivitySession` using a unique key and a patch. */
  updateActivitySession?: Maybe<UpdateActivitySessionPayload>;
  /** Updates a single `ActivitySession` using its globally unique id and a patch. */
  updateActivitySessionByNodeId?: Maybe<UpdateActivitySessionPayload>;
  /** Updates a single `AppSetting` using a unique key and a patch. */
  updateAppSetting?: Maybe<UpdateAppSettingPayload>;
  /** Updates a single `AppSetting` using its globally unique id and a patch. */
  updateAppSettingByNodeId?: Maybe<UpdateAppSettingPayload>;
  /** Updates a single `AppSetting` using a unique key and a patch. */
  updateAppSettingByUserIdAndSettingType?: Maybe<UpdateAppSettingPayload>;
  /** Updates a single `Attachment` using a unique key and a patch. */
  updateAttachment?: Maybe<UpdateAttachmentPayload>;
  /** Updates a single `Attachment` using its globally unique id and a patch. */
  updateAttachmentByNodeId?: Maybe<UpdateAttachmentPayload>;
  /** Updates a single `CaregiverSenior` using a unique key and a patch. */
  updateCaregiverSenior?: Maybe<UpdateCaregiverSeniorPayload>;
  /** Updates a single `CaregiverSenior` using its globally unique id and a patch. */
  updateCaregiverSeniorByNodeId?: Maybe<UpdateCaregiverSeniorPayload>;
  /** Updates a single `CheckIn` using a unique key and a patch. */
  updateCheckIn?: Maybe<UpdateCheckInPayload>;
  /** Updates a single `CheckIn` using its globally unique id and a patch. */
  updateCheckInByNodeId?: Maybe<UpdateCheckInPayload>;
  /** Updates a single `CheckInMessage` using a unique key and a patch. */
  updateCheckInMessage?: Maybe<UpdateCheckInMessagePayload>;
  /** Updates a single `CheckInMessage` using its globally unique id and a patch. */
  updateCheckInMessageByNodeId?: Maybe<UpdateCheckInMessagePayload>;
  /** Updates a single `ContentActivity` using a unique key and a patch. */
  updateContentActivity?: Maybe<UpdateContentActivityPayload>;
  /** Updates a single `ContentActivity` using a unique key and a patch. */
  updateContentActivityByContentId?: Maybe<UpdateContentActivityPayload>;
  /** Updates a single `ContentActivity` using its globally unique id and a patch. */
  updateContentActivityByNodeId?: Maybe<UpdateContentActivityPayload>;
  /** Updates a single `ContentMetaTag` using a unique key and a patch. */
  updateContentMetaTag?: Maybe<UpdateContentMetaTagPayload>;
  /** Updates a single `ContentMetaTag` using a unique key and a patch. */
  updateContentMetaTagByContentIdAndMetaTagId?: Maybe<UpdateContentMetaTagPayload>;
  /** Updates a single `ContentMetaTag` using its globally unique id and a patch. */
  updateContentMetaTagByNodeId?: Maybe<UpdateContentMetaTagPayload>;
  /** Updates a single `CustomActivity` using a unique key and a patch. */
  updateCustomActivity?: Maybe<UpdateCustomActivityPayload>;
  /** Updates a single `CustomActivity` using a unique key and a patch. */
  updateCustomActivityByName?: Maybe<UpdateCustomActivityPayload>;
  /** Updates a single `CustomActivity` using its globally unique id and a patch. */
  updateCustomActivityByNodeId?: Maybe<UpdateCustomActivityPayload>;
  /** Updates a single `Device` using a unique key and a patch. */
  updateDevice?: Maybe<UpdateDevicePayload>;
  /** Updates a single `Device` using its globally unique id and a patch. */
  updateDeviceByNodeId?: Maybe<UpdateDevicePayload>;
  /** Updates a single `FamilyMemberSenior` using a unique key and a patch. */
  updateFamilyMemberSenior?: Maybe<UpdateFamilyMemberSeniorPayload>;
  /** Updates a single `FamilyMemberSenior` using its globally unique id and a patch. */
  updateFamilyMemberSeniorByNodeId?: Maybe<UpdateFamilyMemberSeniorPayload>;
  /** Updates a single `FeatureActivity` using a unique key and a patch. */
  updateFeatureActivity?: Maybe<UpdateFeatureActivityPayload>;
  /** Updates a single `FeatureActivity` using a unique key and a patch. */
  updateFeatureActivityByKind?: Maybe<UpdateFeatureActivityPayload>;
  /** Updates a single `FeatureActivity` using its globally unique id and a patch. */
  updateFeatureActivityByNodeId?: Maybe<UpdateFeatureActivityPayload>;
  updateGroup?: Maybe<UpdateGroupResponse>;
  /** Updates a single `HandshakeCode` using a unique key and a patch. */
  updateHandshakeCode?: Maybe<UpdateHandshakeCodePayload>;
  /** Updates a single `HandshakeCode` using a unique key and a patch. */
  updateHandshakeCodeByCode?: Maybe<UpdateHandshakeCodePayload>;
  /** Updates a single `HandshakeCode` using its globally unique id and a patch. */
  updateHandshakeCodeByNodeId?: Maybe<UpdateHandshakeCodePayload>;
  /** Updates a single `HandshakeCode` using a unique key and a patch. */
  updateHandshakeCodeByWorkgroupIdAndInitiatorId?: Maybe<UpdateHandshakeCodePayload>;
  updateImportedPractitionerStatus: PractitionerResponse;
  updateIntegrationExecution: IntegrationExecution;
  /** Updates a single `Location` using a unique key and a patch. */
  updateLocation?: Maybe<UpdateLocationPayload>;
  /** Updates a single `Location` using a unique key and a patch. */
  updateLocationByExternalId?: Maybe<UpdateLocationPayload>;
  /** Updates a single `Location` using its globally unique id and a patch. */
  updateLocationByNodeId?: Maybe<UpdateLocationPayload>;
  /**
   * Saves the account settings. Invalid input, or a changed clientId or
   * username without its secret, is refused with the error
   * dhl-settings-invalid: followed by the names of the invalid settings.
   * Needs dhl_integration.manage.
   */
  updateLogisticsDhlAccountSettings: LogisticsDhlAccountSettings;
  /**
   * Saves the shipping settings. Invalid input is refused with the error
   * dhl-settings-invalid: followed by the names of the invalid settings.
   * Needs logistics.manage.
   */
  updateLogisticsDhlShippingSettings: LogisticsDhlShippingSettings;
  updateMarketingDeliverySettings: MarketingDeliverySettings;
  /** Updates a single `Media` using a unique key and a patch. */
  updateMedia?: Maybe<UpdateMediaPayload>;
  /** Updates a single `MediaAlbum` using a unique key and a patch. */
  updateMediaAlbum?: Maybe<UpdateMediaAlbumPayload>;
  /** Updates a single `MediaAlbum` using its globally unique id and a patch. */
  updateMediaAlbumByNodeId?: Maybe<UpdateMediaAlbumPayload>;
  /** Updates a single `Media` using its globally unique id and a patch. */
  updateMediaByNodeId?: Maybe<UpdateMediaPayload>;
  /** Updates a single `MediaNote` using a unique key and a patch. */
  updateMediaNote?: Maybe<UpdateMediaNotePayload>;
  /** Updates a single `MediaNote` using its globally unique id and a patch. */
  updateMediaNoteByNodeId?: Maybe<UpdateMediaNotePayload>;
  /** Updates a single `MediaVoiceRecording` using a unique key and a patch. */
  updateMediaVoiceRecording?: Maybe<UpdateMediaVoiceRecordingPayload>;
  /** Updates a single `MediaVoiceRecording` using its globally unique id and a patch. */
  updateMediaVoiceRecordingByNodeId?: Maybe<UpdateMediaVoiceRecordingPayload>;
  /** Updates a single `Membership` using a unique key and a patch. */
  updateMembership?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `Membership` using its globally unique id and a patch. */
  updateMembershipByNodeId?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `Message` using a unique key and a patch. */
  updateMessage?: Maybe<UpdateMessagePayload>;
  /** Updates a single `Message` using its globally unique id and a patch. */
  updateMessageByNodeId?: Maybe<UpdateMessagePayload>;
  /** Updates a single `Note` using a unique key and a patch. */
  updateNote?: Maybe<UpdateNotePayload>;
  /** Updates a single `Note` using its globally unique id and a patch. */
  updateNoteByNodeId?: Maybe<UpdateNotePayload>;
  updatePatientGender: PatientResponse;
  /** Replaces the hotline's phone numbers and returns them as E.164, ordered. At most 20; a number with no country code that is not a German national number, or one given twice, is refused with placetel-hotline-numbers-invalid. */
  updatePlacetelHotlineNumbers: Array<Scalars['String']['output']>;
  updatePlacetelIntegration: PlacetelIntegration;
  /**
   * Replaces the hotline's opening hours. Send only the open days; a weekday
   * that is not listed is closed.
   */
  updatePlacetelOpeningHours: Array<PlacetelOpeningDay>;
  updatePractitionerContactDetails: PractitionerResponse;
  /** Updates a single `Procedure` using a unique key and a patch. */
  updateProcedure?: Maybe<UpdateProcedurePayload>;
  /** Updates a single `Procedure` using its globally unique id and a patch. */
  updateProcedureByNodeId?: Maybe<UpdateProcedurePayload>;
  /** Updates a single `Procedure` using a unique key and a patch. */
  updateProcedureBySourceSystemAndExternalIdAndOrganizationId?: Maybe<UpdateProcedurePayload>;
  /** Updates a single `ProcedureParticipant` using a unique key and a patch. */
  updateProcedureParticipant?: Maybe<UpdateProcedureParticipantPayload>;
  /** Updates a single `ProcedureParticipant` using its globally unique id and a patch. */
  updateProcedureParticipantByNodeId?: Maybe<UpdateProcedureParticipantPayload>;
  updateSalesforceIntegration: SalesforceIntegration;
  updateSeniorsInNote?: Maybe<Scalars['Boolean']['output']>;
  updateUser?: Maybe<UpdateUserResponse>;
  /** Updates a single `UserContentActivity` using a unique key and a patch. */
  updateUserContentActivity?: Maybe<UpdateUserContentActivityPayload>;
  /** Updates a single `UserContentActivity` using its globally unique id and a patch. */
  updateUserContentActivityByNodeId?: Maybe<UpdateUserContentActivityPayload>;
  updateUserEmailWithValidationCode: Scalars['Boolean']['output'];
  /** Updates a single `UserSetting` using a unique key and a patch. */
  updateUserSetting?: Maybe<UpdateUserSettingPayload>;
  /** Updates a single `UserSetting` using its globally unique id and a patch. */
  updateUserSettingByNodeId?: Maybe<UpdateUserSettingPayload>;
  /** Updates a single `Website` using a unique key and a patch. */
  updateWebsite?: Maybe<UpdateWebsitePayload>;
  /** Updates a single `Website` using its globally unique id and a patch. */
  updateWebsiteByNodeId?: Maybe<UpdateWebsitePayload>;
  /** Updates a single `Workgroup` using a unique key and a patch. */
  updateWorkgroup?: Maybe<UpdateWorkgroupPayload>;
  /** Updates a single `Workgroup` using its globally unique id and a patch. */
  updateWorkgroupByNodeId?: Maybe<UpdateWorkgroupPayload>;
  /** Updates a single `WorkgroupMembership` using a unique key and a patch. */
  updateWorkgroupMembership?: Maybe<UpdateWorkgroupMembershipPayload>;
  /** Updates a single `WorkgroupMembership` using its globally unique id and a patch. */
  updateWorkgroupMembershipByNodeId?: Maybe<UpdateWorkgroupMembershipPayload>;
  /** Creates or updates one resident's manual note for an Activity draft. */
  upsertActivityManualNote: UpsertActivityManualNotePayload;
  /** Creates or updates one resident's MD documentation for an Activity draft. */
  upsertActivityMdDocumentation: UpsertActivityMdDocumentationPayload;
  upsertLocation: LocationResponse;
  /**
   * Atomically upserts a note for a procedure.
   * If the procedure already has a note, updates its content and returns that note ID.
   * If not, creates a new note and links it to the procedure.
   */
  upsertNoteForProcedure?: Maybe<UpsertNoteForProcedurePayload>;
  /**
   * Atomically upserts a note for an activity session.
   * If session already has a note, updates its content and returns that note ID.
   * If session has no note, creates a new note and links it to the session.
   * This prevents race conditions between auto-documentation and manual note creation.
   */
  upsertNoteForSession?: Maybe<UpsertNoteForSessionPayload>;
  upsertPatient: PatientResponse;
  upsertPractitioner: PractitionerResponse;
  upsertProcedure: ProcedureResponse;
  userCanAccessCheckIn?: Maybe<UserCanAccessCheckInPayload>;
  versionToInteger?: Maybe<VersionToIntegerPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcceptInvitationOnBehalfArgs = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcceptInvitationToGroupArgs = {
  input: AcceptInvitationToGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationActivateEncryptionForSeniorArgs = {
  input: ActivateEncryptionForSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationActivateLicenseArgs = {
  input: ActivateLicenseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddActivityGoalsArgs = {
  input?: InputMaybe<ActivityGoalsInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddActivitySessionToNoteArgs = {
  input: AddActivitySessionToNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddContentActivitySessionArgs = {
  input?: InputMaybe<ContentActivitySessionInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddContentActivitySessionV2Args = {
  input?: InputMaybe<ContentActivitySessionInputV2>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddCustomActivitySessionArgs = {
  input?: InputMaybe<CustomActivitySessionInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddFeatureActivitySessionArgs = {
  input?: InputMaybe<FeatureActivitySessionInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddMediaToAlbumArgs = {
  input?: InputMaybe<AddMediaToAlbumInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddPlacetelCallNoteArgs = {
  input: PlacetelCallNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddSettingsArgs = {
  input?: InputMaybe<SettingsInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddStaffRoleArgs = {
  role: StaffRole;
  userId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddUserDeviceArgs = {
  input: AddUserDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssignLearningCourseArgs = {
  input: CourseAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssignLearningPathArgs = {
  input: PathAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBeginAdminMfaEnrollmentArgs = {
  currentPassword: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBeginCompanySignInArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBeginPlacetelPhoneSignInArgs = {
  redirectUri: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBelongsToSameWorkgroupArgs = {
  input: BelongsToSameWorkgroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelLogisticsShippingLabelArgs = {
  input: CancelLogisticsShippingLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelPlannedProcedureActivitiesArgs = {
  procedureId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelStaffInvitationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeAdminPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeDeviceArgs = {
  deviceId: Scalars['String']['input'];
  licenseId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckLastOtpArgs = {
  email: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckSalesforceConnectionArgs = {
  input: SalesforceConnectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckValidationCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  kind: ValidationCodeKind;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckValidationCodeForUserIdArgs = {
  code: Scalars['String']['input'];
  deviceToken: Scalars['String']['input'];
  kind: ValidationCodeKind;
  userId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteAdminMfaArgs = {
  input: CompleteAdminMfaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteCompanySignInArgs = {
  input: CompleteCompanySignInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteLearningLessonArgs = {
  input: CompleteLearningLessonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteOnboardingArgs = {
  input: CompleteOnboardingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompletePlacetelPhoneSignInArgs = {
  input: CompletePlacetelPhoneSignInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountBillingInvoiceDownloadArgs = {
  invoiceId: Scalars['String']['input'];
  salesforceId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateActivityArgs = {
  input: CreateActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateActivityGoalArgs = {
  input: CreateActivityGoalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateActivityParticipantArgs = {
  input: CreateActivityParticipantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateActivitySessionArgs = {
  input: CreateActivitySessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAndAddMediaToAlbumArgs = {
  input?: InputMaybe<CreateAndAddMediaToAlbumInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAppSettingArgs = {
  input: CreateAppSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAttachmentArgs = {
  input: CreateAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAvatarFromUrlArgs = {
  input: CreateAvatarFromUrlInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBillingInvoiceDownloadArgs = {
  invoiceId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCaregiverSeniorArgs = {
  input: CreateCaregiverSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChatWithBotArgs = {
  botName: Scalars['String']['input'];
  caregiverName?: InputMaybe<Scalars['String']['input']>;
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCheckInArgs = {
  input: CreateCheckInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCheckInMessageArgs = {
  input: CreateCheckInMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContentActivityArgs = {
  input: CreateContentActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContentMetaTagArgs = {
  input: CreateContentMetaTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomActivityArgs = {
  input: CreateCustomActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDeviceArgs = {
  input: CreateDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDeviceEnrollmentTokenArgs = {
  input: CreateDeviceEnrollmentTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFamilyMemberSeniorArgs = {
  input: CreateFamilyMemberSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeatureActivityArgs = {
  input: CreateFeatureActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeedbackArgs = {
  input: CreateFeedbackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateHandshakeCodeArgs = {
  input: CreateHandshakeCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateKorianUserArgs = {
  input: CreateKorianUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLicensingManagerFixtureArgs = {
  email: Scalars['String']['input'];
  managerName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLogisticsShippingLabelArgs = {
  input: CreateLogisticsShippingLabelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMediaArgs = {
  input: CreateMediaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMediaAlbumArgs = {
  input: CreateMediaAlbumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMediaAlbumsArgs = {
  input: CreateMediaAlbumsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMediaNoteArgs = {
  input: CreateMediaNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMediaVoiceRecordingArgs = {
  input: CreateMediaVoiceRecordingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMembershipArgs = {
  input: CreateMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMessageArgs = {
  input?: InputMaybe<CreateMessageInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrRetrievePrivateChatArgs = {
  input: CreateOrRetrievePrivateChatInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlannedProcedureActivitySessionArgs = {
  input: PlannedProcedureActivitySessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProcedureArgs = {
  input: CreateProcedureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProcedureParticipantArgs = {
  input: CreateProcedureParticipantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProgrammeProcedureArgs = {
  input: CreateProgrammeProcedureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSenderKeyArgs = {
  input: CreateSenderKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSeniorArgs = {
  input: CreateSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSeniorProfileArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSystemMessageArgs = {
  input: CreateSystemMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTestCustomerArgs = {
  contentGroup?: InputMaybe<Scalars['String']['input']>;
  contractStatus: ContractStatus;
  email: Scalars['String']['input'];
  flavour: Flavour;
  name: Scalars['String']['input'];
  swMode?: InputMaybe<SwMode>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTestLicensingCustomerArgs = {
  email: Scalars['String']['input'];
  managerName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserContentActivityArgs = {
  input: CreateUserContentActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserContentFavoriteArgs = {
  input?: InputMaybe<ContentFavorite>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserContentFavoriteV2Args = {
  input?: InputMaybe<ContentFavoriteV2>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserSettingArgs = {
  input: CreateUserSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserWithValidationCodeArgs = {
  caregiverInfo?: InputMaybe<CaregiverProfileDetail>;
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  flavour?: InputMaybe<Flavour>;
  kind: UserType;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  salutation?: InputMaybe<Salutation>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateValidationCodeArgs = {
  email: Scalars['String']['input'];
  kind: ValidationCodeKind;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWebsiteArgs = {
  input: CreateWebsiteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkgroupArgs = {
  input: CreateWorkgroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkgroupMembershipArgs = {
  input: CreateWorkgroupMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityArgs = {
  input: DeleteActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityByNodeIdArgs = {
  input: DeleteActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityGoalArgs = {
  input: DeleteActivityGoalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityGoalByNodeIdArgs = {
  input: DeleteActivityGoalByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityGoalByUserIdAndKindArgs = {
  input: DeleteActivityGoalByUserIdAndKindInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityManualNoteArgs = {
  input: DeleteActivityManualNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityMdDocumentationArgs = {
  input: DeleteActivityMdDocumentationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityParticipantArgs = {
  input: DeleteActivityParticipantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityParticipantByActivitySessionIdAndSeniorIdArgs = {
  input: DeleteActivityParticipantByActivitySessionIdAndSeniorIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivityParticipantByNodeIdArgs = {
  input: DeleteActivityParticipantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivitySessionArgs = {
  input: DeleteActivitySessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActivitySessionByNodeIdArgs = {
  input: DeleteActivitySessionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAlbumMediaArgs = {
  input: DeleteAlbumMediaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAlbumMediaByMediaIdAndAlbumIdArgs = {
  input: DeleteAlbumMediaByMediaIdAndAlbumIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAlbumMediaByNodeIdArgs = {
  input: DeleteAlbumMediaByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAppSettingArgs = {
  input: DeleteAppSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAppSettingByNodeIdArgs = {
  input: DeleteAppSettingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAppSettingByUserIdAndSettingTypeArgs = {
  input: DeleteAppSettingByUserIdAndSettingTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAttachmentByNodeIdArgs = {
  input: DeleteAttachmentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCaregiverSeniorArgs = {
  input: DeleteCaregiverSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCaregiverSeniorByNodeIdArgs = {
  input: DeleteCaregiverSeniorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCheckInMessageArgs = {
  input: DeleteCheckInMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCheckInMessageByNodeIdArgs = {
  input: DeleteCheckInMessageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContentActivityArgs = {
  input: DeleteContentActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContentActivityByContentIdArgs = {
  input: DeleteContentActivityByContentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContentActivityByNodeIdArgs = {
  input: DeleteContentActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContentMetaTagArgs = {
  input: DeleteContentMetaTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContentMetaTagByContentIdAndMetaTagIdArgs = {
  input: DeleteContentMetaTagByContentIdAndMetaTagIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContentMetaTagByNodeIdArgs = {
  input: DeleteContentMetaTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomActivityArgs = {
  input: DeleteCustomActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomActivityByNameArgs = {
  input: DeleteCustomActivityByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomActivityByNodeIdArgs = {
  input: DeleteCustomActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDeviceArgs = {
  input: DeleteDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDeviceByNodeIdArgs = {
  input: DeleteDeviceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFamilyMemberSeniorArgs = {
  input: DeleteFamilyMemberSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFamilyMemberSeniorByNodeIdArgs = {
  input: DeleteFamilyMemberSeniorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureActivityArgs = {
  input: DeleteFeatureActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureActivityByKindArgs = {
  input: DeleteFeatureActivityByKindInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureActivityByNodeIdArgs = {
  input: DeleteFeatureActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeedbackArgs = {
  input: DeleteFeedbackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeedbackByNodeIdArgs = {
  input: DeleteFeedbackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandshakeCodeArgs = {
  input: DeleteHandshakeCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandshakeCodeByCodeArgs = {
  input: DeleteHandshakeCodeByCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandshakeCodeByNodeIdArgs = {
  input: DeleteHandshakeCodeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandshakeCodeByWorkgroupIdAndInitiatorIdArgs = {
  input: DeleteHandshakeCodeByWorkgroupIdAndInitiatorIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvitationArgs = {
  input: DeleteInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvitationByNodeIdArgs = {
  input: DeleteInvitationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationArgs = {
  input: DeleteLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationByNodeIdArgs = {
  input: DeleteLocationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationBySourceSystemAndExternalIdAndTypeAndOrganizationIdArgs = {
  input: DeleteLocationBySourceSystemAndExternalIdAndTypeAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaArgs = {
  input: DeleteMediaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaAlbumArgs = {
  input: DeleteMediaAlbumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaByNodeIdArgs = {
  input: DeleteMediaByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaInAlbumsArgs = {
  input: DeleteMediaInAlbumsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaNoteArgs = {
  input: DeleteMediaNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaNoteByNodeIdArgs = {
  input: DeleteMediaNoteByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaVoiceRecordingArgs = {
  input: DeleteMediaVoiceRecordingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMediaVoiceRecordingByNodeIdArgs = {
  input: DeleteMediaVoiceRecordingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMessageArgs = {
  input: DeleteMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMessageByNodeIdArgs = {
  input: DeleteMessageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNoteByNodeIdArgs = {
  input: DeleteNoteByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProcedureArgs = {
  input: DeleteProcedureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProcedureByNodeIdArgs = {
  input: DeleteProcedureByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProcedureBySourceSystemAndExternalIdAndOrganizationIdArgs = {
  input: DeleteProcedureBySourceSystemAndExternalIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProcedureDocumentationNoteArgs = {
  input: DeleteProcedureDocumentationNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProcedureParticipantArgs = {
  input: DeleteProcedureParticipantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProcedureParticipantByNodeIdArgs = {
  input: DeleteProcedureParticipantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByNodeIdArgs = {
  input: DeleteUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserContentActivityArgs = {
  input: DeleteUserContentActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserContentActivityByNodeIdArgs = {
  input: DeleteUserContentActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserContentFavoriteArgs = {
  input: DeleteUserContentFavoriteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserContentFavoriteByNodeIdArgs = {
  input: DeleteUserContentFavoriteByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserContentFavoriteByUserIdAndContentIdArgs = {
  input: DeleteUserContentFavoriteByUserIdAndContentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserSettingArgs = {
  input: DeleteUserSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserSettingByNodeIdArgs = {
  input: DeleteUserSettingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWebsiteArgs = {
  input: DeleteWebsiteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWebsiteByNodeIdArgs = {
  input: DeleteWebsiteByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkgroupArgs = {
  input: DeleteWorkgroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkgroupByNodeIdArgs = {
  input: DeleteWorkgroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkgroupMembershipArgs = {
  input: DeleteWorkgroupMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkgroupMembershipByNodeIdArgs = {
  input: DeleteWorkgroupMembershipByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeregisterPushNotificationDeviceArgs = {
  input: DeregisterPushNotificationDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDisableAdminMfaArgs = {
  input: DisableAdminMfaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDismissFinanceNotificationArgs = {
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEndProcedureExecutionArgs = {
  input: EndProcedureExecutionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEnrollDeviceAsManagerArgs = {
  input: EnrollDeviceAsManagerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFinishActivitySessionArgs = {
  input?: InputMaybe<FinishActivitySessionInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateTestLicenseArgs = {
  licenseType: TestLicenseType;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateToyDatasetArgs = {
  email: Scalars['String']['input'];
  numberOfImages?: InputMaybe<Scalars['Int']['input']>;
  numberOfMessages?: InputMaybe<Scalars['Int']['input']>;
  numberOfUnread?: InputMaybe<Scalars['Int']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateToyDatasetFromFamilyArgs = {
  email: Scalars['String']['input'];
  numberOfImages?: InputMaybe<Scalars['Int']['input']>;
  numberOfMessages?: InputMaybe<Scalars['Int']['input']>;
  numberOfRelatives?: InputMaybe<Scalars['Int']['input']>;
  numberOfUnread?: InputMaybe<Scalars['Int']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetInvitationOtpArgs = {
  email: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGrantLearningCourseArgs = {
  input: OrganizationCourseGrantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGrantLearningPathArgs = {
  input: OrganizationPathGrantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIncludeProcedureManualNoteArgs = {
  input: IncludeProcedureManualNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInvalidateContentUrlsCacheArgs = {
  input: InvalidateContentUrlsCacheInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInviteArgs = {
  input: InviteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInviteManagerArgs = {
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  salesforceAccountId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInviteStaffArgs = {
  email: Scalars['String']['input'];
  roles: Array<StaffRole>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIsAndroidDeviceSupportedArgs = {
  input: IsAndroidDeviceSupportedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIsTabletUpdatableArgs = {
  input: IsTabletUpdatableInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIsUserInWorkgroupArgs = {
  input: IsUserInWorkgroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIsmanagerofcaregiverArgs = {
  input: IsmanagerofcaregiverInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIssueCaregiverDeviceTokenArgs = {
  deviceId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIssuePlacetelPhoneAccessTokenArgs = {
  renew?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationJoinWorkgroupArgs = {
  input: JoinWorkGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLearningChangePasswordArgs = {
  input: LearningChangePasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLearningLoginArgs = {
  input: LearningLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLearningRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLearningResetPasswordArgs = {
  input: LearningResetPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLogAssistantInteractionArgs = {
  input: LogAssistantInteractionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginArgs = {
  input: LoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginCaregiverWithPinArgs = {
  input: LoginPractitionerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginOrCreateSeniorArgs = {
  input: LoginOrCreateSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginPractitionerArgs = {
  input: LoginPractitionerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginSeniorArgs = {
  input: LoginSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginUserArgs = {
  input: LoginUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMarkAsReadArgs = {
  input: MarkAsReadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMarkAsReceivedArgs = {
  input: MarkAsReceivedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMoveMediaToAlbumArgs = {
  input: MoveMediaToAlbumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMoveMediaToTrashArgs = {
  input?: InputMaybe<MoveMediaToTrashInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPlanRecommendedActivityArgs = {
  input: PlanRecommendedActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPreviewIntegrationImportArgs = {
  organizationId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPublishActivityDocumentationArgs = {
  input: PublishActivityDocumentationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPublishProcedureDocumentationArgs = {
  input: PublishProcedureDocumentationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRecordIntegrationImportPreviewArgs = {
  input: RecordIntegrationImportPreviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRecordPlacetelCallEventArgs = {
  input: PlacetelCallEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRedeemDeviceEnrollmentTokenArgs = {
  input: RedeemDeviceEnrollmentTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterPushNotificationDeviceArgs = {
  input: RegisterPushNotificationDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRejectInvitationToGroupArgs = {
  input: RejectInvitationToGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveActivitySessionFromNoteArgs = {
  input: AddActivitySessionToNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveMediaFromAlbumArgs = {
  input: RemoveMediaFromAlbumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemovePlannedProcedureActivitySessionArgs = {
  input: RemovePlannedProcedureActivitySessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveStaffRoleArgs = {
  role: StaffRole;
  userId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationReportDocumentationSyncArgs = {
  input: ReportDocumentationSyncInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRequestPasswordResetOtpArgs = {
  input: RequestPasswordResetOtpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRequestPractitionerPasswordResetOtpArgs = {
  input: RequestPractitionerPasswordResetOtpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResendInvitationArgs = {
  input: ResendInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetPasswordWithValidationCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetPasswordWithValidationCodeForUserIdArgs = {
  code: Scalars['String']['input'];
  deviceToken: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetPractitionerPasswordOtpArgs = {
  input: ResetPractitionerPasswordOtpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResolveDeviceEnrollmentTokenArgs = {
  code: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevealPractitionerPasswordOtpArgs = {
  input: RevealPractitionerPasswordOtpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationReviewCustomerServiceCrmDuplicateArgs = {
  input: CrmDuplicateReviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeDeviceEnrollmentTokenArgs = {
  id: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeLearningCourseArgs = {
  input: OrganizationCourseGrantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeLearningPathArgs = {
  input: OrganizationPathGrantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSaveFormResponseArgs = {
  input: SaveFormResponseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSaveIntegrationSettingsArgs = {
  credentials: IntegrationCredentialsInput;
  organizationId: Scalars['UUID']['input'];
  provider: IntegrationProvider;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSaveMdappBackupArgs = {
  input: SaveMdappBackupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSaveProcedureDocumentationNoteArgs = {
  input: SaveProcedureDocumentationNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSelfEnrollLearningCourseArgs = {
  courseId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSelfEnrollLearningPathArgs = {
  learningPathId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendDeviceEnrollmentTokenEmailArgs = {
  input: SendDeviceEnrollmentTokenEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendInstallationInstructionsArgs = {
  input: SendInstructionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendInstructionsArgs = {
  input: SendInstructionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendLicensingPortalInvitationArgs = {
  input: SendLicensingPortalInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendMarketingTestEmailArgs = {
  input: MarketingTestEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendQrCodeSalesforceArgs = {
  input: SendQrCodeSalesforceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendQrcodeArgs = {
  input: SendQrcodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendVideocallEventArgs = {
  input: SendVideocallEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetAccountAmbulantArgs = {
  ambulant: Scalars['Boolean']['input'];
  salesforceAccountId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetActivityDocumentationManualNoteIncludedArgs = {
  input: SetActivityDocumentationManualNoteIncludedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetOrganizationBillingAccessArgs = {
  accessEnabled: Scalars['Boolean']['input'];
  expectedMappingVersion: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetOrganizationBillingAccountArgs = {
  confirmed: Scalars['Boolean']['input'];
  expectedMappingVersion?: InputMaybe<Scalars['UUID']['input']>;
  frisbiiCustomerId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['UUID']['input'];
  salesforceAccountId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetOrganizationSalesforceAccountArgs = {
  organizationId: Scalars['UUID']['input'];
  salesforceAccountId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetupAccountPortalAccessArgs = {
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceAccountId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartLearningCourseArgs = {
  input: StartLearningCourseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartPlannedActivitySessionArgs = {
  input: StartPlannedActivitySessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStopProcedureArgs = {
  procedureId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSubmitAdminPortalFeedbackArgs = {
  input: SubmitAdminPortalFeedbackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSubmitLearningQuizAttemptArgs = {
  input: SubmitLearningQuizAttemptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSyncContractItemSalesforceArgs = {
  accountId: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contractEndDate: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  contractName: Scalars['String']['input'];
  contractProductFamily: Scalars['String']['input'];
  contractProductFlavour: Scalars['String']['input'];
  contractProductName: Scalars['String']['input'];
  contractProductPlan: Scalars['String']['input'];
  contractSponsoringKrankenkasse: Scalars['String']['input'];
  contractStartDate: Scalars['String']['input'];
  contractStatus: Scalars['String']['input'];
  latestContractId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSyncIntegrationDataArgs = {
  organizationId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSyncPublishedContentListArgs = {
  contentRelease: ContentRelease;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTestEnvUpdateLastReadArgs = {
  input: TestEnvUpdateLastReadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTestEnvUpdateMessageCreatedAtArgs = {
  input: TestEnvUpdateMessageCreatedAtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTestIntegrationConnectionArgs = {
  organizationId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTrackContentUsageArgs = {
  info?: InputMaybe<ContentInfo>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTranslateTextArgs = {
  input: TranslateTextInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnassignLearningCourseArgs = {
  input: CourseAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnassignLearningPathArgs = {
  input: PathAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnenrollDeviceArgs = {
  id: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnlinkLicenseArgs = {
  id: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivityArgs = {
  input: UpdateActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivityByNodeIdArgs = {
  input: UpdateActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivityGoalArgs = {
  input: UpdateActivityGoalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivityGoalByNodeIdArgs = {
  input: UpdateActivityGoalByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivityGoalByUserIdAndKindArgs = {
  input: UpdateActivityGoalByUserIdAndKindInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivityParticipantArgs = {
  input: UpdateActivityParticipantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivityParticipantByActivitySessionIdAndSeniorIdArgs = {
  input: UpdateActivityParticipantByActivitySessionIdAndSeniorIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivityParticipantByNodeIdArgs = {
  input: UpdateActivityParticipantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivitySessionArgs = {
  input: UpdateActivitySessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActivitySessionByNodeIdArgs = {
  input: UpdateActivitySessionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppSettingArgs = {
  input: UpdateAppSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppSettingByNodeIdArgs = {
  input: UpdateAppSettingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppSettingByUserIdAndSettingTypeArgs = {
  input: UpdateAppSettingByUserIdAndSettingTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAttachmentArgs = {
  input: UpdateAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAttachmentByNodeIdArgs = {
  input: UpdateAttachmentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaregiverSeniorArgs = {
  input: UpdateCaregiverSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCaregiverSeniorByNodeIdArgs = {
  input: UpdateCaregiverSeniorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCheckInArgs = {
  input: UpdateCheckInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCheckInByNodeIdArgs = {
  input: UpdateCheckInByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCheckInMessageArgs = {
  input: UpdateCheckInMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCheckInMessageByNodeIdArgs = {
  input: UpdateCheckInMessageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContentActivityArgs = {
  input: UpdateContentActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContentActivityByContentIdArgs = {
  input: UpdateContentActivityByContentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContentActivityByNodeIdArgs = {
  input: UpdateContentActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContentMetaTagArgs = {
  input: UpdateContentMetaTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContentMetaTagByContentIdAndMetaTagIdArgs = {
  input: UpdateContentMetaTagByContentIdAndMetaTagIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContentMetaTagByNodeIdArgs = {
  input: UpdateContentMetaTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomActivityArgs = {
  input: UpdateCustomActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomActivityByNameArgs = {
  input: UpdateCustomActivityByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomActivityByNodeIdArgs = {
  input: UpdateCustomActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDeviceArgs = {
  input: UpdateDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDeviceByNodeIdArgs = {
  input: UpdateDeviceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFamilyMemberSeniorArgs = {
  input: UpdateFamilyMemberSeniorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFamilyMemberSeniorByNodeIdArgs = {
  input: UpdateFamilyMemberSeniorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureActivityArgs = {
  input: UpdateFeatureActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureActivityByKindArgs = {
  input: UpdateFeatureActivityByKindInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureActivityByNodeIdArgs = {
  input: UpdateFeatureActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandshakeCodeArgs = {
  input: UpdateHandshakeCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandshakeCodeByCodeArgs = {
  input: UpdateHandshakeCodeByCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandshakeCodeByNodeIdArgs = {
  input: UpdateHandshakeCodeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandshakeCodeByWorkgroupIdAndInitiatorIdArgs = {
  input: UpdateHandshakeCodeByWorkgroupIdAndInitiatorIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateImportedPractitionerStatusArgs = {
  input: UpdateImportedPractitionerStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrationExecutionArgs = {
  input: UpdateIntegrationExecutionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationByExternalIdArgs = {
  input: UpdateLocationByExternalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationByNodeIdArgs = {
  input: UpdateLocationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLogisticsDhlAccountSettingsArgs = {
  input: UpdateLogisticsDhlAccountSettingsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLogisticsDhlShippingSettingsArgs = {
  input: UpdateLogisticsDhlShippingSettingsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMarketingDeliverySettingsArgs = {
  input: MarketingDeliverySettingsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaArgs = {
  input: UpdateMediaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaAlbumArgs = {
  input: UpdateMediaAlbumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaAlbumByNodeIdArgs = {
  input: UpdateMediaAlbumByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaByNodeIdArgs = {
  input: UpdateMediaByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaNoteArgs = {
  input: UpdateMediaNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaNoteByNodeIdArgs = {
  input: UpdateMediaNoteByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaVoiceRecordingArgs = {
  input: UpdateMediaVoiceRecordingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMediaVoiceRecordingByNodeIdArgs = {
  input: UpdateMediaVoiceRecordingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipArgs = {
  input: UpdateMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipByNodeIdArgs = {
  input: UpdateMembershipByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMessageArgs = {
  input: UpdateMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMessageByNodeIdArgs = {
  input: UpdateMessageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNoteByNodeIdArgs = {
  input: UpdateNoteByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientGenderArgs = {
  input: UpdatePatientGenderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlacetelHotlineNumbersArgs = {
  numbers: Array<Scalars['String']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlacetelIntegrationArgs = {
  input: PlacetelIntegrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlacetelOpeningHoursArgs = {
  input: Array<PlacetelOpeningDayInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePractitionerContactDetailsArgs = {
  input: UpdatePractitionerContactDetailsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcedureArgs = {
  input: UpdateProcedureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcedureByNodeIdArgs = {
  input: UpdateProcedureByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcedureBySourceSystemAndExternalIdAndOrganizationIdArgs = {
  input: UpdateProcedureBySourceSystemAndExternalIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcedureParticipantArgs = {
  input: UpdateProcedureParticipantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcedureParticipantByNodeIdArgs = {
  input: UpdateProcedureParticipantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSalesforceIntegrationArgs = {
  input: SalesforceIntegrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSeniorsInNoteArgs = {
  input: UpdateSeniorsInNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserContentActivityArgs = {
  input: UpdateUserContentActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserContentActivityByNodeIdArgs = {
  input: UpdateUserContentActivityByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserEmailWithValidationCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserSettingArgs = {
  input: UpdateUserSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserSettingByNodeIdArgs = {
  input: UpdateUserSettingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWebsiteArgs = {
  input: UpdateWebsiteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWebsiteByNodeIdArgs = {
  input: UpdateWebsiteByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkgroupArgs = {
  input: UpdateWorkgroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkgroupByNodeIdArgs = {
  input: UpdateWorkgroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkgroupMembershipArgs = {
  input: UpdateWorkgroupMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkgroupMembershipByNodeIdArgs = {
  input: UpdateWorkgroupMembershipByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertActivityManualNoteArgs = {
  input: UpsertActivityManualNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertActivityMdDocumentationArgs = {
  input: UpsertActivityMdDocumentationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertLocationArgs = {
  input: UpsertLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertNoteForProcedureArgs = {
  input: UpsertNoteForProcedureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertNoteForSessionArgs = {
  input: UpsertNoteForSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPatientArgs = {
  input: UpsertPatientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPractitionerArgs = {
  input: UpsertPractitionerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertProcedureArgs = {
  input: UpsertProcedureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUserCanAccessCheckInArgs = {
  input: UserCanAccessCheckInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVersionToIntegerArgs = {
  input: VersionToIntegerInput;
};

export type MyLearning = {
  __typename?: 'MyLearning';
  courses: Array<MyLearningCourseState>;
  pathSources: Array<MyLearningPathSource>;
};

export type MyLearningCourseState = {
  __typename?: 'MyLearningCourseState';
  activeCourseVersion?: Maybe<Scalars['String']['output']>;
  bestScorePercent?: Maybe<Scalars['Float']['output']>;
  completedLessonIds: Array<Scalars['UUID']['output']>;
  courseId: Scalars['UUID']['output'];
  currentVersion: Scalars['String']['output'];
  directAccess: Scalars['Boolean']['output'];
  startedVersions: Array<Scalars['String']['output']>;
  status: LearningEnrollmentStatus;
};

export type MyLearningPathCourse = {
  __typename?: 'MyLearningPathCourse';
  available: Scalars['Boolean']['output'];
  courseId: Scalars['UUID']['output'];
  locked: Scalars['Boolean']['output'];
};

export type MyLearningPathSource = {
  __typename?: 'MyLearningPathSource';
  assignmentId: Scalars['UUID']['output'];
  orderedCourses: Array<MyLearningPathCourse>;
  pathId: Scalars['UUID']['output'];
  pathVersion: Scalars['String']['output'];
};

export type NewAlbumForUserPayload = {
  __typename?: 'NewAlbumForUserPayload';
  album: MediaAlbum;
};

export type NewProfile = {
  __typename?: 'NewProfile';
  createdAt: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type Note = Node & {
  __typename?: 'Note';
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionList: Array<ActivitySession>;
  /** Reads a single `User` that is related to this `Note`. */
  author?: Maybe<User>;
  authorId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `DocumentationSync`. */
  documentationSyncs: DocumentationSyncsConnection;
  /** Reads and enables pagination through a set of `DocumentationSync`. */
  documentationSyncsList: Array<DocumentationSync>;
  /** Generation lifecycle for internally generated summaries. */
  generationStatus?: Maybe<NoteGenerationStatus>;
  id: Scalars['UUID']['output'];
  /** The semantic note type is assigned only by the server. */
  kind: NoteKind;
  /** DEPRECATED */
  mdDocumentation?: Maybe<Scalars['String']['output']>;
  /** Versioned semantic answers used to reopen resident MD documentation in the wizard. */
  mdWizardAnswers?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByNoteProcedureNoteIdAndProcedureId: NoteProceduresByNoteProcedureNoteIdAndProcedureIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByNoteProcedureNoteIdAndProcedureIdList: Array<Procedure>;
  /** When the caregiver confirmed the documentation. NULL = unpublished draft. Set only by publishActivityDocumentation. */
  publishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `User`. */
  seniorList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  seniors: NoteSeniorsManyToManyConnection;
  updatedAt: Scalars['Datetime']['output'];
};


export type NoteActivitySessionListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type NoteDocumentationSyncsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentationSyncCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentationSyncsOrderBy>>;
};


export type NoteDocumentationSyncsListArgs = {
  condition?: InputMaybe<DocumentationSyncCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentationSyncsOrderBy>>;
};


export type NoteProceduresByNoteProcedureNoteIdAndProcedureIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


export type NoteProceduresByNoteProcedureNoteIdAndProcedureIdListArgs = {
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


export type NoteSeniorListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type NoteSeniorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** Input for the nested mutation of `activityParticipant` in the `NoteInput` mutation. */
export type NoteActivityDocumentationParticipantFkeyInput = {
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  connectByActivitySessionIdAndSeniorId?: InputMaybe<ActivityParticipantActivityParticipantSessionSeniorUniqueConnect>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  connectById?: InputMaybe<ActivityParticipantActivityParticipantPkeyConnect>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ActivityParticipantNodeIdConnect>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  deleteByActivitySessionIdAndSeniorId?: InputMaybe<ActivityParticipantActivityParticipantSessionSeniorUniqueDelete>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  deleteById?: InputMaybe<ActivityParticipantActivityParticipantPkeyDelete>;
  /** The primary key(s) for `activityParticipant` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ActivityParticipantNodeIdDelete>;
};

/** Input for the nested mutation of `note` in the `ActivityParticipantInput` mutation. */
export type NoteActivityDocumentationParticipantFkeyInverseInput = {
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectById?: InputMaybe<NoteNotePkeyConnect>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<NoteNodeIdConnect>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteById?: InputMaybe<NoteNotePkeyDelete>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<NoteNodeIdDelete>;
  /** Flag indicating whether all other `note` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NoteActivitySession = Node & {
  __typename?: 'NoteActivitySession';
  activitySessionId: Scalars['UUID']['output'];
  /** Reads a single `ActivitySession` that is related to this `NoteActivitySession`. */
  activitySessions?: Maybe<ActivitySession>;
  /** Whether this linked manual note is included when the Activity documentation is finalized. */
  includeInDocumentation: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  noteId: Scalars['UUID']['output'];
  /** Reads a single `Note` that is related to this `NoteActivitySession`. */
  notes?: Maybe<Note>;
};

/** The `activitySession` to be created by this mutation. */
export type NoteActivitySessionActivitySessionIdFkeyActivitySessionCreateInput = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind: SessionKind;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** Input for the nested mutation of `activitySession` in the `NoteActivitySessionInput` mutation. */
export type NoteActivitySessionActivitySessionIdFkeyInput = {
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectById?: InputMaybe<ActivitySessionActivitySessionPkeyConnect>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ActivitySessionNodeIdConnect>;
  /** A `ActivitySessionInput` object that will be created and connected to this object. */
  create?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyActivitySessionCreateInput>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteById?: InputMaybe<ActivitySessionActivitySessionPkeyDelete>;
  /** The primary key(s) for `activitySession` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ActivitySessionNodeIdDelete>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateById?: InputMaybe<ActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyUsingActivitySessionPkeyUpdate>;
  /** The primary key(s) and patch data for `activitySession` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<NoteActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `noteActivitySession` in the `ActivitySessionInput` mutation. */
export type NoteActivitySessionActivitySessionIdFkeyInverseInput = {
  /** The primary key(s) for `noteActivitySession` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<NoteActivitySessionNodeIdConnect>>;
  /** The primary key(s) for `noteActivitySession` for the far side of the relationship. */
  connectByNoteIdAndActivitySessionId?: InputMaybe<Array<NoteActivitySessionNoteActivitySessionPkeyConnect>>;
  /** The primary key(s) and patch data for `noteActivitySession` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `noteActivitySession` for the far side of the relationship. */
  updateByNoteIdAndActivitySessionId?: InputMaybe<Array<NoteActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyUsingNoteActivitySessionPkeyUpdate>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type NoteActivitySessionNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `noteActivitySession` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The fields on `noteActivitySession` to look up the row to connect. */
export type NoteActivitySessionNoteActivitySessionPkeyConnect = {
  activitySessionId: Scalars['UUID']['input'];
  noteId: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `note` in the `NoteActivitySessionInput` mutation. */
export type NoteActivitySessionNoteIdFkeyInput = {
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectById?: InputMaybe<NoteNotePkeyConnect>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<NoteNodeIdConnect>;
  /** A `NoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<NoteActivitySessionNoteIdFkeyNoteCreateInput>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteById?: InputMaybe<NoteNotePkeyDelete>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<NoteNodeIdDelete>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateById?: InputMaybe<NoteOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyUsingNotePkeyUpdate>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<NoteActivitySessionOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `noteActivitySession` in the `NoteInput` mutation. */
export type NoteActivitySessionNoteIdFkeyInverseInput = {
  /** The primary key(s) for `noteActivitySession` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<NoteActivitySessionNodeIdConnect>>;
  /** The primary key(s) for `noteActivitySession` for the far side of the relationship. */
  connectByNoteIdAndActivitySessionId?: InputMaybe<Array<NoteActivitySessionNoteActivitySessionPkeyConnect>>;
  /** The primary key(s) and patch data for `noteActivitySession` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<NoteOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `noteActivitySession` for the far side of the relationship. */
  updateByNoteIdAndActivitySessionId?: InputMaybe<Array<NoteActivitySessionOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyUsingNoteActivitySessionPkeyUpdate>>;
};

/** The `note` to be created by this mutation. */
export type NoteActivitySessionNoteIdFkeyNoteCreateInput = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to update. */
export type NoteActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activitySession` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: ActivitySessionPatch;
};

/** The fields on `noteActivitySession` to look up the row to update. */
export type NoteActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyUsingNoteActivitySessionPkeyUpdate = {
  activitySessionId: Scalars['UUID']['input'];
  noteId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `noteActivitySession` being updated. */
  patch: UpdateNoteActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type NoteActivitySessionOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `note` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: NotePatch;
};

/** The fields on `noteActivitySession` to look up the row to update. */
export type NoteActivitySessionOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyUsingNoteActivitySessionPkeyUpdate = {
  activitySessionId: Scalars['UUID']['input'];
  noteId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `noteActivitySession` being updated. */
  patch: UpdateNoteActivitySessionOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyPatch;
};

/** Represents an update to a `NoteActivitySession`. Fields that are set will be updated. */
export type NoteActivitySessionPatch = {
  activitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  activitySessions?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInput>;
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<NoteActivitySessionNoteIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `NoteInput` mutation. */
export type NoteAuthorIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<NoteAuthorIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnNoteForNoteAuthorIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<NoteOnNoteForNoteAuthorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `note` in the `UserInput` mutation. */
export type NoteAuthorIdFkeyInverseInput = {
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NoteNotePkeyConnect>>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<NoteNodeIdConnect>>;
  /** A `NoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NoteAuthorIdFkeyNoteCreateInput>>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NoteNotePkeyDelete>>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<NoteNodeIdDelete>>;
  /** Flag indicating whether all other `note` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NoteOnNoteForNoteAuthorIdFkeyUsingNotePkeyUpdate>>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnNoteForNoteAuthorIdFkeyNodeIdUpdate>>;
};

/** The `note` to be created by this mutation. */
export type NoteAuthorIdFkeyNoteCreateInput = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** The `user` to be created by this mutation. */
export type NoteAuthorIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A condition to be used against `Note` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type NoteCondition = {
  /** Checks for equality with the object’s `authorId` field. */
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  /** Excludes notes where the note field is null or empty */
  excludeEmptyNote?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Only notes linked to at least one of the selected seniors */
  seniorIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum NoteGenerationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** An input for mutations affecting `Note` */
export type NoteInput = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

export enum NoteKind {
  ActivityDocumentation = 'ACTIVITY_DOCUMENTATION',
  AiNote = 'AI_NOTE',
  AiSummary = 'AI_SUMMARY',
  Note = 'NOTE'
}

/** The globally unique `ID` look up for the row to connect. */
export type NoteNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `note` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type NoteNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `note` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The fields on `note` to look up the row to connect. */
export type NoteNotePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `note` to look up the row to delete. */
export type NoteNotePkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type NoteOnDocumentationSyncForDocumentationSyncNoteIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `documentationSync` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `documentationSync` being updated. */
  patch: DocumentationSyncPatch;
};

/** The fields on `note` to look up the row to update. */
export type NoteOnDocumentationSyncForDocumentationSyncNoteIdFkeyUsingNotePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: UpdateNoteOnDocumentationSyncForDocumentationSyncNoteIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type NoteOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `noteActivitySession` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `noteActivitySession` being updated. */
  patch: NoteActivitySessionPatch;
};

/** The fields on `note` to look up the row to update. */
export type NoteOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyUsingNotePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: UpdateNoteOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type NoteOnNoteForNoteAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `note` to look up the row to update. */
export type NoteOnNoteForNoteAuthorIdFkeyUsingNotePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: UpdateNoteOnNoteForNoteAuthorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type NoteOnNoteProcedureForNoteProcedureNoteIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `noteProcedure` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `noteProcedure` being updated. */
  patch: NoteProcedurePatch;
};

/** The fields on `note` to look up the row to update. */
export type NoteOnNoteProcedureForNoteProcedureNoteIdFkeyUsingNotePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: UpdateNoteOnNoteProcedureForNoteProcedureNoteIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type NoteOnNoteSeniorForNoteSeniorNoteIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `noteSenior` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `noteSenior` being updated. */
  patch: NoteSeniorPatch;
};

/** The fields on `note` to look up the row to update. */
export type NoteOnNoteSeniorForNoteSeniorNoteIdFkeyUsingNotePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: UpdateNoteOnNoteSeniorForNoteSeniorNoteIdFkeyPatch;
};

/** Represents an update to a `Note`. Fields that are set will be updated. */
export type NotePatch = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

export type NoteProcedure = Node & {
  __typename?: 'NoteProcedure';
  /** Explicit inclusion of this senior's manual note in procedure documentation. */
  includeInDocumentation: Scalars['Boolean']['output'];
  /** Marks the single procedure-level manual documentation note. */
  isDocumentationManualNote: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  noteId: Scalars['UUID']['output'];
  /** Reads a single `Procedure` that is related to this `NoteProcedure`. */
  procedure?: Maybe<Procedure>;
  procedureId: Scalars['UUID']['output'];
  /** Reads a single `Note` that is related to this `NoteProcedure`. */
  procedureNotes?: Maybe<Note>;
};

/**
 * A condition to be used against `NoteProcedure` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NoteProcedureCondition = {
  /** Checks for equality with the object’s `noteId` field. */
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `procedureId` field. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type NoteProcedureNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `noteProcedure` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** Input for the nested mutation of `note` in the `NoteProcedureInput` mutation. */
export type NoteProcedureNoteIdFkeyInput = {
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectById?: InputMaybe<NoteNotePkeyConnect>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<NoteNodeIdConnect>;
  /** A `NoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<NoteProcedureNoteIdFkeyNoteCreateInput>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteById?: InputMaybe<NoteNotePkeyDelete>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<NoteNodeIdDelete>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateById?: InputMaybe<NoteOnNoteProcedureForNoteProcedureNoteIdFkeyUsingNotePkeyUpdate>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<NoteProcedureOnNoteProcedureForNoteProcedureNoteIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `noteProcedure` in the `NoteInput` mutation. */
export type NoteProcedureNoteIdFkeyInverseInput = {
  /** The primary key(s) for `noteProcedure` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<NoteProcedureNodeIdConnect>>;
  /** The primary key(s) for `noteProcedure` for the far side of the relationship. */
  connectByNoteIdAndProcedureId?: InputMaybe<Array<NoteProcedureNoteProcedurePkeyConnect>>;
  /** The primary key(s) and patch data for `noteProcedure` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<NoteOnNoteProcedureForNoteProcedureNoteIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `noteProcedure` for the far side of the relationship. */
  updateByNoteIdAndProcedureId?: InputMaybe<Array<NoteProcedureOnNoteProcedureForNoteProcedureNoteIdFkeyUsingNoteProcedurePkeyUpdate>>;
};

/** The `note` to be created by this mutation. */
export type NoteProcedureNoteIdFkeyNoteCreateInput = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** The fields on `noteProcedure` to look up the row to connect. */
export type NoteProcedureNoteProcedurePkeyConnect = {
  noteId: Scalars['UUID']['input'];
  procedureId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type NoteProcedureOnNoteProcedureForNoteProcedureNoteIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `note` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: NotePatch;
};

/** The fields on `noteProcedure` to look up the row to update. */
export type NoteProcedureOnNoteProcedureForNoteProcedureNoteIdFkeyUsingNoteProcedurePkeyUpdate = {
  noteId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `noteProcedure` being updated. */
  patch: UpdateNoteProcedureOnNoteProcedureForNoteProcedureNoteIdFkeyPatch;
  procedureId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type NoteProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `procedure` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: ProcedurePatch;
};

/** The fields on `noteProcedure` to look up the row to update. */
export type NoteProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyUsingNoteProcedurePkeyUpdate = {
  noteId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `noteProcedure` being updated. */
  patch: UpdateNoteProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyPatch;
  procedureId: Scalars['UUID']['input'];
};

/** Represents an update to a `NoteProcedure`. Fields that are set will be updated. */
export type NoteProcedurePatch = {
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureNotes?: InputMaybe<NoteProcedureNoteIdFkeyInput>;
  procedureToProcedureId?: InputMaybe<NoteProcedureProcedureIdFkeyInput>;
};

/** Input for the nested mutation of `procedure` in the `NoteProcedureInput` mutation. */
export type NoteProcedureProcedureIdFkeyInput = {
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectById?: InputMaybe<ProcedureProcedurePkeyConnect>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProcedureNodeIdConnect>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureChkProcedureExternalIdSourceConnect>;
  /** A `ProcedureInput` object that will be created and connected to this object. */
  create?: InputMaybe<NoteProcedureProcedureIdFkeyProcedureCreateInput>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteById?: InputMaybe<ProcedureProcedurePkeyDelete>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProcedureNodeIdDelete>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureChkProcedureExternalIdSourceDelete>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateById?: InputMaybe<ProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyUsingProcedurePkeyUpdate>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<NoteProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyUsingChkProcedureExternalIdSourceUpdate>;
};

/** Input for the nested mutation of `noteProcedure` in the `ProcedureInput` mutation. */
export type NoteProcedureProcedureIdFkeyInverseInput = {
  /** The primary key(s) for `noteProcedure` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<NoteProcedureNodeIdConnect>>;
  /** The primary key(s) for `noteProcedure` for the far side of the relationship. */
  connectByNoteIdAndProcedureId?: InputMaybe<Array<NoteProcedureNoteProcedurePkeyConnect>>;
  /** The primary key(s) and patch data for `noteProcedure` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `noteProcedure` for the far side of the relationship. */
  updateByNoteIdAndProcedureId?: InputMaybe<Array<NoteProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyUsingNoteProcedurePkeyUpdate>>;
};

/** The `procedure` to be created by this mutation. */
export type NoteProcedureProcedureIdFkeyProcedureCreateInput = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `Procedure` values, with data from `NoteProcedure`. */
export type NoteProceduresByNoteProcedureNoteIdAndProcedureIdManyToManyConnection = {
  __typename?: 'NoteProceduresByNoteProcedureNoteIdAndProcedureIdManyToManyConnection';
  /** A list of edges which contains the `Procedure`, info from the `NoteProcedure`, and the cursor to aid in pagination. */
  edges: Array<NoteProceduresByNoteProcedureNoteIdAndProcedureIdManyToManyEdge>;
  /** A list of `Procedure` objects. */
  nodes: Array<Procedure>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Procedure` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Procedure` edge in the connection, with data from `NoteProcedure`. */
export type NoteProceduresByNoteProcedureNoteIdAndProcedureIdManyToManyEdge = {
  __typename?: 'NoteProceduresByNoteProcedureNoteIdAndProcedureIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Explicit inclusion of this senior's manual note in procedure documentation. */
  includeInDocumentation: Scalars['Boolean']['output'];
  /** Marks the single procedure-level manual documentation note. */
  isDocumentationManualNote: Scalars['Boolean']['output'];
  /** The `Procedure` at the end of the edge. */
  node: Procedure;
};

/** A connection to a list of `NoteProcedure` values. */
export type NoteProceduresConnection = {
  __typename?: 'NoteProceduresConnection';
  /** A list of edges which contains the `NoteProcedure` and cursor to aid in pagination. */
  edges: Array<NoteProceduresEdge>;
  /** A list of `NoteProcedure` objects. */
  nodes: Array<NoteProcedure>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NoteProcedure` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NoteProcedure` edge in the connection. */
export type NoteProceduresEdge = {
  __typename?: 'NoteProceduresEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NoteProcedure` at the end of the edge. */
  node: NoteProcedure;
};

/** Methods to use when ordering `NoteProcedure`. */
export enum NoteProceduresOrderBy {
  Natural = 'NATURAL',
  NoteIdAsc = 'NOTE_ID_ASC',
  NoteIdDesc = 'NOTE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcedureIdAsc = 'PROCEDURE_ID_ASC',
  ProcedureIdDesc = 'PROCEDURE_ID_DESC'
}

export type NoteSenior = Node & {
  __typename?: 'NoteSenior';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  noteId: Scalars['UUID']['output'];
  /** Reads a single `Note` that is related to this `NoteSenior`. */
  notes?: Maybe<Note>;
  seniorId: Scalars['UUID']['output'];
  /** Reads a single `User` that is related to this `NoteSenior`. */
  seniors?: Maybe<User>;
};

/** The globally unique `ID` look up for the row to connect. */
export type NoteSeniorNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `noteSenior` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** Input for the nested mutation of `note` in the `NoteSeniorInput` mutation. */
export type NoteSeniorNoteIdFkeyInput = {
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectById?: InputMaybe<NoteNotePkeyConnect>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<NoteNodeIdConnect>;
  /** A `NoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<NoteSeniorNoteIdFkeyNoteCreateInput>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteById?: InputMaybe<NoteNotePkeyDelete>;
  /** The primary key(s) for `note` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<NoteNodeIdDelete>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateById?: InputMaybe<NoteOnNoteSeniorForNoteSeniorNoteIdFkeyUsingNotePkeyUpdate>;
  /** The primary key(s) and patch data for `note` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<NoteSeniorOnNoteSeniorForNoteSeniorNoteIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `noteSenior` in the `NoteInput` mutation. */
export type NoteSeniorNoteIdFkeyInverseInput = {
  /** The primary key(s) for `noteSenior` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<NoteSeniorNodeIdConnect>>;
  /** The primary key(s) for `noteSenior` for the far side of the relationship. */
  connectByNoteIdAndSeniorId?: InputMaybe<Array<NoteSeniorNoteSeniorPkeyConnect>>;
  /** The primary key(s) and patch data for `noteSenior` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<NoteOnNoteSeniorForNoteSeniorNoteIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `noteSenior` for the far side of the relationship. */
  updateByNoteIdAndSeniorId?: InputMaybe<Array<NoteSeniorOnNoteSeniorForNoteSeniorNoteIdFkeyUsingNoteSeniorPkeyUpdate>>;
};

/** The `note` to be created by this mutation. */
export type NoteSeniorNoteIdFkeyNoteCreateInput = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** The fields on `noteSenior` to look up the row to connect. */
export type NoteSeniorNoteSeniorPkeyConnect = {
  noteId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type NoteSeniorOnNoteSeniorForNoteSeniorNoteIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `note` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: NotePatch;
};

/** The fields on `noteSenior` to look up the row to update. */
export type NoteSeniorOnNoteSeniorForNoteSeniorNoteIdFkeyUsingNoteSeniorPkeyUpdate = {
  noteId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `noteSenior` being updated. */
  patch: UpdateNoteSeniorOnNoteSeniorForNoteSeniorNoteIdFkeyPatch;
  seniorId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type NoteSeniorOnNoteSeniorForNoteSeniorSeniorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `noteSenior` to look up the row to update. */
export type NoteSeniorOnNoteSeniorForNoteSeniorSeniorIdFkeyUsingNoteSeniorPkeyUpdate = {
  noteId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `noteSenior` being updated. */
  patch: UpdateNoteSeniorOnNoteSeniorForNoteSeniorSeniorIdFkeyPatch;
  seniorId: Scalars['UUID']['input'];
};

/** Represents an update to a `NoteSenior`. Fields that are set will be updated. */
export type NoteSeniorPatch = {
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<NoteSeniorNoteIdFkeyInput>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  seniors?: InputMaybe<NoteSeniorSeniorIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `NoteSeniorInput` mutation. */
export type NoteSeniorSeniorIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<NoteSeniorSeniorIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnNoteSeniorForNoteSeniorSeniorIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<NoteSeniorOnNoteSeniorForNoteSeniorSeniorIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `noteSenior` in the `UserInput` mutation. */
export type NoteSeniorSeniorIdFkeyInverseInput = {
  /** The primary key(s) for `noteSenior` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<NoteSeniorNodeIdConnect>>;
  /** The primary key(s) for `noteSenior` for the far side of the relationship. */
  connectByNoteIdAndSeniorId?: InputMaybe<Array<NoteSeniorNoteSeniorPkeyConnect>>;
  /** The primary key(s) and patch data for `noteSenior` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnNoteSeniorForNoteSeniorSeniorIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `noteSenior` for the far side of the relationship. */
  updateByNoteIdAndSeniorId?: InputMaybe<Array<NoteSeniorOnNoteSeniorForNoteSeniorSeniorIdFkeyUsingNoteSeniorPkeyUpdate>>;
};

/** The `user` to be created by this mutation. */
export type NoteSeniorSeniorIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `User` values, with data from `NoteSenior`. */
export type NoteSeniorsManyToManyConnection = {
  __typename?: 'NoteSeniorsManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `NoteSenior`, and the cursor to aid in pagination. */
  edges: Array<NoteSeniorsManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `NoteSenior`. */
export type NoteSeniorsManyToManyEdge = {
  __typename?: 'NoteSeniorsManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** A connection to a list of `Note` values. */
export type NotesConnection = {
  __typename?: 'NotesConnection';
  /** A list of edges which contains the `Note` and cursor to aid in pagination. */
  edges: Array<NotesEdge>;
  /** A list of `Note` objects. */
  nodes: Array<Note>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Note` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Note` edge in the connection. */
export type NotesEdge = {
  __typename?: 'NotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Note` at the end of the edge. */
  node: Note;
};

/** Methods to use when ordering `Note`. */
export enum NotesOrderBy {
  AuthorIdAsc = 'AUTHOR_ID_ASC',
  AuthorIdDesc = 'AUTHOR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type OnboardingLocationInput = {
  clientId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentReference?: InputMaybe<Scalars['String']['input']>;
  type: LocationTypeEnum;
};

export type OnboardingPatientInput = {
  birthDate: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  gender: GenderEnum;
  lastName: Scalars['String']['input'];
  locationReference: Scalars['String']['input'];
  patientNumber: Scalars['String']['input'];
  salutation: Salutation;
};

export type OnboardingPractitionerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locationReferences: Array<Scalars['String']['input']>;
  salutation: Salutation;
  status: PractitionerStatus;
  workerNumber: Scalars['String']['input'];
};

export type Organization = Node & {
  __typename?: 'Organization';
  /** Additional information about the organization */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Whether the organization provides ambulant care; a copy of its Salesforce account's setting when it has an account. */
  ambulant: Scalars['Boolean']['output'];
  /** City of the organization */
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Device`. */
  devices: DevicesConnection;
  /** Reads and enables pagination through a set of `Device`. */
  devicesList: Array<Device>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `Location`. */
  locations: LocationsConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByDeviceOrganizationIdAndLocationId: OrganizationLocationsByDeviceOrganizationIdAndLocationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByDeviceOrganizationIdAndLocationIdList: Array<Location>;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByLocationOrganizationIdAndPartOfId: OrganizationLocationsByLocationOrganizationIdAndPartOfIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByLocationOrganizationIdAndPartOfIdList: Array<Location>;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByPatientOrganizationIdAndLocationId: OrganizationLocationsByPatientOrganizationIdAndLocationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByPatientOrganizationIdAndLocationIdList: Array<Location>;
  /** Reads and enables pagination through a set of `Location`. */
  locationsList: Array<Location>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrganizationManager`. */
  organizationManagers: OrganizationManagersConnection;
  /** Reads and enables pagination through a set of `OrganizationManager`. */
  organizationManagersList: Array<OrganizationManager>;
  /** Reads and enables pagination through a set of `OrganizationPractitioner`. */
  organizationPractitioners: OrganizationPractitionersConnection;
  /** Reads and enables pagination through a set of `OrganizationPractitioner`. */
  organizationPractitionersList: Array<OrganizationPractitioner>;
  /** Reads and enables pagination through a set of `Patient`. */
  patients: PatientsConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsList: Array<Patient>;
  /** Postal code (PLZ) of the organization location */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Practitioner`. */
  practitioners: PractitionersConnection;
  /** Reads and enables pagination through a set of `Practitioner`. */
  practitionersByProcedureOrganizationIdAndPerformerId: OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Practitioner`. */
  practitionersByProcedureOrganizationIdAndPerformerIdList: Array<Practitioner>;
  /** Reads and enables pagination through a set of `Practitioner`. */
  practitionersList: Array<Practitioner>;
  /** Reads and enables pagination through a set of `Procedure`. */
  procedures: ProceduresConnection;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresList: Array<Procedure>;
  /** Source system that created this organization (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Street address of the organization */
  street?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `User`. */
  usersByOrganizationPractitionerOrganizationIdAndPractitionerId: OrganizationUsersByOrganizationPractitionerOrganizationIdAndPractitionerIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByOrganizationPractitionerOrganizationIdAndPractitionerIdList: Array<User>;
};


export type OrganizationDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


export type OrganizationDevicesListArgs = {
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


export type OrganizationLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationLocationsByDeviceOrganizationIdAndLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationLocationsByDeviceOrganizationIdAndLocationIdListArgs = {
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationLocationsByLocationOrganizationIdAndPartOfIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationLocationsByLocationOrganizationIdAndPartOfIdListArgs = {
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationLocationsByPatientOrganizationIdAndLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationLocationsByPatientOrganizationIdAndLocationIdListArgs = {
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationLocationsListArgs = {
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationOrganizationManagersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationManagerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationManagersOrderBy>>;
};


export type OrganizationOrganizationManagersListArgs = {
  condition?: InputMaybe<OrganizationManagerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationManagersOrderBy>>;
};


export type OrganizationOrganizationPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationPractitionersOrderBy>>;
};


export type OrganizationOrganizationPractitionersListArgs = {
  condition?: InputMaybe<OrganizationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationPractitionersOrderBy>>;
};


export type OrganizationPatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


export type OrganizationPatientsListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


export type OrganizationPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PractitionersOrderBy>>;
};


export type OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PractitionersOrderBy>>;
};


export type OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdListArgs = {
  condition?: InputMaybe<PractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PractitionersOrderBy>>;
};


export type OrganizationPractitionersListArgs = {
  condition?: InputMaybe<PractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PractitionersOrderBy>>;
};


export type OrganizationProceduresArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


export type OrganizationProceduresListArgs = {
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


export type OrganizationUsersByOrganizationPractitionerOrganizationIdAndPractitionerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type OrganizationUsersByOrganizationPractitionerOrganizationIdAndPractitionerIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type OrganizationBilling = {
  __typename?: 'OrganizationBilling';
  availability: BillingAvailability;
  invoices: Array<BillingInvoice>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type OrganizationBillingAccess = {
  __typename?: 'OrganizationBillingAccess';
  accessEnabled: Scalars['Boolean']['output'];
  frisbiiCustomerId?: Maybe<Scalars['String']['output']>;
  invoiceAccountConfigured: Scalars['Boolean']['output'];
  mappingConfigured: Scalars['Boolean']['output'];
  mappingVersion?: Maybe<Scalars['UUID']['output']>;
  organizationId: Scalars['UUID']['output'];
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  salesforceAccountName?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `Organization` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrganizationCondition = {
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `sourceSystem` field. */
  sourceSystem?: InputMaybe<DataSource>;
};

export type OrganizationContractItem = {
  __typename?: 'OrganizationContractItem';
  endDate?: Maybe<Scalars['Date']['output']>;
  flavour?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  product: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  sponsoringOrganization?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  status: Scalars['String']['output'];
};

export type OrganizationContracts = {
  __typename?: 'OrganizationContracts';
  availability: BillingAvailability;
  items: Array<OrganizationContractItem>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type OrganizationCourseGrantInput = {
  courseId: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
};

export type OrganizationLearningGrants = {
  __typename?: 'OrganizationLearningGrants';
  grants: Array<LearningGrant>;
  organizationId: Scalars['UUID']['output'];
};

/** A connection to a list of `Location` values, with data from `Device`. */
export type OrganizationLocationsByDeviceOrganizationIdAndLocationIdManyToManyConnection = {
  __typename?: 'OrganizationLocationsByDeviceOrganizationIdAndLocationIdManyToManyConnection';
  /** A list of edges which contains the `Location`, info from the `Device`, and the cursor to aid in pagination. */
  edges: Array<OrganizationLocationsByDeviceOrganizationIdAndLocationIdManyToManyEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Location>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Location` edge in the connection, with data from `Device`. */
export type OrganizationLocationsByDeviceOrganizationIdAndLocationIdManyToManyEdge = {
  __typename?: 'OrganizationLocationsByDeviceOrganizationIdAndLocationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Reads and enables pagination through a set of `Device`. */
  devices: DevicesConnection;
  /** Reads and enables pagination through a set of `Device`. */
  devicesList: Array<Device>;
  /** The `Location` at the end of the edge. */
  node: Location;
};


/** A `Location` edge in the connection, with data from `Device`. */
export type OrganizationLocationsByDeviceOrganizationIdAndLocationIdManyToManyEdgeDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


/** A `Location` edge in the connection, with data from `Device`. */
export type OrganizationLocationsByDeviceOrganizationIdAndLocationIdManyToManyEdgeDevicesListArgs = {
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** A connection to a list of `Location` values, with data from `Location`. */
export type OrganizationLocationsByLocationOrganizationIdAndPartOfIdManyToManyConnection = {
  __typename?: 'OrganizationLocationsByLocationOrganizationIdAndPartOfIdManyToManyConnection';
  /** A list of edges which contains the `Location`, info from the `Location`, and the cursor to aid in pagination. */
  edges: Array<OrganizationLocationsByLocationOrganizationIdAndPartOfIdManyToManyEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Location>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Location` edge in the connection, with data from `Location`. */
export type OrganizationLocationsByLocationOrganizationIdAndPartOfIdManyToManyEdge = {
  __typename?: 'OrganizationLocationsByLocationOrganizationIdAndPartOfIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByPartOfId: LocationsConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByPartOfIdList: Array<Location>;
  /** The `Location` at the end of the edge. */
  node: Location;
};


/** A `Location` edge in the connection, with data from `Location`. */
export type OrganizationLocationsByLocationOrganizationIdAndPartOfIdManyToManyEdgeLocationsByPartOfIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


/** A `Location` edge in the connection, with data from `Location`. */
export type OrganizationLocationsByLocationOrganizationIdAndPartOfIdManyToManyEdgeLocationsByPartOfIdListArgs = {
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** A connection to a list of `Location` values, with data from `Patient`. */
export type OrganizationLocationsByPatientOrganizationIdAndLocationIdManyToManyConnection = {
  __typename?: 'OrganizationLocationsByPatientOrganizationIdAndLocationIdManyToManyConnection';
  /** A list of edges which contains the `Location`, info from the `Patient`, and the cursor to aid in pagination. */
  edges: Array<OrganizationLocationsByPatientOrganizationIdAndLocationIdManyToManyEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Location>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Location` edge in the connection, with data from `Patient`. */
export type OrganizationLocationsByPatientOrganizationIdAndLocationIdManyToManyEdge = {
  __typename?: 'OrganizationLocationsByPatientOrganizationIdAndLocationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Location` at the end of the edge. */
  node: Location;
  /** Reads and enables pagination through a set of `Patient`. */
  patients: PatientsConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsList: Array<Patient>;
};


/** A `Location` edge in the connection, with data from `Patient`. */
export type OrganizationLocationsByPatientOrganizationIdAndLocationIdManyToManyEdgePatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** A `Location` edge in the connection, with data from `Patient`. */
export type OrganizationLocationsByPatientOrganizationIdAndLocationIdManyToManyEdgePatientsListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};

/**
 * Junction table enforcing one-to-one relationship between managers and organizations.
 * Each manager can be associated with exactly one organization.
 */
export type OrganizationManager = Node & {
  __typename?: 'OrganizationManager';
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `OrganizationManager`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['UUID']['output'];
  /** Reads a single `User` that is related to this `OrganizationManager`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `OrganizationManager` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OrganizationManagerCondition = {
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OrganizationManagerNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `organizationManager` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationManagerOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organization` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: OrganizationPatch;
};

/** The fields on `organizationManager` to look up the row to update. */
export type OrganizationManagerOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyUsingOrganizationManagersPkeyUpdate = {
  /** An object where the defined keys will be set on the `organizationManager` being updated. */
  patch: UpdateOrganizationManagerOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationManagerOnOrganizationManagerForOrganizationManagersUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `organizationManager` to look up the row to update. */
export type OrganizationManagerOnOrganizationManagerForOrganizationManagersUserIdFkeyUsingOrganizationManagersPkeyUpdate = {
  /** An object where the defined keys will be set on the `organizationManager` being updated. */
  patch: UpdateOrganizationManagerOnOrganizationManagerForOrganizationManagersUserIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** The fields on `organizationManager` to look up the row to connect. */
export type OrganizationManagerOrganizationManagersPkeyConnect = {
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `OrganizationManager`. Fields that are set will be updated. */
export type OrganizationManagerPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<OrganizationManagersUserIdFkeyInput>;
};

/** A connection to a list of `OrganizationManager` values. */
export type OrganizationManagersConnection = {
  __typename?: 'OrganizationManagersConnection';
  /** A list of edges which contains the `OrganizationManager` and cursor to aid in pagination. */
  edges: Array<OrganizationManagersEdge>;
  /** A list of `OrganizationManager` objects. */
  nodes: Array<OrganizationManager>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrganizationManager` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrganizationManager` edge in the connection. */
export type OrganizationManagersEdge = {
  __typename?: 'OrganizationManagersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrganizationManager` at the end of the edge. */
  node: OrganizationManager;
};

/** Methods to use when ordering `OrganizationManager`. */
export enum OrganizationManagersOrderBy {
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `organization` in the `OrganizationManagerInput` mutation. */
export type OrganizationManagersOrganizationIdFkeyInput = {
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByExternalId?: InputMaybe<OrganizationOrganizationExternalIdKeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectById?: InputMaybe<OrganizationOrganizationPkeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrganizationNodeIdConnect>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByExternalId?: InputMaybe<OrganizationOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyUsingOrganizationExternalIdKeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateById?: InputMaybe<OrganizationOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyUsingOrganizationPkeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrganizationManagerOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `organizationManager` in the `OrganizationInput` mutation. */
export type OrganizationManagersOrganizationIdFkeyInverseInput = {
  /** The primary key(s) for `organizationManager` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OrganizationManagerNodeIdConnect>>;
  /** The primary key(s) for `organizationManager` for the far side of the relationship. */
  connectByUserId?: InputMaybe<Array<OrganizationManagerOrganizationManagersPkeyConnect>>;
  /** The primary key(s) and patch data for `organizationManager` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrganizationOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `organizationManager` for the far side of the relationship. */
  updateByUserId?: InputMaybe<Array<OrganizationManagerOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyUsingOrganizationManagersPkeyUpdate>>;
};

/** Input for the nested mutation of `user` in the `OrganizationManagerInput` mutation. */
export type OrganizationManagersUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<OrganizationManagersUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnOrganizationManagerForOrganizationManagersUserIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OrganizationManagerOnOrganizationManagerForOrganizationManagersUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `organizationManager` in the `UserInput` mutation. */
export type OrganizationManagersUserIdFkeyInverseInput = {
  /** The primary key(s) for `organizationManager` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrganizationManagerNodeIdConnect>;
  /** The primary key(s) for `organizationManager` for the far side of the relationship. */
  connectByUserId?: InputMaybe<OrganizationManagerOrganizationManagersPkeyConnect>;
  /** The primary key(s) and patch data for `organizationManager` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserOnOrganizationManagerForOrganizationManagersUserIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `organizationManager` for the far side of the relationship. */
  updateByUserId?: InputMaybe<OrganizationManagerOnOrganizationManagerForOrganizationManagersUserIdFkeyUsingOrganizationManagersPkeyUpdate>;
};

/** The `user` to be created by this mutation. */
export type OrganizationManagersUserIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OrganizationNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `organization` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationOnDeviceForDeviceOrganizationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `device` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `device` being updated. */
  patch: DevicePatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnDeviceForDeviceOrganizationIdFkeyUsingOrganizationExternalIdKeyUpdate = {
  externalId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnDeviceForDeviceOrganizationIdFkeyPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnDeviceForDeviceOrganizationIdFkeyUsingOrganizationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnDeviceForDeviceOrganizationIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationOnLocationForFkLocationOrganizationNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `location` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: LocationPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnLocationForFkLocationOrganizationUsingOrganizationExternalIdKeyUpdate = {
  externalId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnLocationForFkLocationOrganizationPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnLocationForFkLocationOrganizationUsingOrganizationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnLocationForFkLocationOrganizationPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organizationManager` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organizationManager` being updated. */
  patch: OrganizationManagerPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyUsingOrganizationExternalIdKeyUpdate = {
  externalId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyUsingOrganizationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationOnOrganizationPractitionerForFkOrganizationNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organizationPractitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organizationPractitioner` being updated. */
  patch: OrganizationPractitionerPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnOrganizationPractitionerForFkOrganizationUsingOrganizationExternalIdKeyUpdate = {
  externalId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnOrganizationPractitionerForFkOrganizationPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnOrganizationPractitionerForFkOrganizationUsingOrganizationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnOrganizationPractitionerForFkOrganizationPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationOnPatientForFkPatientOrganizationNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `patient` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: PatientPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnPatientForFkPatientOrganizationUsingOrganizationExternalIdKeyUpdate = {
  externalId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnPatientForFkPatientOrganizationPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnPatientForFkPatientOrganizationUsingOrganizationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnPatientForFkPatientOrganizationPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationOnPractitionerForPractitionerOrganizationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `practitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: PractitionerPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnPractitionerForPractitionerOrganizationIdFkeyUsingOrganizationExternalIdKeyUpdate = {
  externalId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnPractitionerForPractitionerOrganizationIdFkeyPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnPractitionerForPractitionerOrganizationIdFkeyUsingOrganizationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnPractitionerForPractitionerOrganizationIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationOnProcedureForProcedureOrganizationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `procedure` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: ProcedurePatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnProcedureForProcedureOrganizationIdFkeyUsingOrganizationExternalIdKeyUpdate = {
  externalId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnProcedureForProcedureOrganizationIdFkeyPatch;
};

/** The fields on `organization` to look up the row to update. */
export type OrganizationOnProcedureForProcedureOrganizationIdFkeyUsingOrganizationPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: UpdateOrganizationOnProcedureForProcedureOrganizationIdFkeyPatch;
};

/** The fields on `organization` to look up the row to connect. */
export type OrganizationOrganizationExternalIdKeyConnect = {
  externalId: Scalars['String']['input'];
};

/** The fields on `organization` to look up the row to connect. */
export type OrganizationOrganizationPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** Represents an update to a `Organization`. Fields that are set will be updated. */
export type OrganizationPatch = {
  /** Additional information about the organization */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Whether the organization provides ambulant care; a copy of its Salesforce account's setting when it has an account. */
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** City of the organization */
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceOrganizationIdFkeyInverseInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationsUsingId?: InputMaybe<FkLocationOrganizationInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationManagersUsingId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkOrganizationInverseInput>;
  patientsUsingId?: InputMaybe<FkPatientOrganizationInverseInput>;
  /** Postal code (PLZ) of the organization location */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  practitionersUsingId?: InputMaybe<PractitionerOrganizationIdFkeyInverseInput>;
  proceduresUsingId?: InputMaybe<ProcedureOrganizationIdFkeyInverseInput>;
  /** Source system that created this organization (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  /** Street address of the organization */
  street?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationPathGrantInput = {
  learningPathId: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
};

export type OrganizationPractitioner = Node & {
  __typename?: 'OrganizationPractitioner';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `OrganizationPractitioner`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['UUID']['output'];
  /** Reads a single `User` that is related to this `OrganizationPractitioner`. */
  practitioner?: Maybe<User>;
  practitionerId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `OrganizationPractitioner` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type OrganizationPractitionerCondition = {
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `practitionerId` field. */
  practitionerId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OrganizationPractitionerNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `organizationPractitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationPractitionerOnOrganizationPractitionerForFkOrganizationNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organization` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: OrganizationPatch;
};

/** The fields on `organizationPractitioner` to look up the row to update. */
export type OrganizationPractitionerOnOrganizationPractitionerForFkOrganizationUsingOrganizationPractitionersPkeyUpdate = {
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `organizationPractitioner` being updated. */
  patch: UpdateOrganizationPractitionerOnOrganizationPractitionerForFkOrganizationPatch;
  practitionerId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type OrganizationPractitionerOnOrganizationPractitionerForFkPractitionerNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `organizationPractitioner` to look up the row to update. */
export type OrganizationPractitionerOnOrganizationPractitionerForFkPractitionerUsingOrganizationPractitionersPkeyUpdate = {
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `organizationPractitioner` being updated. */
  patch: UpdateOrganizationPractitionerOnOrganizationPractitionerForFkPractitionerPatch;
  practitionerId: Scalars['UUID']['input'];
};

/** The fields on `organizationPractitioner` to look up the row to connect. */
export type OrganizationPractitionerOrganizationPractitionersPkeyConnect = {
  organizationId: Scalars['UUID']['input'];
  practitionerId: Scalars['UUID']['input'];
};

/** Represents an update to a `OrganizationPractitioner`. Fields that are set will be updated. */
export type OrganizationPractitionerPatch = {
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkOrganizationInput>;
  practitionerId?: InputMaybe<Scalars['UUID']['input']>;
  userToPractitionerId?: InputMaybe<FkPractitionerInput>;
};

/** A connection to a list of `Practitioner` values, with data from `Procedure`. */
export type OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdManyToManyConnection = {
  __typename?: 'OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdManyToManyConnection';
  /** A list of edges which contains the `Practitioner`, info from the `Procedure`, and the cursor to aid in pagination. */
  edges: Array<OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdManyToManyEdge>;
  /** A list of `Practitioner` objects. */
  nodes: Array<Practitioner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Practitioner` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Practitioner` edge in the connection, with data from `Procedure`. */
export type OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdManyToManyEdge = {
  __typename?: 'OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Practitioner` at the end of the edge. */
  node: Practitioner;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByPerformerId: ProceduresConnection;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByPerformerIdList: Array<Procedure>;
};


/** A `Practitioner` edge in the connection, with data from `Procedure`. */
export type OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdManyToManyEdgeProceduresByPerformerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


/** A `Practitioner` edge in the connection, with data from `Procedure`. */
export type OrganizationPractitionersByProcedureOrganizationIdAndPerformerIdManyToManyEdgeProceduresByPerformerIdListArgs = {
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};

/** A connection to a list of `OrganizationPractitioner` values. */
export type OrganizationPractitionersConnection = {
  __typename?: 'OrganizationPractitionersConnection';
  /** A list of edges which contains the `OrganizationPractitioner` and cursor to aid in pagination. */
  edges: Array<OrganizationPractitionersEdge>;
  /** A list of `OrganizationPractitioner` objects. */
  nodes: Array<OrganizationPractitioner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrganizationPractitioner` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrganizationPractitioner` edge in the connection. */
export type OrganizationPractitionersEdge = {
  __typename?: 'OrganizationPractitionersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrganizationPractitioner` at the end of the edge. */
  node: OrganizationPractitioner;
};

/** Methods to use when ordering `OrganizationPractitioner`. */
export enum OrganizationPractitionersOrderBy {
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PractitionerIdAsc = 'PRACTITIONER_ID_ASC',
  PractitionerIdDesc = 'PRACTITIONER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `User` values, with data from `OrganizationPractitioner`. */
export type OrganizationUsersByOrganizationPractitionerOrganizationIdAndPractitionerIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByOrganizationPractitionerOrganizationIdAndPractitionerIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `OrganizationPractitioner`, and the cursor to aid in pagination. */
  edges: Array<OrganizationUsersByOrganizationPractitionerOrganizationIdAndPractitionerIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `OrganizationPractitioner`. */
export type OrganizationUsersByOrganizationPractitionerOrganizationIdAndPractitionerIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByOrganizationPractitionerOrganizationIdAndPractitionerIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** A connection to a list of `Organization` values. */
export type OrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  /** A list of edges which contains the `Organization` and cursor to aid in pagination. */
  edges: Array<OrganizationsEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organization` edge in the connection. */
export type OrganizationsEdge = {
  __typename?: 'OrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Organization` at the end of the edge. */
  node: Organization;
};

/** Methods to use when ordering `Organization`. */
export enum OrganizationsOrderBy {
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceSystemAsc = 'SOURCE_SYSTEM_ASC',
  SourceSystemDesc = 'SOURCE_SYSTEM_DESC'
}

/** Input for the nested mutation of `user` in the `WebsiteInput` mutation. */
export type OwnerUserIdInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<OwnerUserIdUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnWebsiteForOwnerUserIdUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<WebsiteOnWebsiteForOwnerUserIdNodeIdUpdate>;
};

/** Input for the nested mutation of `website` in the `UserInput` mutation. */
export type OwnerUserIdInverseInput = {
  /** The primary key(s) for `website` for the far side of the relationship. */
  connectById?: InputMaybe<Array<WebsiteWebsitePkeyConnect>>;
  /** The primary key(s) for `website` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<WebsiteNodeIdConnect>>;
  /** A `WebsiteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<OwnerUserIdWebsiteCreateInput>>;
  /** The primary key(s) for `website` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<WebsiteWebsitePkeyDelete>>;
  /** The primary key(s) for `website` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<WebsiteNodeIdDelete>>;
  /** Flag indicating whether all other `website` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `website` for the far side of the relationship. */
  updateById?: InputMaybe<Array<WebsiteOnWebsiteForOwnerUserIdUsingWebsitePkeyUpdate>>;
  /** The primary key(s) and patch data for `website` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnWebsiteForOwnerUserIdNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type OwnerUserIdUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The `website` to be created by this mutation. */
export type OwnerUserIdWebsiteCreateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  userToUserId?: InputMaybe<OwnerUserIdInput>;
};

export type Page = {
  __typename?: 'Page';
  kind: TemplateKind;
  mediaWithCaption?: Maybe<Array<MediaWithCaptionV2>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export enum PasswordResetRecipient {
  Admin = 'ADMIN',
  Both = 'BOTH',
  User = 'USER'
}

export type PathAssignmentInput = {
  learningPathId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type Patient = Node & {
  __typename?: 'Patient';
  birthDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId: Scalars['String']['output'];
  gender?: Maybe<GenderEnum>;
  id: Scalars['UUID']['output'];
  /** Reads a single `Location` that is related to this `Patient`. */
  location?: Maybe<Location>;
  /** Returns the complete location hierarchy for this patient, ordered from most specific to most general (BED > ROOM > WARD > DEPARTMENT > SITE). */
  locationHierarchy: PatientLocationHierarchyConnection;
  /** Returns the complete location hierarchy for this patient, ordered from most specific to most general (BED > ROOM > WARD > DEPARTMENT > SITE). */
  locationHierarchyList?: Maybe<Array<Maybe<PatientLocationHierarchyRecord>>>;
  /** Reference to the patient location; the organization root represents no assigned physical location */
  locationId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Patient`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['UUID']['output'];
  /** Unique identifier for the patient within the organization */
  patientNumber?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `ProcedureParticipant`. */
  procedureParticipants: ProcedureParticipantsConnection;
  /** Reads and enables pagination through a set of `ProcedureParticipant`. */
  procedureParticipantsList: Array<ProcedureParticipant>;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByProcedureParticipantPatientIdAndProcedureId: PatientProceduresByProcedureParticipantPatientIdAndProcedureIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByProcedureParticipantPatientIdAndProcedureIdList: Array<Procedure>;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Reads a single `User` that is related to this `Patient`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};


export type PatientLocationHierarchyArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientLocationHierarchyListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientProcedureParticipantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProcedureParticipantsOrderBy>>;
};


export type PatientProcedureParticipantsListArgs = {
  condition?: InputMaybe<ProcedureParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProcedureParticipantsOrderBy>>;
};


export type PatientProceduresByProcedureParticipantPatientIdAndProcedureIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


export type PatientProceduresByProcedureParticipantPatientIdAndProcedureIdListArgs = {
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};

/** A condition to be used against `Patient` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PatientCondition = {
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `patientNumber` field. */
  patientNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceSystem` field. */
  sourceSystem?: InputMaybe<DataSource>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `PatientLocationHierarchyRecord` values. */
export type PatientLocationHierarchyConnection = {
  __typename?: 'PatientLocationHierarchyConnection';
  /** A list of edges which contains the `PatientLocationHierarchyRecord` and cursor to aid in pagination. */
  edges: Array<PatientLocationHierarchyEdge>;
  /** A list of `PatientLocationHierarchyRecord` objects. */
  nodes: Array<PatientLocationHierarchyRecord>;
  /** The count of *all* `PatientLocationHierarchyRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PatientLocationHierarchyRecord` edge in the connection. */
export type PatientLocationHierarchyEdge = {
  __typename?: 'PatientLocationHierarchyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PatientLocationHierarchyRecord` at the end of the edge. */
  node: PatientLocationHierarchyRecord;
};

/** The return type of our `locationHierarchy` query. */
export type PatientLocationHierarchyRecord = {
  __typename?: 'PatientLocationHierarchyRecord';
  externalId?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  locationId?: Maybe<Scalars['UUID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<LocationTypeEnum>;
};

/** Input for the nested mutation of `location` in the `PatientInput` mutation. */
export type PatientLocationIdFkeyInput = {
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectById?: InputMaybe<LocationLocationPkeyConnect>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<LocationNodeIdConnect>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationUqLocationExternalIdConnect>;
  /** A `LocationInput` object that will be created and connected to this object. */
  create?: InputMaybe<PatientLocationIdFkeyLocationCreateInput>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteById?: InputMaybe<LocationLocationPkeyDelete>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<LocationNodeIdDelete>;
  /** The primary key(s) for `location` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationUqLocationExternalIdDelete>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateById?: InputMaybe<LocationOnPatientForPatientLocationIdFkeyUsingLocationPkeyUpdate>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<PatientOnPatientForPatientLocationIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `location` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndTypeAndOrganizationId?: InputMaybe<LocationOnPatientForPatientLocationIdFkeyUsingUqLocationExternalIdUpdate>;
};

/** Input for the nested mutation of `patient` in the `LocationInput` mutation. */
export type PatientLocationIdFkeyInverseInput = {
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PatientPkFhirPatientConnect>>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<PatientNodeIdConnect>>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<PatientUqPatientExternalIdConnect>>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByUserId?: InputMaybe<Array<PatientUqPatientUserIdConnect>>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PatientOnPatientForPatientLocationIdFkeyUsingPkFhirPatientUpdate>>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<LocationOnPatientForPatientLocationIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<PatientOnPatientForPatientLocationIdFkeyUsingUqPatientExternalIdUpdate>>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByUserId?: InputMaybe<Array<PatientOnPatientForPatientLocationIdFkeyUsingUqPatientUserIdUpdate>>;
};

/** The `location` to be created by this mutation. */
export type PatientLocationIdFkeyLocationCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type PatientNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `patient` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type PatientOnPatientForFkPatientOrganizationNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organization` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: OrganizationPatch;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForFkPatientOrganizationUsingPkFhirPatientUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForFkPatientOrganizationPatch;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForFkPatientOrganizationUsingUqPatientExternalIdUpdate = {
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForFkPatientOrganizationPatch;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForFkPatientOrganizationUsingUqPatientUserIdUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForFkPatientOrganizationPatch;
  userId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type PatientOnPatientForFkUserNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForFkUserUsingPkFhirPatientUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForFkUserPatch;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForFkUserUsingUqPatientExternalIdUpdate = {
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForFkUserPatch;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForFkUserUsingUqPatientUserIdUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForFkUserPatch;
  userId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type PatientOnPatientForPatientLocationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `location` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `location` being updated. */
  patch: LocationPatch;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForPatientLocationIdFkeyUsingPkFhirPatientUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForPatientLocationIdFkeyPatch;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForPatientLocationIdFkeyUsingUqPatientExternalIdUpdate = {
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForPatientLocationIdFkeyPatch;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForPatientLocationIdFkeyUsingUqPatientUserIdUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForPatientLocationIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type PatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `procedureParticipant` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `procedureParticipant` being updated. */
  patch: ProcedureParticipantPatch;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyUsingPkFhirPatientUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyPatch;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyUsingUqPatientExternalIdUpdate = {
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyPatch;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** The fields on `patient` to look up the row to update. */
export type PatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyUsingUqPatientUserIdUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `Patient`. Fields that are set will be updated. */
export type PatientPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Reference to the patient location; the organization root represents no assigned physical location */
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<PatientLocationIdFkeyInput>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkPatientOrganizationInput>;
  /** Unique identifier for the patient within the organization */
  patientNumber?: InputMaybe<Scalars['String']['input']>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInverseInput>;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<FkUserInput>;
};

/** The fields on `patient` to look up the row to connect. */
export type PatientPkFhirPatientConnect = {
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `Procedure` values, with data from `ProcedureParticipant`. */
export type PatientProceduresByProcedureParticipantPatientIdAndProcedureIdManyToManyConnection = {
  __typename?: 'PatientProceduresByProcedureParticipantPatientIdAndProcedureIdManyToManyConnection';
  /** A list of edges which contains the `Procedure`, info from the `ProcedureParticipant`, and the cursor to aid in pagination. */
  edges: Array<PatientProceduresByProcedureParticipantPatientIdAndProcedureIdManyToManyEdge>;
  /** A list of `Procedure` objects. */
  nodes: Array<Procedure>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Procedure` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Procedure` edge in the connection, with data from `ProcedureParticipant`. */
export type PatientProceduresByProcedureParticipantPatientIdAndProcedureIdManyToManyEdge = {
  __typename?: 'PatientProceduresByProcedureParticipantPatientIdAndProcedureIdManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Procedure` at the end of the edge. */
  node: Procedure;
};

export type PatientResponse = {
  __typename?: 'PatientResponse';
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

/** The fields on `patient` to look up the row to connect. */
export type PatientUqPatientExternalIdConnect = {
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** The fields on `patient` to look up the row to connect. */
export type PatientUqPatientUserIdConnect = {
  userId: Scalars['UUID']['input'];
};

/** A connection to a list of `Patient` values. */
export type PatientsConnection = {
  __typename?: 'PatientsConnection';
  /** A list of edges which contains the `Patient` and cursor to aid in pagination. */
  edges: Array<PatientsEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Patient` edge in the connection. */
export type PatientsEdge = {
  __typename?: 'PatientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};

/** Methods to use when ordering `Patient`. */
export enum PatientsOrderBy {
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LocationIdAsc = 'LOCATION_ID_ASC',
  LocationIdDesc = 'LOCATION_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PatientNumberAsc = 'PATIENT_NUMBER_ASC',
  PatientNumberDesc = 'PATIENT_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceSystemAsc = 'SOURCE_SYSTEM_ASC',
  SourceSystemDesc = 'SOURCE_SYSTEM_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type PlacetelCall = {
  __typename?: 'PlacetelCall';
  accountId?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['Datetime']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  direction: PlacetelCallDirection;
  endedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  leadId?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<PlacetelCallOutcome>;
  /**
   * E.164, or null when the caller withheld the number or it is no usable
   * phone number.
   */
  remoteNumber?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['Datetime']['output'];
};

export enum PlacetelCallDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export enum PlacetelCallEvent {
  Answered = 'ANSWERED',
  Ended = 'ENDED',
  Started = 'STARTED'
}

export type PlacetelCallEventInput = {
  /** The portal's original connection time, sent only with an answered immediate unload end. */
  answeredAt?: InputMaybe<Scalars['Datetime']['input']>;
  direction: PlacetelCallDirection;
  event: PlacetelCallEvent;
  outcome?: InputMaybe<PlacetelCallOutcome>;
  /**
   * The portal phone's id for the call: the Webex correlation id for incoming
   * calls, a portal-generated UUID for outgoing calls; unique per agent.
   */
  portalCallId: Scalars['String']['input'];
  /**
   * The record the call belongs to. An event that carries a record replaces
   * the call's links.
   */
  record?: InputMaybe<PlacetelCallRecordInput>;
  /**
   * The other party's number as the phone reports or the CRM shows it;
   * national numbers count as German. Outbound calls need a usable number;
   * inbound callers may withhold theirs. A later event of the call fills in a
   * number the call has none of yet; a number the call already has never
   * changes.
   */
  remoteNumber?: InputMaybe<Scalars['String']['input']>;
  /** The portal's original start time, sent only with an immediate unload end. */
  startedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum PlacetelCallHistoryAccess {
  Failed = 'FAILED',
  Forbidden = 'FORBIDDEN',
  Ok = 'OK',
  RateLimited = 'RATE_LIMITED'
}

export type PlacetelCallNote = {
  __typename?: 'PlacetelCallNote';
  authorUserId?: Maybe<Scalars['UUID']['output']>;
  body: Scalars['String']['output'];
  callId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
};

export type PlacetelCallNoteInput = {
  /** The note's text. */
  body: Scalars['String']['input'];
  callId: Scalars['UUID']['input'];
};

export enum PlacetelCallOutcome {
  Answered = 'ANSWERED',
  Busy = 'BUSY',
  Failed = 'FAILED',
  Missed = 'MISSED',
  Rejected = 'REJECTED'
}

/**
 * The account, contact, lead or case a call belongs to; contracts, contract
 * items and orders are refused.
 */
export type PlacetelCallRecordInput = {
  object: CrmObject;
  salesforceId: Scalars['String']['input'];
};

export enum PlacetelConnectionError {
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  CredentialsUnavailable = 'CREDENTIALS_UNAVAILABLE',
  InsufficientScope = 'INSUFFICIENT_SCOPE',
  InvalidResponse = 'INVALID_RESPONSE',
  NetworkError = 'NETWORK_ERROR',
  NotConfigured = 'NOT_CONFIGURED',
  OrganizationMismatch = 'ORGANIZATION_MISMATCH',
  OrganizationNotFound = 'ORGANIZATION_NOT_FOUND',
  ProviderError = 'PROVIDER_ERROR',
  RateLimited = 'RATE_LIMITED',
  Timeout = 'TIMEOUT'
}

export type PlacetelConnectionResult = {
  __typename?: 'PlacetelConnectionResult';
  accountName?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the Service App may read the call history. Null when the
   * connection check failed.
   */
  callHistory?: Maybe<PlacetelCallHistoryAccess>;
  errorCode?: Maybe<PlacetelConnectionError>;
  ok: Scalars['Boolean']['output'];
};

export type PlacetelIntegration = {
  __typename?: 'PlacetelIntegration';
  clientId?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  hasClientSecret: Scalars['Boolean']['output'];
  hasPhoneClientSecret: Scalars['Boolean']['output'];
  hasRefreshToken: Scalars['Boolean']['output'];
  hasWebhookSecret: Scalars['Boolean']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  /**
   * The Webex Integration (OAuth app) agents sign in with for the portal
   * phone. Null when phone sign-in is not configured.
   */
  phoneClientId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type PlacetelIntegrationInput = {
  clientId: Scalars['String']['input'];
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
  /**
   * The Webex Integration (OAuth app) agents sign in with for the portal
   * phone. Null, empty or omitted removes the app and every agent's phone
   * link.
   */
  phoneClientId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Write-only. Omitting it keeps the stored secret while the phone client id
   * is unchanged.
   */
  phoneClientSecret?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

/** One open day of the hotline. */
export type PlacetelOpeningDay = {
  __typename?: 'PlacetelOpeningDay';
  /** Closing time as HH:MM in German (Berlin) time; after opens. */
  closes: Scalars['String']['output'];
  /** Opening time as HH:MM in German (Berlin) time. */
  opens: Scalars['String']['output'];
  /** ISO weekday: 1 = Monday to 7 = Sunday. */
  weekday: Scalars['Int']['output'];
};

export type PlacetelOpeningDayInput = {
  /** Closing time as HH:MM in German (Berlin) time; after opens. */
  closes: Scalars['String']['input'];
  /** Opening time as HH:MM in German (Berlin) time. */
  opens: Scalars['String']['input'];
  /** ISO weekday: 1 = Monday to 7 = Sunday; each at most once. */
  weekday: Scalars['Int']['input'];
};

/**
 * The agent's current Webex access token for their own browser phone. Valid
 * until expiresAt (typically about 14 days); Webex cannot revoke it early, so
 * keep it in memory only.
 */
export type PlacetelPhoneAccessToken = {
  __typename?: 'PlacetelPhoneAccessToken';
  accessToken?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<PlacetelPhoneTokenError>;
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
};

/** The signed-in agent's Webex account for the portal phone. */
export type PlacetelPhoneAccount = {
  __typename?: 'PlacetelPhoneAccount';
  /** Phone sign-in is configured and the integration is enabled. */
  available: Scalars['Boolean']['output'];
  /** The agent linked a Webex account through the current phone sign-in app. */
  connected: Scalars['Boolean']['output'];
  connectedAt?: Maybe<Scalars['Datetime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
};

export enum PlacetelPhoneSignInError {
  AccountInUse = 'ACCOUNT_IN_USE',
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  Cancelled = 'CANCELLED',
  InsufficientScope = 'INSUFFICIENT_SCOPE',
  InvalidResponse = 'INVALID_RESPONSE',
  NetworkError = 'NETWORK_ERROR',
  ProviderError = 'PROVIDER_ERROR',
  RateLimited = 'RATE_LIMITED',
  RequestExpired = 'REQUEST_EXPIRED',
  Timeout = 'TIMEOUT',
  Unavailable = 'UNAVAILABLE',
  WrongOrganization = 'WRONG_ORGANIZATION'
}

export type PlacetelPhoneSignInResult = {
  __typename?: 'PlacetelPhoneSignInResult';
  account: PlacetelPhoneAccount;
  errorCode?: Maybe<PlacetelPhoneSignInError>;
};

export type PlacetelPhoneSignInStart = {
  __typename?: 'PlacetelPhoneSignInStart';
  /** Where the browser goes to sign in to Webex. */
  authorizationUrl: Scalars['String']['output'];
};

export enum PlacetelPhoneTokenError {
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  InsufficientScope = 'INSUFFICIENT_SCOPE',
  InvalidResponse = 'INVALID_RESPONSE',
  NetworkError = 'NETWORK_ERROR',
  NotConnected = 'NOT_CONNECTED',
  ProviderError = 'PROVIDER_ERROR',
  RateLimited = 'RATE_LIMITED',
  ReconnectRequired = 'RECONNECT_REQUIRED',
  Timeout = 'TIMEOUT',
  Unavailable = 'UNAVAILABLE'
}

export enum Plan {
  Basic = 'basic',
  Comfort = 'comfort',
  Games = 'games',
  Standard = 'standard'
}

export type PlanNewProcedureInput = {
  plannedStart: Scalars['Datetime']['input'];
  title: Scalars['String']['input'];
};

export type PlanRecommendedActivityInput = {
  contentUuid: Scalars['UUID']['input'];
  newProcedure?: InputMaybe<PlanNewProcedureInput>;
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  userId: Scalars['UUID']['input'];
};

export type PlanRecommendedActivityResult = {
  __typename?: 'PlanRecommendedActivityResult';
  procedureId: Scalars['UUID']['output'];
  sessionId: Scalars['UUID']['output'];
};

export type PlannedProcedureActivitySessionInput = {
  contentId: Scalars['UUID']['input'];
  positionInProcedure: Scalars['Int']['input'];
  procedureId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

/** FHIR Practitioner resource representing healthcare professionals */
export type Practitioner = Node & {
  __typename?: 'Practitioner';
  birthDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Datetime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId: Scalars['String']['output'];
  gender: GenderEnum;
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `LocationPractitioner`. */
  locationPractitioners: LocationPractitionersConnection;
  /** Reads and enables pagination through a set of `LocationPractitioner`. */
  locationPractitionersList: Array<LocationPractitioner>;
  motherTongue?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Practitioner`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProcedurePerformerIdAndOrganizationId: PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProcedurePerformerIdAndOrganizationIdList: Array<Organization>;
  /** Reads and enables pagination through a set of `Location`. */
  practitioners: PractitionerPractitionersManyToManyConnection;
  /** Reads and enables pagination through a set of `Location`. */
  practitionersList: Array<Location>;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByPerformerId: ProceduresConnection;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByPerformerIdList: Array<Procedure>;
  role: Scalars['String']['output'];
  /** Source-system practitioner short code. For Vivendi this maps to Mitarbeiter.Handzeichen / FHIR Practitioner.identifier system urn:vivendi:handzeichen. */
  shortCode?: Maybe<Scalars['String']['output']>;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  status: PractitionerStatusEnum;
  telephoneNumber?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `Practitioner`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};


/** FHIR Practitioner resource representing healthcare professionals */
export type PractitionerLocationPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationPractitionersOrderBy>>;
};


/** FHIR Practitioner resource representing healthcare professionals */
export type PractitionerLocationPractitionersListArgs = {
  condition?: InputMaybe<LocationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationPractitionersOrderBy>>;
};


/** FHIR Practitioner resource representing healthcare professionals */
export type PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** FHIR Practitioner resource representing healthcare professionals */
export type PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdListArgs = {
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** FHIR Practitioner resource representing healthcare professionals */
export type PractitionerPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


/** FHIR Practitioner resource representing healthcare professionals */
export type PractitionerPractitionersListArgs = {
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


/** FHIR Practitioner resource representing healthcare professionals */
export type PractitionerProceduresByPerformerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


/** FHIR Practitioner resource representing healthcare professionals */
export type PractitionerProceduresByPerformerIdListArgs = {
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};

/**
 * A condition to be used against `Practitioner` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PractitionerCondition = {
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `sourceSystem` field. */
  sourceSystem?: InputMaybe<DataSource>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PractitionerLoginOutcome = {
  __typename?: 'PractitionerLoginOutcome';
  jwtToken?: Maybe<Scalars['String']['output']>;
  remainingAttempts: Scalars['Int']['output'];
  status: PractitionerLoginStatus;
};

export type PractitionerLoginResponse = {
  __typename?: 'PractitionerLoginResponse';
  jwtToken: Scalars['String']['output'];
};

export enum PractitionerLoginStatus {
  Authenticated = 'AUTHENTICATED',
  Blocked = 'BLOCKED',
  InvalidPassword = 'INVALID_PASSWORD'
}

/** The globally unique `ID` look up for the row to connect. */
export type PractitionerNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `practitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type PractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `locationPractitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `locationPractitioner` being updated. */
  patch: LocationPractitionerPatch;
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerUsingPractitionerPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerPatch;
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerUsingPractitionerUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerPatch;
  userId: Scalars['UUID']['input'];
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerUsingUqPractitionerExternalIdUpdate = {
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerPatch;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** The globally unique `ID` look up for the row to update. */
export type PractitionerOnPractitionerForPractitionerOrganizationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organization` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: OrganizationPatch;
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnPractitionerForPractitionerOrganizationIdFkeyUsingPractitionerPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnPractitionerForPractitionerOrganizationIdFkeyPatch;
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnPractitionerForPractitionerOrganizationIdFkeyUsingPractitionerUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnPractitionerForPractitionerOrganizationIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnPractitionerForPractitionerOrganizationIdFkeyUsingUqPractitionerExternalIdUpdate = {
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnPractitionerForPractitionerOrganizationIdFkeyPatch;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** The globally unique `ID` look up for the row to update. */
export type PractitionerOnPractitionerForPractitionerUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnPractitionerForPractitionerUserIdFkeyUsingPractitionerPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnPractitionerForPractitionerUserIdFkeyPatch;
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnPractitionerForPractitionerUserIdFkeyUsingPractitionerUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnPractitionerForPractitionerUserIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnPractitionerForPractitionerUserIdFkeyUsingUqPractitionerExternalIdUpdate = {
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnPractitionerForPractitionerUserIdFkeyPatch;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** The globally unique `ID` look up for the row to update. */
export type PractitionerOnProcedureForProcedurePerformerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `procedure` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: ProcedurePatch;
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnProcedureForProcedurePerformerIdFkeyUsingPractitionerPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnProcedureForProcedurePerformerIdFkeyPatch;
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnProcedureForProcedurePerformerIdFkeyUsingPractitionerUserIdKeyUpdate = {
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnProcedureForProcedurePerformerIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** The fields on `practitioner` to look up the row to update. */
export type PractitionerOnProcedureForProcedurePerformerIdFkeyUsingUqPractitionerExternalIdUpdate = {
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: UpdatePractitionerOnProcedureForProcedurePerformerIdFkeyPatch;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** Input for the nested mutation of `organization` in the `PractitionerInput` mutation. */
export type PractitionerOrganizationIdFkeyInput = {
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByExternalId?: InputMaybe<OrganizationOrganizationExternalIdKeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectById?: InputMaybe<OrganizationOrganizationPkeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrganizationNodeIdConnect>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByExternalId?: InputMaybe<OrganizationOnPractitionerForPractitionerOrganizationIdFkeyUsingOrganizationExternalIdKeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateById?: InputMaybe<OrganizationOnPractitionerForPractitionerOrganizationIdFkeyUsingOrganizationPkeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<PractitionerOnPractitionerForPractitionerOrganizationIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `practitioner` in the `OrganizationInput` mutation. */
export type PractitionerOrganizationIdFkeyInverseInput = {
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PractitionerPractitionerPkeyConnect>>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<PractitionerNodeIdConnect>>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<PractitionerUqPractitionerExternalIdConnect>>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectByUserId?: InputMaybe<Array<PractitionerPractitionerUserIdKeyConnect>>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PractitionerOnPractitionerForPractitionerOrganizationIdFkeyUsingPractitionerPkeyUpdate>>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrganizationOnPractitionerForPractitionerOrganizationIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<PractitionerOnPractitionerForPractitionerOrganizationIdFkeyUsingUqPractitionerExternalIdUpdate>>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateByUserId?: InputMaybe<Array<PractitionerOnPractitionerForPractitionerOrganizationIdFkeyUsingPractitionerUserIdKeyUpdate>>;
};

/** A connection to a list of `Organization` values, with data from `Procedure`. */
export type PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `Procedure`, and the cursor to aid in pagination. */
  edges: Array<PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organization` edge in the connection, with data from `Procedure`. */
export type PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Organization` at the end of the edge. */
  node: Organization;
  /** Reads and enables pagination through a set of `Procedure`. */
  procedures: ProceduresConnection;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresList: Array<Procedure>;
};


/** A `Organization` edge in the connection, with data from `Procedure`. */
export type PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdManyToManyEdgeProceduresArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `Procedure`. */
export type PractitionerOrganizationsByProcedurePerformerIdAndOrganizationIdManyToManyEdgeProceduresListArgs = {
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};

/** Represents an update to a `Practitioner`. Fields that are set will be updated. */
export type PractitionerPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersPractitionerInverseInput>;
  motherTongue?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<PractitionerOrganizationIdFkeyInput>;
  proceduresUsingId?: InputMaybe<ProcedurePerformerIdFkeyInverseInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  /** Source-system practitioner short code. For Vivendi this maps to Mitarbeiter.Handzeichen / FHIR Practitioner.identifier system urn:vivendi:handzeichen. */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<PractitionerStatusEnum>;
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<PractitionerUserIdFkeyInput>;
};

/** The fields on `practitioner` to look up the row to connect. */
export type PractitionerPractitionerPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `practitioner` to look up the row to connect. */
export type PractitionerPractitionerUserIdKeyConnect = {
  userId: Scalars['UUID']['input'];
};

/** A connection to a list of `Location` values, with data from `LocationPractitioner`. */
export type PractitionerPractitionersManyToManyConnection = {
  __typename?: 'PractitionerPractitionersManyToManyConnection';
  /** A list of edges which contains the `Location`, info from the `LocationPractitioner`, and the cursor to aid in pagination. */
  edges: Array<PractitionerPractitionersManyToManyEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Location>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Location` edge in the connection, with data from `LocationPractitioner`. */
export type PractitionerPractitionersManyToManyEdge = {
  __typename?: 'PractitionerPractitionersManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Location` at the end of the edge. */
  node: Location;
};

export type PractitionerResponse = {
  __typename?: 'PractitionerResponse';
  id: Scalars['ID']['output'];
  warningCode?: Maybe<Scalars['String']['output']>;
};

export enum PractitionerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum PractitionerStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** The fields on `practitioner` to look up the row to connect. */
export type PractitionerUqPractitionerExternalIdConnect = {
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
};

/** Input for the nested mutation of `user` in the `PractitionerInput` mutation. */
export type PractitionerUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<PractitionerUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPractitionerForPractitionerUserIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<PractitionerOnPractitionerForPractitionerUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `practitioner` in the `UserInput` mutation. */
export type PractitionerUserIdFkeyInverseInput = {
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectById?: InputMaybe<PractitionerPractitionerPkeyConnect>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<PractitionerNodeIdConnect>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PractitionerUqPractitionerExternalIdConnect>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectByUserId?: InputMaybe<PractitionerPractitionerUserIdKeyConnect>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateById?: InputMaybe<PractitionerOnPractitionerForPractitionerUserIdFkeyUsingPractitionerPkeyUpdate>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserOnPractitionerForPractitionerUserIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PractitionerOnPractitionerForPractitionerUserIdFkeyUsingUqPractitionerExternalIdUpdate>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateByUserId?: InputMaybe<PractitionerOnPractitionerForPractitionerUserIdFkeyUsingPractitionerUserIdKeyUpdate>;
};

/** The `user` to be created by this mutation. */
export type PractitionerUserIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `Practitioner` values. */
export type PractitionersConnection = {
  __typename?: 'PractitionersConnection';
  /** A list of edges which contains the `Practitioner` and cursor to aid in pagination. */
  edges: Array<PractitionersEdge>;
  /** A list of `Practitioner` objects. */
  nodes: Array<Practitioner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Practitioner` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Practitioner` edge in the connection. */
export type PractitionersEdge = {
  __typename?: 'PractitionersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Practitioner` at the end of the edge. */
  node: Practitioner;
};

/** Methods to use when ordering `Practitioner`. */
export enum PractitionersOrderBy {
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceSystemAsc = 'SOURCE_SYSTEM_ASC',
  SourceSystemDesc = 'SOURCE_SYSTEM_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type Procedure = Node & {
  __typename?: 'Procedure';
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `Activity`. */
  activitiesByActivitySessionProcedureIdAndActivityId: ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Activity`. */
  activitiesByActivitySessionProcedureIdAndActivityIdList: Array<Activity>;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessions: ActivitySessionsConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsList: Array<ActivitySession>;
  categoryDisplay?: Maybe<Scalars['String']['output']>;
  categorySystem?: Maybe<Scalars['String']['output']>;
  categoryValue?: Maybe<Scalars['String']['output']>;
  codeDisplay?: Maybe<Scalars['String']['output']>;
  codeSystem?: Maybe<Scalars['String']['output']>;
  codeValue?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Detailed description or instructions for the procedure */
  description?: Maybe<Scalars['String']['output']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `DocumentationSync`. */
  documentationSyncs: DocumentationSyncsConnection;
  /** Reads and enables pagination through a set of `DocumentationSync`. */
  documentationSyncsList: Array<DocumentationSync>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: Maybe<Scalars['String']['output']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: Maybe<Scalars['BigFloat']['output']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: Maybe<Scalars['Int']['output']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Name of medication (for medication procedures) */
  medicationName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Note`. */
  notesByNoteProcedureProcedureIdAndNoteId: ProcedureNotesByNoteProcedureProcedureIdAndNoteIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Note`. */
  notesByNoteProcedureProcedureIdAndNoteIdList: Array<Note>;
  /** Reads a single `Organization` that is related to this `Procedure`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByProcedureParticipantProcedureIdAndPatientId: ProcedurePatientsByProcedureParticipantProcedureIdAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByProcedureParticipantProcedureIdAndPatientIdList: Array<Patient>;
  performedEnd?: Maybe<Scalars['Datetime']['output']>;
  performedStart?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Practitioner` that is related to this `Procedure`. */
  performer?: Maybe<Practitioner>;
  performerId?: Maybe<Scalars['UUID']['output']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: Maybe<Scalars['BigFloat']['output']>;
  plannedEnd?: Maybe<Scalars['Datetime']['output']>;
  plannedStart?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `NoteProcedure`. */
  procedureNotes: NoteProceduresConnection;
  /** Reads and enables pagination through a set of `NoteProcedure`. */
  procedureNotesList: Array<NoteProcedure>;
  /** Reads and enables pagination through a set of `ProcedureParticipant`. */
  procedureParticipants: ProcedureParticipantsConnection;
  /** Reads and enables pagination through a set of `ProcedureParticipant`. */
  procedureParticipantsList: Array<ProcedureParticipant>;
  recorderId?: Maybe<Scalars['UUID']['output']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: Maybe<Scalars['JSON']['output']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
  status: ProcedureStatusEnum;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `User`. */
  usersByActivitySessionProcedureIdAndCaregiverId: ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByActivitySessionProcedureIdAndCaregiverIdList: Array<User>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: Maybe<Scalars['String']['output']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: Maybe<Scalars['String']['output']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: Maybe<Scalars['BigFloat']['output']>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitiesOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdListArgs = {
  condition?: InputMaybe<ActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitiesOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureActivitySessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureActivitySessionsListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureDocumentationSyncsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DocumentationSyncCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentationSyncsOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureDocumentationSyncsListArgs = {
  condition?: InputMaybe<DocumentationSyncCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentationSyncsOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureNotesByNoteProcedureProcedureIdAndNoteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureNotesByNoteProcedureProcedureIdAndNoteIdListArgs = {
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedurePatientsByProcedureParticipantProcedureIdAndPatientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedurePatientsByProcedureParticipantProcedureIdAndPatientIdListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureProcedureNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NoteProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NoteProceduresOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureProcedureNotesListArgs = {
  condition?: InputMaybe<NoteProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NoteProceduresOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureProcedureParticipantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProcedureParticipantsOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureProcedureParticipantsListArgs = {
  condition?: InputMaybe<ProcedureParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProcedureParticipantsOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** Generic FHIR Procedure resource supporting multiple source systems (Senso, Vivendi, etc.) */
export type ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A connection to a list of `Activity` values, with data from `ActivitySession`. */
export type ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdManyToManyConnection = {
  __typename?: 'ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdManyToManyConnection';
  /** A list of edges which contains the `Activity`, info from the `ActivitySession`, and the cursor to aid in pagination. */
  edges: Array<ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdManyToManyEdge>;
  /** A list of `Activity` objects. */
  nodes: Array<Activity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Activity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Activity` edge in the connection, with data from `ActivitySession`. */
export type ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdManyToManyEdge = {
  __typename?: 'ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessions: ActivitySessionsConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsList: Array<ActivitySession>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Activity` at the end of the edge. */
  node: Activity;
};


/** A `Activity` edge in the connection, with data from `ActivitySession`. */
export type ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdManyToManyEdgeActivitySessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** A `Activity` edge in the connection, with data from `ActivitySession`. */
export type ProcedureActivitiesByActivitySessionProcedureIdAndActivityIdManyToManyEdgeActivitySessionsListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};

/** The fields on `procedure` to look up the row to connect. */
export type ProcedureChkProcedureExternalIdSourceConnect = {
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

/** The fields on `procedure` to look up the row to delete. */
export type ProcedureChkProcedureExternalIdSourceDelete = {
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

/**
 * A condition to be used against `Procedure` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProcedureCondition = {
  /** Checks for equality with the object’s `acknowledgedAt` field. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Only procedures in which the given patient participates */
  patientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `performedStart` field. */
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `performerId` field. */
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `plannedStart` field. */
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sourceData` field. */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `sourceSystem` field. */
  sourceSystem?: InputMaybe<DataSource>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ProcedureStatusEnum>;
};

export enum ProcedureDocumentationNoteKind {
  ManualNote = 'MANUAL_NOTE',
  Observation = 'OBSERVATION'
}

export enum ProcedureExecutionEndIntent {
  Cancel = 'CANCEL',
  End = 'END'
}

export enum ProcedureExecutionEndStatus {
  Completed = 'COMPLETED',
  Stopped = 'STOPPED'
}

/** An input for mutations affecting `Procedure` */
export type ProcedureInput = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

export enum ProcedureLifecycleAction {
  CompleteProcedure = 'COMPLETE_PROCEDURE',
  StartProcedure = 'START_PROCEDURE',
  StopProcedure = 'STOP_PROCEDURE'
}

/** The globally unique `ID` look up for the row to connect. */
export type ProcedureNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `procedure` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProcedureNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `procedure` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** A connection to a list of `Note` values, with data from `NoteProcedure`. */
export type ProcedureNotesByNoteProcedureProcedureIdAndNoteIdManyToManyConnection = {
  __typename?: 'ProcedureNotesByNoteProcedureProcedureIdAndNoteIdManyToManyConnection';
  /** A list of edges which contains the `Note`, info from the `NoteProcedure`, and the cursor to aid in pagination. */
  edges: Array<ProcedureNotesByNoteProcedureProcedureIdAndNoteIdManyToManyEdge>;
  /** A list of `Note` objects. */
  nodes: Array<Note>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Note` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Note` edge in the connection, with data from `NoteProcedure`. */
export type ProcedureNotesByNoteProcedureProcedureIdAndNoteIdManyToManyEdge = {
  __typename?: 'ProcedureNotesByNoteProcedureProcedureIdAndNoteIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Explicit inclusion of this senior's manual note in procedure documentation. */
  includeInDocumentation: Scalars['Boolean']['output'];
  /** Marks the single procedure-level manual documentation note. */
  isDocumentationManualNote: Scalars['Boolean']['output'];
  /** The `Note` at the end of the edge. */
  node: Note;
};

/** The globally unique `ID` look up for the row to update. */
export type ProcedureOnActivitySessionForActivitySessionProcedureIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activitySession` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: ActivitySessionPatch;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnActivitySessionForActivitySessionProcedureIdFkeyUsingChkProcedureExternalIdSourceUpdate = {
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnActivitySessionForActivitySessionProcedureIdFkeyPatch;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnActivitySessionForActivitySessionProcedureIdFkeyUsingProcedurePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnActivitySessionForActivitySessionProcedureIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProcedureOnDocumentationSyncForDocumentationSyncProcedureIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `documentationSync` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `documentationSync` being updated. */
  patch: DocumentationSyncPatch;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnDocumentationSyncForDocumentationSyncProcedureIdFkeyUsingChkProcedureExternalIdSourceUpdate = {
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnDocumentationSyncForDocumentationSyncProcedureIdFkeyPatch;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnDocumentationSyncForDocumentationSyncProcedureIdFkeyUsingProcedurePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnDocumentationSyncForDocumentationSyncProcedureIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `noteProcedure` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `noteProcedure` being updated. */
  patch: NoteProcedurePatch;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyUsingChkProcedureExternalIdSourceUpdate = {
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyPatch;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyUsingProcedurePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProcedureOnProcedureForProcedureOrganizationIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organization` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organization` being updated. */
  patch: OrganizationPatch;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnProcedureForProcedureOrganizationIdFkeyUsingChkProcedureExternalIdSourceUpdate = {
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnProcedureForProcedureOrganizationIdFkeyPatch;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnProcedureForProcedureOrganizationIdFkeyUsingProcedurePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnProcedureForProcedureOrganizationIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProcedureOnProcedureForProcedurePerformerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `practitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: PractitionerPatch;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnProcedureForProcedurePerformerIdFkeyUsingChkProcedureExternalIdSourceUpdate = {
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnProcedureForProcedurePerformerIdFkeyPatch;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnProcedureForProcedurePerformerIdFkeyUsingProcedurePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnProcedureForProcedurePerformerIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type ProcedureOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `procedureParticipant` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `procedureParticipant` being updated. */
  patch: ProcedureParticipantPatch;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyUsingChkProcedureExternalIdSourceUpdate = {
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyPatch;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

/** The fields on `procedure` to look up the row to update. */
export type ProcedureOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyUsingProcedurePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: UpdateProcedureOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyPatch;
};

/** Input for the nested mutation of `organization` in the `ProcedureInput` mutation. */
export type ProcedureOrganizationIdFkeyInput = {
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByExternalId?: InputMaybe<OrganizationOrganizationExternalIdKeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectById?: InputMaybe<OrganizationOrganizationPkeyConnect>;
  /** The primary key(s) for `organization` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OrganizationNodeIdConnect>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByExternalId?: InputMaybe<OrganizationOnProcedureForProcedureOrganizationIdFkeyUsingOrganizationExternalIdKeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateById?: InputMaybe<OrganizationOnProcedureForProcedureOrganizationIdFkeyUsingOrganizationPkeyUpdate>;
  /** The primary key(s) and patch data for `organization` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProcedureOnProcedureForProcedureOrganizationIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `procedure` in the `OrganizationInput` mutation. */
export type ProcedureOrganizationIdFkeyInverseInput = {
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProcedureProcedurePkeyConnect>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProcedureNodeIdConnect>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<ProcedureChkProcedureExternalIdSourceConnect>>;
  /** A `ProcedureInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcedureOrganizationIdFkeyProcedureCreateInput>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProcedureProcedurePkeyDelete>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProcedureNodeIdDelete>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<ProcedureChkProcedureExternalIdSourceDelete>>;
  /** Flag indicating whether all other `procedure` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProcedureOnProcedureForProcedureOrganizationIdFkeyUsingProcedurePkeyUpdate>>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OrganizationOnProcedureForProcedureOrganizationIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<ProcedureOnProcedureForProcedureOrganizationIdFkeyUsingChkProcedureExternalIdSourceUpdate>>;
};

/** The `procedure` to be created by this mutation. */
export type ProcedureOrganizationIdFkeyProcedureCreateInput = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Many-to-many relationship between procedures and participating patients. Used for group activities where multiple patients participate in the same procedure (e.g., group therapy, activity sessions). */
export type ProcedureParticipant = Node & {
  __typename?: 'ProcedureParticipant';
  createdAt: Scalars['Datetime']['output'];
  /** Publication time from this participant's finalized procedure note. NULL means not filed. */
  documentationPublishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Patient` that is related to this `ProcedureParticipant`. */
  patient?: Maybe<Patient>;
  /** Reference to a participating patient */
  patientId: Scalars['UUID']['output'];
  /** Reads a single `Procedure` that is related to this `ProcedureParticipant`. */
  procedure?: Maybe<Procedure>;
  /** Reference to the procedure */
  procedureId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `ProcedureParticipant` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProcedureParticipantCondition = {
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `procedureId` field. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `ProcedureParticipant` */
export type ProcedureParticipantInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Reference to a participating patient */
  patientId?: InputMaybe<Scalars['UUID']['input']>;
  patientToPatientId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInput>;
  /** Reference to the procedure */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ProcedureParticipantNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `procedureParticipant` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ProcedureParticipantNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `procedureParticipant` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ProcedureParticipantOnProcedureParticipantForProcedureParticipantsPatientIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `patient` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: PatientPatch;
};

/** The fields on `procedureParticipant` to look up the row to update. */
export type ProcedureParticipantOnProcedureParticipantForProcedureParticipantsPatientIdFkeyUsingProcedureParticipantsPkeyUpdate = {
  /** An object where the defined keys will be set on the `procedureParticipant` being updated. */
  patch: UpdateProcedureParticipantOnProcedureParticipantForProcedureParticipantsPatientIdFkeyPatch;
  /** Reference to a participating patient */
  patientId: Scalars['UUID']['input'];
  /** Reference to the procedure */
  procedureId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type ProcedureParticipantOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `procedure` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `procedure` being updated. */
  patch: ProcedurePatch;
};

/** The fields on `procedureParticipant` to look up the row to update. */
export type ProcedureParticipantOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyUsingProcedureParticipantsPkeyUpdate = {
  /** An object where the defined keys will be set on the `procedureParticipant` being updated. */
  patch: UpdateProcedureParticipantOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyPatch;
  /** Reference to a participating patient */
  patientId: Scalars['UUID']['input'];
  /** Reference to the procedure */
  procedureId: Scalars['UUID']['input'];
};

/** Represents an update to a `ProcedureParticipant`. Fields that are set will be updated. */
export type ProcedureParticipantPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Reference to a participating patient */
  patientId?: InputMaybe<Scalars['UUID']['input']>;
  patientToPatientId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInput>;
  /** Reference to the procedure */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInput>;
};

/** The fields on `procedureParticipant` to look up the row to connect. */
export type ProcedureParticipantProcedureParticipantsPkeyConnect = {
  /** Reference to a participating patient */
  patientId: Scalars['UUID']['input'];
  /** Reference to the procedure */
  procedureId: Scalars['UUID']['input'];
};

/** The fields on `procedureParticipant` to look up the row to delete. */
export type ProcedureParticipantProcedureParticipantsPkeyDelete = {
  /** Reference to a participating patient */
  patientId: Scalars['UUID']['input'];
  /** Reference to the procedure */
  procedureId: Scalars['UUID']['input'];
};

/** A connection to a list of `ProcedureParticipant` values. */
export type ProcedureParticipantsConnection = {
  __typename?: 'ProcedureParticipantsConnection';
  /** A list of edges which contains the `ProcedureParticipant` and cursor to aid in pagination. */
  edges: Array<ProcedureParticipantsEdge>;
  /** A list of `ProcedureParticipant` objects. */
  nodes: Array<ProcedureParticipant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcedureParticipant` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ProcedureParticipant` edge in the connection. */
export type ProcedureParticipantsEdge = {
  __typename?: 'ProcedureParticipantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ProcedureParticipant` at the end of the edge. */
  node: ProcedureParticipant;
};

/** Methods to use when ordering `ProcedureParticipant`. */
export enum ProcedureParticipantsOrderBy {
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcedureIdAsc = 'PROCEDURE_ID_ASC',
  ProcedureIdDesc = 'PROCEDURE_ID_DESC'
}

/** Input for the nested mutation of `patient` in the `ProcedureParticipantInput` mutation. */
export type ProcedureParticipantsPatientIdFkeyInput = {
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectById?: InputMaybe<PatientPkFhirPatientConnect>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<PatientNodeIdConnect>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PatientUqPatientExternalIdConnect>;
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByUserId?: InputMaybe<PatientUqPatientUserIdConnect>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateById?: InputMaybe<PatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyUsingPkFhirPatientUpdate>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProcedureParticipantOnProcedureParticipantForProcedureParticipantsPatientIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyUsingUqPatientExternalIdUpdate>;
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByUserId?: InputMaybe<PatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyUsingUqPatientUserIdUpdate>;
};

/** Input for the nested mutation of `procedureParticipant` in the `PatientInput` mutation. */
export type ProcedureParticipantsPatientIdFkeyInverseInput = {
  /** The primary key(s) for `procedureParticipant` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProcedureParticipantNodeIdConnect>>;
  /** The primary key(s) for `procedureParticipant` for the far side of the relationship. */
  connectByProcedureIdAndPatientId?: InputMaybe<Array<ProcedureParticipantProcedureParticipantsPkeyConnect>>;
  /** A `ProcedureParticipantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcedureParticipantsPatientIdFkeyProcedureParticipantsCreateInput>>;
  /** The primary key(s) for `procedureParticipant` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProcedureParticipantNodeIdDelete>>;
  /** The primary key(s) for `procedureParticipant` for the far side of the relationship. */
  deleteByProcedureIdAndPatientId?: InputMaybe<Array<ProcedureParticipantProcedureParticipantsPkeyDelete>>;
  /** Flag indicating whether all other `procedureParticipant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `procedureParticipant` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<PatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `procedureParticipant` for the far side of the relationship. */
  updateByProcedureIdAndPatientId?: InputMaybe<Array<ProcedureParticipantOnProcedureParticipantForProcedureParticipantsPatientIdFkeyUsingProcedureParticipantsPkeyUpdate>>;
};

/** The `procedureParticipant` to be created by this mutation. */
export type ProcedureParticipantsPatientIdFkeyProcedureParticipantsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  patientToPatientId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInput>;
  /** Reference to the procedure */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInput>;
};

/** Input for the nested mutation of `procedure` in the `ProcedureParticipantInput` mutation. */
export type ProcedureParticipantsProcedureIdFkeyInput = {
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectById?: InputMaybe<ProcedureProcedurePkeyConnect>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ProcedureNodeIdConnect>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureChkProcedureExternalIdSourceConnect>;
  /** A `ProcedureInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProcedureParticipantsProcedureIdFkeyProcedureCreateInput>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteById?: InputMaybe<ProcedureProcedurePkeyDelete>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<ProcedureNodeIdDelete>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureChkProcedureExternalIdSourceDelete>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateById?: InputMaybe<ProcedureOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyUsingProcedurePkeyUpdate>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProcedureParticipantOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<ProcedureOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyUsingChkProcedureExternalIdSourceUpdate>;
};

/** Input for the nested mutation of `procedureParticipant` in the `ProcedureInput` mutation. */
export type ProcedureParticipantsProcedureIdFkeyInverseInput = {
  /** The primary key(s) for `procedureParticipant` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProcedureParticipantNodeIdConnect>>;
  /** The primary key(s) for `procedureParticipant` for the far side of the relationship. */
  connectByProcedureIdAndPatientId?: InputMaybe<Array<ProcedureParticipantProcedureParticipantsPkeyConnect>>;
  /** A `ProcedureParticipantInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcedureParticipantsProcedureIdFkeyProcedureParticipantsCreateInput>>;
  /** The primary key(s) for `procedureParticipant` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProcedureParticipantNodeIdDelete>>;
  /** The primary key(s) for `procedureParticipant` for the far side of the relationship. */
  deleteByProcedureIdAndPatientId?: InputMaybe<Array<ProcedureParticipantProcedureParticipantsPkeyDelete>>;
  /** Flag indicating whether all other `procedureParticipant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `procedureParticipant` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ProcedureOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `procedureParticipant` for the far side of the relationship. */
  updateByProcedureIdAndPatientId?: InputMaybe<Array<ProcedureParticipantOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyUsingProcedureParticipantsPkeyUpdate>>;
};

/** The `procedure` to be created by this mutation. */
export type ProcedureParticipantsProcedureIdFkeyProcedureCreateInput = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** The `procedureParticipant` to be created by this mutation. */
export type ProcedureParticipantsProcedureIdFkeyProcedureParticipantsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Reference to a participating patient */
  patientId?: InputMaybe<Scalars['UUID']['input']>;
  patientToPatientId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInput>;
  procedureToProcedureId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInput>;
};

/** Represents an update to a `Procedure`. Fields that are set will be updated. */
export type ProcedurePatch = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `Patient` values, with data from `ProcedureParticipant`. */
export type ProcedurePatientsByProcedureParticipantProcedureIdAndPatientIdManyToManyConnection = {
  __typename?: 'ProcedurePatientsByProcedureParticipantProcedureIdAndPatientIdManyToManyConnection';
  /** A list of edges which contains the `Patient`, info from the `ProcedureParticipant`, and the cursor to aid in pagination. */
  edges: Array<ProcedurePatientsByProcedureParticipantProcedureIdAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Patient` edge in the connection, with data from `ProcedureParticipant`. */
export type ProcedurePatientsByProcedureParticipantProcedureIdAndPatientIdManyToManyEdge = {
  __typename?: 'ProcedurePatientsByProcedureParticipantProcedureIdAndPatientIdManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};

/** Input for the nested mutation of `practitioner` in the `ProcedureInput` mutation. */
export type ProcedurePerformerIdFkeyInput = {
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectById?: InputMaybe<PractitionerPractitionerPkeyConnect>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<PractitionerNodeIdConnect>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PractitionerUqPractitionerExternalIdConnect>;
  /** The primary key(s) for `practitioner` for the far side of the relationship. */
  connectByUserId?: InputMaybe<PractitionerPractitionerUserIdKeyConnect>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateById?: InputMaybe<PractitionerOnProcedureForProcedurePerformerIdFkeyUsingPractitionerPkeyUpdate>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ProcedureOnProcedureForProcedurePerformerIdFkeyNodeIdUpdate>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<PractitionerOnProcedureForProcedurePerformerIdFkeyUsingUqPractitionerExternalIdUpdate>;
  /** The primary key(s) and patch data for `practitioner` for the far side of the relationship. */
  updateByUserId?: InputMaybe<PractitionerOnProcedureForProcedurePerformerIdFkeyUsingPractitionerUserIdKeyUpdate>;
};

/** Input for the nested mutation of `procedure` in the `PractitionerInput` mutation. */
export type ProcedurePerformerIdFkeyInverseInput = {
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProcedureProcedurePkeyConnect>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ProcedureNodeIdConnect>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  connectBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<ProcedureChkProcedureExternalIdSourceConnect>>;
  /** A `ProcedureInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcedurePerformerIdFkeyProcedureCreateInput>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProcedureProcedurePkeyDelete>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ProcedureNodeIdDelete>>;
  /** The primary key(s) for `procedure` for the far side of the relationship. */
  deleteBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<ProcedureChkProcedureExternalIdSourceDelete>>;
  /** Flag indicating whether all other `procedure` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProcedureOnProcedureForProcedurePerformerIdFkeyUsingProcedurePkeyUpdate>>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<PractitionerOnProcedureForProcedurePerformerIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `procedure` for the far side of the relationship. */
  updateBySourceSystemAndExternalIdAndOrganizationId?: InputMaybe<Array<ProcedureOnProcedureForProcedurePerformerIdFkeyUsingChkProcedureExternalIdSourceUpdate>>;
};

/** The `procedure` to be created by this mutation. */
export type ProcedurePerformerIdFkeyProcedureCreateInput = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** The fields on `procedure` to look up the row to connect. */
export type ProcedureProcedurePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `procedure` to look up the row to delete. */
export type ProcedureProcedurePkeyDelete = {
  id: Scalars['UUID']['input'];
};

export type ProcedureRecommendationsResult = {
  __typename?: 'ProcedureRecommendationsResult';
  activities: Array<RecommendedActivity>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type ProcedureResponse = {
  __typename?: 'ProcedureResponse';
  id: Scalars['ID']['output'];
};

export type ProcedureSearchInput = {
  endDate: Scalars['Datetime']['input'];
  startDate: Scalars['Datetime']['input'];
};

export enum ProcedureStatusEnum {
  Completed = 'COMPLETED',
  EnteredInError = 'ENTERED_IN_ERROR',
  InProgress = 'IN_PROGRESS',
  NotDone = 'NOT_DONE',
  OnHold = 'ON_HOLD',
  Preparation = 'PREPARATION',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

/** A connection to a list of `User` values, with data from `ActivitySession`. */
export type ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdManyToManyConnection = {
  __typename?: 'ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `ActivitySession`, and the cursor to aid in pagination. */
  edges: Array<ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `ActivitySession`. */
export type ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdManyToManyEdge = {
  __typename?: 'ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsByCaregiverId: ActivitySessionsConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsByCaregiverIdList: Array<ActivitySession>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};


/** A `User` edge in the connection, with data from `ActivitySession`. */
export type ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdManyToManyEdgeActivitySessionsByCaregiverIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** A `User` edge in the connection, with data from `ActivitySession`. */
export type ProcedureUsersByActivitySessionProcedureIdAndCaregiverIdManyToManyEdgeActivitySessionsByCaregiverIdListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};

/** A connection to a list of `Procedure` values. */
export type ProceduresConnection = {
  __typename?: 'ProceduresConnection';
  /** A list of edges which contains the `Procedure` and cursor to aid in pagination. */
  edges: Array<ProceduresEdge>;
  /** A list of `Procedure` objects. */
  nodes: Array<Procedure>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Procedure` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Procedure` edge in the connection. */
export type ProceduresEdge = {
  __typename?: 'ProceduresEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Procedure` at the end of the edge. */
  node: Procedure;
};

export type ProceduresInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  patientId?: InputMaybe<Scalars['UUID']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  plannedEndFrom?: InputMaybe<Scalars['Datetime']['input']>;
  plannedEndTo?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStartFrom?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStartTo?: InputMaybe<Scalars['Datetime']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Methods to use when ordering `Procedure`. */
export enum ProceduresOrderBy {
  AcknowledgedAtAsc = 'ACKNOWLEDGED_AT_ASC',
  AcknowledgedAtDesc = 'ACKNOWLEDGED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PerformedStartAsc = 'PERFORMED_START_ASC',
  PerformedStartDesc = 'PERFORMED_START_DESC',
  PerformerIdAsc = 'PERFORMER_ID_ASC',
  PerformerIdDesc = 'PERFORMER_ID_DESC',
  PlannedStartAsc = 'PLANNED_START_ASC',
  PlannedStartAscNullsLast = 'PLANNED_START_ASC_NULLS_LAST',
  PlannedStartDesc = 'PLANNED_START_DESC',
  PlannedStartDescNullsLast = 'PLANNED_START_DESC_NULLS_LAST',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceDataAsc = 'SOURCE_DATA_ASC',
  SourceDataDesc = 'SOURCE_DATA_DESC',
  SourceSystemAsc = 'SOURCE_SYSTEM_ASC',
  SourceSystemDesc = 'SOURCE_SYSTEM_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export type ProgrammeProcedureActivityInput = {
  contentId: Scalars['UUID']['input'];
  positionInProcedure: Scalars['Int']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type ProviderCallList = {
  __typename?: 'ProviderCallList';
  /** Pass as after to get the next page; null on the last page. */
  endCursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  rows: Array<ProviderCallRow>;
  /** All calls of the filter and range, not only this page. */
  totalCount: Scalars['Int']['output'];
};

export type ProviderCallRow = {
  __typename?: 'ProviderCallRow';
  /** The agent who answered or placed the call, named as in the KPI agent table; null when nobody answered or the agent has not connected the portal phone. */
  agentName?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  /** inbound, outbound or internal. */
  direction: Scalars['String']['output'];
  handleSeconds?: Maybe<Scalars['Int']['output']>;
  /** The provider's correlation id of the call. */
  id: Scalars['String']['output'];
  /** Inbound: answered, missed (an agent was rung), abandoned (queued, no agent rung) or not_routed. Outbound: answered or not_answered. */
  outcome?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['Datetime']['output'];
  waitSeconds?: Maybe<Scalars['Int']['output']>;
  withinOpeningHours: Scalars['Boolean']['output'];
};

export type PublishActivityDocumentationInput = {
  /** The participant whose document is filed. Documentation is always per resident. */
  seniorId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type PublishActivityDocumentationPayload = {
  __typename?: 'PublishActivityDocumentationPayload';
  noteIds: Array<Scalars['UUID']['output']>;
  publishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Set once every participant's document is filed and the session is closed. */
  sessionPublishedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type PublishProcedureDocumentationInput = {
  procedureId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};

export type PublishProcedureDocumentationPayload = {
  __typename?: 'PublishProcedureDocumentationPayload';
  acknowledgedAt?: Maybe<Scalars['Datetime']['output']>;
  authorId?: Maybe<Scalars['UUID']['output']>;
  documentText?: Maybe<Scalars['String']['output']>;
  noteIds: Array<Scalars['UUID']['output']>;
  publishedAt?: Maybe<Scalars['Datetime']['output']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads and enables pagination through a set of `Activity`. */
  activities?: Maybe<ActivitiesConnection>;
  /** Reads a set of `Activity`. */
  activitiesList?: Maybe<Array<Activity>>;
  activity?: Maybe<Activity>;
  /** Reads a single `Activity` using its globally unique `ID`. */
  activityByNodeId?: Maybe<Activity>;
  activityGoal?: Maybe<ActivityGoal>;
  /** Reads a single `ActivityGoal` using its globally unique `ID`. */
  activityGoalByNodeId?: Maybe<ActivityGoal>;
  activityGoalByUserIdAndKind?: Maybe<ActivityGoal>;
  activityGoalProgress: Array<ActivityGoalProgress>;
  /** Reads and enables pagination through a set of `ActivityGoal`. */
  activityGoals?: Maybe<ActivityGoalsConnection>;
  /** Reads a set of `ActivityGoal`. */
  activityGoalsList?: Maybe<Array<ActivityGoal>>;
  activityParticipant?: Maybe<ActivityParticipant>;
  activityParticipantByActivitySessionIdAndSeniorId?: Maybe<ActivityParticipant>;
  /** Reads a single `ActivityParticipant` using its globally unique `ID`. */
  activityParticipantByNodeId?: Maybe<ActivityParticipant>;
  /** Reads and enables pagination through a set of `ActivityParticipant`. */
  activityParticipants?: Maybe<ActivityParticipantsConnection>;
  /** Reads a set of `ActivityParticipant`. */
  activityParticipantsList?: Maybe<Array<ActivityParticipant>>;
  activityRecommendations: Array<ActivityRecommendation>;
  activitySession?: Maybe<ActivitySession>;
  /** Reads a single `ActivitySession` using its globally unique `ID`. */
  activitySessionByNodeId?: Maybe<ActivitySession>;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessions?: Maybe<ActivitySessionsConnection>;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsList?: Maybe<Array<ActivitySession>>;
  adminMfaSettings: AdminMfaSettings;
  albumMedia?: Maybe<AlbumMedia>;
  albumMediaByMediaIdAndAlbumId?: Maybe<AlbumMedia>;
  /** Reads a single `AlbumMedia` using its globally unique `ID`. */
  albumMediaByNodeId?: Maybe<AlbumMedia>;
  appSetting?: Maybe<AppSetting>;
  /** Reads a single `AppSetting` using its globally unique `ID`. */
  appSettingByNodeId?: Maybe<AppSetting>;
  appSettingByUserIdAndSettingType?: Maybe<AppSetting>;
  /** Reads and enables pagination through a set of `AppSetting`. */
  appSettings?: Maybe<AppSettingsConnection>;
  /** Reads a set of `AppSetting`. */
  appSettingsList?: Maybe<Array<AppSetting>>;
  attachment?: Maybe<Attachment>;
  /** Reads a single `Attachment` using its globally unique `ID`. */
  attachmentByNodeId?: Maybe<Attachment>;
  /** Reads and enables pagination through a set of `Attachment`. */
  attachments?: Maybe<AttachmentsConnection>;
  /** Reads a set of `Attachment`. */
  attachmentsList?: Maybe<Array<Attachment>>;
  /** Salesforce accounts matched with Billwerk customers by Debitoren-Id, 50 rows per page. Reads the Billwerk list live, in the background: while it is LOADING ask again. Needs billing.read. */
  billwerkCustomerMatch: BillwerkCustomerMatch;
  /** The Billwerk plan variants of the Salesforce price book entries, and the billing-relevant contract items whose plan variant does not resolve, 50 rows per page. Read-only. Needs billing.read. */
  billwerkPlanVariants: BillwerkPlanVariants;
  caregiverDevicePractitionerAuthStatus: CaregiverPractitionerAuthStatus;
  caregiverDevicePractitioners: Array<CaregiverDevicePractitioner>;
  caregiverProcedures: Array<Procedure>;
  caregiverProfile?: Maybe<CaregiverProfile>;
  /** Reads a single `CaregiverProfile` using its globally unique `ID`. */
  caregiverProfileByNodeId?: Maybe<CaregiverProfile>;
  caregiverSenior?: Maybe<CaregiverSenior>;
  /** Reads a single `CaregiverSenior` using its globally unique `ID`. */
  caregiverSeniorByNodeId?: Maybe<CaregiverSenior>;
  /** Reads and enables pagination through a set of `CaregiverSenior`. */
  caregiverSeniors?: Maybe<CaregiverSeniorsConnection>;
  /** Reads a set of `CaregiverSenior`. */
  caregiverSeniorsList?: Maybe<Array<CaregiverSenior>>;
  checkHealth?: Maybe<Scalars['Boolean']['output']>;
  checkIn?: Maybe<CheckIn>;
  /** Reads a single `CheckIn` using its globally unique `ID`. */
  checkInByNodeId?: Maybe<CheckIn>;
  checkInMessage?: Maybe<CheckInMessage>;
  /** Reads a single `CheckInMessage` using its globally unique `ID`. */
  checkInMessageByNodeId?: Maybe<CheckInMessage>;
  /** Reads and enables pagination through a set of `CheckInMessage`. */
  checkInMessages?: Maybe<CheckInMessagesConnection>;
  /** Reads a set of `CheckInMessage`. */
  checkInMessagesList?: Maybe<Array<CheckInMessage>>;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkIns?: Maybe<CheckInsConnection>;
  /** Reads a set of `CheckIn`. */
  checkInsList?: Maybe<Array<CheckIn>>;
  chromeverToInt?: Maybe<Scalars['BigInt']['output']>;
  /** Returns the members of every family chat the current user is member of */
  contacts?: Maybe<UsersConnection>;
  /** Returns the members of every family chat the current user is member of */
  contactsList?: Maybe<Array<User>>;
  content?: Maybe<Content>;
  /** Reads and enables pagination through a set of `ContentActivity`. */
  contentActivities?: Maybe<ContentActivitiesConnection>;
  /** Reads a set of `ContentActivity`. */
  contentActivitiesList?: Maybe<Array<ContentActivity>>;
  contentActivity?: Maybe<ContentActivity>;
  contentActivityByContentId?: Maybe<ContentActivity>;
  /** Reads a single `ContentActivity` using its globally unique `ID`. */
  contentActivityByNodeId?: Maybe<ContentActivity>;
  /**
   * Recorded completed plus unfinished sessions over inclusive UTC dates for
   * relevant analytics apps and titled catalogue entries, including removed or
   * unpublished content. Rankings aggregate the full period before pagination.
   */
  contentAnalyticsReport: ContentAnalyticsReport;
  contentByCmsContentIdAndCmsContentKind?: Maybe<Content>;
  contentByCmsNextContentIdAndCmsNextContentKind?: Maybe<Content>;
  /** Reads a single `Content` using its globally unique `ID`. */
  contentByNodeId?: Maybe<Content>;
  contentMetaTag?: Maybe<ContentMetaTag>;
  contentMetaTagByContentIdAndMetaTagId?: Maybe<ContentMetaTag>;
  /** Reads a single `ContentMetaTag` using its globally unique `ID`. */
  contentMetaTagByNodeId?: Maybe<ContentMetaTag>;
  /** Reads and enables pagination through a set of `ContentMetaTag`. */
  contentMetaTags?: Maybe<ContentMetaTagsConnection>;
  /** Reads a set of `ContentMetaTag`. */
  contentMetaTagsList?: Maybe<Array<ContentMetaTag>>;
  /** Reads and enables pagination through a set of `ContentUsageDaily`. */
  contentUsageDailies?: Maybe<ContentUsageDailiesConnection>;
  /** Reads a set of `ContentUsageDaily`. */
  contentUsageDailiesList?: Maybe<Array<ContentUsageDaily>>;
  contentUsageDaily?: Maybe<ContentUsageDaily>;
  /** Reads a single `ContentUsageDaily` using its globally unique `ID`. */
  contentUsageDailyByNodeId?: Maybe<ContentUsageDaily>;
  currentUserId?: Maybe<Scalars['UUID']['output']>;
  /** Permissions of the signed-in user's staff roles, such as crm.read. */
  currentUserPermissions: Array<Scalars['String']['output']>;
  currentWeather?: Maybe<WeatherObservation>;
  /** Reads and enables pagination through a set of `CustomActivity`. */
  customActivities?: Maybe<CustomActivitiesConnection>;
  /** Reads a set of `CustomActivity`. */
  customActivitiesList?: Maybe<Array<CustomActivity>>;
  customActivity?: Maybe<CustomActivity>;
  customActivityByName?: Maybe<CustomActivity>;
  /** Reads a single `CustomActivity` using its globally unique `ID`. */
  customActivityByNodeId?: Maybe<CustomActivity>;
  customerServiceAccountBilling: CrmAccountBilling;
  customerServiceAccountLicences: CustomerServiceAccountLicences;
  customerServiceAccountManagers: CustomerServiceAccountManagers;
  customerServiceBillingCustomer?: Maybe<BillingCustomer>;
  customerServiceBillingSalesforceAccounts: Array<BillingSalesforceAccount>;
  /** The hotline's call counts from the stored provider call history; null while the Placetel integration is missing or switched off. Needs telephony.use. */
  customerServiceCallKpis?: Maybe<CallKpis>;
  customerServiceCrmDuplicates: CrmDuplicateList;
  customerServiceCrmList: CrmList;
  customerServiceCrmOverview: CrmServiceOverview;
  /** CRM records whose phone number matches a caller's number: contacts, unconverted leads and accounts. National numbers without a country code count as German. At most ten records per object, contacts first. A single matching contact hides its own account. */
  customerServiceCrmPhoneMatches: Array<CrmSearchHit>;
  customerServiceCrmRecord?: Maybe<CrmRecord>;
  customerServiceCrmSearch: Array<CrmSearchHit>;
  /** Emails, calls, comments and case events of an account, contact, lead or case, newest first. A lead's timeline holds only its calls. Calls and their notes appear only for staff who may phone (telephony.use). */
  customerServiceCrmTimeline: Array<CrmTimelineEntry>;
  customerServiceLearningCatalog: LearningCatalog;
  customerServiceLearningOrganizations: Array<LearningOrganization>;
  customerServiceOrganizationAccounts: Array<CustomerServiceOrganizationAccount>;
  customerServiceOrganizationBillingAccess: Array<OrganizationBillingAccess>;
  /** The calls behind a KPI tile, newest first, a page at a time; null while the Placetel integration is missing or switched off. agentKey narrows the list to that agent's answered inbound or outbound calls. Needs telephony.use. */
  customerServiceProviderCalls?: Maybe<ProviderCallList>;
  /** Contracts the MRR and item-count charts of one record type are computed from. */
  customerServiceSalesforceContracts: SalesforceContractRecordList;
  customerServiceSalesforceDashboard: SalesforceDashboard;
  customerServiceSalesforceRecords: SalesforceSubscriptionRecordList;
  /** Reads and enables pagination through a set of `Daily`. */
  dailies?: Maybe<DailiesConnection>;
  /** Reads a set of `Daily`. */
  dailiesList?: Maybe<Array<Daily>>;
  daily?: Maybe<Daily>;
  /** Reads a single `Daily` using its globally unique `ID`. */
  dailyByNodeId?: Maybe<Daily>;
  /** Dashboard patients scoped to an authorized organization and optional location subtree. */
  dashboardPatients?: Maybe<PatientsConnection>;
  /** Dashboard patients scoped to an authorized organization and optional location subtree. */
  dashboardPatientsList?: Maybe<Array<Patient>>;
  /** Dashboard practitioners scoped to direct or immediate-child assignments. */
  dashboardPractitioners?: Maybe<PractitionersConnection>;
  /** Dashboard practitioners scoped to direct or immediate-child assignments. */
  dashboardPractitionersList?: Maybe<Array<Practitioner>>;
  device?: Maybe<Device>;
  /** Reads a single `Device` using its globally unique `ID`. */
  deviceByNodeId?: Maybe<Device>;
  deviceEnrollmentToken?: Maybe<DeviceEnrollmentToken>;
  deviceEnrollmentTokens: Array<DeviceEnrollmentToken>;
  /** Reads and enables pagination through a set of `Device`. */
  devices?: Maybe<DevicesConnection>;
  /** Reads a set of `Device`. */
  devicesList?: Maybe<Array<Device>>;
  distribution?: Maybe<Distribution>;
  /** Reads a single `Distribution` using its globally unique `ID`. */
  distributionByNodeId?: Maybe<Distribution>;
  /** Reads and enables pagination through a set of `Distribution`. */
  distributions?: Maybe<DistributionsConnection>;
  /** Reads a set of `Distribution`. */
  distributionsList?: Maybe<Array<Distribution>>;
  documentationSync?: Maybe<DocumentationSync>;
  /** Reads a single `DocumentationSync` using its globally unique `ID`. */
  documentationSyncByNodeId?: Maybe<DocumentationSync>;
  familyMemberSenior?: Maybe<FamilyMemberSenior>;
  /** Reads a single `FamilyMemberSenior` using its globally unique `ID`. */
  familyMemberSeniorByNodeId?: Maybe<FamilyMemberSenior>;
  /** Reads and enables pagination through a set of `FamilyMemberSenior`. */
  familyMemberSeniors?: Maybe<FamilyMemberSeniorsConnection>;
  /** Reads a set of `FamilyMemberSenior`. */
  familyMemberSeniorsList?: Maybe<Array<FamilyMemberSenior>>;
  /** Reads and enables pagination through a set of `FeatureActivity`. */
  featureActivities?: Maybe<FeatureActivitiesConnection>;
  /** Reads a set of `FeatureActivity`. */
  featureActivitiesList?: Maybe<Array<FeatureActivity>>;
  featureActivity?: Maybe<FeatureActivity>;
  featureActivityByKind?: Maybe<FeatureActivity>;
  /** Reads a single `FeatureActivity` using its globally unique `ID`. */
  featureActivityByNodeId?: Maybe<FeatureActivity>;
  feedback?: Maybe<Feedback>;
  /** Reads a single `Feedback` using its globally unique `ID`. */
  feedbackByNodeId?: Maybe<Feedback>;
  /** Reads and enables pagination through a set of `Feedback`. */
  feedbacks?: Maybe<FeedbacksConnection>;
  /** Reads a set of `Feedback`. */
  feedbacksList?: Maybe<Array<Feedback>>;
  /** How many Finance notifications are open, whatever the rule. Needs billing.read. */
  financeNotificationCount: Scalars['Int']['output'];
  /** The open Finance notifications, oldest first, 50 per page; rule narrows them to one rule. Needs billing.read. */
  financeNotifications: FinanceNotificationPage;
  /** The Finance overview: open Finance notifications, the Salesforce and Billwerk reconciliation, Salesforce checks and Billwerk contracts that need attention, 50 rows per page. Read-only. Needs billing.read. */
  financeOverview: FinanceOverview;
  formResponse?: Maybe<FormResponse>;
  formResponseByAuthorIdAndFormIdAndQuestionId?: Maybe<FormResponse>;
  /** Reads a single `FormResponse` using its globally unique `ID`. */
  formResponseByNodeId?: Maybe<FormResponse>;
  /** Reads and enables pagination through a set of `FormResponse`. */
  formResponses?: Maybe<FormResponsesConnection>;
  /** Reads a set of `FormResponse`. */
  formResponsesList?: Maybe<Array<FormResponse>>;
  getAccounts?: Maybe<Array<AccountData>>;
  getAlbumUserId?: Maybe<Scalars['UUID']['output']>;
  getAnnouncements: Array<Announcement>;
  getAnnouncementsV2: Array<AnnouncementV2>;
  /** Reads and enables pagination through a set of `Attachment`. */
  getAttachments?: Maybe<AttachmentsConnection>;
  /** Reads and enables pagination through a set of `Attachment`. */
  getAttachmentsList?: Maybe<Array<Attachment>>;
  getChatsWithBots: Array<ChatWithBot>;
  getContentUrls: GetContentUrlsReturn;
  getContentUrlsV2: GetContentUrlsReturnV2;
  getCustomers?: Maybe<Array<Customer>>;
  getDownloadLink: UploadLink;
  getIntegrationSettings?: Maybe<IntegrationSettings>;
  getLicense?: Maybe<LicenseData>;
  getMostUsedContentList?: Maybe<Array<ContentUsageInfo>>;
  getMostUsedContentListV2?: Maybe<Array<ContentUsageInfo>>;
  /** Reads and enables pagination through a set of `Attachment`. */
  getPhotoAlbumMedia?: Maybe<AttachmentsConnection>;
  /** Reads and enables pagination through a set of `Attachment`. */
  getPhotoAlbumMediaList?: Maybe<Array<Attachment>>;
  /** Reads and enables pagination through a set of `Attachment`. */
  getSeniorProfileAttachments?: Maybe<AttachmentsConnection>;
  /** Reads and enables pagination through a set of `Attachment`. */
  getSeniorProfileAttachmentsList?: Maybe<Array<Attachment>>;
  getSeniorProfiles: Array<User>;
  getSwOnlyAppDownloadLink: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `SystemMessage`. */
  getSystemMessages?: Maybe<SystemMessagesConnection>;
  /** Reads and enables pagination through a set of `SystemMessage`. */
  getSystemMessagesList?: Maybe<Array<SystemMessage>>;
  getUploadLinks?: Maybe<Array<UploadLink>>;
  getUploadLinksWithKeys?: Maybe<Array<UploadLink>>;
  getUploadLinksWithKeysAndChecksums?: Maybe<Array<UploadLink>>;
  getUserFlavour?: Maybe<Scalars['String']['output']>;
  getWebSiteMetadata?: Maybe<Metadata>;
  group?: Maybe<Group>;
  /** Reads a single `Group` using its globally unique `ID`. */
  groupByNodeId?: Maybe<Group>;
  /** Returns the list of pending invitations for the current user */
  groupInvitations?: Maybe<InvitationsConnection>;
  /** Returns the list of pending invitations for the current user */
  groupInvitationsList?: Maybe<Array<Invitation>>;
  /** Reads and enables pagination through a set of `Group`. */
  groups?: Maybe<GroupsConnection>;
  /** Reads a set of `Group`. */
  groupsList?: Maybe<Array<Group>>;
  handshakeCode?: Maybe<HandshakeCode>;
  handshakeCodeByCode?: Maybe<HandshakeCode>;
  /** Reads a single `HandshakeCode` using its globally unique `ID`. */
  handshakeCodeByNodeId?: Maybe<HandshakeCode>;
  handshakeCodeByWorkgroupIdAndInitiatorId?: Maybe<HandshakeCode>;
  /** Reads and enables pagination through a set of `HandshakeCode`. */
  handshakeCodes?: Maybe<HandshakeCodesConnection>;
  /** Reads a set of `HandshakeCode`. */
  handshakeCodesList?: Maybe<Array<HandshakeCode>>;
  /** Checks if the current user has access to the specified organization */
  hasAccessToOrganization?: Maybe<Scalars['Boolean']['output']>;
  hasCaregiverAccessToChat?: Maybe<Scalars['Boolean']['output']>;
  hasLearningContent: Scalars['Boolean']['output'];
  integrationExecution?: Maybe<IntegrationExecution>;
  integrationExecutions: Array<IntegrationExecution>;
  integrationImportPreview?: Maybe<IntegrationImportPreview>;
  invitation?: Maybe<Invitation>;
  /** Reads a single `Invitation` using its globally unique `ID`. */
  invitationByNodeId?: Maybe<Invitation>;
  /** Returns the list of pending invitations for the current user */
  invitations?: Maybe<InvitationsConnection>;
  /** Returns the list of pending invitations for the current user */
  invitationsList?: Maybe<Array<Invitation>>;
  isUsersAttachment?: Maybe<Scalars['Boolean']['output']>;
  korianUser?: Maybe<KorianUser>;
  /** Reads a single `KorianUser` using its globally unique `ID`. */
  korianUserByNodeId?: Maybe<KorianUser>;
  korianUserByUserId?: Maybe<KorianUser>;
  /** Reads and enables pagination through a set of `KorianUser`. */
  korianUsers?: Maybe<KorianUsersConnection>;
  /** Reads a set of `KorianUser`. */
  korianUsersList?: Maybe<Array<KorianUser>>;
  learningCoursePayload: LearningCoursePayload;
  learningProgressReport: LearningProgressReport;
  learningViewer: LearningViewer;
  /**
   * Recorded content sessions across all apps over the last four calendar
   * months through yesterday (UTC), including database content with zero use.
   */
  leastUsedContentReport: LeastUsedContentReport;
  licenses?: Maybe<Array<LicenseData>>;
  location?: Maybe<Location>;
  locationByExternalId?: Maybe<Location>;
  /** Reads a single `Location` using its globally unique `ID`. */
  locationByNodeId?: Maybe<Location>;
  locationPractitioner?: Maybe<LocationPractitioner>;
  /** Reads a single `LocationPractitioner` using its globally unique `ID`. */
  locationPractitionerByNodeId?: Maybe<LocationPractitioner>;
  /** Reads and enables pagination through a set of `LocationPractitioner`. */
  locationPractitioners?: Maybe<LocationPractitionersConnection>;
  /** Reads a set of `LocationPractitioner`. */
  locationPractitionersList?: Maybe<Array<LocationPractitioner>>;
  /** Reads and enables pagination through a set of `LocationSummary`. */
  locationSummaries?: Maybe<LocationSummariesConnection>;
  /** Reads a set of `LocationSummary`. */
  locationSummariesList?: Maybe<Array<LocationSummary>>;
  locationSummary?: Maybe<LocationSummary>;
  /** Reads a single `LocationSummary` using its globally unique `ID`. */
  locationSummaryByNodeId?: Maybe<LocationSummary>;
  /** Reads and enables pagination through a set of `Location`. */
  locations?: Maybe<LocationsConnection>;
  /** Reads a set of `Location`. */
  locationsList?: Maybe<Array<Location>>;
  /** Needs dhl_integration.manage. */
  logisticsDhlAccountSettings: LogisticsDhlAccountSettings;
  /** Needs logistics.manage. */
  logisticsDhlShippingSettings: LogisticsDhlShippingSettings;
  /** The inventory units, 50 per page, last changed first, with every unit's count by type and status. Read-only. Needs logistics.read. */
  logisticsInventory: LogisticsInventoryList;
  /** One inventory unit with its quality check, the asset that names it and its history; null when the logistics copy does not hold it. Read-only. Needs logistics.read. */
  logisticsInventoryItem?: Maybe<LogisticsInventoryItem>;
  /** Latest relevant command status of an undeleted local Order. Requires logistics.read. */
  logisticsOrderCommandStatus?: Maybe<LogisticsOrderCommandStatus>;
  /** Current label and safe pilot state of an undeleted Order. Requires logistics.read. */
  logisticsShippingLabelState?: Maybe<LogisticsShippingLabelState>;
  /** Everything WhereverSIM returns, live, for one SIM unit's SIM, device and connectivity. Read-only. Needs logistics.read. */
  logisticsWhereverSimDetails: LogisticsWhereverSimDetails;
  /** Read-only Workspace ONE tablet fleet with uniquely matched inventory and newest customer placement. Ambiguous matches never guess a unit or customer. Needs logistics.read. */
  logisticsWorkspaceOneDevices: LogisticsWorkspaceOneOverview;
  managerInvitations: Array<ManagerInvitation>;
  managerLearningAssignments: Array<LearningAssignment>;
  managerLearningCaregivers: Array<LearningCaregiver>;
  managerLearningCatalog: LearningCatalog;
  managerRegistrationCandidate: ManagerRegistrationCandidate;
  marketingDeliverySettings: MarketingDeliverySettings;
  marketingOverview: MarketingOverview;
  marketingSendingDomain?: Maybe<MarketingSendingDomain>;
  marketingWebOrders: MarketingWebOrders;
  /** Returns unread messages for an user. */
  me?: Maybe<User>;
  media?: Maybe<Media>;
  mediaAlbum?: Maybe<MediaAlbum>;
  /** Reads a single `MediaAlbum` using its globally unique `ID`. */
  mediaAlbumByNodeId?: Maybe<MediaAlbum>;
  /** Reads and enables pagination through a set of `MediaAlbum`. */
  mediaAlbums?: Maybe<MediaAlbumsConnection>;
  /** Reads a set of `MediaAlbum`. */
  mediaAlbumsList?: Maybe<Array<MediaAlbum>>;
  /** Reads a single `Media` using its globally unique `ID`. */
  mediaByNodeId?: Maybe<Media>;
  mediaNote?: Maybe<MediaNote>;
  /** Reads a single `MediaNote` using its globally unique `ID`. */
  mediaNoteByNodeId?: Maybe<MediaNote>;
  /** Reads and enables pagination through a set of `MediaNote`. */
  mediaNotes?: Maybe<MediaNotesConnection>;
  /** Reads a set of `MediaNote`. */
  mediaNotesList?: Maybe<Array<MediaNote>>;
  mediaVoiceRecording?: Maybe<MediaVoiceRecording>;
  /** Reads a single `MediaVoiceRecording` using its globally unique `ID`. */
  mediaVoiceRecordingByNodeId?: Maybe<MediaVoiceRecording>;
  /** Reads and enables pagination through a set of `MediaVoiceRecording`. */
  mediaVoiceRecordings?: Maybe<MediaVoiceRecordingsConnection>;
  /** Reads a set of `MediaVoiceRecording`. */
  mediaVoiceRecordingsList?: Maybe<Array<MediaVoiceRecording>>;
  /** Reads and enables pagination through a set of `Media`. */
  medias?: Maybe<MediaConnection>;
  /** Reads a set of `Media`. */
  mediasList?: Maybe<Array<Media>>;
  membership?: Maybe<Membership>;
  /** Reads a single `Membership` using its globally unique `ID`. */
  membershipByNodeId?: Maybe<Membership>;
  /** Reads and enables pagination through a set of `Membership`. */
  memberships?: Maybe<MembershipsConnection>;
  /** Reads a set of `Membership`. */
  membershipsList?: Maybe<Array<Membership>>;
  message?: Maybe<Message>;
  /** Reads a single `Message` using its globally unique `ID`. */
  messageByNodeId?: Maybe<Message>;
  /** Reads and enables pagination through a set of `Message`. */
  messages?: Maybe<MessagesConnection>;
  /** Reads a set of `Message`. */
  messagesList?: Maybe<Array<Message>>;
  metaTag?: Maybe<MetaTag>;
  /** Reads a single `MetaTag` using its globally unique `ID`. */
  metaTagByNodeId?: Maybe<MetaTag>;
  metaTagByTagAndKind?: Maybe<MetaTag>;
  /** Returns the most recent video call event sent by a user to a group. */
  mostRecentVideocallEvent?: Maybe<VideocallEventType>;
  /**
   * Top 20 website items tagged with the youtube-video keyword, aggregated
   * over the inclusive date range for the relevant analytics apps.
   */
  mostUsedYoutubeContent: Array<MostUsedYoutubeContentItem>;
  myLearning: MyLearning;
  myLearningCatalog: LearningCatalog;
  myLearningQuizAttempt?: Maybe<QuizAttemptResult>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  note?: Maybe<Note>;
  noteActivitySession?: Maybe<NoteActivitySession>;
  /** Reads a single `NoteActivitySession` using its globally unique `ID`. */
  noteActivitySessionByNodeId?: Maybe<NoteActivitySession>;
  /** Reads a single `Note` using its globally unique `ID`. */
  noteByNodeId?: Maybe<Note>;
  noteProcedure?: Maybe<NoteProcedure>;
  /** Reads a single `NoteProcedure` using its globally unique `ID`. */
  noteProcedureByNodeId?: Maybe<NoteProcedure>;
  noteSenior?: Maybe<NoteSenior>;
  /** Reads a single `NoteSenior` using its globally unique `ID`. */
  noteSeniorByNodeId?: Maybe<NoteSenior>;
  /** Reads and enables pagination through a set of `Note`. */
  notes?: Maybe<NotesConnection>;
  /** Reads a set of `Note`. */
  notesList?: Maybe<Array<Note>>;
  organization?: Maybe<Organization>;
  organizationBilling: OrganizationBilling;
  organizationByExternalId?: Maybe<Organization>;
  /** Reads a single `Organization` using its globally unique `ID`. */
  organizationByNodeId?: Maybe<Organization>;
  organizationContracts: OrganizationContracts;
  organizationLearningGrants: OrganizationLearningGrants;
  organizationManager?: Maybe<OrganizationManager>;
  /** Reads a single `OrganizationManager` using its globally unique `ID`. */
  organizationManagerByNodeId?: Maybe<OrganizationManager>;
  /** Reads and enables pagination through a set of `OrganizationManager`. */
  organizationManagers?: Maybe<OrganizationManagersConnection>;
  /** Reads a set of `OrganizationManager`. */
  organizationManagersList?: Maybe<Array<OrganizationManager>>;
  organizationPractitioner?: Maybe<OrganizationPractitioner>;
  /** Reads a single `OrganizationPractitioner` using its globally unique `ID`. */
  organizationPractitionerByNodeId?: Maybe<OrganizationPractitioner>;
  /** Reads and enables pagination through a set of `OrganizationPractitioner`. */
  organizationPractitioners?: Maybe<OrganizationPractitionersConnection>;
  /** Reads a set of `OrganizationPractitioner`. */
  organizationPractitionersList?: Maybe<Array<OrganizationPractitioner>>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizations?: Maybe<OrganizationsConnection>;
  /** Reads a set of `Organization`. */
  organizationsList?: Maybe<Array<Organization>>;
  patient?: Maybe<Patient>;
  patientByExternalId?: Maybe<Patient>;
  /** Reads a single `Patient` using its globally unique `ID`. */
  patientByNodeId?: Maybe<Patient>;
  patientByUserId?: Maybe<Patient>;
  /** Reads and enables pagination through a set of `Patient`. */
  patients?: Maybe<PatientsConnection>;
  /** Reads a set of `Patient`. */
  patientsList?: Maybe<Array<Patient>>;
  /** The hotline's phone numbers as E.164, ordered. Only calls dialled to one of them count as the hotline's inbound calls in the Service-Übersicht. */
  placetelHotlineNumbers: Array<Scalars['String']['output']>;
  placetelIntegration: PlacetelIntegration;
  /**
   * The hotline's opening hours, ordered by weekday. A weekday that is not
   * listed is closed; public holidays are not considered.
   */
  placetelOpeningHours: Array<PlacetelOpeningDay>;
  placetelPhoneAccount: PlacetelPhoneAccount;
  plannedProcedureActivities: Array<ActivitySession>;
  practitioner?: Maybe<Practitioner>;
  practitionerByExternalId?: Maybe<Practitioner>;
  /** Reads a single `Practitioner` using its globally unique `ID`. */
  practitionerByNodeId?: Maybe<Practitioner>;
  practitionerByUserId?: Maybe<Practitioner>;
  /** Reads and enables pagination through a set of `Practitioner`. */
  practitioners?: Maybe<PractitionersConnection>;
  /** Reads a set of `Practitioner`. */
  practitionersList?: Maybe<Array<Practitioner>>;
  procedure?: Maybe<Procedure>;
  procedureByExternalId?: Maybe<Procedure>;
  /** Reads a single `Procedure` using its globally unique `ID`. */
  procedureByNodeId?: Maybe<Procedure>;
  procedureParticipant?: Maybe<ProcedureParticipant>;
  /** Reads a single `ProcedureParticipant` using its globally unique `ID`. */
  procedureParticipantByNodeId?: Maybe<ProcedureParticipant>;
  /** Reads and enables pagination through a set of `ProcedureParticipant`. */
  procedureParticipants?: Maybe<ProcedureParticipantsConnection>;
  /** Reads a set of `ProcedureParticipant`. */
  procedureParticipantsList?: Maybe<Array<ProcedureParticipant>>;
  /**
   * Legacy stub (NG-9299): always returns an empty recommendation list.
   * New clients use activityRecommendations instead.
   */
  procedureRecommendations: ProcedureRecommendationsResult;
  /** Reads and enables pagination through a set of `Procedure`. */
  procedures?: Maybe<ProceduresConnection>;
  /** Reads a set of `Procedure`. */
  proceduresList?: Maybe<Array<Procedure>>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  receivedInvitations: Array<Invitation>;
  salesforceIntegration: SalesforceIntegration;
  /** A source report of a copied dashboard with its records, computed from the CRM copy. With a component and the values of its groupings that were clicked (outermost first, null for the empty value), it adds the filters the click links, as Salesforce does. Each column filter adds an equals filter on one of the report's REPORT_FILTER columns or groupings (after the click's filters), at most one per column; anything else is refused. */
  salesforceReport: SalesforceReportData;
  /** A copied Salesforce dashboard, computed from the CRM copy. */
  salesforceReportDashboard: SalesforceReportDashboardData;
  salesforceSyncRuns: Array<SalesforceSyncRun>;
  searchProcedures: Array<Maybe<ActivitySessionOutput>>;
  semverToInt?: Maybe<Scalars['Int']['output']>;
  senderKey?: Maybe<SenderKey>;
  senderKeyByKeyHash?: Maybe<SenderKey>;
  /** Reads a single `SenderKey` using its globally unique `ID`. */
  senderKeyByNodeId?: Maybe<SenderKey>;
  /** Reads and enables pagination through a set of `SenderKey`. */
  senderKeys?: Maybe<SenderKeysConnection>;
  /** Reads a set of `SenderKey`. */
  senderKeysList?: Maybe<Array<SenderKey>>;
  seniorRecoveryKeys?: Maybe<SeniorRecoveryKeysConnection>;
  seniorRecoveryKeysList?: Maybe<Array<Maybe<SeniorRecoveryKeysRecord>>>;
  shouldForceUpdate?: Maybe<ShouldForceUpdateOutput>;
  shouldSeniorUpdate: Scalars['String']['output'];
  /** Open staff invitations, newest first. */
  staffInvitations: Array<StaffInvitation>;
  /**
   * Staff users with their roles: the customer_service accounts and everyone
   * holding a role.
   */
  staffMembers: Array<StaffMember>;
  /**
   * The roles of the staff invitation behind an emailed registration code,
   * or null when the code belongs to no open staff invitation.
   */
  staffRegistrationCandidate?: Maybe<StaffRegistrationCandidate>;
  supportedVideocallVersion?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `Message`. */
  unreadMessages?: Maybe<MessagesConnection>;
  /** Reads and enables pagination through a set of `Message`. */
  unreadMessagesList?: Maybe<Array<Message>>;
  updateLink?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivities?: Maybe<UserContentActivitiesConnection>;
  /** Reads a set of `UserContentActivity`. */
  userContentActivitiesList?: Maybe<Array<UserContentActivity>>;
  userContentActivity?: Maybe<UserContentActivity>;
  /** Reads a single `UserContentActivity` using its globally unique `ID`. */
  userContentActivityByNodeId?: Maybe<UserContentActivity>;
  userContentFavorite?: Maybe<UserContentFavorite>;
  /** Reads a single `UserContentFavorite` using its globally unique `ID`. */
  userContentFavoriteByNodeId?: Maybe<UserContentFavorite>;
  userContentFavoriteByUserIdAndContentId?: Maybe<UserContentFavorite>;
  /** Reads and enables pagination through a set of `UserContentFavorite`. */
  userContentFavorites?: Maybe<UserContentFavoritesConnection>;
  /** Reads a set of `UserContentFavorite`. */
  userContentFavoritesList?: Maybe<Array<UserContentFavorite>>;
  /** Reads and enables pagination through a set of `UserRelation`. */
  userRelations?: Maybe<UserRelationsConnection>;
  /** Reads a set of `UserRelation`. */
  userRelationsList?: Maybe<Array<UserRelation>>;
  userSetting?: Maybe<UserSetting>;
  /** Reads a single `UserSetting` using its globally unique `ID`. */
  userSettingByNodeId?: Maybe<UserSetting>;
  /** Reads and enables pagination through a set of `UserSetting`. */
  userSettings?: Maybe<UserSettingsConnection>;
  /** Reads a set of `UserSetting`. */
  userSettingsList?: Maybe<Array<UserSetting>>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  /** Reads a set of `User`. */
  usersList?: Maybe<Array<User>>;
  verifyToken?: Maybe<Response>;
  videocallHangup?: Maybe<Scalars['Boolean']['output']>;
  videocallInvite: Scalars['Boolean']['output'];
  videocallJoin: Scalars['String']['output'];
  videocallStart: Scalars['String']['output'];
  videocallToken: Scalars['String']['output'];
  weatherObservationCache?: Maybe<WeatherObservationCache>;
  /** Reads a single `WeatherObservationCache` using its globally unique `ID`. */
  weatherObservationCacheByNodeId?: Maybe<WeatherObservationCache>;
  website?: Maybe<Website>;
  /** Reads a single `Website` using its globally unique `ID`. */
  websiteByNodeId?: Maybe<Website>;
  /** Reads and enables pagination through a set of `Website`. */
  websites?: Maybe<WebsitesConnection>;
  /** Reads a set of `Website`. */
  websitesList?: Maybe<Array<Website>>;
  workgroup?: Maybe<Workgroup>;
  /** Reads a single `Workgroup` using its globally unique `ID`. */
  workgroupByNodeId?: Maybe<Workgroup>;
  workgroupMembership?: Maybe<WorkgroupMembership>;
  /** Reads a single `WorkgroupMembership` using its globally unique `ID`. */
  workgroupMembershipByNodeId?: Maybe<WorkgroupMembership>;
  /** Reads and enables pagination through a set of `WorkgroupMembership`. */
  workgroupMemberships?: Maybe<WorkgroupMembershipsConnection>;
  /** Reads a set of `WorkgroupMembership`. */
  workgroupMembershipsList?: Maybe<Array<WorkgroupMembership>>;
  /** Reads and enables pagination through a set of `Workgroup`. */
  workgroups?: Maybe<WorkgroupsConnection>;
  /** Reads a set of `Workgroup`. */
  workgroupsList?: Maybe<Array<Workgroup>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActivitiesListArgs = {
  condition?: InputMaybe<ActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityGoalArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityGoalByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityGoalByUserIdAndKindArgs = {
  kind: ActivityGoalEnum;
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityGoalProgressArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityGoalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivityGoalCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityGoalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityGoalsListArgs = {
  condition?: InputMaybe<ActivityGoalCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityGoalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityParticipantArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityParticipantByActivitySessionIdAndSeniorIdArgs = {
  activitySessionId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityParticipantByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityParticipantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivityParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityParticipantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityParticipantsListArgs = {
  condition?: InputMaybe<ActivityParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityParticipantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActivityRecommendationsArgs = {
  excludeContentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  kind: ActivityGoalEnum;
  limit?: InputMaybe<Scalars['Int']['input']>;
  targetDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivitySessionArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivitySessionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActivitySessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActivitySessionsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAlbumMediaArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAlbumMediaByMediaIdAndAlbumIdArgs = {
  albumId: Scalars['UUID']['input'];
  mediaId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAlbumMediaByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppSettingArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppSettingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppSettingByUserIdAndSettingTypeArgs = {
  settingType: AppSettingEnum;
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AppSettingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AppSettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAppSettingsListArgs = {
  condition?: InputMaybe<AppSettingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AppSettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttachmentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AttachmentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttachmentsListArgs = {
  condition?: InputMaybe<AttachmentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBillwerkCustomerMatchArgs = {
  group?: InputMaybe<BillwerkCustomerMatchGroup>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<BillwerkCustomerMatchReason>;
  refreshAfter?: InputMaybe<Scalars['Datetime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBillwerkPlanVariantsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<BillwerkPlanVariantState>;
  view: BillwerkPlanVariantView;
};


/** The root query type which gives access points into the data universe. */
export type QueryCaregiverDevicePractitionerAuthStatusArgs = {
  deviceToken: Scalars['String']['input'];
  practitionerId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaregiverDevicePractitionersArgs = {
  deviceToken: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaregiverProceduresArgs = {
  input?: InputMaybe<ProceduresInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCaregiverProfileArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaregiverProfileByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaregiverSeniorArgs = {
  caregiverId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaregiverSeniorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCaregiverSeniorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaregiverSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaregiverSeniorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCaregiverSeniorsListArgs = {
  condition?: InputMaybe<CaregiverSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaregiverSeniorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInMessageArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInMessageByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInMessagesListArgs = {
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInsListArgs = {
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChromeverToIntArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContactsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContentActivitiesListArgs = {
  condition?: InputMaybe<ContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContentActivityArgs = {
  activityId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentActivityByContentIdArgs = {
  contentId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentActivityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentAnalyticsReportArgs = {
  contentKind?: InputMaybe<Scalars['String']['input']>;
  contentSubtype?: InputMaybe<Scalars['String']['input']>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  mode?: ContentAnalyticsMode;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContentByCmsContentIdAndCmsContentKindArgs = {
  cmsContentId: Scalars['Int']['input'];
  cmsContentKind: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentByCmsNextContentIdAndCmsNextContentKindArgs = {
  cmsNextContentId: Scalars['Int']['input'];
  cmsNextContentKind: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentMetaTagArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentMetaTagByContentIdAndMetaTagIdArgs = {
  contentId: Scalars['UUID']['input'];
  metaTagId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentMetaTagByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentMetaTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentMetaTagCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetaTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContentMetaTagsListArgs = {
  condition?: InputMaybe<ContentMetaTagCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentMetaTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContentUsageDailiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentUsageDailyCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentUsageDailiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContentUsageDailiesListArgs = {
  condition?: InputMaybe<ContentUsageDailyCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentUsageDailiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContentUsageDailyArgs = {
  appId: Scalars['String']['input'];
  contentId: Scalars['UUID']['input'];
  date: Scalars['Date']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContentUsageDailyByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCurrentWeatherArgs = {
  latitude: Scalars['Float']['input'];
  localDate: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomActivitiesListArgs = {
  condition?: InputMaybe<CustomActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomActivityArgs = {
  activityId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomActivityByNameArgs = {
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomActivityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceAccountBillingArgs = {
  salesforceId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceAccountLicencesArgs = {
  salesforceAccountId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceAccountManagersArgs = {
  salesforceAccountId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceBillingCustomerArgs = {
  frisbiiCustomerId?: InputMaybe<Scalars['String']['input']>;
  salesforceAccountId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceBillingSalesforceAccountsArgs = {
  search: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceCallKpisArgs = {
  range: CallKpiRange;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceCrmDuplicatesArgs = {
  input?: InputMaybe<CrmDuplicateListInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceCrmListArgs = {
  input: CrmListInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceCrmPhoneMatchesArgs = {
  number: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceCrmRecordArgs = {
  includeOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  object: CrmObject;
  salesforceId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceCrmSearchArgs = {
  includeOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceCrmTimelineArgs = {
  after?: InputMaybe<CrmTimelineCursorInput>;
  kinds?: InputMaybe<Array<CrmTimelineKind>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  object: CrmObject;
  salesforceId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceLearningCatalogArgs = {
  organizationId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceOrganizationBillingAccessArgs = {
  organizationIds: Array<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceProviderCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  agentKey?: InputMaybe<Scalars['String']['input']>;
  filter: CallListFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  range: CallKpiRange;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceSalesforceContractsArgs = {
  segment: SalesforceSegment;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerServiceSalesforceRecordsArgs = {
  input: SalesforceRecordsInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryDailiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DailyCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DailiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDailiesListArgs = {
  condition?: InputMaybe<DailyCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DailiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDailyArgs = {
  appId: Scalars['String']['input'];
  date: Scalars['Date']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDailyByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardPatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selectedLocationId?: InputMaybe<Scalars['UUID']['input']>;
  targetOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardPatientsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selectedLocationId?: InputMaybe<Scalars['UUID']['input']>;
  targetOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selectedLocationId?: InputMaybe<Scalars['UUID']['input']>;
  targetOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardPractitionersListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  selectedLocationId?: InputMaybe<Scalars['UUID']['input']>;
  targetOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDeviceArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDeviceByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDeviceEnrollmentTokenArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDeviceEnrollmentTokensArgs = {
  organizationId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDevicesListArgs = {
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDistributionArgs = {
  appId: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  dimension: Scalars['String']['input'];
  label: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDistributionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDistributionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DistributionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDistributionsListArgs = {
  condition?: InputMaybe<DistributionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentationSyncArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentationSyncByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFamilyMemberSeniorArgs = {
  familyMemberId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFamilyMemberSeniorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFamilyMemberSeniorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FamilyMemberSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FamilyMemberSeniorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFamilyMemberSeniorsListArgs = {
  condition?: InputMaybe<FamilyMemberSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FamilyMemberSeniorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FeatureActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeatureActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureActivitiesListArgs = {
  condition?: InputMaybe<FeatureActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeatureActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureActivityArgs = {
  activityId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureActivityByKindArgs = {
  kind: FeatureActivityKind;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureActivityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedbackArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedbackByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedbacksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FeedbackCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeedbacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeedbacksListArgs = {
  condition?: InputMaybe<FeedbackCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeedbacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFinanceNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<FinanceNotificationRule>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFinanceOverviewArgs = {
  billwerkCheck?: InputMaybe<FinanceBillwerkCheck>;
  list: FinanceOverviewList;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recentOnly?: InputMaybe<Scalars['Boolean']['input']>;
  reconciliationStatus?: InputMaybe<FinanceReconciliationStatus>;
  salesforceCheck?: InputMaybe<FinanceSalesforceCheck>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<FinanceOverviewSort>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormResponseArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFormResponseByAuthorIdAndFormIdAndQuestionIdArgs = {
  authorId: Scalars['UUID']['input'];
  formId: Scalars['Int']['input'];
  questionId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFormResponseByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFormResponsesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FormResponseCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FormResponsesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormResponsesListArgs = {
  condition?: InputMaybe<FormResponseCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FormResponsesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAlbumUserIdArgs = {
  albumId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAnnouncementsArgs = {
  condition: AppParameters;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAttachmentsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetChatsWithBotsArgs = {
  seniorId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetContentUrlsArgs = {
  input: ContentUrlParams;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetContentUrlsV2Args = {
  input: ContentUrlsParamsV2;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetCustomersArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetDownloadLinkArgs = {
  key: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetIntegrationSettingsArgs = {
  organizationId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLicenseArgs = {
  licenseId?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetMostUsedContentListArgs = {
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetMostUsedContentListV2Args = {
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPhotoAlbumMediaArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPhotoAlbumMediaListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSeniorProfileAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSeniorProfileAttachmentsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSeniorProfilesArgs = {
  caregiverProfilesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSwOnlyAppDownloadLinkArgs = {
  shortId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSystemMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lowerBound?: InputMaybe<Scalars['Datetime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  upperBound?: InputMaybe<Scalars['Datetime']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSystemMessagesListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  lowerBound?: InputMaybe<Scalars['Datetime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  upperBound?: InputMaybe<Scalars['Datetime']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUploadLinksArgs = {
  n: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUploadLinksWithKeysArgs = {
  keys: Array<InputMaybe<Scalars['String']['input']>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUploadLinksWithKeysAndChecksumsArgs = {
  pairs: Array<InputMaybe<KeyChecksumPair>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetWebSiteMetadataArgs = {
  url: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupInvitationsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupsListArgs = {
  condition?: InputMaybe<GroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHandshakeCodeArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHandshakeCodeByCodeArgs = {
  code: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHandshakeCodeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHandshakeCodeByWorkgroupIdAndInitiatorIdArgs = {
  initiatorId: Scalars['UUID']['input'];
  workgroupId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHandshakeCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandshakeCodeCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandshakeCodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHandshakeCodesListArgs = {
  condition?: InputMaybe<HandshakeCodeCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandshakeCodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasAccessToOrganizationArgs = {
  orgId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasCaregiverAccessToChatArgs = {
  chatId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationExecutionArgs = {
  id: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationExecutionsArgs = {
  input?: InputMaybe<IntegrationExecutionsInput>;
  organizationId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationImportPreviewArgs = {
  organizationId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIsUsersAttachmentArgs = {
  messageId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryKorianUserArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryKorianUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryKorianUserByUserIdArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryKorianUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<KorianUserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KorianUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryKorianUsersListArgs = {
  condition?: InputMaybe<KorianUserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KorianUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLearningCoursePayloadArgs = {
  courseId: Scalars['UUID']['input'];
  version: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLearningProgressReportArgs = {
  filter: LearningProgressFilter;
};


/** The root query type which gives access points into the data universe. */
export type QueryLeastUsedContentReportArgs = {
  contentKind?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLicensesArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  sourceSystem: DataSource;
  type: LocationTypeEnum;
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationPractitionerArgs = {
  locationId: Scalars['UUID']['input'];
  practitionerId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationPractitionerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationPractitionersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationPractitionersListArgs = {
  condition?: InputMaybe<LocationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationPractitionersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationSummariesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationSummaryCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationSummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationSummariesListArgs = {
  condition?: InputMaybe<LocationSummaryCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationSummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationSummaryArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationSummaryByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationsListArgs = {
  condition?: InputMaybe<LocationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLogisticsInventoryArgs = {
  input: LogisticsInventoryInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryLogisticsInventoryItemArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLogisticsOrderCommandStatusArgs = {
  salesforceId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLogisticsShippingLabelStateArgs = {
  salesforceId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLogisticsWhereverSimDetailsArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryManagerLearningAssignmentsArgs = {
  userIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryManagerRegistrationCandidateArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaAlbumArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaAlbumByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaAlbumsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MediaAlbumCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaAlbumsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaAlbumsListArgs = {
  condition?: InputMaybe<MediaAlbumCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaAlbumsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaNoteArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaNoteByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MediaNoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaNotesListArgs = {
  condition?: InputMaybe<MediaNoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaVoiceRecordingArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaVoiceRecordingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaVoiceRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MediaVoiceRecordingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaVoiceRecordingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMediaVoiceRecordingsListArgs = {
  condition?: InputMaybe<MediaVoiceRecordingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaVoiceRecordingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMediasArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MediaCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMediasListArgs = {
  condition?: InputMaybe<MediaCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipArgs = {
  groupId: Scalars['UUID']['input'];
  memberId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipsListArgs = {
  condition?: InputMaybe<MembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMessageArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessageByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMessagesListArgs = {
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMetaTagArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMetaTagByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMetaTagByTagAndKindArgs = {
  kind: MetaTagKind;
  tag: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMostRecentVideocallEventArgs = {
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  senderId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMostUsedYoutubeContentArgs = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMyLearningQuizAttemptArgs = {
  clientAttemptId: Scalars['UUID']['input'];
  courseId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteActivitySessionArgs = {
  activitySessionId: Scalars['UUID']['input'];
  noteId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteActivitySessionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteProcedureArgs = {
  noteId: Scalars['UUID']['input'];
  procedureId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteProcedureByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteSeniorArgs = {
  noteId: Scalars['UUID']['input'];
  seniorId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoteSeniorByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotesListArgs = {
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationBillingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationByExternalIdArgs = {
  externalId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationLearningGrantsArgs = {
  organizationId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationManagerArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationManagerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationManagersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationManagerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationManagersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationManagersListArgs = {
  condition?: InputMaybe<OrganizationManagerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationManagersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationPractitionerArgs = {
  organizationId: Scalars['UUID']['input'];
  practitionerId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationPractitionerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationPractitionersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationPractitionersListArgs = {
  condition?: InputMaybe<OrganizationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationPractitionersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationsListArgs = {
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  sourceSystem: DataSource;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientByUserIdArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientsListArgs = {
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlannedProcedureActivitiesArgs = {
  procedureId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPractitionerArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPractitionerByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  sourceSystem: DataSource;
};


/** The root query type which gives access points into the data universe. */
export type QueryPractitionerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPractitionerByUserIdArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PractitionersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPractitionersListArgs = {
  condition?: InputMaybe<PractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PractitionersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  sourceSystem: DataSource;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureParticipantArgs = {
  patientId: Scalars['UUID']['input'];
  procedureId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureParticipantByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureParticipantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProcedureParticipantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureParticipantsListArgs = {
  condition?: InputMaybe<ProcedureParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProcedureParticipantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureRecommendationsArgs = {
  procedureId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProceduresArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProceduresListArgs = {
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySalesforceReportArgs = {
  columnFilters?: InputMaybe<Array<SalesforceReportColumnFilterInput>>;
  component?: InputMaybe<SalesforceReportComponentKey>;
  reportId: Scalars['String']['input'];
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySalesforceReportDashboardArgs = {
  dashboard: SalesforceReportDashboard;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchProceduresArgs = {
  input: ProcedureSearchInput;
};


/** The root query type which gives access points into the data universe. */
export type QuerySemverToIntArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySenderKeyArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySenderKeyByKeyHashArgs = {
  keyHash: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySenderKeyByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySenderKeysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SenderKeyCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SenderKeysOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySenderKeysListArgs = {
  condition?: InputMaybe<SenderKeyCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SenderKeysOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySeniorRecoveryKeysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySeniorRecoveryKeysListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShouldForceUpdateArgs = {
  input: ShoudForceUpdateInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryStaffRegistrationCandidateArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySupportedVideocallVersionArgs = {
  groupId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUnreadMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUnreadMessagesListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUpdateLinkArgs = {
  flavour?: InputMaybe<Scalars['String']['input']>;
  isLicensing?: InputMaybe<Scalars['Boolean']['input']>;
  nativeRuntimeVersion?: InputMaybe<Scalars['String']['input']>;
  swMode?: InputMaybe<SwMode>;
  version: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContentActivitiesListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContentActivityArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContentActivityByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContentFavoriteArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContentFavoriteByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContentFavoriteByUserIdAndContentIdArgs = {
  contentId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContentFavoritesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentFavoriteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentFavoritesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserContentFavoritesListArgs = {
  condition?: InputMaybe<UserContentFavoriteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentFavoritesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRelationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRelationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRelationsListArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRelationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSettingArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSettingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserSettingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSettingsListArgs = {
  condition?: InputMaybe<UserSettingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVerifyTokenArgs = {
  token: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVideocallHangupArgs = {
  chatId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVideocallInviteArgs = {
  chatId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVideocallJoinArgs = {
  chatId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVideocallStartArgs = {
  chatId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVideocallTokenArgs = {
  chatId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWeatherObservationCacheArgs = {
  localDate: Scalars['Date']['input'];
  locationKey: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWeatherObservationCacheByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWebsiteArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWebsiteByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWebsitesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WebsiteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WebsitesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWebsitesListArgs = {
  condition?: InputMaybe<WebsiteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WebsitesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkgroupArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkgroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkgroupMembershipArgs = {
  memberId: Scalars['UUID']['input'];
  workgroupId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkgroupMembershipByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkgroupMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkgroupMembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupMembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkgroupMembershipsListArgs = {
  condition?: InputMaybe<WorkgroupMembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupMembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkgroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkgroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkgroupsListArgs = {
  condition?: InputMaybe<WorkgroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupsOrderBy>>;
};

export type QuizAttemptResult = {
  __typename?: 'QuizAttemptResult';
  attemptId: Scalars['UUID']['output'];
  clientAttemptId: Scalars['UUID']['output'];
  clientPassed: Scalars['Boolean']['output'];
  clientScorePercent: Scalars['Float']['output'];
  courseId: Scalars['UUID']['output'];
  courseVersion: Scalars['String']['output'];
  effect: LearningProgressEffect;
  finishedAt: Scalars['Datetime']['output'];
  lessonsCompletedBeforeAttempt: Scalars['Boolean']['output'];
  progress: LearningCourseProgress;
  receivedAt: Scalars['Datetime']['output'];
  serverCorrect: Scalars['Int']['output'];
  serverPassed: Scalars['Boolean']['output'];
  serverScorePercent: Scalars['Float']['output'];
  serverTotal: Scalars['Int']['output'];
  startedAt: Scalars['Datetime']['output'];
};

export enum RainForecastEnum {
  InHours = 'IN_HOURS',
  Later = 'LATER',
  Ongoing = 'ONGOING',
  Shortly = 'SHORTLY'
}

export type RecommendedActivity = {
  __typename?: 'RecommendedActivity';
  kind: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type RecordIntegrationImportPreviewInput = {
  executionId: Scalars['UUID']['input'];
  plan: Scalars['JSON']['input'];
};

export type RedeemDeviceEnrollmentTokenInput = {
  /** The typed code or the scanned QR payload. */
  code: Scalars['String']['input'];
  device: DeviceEnrollmentDeviceInput;
  /**
   * Optional for older clients. When provided, it must match the scope that
   * was selected when the token was created.
   */
  targetLocationId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum Region {
  Austria = 'Austria',
  Germany = 'Germany',
  Global = 'Global'
}

/** All input for the `registerPushNotificationDevice` mutation. */
export type RegisterPushNotificationDeviceInput = {
  bundleId?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  videocallToken?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `registerPushNotificationDevice` mutation. */
export type RegisterPushNotificationDevicePayload = {
  __typename?: 'RegisterPushNotificationDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `registerUser` mutation. */
export type RegisterUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** The output of our `registerUser` mutation. */
export type RegisterUserPayload = {
  __typename?: 'RegisterUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type RejectInvitationToGroupInput = {
  invitationId: Scalars['UUID']['input'];
};

export type RemoveMediaFromAlbumInput = {
  albumId: Scalars['UUID']['input'];
  mediaItemIds: Array<Scalars['UUID']['input']>;
};

export type RemovePlannedProcedureActivitySessionInput = {
  procedureId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type ReportDocumentationSyncInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** When the provider answered; the report may arrive later. */
  occurredAt: Scalars['Datetime']['input'];
  outcome: DocumentationSyncOutcome;
  /** Identifies this report; a replay of it changes nothing. */
  reportId: Scalars['UUID']['input'];
};

export type RequestPasswordResetOtpInput = {
  email: Scalars['String']['input'];
};

export type RequestPractitionerPasswordResetOtpInput = {
  deviceToken: Scalars['String']['input'];
  practitionerId: Scalars['UUID']['input'];
};

export type RequestPractitionerPasswordResetOtpResponse = {
  __typename?: 'RequestPractitionerPasswordResetOTPResponse';
  maskedEmail: Scalars['String']['output'];
  sentTo: PasswordResetRecipient;
};

/** All input for the `resendInvitation` mutation. */
export type ResendInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `resendInvitation` mutation. */
export type ResendInvitationPayload = {
  __typename?: 'ResendInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `resetPassword` mutation. */
export type ResetPasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
};

export type ResetPasswordOtpResponse = {
  __typename?: 'ResetPasswordOTPResponse';
  warningCode?: Maybe<Scalars['String']['output']>;
};

/** The output of our `resetPassword` mutation. */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ResetPractitionerPasswordOtpInput = {
  recipient: PasswordResetRecipient;
  userId: Scalars['UUID']['input'];
};

export type ResolvedDeviceEnrollmentToken = {
  __typename?: 'ResolvedDeviceEnrollmentToken';
  organization: DeviceEnrollmentOrganization;
  requiresTargetSelection: Scalars['Boolean']['output'];
  scopeLocation?: Maybe<DeviceEnrollmentLocation>;
  scopeType: DeviceEnrollmentScopeType;
  /**
   * The final location selected when the token was created. Organization
   * scope is represented by the organization's root location.
   */
  targets: Array<DeviceEnrollmentTarget>;
};

export type Response = {
  __typename?: 'Response';
  email?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  sub?: Maybe<Scalars['String']['output']>;
  used: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type RevealPractitionerPasswordOtpInput = {
  password: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export type RevealPractitionerPasswordOtpResponse = {
  __typename?: 'RevealPractitionerPasswordOTPResponse';
  otp?: Maybe<Scalars['String']['output']>;
  status: RevealPractitionerPasswordOtpStatus;
};

export enum RevealPractitionerPasswordOtpStatus {
  InvalidPassword = 'INVALID_PASSWORD',
  Revealed = 'REVEALED',
  Throttled = 'THROTTLED',
  Unavailable = 'UNAVAILABLE'
}

export type RichText = {
  __typename?: 'RichText';
  id: Scalars['Int']['output'];
  template: Array<TemplateType>;
  thumbnail: MediaImage;
  title: Scalars['String']['output'];
};

export type SalesforceConnectionCheck = {
  __typename?: 'SalesforceConnectionCheck';
  dailyApiRequestsMax?: Maybe<Scalars['Int']['output']>;
  dailyApiRequestsRemaining?: Maybe<Scalars['Int']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SalesforceConnectionInput = {
  clientId: Scalars['String']['input'];
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  loginUrl: Scalars['String']['input'];
};

export type SalesforceContractRecord = {
  __typename?: 'SalesforceContractRecord';
  activeSubscriptionItems?: Maybe<Scalars['BigFloat']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  mrr?: Maybe<Scalars['BigFloat']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SalesforceContractRecordList = {
  __typename?: 'SalesforceContractRecordList';
  records: Array<SalesforceContractRecord>;
  totalCount: Scalars['Int']['output'];
};

export type SalesforceContractSegment = {
  __typename?: 'SalesforceContractSegment';
  averageActiveSubscriptionItems?: Maybe<Scalars['BigFloat']['output']>;
  averageMrr?: Maybe<Scalars['BigFloat']['output']>;
  eligibleContracts: Scalars['Int']['output'];
  missingMrrContracts: Scalars['Int']['output'];
  missingSubscriptionCountContracts: Scalars['Int']['output'];
  /** Record type of the Salesforce contract. */
  recordType: SalesforceSegment;
  totalMrr?: Maybe<Scalars['BigFloat']['output']>;
};

export type SalesforceDashboard = {
  __typename?: 'SalesforceDashboard';
  activeB2BProducts: Array<SalesforceLabelCount>;
  activeB2CProducts: Array<SalesforceLabelCount>;
  activeLicenceProducts: Array<SalesforceLabelCount>;
  contractCount: Scalars['Int']['output'];
  contractSegments: Array<SalesforceContractSegment>;
  currency: Scalars['String']['output'];
  history: SalesforceSubscriptionHistory;
  lastSyncedAt?: Maybe<Scalars['Datetime']['output']>;
  subscriptionCount: Scalars['Int']['output'];
  unclassifiedSubscriptions: Scalars['Int']['output'];
};

export type SalesforceIntegration = {
  __typename?: 'SalesforceIntegration';
  anonymizationRequired: Scalars['Boolean']['output'];
  anonymize: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  dailyTime?: Maybe<Scalars['String']['output']>;
  hasClientSecret: Scalars['Boolean']['output'];
  intervalHours?: Maybe<Scalars['Int']['output']>;
  loginUrl?: Maybe<Scalars['String']['output']>;
  nextRunAt?: Maybe<Scalars['Datetime']['output']>;
  outsideIntervalHours?: Maybe<Scalars['Int']['output']>;
  schedule: SalesforceSyncSchedule;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  windowEnd?: Maybe<Scalars['String']['output']>;
  windowIntervalMinutes?: Maybe<Scalars['Int']['output']>;
  /** The workday schedule: window start and end, HH:MM in Europe/Berlin. */
  windowStart?: Maybe<Scalars['String']['output']>;
};

export type SalesforceIntegrationInput = {
  anonymize: Scalars['Boolean']['input'];
  clientId: Scalars['String']['input'];
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  dailyTime?: InputMaybe<Scalars['String']['input']>;
  intervalHours?: InputMaybe<Scalars['Int']['input']>;
  loginUrl: Scalars['String']['input'];
  outsideIntervalHours?: InputMaybe<Scalars['Int']['input']>;
  schedule: SalesforceSyncSchedule;
  windowEnd?: InputMaybe<Scalars['String']['input']>;
  windowIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  windowStart?: InputMaybe<Scalars['String']['input']>;
};

export type SalesforceLabelCount = {
  __typename?: 'SalesforceLabelCount';
  count: Scalars['Int']['output'];
  /** Product name; null when the item has none. */
  label?: Maybe<Scalars['String']['output']>;
};

export type SalesforcePeriodCount = {
  __typename?: 'SalesforcePeriodCount';
  /** Status__c for the creation series, the Kuendigungsart__c API value for the cancellation and end series; null when empty. */
  category?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  periodStart: Scalars['Date']['output'];
  /** Record type of the item's linked Salesforce account. */
  segment: SalesforceSegment;
};

export enum SalesforcePeriodGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Selects the subscription items behind one dashboard chart element. */
export type SalesforceRecordsInput = {
  /** Bucket size of the CREATED series; defaults to MONTH. */
  granularity?: InputMaybe<SalesforcePeriodGranularity>;
  kind: SalesforceRecordsKind;
  /** Product names for the active series, Status__c or Kuendigungsart__c for the history series; a null entry matches an empty value. Empty or omitted matches every value. */
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** First day of the clicked period; required for CREATED, CANCELLED and ENDED. */
  periodStart?: InputMaybe<Scalars['Date']['input']>;
  segment?: InputMaybe<SalesforceSegment>;
};

export enum SalesforceRecordsKind {
  ActiveLicences = 'ACTIVE_LICENCES',
  ActiveProducts = 'ACTIVE_PRODUCTS',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Ended = 'ENDED'
}

/** UNIQUE counts distinct values, with all empty values as one, as a report's Unique summary. */
export enum SalesforceReportAggregate {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Formula = 'FORMULA',
  Sum = 'SUM',
  Unique = 'UNIQUE'
}

/** COLUMN: one column per first grouping value. COLUMN_GROUPED, COLUMN_STACKED and COLUMN_STACKED_TO_HUNDRED: the second grouping's values side by side, stacked, or stacked to 100 %. COLUMN_STACKED_LINE: stacked columns of the first measure and a line of the second. COLUMN_MEASURES: one column per measure. BAR: horizontal bars. BAR_STACKED: horizontal stacked bars. DONUT: slices of the first grouping. METRIC: one number. */
export enum SalesforceReportChart {
  Bar = 'BAR',
  BarStacked = 'BAR_STACKED',
  Column = 'COLUMN',
  ColumnGrouped = 'COLUMN_GROUPED',
  ColumnMeasures = 'COLUMN_MEASURES',
  ColumnStacked = 'COLUMN_STACKED',
  ColumnStackedLine = 'COLUMN_STACKED_LINE',
  ColumnStackedToHundred = 'COLUMN_STACKED_TO_HUNDRED',
  Donut = 'DONUT',
  Metric = 'METRIC'
}

export type SalesforceReportColumn = {
  __typename?: 'SalesforceReportColumn';
  field: Scalars['String']['output'];
  /** Where the column's detail cells link to; null when they do not. */
  link?: Maybe<SalesforceReportColumnLink>;
  type: SalesforceReportFieldType;
};

/** A detail cell's value that narrows a report to the records with it. */
export type SalesforceReportColumnFilterInput = {
  /** A column or grouping of the report whose link kind is REPORT_FILTER. */
  field: Scalars['String']['input'];
  /** The value the column must equal; not empty. */
  value: Scalars['String']['input'];
};

export type SalesforceReportColumnLink = {
  __typename?: 'SalesforceReportColumnLink';
  kind: SalesforceReportLinkKind;
  /** The object a RECORD or OWNER_LIST link opens; null for REPORT_FILTER. */
  object?: Maybe<CrmObject>;
};

export type SalesforceReportComponent = {
  __typename?: 'SalesforceReportComponent';
  blockKey?: Maybe<Scalars['String']['output']>;
  /** Null for a component that cannot be copied. */
  chart?: Maybe<SalesforceReportChart>;
  groupings: Array<SalesforceReportGrouping>;
  key: SalesforceReportComponentKey;
  layout: SalesforceReportLayout;
  measures: Array<SalesforceReportMeasure>;
  missingFields: Array<Scalars['String']['output']>;
  pendingObjects: Array<Scalars['String']['output']>;
  points: Array<SalesforceReportPoint>;
  /** The Salesforce report the component copies. */
  reportId: Scalars['String']['output'];
  /** The donut also shows each slice's share. */
  showPercentages: Scalars['Boolean']['output'];
  showValues?: Maybe<Scalars['Boolean']['output']>;
  /** Largest value first, as the dashboard sorts it. */
  sortByValue: Scalars['Boolean']['output'];
  sortLegendValues?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<SalesforceReportSource>;
  table?: Maybe<SalesforceReportSection>;
  unavailable?: Maybe<SalesforceReportUnavailable>;
  /** The Salesforce fields the component reads that the last sync could not read, as Object.Field; its values are missing until they are granted. */
  unreadableFields: Array<Scalars['String']['output']>;
};

/** A component of a copied Salesforce dashboard, unique across them. */
export enum SalesforceReportComponentKey {
  ChurnB2CEndingSubscriptions = 'CHURN_B2C_ENDING_SUBSCRIPTIONS',
  ChurnB2CIncomingSubscriptions = 'CHURN_B2C_INCOMING_SUBSCRIPTIONS',
  ChurnFirstReactionTime = 'CHURN_FIRST_REACTION_TIME',
  ChurnIncomingCases = 'CHURN_INCOMING_CASES',
  ChurnIncomingCasesByStatus = 'CHURN_INCOMING_CASES_BY_STATUS',
  ChurnIncomingSubscriptions = 'CHURN_INCOMING_SUBSCRIPTIONS',
  ChurnLostAccounts = 'CHURN_LOST_ACCOUNTS',
  ChurnLostSubscriptions = 'CHURN_LOST_SUBSCRIPTIONS',
  ChurnOpenCancellationCases = 'CHURN_OPEN_CANCELLATION_CASES',
  ChurnReasons = 'CHURN_REASONS',
  ChurnUnlicensedLostSubscriptions = 'CHURN_UNLICENSED_LOST_SUBSCRIPTIONS',
  ChurnWinBackByIntake = 'CHURN_WIN_BACK_BY_INTAKE',
  ChurnWinBackLastQuarter = 'CHURN_WIN_BACK_LAST_QUARTER',
  ChurnWinBackOpportunities = 'CHURN_WIN_BACK_OPPORTUNITIES',
  ChurnWinBackThisQuarter = 'CHURN_WIN_BACK_THIS_QUARTER',
  CsAverageTalkTimeDaily = 'CS_AVERAGE_TALK_TIME_DAILY',
  CsAverageTalkTimeMonthly = 'CS_AVERAGE_TALK_TIME_MONTHLY',
  CsAverageTalkTimeWeekly = 'CS_AVERAGE_TALK_TIME_WEEKLY',
  CsAverageWrapUpDaily = 'CS_AVERAGE_WRAP_UP_DAILY',
  CsAverageWrapUpMonthly = 'CS_AVERAGE_WRAP_UP_MONTHLY',
  CsAverageWrapUpWeekly = 'CS_AVERAGE_WRAP_UP_WEEKLY',
  CsCallsPerRepDaily = 'CS_CALLS_PER_REP_DAILY',
  CsCallsPerRepMonthly = 'CS_CALLS_PER_REP_MONTHLY',
  CsCallsPerRepWeekly = 'CS_CALLS_PER_REP_WEEKLY',
  CsDcallFollowUp = 'CS_DCALL_FOLLOW_UP',
  CsSecondCallsDaily = 'CS_SECOND_CALLS_DAILY',
  CsSecondCallsMonthly = 'CS_SECOND_CALLS_MONTHLY',
  CsSecondCallsWeekly = 'CS_SECOND_CALLS_WEEKLY',
  CsSuccessfulCallsDaily = 'CS_SUCCESSFUL_CALLS_DAILY',
  CsSuccessfulCallsMonthly = 'CS_SUCCESSFUL_CALLS_MONTHLY',
  CsSuccessfulCallsWeekly = 'CS_SUCCESSFUL_CALLS_WEEKLY',
  CsUniqueCustomersDaily = 'CS_UNIQUE_CUSTOMERS_DAILY',
  CsUniqueCustomersMonthly = 'CS_UNIQUE_CUSTOMERS_MONTHLY',
  CsUniqueCustomersWeekly = 'CS_UNIQUE_CUSTOMERS_WEEKLY',
  DocumentationInterestedAccounts = 'DOCUMENTATION_INTERESTED_ACCOUNTS',
  DocumentationSystems = 'DOCUMENTATION_SYSTEMS',
  DocumentationSystemAccounts = 'DOCUMENTATION_SYSTEM_ACCOUNTS',
  DocumentationSystemDates = 'DOCUMENTATION_SYSTEM_DATES',
  DocumentationSystemUsers = 'DOCUMENTATION_SYSTEM_USERS',
  LogisticsEndedContractItems = 'LOGISTICS_ENDED_CONTRACT_ITEMS',
  LogisticsExpectedReturns = 'LOGISTICS_EXPECTED_RETURNS',
  LogisticsOpenCases = 'LOGISTICS_OPEN_CASES',
  LogisticsOpenDaily = 'LOGISTICS_OPEN_DAILY',
  LogisticsOpenWeekly = 'LOGISTICS_OPEN_WEEKLY',
  LogisticsReturnedChart = 'LOGISTICS_RETURNED_CHART',
  LogisticsReturnedTable = 'LOGISTICS_RETURNED_TABLE',
  LogisticsShipped = 'LOGISTICS_SHIPPED',
  LogisticsShipping = 'LOGISTICS_SHIPPING',
  SalesAllSubscriptionsPerRepMonthly = 'SALES_ALL_SUBSCRIPTIONS_PER_REP_MONTHLY',
  SalesCallsMonthly = 'SALES_CALLS_MONTHLY',
  SalesCallsPerRepDaily = 'SALES_CALLS_PER_REP_DAILY',
  SalesCallsPerRepMonthly = 'SALES_CALLS_PER_REP_MONTHLY',
  SalesCallsPerRepWeekly = 'SALES_CALLS_PER_REP_WEEKLY',
  SalesOneTimeUpsells = 'SALES_ONE_TIME_UPSELLS',
  SalesOpenOpportunitiesByCloseMonth = 'SALES_OPEN_OPPORTUNITIES_BY_CLOSE_MONTH',
  SalesOpenOpportunitiesByCloseWeek = 'SALES_OPEN_OPPORTUNITIES_BY_CLOSE_WEEK',
  SalesOpenOpportunitiesByOwner = 'SALES_OPEN_OPPORTUNITIES_BY_OWNER',
  SalesOpportunitiesMonthly = 'SALES_OPPORTUNITIES_MONTHLY',
  SalesOpportunitiesPerRepDaily = 'SALES_OPPORTUNITIES_PER_REP_DAILY',
  SalesOpportunitiesPerRepMonthly = 'SALES_OPPORTUNITIES_PER_REP_MONTHLY',
  SalesOpportunitiesPerRepWeekly = 'SALES_OPPORTUNITIES_PER_REP_WEEKLY',
  SalesSubscriptionsEnding = 'SALES_SUBSCRIPTIONS_ENDING',
  SalesSubscriptionsMonthly = 'SALES_SUBSCRIPTIONS_MONTHLY',
  SalesSubscriptionsPerRepDaily = 'SALES_SUBSCRIPTIONS_PER_REP_DAILY',
  SalesSubscriptionsPerRepWeekly = 'SALES_SUBSCRIPTIONS_PER_REP_WEEKLY',
  SalesSubscriptionsStarting = 'SALES_SUBSCRIPTIONS_STARTING',
  SalesTrainingSubscriptions = 'SALES_TRAINING_SUBSCRIPTIONS',
  SalesTvBoxes = 'SALES_TV_BOXES',
  SupportClosedCasesBySegment = 'SUPPORT_CLOSED_CASES_BY_SEGMENT',
  SupportFirstReactionTime = 'SUPPORT_FIRST_REACTION_TIME',
  SupportHotlineTodayByHour = 'SUPPORT_HOTLINE_TODAY_BY_HOUR',
  SupportHotlineTodayByQueue = 'SUPPORT_HOTLINE_TODAY_BY_QUEUE',
  SupportHotlineVolume = 'SUPPORT_HOTLINE_VOLUME',
  SupportHotlineYesterdayByQueue = 'SUPPORT_HOTLINE_YESTERDAY_BY_QUEUE',
  SupportInboundCallsMonthly = 'SUPPORT_INBOUND_CALLS_MONTHLY',
  SupportIncomingCases = 'SUPPORT_INCOMING_CASES',
  SupportNewCasesByChannel = 'SUPPORT_NEW_CASES_BY_CHANNEL',
  SupportOpenCases = 'SUPPORT_OPEN_CASES',
  SupportReachabilityDaily = 'SUPPORT_REACHABILITY_DAILY',
  SupportReachabilityLastQuarter = 'SUPPORT_REACHABILITY_LAST_QUARTER',
  SupportReachabilityThisQuarter = 'SUPPORT_REACHABILITY_THIS_QUARTER',
  SupportTalkTimeByWrapUp = 'SUPPORT_TALK_TIME_BY_WRAP_UP',
  SupportTimeToClose = 'SUPPORT_TIME_TO_CLOSE',
  SupportTotalCallsMonthly = 'SUPPORT_TOTAL_CALLS_MONTHLY',
  SupportToSalesByAgent = 'SUPPORT_TO_SALES_BY_AGENT',
  SupportToSalesByCampaign = 'SUPPORT_TO_SALES_BY_CAMPAIGN',
  SupportToSalesStatus = 'SUPPORT_TO_SALES_STATUS',
  SupportWaitAndTalkTime = 'SUPPORT_WAIT_AND_TALK_TIME',
  WeeklyCaregiverChurnMonthly = 'WEEKLY_CAREGIVER_CHURN_MONTHLY',
  WeeklyCaregiverChurnWeekly = 'WEEKLY_CAREGIVER_CHURN_WEEKLY',
  WeeklyCaregiverSubscriptionsMonthly = 'WEEKLY_CAREGIVER_SUBSCRIPTIONS_MONTHLY',
  WeeklyCaregiverSubscriptionsWeekly = 'WEEKLY_CAREGIVER_SUBSCRIPTIONS_WEEKLY',
  WeeklyCaregiverTabletsActive = 'WEEKLY_CAREGIVER_TABLETS_ACTIVE',
  WeeklyCaregiverTests = 'WEEKLY_CAREGIVER_TESTS',
  WeeklyLicencesActive = 'WEEKLY_LICENCES_ACTIVE',
  WeeklyOneTimeUpsells = 'WEEKLY_ONE_TIME_UPSELLS',
  WeeklySeniorChurnMonthly = 'WEEKLY_SENIOR_CHURN_MONTHLY',
  WeeklySeniorChurnWeekly = 'WEEKLY_SENIOR_CHURN_WEEKLY',
  WeeklySeniorSubscriptionsMonthly = 'WEEKLY_SENIOR_SUBSCRIPTIONS_MONTHLY',
  WeeklySeniorSubscriptionsWeekly = 'WEEKLY_SENIOR_SUBSCRIPTIONS_WEEKLY',
  WeeklySeniorTabletsActive = 'WEEKLY_SENIOR_TABLETS_ACTIVE',
  WeeklySeniorTests = 'WEEKLY_SENIOR_TESTS',
  WeeklySoldTabletsMonthly = 'WEEKLY_SOLD_TABLETS_MONTHLY',
  WeeklySoldTabletsWeekly = 'WEEKLY_SOLD_TABLETS_WEEKLY',
  WeeklySubscriptionsMonthly = 'WEEKLY_SUBSCRIPTIONS_MONTHLY',
  WeeklySubscriptionsWeekly = 'WEEKLY_SUBSCRIPTIONS_WEEKLY',
  WeeklyTestsCreatedMonthly = 'WEEKLY_TESTS_CREATED_MONTHLY',
  WeeklyTestsCreatedWeekly = 'WEEKLY_TESTS_CREATED_WEEKLY'
}

/** A Salesforce dashboard the portal copies. */
export enum SalesforceReportDashboard {
  CareDocumentationSystems = 'CARE_DOCUMENTATION_SYSTEMS',
  ChurnSupport = 'CHURN_SUPPORT',
  CustomerSuccess_2026 = 'CUSTOMER_SUCCESS_2026',
  LogisticsOperations = 'LOGISTICS_OPERATIONS',
  SalesDashboardRy = 'SALES_DASHBOARD_RY',
  SupportMetricsMonthly = 'SUPPORT_METRICS_MONTHLY',
  WeeklySalesSf2020 = 'WEEKLY_SALES_SF2020'
}

export type SalesforceReportDashboardData = {
  __typename?: 'SalesforceReportDashboardData';
  components: Array<SalesforceReportComponent>;
  dashboard: SalesforceReportDashboard;
  /** When the last Salesforce sync finished; null before the first. */
  lastSyncedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The Salesforce dashboard it copies. */
  salesforceId: Scalars['String']['output'];
};

export type SalesforceReportData = {
  __typename?: 'SalesforceReportData';
  across: Array<SalesforceReportTableGrouping>;
  blockKey?: Maybe<Scalars['String']['output']>;
  blocks?: Maybe<Array<SalesforceReportSection>>;
  /** The report's own chart; null when it has none. */
  chart?: Maybe<SalesforceReportChart>;
  chartGroupings: Array<SalesforceReportGrouping>;
  chartMeasures: Array<SalesforceReportMeasure>;
  chartMissingFields: Array<Scalars['String']['output']>;
  chartPendingObjects: Array<Scalars['String']['output']>;
  chartPoints: Array<SalesforceReportPoint>;
  chartUnavailable?: Maybe<SalesforceReportUnavailable>;
  columns: Array<SalesforceReportColumn>;
  dateRange?: Maybe<SalesforceReportDateRange>;
  down: Array<SalesforceReportTableGrouping>;
  /** Over the filters' numbers, such as 1 AND (2 OR 3); null when all apply. */
  filterLogic?: Maybe<Scalars['String']['output']>;
  filters: Array<SalesforceReportFilter>;
  format: SalesforceReportFormat;
  /** Each group before the groups within it, in the report's order; the grand total first. */
  groups: Array<SalesforceReportGroup>;
  hasMoreRows: Scalars['Boolean']['output'];
  lastSyncedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The filters a click on a dashboard component added, then those of the column filters. */
  linkedFilters: Array<SalesforceReportFilter>;
  missingFields: Array<Scalars['String']['output']>;
  pendingObjects: Array<Scalars['String']['output']>;
  reportId: Scalars['String']['output'];
  rowLimit: Scalars['Int']['output'];
  /** The detail rows in the report's order, at most rowLimit. */
  rows: Array<SalesforceReportRow>;
  selectedBlock?: Maybe<Scalars['String']['output']>;
  showGrandTotal: Scalars['Boolean']['output'];
  showSubtotals: Scalars['Boolean']['output'];
  showValues?: Maybe<Scalars['Boolean']['output']>;
  sortLegendValues?: Maybe<Scalars['Boolean']['output']>;
  source: SalesforceReportSource;
  summaries: Array<SalesforceReportSummary>;
  type: SalesforceReportType;
  unavailable?: Maybe<SalesforceReportUnavailable>;
  /** The Salesforce fields the page reads that the last sync could not read, as Object.Field. */
  unreadableFields: Array<Scalars['String']['output']>;
};

/** A report's standard date filter. */
export type SalesforceReportDateRange = {
  __typename?: 'SalesforceReportDateRange';
  field: Scalars['String']['output'];
  /** The first and last day it covers today (YYYY-MM-DD); null for an open end. */
  from?: Maybe<Scalars['String']['output']>;
  /** The last n days, today included. */
  lastDays?: Maybe<Scalars['Int']['output']>;
  relative?: Maybe<SalesforceReportRelativeRange>;
  to?: Maybe<Scalars['String']['output']>;
};

/** How a column's values are written: dates as YYYY-MM-DD, times as UTC ISO, numbers and checkboxes (true or false) as text. A PICKLIST cell shows the label Salesforce lists for its value, or the value where the copy has no label; group values and filters stay API values. */
export enum SalesforceReportFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Number = 'NUMBER',
  Picklist = 'PICKLIST',
  Text = 'TEXT'
}

export type SalesforceReportFilter = {
  __typename?: 'SalesforceReportFilter';
  field: Scalars['String']['output'];
  operator: SalesforceReportFilterOperator;
  /** As the report lists them: an empty text is the empty value; a date can be relative, such as TODAY or LAST 120 DAYS. */
  values: Array<Scalars['String']['output']>;
};

export enum SalesforceReportFilterOperator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  GreaterOrEqual = 'GREATER_OR_EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessOrEqual = 'LESS_OR_EQUAL',
  LessThan = 'LESS_THAN',
  NotContain = 'NOT_CONTAIN',
  NotEqual = 'NOT_EQUAL'
}

/** SUMMARY groups down and lists its records; MATRIX also groups across and shows its summaries only. TABULAR lists records; JOINED has independent blocks. */
export enum SalesforceReportFormat {
  Joined = 'JOINED',
  Matrix = 'MATRIX',
  Summary = 'SUMMARY',
  Tabular = 'TABULAR'
}

export enum SalesforceReportGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** A group of the report at any level: the grand total has no values, a subtotal the values of the groupings it is within. */
export type SalesforceReportGroup = {
  __typename?: 'SalesforceReportGroup';
  across: Array<SalesforceReportGroupValue>;
  count: Scalars['Int']['output'];
  down: Array<SalesforceReportGroupValue>;
  /** One per summary, in their order. */
  values: Array<Maybe<Scalars['Float']['output']>>;
};

export type SalesforceReportGroupValue = {
  __typename?: 'SalesforceReportGroupValue';
  /** The record type label, record name or picklist label the report shows instead of the value; null to show the value. */
  label?: Maybe<Scalars['String']['output']>;
  /** As a chart's group: a date grouping gives its period's first day; null for the empty value. */
  value?: Maybe<Scalars['String']['output']>;
};

export type SalesforceReportGrouping = {
  __typename?: 'SalesforceReportGrouping';
  descending: Scalars['Boolean']['output'];
  /** The field of the source, such as createdDate or ownerName. */
  field: Scalars['String']['output'];
  /** For a date field: the period a value stands for. */
  granularity?: Maybe<SalesforceReportGranularity>;
};

/** A component's place on the dashboard's grid of 12 columns and 36-pixel rows. */
export type SalesforceReportLayout = {
  __typename?: 'SalesforceReportLayout';
  column: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  row: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

/** What a detail cell of a column links to. RECORD: the CRM page of the record the cell shows or names. OWNER_LIST: the object's CRM list, filtered to the owner the cell names. REPORT_FILTER: the same report narrowed to the cell's or group's value, with a column filter. */
export enum SalesforceReportLinkKind {
  OwnerList = 'OWNER_LIST',
  Record = 'RECORD',
  ReportFilter = 'REPORT_FILTER'
}

export type SalesforceReportMeasure = {
  __typename?: 'SalesforceReportMeasure';
  aggregate: SalesforceReportAggregate;
  /** The field it aggregates; null for COUNT. */
  field?: Maybe<Scalars['String']['output']>;
};

export type SalesforceReportPoint = {
  __typename?: 'SalesforceReportPoint';
  /** The first grouping's value; a date grouping gives its period's first day (YYYY-MM-DD). Null for an empty value and for a component without groupings. */
  group?: Maybe<Scalars['String']['output']>;
  /** The second grouping's value; null for an empty value and for a component with one grouping. */
  series?: Maybe<Scalars['String']['output']>;
  /** One value per measure, in their order; null when no record had one. */
  values: Array<Maybe<Scalars['Float']['output']>>;
};

/** A report's relative standard date range. */
export enum SalesforceReportRelativeRange {
  LastAndThisMonth = 'LAST_AND_THIS_MONTH',
  LastAndThisQuarter = 'LAST_AND_THIS_QUARTER',
  LastQuarter = 'LAST_QUARTER',
  ThisAndLastTwoYears = 'THIS_AND_LAST_TWO_YEARS',
  ThisAndLastYear = 'THIS_AND_LAST_YEAR',
  ThisAndNextYear = 'THIS_AND_NEXT_YEAR',
  ThisMonth = 'THIS_MONTH',
  ThisQuarter = 'THIS_QUARTER',
  ThisYear = 'THIS_YEAR',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY'
}

export type SalesforceReportRow = {
  __typename?: 'SalesforceReportRow';
  down: Array<SalesforceReportGroupValue>;
  /** One per column, what its link needs: the Salesforce id of the record for RECORD, the owner's name for OWNER_LIST, the cell's value for REPORT_FILTER; null where the column has no link or the cell has nothing to link to. */
  links: Array<Maybe<Scalars['String']['output']>>;
  /** One per column, written as the column's type says (a picklist as its label); null when empty. */
  values: Array<Maybe<Scalars['String']['output']>>;
};

export type SalesforceReportSection = {
  __typename?: 'SalesforceReportSection';
  across: Array<SalesforceReportTableGrouping>;
  blockKey?: Maybe<Scalars['String']['output']>;
  /** The report's own chart; null when it has none. */
  chart?: Maybe<SalesforceReportChart>;
  chartGroupings: Array<SalesforceReportGrouping>;
  chartMeasures: Array<SalesforceReportMeasure>;
  chartMissingFields: Array<Scalars['String']['output']>;
  chartPendingObjects: Array<Scalars['String']['output']>;
  chartPoints: Array<SalesforceReportPoint>;
  chartUnavailable?: Maybe<SalesforceReportUnavailable>;
  columns: Array<SalesforceReportColumn>;
  dateRange?: Maybe<SalesforceReportDateRange>;
  down: Array<SalesforceReportTableGrouping>;
  /** Over the filters' numbers, such as 1 AND (2 OR 3); null when all apply. */
  filterLogic?: Maybe<Scalars['String']['output']>;
  filters: Array<SalesforceReportFilter>;
  format: SalesforceReportFormat;
  /** Each group before the groups within it, in the report's order; the grand total first. */
  groups: Array<SalesforceReportGroup>;
  hasMoreRows: Scalars['Boolean']['output'];
  lastSyncedAt?: Maybe<Scalars['Datetime']['output']>;
  /** The filters a click on a dashboard component added, then those of the column filters. */
  linkedFilters: Array<SalesforceReportFilter>;
  missingFields: Array<Scalars['String']['output']>;
  pendingObjects: Array<Scalars['String']['output']>;
  reportId: Scalars['String']['output'];
  rowLimit: Scalars['Int']['output'];
  /** The detail rows in the report's order, at most rowLimit. */
  rows: Array<SalesforceReportRow>;
  showGrandTotal: Scalars['Boolean']['output'];
  showSubtotals: Scalars['Boolean']['output'];
  showValues?: Maybe<Scalars['Boolean']['output']>;
  sortLegendValues?: Maybe<Scalars['Boolean']['output']>;
  source: SalesforceReportSource;
  summaries: Array<SalesforceReportSummary>;
  type: SalesforceReportType;
  unavailable?: Maybe<SalesforceReportUnavailable>;
  /** The Salesforce fields the page reads that the last sync could not read, as Object.Field. */
  unreadableFields: Array<Scalars['String']['output']>;
};

/** The records a component counts. */
export enum SalesforceReportSource {
  Accounts = 'ACCOUNTS',
  Calls = 'CALLS',
  CampaignMembers = 'CAMPAIGN_MEMBERS',
  Cases = 'CASES',
  Contracts = 'CONTRACTS',
  ContractItems = 'CONTRACT_ITEMS',
  ContractItemOrderItems = 'CONTRACT_ITEM_ORDER_ITEMS',
  Opportunities = 'OPPORTUNITIES',
  OrdersWithItems = 'ORDERS_WITH_ITEMS',
  OrderAssetItems = 'ORDER_ASSET_ITEMS'
}

/** A summary besides the record count. FORMULA is a summary formula, named by formula. */
export type SalesforceReportSummary = {
  __typename?: 'SalesforceReportSummary';
  aggregate: SalesforceReportAggregate;
  field?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
};

export type SalesforceReportTableGrouping = {
  __typename?: 'SalesforceReportTableGrouping';
  descending: Scalars['Boolean']['output'];
  field: Scalars['String']['output'];
  granularity?: Maybe<SalesforceReportGranularity>;
  /** Where a group's header links to, for an owner or a person: OWNER_LIST or REPORT_FILTER, the group's value being the name. Null for any other grouping. */
  link?: Maybe<SalesforceReportColumnLink>;
};

/** The Salesforce report type a report is built on. */
export enum SalesforceReportType {
  Accounts = 'ACCOUNTS',
  AccountsWithContracts = 'ACCOUNTS_WITH_CONTRACTS',
  CallReporting = 'CALL_REPORTING',
  CampaignsWithContacts = 'CAMPAIGNS_WITH_CONTACTS',
  CampaignsWithMembers = 'CAMPAIGNS_WITH_MEMBERS',
  Cases = 'CASES',
  ContractsWithItems = 'CONTRACTS_WITH_ITEMS',
  ContractItems = 'CONTRACT_ITEMS',
  ContractItemOrderItems = 'CONTRACT_ITEM_ORDER_ITEMS',
  Opportunities = 'OPPORTUNITIES',
  OrdersWithItems = 'ORDERS_WITH_ITEMS',
  OrderAssetItems = 'ORDER_ASSET_ITEMS'
}

/** TASKS_NOT_COPIED: the component counts Salesforce Tasks, which the integration licence cannot read. REPORT_NOT_SHARED: its source report is not shared with the dashboard's owner. */
export enum SalesforceReportUnavailable {
  CopyUnconfirmed = 'COPY_UNCONFIRMED',
  RefreshPending = 'REFRESH_PENDING',
  ReportNotShared = 'REPORT_NOT_SHARED',
  RequiredFieldsUnavailable = 'REQUIRED_FIELDS_UNAVAILABLE',
  SourceIncomplete = 'SOURCE_INCOMPLETE',
  TasksNotCopied = 'TASKS_NOT_COPIED'
}

/** Salesforce record type B2B or B2C. */
export enum SalesforceSegment {
  B2B = 'B2B',
  B2C = 'B2C'
}

export type SalesforceSubscriptionHistory = {
  __typename?: 'SalesforceSubscriptionHistory';
  asOf: Scalars['Date']['output'];
  cancelledMonthly: Array<SalesforcePeriodCount>;
  createdDaily: Array<SalesforcePeriodCount>;
  createdMonthly: Array<SalesforcePeriodCount>;
  createdWeekly: Array<SalesforcePeriodCount>;
  endedMonthly: Array<SalesforcePeriodCount>;
  missingCancellationDates: Scalars['Int']['output'];
  missingCreatedDates: Scalars['Int']['output'];
  missingEndDates: Scalars['Int']['output'];
};

export type SalesforceSubscriptionRecord = {
  __typename?: 'SalesforceSubscriptionRecord';
  assetType?: Maybe<Scalars['String']['output']>;
  billingStartDate?: Maybe<Scalars['Date']['output']>;
  billingStarted?: Maybe<Scalars['Boolean']['output']>;
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationType?: Maybe<Scalars['String']['output']>;
  changedFromName?: Maybe<Scalars['String']['output']>;
  changedFromSalesforceId?: Maybe<Scalars['String']['output']>;
  changedIntoName?: Maybe<Scalars['String']['output']>;
  changedIntoSalesforceId?: Maybe<Scalars['String']['output']>;
  contractName?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractRecordType?: Maybe<Scalars['String']['output']>;
  contractSalesforceId?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  inTrial?: Maybe<Scalars['Boolean']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['BigFloat']['output']>;
  productFamily?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productSalesforceId?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  salesforceId: Scalars['String']['output'];
  segment?: Maybe<Scalars['String']['output']>;
  sponsoringKrankenkasse?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
};

export type SalesforceSubscriptionRecordList = {
  __typename?: 'SalesforceSubscriptionRecordList';
  records: Array<SalesforceSubscriptionRecord>;
  /** Number of matching items; records holds at most the first 500. */
  totalCount: Scalars['Int']['output'];
};

export type SalesforceSyncCounts = {
  __typename?: 'SalesforceSyncCounts';
  accounts: Scalars['Int']['output'];
  calls: Scalars['Int']['output'];
  caseComments: Scalars['Int']['output'];
  caseHistories: Scalars['Int']['output'];
  cases: Scalars['Int']['output'];
  contacts: Scalars['Int']['output'];
  contracts: Scalars['Int']['output'];
  emails: Scalars['Int']['output'];
  items: Scalars['Int']['output'];
  leads: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  products: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

/**
 * What a run read: everything on the first real run, everything as
 * pseudonyms, only the records that changed since the last run, or
 * everything on request.
 */
export enum SalesforceSyncMode {
  Anonymised = 'ANONYMISED',
  Full = 'FULL',
  Incremental = 'INCREMENTAL',
  Initial = 'INITIAL'
}

export enum SalesforceSyncPhase {
  Accounts = 'ACCOUNTS',
  Communication = 'COMMUNICATION',
  EmailBodies = 'EMAIL_BODIES',
  Finalizing = 'FINALIZING',
  Inventory = 'INVENTORY',
  Reading = 'READING'
}

export type SalesforceSyncRun = {
  __typename?: 'SalesforceSyncRun';
  anonymized: Scalars['Boolean']['output'];
  apiCalls?: Maybe<Scalars['Int']['output']>;
  apiRequestsMax?: Maybe<Scalars['Int']['output']>;
  apiRequestsRemaining?: Maybe<Scalars['Int']['output']>;
  counts?: Maybe<SalesforceSyncCounts>;
  errorCode?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  /** Null before the run decided, and for runs before modes existed. */
  mode?: Maybe<SalesforceSyncMode>;
  phase?: Maybe<SalesforceSyncPhase>;
  phaseRecords: Scalars['Int']['output'];
  progressAt?: Maybe<Scalars['Datetime']['output']>;
  startedAt: Scalars['Datetime']['output'];
  status: SalesforceSyncStatus;
  trigger: SalesforceSyncTrigger;
  unavailable?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SalesforceSyncSchedule {
  Daily = 'DAILY',
  Interval = 'INTERVAL',
  Off = 'OFF',
  /** Every few minutes in a window on weekdays, every few hours otherwise. */
  WorkdayWindow = 'WORKDAY_WINDOW'
}

export enum SalesforceSyncStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Skipped = 'SKIPPED',
  Succeeded = 'SUCCEEDED'
}

export enum SalesforceSyncTrigger {
  Manual = 'MANUAL',
  Schedule = 'SCHEDULE'
}

export enum Salutation {
  Missus = 'missus',
  Mister = 'mister',
  Others = 'others'
}

export type SaveFormResponseInput = {
  formId: Scalars['Int']['input'];
  responses: Array<FormQuestionResponseInput>;
};

/** All input for the `saveMdappBackup` mutation. */
export type SaveMdappBackupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceData?: InputMaybe<Scalars['JSON']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  utilizationMode?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `saveMdappBackup` mutation. */
export type SaveMdappBackupPayload = {
  __typename?: 'SaveMdappBackupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type SaveProcedureDocumentationNoteInput = {
  kind: ProcedureDocumentationNoteKind;
  note: Scalars['String']['input'];
  procedureId: Scalars['UUID']['input'];
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  wizardAnswers?: InputMaybe<Scalars['JSON']['input']>;
};

export type SaveProcedureDocumentationNotePayload = {
  __typename?: 'SaveProcedureDocumentationNotePayload';
  created: Scalars['Boolean']['output'];
  noteId: Scalars['UUID']['output'];
};

export type SendDeviceEnrollmentTokenEmailInput = {
  recipientEmail: Scalars['String']['input'];
  tokenId: Scalars['UUID']['input'];
};

export type SendInstructionsInput = {
  email: Scalars['String']['input'];
};

/** All input for the `sendLicensingPortalInvitation` mutation. */
export type SendLicensingPortalInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerEmail: Scalars['String']['input'];
};

/** The output of our `sendLicensingPortalInvitation` mutation. */
export type SendLicensingPortalInvitationPayload = {
  __typename?: 'SendLicensingPortalInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `sendQrCodeSalesforce` mutation. */
export type SendQrCodeSalesforceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  licenseId: Scalars['String']['input'];
  swOnly: Scalars['Boolean']['input'];
};

/** The output of our `sendQrCodeSalesforce` mutation. */
export type SendQrCodeSalesforcePayload = {
  __typename?: 'SendQrCodeSalesforcePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `sendQrcode` mutation. */
export type SendQrcodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  licenseId: Scalars['String']['input'];
};

/** The output of our `sendQrcode` mutation. */
export type SendQrcodePayload = {
  __typename?: 'SendQrcodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `sendVideocallEvent` mutation. */
export type SendVideocallEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<VideocallEventType>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  senderId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `sendVideocallEvent` mutation. */
export type SendVideocallEventPayload = {
  __typename?: 'SendVideocallEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type SenderKey = Node & {
  __typename?: 'SenderKey';
  createdAt: Scalars['Datetime']['output'];
  deviceId: Scalars['UUID']['output'];
  /** Reads a single `Group` that is related to this `SenderKey`. */
  group?: Maybe<Group>;
  groupId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  keyHash: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `SenderKey` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SenderKeyCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `keyHash` field. */
  keyHash?: InputMaybe<Scalars['String']['input']>;
};

/** The `group` to be created by this mutation. */
export type SenderKeyGroupIdGroupCreateInput = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind: GroupType;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** Input for the nested mutation of `group` in the `SenderKeyInput` mutation. */
export type SenderKeyGroupIdInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<GroupNodeIdConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<SenderKeyGroupIdGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnSenderKeyForSenderKeyGroupIdUsingGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<SenderKeyOnSenderKeyForSenderKeyGroupIdNodeIdUpdate>;
};

/** Input for the nested mutation of `senderKey` in the `GroupInput` mutation. */
export type SenderKeyGroupIdInverseInput = {
  /** The primary key(s) for `senderKey` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SenderKeySenderKeyPkeyConnect>>;
  /** The primary key(s) for `senderKey` for the far side of the relationship. */
  connectByKeyHash?: InputMaybe<Array<SenderKeySenderKeyKeyHashKeyConnect>>;
  /** The primary key(s) for `senderKey` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<SenderKeyNodeIdConnect>>;
  /** A `SenderKeyInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SenderKeyGroupIdSenderKeyCreateInput>>;
  /** The primary key(s) and patch data for `senderKey` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SenderKeyOnSenderKeyForSenderKeyGroupIdUsingSenderKeyPkeyUpdate>>;
  /** The primary key(s) and patch data for `senderKey` for the far side of the relationship. */
  updateByKeyHash?: InputMaybe<Array<SenderKeyOnSenderKeyForSenderKeyGroupIdUsingSenderKeyKeyHashKeyUpdate>>;
  /** The primary key(s) and patch data for `senderKey` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<GroupOnSenderKeyForSenderKeyGroupIdNodeIdUpdate>>;
};

/** The `senderKey` to be created by this mutation. */
export type SenderKeyGroupIdSenderKeyCreateInput = {
  deviceId: Scalars['UUID']['input'];
  groupToGroupId?: InputMaybe<SenderKeyGroupIdInput>;
  keyHash: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

/** An input for mutations affecting `SenderKey` */
export type SenderKeyInput = {
  deviceId: Scalars['UUID']['input'];
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupToGroupId?: InputMaybe<SenderKeyGroupIdInput>;
  keyHash: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to connect. */
export type SenderKeyNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `senderKey` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type SenderKeyOnSenderKeyForSenderKeyGroupIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: GroupPatch;
};

/** The fields on `senderKey` to look up the row to update. */
export type SenderKeyOnSenderKeyForSenderKeyGroupIdUsingSenderKeyKeyHashKeyUpdate = {
  keyHash: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `senderKey` being updated. */
  patch: UpdateSenderKeyOnSenderKeyForSenderKeyGroupIdPatch;
};

/** The fields on `senderKey` to look up the row to update. */
export type SenderKeyOnSenderKeyForSenderKeyGroupIdUsingSenderKeyPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `senderKey` being updated. */
  patch: UpdateSenderKeyOnSenderKeyForSenderKeyGroupIdPatch;
};

/** Represents an update to a `SenderKey`. Fields that are set will be updated. */
export type SenderKeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupToGroupId?: InputMaybe<SenderKeyGroupIdInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keyHash?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The fields on `senderKey` to look up the row to connect. */
export type SenderKeySenderKeyKeyHashKeyConnect = {
  keyHash: Scalars['String']['input'];
};

/** The fields on `senderKey` to look up the row to connect. */
export type SenderKeySenderKeyPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `SenderKey` values. */
export type SenderKeysConnection = {
  __typename?: 'SenderKeysConnection';
  /** A list of edges which contains the `SenderKey` and cursor to aid in pagination. */
  edges: Array<SenderKeysEdge>;
  /** A list of `SenderKey` objects. */
  nodes: Array<SenderKey>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SenderKey` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SenderKey` edge in the connection. */
export type SenderKeysEdge = {
  __typename?: 'SenderKeysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SenderKey` at the end of the edge. */
  node: SenderKey;
};

/** Methods to use when ordering `SenderKey`. */
export enum SenderKeysOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyHashAsc = 'KEY_HASH_ASC',
  KeyHashDesc = 'KEY_HASH_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A `SeniorRecoveryKeysRecord` edge in the connection. */
export type SeniorRecoveryKeyEdge = {
  __typename?: 'SeniorRecoveryKeyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SeniorRecoveryKeysRecord` at the end of the edge. */
  node: SeniorRecoveryKeysRecord;
};

/** A connection to a list of `SeniorRecoveryKeysRecord` values. */
export type SeniorRecoveryKeysConnection = {
  __typename?: 'SeniorRecoveryKeysConnection';
  /** A list of edges which contains the `SeniorRecoveryKeysRecord` and cursor to aid in pagination. */
  edges: Array<SeniorRecoveryKeyEdge>;
  /** A list of `SeniorRecoveryKeysRecord` objects. */
  nodes: Array<SeniorRecoveryKeysRecord>;
  /** The count of *all* `SeniorRecoveryKeysRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `seniorRecoveryKeys` query. */
export type SeniorRecoveryKeysRecord = {
  __typename?: 'SeniorRecoveryKeysRecord';
  adminId?: Maybe<Scalars['UUID']['output']>;
  adminName?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['UUID']['output']>;
  licence?: Maybe<Scalars['String']['output']>;
  seniorId?: Maybe<Scalars['UUID']['output']>;
  seniorName?: Maybe<Scalars['String']['output']>;
};

export enum SessionKind {
  Group = 'GROUP',
  Single = 'SINGLE'
}

export enum SessionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Planned = 'PLANNED',
  Started = 'STARTED'
}

export type SetActivityDocumentationManualNoteIncludedInput = {
  included: Scalars['Boolean']['input'];
  seniorId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type Setting = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  settingType: AppSettingEnum;
  userId: Scalars['UUID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsInput = {
  settings: Array<Setting>;
};

export type ShoudForceUpdateInput = {
  appId: Scalars['String']['input'];
  flavour: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type ShouldForceUpdateOutput = {
  __typename?: 'ShouldForceUpdateOutput';
  nDays: Scalars['Int']['output'];
  nUpdates: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type StaffInvitation = {
  __typename?: 'StaffInvitation';
  createdAt: Scalars['Datetime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  invitedByName?: Maybe<Scalars['String']['output']>;
  roles: Array<StaffRole>;
  status: StaffInvitationStatus;
};

export enum StaffInvitationStatus {
  Failed = 'FAILED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type StaffMember = {
  __typename?: 'StaffMember';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  roles: Array<StaffRole>;
};

export type StaffRegistrationCandidate = {
  __typename?: 'StaffRegistrationCandidate';
  roles: Array<StaffRole>;
};

/**
 * A staff role. A staff user may hold several; their access is the union of
 * the roles' permissions.
 */
export enum StaffRole {
  Admin = 'ADMIN',
  CustomerService = 'CUSTOMER_SERVICE',
  CustomerSuccess = 'CUSTOMER_SUCCESS',
  Finance = 'FINANCE',
  Management = 'MANAGEMENT',
  Marketing = 'MARKETING',
  Operations = 'OPERATIONS'
}

export type StartLearningCourseInput = {
  clientEventId: Scalars['UUID']['input'];
  courseId: Scalars['UUID']['input'];
  courseVersion: Scalars['String']['input'];
  startedAt: Scalars['Datetime']['input'];
};

export type StartPlannedActivitySessionInput = {
  beganAt: Scalars['Datetime']['input'];
  lifecycleAction?: InputMaybe<ProcedureLifecycleAction>;
  sessionId: Scalars['UUID']['input'];
};

export type StartedLearningCourse = {
  __typename?: 'StartedLearningCourse';
  courseId: Scalars['UUID']['output'];
  courseVersion: Scalars['String']['output'];
  effect: LearningProgressEffect;
  payload: Scalars['String']['output'];
  progress: LearningCourseProgress;
  startedAt: Scalars['Datetime']['output'];
};

export type StreamingMessagePayload = {
  __typename?: 'StreamingMessagePayload';
  authorId: Scalars['UUID']['output'];
  chatId: Scalars['UUID']['output'];
  content: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  messageId?: Maybe<Scalars['UUID']['output']>;
};

export type SubmitAdminPortalFeedbackInput = {
  browser?: InputMaybe<Scalars['String']['input']>;
  category: AdminPortalFeedbackCategory;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  message: Scalars['String']['input'];
  operatingSystem?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  pagePath: Scalars['String']['input'];
  portalVersion?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitAdminPortalFeedbackPayload = {
  __typename?: 'SubmitAdminPortalFeedbackPayload';
  feedbackId: Scalars['Int']['output'];
};

export type SubmitLearningQuizAttemptInput = {
  answers: Array<LearningQuizAnswerInput>;
  clientAttemptId: Scalars['UUID']['input'];
  clientPassed: Scalars['Boolean']['input'];
  clientScorePercent: Scalars['Float']['input'];
  courseId: Scalars['UUID']['input'];
  courseVersion: Scalars['String']['input'];
  finishedAt: Scalars['Datetime']['input'];
  startedAt: Scalars['Datetime']['input'];
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  albumDeletedForUser?: Maybe<AlbumDeletedForUserPayload>;
  albumMediaChanges?: Maybe<AlbumMediaChangesPayload>;
  checkIn?: Maybe<CheckInPayload>;
  checkInMessage?: Maybe<CheckInMessagePayload>;
  groupJoined?: Maybe<GroupSubscriptionPayload>;
  groupLastReadByAllUpdated?: Maybe<UpdateLastRemoteReadPayload>;
  invitationAddedOrUpdated?: Maybe<InvitationSubscriptionPayload>;
  messageAdded?: Maybe<MessageSubscriptionPayload>;
  messageDeleted?: Maybe<DeleteMessageSubscriptionPayload>;
  newAlbumForUser?: Maybe<NewAlbumForUserPayload>;
  newVideocallEvent?: Maybe<VideocallEventSubscriptionPayload>;
  streamingMessageForChat?: Maybe<StreamingMessagePayload>;
  systemMessageAdded?: Maybe<SystemMessageAddedPayload>;
  voiceTranscription?: Maybe<VoiceTranscriptionPayload>;
  workgroup?: Maybe<WorkgroupPayload>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionAlbumDeletedForUserArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionAlbumMediaChangesArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionGroupJoinedArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionGroupLastReadByAllUpdatedArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionMessageAddedArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionMessageDeletedArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionNewAlbumForUserArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionStreamingMessageForChatArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionVoiceTranscriptionArgs = {
  userId: Scalars['UUID']['input'];
};

export enum SupportedLanguage {
  De = 'de',
  En = 'en',
  Es = 'es',
  Pl = 'pl',
  Ro = 'ro',
  Ru = 'ru',
  Tr = 'tr'
}

export enum SwMode {
  SwAndHw = 'swAndHw',
  SwOnly = 'swOnly'
}

export type SystemMessage = {
  __typename?: 'SystemMessage';
  createdAt: Scalars['Datetime']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  kind: SystemMessageType;
  payload: Scalars['JSON']['output'];
  receiverId?: Maybe<Scalars['UUID']['output']>;
  senderId?: Maybe<Scalars['UUID']['output']>;
};

export enum SystemMessageType {
  BroadcastSenderKeys = 'BROADCAST_SENDER_KEYS',
  MissedCall = 'MISSED_CALL',
  SenderKeys = 'SENDER_KEYS'
}

/** A connection to a list of `SystemMessage` values. */
export type SystemMessagesConnection = {
  __typename?: 'SystemMessagesConnection';
  /** A list of edges which contains the `SystemMessage` and cursor to aid in pagination. */
  edges: Array<SystemMessagesEdge>;
  /** A list of `SystemMessage` objects. */
  nodes: Array<SystemMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SystemMessage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SystemMessage` edge in the connection. */
export type SystemMessagesEdge = {
  __typename?: 'SystemMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SystemMessage` at the end of the edge. */
  node: SystemMessage;
};

export enum TemplateKind {
  FloatingImageLeft = 'floatingImageLeft',
  FloatingImageRight = 'floatingImageRight',
  ImageFullscreen = 'imageFullscreen',
  ImageLeftTextRight = 'imageLeftTextRight',
  ImageRightTextLeft = 'imageRightTextLeft',
  SinglePage = 'singlePage',
  TextOnly = 'textOnly',
  TwoImagesFullscreen = 'twoImagesFullscreen'
}

export type TemplateType = {
  __typename?: 'TemplateType';
  kind: TemplateKind;
  mediaWithCaption?: Maybe<Array<MediaWithCaption>>;
  text?: Maybe<Scalars['String']['output']>;
};

/** All input for the `testEnvUpdateLastRead` mutation. */
export type TestEnvUpdateLastReadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  lastRead?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `testEnvUpdateLastRead` mutation. */
export type TestEnvUpdateLastReadPayload = {
  __typename?: 'TestEnvUpdateLastReadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['Datetime']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `testEnvUpdateMessageCreatedAt` mutation. */
export type TestEnvUpdateMessageCreatedAtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  messageId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `testEnvUpdateMessageCreatedAt` mutation. */
export type TestEnvUpdateMessageCreatedAtPayload = {
  __typename?: 'TestEnvUpdateMessageCreatedAtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['Datetime']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type TestLicenseResponse = {
  __typename?: 'TestLicenseResponse';
  flavour: Scalars['String']['output'];
  licenseId: Scalars['String']['output'];
  plan: Scalars['String']['output'];
};

export enum TestLicenseType {
  B2b = 'b2b',
  B2bBasic = 'b2bBasic',
  B2c = 'b2c',
  Korian = 'korian'
}

export type TokenResponse = {
  __typename?: 'TokenResponse';
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
};

export type TranslateTextInput = {
  sourceLanguage: SupportedLanguage;
  targetLanguage: SupportedLanguage;
  text: Scalars['String']['input'];
};

export type TranslateTextResponse = {
  __typename?: 'TranslateTextResponse';
  translatedText: Scalars['String']['output'];
};

export type UnenrollDeviceResult = {
  __typename?: 'UnenrollDeviceResult';
  id: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
};

/** All input for the `updateActivityByNodeId` mutation. */
export type UpdateActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Activity` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Activity` being updated. */
  patch: ActivityPatch;
};

/** All input for the `updateActivityGoalByNodeId` mutation. */
export type UpdateActivityGoalByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActivityGoal` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ActivityGoal` being updated. */
  patch: ActivityGoalPatch;
};

/** All input for the `updateActivityGoalByUserIdAndKind` mutation. */
export type UpdateActivityGoalByUserIdAndKindInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  kind: ActivityGoalEnum;
  /** An object where the defined keys will be set on the `ActivityGoal` being updated. */
  patch: ActivityGoalPatch;
  userId: Scalars['UUID']['input'];
};

/** All input for the `updateActivityGoal` mutation. */
export type UpdateActivityGoalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ActivityGoal` being updated. */
  patch: ActivityGoalPatch;
};

/** The output of our update `ActivityGoal` mutation. */
export type UpdateActivityGoalPayload = {
  __typename?: 'UpdateActivityGoalPayload';
  /** The `ActivityGoal` that was updated by this mutation. */
  activityGoal?: Maybe<ActivityGoal>;
  /** An edge for our `ActivityGoal`. May be used by Relay 1. */
  activityGoalEdge?: Maybe<ActivityGoalsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ActivityGoal`. */
  user?: Maybe<User>;
};


/** The output of our update `ActivityGoal` mutation. */
export type UpdateActivityGoalPayloadActivityGoalEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivityGoalsOrderBy>>;
};

/** All input for the `updateActivity` mutation. */
export type UpdateActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Activity` being updated. */
  patch: ActivityPatch;
};

/** All input for the `updateActivityParticipantByActivitySessionIdAndSeniorId` mutation. */
export type UpdateActivityParticipantByActivitySessionIdAndSeniorIdInput = {
  activitySessionId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ActivityParticipant` being updated. */
  patch: ActivityParticipantPatch;
  seniorId: Scalars['UUID']['input'];
};

/** All input for the `updateActivityParticipantByNodeId` mutation. */
export type UpdateActivityParticipantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActivityParticipant` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ActivityParticipant` being updated. */
  patch: ActivityParticipantPatch;
};

/** All input for the `updateActivityParticipant` mutation. */
export type UpdateActivityParticipantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ActivityParticipant` being updated. */
  patch: ActivityParticipantPatch;
};

/** The output of our update `ActivityParticipant` mutation. */
export type UpdateActivityParticipantPayload = {
  __typename?: 'UpdateActivityParticipantPayload';
  /** The `ActivityParticipant` that was updated by this mutation. */
  activityParticipant?: Maybe<ActivityParticipant>;
  /** An edge for our `ActivityParticipant`. May be used by Relay 1. */
  activityParticipantEdge?: Maybe<ActivityParticipantsEdge>;
  /** Reads a single `ActivitySession` that is related to this `ActivityParticipant`. */
  activitySession?: Maybe<ActivitySession>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ActivityParticipant`. */
  senior?: Maybe<User>;
};


/** The output of our update `ActivityParticipant` mutation. */
export type UpdateActivityParticipantPayloadActivityParticipantEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivityParticipantsOrderBy>>;
};

/** The output of our update `Activity` mutation. */
export type UpdateActivityPayload = {
  __typename?: 'UpdateActivityPayload';
  /** The `Activity` that was updated by this mutation. */
  activity?: Maybe<Activity>;
  /** An edge for our `Activity`. May be used by Relay 1. */
  activityEdge?: Maybe<ActivitiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Activity` mutation. */
export type UpdateActivityPayloadActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivitiesOrderBy>>;
};

/** All input for the `updateActivitySessionByNodeId` mutation. */
export type UpdateActivitySessionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActivitySession` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ActivitySession` being updated. */
  patch: ActivitySessionPatch;
};

/** All input for the `updateActivitySession` mutation. */
export type UpdateActivitySessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ActivitySession` being updated. */
  patch: ActivitySessionPatch;
};

/** The output of our update `ActivitySession` mutation. */
export type UpdateActivitySessionPayload = {
  __typename?: 'UpdateActivitySessionPayload';
  /** Reads a single `Activity` that is related to this `ActivitySession`. */
  activity?: Maybe<Activity>;
  /** The `ActivitySession` that was updated by this mutation. */
  activitySession?: Maybe<ActivitySession>;
  /** An edge for our `ActivitySession`. May be used by Relay 1. */
  activitySessionEdge?: Maybe<ActivitySessionsEdge>;
  /** Reads a single `User` that is related to this `ActivitySession`. */
  caregiver?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Procedure` that is related to this `ActivitySession`. */
  procedure?: Maybe<Procedure>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ActivitySession` mutation. */
export type UpdateActivitySessionPayloadActivitySessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};

/** All input for the `updateAppSettingByNodeId` mutation. */
export type UpdateAppSettingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AppSetting` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `AppSetting` being updated. */
  patch: AppSettingPatch;
};

/** All input for the `updateAppSettingByUserIdAndSettingType` mutation. */
export type UpdateAppSettingByUserIdAndSettingTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `AppSetting` being updated. */
  patch: AppSettingPatch;
  settingType: AppSettingEnum;
  userId: Scalars['UUID']['input'];
};

/** All input for the `updateAppSetting` mutation. */
export type UpdateAppSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `AppSetting` being updated. */
  patch: AppSettingPatch;
};

/** The output of our update `AppSetting` mutation. */
export type UpdateAppSettingPayload = {
  __typename?: 'UpdateAppSettingPayload';
  /** The `AppSetting` that was updated by this mutation. */
  appSetting?: Maybe<AppSetting>;
  /** An edge for our `AppSetting`. May be used by Relay 1. */
  appSettingEdge?: Maybe<AppSettingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `AppSetting`. */
  user?: Maybe<User>;
};


/** The output of our update `AppSetting` mutation. */
export type UpdateAppSettingPayloadAppSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<AppSettingsOrderBy>>;
};

/** All input for the `updateAttachmentByNodeId` mutation. */
export type UpdateAttachmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Attachment` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Attachment` being updated. */
  patch: AttachmentPatch;
};

/** All input for the `updateAttachment` mutation. */
export type UpdateAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Attachment` being updated. */
  patch: AttachmentPatch;
};

/** The output of our update `Attachment` mutation. */
export type UpdateAttachmentPayload = {
  __typename?: 'UpdateAttachmentPayload';
  /** The `Attachment` that was updated by this mutation. */
  attachment?: Maybe<Attachment>;
  /** An edge for our `Attachment`. May be used by Relay 1. */
  attachmentEdge?: Maybe<AttachmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Media` that is related to this `Attachment`. */
  media?: Maybe<Media>;
  /** Reads a single `Message` that is related to this `Attachment`. */
  message?: Maybe<Message>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Attachment` mutation. */
export type UpdateAttachmentPayloadAttachmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AttachmentsOrderBy>>;
};

/** All input for the `updateCaregiverSeniorByNodeId` mutation. */
export type UpdateCaregiverSeniorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CaregiverSenior` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CaregiverSenior` being updated. */
  patch: CaregiverSeniorPatch;
};

/** All input for the `updateCaregiverSenior` mutation. */
export type UpdateCaregiverSeniorInput = {
  caregiverId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CaregiverSenior` being updated. */
  patch: CaregiverSeniorPatch;
  seniorId: Scalars['UUID']['input'];
};

/** The output of our update `CaregiverSenior` mutation. */
export type UpdateCaregiverSeniorPayload = {
  __typename?: 'UpdateCaregiverSeniorPayload';
  /** Reads a single `User` that is related to this `CaregiverSenior`. */
  caregiver?: Maybe<User>;
  /** The `CaregiverSenior` that was updated by this mutation. */
  caregiverSenior?: Maybe<CaregiverSenior>;
  /** An edge for our `CaregiverSenior`. May be used by Relay 1. */
  caregiverSeniorEdge?: Maybe<CaregiverSeniorsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CaregiverSenior`. */
  senior?: Maybe<User>;
};


/** The output of our update `CaregiverSenior` mutation. */
export type UpdateCaregiverSeniorPayloadCaregiverSeniorEdgeArgs = {
  orderBy?: InputMaybe<Array<CaregiverSeniorsOrderBy>>;
};

/** All input for the `updateCheckInByNodeId` mutation. */
export type UpdateCheckInByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CheckIn` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CheckIn` being updated. */
  patch: CheckInPatch;
};

/** All input for the `updateCheckIn` mutation. */
export type UpdateCheckInInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `CheckIn` being updated. */
  patch: CheckInPatch;
};

/** All input for the `updateCheckInMessageByNodeId` mutation. */
export type UpdateCheckInMessageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CheckInMessage` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CheckInMessage` being updated. */
  patch: CheckInMessagePatch;
};

/** All input for the `updateCheckInMessage` mutation. */
export type UpdateCheckInMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `CheckInMessage` being updated. */
  patch: CheckInMessagePatch;
};

/** The output of our update `CheckInMessage` mutation. */
export type UpdateCheckInMessagePayload = {
  __typename?: 'UpdateCheckInMessagePayload';
  /** Reads a single `User` that is related to this `CheckInMessage`. */
  author?: Maybe<User>;
  /** Reads a single `CheckIn` that is related to this `CheckInMessage`. */
  checkIn?: Maybe<CheckIn>;
  /** The `CheckInMessage` that was updated by this mutation. */
  checkInMessage?: Maybe<CheckInMessage>;
  /** An edge for our `CheckInMessage`. May be used by Relay 1. */
  checkInMessageEdge?: Maybe<CheckInMessagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CheckInMessage` mutation. */
export type UpdateCheckInMessagePayloadCheckInMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};

/** The output of our update `CheckIn` mutation. */
export type UpdateCheckInPayload = {
  __typename?: 'UpdateCheckInPayload';
  /** Reads a single `User` that is related to this `CheckIn`. */
  author?: Maybe<User>;
  /** The `CheckIn` that was updated by this mutation. */
  checkIn?: Maybe<CheckIn>;
  /** An edge for our `CheckIn`. May be used by Relay 1. */
  checkInEdge?: Maybe<CheckInsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CheckIn`. */
  senior?: Maybe<User>;
};


/** The output of our update `CheckIn` mutation. */
export type UpdateCheckInPayloadCheckInEdgeArgs = {
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};

/** All input for the `updateContentActivityByContentId` mutation. */
export type UpdateContentActivityByContentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ContentActivity` being updated. */
  patch: ContentActivityPatch;
};

/** All input for the `updateContentActivityByNodeId` mutation. */
export type UpdateContentActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ContentActivity` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ContentActivity` being updated. */
  patch: ContentActivityPatch;
};

/** All input for the `updateContentActivity` mutation. */
export type UpdateContentActivityInput = {
  activityId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ContentActivity` being updated. */
  patch: ContentActivityPatch;
};

/** The output of our update `ContentActivity` mutation. */
export type UpdateContentActivityPayload = {
  __typename?: 'UpdateContentActivityPayload';
  /** Reads a single `Activity` that is related to this `ContentActivity`. */
  activity?: Maybe<Activity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `ContentActivity`. */
  content?: Maybe<Content>;
  /** The `ContentActivity` that was updated by this mutation. */
  contentActivity?: Maybe<ContentActivity>;
  /** An edge for our `ContentActivity`. May be used by Relay 1. */
  contentActivityEdge?: Maybe<ContentActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ContentActivity` mutation. */
export type UpdateContentActivityPayloadContentActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<ContentActivitiesOrderBy>>;
};

/** All input for the `updateContentMetaTagByContentIdAndMetaTagId` mutation. */
export type UpdateContentMetaTagByContentIdAndMetaTagIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['UUID']['input'];
  metaTagId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ContentMetaTag` being updated. */
  patch: ContentMetaTagPatch;
};

/** All input for the `updateContentMetaTagByNodeId` mutation. */
export type UpdateContentMetaTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ContentMetaTag` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ContentMetaTag` being updated. */
  patch: ContentMetaTagPatch;
};

/** All input for the `updateContentMetaTag` mutation. */
export type UpdateContentMetaTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ContentMetaTag` being updated. */
  patch: ContentMetaTagPatch;
};

/** The output of our update `ContentMetaTag` mutation. */
export type UpdateContentMetaTagPayload = {
  __typename?: 'UpdateContentMetaTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `ContentMetaTag`. */
  content?: Maybe<Content>;
  /** The `ContentMetaTag` that was updated by this mutation. */
  contentMetaTag?: Maybe<ContentMetaTag>;
  /** An edge for our `ContentMetaTag`. May be used by Relay 1. */
  contentMetaTagEdge?: Maybe<ContentMetaTagsEdge>;
  /** Reads a single `MetaTag` that is related to this `ContentMetaTag`. */
  metaTag?: Maybe<MetaTag>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ContentMetaTag` mutation. */
export type UpdateContentMetaTagPayloadContentMetaTagEdgeArgs = {
  orderBy?: InputMaybe<Array<ContentMetaTagsOrderBy>>;
};

/** All input for the `updateCustomActivityByName` mutation. */
export type UpdateCustomActivityByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `CustomActivity` being updated. */
  patch: CustomActivityPatch;
};

/** All input for the `updateCustomActivityByNodeId` mutation. */
export type UpdateCustomActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CustomActivity` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CustomActivity` being updated. */
  patch: CustomActivityPatch;
};

/** All input for the `updateCustomActivity` mutation. */
export type UpdateCustomActivityInput = {
  activityId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CustomActivity` being updated. */
  patch: CustomActivityPatch;
};

/** The output of our update `CustomActivity` mutation. */
export type UpdateCustomActivityPayload = {
  __typename?: 'UpdateCustomActivityPayload';
  /** Reads a single `Activity` that is related to this `CustomActivity`. */
  activity?: Maybe<Activity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CustomActivity` that was updated by this mutation. */
  customActivity?: Maybe<CustomActivity>;
  /** An edge for our `CustomActivity`. May be used by Relay 1. */
  customActivityEdge?: Maybe<CustomActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CustomActivity` mutation. */
export type UpdateCustomActivityPayloadCustomActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomActivitiesOrderBy>>;
};

/** All input for the `updateDeviceByNodeId` mutation. */
export type UpdateDeviceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Device` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Device` being updated. */
  patch: DevicePatch;
};

/** All input for the `updateDevice` mutation. */
export type UpdateDeviceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Device` being updated. */
  patch: DevicePatch;
};

/** The output of our update `Device` mutation. */
export type UpdateDevicePayload = {
  __typename?: 'UpdateDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Device` that was updated by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Reads a single `Location` that is related to this `Device`. */
  location?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Device`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Device` mutation. */
export type UpdateDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** All input for the `updateFamilyMemberSeniorByNodeId` mutation. */
export type UpdateFamilyMemberSeniorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `FamilyMemberSenior` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `FamilyMemberSenior` being updated. */
  patch: FamilyMemberSeniorPatch;
};

/** All input for the `updateFamilyMemberSenior` mutation. */
export type UpdateFamilyMemberSeniorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  familyMemberId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `FamilyMemberSenior` being updated. */
  patch: FamilyMemberSeniorPatch;
  seniorId: Scalars['UUID']['input'];
};

/** The output of our update `FamilyMemberSenior` mutation. */
export type UpdateFamilyMemberSeniorPayload = {
  __typename?: 'UpdateFamilyMemberSeniorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `FamilyMemberSenior`. */
  familyMember?: Maybe<User>;
  /** The `FamilyMemberSenior` that was updated by this mutation. */
  familyMemberSenior?: Maybe<FamilyMemberSenior>;
  /** An edge for our `FamilyMemberSenior`. May be used by Relay 1. */
  familyMemberSeniorEdge?: Maybe<FamilyMemberSeniorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FamilyMemberSenior`. */
  senior?: Maybe<User>;
};


/** The output of our update `FamilyMemberSenior` mutation. */
export type UpdateFamilyMemberSeniorPayloadFamilyMemberSeniorEdgeArgs = {
  orderBy?: InputMaybe<Array<FamilyMemberSeniorsOrderBy>>;
};

/** All input for the `updateFeatureActivityByKind` mutation. */
export type UpdateFeatureActivityByKindInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  kind: FeatureActivityKind;
  /** An object where the defined keys will be set on the `FeatureActivity` being updated. */
  patch: FeatureActivityPatch;
};

/** All input for the `updateFeatureActivityByNodeId` mutation. */
export type UpdateFeatureActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `FeatureActivity` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `FeatureActivity` being updated. */
  patch: FeatureActivityPatch;
};

/** All input for the `updateFeatureActivity` mutation. */
export type UpdateFeatureActivityInput = {
  activityId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `FeatureActivity` being updated. */
  patch: FeatureActivityPatch;
};

/** The output of our update `FeatureActivity` mutation. */
export type UpdateFeatureActivityPayload = {
  __typename?: 'UpdateFeatureActivityPayload';
  /** Reads a single `Activity` that is related to this `FeatureActivity`. */
  activity?: Maybe<Activity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `FeatureActivity` that was updated by this mutation. */
  featureActivity?: Maybe<FeatureActivity>;
  /** An edge for our `FeatureActivity`. May be used by Relay 1. */
  featureActivityEdge?: Maybe<FeatureActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FeatureActivity` mutation. */
export type UpdateFeatureActivityPayloadFeatureActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureActivitiesOrderBy>>;
};

export type UpdateGroupInput = {
  id: Scalars['UUID']['input'];
  patch: GroupProfileInput;
};

export type UpdateGroupResponse = {
  __typename?: 'UpdateGroupResponse';
  group?: Maybe<Group>;
};

/** All input for the `updateHandshakeCodeByCode` mutation. */
export type UpdateHandshakeCodeByCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `HandshakeCode` being updated. */
  patch: HandshakeCodePatch;
};

/** All input for the `updateHandshakeCodeByNodeId` mutation. */
export type UpdateHandshakeCodeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `HandshakeCode` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `HandshakeCode` being updated. */
  patch: HandshakeCodePatch;
};

/** All input for the `updateHandshakeCodeByWorkgroupIdAndInitiatorId` mutation. */
export type UpdateHandshakeCodeByWorkgroupIdAndInitiatorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  initiatorId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `HandshakeCode` being updated. */
  patch: HandshakeCodePatch;
  workgroupId: Scalars['UUID']['input'];
};

/** All input for the `updateHandshakeCode` mutation. */
export type UpdateHandshakeCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `HandshakeCode` being updated. */
  patch: HandshakeCodePatch;
};

/** The output of our update `HandshakeCode` mutation. */
export type UpdateHandshakeCodePayload = {
  __typename?: 'UpdateHandshakeCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `HandshakeCode` that was updated by this mutation. */
  handshakeCode?: Maybe<HandshakeCode>;
  /** An edge for our `HandshakeCode`. May be used by Relay 1. */
  handshakeCodeEdge?: Maybe<HandshakeCodesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workgroup` that is related to this `HandshakeCode`. */
  workgroup?: Maybe<Workgroup>;
};


/** The output of our update `HandshakeCode` mutation. */
export type UpdateHandshakeCodePayloadHandshakeCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<HandshakeCodesOrderBy>>;
};

export type UpdateImportedPractitionerStatusInput = {
  id: Scalars['UUID']['input'];
  status: PractitionerStatus;
};

export type UpdateIntegrationExecutionInput = {
  completedAt?: InputMaybe<Scalars['Datetime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  jobId?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<IntegrationExecutionResult>;
  status?: InputMaybe<IntegrationExecutionStatus>;
  summary?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateLastRemoteReadPayload = {
  __typename?: 'UpdateLastRemoteReadPayload';
  chatId: Scalars['UUID']['output'];
  lastReadByAll: Scalars['Datetime']['output'];
  lastReceivedByAll: Scalars['Datetime']['output'];
};

/** All input for the `updateLocationByExternalId` mutation. */
export type UpdateLocationByExternalIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Location` being updated. */
  patch: LocationPatch;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem: DataSource;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type: LocationTypeEnum;
};

/** All input for the `updateLocationByNodeId` mutation. */
export type UpdateLocationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Location` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Location` being updated. */
  patch: LocationPatch;
};

/** All input for the `updateLocation` mutation. */
export type UpdateLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Location` being updated. */
  patch: LocationPatch;
};

/** The output of our update `Location` mutation. */
export type UpdateLocationPayload = {
  __typename?: 'UpdateLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Location` that was updated by this mutation. */
  location?: Maybe<Location>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge?: Maybe<LocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Location` that is related to this `Location`. */
  partOf?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Location` mutation. */
export type UpdateLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

export type UpdateLogisticsDhlAccountSettingsInput = {
  billingNumberPaket: Scalars['String']['input'];
  billingNumberPaketInternational: Scalars['String']['input'];
  billingNumberRetoure: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  /**
   * Write-only. Omitting it keeps the stored secret while clientId is
   * unchanged.
   */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /**
   * Write-only. Omitting it keeps the stored password while username is
   * unchanged.
   */
  password?: InputMaybe<Scalars['String']['input']>;
  returnReceiverIdAustria: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UpdateLogisticsDhlShippingSettingsInput = {
  /** Null or empty selects the default. */
  labelPrintFormat?: InputMaybe<Scalars['String']['input']>;
  /** All four fields or none; null or empty removes the return address. */
  returnAddress?: InputMaybe<LogisticsDhlAddressInput>;
  /** Null or empty selects the default. */
  returnLabelPrintFormat?: InputMaybe<Scalars['String']['input']>;
  shipper: LogisticsDhlAddressInput;
};

/** All input for the `updateMediaAlbumByNodeId` mutation. */
export type UpdateMediaAlbumByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `MediaAlbum` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `MediaAlbum` being updated. */
  patch: MediaAlbumPatch;
};

/** All input for the `updateMediaAlbum` mutation. */
export type UpdateMediaAlbumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `MediaAlbum` being updated. */
  patch: MediaAlbumPatch;
};

/** The output of our update `MediaAlbum` mutation. */
export type UpdateMediaAlbumPayload = {
  __typename?: 'UpdateMediaAlbumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `MediaAlbum` that was updated by this mutation. */
  mediaAlbum?: Maybe<MediaAlbum>;
  /** An edge for our `MediaAlbum`. May be used by Relay 1. */
  mediaAlbumEdge?: Maybe<MediaAlbumsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `MediaAlbum`. */
  user?: Maybe<User>;
};


/** The output of our update `MediaAlbum` mutation. */
export type UpdateMediaAlbumPayloadMediaAlbumEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaAlbumsOrderBy>>;
};

/** All input for the `updateMediaByNodeId` mutation. */
export type UpdateMediaByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Media` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Media` being updated. */
  patch: MediaPatch;
};

/** All input for the `updateMedia` mutation. */
export type UpdateMediaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Media` being updated. */
  patch: MediaPatch;
};

/** All input for the `updateMediaNoteByNodeId` mutation. */
export type UpdateMediaNoteByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `MediaNote` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `MediaNote` being updated. */
  patch: MediaNotePatch;
};

/** All input for the `updateMediaNote` mutation. */
export type UpdateMediaNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `MediaNote` being updated. */
  patch: MediaNotePatch;
};

/** The output of our update `MediaNote` mutation. */
export type UpdateMediaNotePayload = {
  __typename?: 'UpdateMediaNotePayload';
  /** Reads a single `User` that is related to this `MediaNote`. */
  author?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Media` that is related to this `MediaNote`. */
  media?: Maybe<Media>;
  /** The `MediaNote` that was updated by this mutation. */
  mediaNote?: Maybe<MediaNote>;
  /** An edge for our `MediaNote`. May be used by Relay 1. */
  mediaNoteEdge?: Maybe<MediaNotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `MediaNote` mutation. */
export type UpdateMediaNotePayloadMediaNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaNotesOrderBy>>;
};

/** The output of our update `Media` mutation. */
export type UpdateMediaPayload = {
  __typename?: 'UpdateMediaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Media` that was updated by this mutation. */
  media?: Maybe<Media>;
  /** An edge for our `Media`. May be used by Relay 1. */
  mediaEdge?: Maybe<MediaEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Media` mutation. */
export type UpdateMediaPayloadMediaEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
};

/** All input for the `updateMediaVoiceRecordingByNodeId` mutation. */
export type UpdateMediaVoiceRecordingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `MediaVoiceRecording` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `MediaVoiceRecording` being updated. */
  patch: MediaVoiceRecordingPatch;
};

/** All input for the `updateMediaVoiceRecording` mutation. */
export type UpdateMediaVoiceRecordingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `MediaVoiceRecording` being updated. */
  patch: MediaVoiceRecordingPatch;
};

/** The output of our update `MediaVoiceRecording` mutation. */
export type UpdateMediaVoiceRecordingPayload = {
  __typename?: 'UpdateMediaVoiceRecordingPayload';
  /** Reads a single `User` that is related to this `MediaVoiceRecording`. */
  author?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Media` that is related to this `MediaVoiceRecording`. */
  media?: Maybe<Media>;
  /** The `MediaVoiceRecording` that was updated by this mutation. */
  mediaVoiceRecording?: Maybe<MediaVoiceRecording>;
  /** An edge for our `MediaVoiceRecording`. May be used by Relay 1. */
  mediaVoiceRecordingEdge?: Maybe<MediaVoiceRecordingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Media` that is related to this `MediaVoiceRecording`. */
  voiceRecording?: Maybe<Media>;
};


/** The output of our update `MediaVoiceRecording` mutation. */
export type UpdateMediaVoiceRecordingPayloadMediaVoiceRecordingEdgeArgs = {
  orderBy?: InputMaybe<Array<MediaVoiceRecordingsOrderBy>>;
};

/** All input for the `updateMembershipByNodeId` mutation. */
export type UpdateMembershipByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Membership` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
};

/** All input for the `updateMembership` mutation. */
export type UpdateMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['UUID']['input'];
  memberId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
};

/** The output of our update `Membership` mutation. */
export type UpdateMembershipPayload = {
  __typename?: 'UpdateMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `Membership`. */
  group?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Membership`. */
  member?: Maybe<User>;
  /** The `Membership` that was updated by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Membership` mutation. */
export type UpdateMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the `updateMessageByNodeId` mutation. */
export type UpdateMessageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Message` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Message` being updated. */
  patch: MessagePatch;
};

/** All input for the `updateMessage` mutation. */
export type UpdateMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Message` being updated. */
  patch: MessagePatch;
};

/** The output of our update `Message` mutation. */
export type UpdateMessagePayload = {
  __typename?: 'UpdateMessagePayload';
  /** Reads a single `User` that is related to this `Message`. */
  author?: Maybe<User>;
  /** Reads a single `Group` that is related to this `Message`. */
  chat?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Message` that was updated by this mutation. */
  message?: Maybe<Message>;
  /** An edge for our `Message`. May be used by Relay 1. */
  messageEdge?: Maybe<MessagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Message` mutation. */
export type UpdateMessagePayloadMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};

export enum UpdateMode {
  InApp = 'inApp',
  Managed = 'managed'
}

/** All input for the `updateNoteByNodeId` mutation. */
export type UpdateNoteByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Note` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Note` being updated. */
  patch: NotePatch;
};

/** All input for the `updateNote` mutation. */
export type UpdateNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Note` being updated. */
  patch: NotePatch;
};

/** The output of our update `Note` mutation. */
export type UpdateNotePayload = {
  __typename?: 'UpdateNotePayload';
  /** Reads a single `User` that is related to this `Note`. */
  author?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Note` that was updated by this mutation. */
  note?: Maybe<Note>;
  /** An edge for our `Note`. May be used by Relay 1. */
  noteEdge?: Maybe<NotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Note` mutation. */
export type UpdateNotePayloadNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};

export type UpdatePatientGenderInput = {
  gender: GenderEnum;
  userId: Scalars['UUID']['input'];
};

export type UpdatePractitionerContactDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `updateProcedureByNodeId` mutation. */
export type UpdateProcedureByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Procedure` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Procedure` being updated. */
  patch: ProcedurePatch;
};

/** All input for the `updateProcedureBySourceSystemAndExternalIdAndOrganizationId` mutation. */
export type UpdateProcedureBySourceSystemAndExternalIdAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Original ID from the source system */
  externalId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Procedure` being updated. */
  patch: ProcedurePatch;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem: DataSource;
};

/** All input for the `updateProcedure` mutation. */
export type UpdateProcedureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Procedure` being updated. */
  patch: ProcedurePatch;
};

/** All input for the `updateProcedureParticipantByNodeId` mutation. */
export type UpdateProcedureParticipantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ProcedureParticipant` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ProcedureParticipant` being updated. */
  patch: ProcedureParticipantPatch;
};

/** All input for the `updateProcedureParticipant` mutation. */
export type UpdateProcedureParticipantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ProcedureParticipant` being updated. */
  patch: ProcedureParticipantPatch;
  /** Reference to a participating patient */
  patientId: Scalars['UUID']['input'];
  /** Reference to the procedure */
  procedureId: Scalars['UUID']['input'];
};

/** The output of our update `ProcedureParticipant` mutation. */
export type UpdateProcedureParticipantPayload = {
  __typename?: 'UpdateProcedureParticipantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Patient` that is related to this `ProcedureParticipant`. */
  patient?: Maybe<Patient>;
  /** Reads a single `Procedure` that is related to this `ProcedureParticipant`. */
  procedure?: Maybe<Procedure>;
  /** The `ProcedureParticipant` that was updated by this mutation. */
  procedureParticipant?: Maybe<ProcedureParticipant>;
  /** An edge for our `ProcedureParticipant`. May be used by Relay 1. */
  procedureParticipantEdge?: Maybe<ProcedureParticipantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProcedureParticipant` mutation. */
export type UpdateProcedureParticipantPayloadProcedureParticipantEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcedureParticipantsOrderBy>>;
};

/** The output of our update `Procedure` mutation. */
export type UpdateProcedurePayload = {
  __typename?: 'UpdateProcedurePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Procedure`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Practitioner` that is related to this `Procedure`. */
  performer?: Maybe<Practitioner>;
  /** The `Procedure` that was updated by this mutation. */
  procedure?: Maybe<Procedure>;
  /** An edge for our `Procedure`. May be used by Relay 1. */
  procedureEdge?: Maybe<ProceduresEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Procedure` mutation. */
export type UpdateProcedurePayloadProcedureEdgeArgs = {
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};

export type UpdateSeniorsInNoteInput = {
  noteId: Scalars['UUID']['input'];
  seniorIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `updateUserContentActivityByNodeId` mutation. */
export type UpdateUserContentActivityByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserContentActivity` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserContentActivity` being updated. */
  patch: UserContentActivityPatch;
};

/** All input for the `updateUserContentActivity` mutation. */
export type UpdateUserContentActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `UserContentActivity` being updated. */
  patch: UserContentActivityPatch;
};

/** The output of our update `UserContentActivity` mutation. */
export type UpdateUserContentActivityPayload = {
  __typename?: 'UpdateUserContentActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Content` that is related to this `UserContentActivity`. */
  content?: Maybe<Content>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserContentActivity`. */
  seniorProfile?: Maybe<User>;
  /** Reads a single `User` that is related to this `UserContentActivity`. */
  user?: Maybe<User>;
  /** The `UserContentActivity` that was updated by this mutation. */
  userContentActivity?: Maybe<UserContentActivity>;
  /** An edge for our `UserContentActivity`. May be used by Relay 1. */
  userContentActivityEdge?: Maybe<UserContentActivitiesEdge>;
};


/** The output of our update `UserContentActivity` mutation. */
export type UpdateUserContentActivityPayloadUserContentActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};

export type UpdateUserInput = {
  id: Scalars['UUID']['input'];
  patch: UserProfileInput;
};

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  user?: Maybe<User>;
};

/** All input for the `updateUserSettingByNodeId` mutation. */
export type UpdateUserSettingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserSetting` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserSetting` being updated. */
  patch: UserSettingPatch;
};

/** All input for the `updateUserSetting` mutation. */
export type UpdateUserSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `UserSetting` being updated. */
  patch: UserSettingPatch;
  userId: Scalars['UUID']['input'];
};

/** The output of our update `UserSetting` mutation. */
export type UpdateUserSettingPayload = {
  __typename?: 'UpdateUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  user?: Maybe<User>;
  /** The `UserSetting` that was updated by this mutation. */
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our update `UserSetting` mutation. */
export type UpdateUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

/** All input for the `updateWebsiteByNodeId` mutation. */
export type UpdateWebsiteByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Website` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Website` being updated. */
  patch: WebsitePatch;
};

/** All input for the `updateWebsite` mutation. */
export type UpdateWebsiteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `Website` being updated. */
  patch: WebsitePatch;
};

/** The output of our update `Website` mutation. */
export type UpdateWebsitePayload = {
  __typename?: 'UpdateWebsitePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Website`. */
  user?: Maybe<User>;
  /** The `Website` that was updated by this mutation. */
  website?: Maybe<Website>;
  /** An edge for our `Website`. May be used by Relay 1. */
  websiteEdge?: Maybe<WebsitesEdge>;
};


/** The output of our update `Website` mutation. */
export type UpdateWebsitePayloadWebsiteEdgeArgs = {
  orderBy?: InputMaybe<Array<WebsitesOrderBy>>;
};

/** All input for the `updateWorkgroupByNodeId` mutation. */
export type UpdateWorkgroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Workgroup` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Workgroup` being updated. */
  patch: WorkgroupPatch;
};

/** All input for the `updateWorkgroup` mutation. */
export type UpdateWorkgroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Workgroup` being updated. */
  patch: WorkgroupPatch;
};

/** All input for the `updateWorkgroupMembershipByNodeId` mutation. */
export type UpdateWorkgroupMembershipByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WorkgroupMembership` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `WorkgroupMembership` being updated. */
  patch: WorkgroupMembershipPatch;
};

/** All input for the `updateWorkgroupMembership` mutation. */
export type UpdateWorkgroupMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `WorkgroupMembership` being updated. */
  patch: WorkgroupMembershipPatch;
  workgroupId: Scalars['UUID']['input'];
};

/** The output of our update `WorkgroupMembership` mutation. */
export type UpdateWorkgroupMembershipPayload = {
  __typename?: 'UpdateWorkgroupMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `User` that is related to this `WorkgroupMembership`. */
  member?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workgroup` that is related to this `WorkgroupMembership`. */
  workgroup?: Maybe<Workgroup>;
  /** The `WorkgroupMembership` that was updated by this mutation. */
  workgroupMembership?: Maybe<WorkgroupMembership>;
  /** An edge for our `WorkgroupMembership`. May be used by Relay 1. */
  workgroupMembershipEdge?: Maybe<WorkgroupMembershipsEdge>;
};


/** The output of our update `WorkgroupMembership` mutation. */
export type UpdateWorkgroupMembershipPayloadWorkgroupMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkgroupMembershipsOrderBy>>;
};

/** The output of our update `Workgroup` mutation. */
export type UpdateWorkgroupPayload = {
  __typename?: 'UpdateWorkgroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workgroup` that was updated by this mutation. */
  workgroup?: Maybe<Workgroup>;
  /** An edge for our `Workgroup`. May be used by Relay 1. */
  workgroupEdge?: Maybe<WorkgroupsEdge>;
};


/** The output of our update `Workgroup` mutation. */
export type UpdateWorkgroupPayloadWorkgroupEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkgroupsOrderBy>>;
};

export type UploadLink = {
  __typename?: 'UploadLink';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UpsertActivityManualNoteInput = {
  note: Scalars['String']['input'];
  seniorId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type UpsertActivityManualNotePayload = {
  __typename?: 'UpsertActivityManualNotePayload';
  created: Scalars['Boolean']['output'];
  noteId: Scalars['UUID']['output'];
};

export type UpsertActivityMdDocumentationInput = {
  note: Scalars['String']['input'];
  seniorId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
  wizardAnswers: Scalars['JSON']['input'];
};

export type UpsertActivityMdDocumentationPayload = {
  __typename?: 'UpsertActivityMdDocumentationPayload';
  created: Scalars['Boolean']['output'];
  noteId: Scalars['UUID']['output'];
};

export type UpsertLocationInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<LocationModeEnum>;
  name: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  sourceSystem: DataSource;
  type: LocationTypeEnum;
};

export type UpsertNoteForProcedureInput = {
  kind?: InputMaybe<NoteKind>;
  note: Scalars['String']['input'];
  procedureId: Scalars['UUID']['input'];
  seniorIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpsertNoteForProcedurePayload = {
  __typename?: 'UpsertNoteForProcedurePayload';
  created: Scalars['Boolean']['output'];
  noteId: Scalars['UUID']['output'];
};

export type UpsertNoteForSessionInput = {
  kind?: InputMaybe<NoteKind>;
  note: Scalars['String']['input'];
  seniorIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sessionId: Scalars['UUID']['input'];
};

export type UpsertNoteForSessionPayload = {
  __typename?: 'UpsertNoteForSessionPayload';
  created: Scalars['Boolean']['output'];
  noteId: Scalars['UUID']['output'];
};

export type UpsertPatientInput = {
  avatarId?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId: Scalars['UUID']['input'];
  patientNumber?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Salutation>;
  sourceSystem: DataSource;
};

export type UpsertPractitionerInput = {
  avatarId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<GenderEnum>;
  lastName: Scalars['String']['input'];
  locationIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  motherTongue?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['UUID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Salutation>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  sourceSystem: DataSource;
  status?: InputMaybe<PractitionerStatus>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  workerNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertProcedureInput = {
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentation?: InputMaybe<Scalars['String']['input']>;
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  executedDose?: InputMaybe<Scalars['Float']['input']>;
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  externalId: Scalars['String']['input'];
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['UUID']['input'];
  patientIds: Array<Scalars['UUID']['input']>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  plannedDose?: InputMaybe<Scalars['Float']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  sourceSystem: DataSource;
  status: Scalars['String']['input'];
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  vitalSignValue?: InputMaybe<Scalars['Float']['input']>;
};

export type User = Node & {
  __typename?: 'User';
  /** Reads and enables pagination through a set of `Activity`. */
  activitiesByActivitySessionCaregiverIdAndActivityId: UserActivitiesByActivitySessionCaregiverIdAndActivityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Activity`. */
  activitiesByActivitySessionCaregiverIdAndActivityIdList: Array<Activity>;
  /** Reads and enables pagination through a set of `ActivityGoal`. */
  activityGoals: ActivityGoalsConnection;
  /** Reads and enables pagination through a set of `ActivityGoal`. */
  activityGoalsList: Array<ActivityGoal>;
  /** Reads and enables pagination through a set of `ActivityParticipant`. */
  activityParticipantsBySeniorId: ActivityParticipantsConnection;
  /** Reads and enables pagination through a set of `ActivityParticipant`. */
  activityParticipantsBySeniorIdList: Array<ActivityParticipant>;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsByActivityParticipantSeniorIdAndActivitySessionId: UserActivitySessionsByActivityParticipantSeniorIdAndActivitySessionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsByActivityParticipantSeniorIdAndActivitySessionIdList: Array<ActivitySession>;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsByCaregiverId: ActivitySessionsConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsByCaregiverIdList: Array<ActivitySession>;
  /** Reads and enables pagination through a set of `AppSetting`. */
  appSettings: AppSettingsConnection;
  /** Reads and enables pagination through a set of `AppSetting`. */
  appSettingsList: Array<AppSetting>;
  /** Credential state of the user: credential block, password set, one-time password pending, or no credentials. */
  authStatus?: Maybe<AuthStatus>;
  /** Expiry of the user's pending one-time password, if any. */
  authStatusValidUntil?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `CheckInMessage`. */
  authoredCheckInMessages: CheckInMessagesConnection;
  /** Reads and enables pagination through a set of `CheckInMessage`. */
  authoredCheckInMessagesList: Array<CheckInMessage>;
  /** Reads and enables pagination through a set of `CheckIn`. */
  authoredCheckIns: CheckInsConnection;
  /** Reads and enables pagination through a set of `CheckIn`. */
  authoredCheckInsList: Array<CheckIn>;
  /** Reads and enables pagination through a set of `FormResponse`. */
  authoredFormResponses: FormResponsesConnection;
  /** Reads and enables pagination through a set of `FormResponse`. */
  authoredFormResponsesList: Array<FormResponse>;
  /** Reads and enables pagination through a set of `Note`. */
  authoredNotes: NotesConnection;
  /** Reads and enables pagination through a set of `Note`. */
  authoredNotesList: Array<Note>;
  availableFeatures?: Maybe<Array<Maybe<AppFeature>>>;
  avatar?: Maybe<Scalars['UUID']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CaregiverProfile` that is related to this `User`. */
  caregiverProfile?: Maybe<CaregiverProfile>;
  /** Reads and enables pagination through a set of `CaregiverSenior`. */
  caregiverSeniorsByCaregiverId: CaregiverSeniorsConnection;
  /** Reads and enables pagination through a set of `CaregiverSenior`. */
  caregiverSeniorsByCaregiverIdList: Array<CaregiverSenior>;
  /** Reads and enables pagination through a set of `CaregiverSenior`. */
  caregiverSeniorsBySeniorId: CaregiverSeniorsConnection;
  /** Reads and enables pagination through a set of `CaregiverSenior`. */
  caregiverSeniorsBySeniorIdList: Array<CaregiverSenior>;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkInsByCheckInMessageAuthorIdAndCheckInId: UserCheckInsByCheckInMessageAuthorIdAndCheckInIdManyToManyConnection;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkInsByCheckInMessageAuthorIdAndCheckInIdList: Array<CheckIn>;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkInsBySeniorId: CheckInsConnection;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkInsBySeniorIdList: Array<CheckIn>;
  /** Reads and enables pagination through a set of `Content`. */
  contentsByUserContentActivitySeniorProfileIdAndContentId: UserContentsByUserContentActivitySeniorProfileIdAndContentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Content`. */
  contentsByUserContentActivitySeniorProfileIdAndContentIdList: Array<Content>;
  /** Reads and enables pagination through a set of `Content`. */
  contentsByUserContentActivityUserIdAndContentId: UserContentsByUserContentActivityUserIdAndContentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Content`. */
  contentsByUserContentActivityUserIdAndContentIdList: Array<Content>;
  /** Reads and enables pagination through a set of `Content`. */
  contentsByUserContentFavoriteUserIdAndContentId: UserContentsByUserContentFavoriteUserIdAndContentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Content`. */
  contentsByUserContentFavoriteUserIdAndContentIdList: Array<Content>;
  createdAt: Scalars['Datetime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `FamilyMemberSenior`. */
  familyMemberSeniorsByFamilyMemberId: FamilyMemberSeniorsConnection;
  /** Reads and enables pagination through a set of `FamilyMemberSenior`. */
  familyMemberSeniorsByFamilyMemberIdList: Array<FamilyMemberSenior>;
  /** Reads and enables pagination through a set of `FamilyMemberSenior`. */
  familyMemberSeniorsBySeniorId: FamilyMemberSeniorsConnection;
  /** Reads and enables pagination through a set of `FamilyMemberSenior`. */
  familyMemberSeniorsBySeniorIdList: Array<FamilyMemberSenior>;
  /** Reads and enables pagination through a set of `Feedback`. */
  feedbacks: FeedbacksConnection;
  /** Reads and enables pagination through a set of `Feedback`. */
  feedbacksList: Array<Feedback>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Group`. */
  groups: UserGroupsManyToManyConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByInvitationInvitedByAndInvitedTo: UserGroupsByInvitationInvitedByAndInvitedToManyToManyConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByInvitationInvitedByAndInvitedToList: Array<Group>;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByMessageAuthorIdAndChatId: UserGroupsByMessageAuthorIdAndChatIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByMessageAuthorIdAndChatIdList: Array<Group>;
  /** Reads and enables pagination through a set of `Group`. */
  groupsList: Array<Group>;
  id: Scalars['UUID']['output'];
  kind: UserType;
  /** Reads a single `KorianUser` that is related to this `User`. */
  korianUser?: Maybe<KorianUser>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Returns the current user's licence number */
  licence?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `MediaAlbum`. */
  mediaAlbums: MediaAlbumsConnection;
  /** Reads and enables pagination through a set of `MediaAlbum`. */
  mediaAlbumsList: Array<MediaAlbum>;
  /** Reads a single `Media` that is related to this `User`. */
  mediaByAvatar?: Maybe<Media>;
  /** Reads and enables pagination through a set of `Membership`. */
  memberships: MembershipsConnection;
  /** Reads and enables pagination through a set of `Membership`. */
  membershipsList: Array<Membership>;
  /** Reads and enables pagination through a set of `Message`. */
  messagesAuthored: MessagesConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesAuthoredList: Array<Message>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Note`. */
  notesByNoteSeniorSeniorIdAndNoteId: UserNotesByNoteSeniorSeniorIdAndNoteIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Note`. */
  notesByNoteSeniorSeniorIdAndNoteIdList: Array<Note>;
  /** Reads a single `OrganizationManager` that is related to this `User`. */
  organizationManager?: Maybe<OrganizationManager>;
  /**
   * Reads and enables pagination through a set of `OrganizationManager`.
   * @deprecated Please use organizationManager instead
   */
  organizationManagers: OrganizationManagersConnection;
  /** Reads and enables pagination through a set of `OrganizationPractitioner`. */
  organizationPractitionersByPractitionerId: OrganizationPractitionersConnection;
  /** Reads and enables pagination through a set of `OrganizationPractitioner`. */
  organizationPractitionersByPractitionerIdList: Array<OrganizationPractitioner>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationPractitionerPractitionerIdAndOrganizationId: UserOrganizationsByOrganizationPractitionerPractitionerIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationPractitionerPractitionerIdAndOrganizationIdList: Array<Organization>;
  /** Reads a single `Patient` that is related to this `User`. */
  patient?: Maybe<Patient>;
  /**
   * Reads and enables pagination through a set of `Patient`.
   * @deprecated Please use patient instead
   */
  patients: PatientsConnection;
  /** Reads a single `Practitioner` that is related to this `User`. */
  practitioner?: Maybe<Practitioner>;
  /**
   * Reads and enables pagination through a set of `Practitioner`.
   * @deprecated Please use practitioner instead
   */
  practitioners: PractitionersConnection;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByActivitySessionCaregiverIdAndProcedureId: UserProceduresByActivitySessionCaregiverIdAndProcedureIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Procedure`. */
  proceduresByActivitySessionCaregiverIdAndProcedureIdList: Array<Procedure>;
  salutation?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivities: UserContentActivitiesConnection;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesBySeniorProfileId: UserContentActivitiesConnection;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesBySeniorProfileIdList: Array<UserContentActivity>;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesList: Array<UserContentActivity>;
  /** Reads a single `UserSetting` that is related to this `User`. */
  userSetting?: Maybe<UserSetting>;
  /**
   * Reads and enables pagination through a set of `UserSetting`.
   * @deprecated Please use userSetting instead
   */
  userSettings: UserSettingsConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByCaregiverSeniorCaregiverIdAndSeniorId: UserUsersByCaregiverSeniorCaregiverIdAndSeniorIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByCaregiverSeniorCaregiverIdAndSeniorIdList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByCaregiverSeniorSeniorIdAndCaregiverId: UserUsersByCaregiverSeniorSeniorIdAndCaregiverIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByCaregiverSeniorSeniorIdAndCaregiverIdList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByCheckInAuthorIdAndSeniorId: UserUsersByCheckInAuthorIdAndSeniorIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByCheckInAuthorIdAndSeniorIdList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByCheckInSeniorIdAndAuthorId: UserUsersByCheckInSeniorIdAndAuthorIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByCheckInSeniorIdAndAuthorIdList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByFamilyMemberSeniorFamilyMemberIdAndSeniorId: UserUsersByFamilyMemberSeniorFamilyMemberIdAndSeniorIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByFamilyMemberSeniorFamilyMemberIdAndSeniorIdList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByFamilyMemberSeniorSeniorIdAndFamilyMemberId: UserUsersByFamilyMemberSeniorSeniorIdAndFamilyMemberIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByFamilyMemberSeniorSeniorIdAndFamilyMemberIdList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentActivitySeniorProfileIdAndUserId: UserUsersByUserContentActivitySeniorProfileIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentActivitySeniorProfileIdAndUserIdList: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentActivityUserIdAndSeniorProfileId: UserUsersByUserContentActivityUserIdAndSeniorProfileIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserContentActivityUserIdAndSeniorProfileIdList: Array<User>;
  /** Reads and enables pagination through a set of `Website`. */
  websites: WebsitesConnection;
  /** Reads and enables pagination through a set of `Website`. */
  websitesList: Array<Website>;
  /** Reads and enables pagination through a set of `WorkgroupMembership`. */
  workgroupMembershipsByMemberId: WorkgroupMembershipsConnection;
  /** Reads and enables pagination through a set of `WorkgroupMembership`. */
  workgroupMembershipsByMemberIdList: Array<WorkgroupMembership>;
  /** Reads and enables pagination through a set of `Workgroup`. */
  workgroupsByWorkgroupMembershipMemberIdAndWorkgroupId: UserWorkgroupsByWorkgroupMembershipMemberIdAndWorkgroupIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Workgroup`. */
  workgroupsByWorkgroupMembershipMemberIdAndWorkgroupIdList: Array<Workgroup>;
};


export type UserActivitiesByActivitySessionCaregiverIdAndActivityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitiesOrderBy>>;
};


export type UserActivitiesByActivitySessionCaregiverIdAndActivityIdListArgs = {
  condition?: InputMaybe<ActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitiesOrderBy>>;
};


export type UserActivityGoalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivityGoalCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityGoalsOrderBy>>;
};


export type UserActivityGoalsListArgs = {
  condition?: InputMaybe<ActivityGoalCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityGoalsOrderBy>>;
};


export type UserActivityParticipantsBySeniorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivityParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityParticipantsOrderBy>>;
};


export type UserActivityParticipantsBySeniorIdListArgs = {
  condition?: InputMaybe<ActivityParticipantCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityParticipantsOrderBy>>;
};


export type UserActivitySessionsByActivityParticipantSeniorIdAndActivitySessionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


export type UserActivitySessionsByActivityParticipantSeniorIdAndActivitySessionIdListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


export type UserActivitySessionsByCaregiverIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


export type UserActivitySessionsByCaregiverIdListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


export type UserAppSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AppSettingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AppSettingsOrderBy>>;
};


export type UserAppSettingsListArgs = {
  condition?: InputMaybe<AppSettingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AppSettingsOrderBy>>;
};


export type UserAuthoredCheckInMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};


export type UserAuthoredCheckInMessagesListArgs = {
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};


export type UserAuthoredCheckInsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


export type UserAuthoredCheckInsListArgs = {
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


export type UserAuthoredFormResponsesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FormResponseCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FormResponsesOrderBy>>;
};


export type UserAuthoredFormResponsesListArgs = {
  condition?: InputMaybe<FormResponseCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FormResponsesOrderBy>>;
};


export type UserAuthoredNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


export type UserAuthoredNotesListArgs = {
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


export type UserCaregiverSeniorsByCaregiverIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaregiverSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaregiverSeniorsOrderBy>>;
};


export type UserCaregiverSeniorsByCaregiverIdListArgs = {
  condition?: InputMaybe<CaregiverSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaregiverSeniorsOrderBy>>;
};


export type UserCaregiverSeniorsBySeniorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CaregiverSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaregiverSeniorsOrderBy>>;
};


export type UserCaregiverSeniorsBySeniorIdListArgs = {
  condition?: InputMaybe<CaregiverSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CaregiverSeniorsOrderBy>>;
};


export type UserCheckInsByCheckInMessageAuthorIdAndCheckInIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


export type UserCheckInsByCheckInMessageAuthorIdAndCheckInIdListArgs = {
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


export type UserCheckInsBySeniorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


export type UserCheckInsBySeniorIdListArgs = {
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


export type UserContentsByUserContentActivitySeniorProfileIdAndContentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentsOrderBy>>;
};


export type UserContentsByUserContentActivitySeniorProfileIdAndContentIdListArgs = {
  condition?: InputMaybe<ContentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentsOrderBy>>;
};


export type UserContentsByUserContentActivityUserIdAndContentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentsOrderBy>>;
};


export type UserContentsByUserContentActivityUserIdAndContentIdListArgs = {
  condition?: InputMaybe<ContentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentsOrderBy>>;
};


export type UserContentsByUserContentFavoriteUserIdAndContentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentsOrderBy>>;
};


export type UserContentsByUserContentFavoriteUserIdAndContentIdListArgs = {
  condition?: InputMaybe<ContentCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContentsOrderBy>>;
};


export type UserFamilyMemberSeniorsByFamilyMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FamilyMemberSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FamilyMemberSeniorsOrderBy>>;
};


export type UserFamilyMemberSeniorsByFamilyMemberIdListArgs = {
  condition?: InputMaybe<FamilyMemberSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FamilyMemberSeniorsOrderBy>>;
};


export type UserFamilyMemberSeniorsBySeniorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FamilyMemberSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FamilyMemberSeniorsOrderBy>>;
};


export type UserFamilyMemberSeniorsBySeniorIdListArgs = {
  condition?: InputMaybe<FamilyMemberSeniorCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FamilyMemberSeniorsOrderBy>>;
};


export type UserFeedbacksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FeedbackCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeedbacksOrderBy>>;
};


export type UserFeedbacksListArgs = {
  condition?: InputMaybe<FeedbackCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeedbacksOrderBy>>;
};


export type UserGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserGroupsByInvitationInvitedByAndInvitedToArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserGroupsByInvitationInvitedByAndInvitedToListArgs = {
  condition?: InputMaybe<GroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserGroupsByMessageAuthorIdAndChatIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserGroupsByMessageAuthorIdAndChatIdListArgs = {
  condition?: InputMaybe<GroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserGroupsListArgs = {
  condition?: InputMaybe<GroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserMediaAlbumsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MediaAlbumCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaAlbumsOrderBy>>;
};


export type UserMediaAlbumsListArgs = {
  condition?: InputMaybe<MediaAlbumCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaAlbumsOrderBy>>;
};


export type UserMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type UserMembershipsListArgs = {
  condition?: InputMaybe<MembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type UserMessagesAuthoredArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type UserMessagesAuthoredListArgs = {
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type UserNotesByNoteSeniorSeniorIdAndNoteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


export type UserNotesByNoteSeniorSeniorIdAndNoteIdListArgs = {
  condition?: InputMaybe<NoteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
};


export type UserOrganizationManagersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationManagerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationManagersOrderBy>>;
};


export type UserOrganizationPractitionersByPractitionerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationPractitionersOrderBy>>;
};


export type UserOrganizationPractitionersByPractitionerIdListArgs = {
  condition?: InputMaybe<OrganizationPractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationPractitionersOrderBy>>;
};


export type UserOrganizationsByOrganizationPractitionerPractitionerIdAndOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type UserOrganizationsByOrganizationPractitionerPractitionerIdAndOrganizationIdListArgs = {
  condition?: InputMaybe<OrganizationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type UserPatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PatientCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientsOrderBy>>;
};


export type UserPractitionersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PractitionerCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PractitionersOrderBy>>;
};


export type UserProceduresByActivitySessionCaregiverIdAndProcedureIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


export type UserProceduresByActivitySessionCaregiverIdAndProcedureIdListArgs = {
  condition?: InputMaybe<ProcedureCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy>>;
};


export type UserUserContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


export type UserUserContentActivitiesBySeniorProfileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


export type UserUserContentActivitiesBySeniorProfileIdListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


export type UserUserContentActivitiesListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


export type UserUserSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserSettingCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};


export type UserUsersByCaregiverSeniorCaregiverIdAndSeniorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByCaregiverSeniorCaregiverIdAndSeniorIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByCaregiverSeniorSeniorIdAndCaregiverIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByCaregiverSeniorSeniorIdAndCaregiverIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByCheckInAuthorIdAndSeniorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByCheckInAuthorIdAndSeniorIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByCheckInSeniorIdAndAuthorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByCheckInSeniorIdAndAuthorIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByFamilyMemberSeniorFamilyMemberIdAndSeniorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByFamilyMemberSeniorFamilyMemberIdAndSeniorIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByFamilyMemberSeniorSeniorIdAndFamilyMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByFamilyMemberSeniorSeniorIdAndFamilyMemberIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByUserContentActivitySeniorProfileIdAndUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByUserContentActivitySeniorProfileIdAndUserIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByUserContentActivityUserIdAndSeniorProfileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserUsersByUserContentActivityUserIdAndSeniorProfileIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type UserWebsitesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WebsiteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WebsitesOrderBy>>;
};


export type UserWebsitesListArgs = {
  condition?: InputMaybe<WebsiteCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WebsitesOrderBy>>;
};


export type UserWorkgroupMembershipsByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkgroupMembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupMembershipsOrderBy>>;
};


export type UserWorkgroupMembershipsByMemberIdListArgs = {
  condition?: InputMaybe<WorkgroupMembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupMembershipsOrderBy>>;
};


export type UserWorkgroupsByWorkgroupMembershipMemberIdAndWorkgroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkgroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupsOrderBy>>;
};


export type UserWorkgroupsByWorkgroupMembershipMemberIdAndWorkgroupIdListArgs = {
  condition?: InputMaybe<WorkgroupCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupsOrderBy>>;
};

/** A connection to a list of `Activity` values, with data from `ActivitySession`. */
export type UserActivitiesByActivitySessionCaregiverIdAndActivityIdManyToManyConnection = {
  __typename?: 'UserActivitiesByActivitySessionCaregiverIdAndActivityIdManyToManyConnection';
  /** A list of edges which contains the `Activity`, info from the `ActivitySession`, and the cursor to aid in pagination. */
  edges: Array<UserActivitiesByActivitySessionCaregiverIdAndActivityIdManyToManyEdge>;
  /** A list of `Activity` objects. */
  nodes: Array<Activity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Activity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Activity` edge in the connection, with data from `ActivitySession`. */
export type UserActivitiesByActivitySessionCaregiverIdAndActivityIdManyToManyEdge = {
  __typename?: 'UserActivitiesByActivitySessionCaregiverIdAndActivityIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessions: ActivitySessionsConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsList: Array<ActivitySession>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Activity` at the end of the edge. */
  node: Activity;
};


/** A `Activity` edge in the connection, with data from `ActivitySession`. */
export type UserActivitiesByActivitySessionCaregiverIdAndActivityIdManyToManyEdgeActivitySessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** A `Activity` edge in the connection, with data from `ActivitySession`. */
export type UserActivitiesByActivitySessionCaregiverIdAndActivityIdManyToManyEdgeActivitySessionsListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};

/** A connection to a list of `ActivitySession` values, with data from `ActivityParticipant`. */
export type UserActivitySessionsByActivityParticipantSeniorIdAndActivitySessionIdManyToManyConnection = {
  __typename?: 'UserActivitySessionsByActivityParticipantSeniorIdAndActivitySessionIdManyToManyConnection';
  /** A list of edges which contains the `ActivitySession`, info from the `ActivityParticipant`, and the cursor to aid in pagination. */
  edges: Array<UserActivitySessionsByActivityParticipantSeniorIdAndActivitySessionIdManyToManyEdge>;
  /** A list of `ActivitySession` objects. */
  nodes: Array<ActivitySession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActivitySession` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActivitySession` edge in the connection, with data from `ActivityParticipant`. */
export type UserActivitySessionsByActivityParticipantSeniorIdAndActivitySessionIdManyToManyEdge = {
  __typename?: 'UserActivitySessionsByActivityParticipantSeniorIdAndActivitySessionIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** When this participant's Activity documentation was filed. NULL means their part is still a draft. */
  documentationPublishedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  /** The `ActivitySession` at the end of the edge. */
  node: ActivitySession;
};

/** Input for the nested mutation of `media` in the `UserInput` mutation. */
export type UserAvatarMediaFkeyInput = {
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectById?: InputMaybe<MediaMediaPkeyConnect>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MediaNodeIdConnect>;
  /** A `MediaInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserAvatarMediaFkeyMediaCreateInput>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteById?: InputMaybe<MediaMediaPkeyDelete>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<MediaNodeIdDelete>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateById?: InputMaybe<MediaOnUserForUserAvatarMediaFkeyUsingMediaPkeyUpdate>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserOnUserForUserAvatarMediaFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `user` in the `MediaInput` mutation. */
export type UserAvatarMediaFkeyInverseInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserUserPkeyConnect>>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserNodeIdConnect>>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserAvatarMediaFkeyUserCreateInput>>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserUserPkeyDelete>>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<UserNodeIdDelete>>;
  /** Flag indicating whether all other `user` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserForUserAvatarMediaFkeyUsingUserPkeyUpdate>>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<MediaOnUserForUserAvatarMediaFkeyNodeIdUpdate>>;
};

/** The `media` to be created by this mutation. */
export type UserAvatarMediaFkeyMediaCreateInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** The `user` to be created by this mutation. */
export type UserAvatarMediaFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** All input for the `userCanAccessCheckIn` mutation. */
export type UserCanAccessCheckInInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pCheckInId?: InputMaybe<Scalars['UUID']['input']>;
  pUserId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `userCanAccessCheckIn` mutation. */
export type UserCanAccessCheckInPayload = {
  __typename?: 'UserCanAccessCheckInPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `CheckIn` values, with data from `CheckInMessage`. */
export type UserCheckInsByCheckInMessageAuthorIdAndCheckInIdManyToManyConnection = {
  __typename?: 'UserCheckInsByCheckInMessageAuthorIdAndCheckInIdManyToManyConnection';
  /** A list of edges which contains the `CheckIn`, info from the `CheckInMessage`, and the cursor to aid in pagination. */
  edges: Array<UserCheckInsByCheckInMessageAuthorIdAndCheckInIdManyToManyEdge>;
  /** A list of `CheckIn` objects. */
  nodes: Array<CheckIn>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckIn` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CheckIn` edge in the connection, with data from `CheckInMessage`. */
export type UserCheckInsByCheckInMessageAuthorIdAndCheckInIdManyToManyEdge = {
  __typename?: 'UserCheckInsByCheckInMessageAuthorIdAndCheckInIdManyToManyEdge';
  /** Reads and enables pagination through a set of `CheckInMessage`. */
  checkInMessages: CheckInMessagesConnection;
  /** Reads and enables pagination through a set of `CheckInMessage`. */
  checkInMessagesList: Array<CheckInMessage>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CheckIn` at the end of the edge. */
  node: CheckIn;
};


/** A `CheckIn` edge in the connection, with data from `CheckInMessage`. */
export type UserCheckInsByCheckInMessageAuthorIdAndCheckInIdManyToManyEdgeCheckInMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};


/** A `CheckIn` edge in the connection, with data from `CheckInMessage`. */
export type UserCheckInsByCheckInMessageAuthorIdAndCheckInIdManyToManyEdgeCheckInMessagesListArgs = {
  condition?: InputMaybe<CheckInMessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInMessagesOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `avatar` field. */
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<UserType>;
};

/** A connection to a list of `UserContentActivity` values. */
export type UserContentActivitiesConnection = {
  __typename?: 'UserContentActivitiesConnection';
  /** A list of edges which contains the `UserContentActivity` and cursor to aid in pagination. */
  edges: Array<UserContentActivitiesEdge>;
  /** A list of `UserContentActivity` objects. */
  nodes: Array<UserContentActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserContentActivity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserContentActivity` edge in the connection. */
export type UserContentActivitiesEdge = {
  __typename?: 'UserContentActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserContentActivity` at the end of the edge. */
  node: UserContentActivity;
};

/** Methods to use when ordering `UserContentActivity`. */
export enum UserContentActivitiesOrderBy {
  BeganAtAsc = 'BEGAN_AT_ASC',
  BeganAtDesc = 'BEGAN_AT_DESC',
  ContentIdAsc = 'CONTENT_ID_ASC',
  ContentIdDesc = 'CONTENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SeniorProfileIdAsc = 'SENIOR_PROFILE_ID_ASC',
  SeniorProfileIdDesc = 'SENIOR_PROFILE_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserContentActivity = Node & {
  __typename?: 'UserContentActivity';
  beganAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Content` that is related to this `UserContentActivity`. */
  content?: Maybe<Content>;
  contentId: Scalars['UUID']['output'];
  customActivityName?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `UserContentActivity`. */
  seniorProfile?: Maybe<User>;
  seniorProfileId?: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `User` that is related to this `UserContentActivity`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UserContentActivity` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserContentActivityCondition = {
  /** Checks for equality with the object’s `beganAt` field. */
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `contentId` field. */
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `seniorProfileId` field. */
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for the nested mutation of `content` in the `UserContentActivityInput` mutation. */
export type UserContentActivityContentIdFkeyInput = {
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByCmsContentIdAndCmsContentKind?: InputMaybe<ContentUniqueContentItemsConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByCmsNextContentIdAndCmsNextContentKind?: InputMaybe<ContentUniqueCmsNextContentItemsConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectById?: InputMaybe<ContentContentPkeyConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContentNodeIdConnect>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByCmsContentIdAndCmsContentKind?: InputMaybe<ContentOnUserContentActivityForUserContentActivityContentIdFkeyUsingUniqueContentItemsUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByCmsNextContentIdAndCmsNextContentKind?: InputMaybe<ContentOnUserContentActivityForUserContentActivityContentIdFkeyUsingUniqueCmsNextContentItemsUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateById?: InputMaybe<ContentOnUserContentActivityForUserContentActivityContentIdFkeyUsingContentPkeyUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserContentActivityOnUserContentActivityForUserContentActivityContentIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `userContentActivity` in the `ContentInput` mutation. */
export type UserContentActivityContentIdFkeyInverseInput = {
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserContentActivityUserContentActivityPkeyConnect>>;
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserContentActivityNodeIdConnect>>;
  /** A `UserContentActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserContentActivityContentIdFkeyUserContentActivityCreateInput>>;
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserContentActivityUserContentActivityPkeyDelete>>;
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<UserContentActivityNodeIdDelete>>;
  /** Flag indicating whether all other `userContentActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `userContentActivity` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserContentActivityOnUserContentActivityForUserContentActivityContentIdFkeyUsingUserContentActivityPkeyUpdate>>;
  /** The primary key(s) and patch data for `userContentActivity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContentOnUserContentActivityForUserContentActivityContentIdFkeyNodeIdUpdate>>;
};

/** The `userContentActivity` to be created by this mutation. */
export type UserContentActivityContentIdFkeyUserContentActivityCreateInput = {
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  contentToContentId?: InputMaybe<UserContentActivityContentIdFkeyInput>;
  customActivityName?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorProfileId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInput>;
  userToUserId?: InputMaybe<UserContentActivityUserIdFkeyInput>;
};

/** An input for mutations affecting `UserContentActivity` */
export type UserContentActivityInput = {
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<UserContentActivityContentIdFkeyInput>;
  customActivityName?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorProfileId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInput>;
  userToUserId?: InputMaybe<UserContentActivityUserIdFkeyInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type UserContentActivityNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userContentActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type UserContentActivityNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userContentActivity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type UserContentActivityOnUserContentActivityForUserContentActivityContentIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `content` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: ContentPatch;
};

/** The fields on `userContentActivity` to look up the row to update. */
export type UserContentActivityOnUserContentActivityForUserContentActivityContentIdFkeyUsingUserContentActivityPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `userContentActivity` being updated. */
  patch: UpdateUserContentActivityOnUserContentActivityForUserContentActivityContentIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserContentActivityOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `userContentActivity` to look up the row to update. */
export type UserContentActivityOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyUsingUserContentActivityPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `userContentActivity` being updated. */
  patch: UpdateUserContentActivityOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserContentActivityOnUserContentActivityForUserContentActivityUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `userContentActivity` to look up the row to update. */
export type UserContentActivityOnUserContentActivityForUserContentActivityUserIdFkeyUsingUserContentActivityPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `userContentActivity` being updated. */
  patch: UpdateUserContentActivityOnUserContentActivityForUserContentActivityUserIdFkeyPatch;
};

/** Represents an update to a `UserContentActivity`. Fields that are set will be updated. */
export type UserContentActivityPatch = {
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<UserContentActivityContentIdFkeyInput>;
  customActivityName?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorProfileId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInput>;
  userToUserId?: InputMaybe<UserContentActivityUserIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `UserContentActivityInput` mutation. */
export type UserContentActivitySeniorProfileIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserContentActivitySeniorProfileIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserContentActivityOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `userContentActivity` in the `UserInput` mutation. */
export type UserContentActivitySeniorProfileIdFkeyInverseInput = {
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserContentActivityUserContentActivityPkeyConnect>>;
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserContentActivityNodeIdConnect>>;
  /** A `UserContentActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserContentActivitySeniorProfileIdFkeyUserContentActivityCreateInput>>;
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserContentActivityUserContentActivityPkeyDelete>>;
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<UserContentActivityNodeIdDelete>>;
  /** Flag indicating whether all other `userContentActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `userContentActivity` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserContentActivityOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyUsingUserContentActivityPkeyUpdate>>;
  /** The primary key(s) and patch data for `userContentActivity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyNodeIdUpdate>>;
};

/** The `userContentActivity` to be created by this mutation. */
export type UserContentActivitySeniorProfileIdFkeyUserContentActivityCreateInput = {
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<UserContentActivityContentIdFkeyInput>;
  customActivityName?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorProfileId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInput>;
  userToUserId?: InputMaybe<UserContentActivityUserIdFkeyInput>;
};

/** The `user` to be created by this mutation. */
export type UserContentActivitySeniorProfileIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The fields on `userContentActivity` to look up the row to connect. */
export type UserContentActivityUserContentActivityPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `userContentActivity` to look up the row to delete. */
export type UserContentActivityUserContentActivityPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `user` in the `UserContentActivityInput` mutation. */
export type UserContentActivityUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserContentActivityUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserContentActivityForUserContentActivityUserIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserContentActivityOnUserContentActivityForUserContentActivityUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `userContentActivity` in the `UserInput` mutation. */
export type UserContentActivityUserIdFkeyInverseInput = {
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserContentActivityUserContentActivityPkeyConnect>>;
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserContentActivityNodeIdConnect>>;
  /** A `UserContentActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserContentActivityUserIdFkeyUserContentActivityCreateInput>>;
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserContentActivityUserContentActivityPkeyDelete>>;
  /** The primary key(s) for `userContentActivity` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<UserContentActivityNodeIdDelete>>;
  /** Flag indicating whether all other `userContentActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `userContentActivity` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserContentActivityOnUserContentActivityForUserContentActivityUserIdFkeyUsingUserContentActivityPkeyUpdate>>;
  /** The primary key(s) and patch data for `userContentActivity` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnUserContentActivityForUserContentActivityUserIdFkeyNodeIdUpdate>>;
};

/** The `userContentActivity` to be created by this mutation. */
export type UserContentActivityUserIdFkeyUserContentActivityCreateInput = {
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<UserContentActivityContentIdFkeyInput>;
  customActivityName?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorProfileId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInput>;
  userToUserId?: InputMaybe<UserContentActivityUserIdFkeyInput>;
};

/** The `user` to be created by this mutation. */
export type UserContentActivityUserIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

export type UserContentFavorite = Node & {
  __typename?: 'UserContentFavorite';
  /** Reads a single `Content` that is related to this `UserContentFavorite`. */
  content?: Maybe<Content>;
  contentId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `UserContentFavorite`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UserContentFavorite` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserContentFavoriteCondition = {
  /** Checks for equality with the object’s `contentId` field. */
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for the nested mutation of `content` in the `UserContentFavoriteInput` mutation. */
export type UserContentFavoriteContentIdFkeyInput = {
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByCmsContentIdAndCmsContentKind?: InputMaybe<ContentUniqueContentItemsConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByCmsNextContentIdAndCmsNextContentKind?: InputMaybe<ContentUniqueCmsNextContentItemsConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectById?: InputMaybe<ContentContentPkeyConnect>;
  /** The primary key(s) for `content` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<ContentNodeIdConnect>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByCmsContentIdAndCmsContentKind?: InputMaybe<ContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingUniqueContentItemsUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByCmsNextContentIdAndCmsNextContentKind?: InputMaybe<ContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingUniqueCmsNextContentItemsUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateById?: InputMaybe<ContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingContentPkeyUpdate>;
  /** The primary key(s) and patch data for `content` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteContentIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `userContentFavorite` in the `ContentInput` mutation. */
export type UserContentFavoriteContentIdFkeyInverseInput = {
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserContentFavoriteUserContentFavoritePkeyConnect>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserContentFavoriteNodeIdConnect>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  connectByUserIdAndContentId?: InputMaybe<Array<UserContentFavoriteUniqueContentFavoritesConnect>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserContentFavoriteUserContentFavoritePkeyDelete>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<UserContentFavoriteNodeIdDelete>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  deleteByUserIdAndContentId?: InputMaybe<Array<UserContentFavoriteUniqueContentFavoritesDelete>>;
  /** Flag indicating whether all other `userContentFavorite` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `userContentFavorite` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingUserContentFavoritePkeyUpdate>>;
  /** The primary key(s) and patch data for `userContentFavorite` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<ContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `userContentFavorite` for the far side of the relationship. */
  updateByUserIdAndContentId?: InputMaybe<Array<UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingUniqueContentFavoritesUpdate>>;
};

/** The globally unique `ID` look up for the row to connect. */
export type UserContentFavoriteNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userContentFavorite` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type UserContentFavoriteNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userContentFavorite` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteContentIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `content` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `content` being updated. */
  patch: ContentPatch;
};

/** The fields on `userContentFavorite` to look up the row to update. */
export type UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingUniqueContentFavoritesUpdate = {
  contentId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `userContentFavorite` being updated. */
  patch: UpdateUserContentFavoriteOnUserContentFavoriteForUserContentFavoriteContentIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** The fields on `userContentFavorite` to look up the row to update. */
export type UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteContentIdFkeyUsingUserContentFavoritePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `userContentFavorite` being updated. */
  patch: UpdateUserContentFavoriteOnUserContentFavoriteForUserContentFavoriteContentIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `userContentFavorite` to look up the row to update. */
export type UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteUserIdFkeyUsingUniqueContentFavoritesUpdate = {
  contentId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `userContentFavorite` being updated. */
  patch: UpdateUserContentFavoriteOnUserContentFavoriteForUserContentFavoriteUserIdFkeyPatch;
  userId: Scalars['UUID']['input'];
};

/** The fields on `userContentFavorite` to look up the row to update. */
export type UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteUserIdFkeyUsingUserContentFavoritePkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `userContentFavorite` being updated. */
  patch: UpdateUserContentFavoriteOnUserContentFavoriteForUserContentFavoriteUserIdFkeyPatch;
};

/** Represents an update to a `UserContentFavorite`. Fields that are set will be updated. */
export type UserContentFavoritePatch = {
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<UserContentFavoriteContentIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<UserContentFavoriteUserIdFkeyInput>;
};

/** The fields on `userContentFavorite` to look up the row to connect. */
export type UserContentFavoriteUniqueContentFavoritesConnect = {
  contentId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

/** The fields on `userContentFavorite` to look up the row to delete. */
export type UserContentFavoriteUniqueContentFavoritesDelete = {
  contentId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

/** The fields on `userContentFavorite` to look up the row to connect. */
export type UserContentFavoriteUserContentFavoritePkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `userContentFavorite` to look up the row to delete. */
export type UserContentFavoriteUserContentFavoritePkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** Input for the nested mutation of `user` in the `UserContentFavoriteInput` mutation. */
export type UserContentFavoriteUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserContentFavoriteUserIdFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserContentFavoriteForUserContentFavoriteUserIdFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteUserIdFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `userContentFavorite` in the `UserInput` mutation. */
export type UserContentFavoriteUserIdFkeyInverseInput = {
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserContentFavoriteUserContentFavoritePkeyConnect>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserContentFavoriteNodeIdConnect>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  connectByUserIdAndContentId?: InputMaybe<Array<UserContentFavoriteUniqueContentFavoritesConnect>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserContentFavoriteUserContentFavoritePkeyDelete>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<UserContentFavoriteNodeIdDelete>>;
  /** The primary key(s) for `userContentFavorite` for the far side of the relationship. */
  deleteByUserIdAndContentId?: InputMaybe<Array<UserContentFavoriteUniqueContentFavoritesDelete>>;
  /** Flag indicating whether all other `userContentFavorite` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `userContentFavorite` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteUserIdFkeyUsingUserContentFavoritePkeyUpdate>>;
  /** The primary key(s) and patch data for `userContentFavorite` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnUserContentFavoriteForUserContentFavoriteUserIdFkeyNodeIdUpdate>>;
  /** The primary key(s) and patch data for `userContentFavorite` for the far side of the relationship. */
  updateByUserIdAndContentId?: InputMaybe<Array<UserContentFavoriteOnUserContentFavoriteForUserContentFavoriteUserIdFkeyUsingUniqueContentFavoritesUpdate>>;
};

/** The `user` to be created by this mutation. */
export type UserContentFavoriteUserIdFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `UserContentFavorite` values. */
export type UserContentFavoritesConnection = {
  __typename?: 'UserContentFavoritesConnection';
  /** A list of edges which contains the `UserContentFavorite` and cursor to aid in pagination. */
  edges: Array<UserContentFavoritesEdge>;
  /** A list of `UserContentFavorite` objects. */
  nodes: Array<UserContentFavorite>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserContentFavorite` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserContentFavorite` edge in the connection. */
export type UserContentFavoritesEdge = {
  __typename?: 'UserContentFavoritesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserContentFavorite` at the end of the edge. */
  node: UserContentFavorite;
};

/** Methods to use when ordering `UserContentFavorite`. */
export enum UserContentFavoritesOrderBy {
  ContentIdAsc = 'CONTENT_ID_ASC',
  ContentIdDesc = 'CONTENT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A connection to a list of `Content` values, with data from `UserContentActivity`. */
export type UserContentsByUserContentActivitySeniorProfileIdAndContentIdManyToManyConnection = {
  __typename?: 'UserContentsByUserContentActivitySeniorProfileIdAndContentIdManyToManyConnection';
  /** A list of edges which contains the `Content`, info from the `UserContentActivity`, and the cursor to aid in pagination. */
  edges: Array<UserContentsByUserContentActivitySeniorProfileIdAndContentIdManyToManyEdge>;
  /** A list of `Content` objects. */
  nodes: Array<Content>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Content` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Content` edge in the connection, with data from `UserContentActivity`. */
export type UserContentsByUserContentActivitySeniorProfileIdAndContentIdManyToManyEdge = {
  __typename?: 'UserContentsByUserContentActivitySeniorProfileIdAndContentIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Content` at the end of the edge. */
  node: Content;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivities: UserContentActivitiesConnection;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesList: Array<UserContentActivity>;
};


/** A `Content` edge in the connection, with data from `UserContentActivity`. */
export type UserContentsByUserContentActivitySeniorProfileIdAndContentIdManyToManyEdgeUserContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


/** A `Content` edge in the connection, with data from `UserContentActivity`. */
export type UserContentsByUserContentActivitySeniorProfileIdAndContentIdManyToManyEdgeUserContentActivitiesListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};

/** A connection to a list of `Content` values, with data from `UserContentActivity`. */
export type UserContentsByUserContentActivityUserIdAndContentIdManyToManyConnection = {
  __typename?: 'UserContentsByUserContentActivityUserIdAndContentIdManyToManyConnection';
  /** A list of edges which contains the `Content`, info from the `UserContentActivity`, and the cursor to aid in pagination. */
  edges: Array<UserContentsByUserContentActivityUserIdAndContentIdManyToManyEdge>;
  /** A list of `Content` objects. */
  nodes: Array<Content>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Content` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Content` edge in the connection, with data from `UserContentActivity`. */
export type UserContentsByUserContentActivityUserIdAndContentIdManyToManyEdge = {
  __typename?: 'UserContentsByUserContentActivityUserIdAndContentIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Content` at the end of the edge. */
  node: Content;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivities: UserContentActivitiesConnection;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesList: Array<UserContentActivity>;
};


/** A `Content` edge in the connection, with data from `UserContentActivity`. */
export type UserContentsByUserContentActivityUserIdAndContentIdManyToManyEdgeUserContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


/** A `Content` edge in the connection, with data from `UserContentActivity`. */
export type UserContentsByUserContentActivityUserIdAndContentIdManyToManyEdgeUserContentActivitiesListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};

/** A connection to a list of `Content` values, with data from `UserContentFavorite`. */
export type UserContentsByUserContentFavoriteUserIdAndContentIdManyToManyConnection = {
  __typename?: 'UserContentsByUserContentFavoriteUserIdAndContentIdManyToManyConnection';
  /** A list of edges which contains the `Content`, info from the `UserContentFavorite`, and the cursor to aid in pagination. */
  edges: Array<UserContentsByUserContentFavoriteUserIdAndContentIdManyToManyEdge>;
  /** A list of `Content` objects. */
  nodes: Array<Content>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Content` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Content` edge in the connection, with data from `UserContentFavorite`. */
export type UserContentsByUserContentFavoriteUserIdAndContentIdManyToManyEdge = {
  __typename?: 'UserContentsByUserContentFavoriteUserIdAndContentIdManyToManyEdge';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  id: Scalars['UUID']['output'];
  /** The `Content` at the end of the edge. */
  node: Content;
};

/** A connection to a list of `Group` values, with data from `Invitation`. */
export type UserGroupsByInvitationInvitedByAndInvitedToManyToManyConnection = {
  __typename?: 'UserGroupsByInvitationInvitedByAndInvitedToManyToManyConnection';
  /** A list of edges which contains the `Group`, info from the `Invitation`, and the cursor to aid in pagination. */
  edges: Array<UserGroupsByInvitationInvitedByAndInvitedToManyToManyEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Group>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Group` edge in the connection, with data from `Invitation`. */
export type UserGroupsByInvitationInvitedByAndInvitedToManyToManyEdge = {
  __typename?: 'UserGroupsByInvitationInvitedByAndInvitedToManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Reads and enables pagination through a set of `Invitation`. */
  invitationsByInvitedTo: InvitationsConnection;
  /** Reads and enables pagination through a set of `Invitation`. */
  invitationsByInvitedToList: Array<Invitation>;
  /** The `Group` at the end of the edge. */
  node: Group;
};


/** A `Group` edge in the connection, with data from `Invitation`. */
export type UserGroupsByInvitationInvitedByAndInvitedToManyToManyEdgeInvitationsByInvitedToArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvitationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};


/** A `Group` edge in the connection, with data from `Invitation`. */
export type UserGroupsByInvitationInvitedByAndInvitedToManyToManyEdgeInvitationsByInvitedToListArgs = {
  condition?: InputMaybe<InvitationCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};

/** A connection to a list of `Group` values, with data from `Message`. */
export type UserGroupsByMessageAuthorIdAndChatIdManyToManyConnection = {
  __typename?: 'UserGroupsByMessageAuthorIdAndChatIdManyToManyConnection';
  /** A list of edges which contains the `Group`, info from the `Message`, and the cursor to aid in pagination. */
  edges: Array<UserGroupsByMessageAuthorIdAndChatIdManyToManyEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Group>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Group` edge in the connection, with data from `Message`. */
export type UserGroupsByMessageAuthorIdAndChatIdManyToManyEdge = {
  __typename?: 'UserGroupsByMessageAuthorIdAndChatIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** Reads and enables pagination through a set of `Message`. */
  messages: MessagesConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesList: Array<Message>;
  /** The `Group` at the end of the edge. */
  node: Group;
};


/** A `Group` edge in the connection, with data from `Message`. */
export type UserGroupsByMessageAuthorIdAndChatIdManyToManyEdgeMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


/** A `Group` edge in the connection, with data from `Message`. */
export type UserGroupsByMessageAuthorIdAndChatIdManyToManyEdgeMessagesListArgs = {
  condition?: InputMaybe<MessageCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};

/** A connection to a list of `Group` values, with data from `Membership`. */
export type UserGroupsManyToManyConnection = {
  __typename?: 'UserGroupsManyToManyConnection';
  /** A list of edges which contains the `Group`, info from the `Membership`, and the cursor to aid in pagination. */
  edges: Array<UserGroupsManyToManyEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Group>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Group` edge in the connection, with data from `Membership`. */
export type UserGroupsManyToManyEdge = {
  __typename?: 'UserGroupsManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastRead: Scalars['Datetime']['output'];
  lastReceived?: Maybe<Scalars['Datetime']['output']>;
  /** The `Group` at the end of the edge. */
  node: Group;
};

/** Input for the nested mutation of `user` in the `UserSettingInput` mutation. */
export type UserIdInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserIdUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserSettingForUserIdUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserSettingOnUserSettingForUserIdNodeIdUpdate>;
};

/** Input for the nested mutation of `userSetting` in the `UserInput` mutation. */
export type UserIdInverseInput = {
  /** The primary key(s) for `userSetting` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserSettingNodeIdConnect>;
  /** The primary key(s) for `userSetting` for the far side of the relationship. */
  connectByUserId?: InputMaybe<UserSettingUserSettingsPkeyConnect>;
  /** A `UserSettingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserIdUserSettingsCreateInput>>;
  /** The primary key(s) for `userSetting` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserSettingNodeIdDelete>;
  /** The primary key(s) for `userSetting` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<UserSettingUserSettingsPkeyDelete>;
  /** Flag indicating whether all other `userSetting` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `userSetting` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserOnUserSettingForUserIdNodeIdUpdate>;
  /** The primary key(s) and patch data for `userSetting` for the far side of the relationship. */
  updateByUserId?: InputMaybe<UserSettingOnUserSettingForUserIdUsingUserSettingsPkeyUpdate>;
};

/** The `user` to be created by this mutation. */
export type UserIdUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The `userSetting` to be created by this mutation. */
export type UserIdUserSettingsCreateInput = {
  encryptionMode?: InputMaybe<EncryptionMode>;
  userToUserId?: InputMaybe<UserIdInput>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type UserNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type UserNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `user` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** A connection to a list of `Note` values, with data from `NoteSenior`. */
export type UserNotesByNoteSeniorSeniorIdAndNoteIdManyToManyConnection = {
  __typename?: 'UserNotesByNoteSeniorSeniorIdAndNoteIdManyToManyConnection';
  /** A list of edges which contains the `Note`, info from the `NoteSenior`, and the cursor to aid in pagination. */
  edges: Array<UserNotesByNoteSeniorSeniorIdAndNoteIdManyToManyEdge>;
  /** A list of `Note` objects. */
  nodes: Array<Note>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Note` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Note` edge in the connection, with data from `NoteSenior`. */
export type UserNotesByNoteSeniorSeniorIdAndNoteIdManyToManyEdge = {
  __typename?: 'UserNotesByNoteSeniorSeniorIdAndNoteIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Note` at the end of the edge. */
  node: Note;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnActivityGoalForActivityGoalUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activityGoal` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activityGoal` being updated. */
  patch: ActivityGoalPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnActivityGoalForActivityGoalUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnActivityGoalForActivityGoalUserIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnActivityParticipantForActivityParticipantSeniorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activityParticipant` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activityParticipant` being updated. */
  patch: ActivityParticipantPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnActivityParticipantForActivityParticipantSeniorIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnActivityParticipantForActivityParticipantSeniorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnActivitySessionForActivitySessionCaregiverIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `activitySession` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `activitySession` being updated. */
  patch: ActivitySessionPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnActivitySessionForActivitySessionCaregiverIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnActivitySessionForActivitySessionCaregiverIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnAppSettingForAppSettingUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `appSetting` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `appSetting` being updated. */
  patch: AppSettingPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnAppSettingForAppSettingUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnAppSettingForAppSettingUserIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnCaregiverProfileForCaregiverProfileUserIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `caregiverProfile` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `caregiverProfile` being updated. */
  patch: CaregiverProfilePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnCaregiverProfileForCaregiverProfileUserIdUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnCaregiverProfileForCaregiverProfileUserIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `caregiverSenior` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `caregiverSenior` being updated. */
  patch: CaregiverSeniorPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `caregiverSenior` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `caregiverSenior` being updated. */
  patch: CaregiverSeniorPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnCheckInForCheckInAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `checkIn` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `checkIn` being updated. */
  patch: CheckInPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnCheckInForCheckInAuthorFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnCheckInForCheckInAuthorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnCheckInForCheckInSeniorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `checkIn` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `checkIn` being updated. */
  patch: CheckInPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnCheckInForCheckInSeniorFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnCheckInForCheckInSeniorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnCheckInMessageForCheckInMessageAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `checkInMessage` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `checkInMessage` being updated. */
  patch: CheckInMessagePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnCheckInMessageForCheckInMessageAuthorFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnCheckInMessageForCheckInMessageAuthorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `familyMemberSenior` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `familyMemberSenior` being updated. */
  patch: FamilyMemberSeniorPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `familyMemberSenior` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `familyMemberSenior` being updated. */
  patch: FamilyMemberSeniorPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnFeedbackForFeedbackUserIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `feedback` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `feedback` being updated. */
  patch: FeedbackPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFeedbackForFeedbackUserIdUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFeedbackForFeedbackUserIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnFormResponseForFormResponseAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `formResponse` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `formResponse` being updated. */
  patch: FormResponsePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFormResponseForFormResponseAuthorFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFormResponseForFormResponseAuthorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnInvitationForInvitationInvitedByFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `invitation` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `invitation` being updated. */
  patch: InvitationPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnInvitationForInvitationInvitedByFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnInvitationForInvitationInvitedByFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnKorianUserForKorianUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `korianUser` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `korianUser` being updated. */
  patch: KorianUserPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnKorianUserForKorianUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnKorianUserForKorianUserIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnMediaAlbumForMediaAlbumUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `mediaAlbum` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `mediaAlbum` being updated. */
  patch: MediaAlbumPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnMediaAlbumForMediaAlbumUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnMediaAlbumForMediaAlbumUserIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnMediaNoteForMediaNoteAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `mediaNote` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `mediaNote` being updated. */
  patch: MediaNotePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnMediaNoteForMediaNoteAuthorFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnMediaNoteForMediaNoteAuthorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `mediaVoiceRecording` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `mediaVoiceRecording` being updated. */
  patch: MediaVoiceRecordingPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnMembershipForMembershipMemberIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `membership` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `membership` being updated. */
  patch: MembershipPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnMembershipForMembershipMemberIdUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnMembershipForMembershipMemberIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnMessageForMessageAuthorIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `message` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: MessagePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnMessageForMessageAuthorIdUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnMessageForMessageAuthorIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnNoteForNoteAuthorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `note` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `note` being updated. */
  patch: NotePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnNoteForNoteAuthorIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnNoteForNoteAuthorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnNoteSeniorForNoteSeniorSeniorIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `noteSenior` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `noteSenior` being updated. */
  patch: NoteSeniorPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnNoteSeniorForNoteSeniorSeniorIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnNoteSeniorForNoteSeniorSeniorIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnOrganizationManagerForOrganizationManagersUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organizationManager` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organizationManager` being updated. */
  patch: OrganizationManagerPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnOrganizationManagerForOrganizationManagersUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnOrganizationManagerForOrganizationManagersUserIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnOrganizationPractitionerForFkPractitionerNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `organizationPractitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `organizationPractitioner` being updated. */
  patch: OrganizationPractitionerPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnOrganizationPractitionerForFkPractitionerUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnOrganizationPractitionerForFkPractitionerPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnPatientForFkUserNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `patient` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: PatientPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPatientForFkUserUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPatientForFkUserPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnPractitionerForPractitionerUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `practitioner` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `practitioner` being updated. */
  patch: PractitionerPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPractitionerForPractitionerUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPractitionerForPractitionerUserIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userContentActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `userContentActivity` being updated. */
  patch: UserContentActivityPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserContentActivityForUserContentActivityUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userContentActivity` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `userContentActivity` being updated. */
  patch: UserContentActivityPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserContentActivityForUserContentActivityUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserContentActivityForUserContentActivityUserIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserContentFavoriteForUserContentFavoriteUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userContentFavorite` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `userContentFavorite` being updated. */
  patch: UserContentFavoritePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserContentFavoriteForUserContentFavoriteUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserContentFavoriteForUserContentFavoriteUserIdFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserForUserAvatarMediaFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `media` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `media` being updated. */
  patch: MediaPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserForUserAvatarMediaFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserForUserAvatarMediaFkeyPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserSettingForUserIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userSetting` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `userSetting` being updated. */
  patch: UserSettingPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserSettingForUserIdUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserSettingForUserIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnWebsiteForOwnerUserIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `website` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `website` being updated. */
  patch: WebsitePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnWebsiteForOwnerUserIdUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnWebsiteForOwnerUserIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnWorkgroupMembershipForWorkgroupMembershipMemberIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `workgroupMembership` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `workgroupMembership` being updated. */
  patch: WorkgroupMembershipPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnWorkgroupMembershipForWorkgroupMembershipMemberIdUsingUserPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnWorkgroupMembershipForWorkgroupMembershipMemberIdPatch;
};

/** A connection to a list of `Organization` values, with data from `OrganizationPractitioner`. */
export type UserOrganizationsByOrganizationPractitionerPractitionerIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByOrganizationPractitionerPractitionerIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `OrganizationPractitioner`, and the cursor to aid in pagination. */
  edges: Array<UserOrganizationsByOrganizationPractitionerPractitionerIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organization` edge in the connection, with data from `OrganizationPractitioner`. */
export type UserOrganizationsByOrganizationPractitionerPractitionerIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByOrganizationPractitionerPractitionerIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Organization` at the end of the edge. */
  node: Organization;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** A connection to a list of `Procedure` values, with data from `ActivitySession`. */
export type UserProceduresByActivitySessionCaregiverIdAndProcedureIdManyToManyConnection = {
  __typename?: 'UserProceduresByActivitySessionCaregiverIdAndProcedureIdManyToManyConnection';
  /** A list of edges which contains the `Procedure`, info from the `ActivitySession`, and the cursor to aid in pagination. */
  edges: Array<UserProceduresByActivitySessionCaregiverIdAndProcedureIdManyToManyEdge>;
  /** A list of `Procedure` objects. */
  nodes: Array<Procedure>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Procedure` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Procedure` edge in the connection, with data from `ActivitySession`. */
export type UserProceduresByActivitySessionCaregiverIdAndProcedureIdManyToManyEdge = {
  __typename?: 'UserProceduresByActivitySessionCaregiverIdAndProcedureIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessions: ActivitySessionsConnection;
  /** Reads and enables pagination through a set of `ActivitySession`. */
  activitySessionsList: Array<ActivitySession>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Procedure` at the end of the edge. */
  node: Procedure;
};


/** A `Procedure` edge in the connection, with data from `ActivitySession`. */
export type UserProceduresByActivitySessionCaregiverIdAndProcedureIdManyToManyEdgeActivitySessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};


/** A `Procedure` edge in the connection, with data from `ActivitySession`. */
export type UserProceduresByActivitySessionCaregiverIdAndProcedureIdManyToManyEdgeActivitySessionsListArgs = {
  condition?: InputMaybe<ActivitySessionCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy>>;
};

export type UserProfileInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  avatarMedia?: InputMaybe<AvatarMediaInput>;
  kind?: InputMaybe<UserType>;
  name: Scalars['String']['input'];
};

export type UserRelation = {
  __typename?: 'UserRelation';
  contact1Id?: Maybe<Scalars['UUID']['output']>;
  contact1Kind?: Maybe<UserType>;
  contact2Id?: Maybe<Scalars['UUID']['output']>;
  contact2Kind?: Maybe<UserType>;
  privateChatId?: Maybe<Scalars['UUID']['output']>;
  relatedSeniorId?: Maybe<Scalars['UUID']['output']>;
};

/** A connection to a list of `UserRelation` values. */
export type UserRelationsConnection = {
  __typename?: 'UserRelationsConnection';
  /** A list of edges which contains the `UserRelation` and cursor to aid in pagination. */
  edges: Array<UserRelationsEdge>;
  /** A list of `UserRelation` objects. */
  nodes: Array<UserRelation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRelation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserRelation` edge in the connection. */
export type UserRelationsEdge = {
  __typename?: 'UserRelationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRelation` at the end of the edge. */
  node: UserRelation;
};

/** Methods to use when ordering `UserRelation`. */
export enum UserRelationsOrderBy {
  Natural = 'NATURAL'
}

export type UserSetting = Node & {
  __typename?: 'UserSetting';
  encryptionMode?: Maybe<EncryptionMode>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `UserSetting`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UserSetting` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserSettingCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `UserSetting` */
export type UserSettingInput = {
  encryptionMode?: InputMaybe<EncryptionMode>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<UserIdInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type UserSettingNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userSetting` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type UserSettingNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userSetting` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type UserSettingOnUserSettingForUserIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `userSetting` to look up the row to update. */
export type UserSettingOnUserSettingForUserIdUsingUserSettingsPkeyUpdate = {
  /** An object where the defined keys will be set on the `userSetting` being updated. */
  patch: UpdateUserSettingOnUserSettingForUserIdPatch;
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `UserSetting`. Fields that are set will be updated. */
export type UserSettingPatch = {
  encryptionMode?: InputMaybe<EncryptionMode>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<UserIdInput>;
};

/** The fields on `userSetting` to look up the row to connect. */
export type UserSettingUserSettingsPkeyConnect = {
  userId: Scalars['UUID']['input'];
};

/** The fields on `userSetting` to look up the row to delete. */
export type UserSettingUserSettingsPkeyDelete = {
  userId: Scalars['UUID']['input'];
};

/** A connection to a list of `UserSetting` values. */
export type UserSettingsConnection = {
  __typename?: 'UserSettingsConnection';
  /** A list of edges which contains the `UserSetting` and cursor to aid in pagination. */
  edges: Array<UserSettingsEdge>;
  /** A list of `UserSetting` objects. */
  nodes: Array<UserSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserSetting` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserSetting` edge in the connection. */
export type UserSettingsEdge = {
  __typename?: 'UserSettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserSetting` at the end of the edge. */
  node: UserSetting;
};

/** Methods to use when ordering `UserSetting`. */
export enum UserSettingsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export enum UserType {
  Analytics = 'ANALYTICS',
  Bot = 'BOT',
  Caregiver = 'CAREGIVER',
  Customer = 'CUSTOMER',
  CustomerService = 'CUSTOMER_SERVICE',
  Manager = 'MANAGER',
  Redurisk = 'REDURISK',
  Relative = 'RELATIVE',
  Senior = 'SENIOR'
}

/** The fields on `user` to look up the row to connect. */
export type UserUserPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `user` to look up the row to delete. */
export type UserUserPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `User` values, with data from `CaregiverSenior`. */
export type UserUsersByCaregiverSeniorCaregiverIdAndSeniorIdManyToManyConnection = {
  __typename?: 'UserUsersByCaregiverSeniorCaregiverIdAndSeniorIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `CaregiverSenior`, and the cursor to aid in pagination. */
  edges: Array<UserUsersByCaregiverSeniorCaregiverIdAndSeniorIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `CaregiverSenior`. */
export type UserUsersByCaregiverSeniorCaregiverIdAndSeniorIdManyToManyEdge = {
  __typename?: 'UserUsersByCaregiverSeniorCaregiverIdAndSeniorIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** A connection to a list of `User` values, with data from `CaregiverSenior`. */
export type UserUsersByCaregiverSeniorSeniorIdAndCaregiverIdManyToManyConnection = {
  __typename?: 'UserUsersByCaregiverSeniorSeniorIdAndCaregiverIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `CaregiverSenior`, and the cursor to aid in pagination. */
  edges: Array<UserUsersByCaregiverSeniorSeniorIdAndCaregiverIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `CaregiverSenior`. */
export type UserUsersByCaregiverSeniorSeniorIdAndCaregiverIdManyToManyEdge = {
  __typename?: 'UserUsersByCaregiverSeniorSeniorIdAndCaregiverIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** A connection to a list of `User` values, with data from `CheckIn`. */
export type UserUsersByCheckInAuthorIdAndSeniorIdManyToManyConnection = {
  __typename?: 'UserUsersByCheckInAuthorIdAndSeniorIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `CheckIn`, and the cursor to aid in pagination. */
  edges: Array<UserUsersByCheckInAuthorIdAndSeniorIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `CheckIn`. */
export type UserUsersByCheckInAuthorIdAndSeniorIdManyToManyEdge = {
  __typename?: 'UserUsersByCheckInAuthorIdAndSeniorIdManyToManyEdge';
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkInsBySeniorId: CheckInsConnection;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkInsBySeniorIdList: Array<CheckIn>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};


/** A `User` edge in the connection, with data from `CheckIn`. */
export type UserUsersByCheckInAuthorIdAndSeniorIdManyToManyEdgeCheckInsBySeniorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


/** A `User` edge in the connection, with data from `CheckIn`. */
export type UserUsersByCheckInAuthorIdAndSeniorIdManyToManyEdgeCheckInsBySeniorIdListArgs = {
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};

/** A connection to a list of `User` values, with data from `CheckIn`. */
export type UserUsersByCheckInSeniorIdAndAuthorIdManyToManyConnection = {
  __typename?: 'UserUsersByCheckInSeniorIdAndAuthorIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `CheckIn`, and the cursor to aid in pagination. */
  edges: Array<UserUsersByCheckInSeniorIdAndAuthorIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `CheckIn`. */
export type UserUsersByCheckInSeniorIdAndAuthorIdManyToManyEdge = {
  __typename?: 'UserUsersByCheckInSeniorIdAndAuthorIdManyToManyEdge';
  /** Reads and enables pagination through a set of `CheckIn`. */
  authoredCheckIns: CheckInsConnection;
  /** Reads and enables pagination through a set of `CheckIn`. */
  authoredCheckInsList: Array<CheckIn>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};


/** A `User` edge in the connection, with data from `CheckIn`. */
export type UserUsersByCheckInSeniorIdAndAuthorIdManyToManyEdgeAuthoredCheckInsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


/** A `User` edge in the connection, with data from `CheckIn`. */
export type UserUsersByCheckInSeniorIdAndAuthorIdManyToManyEdgeAuthoredCheckInsListArgs = {
  condition?: InputMaybe<CheckInCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};

/** A connection to a list of `User` values, with data from `FamilyMemberSenior`. */
export type UserUsersByFamilyMemberSeniorFamilyMemberIdAndSeniorIdManyToManyConnection = {
  __typename?: 'UserUsersByFamilyMemberSeniorFamilyMemberIdAndSeniorIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `FamilyMemberSenior`, and the cursor to aid in pagination. */
  edges: Array<UserUsersByFamilyMemberSeniorFamilyMemberIdAndSeniorIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `FamilyMemberSenior`. */
export type UserUsersByFamilyMemberSeniorFamilyMemberIdAndSeniorIdManyToManyEdge = {
  __typename?: 'UserUsersByFamilyMemberSeniorFamilyMemberIdAndSeniorIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** A connection to a list of `User` values, with data from `FamilyMemberSenior`. */
export type UserUsersByFamilyMemberSeniorSeniorIdAndFamilyMemberIdManyToManyConnection = {
  __typename?: 'UserUsersByFamilyMemberSeniorSeniorIdAndFamilyMemberIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `FamilyMemberSenior`, and the cursor to aid in pagination. */
  edges: Array<UserUsersByFamilyMemberSeniorSeniorIdAndFamilyMemberIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `FamilyMemberSenior`. */
export type UserUsersByFamilyMemberSeniorSeniorIdAndFamilyMemberIdManyToManyEdge = {
  __typename?: 'UserUsersByFamilyMemberSeniorSeniorIdAndFamilyMemberIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** A connection to a list of `User` values, with data from `UserContentActivity`. */
export type UserUsersByUserContentActivitySeniorProfileIdAndUserIdManyToManyConnection = {
  __typename?: 'UserUsersByUserContentActivitySeniorProfileIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UserContentActivity`, and the cursor to aid in pagination. */
  edges: Array<UserUsersByUserContentActivitySeniorProfileIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type UserUsersByUserContentActivitySeniorProfileIdAndUserIdManyToManyEdge = {
  __typename?: 'UserUsersByUserContentActivitySeniorProfileIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivities: UserContentActivitiesConnection;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesList: Array<UserContentActivity>;
};


/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type UserUsersByUserContentActivitySeniorProfileIdAndUserIdManyToManyEdgeUserContentActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type UserUsersByUserContentActivitySeniorProfileIdAndUserIdManyToManyEdgeUserContentActivitiesListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UserContentActivity`. */
export type UserUsersByUserContentActivityUserIdAndSeniorProfileIdManyToManyConnection = {
  __typename?: 'UserUsersByUserContentActivityUserIdAndSeniorProfileIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UserContentActivity`, and the cursor to aid in pagination. */
  edges: Array<UserUsersByUserContentActivityUserIdAndSeniorProfileIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type UserUsersByUserContentActivityUserIdAndSeniorProfileIdManyToManyEdge = {
  __typename?: 'UserUsersByUserContentActivityUserIdAndSeniorProfileIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesBySeniorProfileId: UserContentActivitiesConnection;
  /** Reads and enables pagination through a set of `UserContentActivity`. */
  userContentActivitiesBySeniorProfileIdList: Array<UserContentActivity>;
};


/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type UserUsersByUserContentActivityUserIdAndSeniorProfileIdManyToManyEdgeUserContentActivitiesBySeniorProfileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};


/** A `User` edge in the connection, with data from `UserContentActivity`. */
export type UserUsersByUserContentActivityUserIdAndSeniorProfileIdManyToManyEdgeUserContentActivitiesBySeniorProfileIdListArgs = {
  condition?: InputMaybe<UserContentActivityCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserContentActivitiesOrderBy>>;
};

/** A connection to a list of `Workgroup` values, with data from `WorkgroupMembership`. */
export type UserWorkgroupsByWorkgroupMembershipMemberIdAndWorkgroupIdManyToManyConnection = {
  __typename?: 'UserWorkgroupsByWorkgroupMembershipMemberIdAndWorkgroupIdManyToManyConnection';
  /** A list of edges which contains the `Workgroup`, info from the `WorkgroupMembership`, and the cursor to aid in pagination. */
  edges: Array<UserWorkgroupsByWorkgroupMembershipMemberIdAndWorkgroupIdManyToManyEdge>;
  /** A list of `Workgroup` objects. */
  nodes: Array<Workgroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Workgroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Workgroup` edge in the connection, with data from `WorkgroupMembership`. */
export type UserWorkgroupsByWorkgroupMembershipMemberIdAndWorkgroupIdManyToManyEdge = {
  __typename?: 'UserWorkgroupsByWorkgroupMembershipMemberIdAndWorkgroupIdManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Workgroup` at the end of the edge. */
  node: Workgroup;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  AvatarAsc = 'AVATAR_ASC',
  AvatarDesc = 'AVATAR_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KindAsc = 'KIND_ASC',
  KindDesc = 'KIND_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum ValidationCodeKind {
  Registration = 'registration',
  ResetPassword = 'resetPassword'
}

/** All input for the `versionToInteger` mutation. */
export type VersionToIntegerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  versionText?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `versionToInteger` mutation. */
export type VersionToIntegerPayload = {
  __typename?: 'VersionToIntegerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integer?: Maybe<Scalars['Int']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type VideocallEvent = {
  __typename?: 'VideocallEvent';
  event: VideocallEventType;
  groupId: Scalars['UUID']['output'];
  senderId: Scalars['UUID']['output'];
};

export type VideocallEventSubscriptionPayload = {
  __typename?: 'VideocallEventSubscriptionPayload';
  videocallEvent: VideocallEvent;
};

export enum VideocallEventType {
  Accept = 'ACCEPT',
  Busy = 'BUSY',
  Call = 'CALL',
  Reject = 'REJECT',
  Ringing = 'RINGING'
}

/** Input for the nested mutation of `media` in the `MediaVoiceRecordingInput` mutation. */
export type VoiceRecordingAudioFkeyInput = {
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectById?: InputMaybe<MediaMediaPkeyConnect>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MediaNodeIdConnect>;
  /** A `MediaInput` object that will be created and connected to this object. */
  create?: InputMaybe<VoiceRecordingAudioFkeyMediaCreateInput>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteById?: InputMaybe<MediaMediaPkeyDelete>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<MediaNodeIdDelete>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateById?: InputMaybe<MediaOnMediaVoiceRecordingForVoiceRecordingAudioFkeyUsingMediaPkeyUpdate>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAudioFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `mediaVoiceRecording` in the `MediaInput` mutation. */
export type VoiceRecordingAudioFkeyInverseInput = {
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MediaVoiceRecordingMediaVoiceRecordingPkeyConnect>>;
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MediaVoiceRecordingNodeIdConnect>>;
  /** A `MediaVoiceRecordingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VoiceRecordingAudioFkeyMediaVoiceRecordingCreateInput>>;
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MediaVoiceRecordingMediaVoiceRecordingPkeyDelete>>;
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<MediaVoiceRecordingNodeIdDelete>>;
  /** Flag indicating whether all other `mediaVoiceRecording` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `mediaVoiceRecording` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAudioFkeyUsingMediaVoiceRecordingPkeyUpdate>>;
  /** The primary key(s) and patch data for `mediaVoiceRecording` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<MediaOnMediaVoiceRecordingForVoiceRecordingAudioFkeyNodeIdUpdate>>;
};

/** The `media` to be created by this mutation. */
export type VoiceRecordingAudioFkeyMediaCreateInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** The `mediaVoiceRecording` to be created by this mutation. */
export type VoiceRecordingAudioFkeyMediaVoiceRecordingCreateInput = {
  author?: InputMaybe<VoiceRecordingAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<VoiceRecordingMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  voiceRecording?: InputMaybe<VoiceRecordingAudioFkeyInput>;
};

/** Input for the nested mutation of `user` in the `MediaVoiceRecordingInput` mutation. */
export type VoiceRecordingAuthorFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<VoiceRecordingAuthorFkeyUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `mediaVoiceRecording` in the `UserInput` mutation. */
export type VoiceRecordingAuthorFkeyInverseInput = {
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MediaVoiceRecordingMediaVoiceRecordingPkeyConnect>>;
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MediaVoiceRecordingNodeIdConnect>>;
  /** A `MediaVoiceRecordingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VoiceRecordingAuthorFkeyMediaVoiceRecordingCreateInput>>;
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MediaVoiceRecordingMediaVoiceRecordingPkeyDelete>>;
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<MediaVoiceRecordingNodeIdDelete>>;
  /** Flag indicating whether all other `mediaVoiceRecording` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `mediaVoiceRecording` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyUsingMediaVoiceRecordingPkeyUpdate>>;
  /** The primary key(s) and patch data for `mediaVoiceRecording` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyNodeIdUpdate>>;
};

/** The `mediaVoiceRecording` to be created by this mutation. */
export type VoiceRecordingAuthorFkeyMediaVoiceRecordingCreateInput = {
  audioId?: InputMaybe<Scalars['UUID']['input']>;
  author?: InputMaybe<VoiceRecordingAuthorFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<VoiceRecordingMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  voiceRecording?: InputMaybe<VoiceRecordingAudioFkeyInput>;
};

/** The `user` to be created by this mutation. */
export type VoiceRecordingAuthorFkeyUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** Input for the nested mutation of `media` in the `MediaVoiceRecordingInput` mutation. */
export type VoiceRecordingMediaFkeyInput = {
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectById?: InputMaybe<MediaMediaPkeyConnect>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<MediaNodeIdConnect>;
  /** A `MediaInput` object that will be created and connected to this object. */
  create?: InputMaybe<VoiceRecordingMediaFkeyMediaCreateInput>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteById?: InputMaybe<MediaMediaPkeyDelete>;
  /** The primary key(s) for `media` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<MediaNodeIdDelete>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateById?: InputMaybe<MediaOnMediaVoiceRecordingForVoiceRecordingMediaFkeyUsingMediaPkeyUpdate>;
  /** The primary key(s) and patch data for `media` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingMediaFkeyNodeIdUpdate>;
};

/** Input for the nested mutation of `mediaVoiceRecording` in the `MediaInput` mutation. */
export type VoiceRecordingMediaFkeyInverseInput = {
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MediaVoiceRecordingMediaVoiceRecordingPkeyConnect>>;
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<MediaVoiceRecordingNodeIdConnect>>;
  /** A `MediaVoiceRecordingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VoiceRecordingMediaFkeyMediaVoiceRecordingCreateInput>>;
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MediaVoiceRecordingMediaVoiceRecordingPkeyDelete>>;
  /** The primary key(s) for `mediaVoiceRecording` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<MediaVoiceRecordingNodeIdDelete>>;
  /** Flag indicating whether all other `mediaVoiceRecording` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `mediaVoiceRecording` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingMediaFkeyUsingMediaVoiceRecordingPkeyUpdate>>;
  /** The primary key(s) and patch data for `mediaVoiceRecording` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<MediaOnMediaVoiceRecordingForVoiceRecordingMediaFkeyNodeIdUpdate>>;
};

/** The `media` to be created by this mutation. */
export type VoiceRecordingMediaFkeyMediaCreateInput = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** The `mediaVoiceRecording` to be created by this mutation. */
export type VoiceRecordingMediaFkeyMediaVoiceRecordingCreateInput = {
  audioId?: InputMaybe<Scalars['UUID']['input']>;
  author?: InputMaybe<VoiceRecordingAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<VoiceRecordingMediaFkeyInput>;
  voiceRecording?: InputMaybe<VoiceRecordingAudioFkeyInput>;
};

export type VoiceTranscriptionPayload = {
  __typename?: 'VoiceTranscriptionPayload';
  authorId: Scalars['String']['output'];
  chatId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
};

export type WeatherAlert = {
  __typename?: 'WeatherAlert';
  description: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  instruction?: Maybe<Scalars['String']['output']>;
  severity: WeatherAlertSeverityEnum;
};

export enum WeatherAlertSeverityEnum {
  Extreme = 'EXTREME',
  Minor = 'MINOR',
  Moderate = 'MODERATE',
  Severe = 'SEVERE'
}

export type WeatherObservation = {
  __typename?: 'WeatherObservation';
  afternoonStatus?: Maybe<WeatherStatusEnum>;
  afternoonTempMax?: Maybe<Scalars['Float']['output']>;
  afternoonTempMin?: Maybe<Scalars['Float']['output']>;
  alert?: Maybe<WeatherAlert>;
  eveningStatus?: Maybe<WeatherStatusEnum>;
  eveningTempMax?: Maybe<Scalars['Float']['output']>;
  eveningTempMin?: Maybe<Scalars['Float']['output']>;
  morningStatus?: Maybe<WeatherStatusEnum>;
  morningTempMax?: Maybe<Scalars['Float']['output']>;
  morningTempMin?: Maybe<Scalars['Float']['output']>;
  rainExpectedInMinutes?: Maybe<Scalars['Int']['output']>;
  rainForecast?: Maybe<RainForecastEnum>;
  rainForecastHours?: Maybe<Scalars['Int']['output']>;
  status: WeatherStatusEnum;
  sunriseAt?: Maybe<Scalars['String']['output']>;
  sunsetAt?: Maybe<Scalars['String']['output']>;
  temperatureCelsius: Scalars['Float']['output'];
  temperatureMaxCelsiusToday?: Maybe<Scalars['Float']['output']>;
  temperatureMinCelsiusToday?: Maybe<Scalars['Float']['output']>;
  windGustInsightKmh?: Maybe<Scalars['Float']['output']>;
  windGustMaxKmh?: Maybe<Scalars['Float']['output']>;
  windSpeedKmh?: Maybe<Scalars['Float']['output']>;
};

export type WeatherObservationCache = Node & {
  __typename?: 'WeatherObservationCache';
  afternoonStatus?: Maybe<WeatherStatusEnum>;
  afternoonTempMax?: Maybe<Scalars['Float']['output']>;
  afternoonTempMin?: Maybe<Scalars['Float']['output']>;
  alertDescriptionDe?: Maybe<Scalars['String']['output']>;
  alertDescriptionEn?: Maybe<Scalars['String']['output']>;
  alertHeadlineDe?: Maybe<Scalars['String']['output']>;
  alertHeadlineEn?: Maybe<Scalars['String']['output']>;
  alertInstructionDe?: Maybe<Scalars['String']['output']>;
  alertInstructionEn?: Maybe<Scalars['String']['output']>;
  alertSeverity?: Maybe<Scalars['String']['output']>;
  eveningStatus?: Maybe<WeatherStatusEnum>;
  eveningTempMax?: Maybe<Scalars['Float']['output']>;
  eveningTempMin?: Maybe<Scalars['Float']['output']>;
  fetchedAt: Scalars['Datetime']['output'];
  localDate: Scalars['Date']['output'];
  locationKey: Scalars['String']['output'];
  morningStatus?: Maybe<WeatherStatusEnum>;
  morningTempMax?: Maybe<Scalars['Float']['output']>;
  morningTempMin?: Maybe<Scalars['Float']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  rainExpectedInMinutes?: Maybe<Scalars['Int']['output']>;
  sunriseAt?: Maybe<Scalars['Datetime']['output']>;
  sunsetAt?: Maybe<Scalars['Datetime']['output']>;
  temperatureCelsius: Scalars['Float']['output'];
  temperatureMaxCelsius?: Maybe<Scalars['Float']['output']>;
  temperatureMinCelsius?: Maybe<Scalars['Float']['output']>;
  weatherStatus: WeatherStatusEnum;
  windGustMaxKmh?: Maybe<Scalars['Float']['output']>;
  windSpeedKmh?: Maybe<Scalars['Float']['output']>;
};

export enum WeatherStatusEnum {
  Cloudy = 'CLOUDY',
  Foggy = 'FOGGY',
  Hail = 'HAIL',
  Icy = 'ICY',
  PartlySunny = 'PARTLY_SUNNY',
  Rainy = 'RAINY',
  Snowy = 'SNOWY',
  SnowAndRain = 'SNOW_AND_RAIN',
  Sunny = 'SUNNY',
  Thunderstorm = 'THUNDERSTORM',
  Windy = 'WINDY'
}

export type WebOrder = {
  __typename?: 'WebOrder';
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  markers: Array<WebOrderMarker>;
  planVariantCount: Scalars['Int']['output'];
  products: Array<WebOrderProduct>;
  /** The lead's Salesforce id. */
  salesforceId: Scalars['String']['output'];
  salesforceUrl: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  steps: Array<WebOrderStep>;
  /** A step is still missing longer than stuckAfterMinutes after the lead was created. */
  stuck: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export enum WebOrderMarker {
  ConvertedWithoutContract = 'CONVERTED_WITHOUT_CONTRACT',
  /** A plan variant id of the order has no lead product. */
  ProductWithoutPlanVariant = 'PRODUCT_WITHOUT_PLAN_VARIANT'
}

export type WebOrderProduct = {
  __typename?: 'WebOrderProduct';
  name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

/** A step of a web order. at is when it happened; on its day when only that is known. */
export type WebOrderStep = {
  __typename?: 'WebOrderStep';
  at?: Maybe<Scalars['Datetime']['output']>;
  done: Scalars['Boolean']['output'];
  kind: WebOrderStepKind;
  /** The CRM page of the step's record, where one exists. */
  object?: Maybe<CrmObject>;
  on?: Maybe<Scalars['Date']['output']>;
  salesforceId?: Maybe<Scalars['String']['output']>;
  salesforceUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum WebOrderStepKind {
  Contract = 'CONTRACT',
  Conversion = 'CONVERSION',
  LeadProducts = 'LEAD_PRODUCTS',
  Order = 'ORDER'
}

export type WebOrderWeek = {
  __typename?: 'WebOrderWeek';
  orders: Scalars['Int']['output'];
  stuck: Scalars['Int']['output'];
  /** Monday of the week in Berlin. */
  week: Scalars['Date']['output'];
};

export type Website = Node & {
  __typename?: 'Website';
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `Website`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/** A condition to be used against `Website` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type WebsiteCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `Website` */
export type WebsiteInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<OwnerUserIdInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type WebsiteNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `website` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type WebsiteNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `website` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type WebsiteOnWebsiteForOwnerUserIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `website` to look up the row to update. */
export type WebsiteOnWebsiteForOwnerUserIdUsingWebsitePkeyUpdate = {
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `website` being updated. */
  patch: UpdateWebsiteOnWebsiteForOwnerUserIdPatch;
};

/** Represents an update to a `Website`. Fields that are set will be updated. */
export type WebsitePatch = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<OwnerUserIdInput>;
};

/** The fields on `website` to look up the row to connect. */
export type WebsiteWebsitePkeyConnect = {
  id: Scalars['Int']['input'];
};

/** The fields on `website` to look up the row to delete. */
export type WebsiteWebsitePkeyDelete = {
  id: Scalars['Int']['input'];
};

/** A connection to a list of `Website` values. */
export type WebsitesConnection = {
  __typename?: 'WebsitesConnection';
  /** A list of edges which contains the `Website` and cursor to aid in pagination. */
  edges: Array<WebsitesEdge>;
  /** A list of `Website` objects. */
  nodes: Array<Website>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Website` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Website` edge in the connection. */
export type WebsitesEdge = {
  __typename?: 'WebsitesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Website` at the end of the edge. */
  node: Website;
};

/** Methods to use when ordering `Website`. */
export enum WebsitesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type Workgroup = Node & {
  __typename?: 'Workgroup';
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `HandshakeCode`. */
  handshakeCodes: HandshakeCodesConnection;
  /** Reads and enables pagination through a set of `HandshakeCode`. */
  handshakeCodesList: Array<HandshakeCode>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `User`. */
  usersByWorkgroupMembershipWorkgroupIdAndMemberId: WorkgroupUsersByWorkgroupMembershipWorkgroupIdAndMemberIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByWorkgroupMembershipWorkgroupIdAndMemberIdList: Array<User>;
  /** Reads and enables pagination through a set of `WorkgroupMembership`. */
  workgroupMemberships: WorkgroupMembershipsConnection;
  /** Reads and enables pagination through a set of `WorkgroupMembership`. */
  workgroupMembershipsList: Array<WorkgroupMembership>;
};


export type WorkgroupHandshakeCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandshakeCodeCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandshakeCodesOrderBy>>;
};


export type WorkgroupHandshakeCodesListArgs = {
  condition?: InputMaybe<HandshakeCodeCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandshakeCodesOrderBy>>;
};


export type WorkgroupUsersByWorkgroupMembershipWorkgroupIdAndMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type WorkgroupUsersByWorkgroupMembershipWorkgroupIdAndMemberIdListArgs = {
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type WorkgroupWorkgroupMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkgroupMembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupMembershipsOrderBy>>;
};


export type WorkgroupWorkgroupMembershipsListArgs = {
  condition?: InputMaybe<WorkgroupMembershipCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkgroupMembershipsOrderBy>>;
};

/**
 * A condition to be used against `Workgroup` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type WorkgroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `Workgroup` */
export type WorkgroupInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  handshakeCodesUsingId?: InputMaybe<HandshakeCodesWorkgroupIdInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipWorkgroupIdInverseInput>;
};

export type WorkgroupMembership = Node & {
  __typename?: 'WorkgroupMembership';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `WorkgroupMembership`. */
  member?: Maybe<User>;
  memberId: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Workgroup` that is related to this `WorkgroupMembership`. */
  workgroup?: Maybe<Workgroup>;
  workgroupId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `WorkgroupMembership` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type WorkgroupMembershipCondition = {
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `workgroupId` field. */
  workgroupId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An input for mutations affecting `WorkgroupMembership` */
export type WorkgroupMembershipInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  userToMemberId?: InputMaybe<WorkgroupMembershipMemberIdInput>;
  workgroupId?: InputMaybe<Scalars['UUID']['input']>;
  workgroupToWorkgroupId?: InputMaybe<WorkgroupMembershipWorkgroupIdInput>;
};

/** Input for the nested mutation of `user` in the `WorkgroupMembershipInput` mutation. */
export type WorkgroupMembershipMemberIdInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkgroupMembershipMemberIdUserCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserUserPkeyDelete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnWorkgroupMembershipForWorkgroupMembershipMemberIdUsingUserPkeyUpdate>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<WorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipMemberIdNodeIdUpdate>;
};

/** Input for the nested mutation of `workgroupMembership` in the `UserInput` mutation. */
export type WorkgroupMembershipMemberIdInverseInput = {
  /** The primary key(s) for `workgroupMembership` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<WorkgroupMembershipNodeIdConnect>>;
  /** The primary key(s) for `workgroupMembership` for the far side of the relationship. */
  connectByWorkgroupIdAndMemberId?: InputMaybe<Array<WorkgroupMembershipWorkgroupMembershipPkeyConnect>>;
  /** A `WorkgroupMembershipInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<WorkgroupMembershipMemberIdWorkgroupMembershipCreateInput>>;
  /** The primary key(s) for `workgroupMembership` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<WorkgroupMembershipNodeIdDelete>>;
  /** The primary key(s) for `workgroupMembership` for the far side of the relationship. */
  deleteByWorkgroupIdAndMemberId?: InputMaybe<Array<WorkgroupMembershipWorkgroupMembershipPkeyDelete>>;
  /** Flag indicating whether all other `workgroupMembership` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `workgroupMembership` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnWorkgroupMembershipForWorkgroupMembershipMemberIdNodeIdUpdate>>;
  /** The primary key(s) and patch data for `workgroupMembership` for the far side of the relationship. */
  updateByWorkgroupIdAndMemberId?: InputMaybe<Array<WorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipMemberIdUsingWorkgroupMembershipPkeyUpdate>>;
};

/** The `user` to be created by this mutation. */
export type WorkgroupMembershipMemberIdUserCreateInput = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind: UserType;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name: Scalars['String']['input'];
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** The `workgroupMembership` to be created by this mutation. */
export type WorkgroupMembershipMemberIdWorkgroupMembershipCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToMemberId?: InputMaybe<WorkgroupMembershipMemberIdInput>;
  workgroupId?: InputMaybe<Scalars['UUID']['input']>;
  workgroupToWorkgroupId?: InputMaybe<WorkgroupMembershipWorkgroupIdInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type WorkgroupMembershipNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `workgroupMembership` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type WorkgroupMembershipNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `workgroupMembership` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type WorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipMemberIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `workgroupMembership` to look up the row to update. */
export type WorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipMemberIdUsingWorkgroupMembershipPkeyUpdate = {
  memberId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `workgroupMembership` being updated. */
  patch: UpdateWorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipMemberIdPatch;
  workgroupId: Scalars['UUID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type WorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `workgroup` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `workgroup` being updated. */
  patch: WorkgroupPatch;
};

/** The fields on `workgroupMembership` to look up the row to update. */
export type WorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdUsingWorkgroupMembershipPkeyUpdate = {
  memberId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `workgroupMembership` being updated. */
  patch: UpdateWorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdPatch;
  workgroupId: Scalars['UUID']['input'];
};

/** Represents an update to a `WorkgroupMembership`. Fields that are set will be updated. */
export type WorkgroupMembershipPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  userToMemberId?: InputMaybe<WorkgroupMembershipMemberIdInput>;
  workgroupId?: InputMaybe<Scalars['UUID']['input']>;
  workgroupToWorkgroupId?: InputMaybe<WorkgroupMembershipWorkgroupIdInput>;
};

/** Input for the nested mutation of `workgroup` in the `WorkgroupMembershipInput` mutation. */
export type WorkgroupMembershipWorkgroupIdInput = {
  /** The primary key(s) for `workgroup` for the far side of the relationship. */
  connectById?: InputMaybe<WorkgroupWorkgroupPkeyConnect>;
  /** The primary key(s) for `workgroup` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<WorkgroupNodeIdConnect>;
  /** A `WorkgroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkgroupMembershipWorkgroupIdWorkgroupCreateInput>;
  /** The primary key(s) for `workgroup` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkgroupWorkgroupPkeyDelete>;
  /** The primary key(s) for `workgroup` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<WorkgroupNodeIdDelete>;
  /** The primary key(s) and patch data for `workgroup` for the far side of the relationship. */
  updateById?: InputMaybe<WorkgroupOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdUsingWorkgroupPkeyUpdate>;
  /** The primary key(s) and patch data for `workgroup` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<WorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdNodeIdUpdate>;
};

/** Input for the nested mutation of `workgroupMembership` in the `WorkgroupInput` mutation. */
export type WorkgroupMembershipWorkgroupIdInverseInput = {
  /** The primary key(s) for `workgroupMembership` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<WorkgroupMembershipNodeIdConnect>>;
  /** The primary key(s) for `workgroupMembership` for the far side of the relationship. */
  connectByWorkgroupIdAndMemberId?: InputMaybe<Array<WorkgroupMembershipWorkgroupMembershipPkeyConnect>>;
  /** A `WorkgroupMembershipInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<WorkgroupMembershipWorkgroupIdWorkgroupMembershipCreateInput>>;
  /** The primary key(s) for `workgroupMembership` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<WorkgroupMembershipNodeIdDelete>>;
  /** The primary key(s) for `workgroupMembership` for the far side of the relationship. */
  deleteByWorkgroupIdAndMemberId?: InputMaybe<Array<WorkgroupMembershipWorkgroupMembershipPkeyDelete>>;
  /** Flag indicating whether all other `workgroupMembership` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The primary key(s) and patch data for `workgroupMembership` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<WorkgroupOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdNodeIdUpdate>>;
  /** The primary key(s) and patch data for `workgroupMembership` for the far side of the relationship. */
  updateByWorkgroupIdAndMemberId?: InputMaybe<Array<WorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdUsingWorkgroupMembershipPkeyUpdate>>;
};

/** The `workgroup` to be created by this mutation. */
export type WorkgroupMembershipWorkgroupIdWorkgroupCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  handshakeCodesUsingId?: InputMaybe<HandshakeCodesWorkgroupIdInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipWorkgroupIdInverseInput>;
};

/** The `workgroupMembership` to be created by this mutation. */
export type WorkgroupMembershipWorkgroupIdWorkgroupMembershipCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  userToMemberId?: InputMaybe<WorkgroupMembershipMemberIdInput>;
  workgroupToWorkgroupId?: InputMaybe<WorkgroupMembershipWorkgroupIdInput>;
};

/** The fields on `workgroupMembership` to look up the row to connect. */
export type WorkgroupMembershipWorkgroupMembershipPkeyConnect = {
  memberId: Scalars['UUID']['input'];
  workgroupId: Scalars['UUID']['input'];
};

/** The fields on `workgroupMembership` to look up the row to delete. */
export type WorkgroupMembershipWorkgroupMembershipPkeyDelete = {
  memberId: Scalars['UUID']['input'];
  workgroupId: Scalars['UUID']['input'];
};

/** A connection to a list of `WorkgroupMembership` values. */
export type WorkgroupMembershipsConnection = {
  __typename?: 'WorkgroupMembershipsConnection';
  /** A list of edges which contains the `WorkgroupMembership` and cursor to aid in pagination. */
  edges: Array<WorkgroupMembershipsEdge>;
  /** A list of `WorkgroupMembership` objects. */
  nodes: Array<WorkgroupMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkgroupMembership` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WorkgroupMembership` edge in the connection. */
export type WorkgroupMembershipsEdge = {
  __typename?: 'WorkgroupMembershipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WorkgroupMembership` at the end of the edge. */
  node: WorkgroupMembership;
};

/** Methods to use when ordering `WorkgroupMembership`. */
export enum WorkgroupMembershipsOrderBy {
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WorkgroupIdAsc = 'WORKGROUP_ID_ASC',
  WorkgroupIdDesc = 'WORKGROUP_ID_DESC'
}

/** The globally unique `ID` look up for the row to connect. */
export type WorkgroupNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `workgroup` to be connected. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to delete. */
export type WorkgroupNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `workgroup` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The globally unique `ID` look up for the row to update. */
export type WorkgroupOnHandshakeCodeForHandshakeCodesWorkgroupIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `handshakeCode` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `handshakeCode` being updated. */
  patch: HandshakeCodePatch;
};

/** The fields on `workgroup` to look up the row to update. */
export type WorkgroupOnHandshakeCodeForHandshakeCodesWorkgroupIdUsingWorkgroupPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `workgroup` being updated. */
  patch: UpdateWorkgroupOnHandshakeCodeForHandshakeCodesWorkgroupIdPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type WorkgroupOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `workgroupMembership` to be connected. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `workgroupMembership` being updated. */
  patch: WorkgroupMembershipPatch;
};

/** The fields on `workgroup` to look up the row to update. */
export type WorkgroupOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdUsingWorkgroupPkeyUpdate = {
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `workgroup` being updated. */
  patch: UpdateWorkgroupOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdPatch;
};

/** Represents an update to a `Workgroup`. Fields that are set will be updated. */
export type WorkgroupPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  handshakeCodesUsingId?: InputMaybe<HandshakeCodesWorkgroupIdInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipWorkgroupIdInverseInput>;
};

export type WorkgroupPayload = {
  __typename?: 'WorkgroupPayload';
  workgroup?: Maybe<Workgroup>;
};

/** A connection to a list of `User` values, with data from `WorkgroupMembership`. */
export type WorkgroupUsersByWorkgroupMembershipWorkgroupIdAndMemberIdManyToManyConnection = {
  __typename?: 'WorkgroupUsersByWorkgroupMembershipWorkgroupIdAndMemberIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `WorkgroupMembership`, and the cursor to aid in pagination. */
  edges: Array<WorkgroupUsersByWorkgroupMembershipWorkgroupIdAndMemberIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection, with data from `WorkgroupMembership`. */
export type WorkgroupUsersByWorkgroupMembershipWorkgroupIdAndMemberIdManyToManyEdge = {
  __typename?: 'WorkgroupUsersByWorkgroupMembershipWorkgroupIdAndMemberIdManyToManyEdge';
  createdAt: Scalars['Datetime']['output'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** The fields on `workgroup` to look up the row to connect. */
export type WorkgroupWorkgroupPkeyConnect = {
  id: Scalars['UUID']['input'];
};

/** The fields on `workgroup` to look up the row to delete. */
export type WorkgroupWorkgroupPkeyDelete = {
  id: Scalars['UUID']['input'];
};

/** A connection to a list of `Workgroup` values. */
export type WorkgroupsConnection = {
  __typename?: 'WorkgroupsConnection';
  /** A list of edges which contains the `Workgroup` and cursor to aid in pagination. */
  edges: Array<WorkgroupsEdge>;
  /** A list of `Workgroup` objects. */
  nodes: Array<Workgroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Workgroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Workgroup` edge in the connection. */
export type WorkgroupsEdge = {
  __typename?: 'WorkgroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Workgroup` at the end of the edge. */
  node: Workgroup;
};

/** Methods to use when ordering `Workgroup`. */
export enum WorkgroupsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CheckInMessagePayload = {
  __typename?: 'checkInMessagePayload';
  checkInMessage: CheckInMessage;
};

export type CheckInPayload = {
  __typename?: 'checkInPayload';
  checkIn: CheckIn;
};

export enum CmsEnvironment {
  Dev = 'dev',
  Local = 'local',
  Prod = 'prod'
}

export type SystemMessageAddedPayload = {
  __typename?: 'systemMessageAddedPayload';
  systemMessage: SystemMessage;
};

/** An object where the defined keys will be set on the `activityGoal` being updated. */
export type UpdateActivityGoalOnActivityGoalForActivityGoalUserIdFkeyPatch = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<ActivityGoalEnum>;
  userToUserId?: InputMaybe<ActivityGoalUserIdFkeyInput>;
  weeklyGoal?: InputMaybe<Scalars['Int']['input']>;
};

/** An object where the defined keys will be set on the `activity` being updated. */
export type UpdateActivityOnActivitySessionForActivitySessionActivityIdFkeyPatch = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<ActivityKind>;
};

/** An object where the defined keys will be set on the `activity` being updated. */
export type UpdateActivityOnContentActivityForContentActivityActivityIdFkeyPatch = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<ActivityKind>;
};

/** An object where the defined keys will be set on the `activity` being updated. */
export type UpdateActivityOnCustomActivityForCustomActivityFkeyPatch = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<ActivityKind>;
};

/** An object where the defined keys will be set on the `activity` being updated. */
export type UpdateActivityOnFeatureActivityForFeatureActivityFkeyPatch = {
  activitySessionsUsingId?: InputMaybe<ActivitySessionActivityIdFkeyInverseInput>;
  contentActivityUsingId?: InputMaybe<ContentActivityActivityIdFkeyInverseInput>;
  customActivityUsingId?: InputMaybe<CustomActivityFkeyInverseInput>;
  featureActivityUsingId?: InputMaybe<FeatureActivityFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<ActivityKind>;
};

/** An object where the defined keys will be set on the `activityParticipant` being updated. */
export type UpdateActivityParticipantOnActivityParticipantForActivityParticipantActivitySessionIdFkeyPatch = {
  activitySessionToActivitySessionId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  noteUsingActivitySessionIdAndSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInverseInput>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorId?: InputMaybe<ActivityParticipantSeniorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `activityParticipant` being updated. */
export type UpdateActivityParticipantOnActivityParticipantForActivityParticipantSeniorIdFkeyPatch = {
  activitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  activitySessionToActivitySessionId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  noteUsingActivitySessionIdAndSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInverseInput>;
  userToSeniorId?: InputMaybe<ActivityParticipantSeniorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `activitySession` being updated. */
export type UpdateActivitySessionOnActivityParticipantForActivityParticipantActivitySessionIdFkeyPatch = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<SessionKind>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** An object where the defined keys will be set on the `activitySession` being updated. */
export type UpdateActivitySessionOnActivitySessionForActivitySessionActivityIdFkeyPatch = {
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<SessionKind>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** An object where the defined keys will be set on the `activitySession` being updated. */
export type UpdateActivitySessionOnActivitySessionForActivitySessionCaregiverIdFkeyPatch = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<SessionKind>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** An object where the defined keys will be set on the `activitySession` being updated. */
export type UpdateActivitySessionOnActivitySessionForActivitySessionProcedureIdFkeyPatch = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<SessionKind>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** An object where the defined keys will be set on the `activitySession` being updated. */
export type UpdateActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyPatch = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantActivitySessionIdFkeyInverseInput>;
  activityToActivityId?: InputMaybe<ActivitySessionActivityIdFkeyInput>;
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<SessionKind>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInverseInput>;
  positionInProcedure?: InputMaybe<Scalars['Int']['input']>;
  /** Optional link to FHIR procedure that this activity session fulfills. One procedure can be fulfilled by multiple sessions over time. NULL if the session does not fulfill a specific procedure. */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ActivitySessionProcedureIdFkeyInput>;
  /** Lifecycle state of the activity session: planned (scheduled by a manager, not yet executed), started, cancelled, or completed. Transitions: planned -> started -> completed | cancelled. Used for filtering completed activities and excluding planned rows from execution history/analytics. */
  sessionStatus?: InputMaybe<SessionStatus>;
  userToCaregiverId?: InputMaybe<ActivitySessionCaregiverIdFkeyInput>;
};

/** An object where the defined keys will be set on the `albumMedia` being updated. */
export type UpdateAlbumMediaOnAlbumMediaForAlbumMediaAlbumIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  mediaAlbumToAlbumId?: InputMaybe<AlbumMediaAlbumIdFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  mediaToMediaId?: InputMaybe<AlbumMediaMediaIdFkeyInput>;
};

/** An object where the defined keys will be set on the `albumMedia` being updated. */
export type UpdateAlbumMediaOnAlbumMediaForAlbumMediaMediaIdFkeyPatch = {
  albumId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  mediaAlbumToAlbumId?: InputMaybe<AlbumMediaAlbumIdFkeyInput>;
  mediaToMediaId?: InputMaybe<AlbumMediaMediaIdFkeyInput>;
};

/** An object where the defined keys will be set on the `appSetting` being updated. */
export type UpdateAppSettingOnAppSettingForAppSettingUserIdFkeyPatch = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  settingType?: InputMaybe<AppSettingEnum>;
  userToUserId?: InputMaybe<AppSettingUserIdFkeyInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `attachment` being updated. */
export type UpdateAttachmentOnAttachmentForAttachmentMessageIdPatch = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<FkAttachmentMediaInput>;
  messageToMessageId?: InputMaybe<AttachmentMessageIdInput>;
};

/** An object where the defined keys will be set on the `attachment` being updated. */
export type UpdateAttachmentOnAttachmentForFkAttachmentMediaPatch = {
  media?: InputMaybe<FkAttachmentMediaInput>;
  messageId?: InputMaybe<Scalars['UUID']['input']>;
  messageToMessageId?: InputMaybe<AttachmentMessageIdInput>;
};

/** An object where the defined keys will be set on the `caregiverProfile` being updated. */
export type UpdateCaregiverProfileOnCaregiverProfileForCaregiverProfileUserIdPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  facilityName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userToUserId?: InputMaybe<CaregiverProfileUserIdInput>;
};

/** An object where the defined keys will be set on the `caregiverSenior` being updated. */
export type UpdateCaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyPatch = {
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToCaregiverId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInput>;
  userToSeniorId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `caregiverSenior` being updated. */
export type UpdateCaregiverSeniorOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyPatch = {
  caregiverId?: InputMaybe<Scalars['UUID']['input']>;
  userToCaregiverId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInput>;
  userToSeniorId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `checkInMessage` being updated. */
export type UpdateCheckInMessageOnCheckInMessageForCheckInMessageAuthorFkeyPatch = {
  checkInId?: InputMaybe<Scalars['UUID']['input']>;
  checkInToCheckInId?: InputMaybe<CheckInMessageCheckInFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  secondMessage?: InputMaybe<Scalars['String']['input']>;
  userToAuthorId?: InputMaybe<CheckInMessageAuthorFkeyInput>;
};

/** An object where the defined keys will be set on the `checkInMessage` being updated. */
export type UpdateCheckInMessageOnCheckInMessageForCheckInMessageCheckInFkeyPatch = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInToCheckInId?: InputMaybe<CheckInMessageCheckInFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  secondMessage?: InputMaybe<Scalars['String']['input']>;
  userToAuthorId?: InputMaybe<CheckInMessageAuthorFkeyInput>;
};

/** An object where the defined keys will be set on the `checkIn` being updated. */
export type UpdateCheckInOnCheckInForCheckInAuthorFkeyPatch = {
  checkInMessagesUsingId?: InputMaybe<CheckInMessageCheckInFkeyInverseInput>;
  checkInStatus?: InputMaybe<CheckInStatusEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<CheckInAuthorFkeyInput>;
  userToSeniorId?: InputMaybe<CheckInSeniorFkeyInput>;
};

/** An object where the defined keys will be set on the `checkIn` being updated. */
export type UpdateCheckInOnCheckInForCheckInSeniorFkeyPatch = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageCheckInFkeyInverseInput>;
  checkInStatus?: InputMaybe<CheckInStatusEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<CheckInAuthorFkeyInput>;
  userToSeniorId?: InputMaybe<CheckInSeniorFkeyInput>;
};

/** An object where the defined keys will be set on the `checkIn` being updated. */
export type UpdateCheckInOnCheckInMessageForCheckInMessageCheckInFkeyPatch = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageCheckInFkeyInverseInput>;
  checkInStatus?: InputMaybe<CheckInStatusEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<CheckInAuthorFkeyInput>;
  userToSeniorId?: InputMaybe<CheckInSeniorFkeyInput>;
};

/** An object where the defined keys will be set on the `contentActivity` being updated. */
export type UpdateContentActivityOnContentActivityForContentActivityActivityIdFkeyPatch = {
  activityToActivityId?: InputMaybe<ContentActivityActivityIdFkeyInput>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<ContentActivityContentIdFkeyInput>;
};

/** An object where the defined keys will be set on the `contentActivity` being updated. */
export type UpdateContentActivityOnContentActivityForContentActivityContentIdFkeyPatch = {
  activityId?: InputMaybe<Scalars['UUID']['input']>;
  activityToActivityId?: InputMaybe<ContentActivityActivityIdFkeyInput>;
  contentToContentId?: InputMaybe<ContentActivityContentIdFkeyInput>;
};

/** An object where the defined keys will be set on the `contentMetaTag` being updated. */
export type UpdateContentMetaTagOnContentMetaTagForContentMetaTagContentIdFkeyPatch = {
  contentToContentId?: InputMaybe<ContentMetaTagContentIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTagId?: InputMaybe<Scalars['UUID']['input']>;
  metaTagToMetaTagId?: InputMaybe<ContentMetaTagMetaTagIdFkeyInput>;
};

/** An object where the defined keys will be set on the `contentMetaTag` being updated. */
export type UpdateContentMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyPatch = {
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<ContentMetaTagContentIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTagToMetaTagId?: InputMaybe<ContentMetaTagMetaTagIdFkeyInput>;
};

/** An object where the defined keys will be set on the `content` being updated. */
export type UpdateContentOnContentActivityForContentActivityContentIdFkeyPatch = {
  cmsContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsContentKind?: InputMaybe<Scalars['String']['input']>;
  cmsNextContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsNextContentKind?: InputMaybe<Scalars['String']['input']>;
  contentActivityUsingId?: InputMaybe<ContentActivityContentIdFkeyInverseInput>;
  /** Difficulty levels for different aspects: cognitive, motor, speech, vision, hearing. Values: easy, medium, hard */
  difficultyLevel?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTags?: InputMaybe<ContentMetaTagContentIdFkeyInverseInput>;
  /** CMS game model key; null for non-game content or unavailable metadata. */
  subtype?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesUsingId?: InputMaybe<UserContentActivityContentIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteContentIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `content` being updated. */
export type UpdateContentOnContentMetaTagForContentMetaTagContentIdFkeyPatch = {
  cmsContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsContentKind?: InputMaybe<Scalars['String']['input']>;
  cmsNextContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsNextContentKind?: InputMaybe<Scalars['String']['input']>;
  contentActivityUsingId?: InputMaybe<ContentActivityContentIdFkeyInverseInput>;
  /** Difficulty levels for different aspects: cognitive, motor, speech, vision, hearing. Values: easy, medium, hard */
  difficultyLevel?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTags?: InputMaybe<ContentMetaTagContentIdFkeyInverseInput>;
  /** CMS game model key; null for non-game content or unavailable metadata. */
  subtype?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesUsingId?: InputMaybe<UserContentActivityContentIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteContentIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `content` being updated. */
export type UpdateContentOnUserContentActivityForUserContentActivityContentIdFkeyPatch = {
  cmsContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsContentKind?: InputMaybe<Scalars['String']['input']>;
  cmsNextContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsNextContentKind?: InputMaybe<Scalars['String']['input']>;
  contentActivityUsingId?: InputMaybe<ContentActivityContentIdFkeyInverseInput>;
  /** Difficulty levels for different aspects: cognitive, motor, speech, vision, hearing. Values: easy, medium, hard */
  difficultyLevel?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTags?: InputMaybe<ContentMetaTagContentIdFkeyInverseInput>;
  /** CMS game model key; null for non-game content or unavailable metadata. */
  subtype?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesUsingId?: InputMaybe<UserContentActivityContentIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteContentIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `content` being updated. */
export type UpdateContentOnUserContentFavoriteForUserContentFavoriteContentIdFkeyPatch = {
  cmsContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsContentKind?: InputMaybe<Scalars['String']['input']>;
  cmsNextContentId?: InputMaybe<Scalars['Int']['input']>;
  cmsNextContentKind?: InputMaybe<Scalars['String']['input']>;
  contentActivityUsingId?: InputMaybe<ContentActivityContentIdFkeyInverseInput>;
  /** Difficulty levels for different aspects: cognitive, motor, speech, vision, hearing. Values: easy, medium, hard */
  difficultyLevel?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaTags?: InputMaybe<ContentMetaTagContentIdFkeyInverseInput>;
  /** CMS game model key; null for non-game content or unavailable metadata. */
  subtype?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesUsingId?: InputMaybe<UserContentActivityContentIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteContentIdFkeyInverseInput>;
};

/** An object where the defined keys will be set on the `customActivity` being updated. */
export type UpdateCustomActivityOnCustomActivityForCustomActivityFkeyPatch = {
  activityToActivityId?: InputMaybe<CustomActivityFkeyInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `device` being updated. */
export type UpdateDeviceOnDeviceForDeviceLocationIdFkeyPatch = {
  appPackageId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  contentVersion?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<DeviceLocationIdFkeyInput>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<DeviceOrganizationIdFkeyInput>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An object where the defined keys will be set on the `device` being updated. */
export type UpdateDeviceOnDeviceForDeviceOrganizationIdFkeyPatch = {
  appPackageId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  contentVersion?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<DeviceLocationIdFkeyInput>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationToOrganizationId?: InputMaybe<DeviceOrganizationIdFkeyInput>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An object where the defined keys will be set on the `documentationSync` being updated. */
export type UpdateDocumentationSyncOnDocumentationSyncForDocumentationSyncNoteIdFkeyPatch = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<DocumentationSyncKind>;
  /** Provider or backend error of the latest failed attempt. */
  lastError?: InputMaybe<Scalars['String']['input']>;
  noteToNoteId?: InputMaybe<DocumentationSyncNoteIdFkeyInput>;
  /** When the latest outcome happened. For a provider report this is when the provider answered, not when the report arrived. */
  outcomeAt?: InputMaybe<Scalars['Datetime']['input']>;
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<DocumentationSyncProcedureIdFkeyInput>;
  provider?: InputMaybe<DataSource>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  /** When the provider accepted the export. */
  sentAt?: InputMaybe<Scalars['Datetime']['input']>;
  skipReason?: InputMaybe<DocumentationSyncSkipReason>;
  status?: InputMaybe<DocumentationSyncStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An object where the defined keys will be set on the `documentationSync` being updated. */
export type UpdateDocumentationSyncOnDocumentationSyncForDocumentationSyncProcedureIdFkeyPatch = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<DocumentationSyncKind>;
  /** Provider or backend error of the latest failed attempt. */
  lastError?: InputMaybe<Scalars['String']['input']>;
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  noteToNoteId?: InputMaybe<DocumentationSyncNoteIdFkeyInput>;
  /** When the latest outcome happened. For a provider report this is when the provider answered, not when the report arrived. */
  outcomeAt?: InputMaybe<Scalars['Datetime']['input']>;
  procedureToProcedureId?: InputMaybe<DocumentationSyncProcedureIdFkeyInput>;
  provider?: InputMaybe<DataSource>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  /** When the provider accepted the export. */
  sentAt?: InputMaybe<Scalars['Datetime']['input']>;
  skipReason?: InputMaybe<DocumentationSyncSkipReason>;
  status?: InputMaybe<DocumentationSyncStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An object where the defined keys will be set on the `familyMemberSenior` being updated. */
export type UpdateFamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyPatch = {
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  userToFamilyMemberId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInput>;
  userToSeniorId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `familyMemberSenior` being updated. */
export type UpdateFamilyMemberSeniorOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyPatch = {
  familyMemberId?: InputMaybe<Scalars['UUID']['input']>;
  userToFamilyMemberId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInput>;
  userToSeniorId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `featureActivity` being updated. */
export type UpdateFeatureActivityOnFeatureActivityForFeatureActivityFkeyPatch = {
  activityToActivityId?: InputMaybe<FeatureActivityFkeyInput>;
  kind?: InputMaybe<FeatureActivityKind>;
};

/** An object where the defined keys will be set on the `feedback` being updated. */
export type UpdateFeedbackOnFeedbackForFeedbackUserIdPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
  userToUserId?: InputMaybe<FeedbackUserIdInput>;
};

/** An object where the defined keys will be set on the `formResponse` being updated. */
export type UpdateFormResponseOnFormResponseForFormResponseAuthorFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<FormResponseAuthorFkeyInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnGroupForGroupAvatarMediaFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind?: InputMaybe<GroupType>;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnInvitationForInvitationInvitedToFkeyPatch = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind?: InputMaybe<GroupType>;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnMembershipForMembershipGroupIdPatch = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind?: InputMaybe<GroupType>;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnMessageForMessageChatIdPatch = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind?: InputMaybe<GroupType>;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnSenderKeyForSenderKeyGroupIdPatch = {
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedToFkeyInverseInput>;
  kind?: InputMaybe<GroupType>;
  mediaToAvatar?: InputMaybe<GroupAvatarMediaFkeyInput>;
  memberships?: InputMaybe<MembershipGroupIdInverseInput>;
  messages?: InputMaybe<MessageChatIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  senderKeysUsingId?: InputMaybe<SenderKeyGroupIdInverseInput>;
};

/** An object where the defined keys will be set on the `handshakeCode` being updated. */
export type UpdateHandshakeCodeOnHandshakeCodeForHandshakeCodesWorkgroupIdPatch = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  initiatorId?: InputMaybe<Scalars['UUID']['input']>;
  workgroupToWorkgroupId?: InputMaybe<HandshakeCodesWorkgroupIdInput>;
};

/** An object where the defined keys will be set on the `invitation` being updated. */
export type UpdateInvitationOnInvitationForInvitationInvitedByFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  groupToInvitedTo?: InputMaybe<InvitationInvitedToFkeyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationKind?: InputMaybe<UserType>;
  invitedTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Deprecated and no longer read: the account's ambulant setting applies. */
  managerOrganizationAmbulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Salesforce account (crm.account) whose licence manager this manager invitation is for. No foreign key. */
  managerSalesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmailStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToInvitedBy?: InputMaybe<InvitationInvitedByFkeyInput>;
};

/** An object where the defined keys will be set on the `invitation` being updated. */
export type UpdateInvitationOnInvitationForInvitationInvitedToFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  groupToInvitedTo?: InputMaybe<InvitationInvitedToFkeyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationKind?: InputMaybe<UserType>;
  invitedBy?: InputMaybe<Scalars['UUID']['input']>;
  /** Deprecated and no longer read: the account's ambulant setting applies. */
  managerOrganizationAmbulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Salesforce account (crm.account) whose licence manager this manager invitation is for. No foreign key. */
  managerSalesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmailStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToInvitedBy?: InputMaybe<InvitationInvitedByFkeyInput>;
};

/** An object where the defined keys will be set on the `korianUser` being updated. */
export type UpdateKorianUserOnKorianUserForKorianUserIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  facilityId?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<KorianUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `location` being updated. */
export type UpdateLocationOnDeviceForDeviceLocationIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type?: InputMaybe<LocationTypeEnum>;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An object where the defined keys will be set on the `location` being updated. */
export type UpdateLocationOnLocationForFkLocationOrganizationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type?: InputMaybe<LocationTypeEnum>;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An object where the defined keys will be set on the `location` being updated. */
export type UpdateLocationOnLocationForFkLocationPartOfPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type?: InputMaybe<LocationTypeEnum>;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An object where the defined keys will be set on the `location` being updated. */
export type UpdateLocationOnLocationPractitionerForFkLocationPractitionersLocationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type?: InputMaybe<LocationTypeEnum>;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An object where the defined keys will be set on the `location` being updated. */
export type UpdateLocationOnPatientForPatientLocationIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceLocationIdFkeyInverseInput>;
  /** Pure external ID from source system (e.g., "123"), not prefixed with source or type. For M4c-created locations, this is the location id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersLocationInverseInput>;
  locationToPartOfId?: InputMaybe<FkLocationPartOfInput>;
  /** FHIR Location.mode: INSTANCE (specific location) or KIND (category of locations) */
  mode?: InputMaybe<LocationModeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkLocationOrganizationInput>;
  /** Reference to parent location in hierarchy (e.g., room belongs to ward) */
  partOfId?: InputMaybe<Scalars['UUID']['input']>;
  patientsUsingId?: InputMaybe<PatientLocationIdFkeyInverseInput>;
  /** Source system that created this location (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<Scalars['String']['input']>;
  /** Type of location: ORGANIZATION (system root), SITE, DEPARTMENT, WARD, ROOM, or BED */
  type?: InputMaybe<LocationTypeEnum>;
  /** Timestamp of last update */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** An object where the defined keys will be set on the `locationPractitioner` being updated. */
export type UpdateLocationPractitionerOnLocationPractitionerForFkLocationPractitionersLocationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  locationToLocationId?: InputMaybe<FkLocationPractitionersLocationInput>;
  practitionerId?: InputMaybe<Scalars['UUID']['input']>;
  practitionerToPractitionerId?: InputMaybe<FkLocationPractitionersPractitionerInput>;
};

/** An object where the defined keys will be set on the `locationPractitioner` being updated. */
export type UpdateLocationPractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<FkLocationPractitionersLocationInput>;
  practitionerToPractitionerId?: InputMaybe<FkLocationPractitionersPractitionerInput>;
};

/** An object where the defined keys will be set on the `mediaAlbum` being updated. */
export type UpdateMediaAlbumOnAlbumMediaForAlbumMediaAlbumIdFkeyPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaAlbumIdFkeyInverseInput>;
  albumName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaAlbumKind>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<MediaAlbumUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `mediaAlbum` being updated. */
export type UpdateMediaAlbumOnMediaAlbumForMediaAlbumUserIdFkeyPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaAlbumIdFkeyInverseInput>;
  albumName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  creatorId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaAlbumKind>;
  userToUserId?: InputMaybe<MediaAlbumUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `mediaNote` being updated. */
export type UpdateMediaNoteOnMediaNoteForMediaNoteAuthorFkeyPatch = {
  author?: InputMaybe<MediaNoteAuthorFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<MediaNoteMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `mediaNote` being updated. */
export type UpdateMediaNoteOnMediaNoteForMediaNoteMediaFkeyPatch = {
  author?: InputMaybe<MediaNoteAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<MediaNoteMediaFkeyInput>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `media` being updated. */
export type UpdateMediaOnAlbumMediaForAlbumMediaMediaIdFkeyPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An object where the defined keys will be set on the `media` being updated. */
export type UpdateMediaOnAttachmentForFkAttachmentMediaPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An object where the defined keys will be set on the `media` being updated. */
export type UpdateMediaOnGroupForGroupAvatarMediaFkeyPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An object where the defined keys will be set on the `media` being updated. */
export type UpdateMediaOnMediaNoteForMediaNoteMediaFkeyPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An object where the defined keys will be set on the `media` being updated. */
export type UpdateMediaOnMediaVoiceRecordingForVoiceRecordingAudioFkeyPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An object where the defined keys will be set on the `media` being updated. */
export type UpdateMediaOnMediaVoiceRecordingForVoiceRecordingMediaFkeyPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An object where the defined keys will be set on the `media` being updated. */
export type UpdateMediaOnUserForUserAvatarMediaFkeyPatch = {
  albumMediaUsingId?: InputMaybe<AlbumMediaMediaIdFkeyInverseInput>;
  attachmentUsingId?: InputMaybe<FkAttachmentMediaInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dateOfCapture?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  featuredPeople?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsUsingId?: InputMaybe<GroupAvatarMediaFkeyInverseInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MediaKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  md5?: InputMaybe<Scalars['String']['input']>;
  mediaNotesUsingId?: InputMaybe<MediaNoteMediaFkeyInverseInput>;
  mediaVoiceRecordingsToAudioIdUsingId?: InputMaybe<VoiceRecordingAudioFkeyInverseInput>;
  mediaVoiceRecordingsToMediaIdUsingId?: InputMaybe<VoiceRecordingMediaFkeyInverseInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  usersUsingId?: InputMaybe<UserAvatarMediaFkeyInverseInput>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** An object where the defined keys will be set on the `mediaVoiceRecording` being updated. */
export type UpdateMediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAudioFkeyPatch = {
  author?: InputMaybe<VoiceRecordingAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<VoiceRecordingMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  voiceRecording?: InputMaybe<VoiceRecordingAudioFkeyInput>;
};

/** An object where the defined keys will be set on the `mediaVoiceRecording` being updated. */
export type UpdateMediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyPatch = {
  audioId?: InputMaybe<Scalars['UUID']['input']>;
  author?: InputMaybe<VoiceRecordingAuthorFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<VoiceRecordingMediaFkeyInput>;
  mediaId?: InputMaybe<Scalars['UUID']['input']>;
  voiceRecording?: InputMaybe<VoiceRecordingAudioFkeyInput>;
};

/** An object where the defined keys will be set on the `mediaVoiceRecording` being updated. */
export type UpdateMediaVoiceRecordingOnMediaVoiceRecordingForVoiceRecordingMediaFkeyPatch = {
  audioId?: InputMaybe<Scalars['UUID']['input']>;
  author?: InputMaybe<VoiceRecordingAuthorFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  media?: InputMaybe<VoiceRecordingMediaFkeyInput>;
  voiceRecording?: InputMaybe<VoiceRecordingAudioFkeyInput>;
};

/** An object where the defined keys will be set on the `membership` being updated. */
export type UpdateMembershipOnMembershipForMembershipGroupIdPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  groupToGroupId?: InputMaybe<MembershipGroupIdInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastRead?: InputMaybe<Scalars['Datetime']['input']>;
  lastReceived?: InputMaybe<Scalars['Datetime']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  userToMemberId?: InputMaybe<MembershipMemberIdInput>;
};

/** An object where the defined keys will be set on the `membership` being updated. */
export type UpdateMembershipOnMembershipForMembershipMemberIdPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupToGroupId?: InputMaybe<MembershipGroupIdInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastRead?: InputMaybe<Scalars['Datetime']['input']>;
  lastReceived?: InputMaybe<Scalars['Datetime']['input']>;
  userToMemberId?: InputMaybe<MembershipMemberIdInput>;
};

/** An object where the defined keys will be set on the `message` being updated. */
export type UpdateMessageOnAttachmentForAttachmentMessageIdPatch = {
  attachmentsUsingId?: InputMaybe<AttachmentMessageIdInverseInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  chatId?: InputMaybe<Scalars['UUID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  groupToChatId?: InputMaybe<MessageChatIdInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  senderKeyId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<MessageAuthorIdInput>;
};

/** An object where the defined keys will be set on the `message` being updated. */
export type UpdateMessageOnMessageForMessageAuthorIdPatch = {
  attachmentsUsingId?: InputMaybe<AttachmentMessageIdInverseInput>;
  chatId?: InputMaybe<Scalars['UUID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  groupToChatId?: InputMaybe<MessageChatIdInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  senderKeyId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<MessageAuthorIdInput>;
};

/** An object where the defined keys will be set on the `message` being updated. */
export type UpdateMessageOnMessageForMessageChatIdPatch = {
  attachmentsUsingId?: InputMaybe<AttachmentMessageIdInverseInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  groupToChatId?: InputMaybe<MessageChatIdInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  senderKeyId?: InputMaybe<Scalars['UUID']['input']>;
  userToAuthorId?: InputMaybe<MessageAuthorIdInput>;
};

/** An object where the defined keys will be set on the `metaTag` being updated. */
export type UpdateMetaTagOnContentMetaTagForContentMetaTagMetaTagIdFkeyPatch = {
  contentItems?: InputMaybe<ContentMetaTagMetaTagIdFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MetaTagKind>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `noteActivitySession` being updated. */
export type UpdateNoteActivitySessionOnNoteActivitySessionForNoteActivitySessionActivitySessionIdFkeyPatch = {
  activitySessions?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInput>;
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<NoteActivitySessionNoteIdFkeyInput>;
};

/** An object where the defined keys will be set on the `noteActivitySession` being updated. */
export type UpdateNoteActivitySessionOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyPatch = {
  activitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  activitySessions?: InputMaybe<NoteActivitySessionActivitySessionIdFkeyInput>;
  notes?: InputMaybe<NoteActivitySessionNoteIdFkeyInput>;
};

/** An object where the defined keys will be set on the `note` being updated. */
export type UpdateNoteOnDocumentationSyncForDocumentationSyncNoteIdFkeyPatch = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `note` being updated. */
export type UpdateNoteOnNoteActivitySessionForNoteActivitySessionNoteIdFkeyPatch = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `note` being updated. */
export type UpdateNoteOnNoteForNoteAuthorIdFkeyPatch = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `note` being updated. */
export type UpdateNoteOnNoteProcedureForNoteProcedureNoteIdFkeyPatch = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `note` being updated. */
export type UpdateNoteOnNoteSeniorForNoteSeniorNoteIdFkeyPatch = {
  activityParticipantToDocumentationActivitySessionIdAndDocumentationSeniorId?: InputMaybe<NoteActivityDocumentationParticipantFkeyInput>;
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  documentationActivitySessionId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSeniorId?: InputMaybe<Scalars['UUID']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncNoteIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** DEPRECATED */
  mdDocumentation?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteActivitySessionsUsingId?: InputMaybe<NoteActivitySessionNoteIdFkeyInverseInput>;
  noteProceduresUsingId?: InputMaybe<NoteProcedureNoteIdFkeyInverseInput>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorNoteIdFkeyInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToAuthorId?: InputMaybe<NoteAuthorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `noteProcedure` being updated. */
export type UpdateNoteProcedureOnNoteProcedureForNoteProcedureNoteIdFkeyPatch = {
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureNotes?: InputMaybe<NoteProcedureNoteIdFkeyInput>;
  procedureToProcedureId?: InputMaybe<NoteProcedureProcedureIdFkeyInput>;
};

/** An object where the defined keys will be set on the `noteProcedure` being updated. */
export type UpdateNoteProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyPatch = {
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  procedureNotes?: InputMaybe<NoteProcedureNoteIdFkeyInput>;
  procedureToProcedureId?: InputMaybe<NoteProcedureProcedureIdFkeyInput>;
};

/** An object where the defined keys will be set on the `noteSenior` being updated. */
export type UpdateNoteSeniorOnNoteSeniorForNoteSeniorNoteIdFkeyPatch = {
  notes?: InputMaybe<NoteSeniorNoteIdFkeyInput>;
  seniorId?: InputMaybe<Scalars['UUID']['input']>;
  seniors?: InputMaybe<NoteSeniorSeniorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `noteSenior` being updated. */
export type UpdateNoteSeniorOnNoteSeniorForNoteSeniorSeniorIdFkeyPatch = {
  noteId?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<NoteSeniorNoteIdFkeyInput>;
  seniors?: InputMaybe<NoteSeniorSeniorIdFkeyInput>;
};

/** An object where the defined keys will be set on the `organizationManager` being updated. */
export type UpdateOrganizationManagerOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  organizationToOrganizationId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<OrganizationManagersUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `organizationManager` being updated. */
export type UpdateOrganizationManagerOnOrganizationManagerForOrganizationManagersUserIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInput>;
  userToUserId?: InputMaybe<OrganizationManagersUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `organization` being updated. */
export type UpdateOrganizationOnDeviceForDeviceOrganizationIdFkeyPatch = {
  /** Additional information about the organization */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Whether the organization provides ambulant care; a copy of its Salesforce account's setting when it has an account. */
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** City of the organization */
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceOrganizationIdFkeyInverseInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationsUsingId?: InputMaybe<FkLocationOrganizationInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationManagersUsingId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkOrganizationInverseInput>;
  patientsUsingId?: InputMaybe<FkPatientOrganizationInverseInput>;
  /** Postal code (PLZ) of the organization location */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  practitionersUsingId?: InputMaybe<PractitionerOrganizationIdFkeyInverseInput>;
  proceduresUsingId?: InputMaybe<ProcedureOrganizationIdFkeyInverseInput>;
  /** Source system that created this organization (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  /** Street address of the organization */
  street?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `organization` being updated. */
export type UpdateOrganizationOnLocationForFkLocationOrganizationPatch = {
  /** Additional information about the organization */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Whether the organization provides ambulant care; a copy of its Salesforce account's setting when it has an account. */
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** City of the organization */
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceOrganizationIdFkeyInverseInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationsUsingId?: InputMaybe<FkLocationOrganizationInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationManagersUsingId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkOrganizationInverseInput>;
  patientsUsingId?: InputMaybe<FkPatientOrganizationInverseInput>;
  /** Postal code (PLZ) of the organization location */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  practitionersUsingId?: InputMaybe<PractitionerOrganizationIdFkeyInverseInput>;
  proceduresUsingId?: InputMaybe<ProcedureOrganizationIdFkeyInverseInput>;
  /** Source system that created this organization (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  /** Street address of the organization */
  street?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `organization` being updated. */
export type UpdateOrganizationOnOrganizationManagerForOrganizationManagersOrganizationIdFkeyPatch = {
  /** Additional information about the organization */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Whether the organization provides ambulant care; a copy of its Salesforce account's setting when it has an account. */
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** City of the organization */
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceOrganizationIdFkeyInverseInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationsUsingId?: InputMaybe<FkLocationOrganizationInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationManagersUsingId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkOrganizationInverseInput>;
  patientsUsingId?: InputMaybe<FkPatientOrganizationInverseInput>;
  /** Postal code (PLZ) of the organization location */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  practitionersUsingId?: InputMaybe<PractitionerOrganizationIdFkeyInverseInput>;
  proceduresUsingId?: InputMaybe<ProcedureOrganizationIdFkeyInverseInput>;
  /** Source system that created this organization (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  /** Street address of the organization */
  street?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `organization` being updated. */
export type UpdateOrganizationOnOrganizationPractitionerForFkOrganizationPatch = {
  /** Additional information about the organization */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Whether the organization provides ambulant care; a copy of its Salesforce account's setting when it has an account. */
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** City of the organization */
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceOrganizationIdFkeyInverseInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationsUsingId?: InputMaybe<FkLocationOrganizationInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationManagersUsingId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkOrganizationInverseInput>;
  patientsUsingId?: InputMaybe<FkPatientOrganizationInverseInput>;
  /** Postal code (PLZ) of the organization location */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  practitionersUsingId?: InputMaybe<PractitionerOrganizationIdFkeyInverseInput>;
  proceduresUsingId?: InputMaybe<ProcedureOrganizationIdFkeyInverseInput>;
  /** Source system that created this organization (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  /** Street address of the organization */
  street?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `organization` being updated. */
export type UpdateOrganizationOnPatientForFkPatientOrganizationPatch = {
  /** Additional information about the organization */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Whether the organization provides ambulant care; a copy of its Salesforce account's setting when it has an account. */
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** City of the organization */
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceOrganizationIdFkeyInverseInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationsUsingId?: InputMaybe<FkLocationOrganizationInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationManagersUsingId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkOrganizationInverseInput>;
  patientsUsingId?: InputMaybe<FkPatientOrganizationInverseInput>;
  /** Postal code (PLZ) of the organization location */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  practitionersUsingId?: InputMaybe<PractitionerOrganizationIdFkeyInverseInput>;
  proceduresUsingId?: InputMaybe<ProcedureOrganizationIdFkeyInverseInput>;
  /** Source system that created this organization (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  /** Street address of the organization */
  street?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `organization` being updated. */
export type UpdateOrganizationOnPractitionerForPractitionerOrganizationIdFkeyPatch = {
  /** Additional information about the organization */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Whether the organization provides ambulant care; a copy of its Salesforce account's setting when it has an account. */
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** City of the organization */
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceOrganizationIdFkeyInverseInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationsUsingId?: InputMaybe<FkLocationOrganizationInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationManagersUsingId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkOrganizationInverseInput>;
  patientsUsingId?: InputMaybe<FkPatientOrganizationInverseInput>;
  /** Postal code (PLZ) of the organization location */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  practitionersUsingId?: InputMaybe<PractitionerOrganizationIdFkeyInverseInput>;
  proceduresUsingId?: InputMaybe<ProcedureOrganizationIdFkeyInverseInput>;
  /** Source system that created this organization (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  /** Street address of the organization */
  street?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `organization` being updated. */
export type UpdateOrganizationOnProcedureForProcedureOrganizationIdFkeyPatch = {
  /** Additional information about the organization */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Whether the organization provides ambulant care; a copy of its Salesforce account's setting when it has an account. */
  ambulant?: InputMaybe<Scalars['Boolean']['input']>;
  /** City of the organization */
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  devicesUsingId?: InputMaybe<DeviceOrganizationIdFkeyInverseInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationsUsingId?: InputMaybe<FkLocationOrganizationInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationManagersUsingId?: InputMaybe<OrganizationManagersOrganizationIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkOrganizationInverseInput>;
  patientsUsingId?: InputMaybe<FkPatientOrganizationInverseInput>;
  /** Postal code (PLZ) of the organization location */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  practitionersUsingId?: InputMaybe<PractitionerOrganizationIdFkeyInverseInput>;
  proceduresUsingId?: InputMaybe<ProcedureOrganizationIdFkeyInverseInput>;
  /** Source system that created this organization (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  /** Street address of the organization */
  street?: InputMaybe<Scalars['String']['input']>;
};

/** An object where the defined keys will be set on the `organizationPractitioner` being updated. */
export type UpdateOrganizationPractitionerOnOrganizationPractitionerForFkOrganizationPatch = {
  organizationToOrganizationId?: InputMaybe<FkOrganizationInput>;
  practitionerId?: InputMaybe<Scalars['UUID']['input']>;
  userToPractitionerId?: InputMaybe<FkPractitionerInput>;
};

/** An object where the defined keys will be set on the `organizationPractitioner` being updated. */
export type UpdateOrganizationPractitionerOnOrganizationPractitionerForFkPractitionerPatch = {
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkOrganizationInput>;
  userToPractitionerId?: InputMaybe<FkPractitionerInput>;
};

/** An object where the defined keys will be set on the `patient` being updated. */
export type UpdatePatientOnPatientForFkPatientOrganizationPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Reference to the patient location; the organization root represents no assigned physical location */
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<PatientLocationIdFkeyInput>;
  organizationToOrganizationId?: InputMaybe<FkPatientOrganizationInput>;
  /** Unique identifier for the patient within the organization */
  patientNumber?: InputMaybe<Scalars['String']['input']>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInverseInput>;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<FkUserInput>;
};

/** An object where the defined keys will be set on the `patient` being updated. */
export type UpdatePatientOnPatientForFkUserPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Reference to the patient location; the organization root represents no assigned physical location */
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<PatientLocationIdFkeyInput>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkPatientOrganizationInput>;
  /** Unique identifier for the patient within the organization */
  patientNumber?: InputMaybe<Scalars['String']['input']>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInverseInput>;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  userToUserId?: InputMaybe<FkUserInput>;
};

/** An object where the defined keys will be set on the `patient` being updated. */
export type UpdatePatientOnPatientForPatientLocationIdFkeyPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<PatientLocationIdFkeyInput>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkPatientOrganizationInput>;
  /** Unique identifier for the patient within the organization */
  patientNumber?: InputMaybe<Scalars['String']['input']>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInverseInput>;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<FkUserInput>;
};

/** An object where the defined keys will be set on the `patient` being updated. */
export type UpdatePatientOnProcedureParticipantForProcedureParticipantsPatientIdFkeyPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** External ID from source system. For M4c-created patients, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Reference to the patient location; the organization root represents no assigned physical location */
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  locationToLocationId?: InputMaybe<PatientLocationIdFkeyInput>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<FkPatientOrganizationInput>;
  /** Unique identifier for the patient within the organization */
  patientNumber?: InputMaybe<Scalars['String']['input']>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInverseInput>;
  /** Source system that created this patient (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<FkUserInput>;
};

/** An object where the defined keys will be set on the `practitioner` being updated. */
export type UpdatePractitionerOnLocationPractitionerForFkLocationPractitionersPractitionerPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersPractitionerInverseInput>;
  motherTongue?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<PractitionerOrganizationIdFkeyInput>;
  proceduresUsingId?: InputMaybe<ProcedurePerformerIdFkeyInverseInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  /** Source-system practitioner short code. For Vivendi this maps to Mitarbeiter.Handzeichen / FHIR Practitioner.identifier system urn:vivendi:handzeichen. */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<PractitionerStatusEnum>;
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<PractitionerUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `practitioner` being updated. */
export type UpdatePractitionerOnPractitionerForPractitionerOrganizationIdFkeyPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersPractitionerInverseInput>;
  motherTongue?: InputMaybe<Scalars['String']['input']>;
  organizationToOrganizationId?: InputMaybe<PractitionerOrganizationIdFkeyInput>;
  proceduresUsingId?: InputMaybe<ProcedurePerformerIdFkeyInverseInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  /** Source-system practitioner short code. For Vivendi this maps to Mitarbeiter.Handzeichen / FHIR Practitioner.identifier system urn:vivendi:handzeichen. */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<PractitionerStatusEnum>;
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<PractitionerUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `practitioner` being updated. */
export type UpdatePractitionerOnPractitionerForPractitionerUserIdFkeyPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersPractitionerInverseInput>;
  motherTongue?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<PractitionerOrganizationIdFkeyInput>;
  proceduresUsingId?: InputMaybe<ProcedurePerformerIdFkeyInverseInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  /** Source-system practitioner short code. For Vivendi this maps to Mitarbeiter.Handzeichen / FHIR Practitioner.identifier system urn:vivendi:handzeichen. */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<PractitionerStatusEnum>;
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
  userToUserId?: InputMaybe<PractitionerUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `practitioner` being updated. */
export type UpdatePractitionerOnProcedureForProcedurePerformerIdFkeyPatch = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  /** External ID from source system. For M4c-created practitioners, this is the user_id. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  locationPractitionersUsingId?: InputMaybe<FkLocationPractitionersPractitionerInverseInput>;
  motherTongue?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<PractitionerOrganizationIdFkeyInput>;
  proceduresUsingId?: InputMaybe<ProcedurePerformerIdFkeyInverseInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  /** Source-system practitioner short code. For Vivendi this maps to Mitarbeiter.Handzeichen / FHIR Practitioner.identifier system urn:vivendi:handzeichen. */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  /** Source system that created this practitioner (senso, vivendi, medifoxdan, mynerva, m4c) */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<PractitionerStatusEnum>;
  telephoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<PractitionerUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `procedure` being updated. */
export type UpdateProcedureOnActivitySessionForActivitySessionProcedureIdFkeyPatch = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** An object where the defined keys will be set on the `procedure` being updated. */
export type UpdateProcedureOnDocumentationSyncForDocumentationSyncProcedureIdFkeyPatch = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** An object where the defined keys will be set on the `procedure` being updated. */
export type UpdateProcedureOnNoteProcedureForNoteProcedureProcedureIdFkeyPatch = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** An object where the defined keys will be set on the `procedure` being updated. */
export type UpdateProcedureOnProcedureForProcedureOrganizationIdFkeyPatch = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** An object where the defined keys will be set on the `procedure` being updated. */
export type UpdateProcedureOnProcedureForProcedurePerformerIdFkeyPatch = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** An object where the defined keys will be set on the `procedure` being updated. */
export type UpdateProcedureOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyPatch = {
  /** Timestamp when the procedure was formally acknowledged/signed off (German: abgezeichnet/quittiert). NULL means not yet signed off. Used to distinguish draft procedures (executed but not finalized) from completed procedures (executed and signed off). Maps to: Senso durchfZeitpunkt, Vivendi DokumentiertAm. */
  acknowledgedAt?: InputMaybe<Scalars['Datetime']['input']>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionProcedureIdFkeyInverseInput>;
  categoryDisplay?: InputMaybe<Scalars['String']['input']>;
  categorySystem?: InputMaybe<Scalars['String']['input']>;
  categoryValue?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeValue?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Detailed description or instructions for the procedure */
  description?: InputMaybe<Scalars['String']['input']>;
  /** AI-generated comprehensive documentation summarizing all activities performed in this procedure. Generated once when the procedure completes (status becomes completed). */
  documentation?: InputMaybe<Scalars['String']['input']>;
  documentationSyncsUsingId?: InputMaybe<DocumentationSyncProcedureIdFkeyInverseInput>;
  /** Unit for medication doses (e.g., mg, ml) */
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Actually administered medication dose (for medication procedures) */
  executedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  /**
   * Expected duration of the procedure in minutes (Zeitbedarf from source system).
   *    This is separate from planned_start/planned_end which represent the scheduling window (Zeitbereich).
   *
   *    Example:
   *      - planned_start = 2026-02-03 13:00 (window start)
   *      - planned_end = 2026-02-03 15:59 (window end - 3 hour window)
   *      - expected_duration = 60 (actual duration in minutes)
   *
   *    Interpretation: The procedure CAN be started anytime between 13:00-15:59,
   *    and will TAKE 60 minutes to complete.
   */
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Original ID from the source system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of medication (for medication procedures) */
  medicationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationToOrganizationId?: InputMaybe<ProcedureOrganizationIdFkeyInput>;
  performedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  performedStart?: InputMaybe<Scalars['Datetime']['input']>;
  performerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Planned medication dose (for medication procedures) */
  plannedDose?: InputMaybe<Scalars['BigFloat']['input']>;
  plannedEnd?: InputMaybe<Scalars['Datetime']['input']>;
  plannedStart?: InputMaybe<Scalars['Datetime']['input']>;
  practitionerToPerformerId?: InputMaybe<ProcedurePerformerIdFkeyInput>;
  procedureNotes?: InputMaybe<NoteProcedureProcedureIdFkeyInverseInput>;
  procedureParticipantsUsingId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInverseInput>;
  recorderId?: InputMaybe<Scalars['UUID']['input']>;
  /** Flexible JSON storage for source-specific data */
  sourceData?: InputMaybe<Scalars['JSON']['input']>;
  /** Source system that created this procedure (senso, vivendi, medifoxdan, mynerva, m4c) - uses shared api.data_source */
  sourceSystem?: InputMaybe<DataSource>;
  status?: InputMaybe<ProcedureStatusEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Type of vital sign measured (for vital sign procedures) */
  vitalSignType?: InputMaybe<Scalars['String']['input']>;
  /** Unit for vital sign values (e.g., mmHg, bpm, °C) */
  vitalSignUnit?: InputMaybe<Scalars['String']['input']>;
  /** Measured vital sign value (for vital sign procedures) */
  vitalSignValue?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** An object where the defined keys will be set on the `procedureParticipant` being updated. */
export type UpdateProcedureParticipantOnProcedureParticipantForProcedureParticipantsPatientIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  patientToPatientId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInput>;
  /** Reference to the procedure */
  procedureId?: InputMaybe<Scalars['UUID']['input']>;
  procedureToProcedureId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInput>;
};

/** An object where the defined keys will be set on the `procedureParticipant` being updated. */
export type UpdateProcedureParticipantOnProcedureParticipantForProcedureParticipantsProcedureIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Reference to a participating patient */
  patientId?: InputMaybe<Scalars['UUID']['input']>;
  patientToPatientId?: InputMaybe<ProcedureParticipantsPatientIdFkeyInput>;
  procedureToProcedureId?: InputMaybe<ProcedureParticipantsProcedureIdFkeyInput>;
};

/** An object where the defined keys will be set on the `senderKey` being updated. */
export type UpdateSenderKeyOnSenderKeyForSenderKeyGroupIdPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  groupToGroupId?: InputMaybe<SenderKeyGroupIdInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  keyHash?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** An object where the defined keys will be set on the `userContentActivity` being updated. */
export type UpdateUserContentActivityOnUserContentActivityForUserContentActivityContentIdFkeyPatch = {
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  contentToContentId?: InputMaybe<UserContentActivityContentIdFkeyInput>;
  customActivityName?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorProfileId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInput>;
  userToUserId?: InputMaybe<UserContentActivityUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `userContentActivity` being updated. */
export type UpdateUserContentActivityOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyPatch = {
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<UserContentActivityContentIdFkeyInput>;
  customActivityName?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorProfileId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInput>;
  userToUserId?: InputMaybe<UserContentActivityUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `userContentActivity` being updated. */
export type UpdateUserContentActivityOnUserContentActivityForUserContentActivityUserIdFkeyPatch = {
  beganAt?: InputMaybe<Scalars['Datetime']['input']>;
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<UserContentActivityContentIdFkeyInput>;
  customActivityName?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  seniorProfileId?: InputMaybe<Scalars['UUID']['input']>;
  userToSeniorProfileId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInput>;
  userToUserId?: InputMaybe<UserContentActivityUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `userContentFavorite` being updated. */
export type UpdateUserContentFavoriteOnUserContentFavoriteForUserContentFavoriteContentIdFkeyPatch = {
  contentToContentId?: InputMaybe<UserContentFavoriteContentIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<UserContentFavoriteUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `userContentFavorite` being updated. */
export type UpdateUserContentFavoriteOnUserContentFavoriteForUserContentFavoriteUserIdFkeyPatch = {
  contentId?: InputMaybe<Scalars['UUID']['input']>;
  contentToContentId?: InputMaybe<UserContentFavoriteContentIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  userToUserId?: InputMaybe<UserContentFavoriteUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnActivityGoalForActivityGoalUserIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnActivityParticipantForActivityParticipantSeniorIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnActivitySessionForActivitySessionCaregiverIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnAppSettingForAppSettingUserIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnCaregiverProfileForCaregiverProfileUserIdPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnCaregiverSeniorForCaregiverSeniorsCaregiverIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnCaregiverSeniorForCaregiverSeniorsSeniorIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnCheckInForCheckInAuthorFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnCheckInForCheckInSeniorFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnCheckInMessageForCheckInMessageAuthorFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFamilyMemberSeniorForFamilyMemberSeniorsFamilyMemberIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFamilyMemberSeniorForFamilyMemberSeniorsSeniorIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFeedbackForFeedbackUserIdPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFormResponseForFormResponseAuthorFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnInvitationForInvitationInvitedByFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnKorianUserForKorianUserIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnMediaAlbumForMediaAlbumUserIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnMediaNoteForMediaNoteAuthorFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnMediaVoiceRecordingForVoiceRecordingAuthorFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnMembershipForMembershipMemberIdPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnMessageForMessageAuthorIdPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnNoteForNoteAuthorIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnNoteSeniorForNoteSeniorSeniorIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnOrganizationManagerForOrganizationManagersUserIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnOrganizationPractitionerForFkPractitionerPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPatientForFkUserPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPractitionerForPractitionerUserIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserContentActivityForUserContentActivitySeniorProfileIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserContentActivityForUserContentActivityUserIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserContentFavoriteForUserContentFavoriteUserIdFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserForUserAvatarMediaFkeyPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserSettingForUserIdPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnWebsiteForOwnerUserIdPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnWorkgroupMembershipForWorkgroupMembershipMemberIdPatch = {
  activityGoalsUsingId?: InputMaybe<ActivityGoalUserIdFkeyInverseInput>;
  activityParticipantsUsingId?: InputMaybe<ActivityParticipantSeniorIdFkeyInverseInput>;
  activitySessionsUsingId?: InputMaybe<ActivitySessionCaregiverIdFkeyInverseInput>;
  appSettingsUsingId?: InputMaybe<AppSettingUserIdFkeyInverseInput>;
  avatar?: InputMaybe<Scalars['UUID']['input']>;
  caregiverProfileUsingId?: InputMaybe<CaregiverProfileUserIdInverseInput>;
  caregiverSeniorsToCaregiverIdUsingId?: InputMaybe<CaregiverSeniorsCaregiverIdFkeyInverseInput>;
  caregiverSeniorsToSeniorIdUsingId?: InputMaybe<CaregiverSeniorsSeniorIdFkeyInverseInput>;
  checkInMessagesUsingId?: InputMaybe<CheckInMessageAuthorFkeyInverseInput>;
  checkInsToAuthorIdUsingId?: InputMaybe<CheckInAuthorFkeyInverseInput>;
  checkInsToSeniorIdUsingId?: InputMaybe<CheckInSeniorFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  familyMemberSeniorsToFamilyMemberIdUsingId?: InputMaybe<FamilyMemberSeniorsFamilyMemberIdFkeyInverseInput>;
  familyMemberSeniorsToSeniorIdUsingId?: InputMaybe<FamilyMemberSeniorsSeniorIdFkeyInverseInput>;
  feedbacksUsingId?: InputMaybe<FeedbackUserIdInverseInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formResponsesUsingId?: InputMaybe<FormResponseAuthorFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitationsUsingId?: InputMaybe<InvitationInvitedByFkeyInverseInput>;
  kind?: InputMaybe<UserType>;
  korianUserUsingId?: InputMaybe<KorianUserIdFkeyInverseInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaAlbumsUsingId?: InputMaybe<MediaAlbumUserIdFkeyInverseInput>;
  mediaNotesUsingId?: InputMaybe<MediaNoteAuthorFkeyInverseInput>;
  mediaToAvatar?: InputMaybe<UserAvatarMediaFkeyInput>;
  mediaVoiceRecordingsUsingId?: InputMaybe<VoiceRecordingAuthorFkeyInverseInput>;
  memberships?: InputMaybe<MembershipMemberIdInverseInput>;
  messagesAuthored?: InputMaybe<MessageAuthorIdInverseInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteSeniorsUsingId?: InputMaybe<NoteSeniorSeniorIdFkeyInverseInput>;
  notesUsingId?: InputMaybe<NoteAuthorIdFkeyInverseInput>;
  organizationManagerUsingId?: InputMaybe<OrganizationManagersUserIdFkeyInverseInput>;
  organizationPractitionersUsingId?: InputMaybe<FkPractitionerInverseInput>;
  patientUsingId?: InputMaybe<FkUserInverseInput>;
  practitionerUsingId?: InputMaybe<PractitionerUserIdFkeyInverseInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  userContentActivitiesToSeniorProfileIdUsingId?: InputMaybe<UserContentActivitySeniorProfileIdFkeyInverseInput>;
  userContentActivitiesToUserIdUsingId?: InputMaybe<UserContentActivityUserIdFkeyInverseInput>;
  userContentFavoritesUsingId?: InputMaybe<UserContentFavoriteUserIdFkeyInverseInput>;
  userSettingUsingId?: InputMaybe<UserIdInverseInput>;
  websitesUsingId?: InputMaybe<OwnerUserIdInverseInput>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipMemberIdInverseInput>;
};

/** An object where the defined keys will be set on the `userSetting` being updated. */
export type UpdateUserSettingOnUserSettingForUserIdPatch = {
  encryptionMode?: InputMaybe<EncryptionMode>;
  userToUserId?: InputMaybe<UserIdInput>;
};

/** An object where the defined keys will be set on the `website` being updated. */
export type UpdateWebsiteOnWebsiteForOwnerUserIdPatch = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userToUserId?: InputMaybe<OwnerUserIdInput>;
};

/** An object where the defined keys will be set on the `workgroupMembership` being updated. */
export type UpdateWorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipMemberIdPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  userToMemberId?: InputMaybe<WorkgroupMembershipMemberIdInput>;
  workgroupId?: InputMaybe<Scalars['UUID']['input']>;
  workgroupToWorkgroupId?: InputMaybe<WorkgroupMembershipWorkgroupIdInput>;
};

/** An object where the defined keys will be set on the `workgroupMembership` being updated. */
export type UpdateWorkgroupMembershipOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  userToMemberId?: InputMaybe<WorkgroupMembershipMemberIdInput>;
  workgroupToWorkgroupId?: InputMaybe<WorkgroupMembershipWorkgroupIdInput>;
};

/** An object where the defined keys will be set on the `workgroup` being updated. */
export type UpdateWorkgroupOnHandshakeCodeForHandshakeCodesWorkgroupIdPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  handshakeCodesUsingId?: InputMaybe<HandshakeCodesWorkgroupIdInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipWorkgroupIdInverseInput>;
};

/** An object where the defined keys will be set on the `workgroup` being updated. */
export type UpdateWorkgroupOnWorkgroupMembershipForWorkgroupMembershipWorkgroupIdPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  handshakeCodesUsingId?: InputMaybe<HandshakeCodesWorkgroupIdInverseInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workgroupMembershipsUsingId?: InputMaybe<WorkgroupMembershipWorkgroupIdInverseInput>;
};

export type LogisticsHexnodeDeviceFragment = { __typename?: 'LogisticsHexnodeDevice', state: LogisticsHexnodeState, deviceId?: string | null, url?: string | null, enrollmentStatus?: string | null, active?: boolean | null, lastSeenAt?: any | null, syncedAt?: any | null, stale: boolean };

export type LogisticsWorkspaceOneAppFragment = { __typename?: 'LogisticsWorkspaceOneApp', bundleId: string, appUuid: string, installedVersion?: string | null, assignedVersion?: string | null, installedStatus?: string | null, assignmentStatus?: string | null, lastReportedAt?: any | null };

export type LogisticsWorkspaceOneDeviceFragment = { __typename?: 'LogisticsWorkspaceOneDevice', deviceId: string, deviceUuid: string, imei?: string | null, serialNumber?: string | null, name?: string | null, model?: string | null, operatingSystem?: string | null, organizationGroupName?: string | null, enrollmentStatus?: string | null, complianceStatus?: string | null, lastSeenAt?: any | null, url: string, apps: Array<{ __typename?: 'LogisticsWorkspaceOneApp', bundleId: string, appUuid: string, installedVersion?: string | null, assignedVersion?: string | null, installedStatus?: string | null, assignmentStatus?: string | null, lastReportedAt?: any | null }> };

export type LogisticsWorkspaceOneMatchFragment = { __typename?: 'LogisticsWorkspaceOneMatch', state: LogisticsWorkspaceOneMatchState, syncedAt?: any | null, stale: boolean, device?: { __typename?: 'LogisticsWorkspaceOneDevice', deviceId: string, deviceUuid: string, imei?: string | null, serialNumber?: string | null, name?: string | null, model?: string | null, operatingSystem?: string | null, organizationGroupName?: string | null, enrollmentStatus?: string | null, complianceStatus?: string | null, lastSeenAt?: any | null, url: string, apps: Array<{ __typename?: 'LogisticsWorkspaceOneApp', bundleId: string, appUuid: string, installedVersion?: string | null, assignedVersion?: string | null, installedStatus?: string | null, assignmentStatus?: string | null, lastReportedAt?: any | null }> } | null };

export type SalesforceReportSectionFragment = { __typename?: 'SalesforceReportSection', reportId: string, type: SalesforceReportType, format: SalesforceReportFormat, source: SalesforceReportSource, filterLogic?: string | null, showSubtotals: boolean, showGrandTotal: boolean, hasMoreRows: boolean, rowLimit: number, chart?: SalesforceReportChart | null, lastSyncedAt?: any | null, unreadableFields: Array<string>, blockKey?: string | null, unavailable?: SalesforceReportUnavailable | null, missingFields: Array<string>, pendingObjects: Array<string>, chartUnavailable?: SalesforceReportUnavailable | null, chartMissingFields: Array<string>, chartPendingObjects: Array<string>, showValues?: boolean | null, sortLegendValues?: boolean | null, dateRange?: { __typename?: 'SalesforceReportDateRange', field: string, relative?: SalesforceReportRelativeRange | null, lastDays?: number | null, from?: string | null, to?: string | null } | null, filters: Array<{ __typename?: 'SalesforceReportFilter', field: string, operator: SalesforceReportFilterOperator, values: Array<string> }>, linkedFilters: Array<{ __typename?: 'SalesforceReportFilter', field: string, operator: SalesforceReportFilterOperator, values: Array<string> }>, down: Array<{ __typename?: 'SalesforceReportTableGrouping', field: string, granularity?: SalesforceReportGranularity | null, descending: boolean, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, across: Array<{ __typename?: 'SalesforceReportTableGrouping', field: string, granularity?: SalesforceReportGranularity | null, descending: boolean, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, summaries: Array<{ __typename?: 'SalesforceReportSummary', aggregate: SalesforceReportAggregate, field?: string | null, formula?: string | null }>, columns: Array<{ __typename?: 'SalesforceReportColumn', field: string, type: SalesforceReportFieldType, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, groups: Array<{ __typename?: 'SalesforceReportGroup', count: number, values: Array<number | null>, down: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }>, across: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }> }>, rows: Array<{ __typename?: 'SalesforceReportRow', values: Array<string | null>, links: Array<string | null>, down: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }> }>, chartGroupings: Array<{ __typename?: 'SalesforceReportGrouping', field: string, granularity?: SalesforceReportGranularity | null }>, chartMeasures: Array<{ __typename?: 'SalesforceReportMeasure', aggregate: SalesforceReportAggregate, field?: string | null }>, chartPoints: Array<{ __typename?: 'SalesforceReportPoint', group?: string | null, series?: string | null, values: Array<number | null> }> };

export type LogisticsDhlShippingSettingsFieldsFragment = { __typename?: 'LogisticsDhlShippingSettings', labelPrintFormat: string, returnLabelPrintFormat: string, labelPrintFormats: Array<string>, returnLabelPrintFormats: Array<string>, missingSettings: Array<LogisticsDhlSetting>, updatedAt?: any | null, shipper?: { __typename?: 'LogisticsDhlAddress', name: string, street: string, postalCode: string, city: string } | null, returnAddress?: { __typename?: 'LogisticsDhlAddress', name: string, street: string, postalCode: string, city: string } | null };

export type LogisticsDhlAccountSettingsFieldsFragment = { __typename?: 'LogisticsDhlAccountSettings', gateway: LogisticsDhlGateway, clientId?: string | null, hasClientSecret: boolean, username?: string | null, hasPassword: boolean, billingNumberPaket?: string | null, billingNumberPaketInternational?: string | null, billingNumberRetoure?: string | null, returnReceiverIdAustria?: string | null, missingSettings: Array<LogisticsDhlSetting>, updatedAt?: any | null };

export type LogisticsShippingLabelFieldsFragment = { __typename?: 'LogisticsShippingLabel', id: any, orderId: any, product: string, shipmentNumber: string, returnShipmentNumber?: string | null, printFormat: string, returnPrintFormat?: string | null, weightKg: number, createdAt: any, cancelledAt?: any | null, labelPdf: string, returnLabelPdf?: string | null };

export type CreateBillingInvoiceDownloadMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateBillingInvoiceDownloadMutation = { __typename?: 'Mutation', createBillingInvoiceDownload: { __typename?: 'BillingInvoiceDownload', url: string, expiresAt: any } };

export type SetOrganizationBillingAccessMutationVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
  accessEnabled: Scalars['Boolean']['input'];
  expectedMappingVersion: Scalars['UUID']['input'];
}>;


export type SetOrganizationBillingAccessMutation = { __typename?: 'Mutation', setOrganizationBillingAccess: { __typename?: 'OrganizationBillingAccess', organizationId: any, accessEnabled: boolean, mappingConfigured: boolean, invoiceAccountConfigured: boolean, salesforceAccountId?: string | null, salesforceAccountName?: string | null, frisbiiCustomerId?: string | null, mappingVersion?: any | null } };

export type SetOrganizationBillingAccountMutationVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
  salesforceAccountId: Scalars['String']['input'];
  frisbiiCustomerId?: InputMaybe<Scalars['String']['input']>;
  expectedMappingVersion?: InputMaybe<Scalars['UUID']['input']>;
  confirmed: Scalars['Boolean']['input'];
}>;


export type SetOrganizationBillingAccountMutation = { __typename?: 'Mutation', setOrganizationBillingAccount: { __typename?: 'OrganizationBillingAccess', organizationId: any, accessEnabled: boolean, mappingConfigured: boolean, invoiceAccountConfigured: boolean, salesforceAccountId?: string | null, salesforceAccountName?: string | null, frisbiiCustomerId?: string | null, mappingVersion?: any | null } };

export type StartLearningCourseMutationVariables = Exact<{
  input: StartLearningCourseInput;
}>;


export type StartLearningCourseMutation = { __typename?: 'Mutation', startLearningCourse: { __typename?: 'StartedLearningCourse', courseId: any, courseVersion: string, effect: LearningProgressEffect, startedAt: any, payload: string, progress: { __typename?: 'LearningCourseProgress', enrollmentId: any, status: LearningEnrollmentStatus, completedAt?: any | null, bestScorePercent?: number | null, lessons: Array<{ __typename?: 'LearningLessonProgress', courseVersion: string, lessonId: any, completedAt: any }>, quizAttempts: Array<{ __typename?: 'LearningQuizAttempt', id: any, courseVersion: string, serverScorePercent: number, serverPassed: boolean, finishedAt: any }> } } };

export type CompleteLearningLessonMutationVariables = Exact<{
  input: CompleteLearningLessonInput;
}>;


export type CompleteLearningLessonMutation = { __typename?: 'Mutation', completeLearningLesson: { __typename?: 'LessonProgressResult', courseId: any, courseVersion: string, lessonId: any, effect: LearningProgressEffect, completedAt: any, progress: { __typename?: 'LearningCourseProgress', enrollmentId: any, status: LearningEnrollmentStatus, completedAt?: any | null, bestScorePercent?: number | null, lessons: Array<{ __typename?: 'LearningLessonProgress', courseVersion: string, lessonId: any, completedAt: any }> } } };

export type SubmitLearningQuizAttemptMutationVariables = Exact<{
  input: SubmitLearningQuizAttemptInput;
}>;


export type SubmitLearningQuizAttemptMutation = { __typename?: 'Mutation', submitLearningQuizAttempt: { __typename?: 'QuizAttemptResult', attemptId: any, courseId: any, courseVersion: string, effect: LearningProgressEffect, clientScorePercent: number, clientPassed: boolean, serverCorrect: number, serverTotal: number, serverScorePercent: number, serverPassed: boolean, startedAt: any, finishedAt: any, progress: { __typename?: 'LearningCourseProgress', enrollmentId: any, status: LearningEnrollmentStatus, completedAt?: any | null, bestScorePercent?: number | null, quizAttempts: Array<{ __typename?: 'LearningQuizAttempt', id: any, courseVersion: string, serverScorePercent: number, serverPassed: boolean, finishedAt: any }> } } };

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation?: { __typename?: 'CreateLocationPayload', location?: { __typename?: 'Location', id: any, name: string, externalId: string, type: LocationTypeEnum, status?: string | null, partOfId?: any | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null } | null } | null };

export type UpdateLocationMutationVariables = Exact<{
  input: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation?: { __typename?: 'UpdateLocationPayload', location?: { __typename?: 'Location', id: any, name: string, externalId: string, type: LocationTypeEnum, partOfId?: any | null } | null } | null };

export type UpsertPatientMutationVariables = Exact<{
  input: UpsertPatientInput;
}>;


export type UpsertPatientMutation = { __typename?: 'Mutation', upsertPatient: { __typename?: 'PatientResponse', id: string } };

export type AddActivityGoalsMutationVariables = Exact<{
  activityGoals: Array<ActivityGoalItem> | ActivityGoalItem;
}>;


export type AddActivityGoalsMutation = { __typename?: 'Mutation', addActivityGoals?: boolean | null };

export type UpsertPractitionerMutationVariables = Exact<{
  input: UpsertPractitionerInput;
}>;


export type UpsertPractitionerMutation = { __typename?: 'Mutation', upsertPractitioner: { __typename?: 'PractitionerResponse', id: string, warningCode?: string | null } };

export type UpsertLocationMutationVariables = Exact<{
  input: UpsertLocationInput;
}>;


export type UpsertLocationMutation = { __typename?: 'Mutation', upsertLocation: { __typename?: 'LocationResponse', id: string } };

export type CompleteOnboardingMutationVariables = Exact<{
  input: CompleteOnboardingInput;
}>;


export type CompleteOnboardingMutation = { __typename?: 'Mutation', completeOnboarding: { __typename?: 'CompleteOnboardingPayload', locationIds: Array<string>, patientIds: Array<string>, practitionerIds: Array<string> } };

export type ResetPractitionerPasswordOtpMutationVariables = Exact<{
  input: ResetPractitionerPasswordOtpInput;
}>;


export type ResetPractitionerPasswordOtpMutation = { __typename?: 'Mutation', resetPractitionerPasswordOTP: { __typename?: 'ResetPasswordOTPResponse', warningCode?: string | null } };

export type RevealPractitionerPasswordOtpMutationVariables = Exact<{
  input: RevealPractitionerPasswordOtpInput;
}>;


export type RevealPractitionerPasswordOtpMutation = { __typename?: 'Mutation', revealPractitionerPasswordOTP: { __typename?: 'RevealPractitionerPasswordOTPResponse', otp?: string | null, status: RevealPractitionerPasswordOtpStatus } };

export type UpdateImportedPractitionerStatusMutationVariables = Exact<{
  input: UpdateImportedPractitionerStatusInput;
}>;


export type UpdateImportedPractitionerStatusMutation = { __typename?: 'Mutation', updateImportedPractitionerStatus: { __typename?: 'PractitionerResponse', id: string, warningCode?: string | null } };

export type SetupAccountPortalAccessMutationVariables = Exact<{
  salesforceAccountId: Scalars['String']['input'];
}>;


export type SetupAccountPortalAccessMutation = { __typename?: 'Mutation', setupAccountPortalAccess: any };

export type SetAccountAmbulantMutationVariables = Exact<{
  salesforceAccountId: Scalars['String']['input'];
  ambulant: Scalars['Boolean']['input'];
}>;


export type SetAccountAmbulantMutation = { __typename?: 'Mutation', setAccountAmbulant: boolean };

export type InviteManagerMutationVariables = Exact<{
  salesforceAccountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type InviteManagerMutation = { __typename?: 'Mutation', inviteManager: boolean };

export type SetOrganizationSalesforceAccountMutationVariables = Exact<{
  salesforceAccountId: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
}>;


export type SetOrganizationSalesforceAccountMutation = { __typename?: 'Mutation', setOrganizationSalesforceAccount: boolean };

export type CreateTestLicensingCustomerMutationVariables = Exact<{
  email: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  managerName: Scalars['String']['input'];
}>;


export type CreateTestLicensingCustomerMutation = { __typename?: 'Mutation', createTestLicensingCustomer: string };

export type CreateUserWithValidationCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  kind: UserType;
  password: Scalars['String']['input'];
  code: Scalars['String']['input'];
  organizationName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUserWithValidationCodeMutation = { __typename?: 'Mutation', createUserWithValidationCode: { __typename?: 'TokenResponse', jwtToken?: any | null } };

export type SaveIntegrationSettingsMutationVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
  provider: IntegrationProvider;
  credentials: IntegrationCredentialsInput;
}>;


export type SaveIntegrationSettingsMutation = { __typename?: 'Mutation', saveIntegrationSettings: { __typename?: 'IntegrationSettings', organizationId: any, hasClientSecret: boolean, provider: IntegrationProvider, credentials: { __typename?: 'IntegrationCredentials', serverUrl?: string | null, clientId?: string | null, clientSecret?: string | null } } };

export type UpdatePlacetelIntegrationMutationVariables = Exact<{
  input: PlacetelIntegrationInput;
}>;


export type UpdatePlacetelIntegrationMutation = { __typename?: 'Mutation', updatePlacetelIntegration: { __typename?: 'PlacetelIntegration', enabled: boolean, organizationId?: string | null, clientId?: string | null, hasClientSecret: boolean, hasRefreshToken: boolean, hasWebhookSecret: boolean, phoneClientId?: string | null, hasPhoneClientSecret: boolean, updatedAt?: any | null } };

export type CheckPlacetelConnectionMutationVariables = Exact<{ [key: string]: never; }>;


export type CheckPlacetelConnectionMutation = { __typename?: 'Mutation', checkPlacetelConnection: { __typename?: 'PlacetelConnectionResult', ok: boolean, accountName?: string | null, errorCode?: PlacetelConnectionError | null, callHistory?: PlacetelCallHistoryAccess | null } };

export type UpdatePlacetelHotlineNumbersMutationVariables = Exact<{
  numbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdatePlacetelHotlineNumbersMutation = { __typename?: 'Mutation', updatePlacetelHotlineNumbers: Array<string> };

export type UpdatePlacetelOpeningHoursMutationVariables = Exact<{
  input: Array<PlacetelOpeningDayInput> | PlacetelOpeningDayInput;
}>;


export type UpdatePlacetelOpeningHoursMutation = { __typename?: 'Mutation', updatePlacetelOpeningHours: Array<{ __typename?: 'PlacetelOpeningDay', weekday: number, opens: string, closes: string }> };

export type BeginPlacetelPhoneSignInMutationVariables = Exact<{
  redirectUri: Scalars['String']['input'];
}>;


export type BeginPlacetelPhoneSignInMutation = { __typename?: 'Mutation', beginPlacetelPhoneSignIn: { __typename?: 'PlacetelPhoneSignInStart', authorizationUrl: string } };

export type CompletePlacetelPhoneSignInMutationVariables = Exact<{
  input: CompletePlacetelPhoneSignInInput;
}>;


export type CompletePlacetelPhoneSignInMutation = { __typename?: 'Mutation', completePlacetelPhoneSignIn: { __typename?: 'PlacetelPhoneSignInResult', errorCode?: PlacetelPhoneSignInError | null, account: { __typename?: 'PlacetelPhoneAccount', available: boolean, connected: boolean, email?: string | null, connectedAt?: any | null } } };

export type DisconnectPlacetelPhoneMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectPlacetelPhoneMutation = { __typename?: 'Mutation', disconnectPlacetelPhone: { __typename?: 'PlacetelPhoneAccount', available: boolean, connected: boolean, email?: string | null, connectedAt?: any | null } };

export type IssuePlacetelPhoneAccessTokenMutationVariables = Exact<{
  renew?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IssuePlacetelPhoneAccessTokenMutation = { __typename?: 'Mutation', issuePlacetelPhoneAccessToken: { __typename?: 'PlacetelPhoneAccessToken', accessToken?: string | null, expiresAt?: any | null, errorCode?: PlacetelPhoneTokenError | null } };

export type RecordPlacetelCallEventMutationVariables = Exact<{
  input: PlacetelCallEventInput;
}>;


export type RecordPlacetelCallEventMutation = { __typename?: 'Mutation', recordPlacetelCallEvent: { __typename?: 'PlacetelCall', id: any, remoteNumber?: string | null } };

export type AddPlacetelCallNoteMutationVariables = Exact<{
  input: PlacetelCallNoteInput;
}>;


export type AddPlacetelCallNoteMutation = { __typename?: 'Mutation', addPlacetelCallNote: { __typename?: 'PlacetelCallNote', id: any, callId: any, createdAt: any } };

export type SyncIntegrationDataMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type SyncIntegrationDataMutation = { __typename?: 'Mutation', syncIntegrationData: { __typename?: 'IntegrationExecution', organizationId: any, id: any, userId?: any | null, provider: IntegrationProvider, status: IntegrationExecutionStatus, result?: IntegrationExecutionResult | null, jobId?: string | null, summary?: any | null, errorMessage?: string | null, startedAt: any, completedAt?: any | null, duration?: number | null } };

export type TestIntegrationConnectionMutationVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
}>;


export type TestIntegrationConnectionMutation = { __typename?: 'Mutation', testIntegrationConnection: { __typename?: 'IntegrationConnectionCheck', ok: boolean, provider?: IntegrationProvider | null, stage?: IntegrationConnectionStage | null, error?: IntegrationConnectionError | null, httpStatus?: number | null, locationCount?: number | null, durationMs: number } };

export type PreviewIntegrationImportMutationVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
}>;


export type PreviewIntegrationImportMutation = { __typename?: 'Mutation', previewIntegrationImport: { __typename?: 'IntegrationExecution', id: any, organizationId: any, kind: IntegrationExecutionKind, status: IntegrationExecutionStatus } };

export type RequestPasswordResetOtpMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetOtpMutation = { __typename?: 'Mutation', requestPasswordResetOTP: boolean };

export type ResetPasswordWithValidationCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordWithValidationCodeMutation = { __typename?: 'Mutation', resetPasswordWithValidationCode: { __typename?: 'TokenResponse', jwtToken?: any | null } };

export type PlanRecommendedActivityMutationVariables = Exact<{
  input: PlanRecommendedActivityInput;
}>;


export type PlanRecommendedActivityMutation = { __typename?: 'Mutation', planRecommendedActivity: { __typename?: 'PlanRecommendedActivityResult', procedureId: any, sessionId: any } };

export type RemovePlannedProcedureActivitySessionMutationVariables = Exact<{
  input: RemovePlannedProcedureActivitySessionInput;
}>;


export type RemovePlannedProcedureActivitySessionMutation = { __typename?: 'Mutation', removePlannedProcedureActivitySession: boolean };

export type SubmitAdminPortalFeedbackMutationVariables = Exact<{
  input: SubmitAdminPortalFeedbackInput;
}>;


export type SubmitAdminPortalFeedbackMutation = { __typename?: 'Mutation', submitAdminPortalFeedback: { __typename?: 'SubmitAdminPortalFeedbackPayload', feedbackId: number } };

export type GrantOrganizationLearningCourseMutationVariables = Exact<{
  input: OrganizationCourseGrantInput;
}>;


export type GrantOrganizationLearningCourseMutation = { __typename?: 'Mutation', grantLearningCourse: { __typename?: 'GrantResult', grant: { __typename?: 'LearningGrant', id?: any | null, courseId?: any | null, active: boolean } } };

export type RevokeOrganizationLearningCourseMutationVariables = Exact<{
  input: OrganizationCourseGrantInput;
}>;


export type RevokeOrganizationLearningCourseMutation = { __typename?: 'Mutation', revokeLearningCourse: { __typename?: 'GrantResult', grant: { __typename?: 'LearningGrant', id?: any | null, courseId?: any | null, active: boolean } } };

export type GrantOrganizationLearningPathMutationVariables = Exact<{
  input: OrganizationPathGrantInput;
}>;


export type GrantOrganizationLearningPathMutation = { __typename?: 'Mutation', grantLearningPath: { __typename?: 'GrantResult', grant: { __typename?: 'LearningGrant', id?: any | null, learningPathId?: any | null, active: boolean } } };

export type RevokeOrganizationLearningPathMutationVariables = Exact<{
  input: OrganizationPathGrantInput;
}>;


export type RevokeOrganizationLearningPathMutation = { __typename?: 'Mutation', revokeLearningPath: { __typename?: 'GrantResult', grant: { __typename?: 'LearningGrant', id?: any | null, learningPathId?: any | null, active: boolean } } };

export type ManagerLearningAssignmentFieldsFragment = { __typename?: 'LearningAssignment', id?: any | null, organizationId: any, userId: any, itemKind: LearningItemKind, courseId?: any | null, learningPathId?: any | null, learningPathVersion?: string | null, kind: LearningAssignmentKind, assignedBy?: any | null, assignedAt?: any | null, unassignedBy?: any | null, unassignedAt?: any | null, active: boolean, enrollmentIds: Array<any> };

export type AssignManagerLearningCourseMutationVariables = Exact<{
  input: CourseAssignmentInput;
}>;


export type AssignManagerLearningCourseMutation = { __typename?: 'Mutation', assignLearningCourse: { __typename?: 'AssignmentResult', assignment: { __typename?: 'LearningAssignment', id?: any | null, organizationId: any, userId: any, itemKind: LearningItemKind, courseId?: any | null, learningPathId?: any | null, learningPathVersion?: string | null, kind: LearningAssignmentKind, assignedBy?: any | null, assignedAt?: any | null, unassignedBy?: any | null, unassignedAt?: any | null, active: boolean, enrollmentIds: Array<any> } } };

export type UnassignManagerLearningCourseMutationVariables = Exact<{
  input: CourseAssignmentInput;
}>;


export type UnassignManagerLearningCourseMutation = { __typename?: 'Mutation', unassignLearningCourse: { __typename?: 'AssignmentResult', assignment: { __typename?: 'LearningAssignment', id?: any | null, organizationId: any, userId: any, itemKind: LearningItemKind, courseId?: any | null, learningPathId?: any | null, learningPathVersion?: string | null, kind: LearningAssignmentKind, assignedBy?: any | null, assignedAt?: any | null, unassignedBy?: any | null, unassignedAt?: any | null, active: boolean, enrollmentIds: Array<any> } } };

export type AssignManagerLearningPathMutationVariables = Exact<{
  input: PathAssignmentInput;
}>;


export type AssignManagerLearningPathMutation = { __typename?: 'Mutation', assignLearningPath: { __typename?: 'AssignmentResult', assignment: { __typename?: 'LearningAssignment', id?: any | null, organizationId: any, userId: any, itemKind: LearningItemKind, courseId?: any | null, learningPathId?: any | null, learningPathVersion?: string | null, kind: LearningAssignmentKind, assignedBy?: any | null, assignedAt?: any | null, unassignedBy?: any | null, unassignedAt?: any | null, active: boolean, enrollmentIds: Array<any> } } };

export type UnassignManagerLearningPathMutationVariables = Exact<{
  input: PathAssignmentInput;
}>;


export type UnassignManagerLearningPathMutation = { __typename?: 'Mutation', unassignLearningPath: { __typename?: 'AssignmentResult', assignment: { __typename?: 'LearningAssignment', id?: any | null, organizationId: any, userId: any, itemKind: LearningItemKind, courseId?: any | null, learningPathId?: any | null, learningPathVersion?: string | null, kind: LearningAssignmentKind, assignedBy?: any | null, assignedAt?: any | null, unassignedBy?: any | null, unassignedAt?: any | null, active: boolean, enrollmentIds: Array<any> } } };

export type CreateDeviceEnrollmentTokenMutationVariables = Exact<{
  input: CreateDeviceEnrollmentTokenInput;
}>;


export type CreateDeviceEnrollmentTokenMutation = { __typename?: 'Mutation', createDeviceEnrollmentToken: { __typename?: 'CreateDeviceEnrollmentTokenResponse', code: string, qrPayload: string, token: { __typename?: 'DeviceEnrollmentToken', id: any, organizationId: any, scopeType: DeviceEnrollmentScopeType, expiresAt: any, maxUses?: number | null, useCount: number, status: DeviceEnrollmentTokenStatus, implicit: boolean, createdAt: any, revokedAt?: any | null, scopeLocation?: { __typename?: 'DeviceEnrollmentLocation', id: any, name: string, type: LocationTypeEnum } | null, createdBy?: { __typename?: 'DeviceEnrollmentActor', id: any, name?: string | null } | null, redemptions: Array<{ __typename?: 'DeviceEnrollmentRedemption', id: any, redeemedAt: any, targetLocation?: { __typename?: 'DeviceEnrollmentLocation', id: any, name: string, type: LocationTypeEnum } | null, device?: { __typename?: 'DeviceEnrollmentRedemptionDevice', id: any, deviceId: string, name?: string | null, model?: string | null, manufacturer?: string | null, status: string } | null }>, emailDeliveries: Array<{ __typename?: 'DeviceEnrollmentEmailDelivery', id: any, recipientEmail: string, queuedAt: any, sentAt?: any | null, failedAt?: any | null, status: DeviceEnrollmentEmailDeliveryStatus, sentBy?: { __typename?: 'DeviceEnrollmentActor', id: any, name?: string | null } | null }> } } };

export type RevokeDeviceEnrollmentTokenMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RevokeDeviceEnrollmentTokenMutation = { __typename?: 'Mutation', revokeDeviceEnrollmentToken: { __typename?: 'DeviceEnrollmentToken', id: any, status: DeviceEnrollmentTokenStatus, revokedAt?: any | null } };

export type UnenrollDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type UnenrollDeviceMutation = { __typename?: 'Mutation', unenrollDevice: { __typename?: 'UnenrollDeviceResult', id: any, status: string } };

export type SendDeviceEnrollmentTokenEmailMutationVariables = Exact<{
  input: SendDeviceEnrollmentTokenEmailInput;
}>;


export type SendDeviceEnrollmentTokenEmailMutation = { __typename?: 'Mutation', sendDeviceEnrollmentTokenEmail: { __typename?: 'DeviceEnrollmentEmailDelivery', id: any, recipientEmail: string, queuedAt: any, sentAt?: any | null, failedAt?: any | null, status: DeviceEnrollmentEmailDeliveryStatus, sentBy?: { __typename?: 'DeviceEnrollmentActor', id: any, name?: string | null } | null } };

export type StartSalesforceSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type StartSalesforceSyncMutation = { __typename?: 'Mutation', startSalesforceSync: boolean };

export type StartFullSalesforceSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type StartFullSalesforceSyncMutation = { __typename?: 'Mutation', startFullSalesforceSync: boolean };

export type CheckSalesforceConnectionMutationVariables = Exact<{
  input: SalesforceConnectionInput;
}>;


export type CheckSalesforceConnectionMutation = { __typename?: 'Mutation', checkSalesforceConnection: { __typename?: 'SalesforceConnectionCheck', ok: boolean, errorCode?: string | null, dailyApiRequestsMax?: number | null, dailyApiRequestsRemaining?: number | null } };

export type UpdateSalesforceIntegrationMutationVariables = Exact<{
  input: SalesforceIntegrationInput;
}>;


export type UpdateSalesforceIntegrationMutation = { __typename?: 'Mutation', updateSalesforceIntegration: { __typename?: 'SalesforceIntegration', loginUrl?: string | null, clientId?: string | null, hasClientSecret: boolean, anonymize: boolean, anonymizationRequired: boolean, schedule: SalesforceSyncSchedule, dailyTime?: string | null, intervalHours?: number | null, windowStart?: string | null, windowEnd?: string | null, windowIntervalMinutes?: number | null, outsideIntervalHours?: number | null, updatedAt?: any | null, nextRunAt?: any | null } };

export type UpdateMarketingDeliverySettingsMutationVariables = Exact<{
  input: MarketingDeliverySettingsInput;
}>;


export type UpdateMarketingDeliverySettingsMutation = { __typename?: 'Mutation', updateMarketingDeliverySettings: { __typename?: 'MarketingDeliverySettings', provider?: MarketingDeliveryProviderType | null, hasApiKey: boolean, hasApiSecret: boolean, hasWebhookSecret: boolean, sendingDomain?: string | null, fromAddress?: string | null, fromName?: string | null, replyToAddress?: string | null, updatedAt?: any | null, recipientsRestricted: boolean, allowedRecipients: Array<string>, availableProviders: Array<{ __typename?: 'MarketingDeliveryProviderOption', type: MarketingDeliveryProviderType, name: string }> } };

export type SendMarketingTestEmailMutationVariables = Exact<{
  input: MarketingTestEmailInput;
}>;


export type SendMarketingTestEmailMutation = { __typename?: 'Mutation', sendMarketingTestEmail: { __typename?: 'MarketingTestEmailResult', ok: boolean, providerMessageId?: string | null, errorCode?: string | null } };

export type AddStaffRoleMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  role: StaffRole;
}>;


export type AddStaffRoleMutation = { __typename?: 'Mutation', addStaffRole: boolean };

export type RemoveStaffRoleMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  role: StaffRole;
}>;


export type RemoveStaffRoleMutation = { __typename?: 'Mutation', removeStaffRole: boolean };

export type InviteStaffMutationVariables = Exact<{
  email: Scalars['String']['input'];
  roles: Array<StaffRole> | StaffRole;
}>;


export type InviteStaffMutation = { __typename?: 'Mutation', inviteStaff: boolean };

export type CancelStaffInvitationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CancelStaffInvitationMutation = { __typename?: 'Mutation', cancelStaffInvitation: boolean };

export type DismissFinanceNotificationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}>;


export type DismissFinanceNotificationMutation = { __typename?: 'Mutation', dismissFinanceNotification: { __typename?: 'FinanceNotificationDismissal', id: any, dismissedAt: any } };

export type ReviewCustomerServiceCrmDuplicateMutationVariables = Exact<{
  input: CrmDuplicateReviewInput;
}>;


export type ReviewCustomerServiceCrmDuplicateMutation = { __typename?: 'Mutation', reviewCustomerServiceCrmDuplicate: { __typename?: 'CrmDuplicateCandidate', id: string, fingerprint: string, score: number, status: CrmDuplicateStatus, reviewedAt?: any | null, reasons: Array<{ __typename?: 'CrmDuplicateReason', code: string, similarity?: number | null }>, left: { __typename?: 'CrmDuplicateRecord', object: CrmObject, salesforceId: string, kind: string, name: string, createdAt?: any | null, createdByName?: string | null, company?: string | null, email?: string | null, phone?: string | null, addresses: Array<{ __typename?: 'CrmDuplicateAddress', street?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }>, normalized: { __typename?: 'CrmDuplicateNormalizedRecord', name?: string | null, company?: string | null, email?: string | null, phone?: { __typename?: 'CrmDuplicatePhone', base: string, extension?: string | null } | null, addresses: Array<{ __typename?: 'CrmDuplicateNormalizedAddress', street?: string | null, house?: string | null, unit?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }> } }, right: { __typename?: 'CrmDuplicateRecord', object: CrmObject, salesforceId: string, kind: string, name: string, createdAt?: any | null, createdByName?: string | null, company?: string | null, email?: string | null, phone?: string | null, addresses: Array<{ __typename?: 'CrmDuplicateAddress', street?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }>, normalized: { __typename?: 'CrmDuplicateNormalizedRecord', name?: string | null, company?: string | null, email?: string | null, phone?: { __typename?: 'CrmDuplicatePhone', base: string, extension?: string | null } | null, addresses: Array<{ __typename?: 'CrmDuplicateNormalizedAddress', street?: string | null, house?: string | null, unit?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }> } } } };

export type CreateAccountBillingInvoiceDownloadMutationVariables = Exact<{
  salesforceId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
}>;


export type CreateAccountBillingInvoiceDownloadMutation = { __typename?: 'Mutation', createAccountBillingInvoiceDownload: { __typename?: 'BillingInvoiceDownload', url: string, expiresAt: any } };

export type UpdateLogisticsDhlShippingSettingsMutationVariables = Exact<{
  input: UpdateLogisticsDhlShippingSettingsInput;
}>;


export type UpdateLogisticsDhlShippingSettingsMutation = { __typename?: 'Mutation', updateLogisticsDhlShippingSettings: { __typename?: 'LogisticsDhlShippingSettings', labelPrintFormat: string, returnLabelPrintFormat: string, labelPrintFormats: Array<string>, returnLabelPrintFormats: Array<string>, missingSettings: Array<LogisticsDhlSetting>, updatedAt?: any | null, shipper?: { __typename?: 'LogisticsDhlAddress', name: string, street: string, postalCode: string, city: string } | null, returnAddress?: { __typename?: 'LogisticsDhlAddress', name: string, street: string, postalCode: string, city: string } | null } };

export type UpdateLogisticsDhlAccountSettingsMutationVariables = Exact<{
  input: UpdateLogisticsDhlAccountSettingsInput;
}>;


export type UpdateLogisticsDhlAccountSettingsMutation = { __typename?: 'Mutation', updateLogisticsDhlAccountSettings: { __typename?: 'LogisticsDhlAccountSettings', gateway: LogisticsDhlGateway, clientId?: string | null, hasClientSecret: boolean, username?: string | null, hasPassword: boolean, billingNumberPaket?: string | null, billingNumberPaketInternational?: string | null, billingNumberRetoure?: string | null, returnReceiverIdAustria?: string | null, missingSettings: Array<LogisticsDhlSetting>, updatedAt?: any | null } };

export type CheckLogisticsDhlConnectionMutationVariables = Exact<{ [key: string]: never; }>;


export type CheckLogisticsDhlConnectionMutation = { __typename?: 'Mutation', checkLogisticsDhlConnection: { __typename?: 'LogisticsDhlConnectionCheck', ok: boolean, failure?: LogisticsDhlConnectionFailure | null, missingSettings: Array<LogisticsDhlSetting>, gateway: LogisticsDhlGateway, storedReturnReceiverFound: boolean, austrianReturnReceivers: Array<{ __typename?: 'LogisticsDhlReturnReceiver', receiverId: string, shipperCountry?: string | null, billingNumber?: string | null, name?: string | null, street?: string | null, houseNumber?: string | null, postalCode?: string | null, city?: string | null }> } };

export type CreateLogisticsShippingLabelMutationVariables = Exact<{
  input: CreateLogisticsShippingLabelInput;
}>;


export type CreateLogisticsShippingLabelMutation = { __typename?: 'Mutation', createLogisticsShippingLabel: { __typename?: 'LogisticsShippingLabelResult', outcome: LogisticsShippingLabelOutcome, refusal?: LogisticsShippingLabelRefusal | null, missingAddressFields: Array<LogisticsShippingAddressField>, failure?: LogisticsShippingLabelFailure | null, messages: Array<{ __typename?: 'LogisticsDhlMessage', property?: string | null, message: string, state?: string | null }>, label?: { __typename?: 'LogisticsShippingLabel', id: any, orderId: any, product: string, shipmentNumber: string, returnShipmentNumber?: string | null, printFormat: string, returnPrintFormat?: string | null, weightKg: number, createdAt: any, cancelledAt?: any | null, labelPdf: string, returnLabelPdf?: string | null } | null, pilot?: { __typename?: 'LogisticsShippingLabelPilotResult', requestId?: any | null, outcome: LogisticsShippingLabelPilotOutcome, refusal?: string | null, messages: Array<string>, salesforceCommandId?: any | null } | null } };

export type CancelLogisticsShippingLabelMutationVariables = Exact<{
  input: CancelLogisticsShippingLabelInput;
}>;


export type CancelLogisticsShippingLabelMutation = { __typename?: 'Mutation', cancelLogisticsShippingLabel: { __typename?: 'LogisticsShippingLabelResult', outcome: LogisticsShippingLabelOutcome, refusal?: LogisticsShippingLabelRefusal | null, missingAddressFields: Array<LogisticsShippingAddressField>, failure?: LogisticsShippingLabelFailure | null, messages: Array<{ __typename?: 'LogisticsDhlMessage', property?: string | null, message: string, state?: string | null }>, label?: { __typename?: 'LogisticsShippingLabel', id: any, orderId: any, product: string, shipmentNumber: string, returnShipmentNumber?: string | null, printFormat: string, returnPrintFormat?: string | null, weightKg: number, createdAt: any, cancelledAt?: any | null, labelPdf: string, returnLabelPdf?: string | null } | null, pilot?: { __typename?: 'LogisticsShippingLabelPilotResult', requestId?: any | null, outcome: LogisticsShippingLabelPilotOutcome, refusal?: string | null, messages: Array<string>, salesforceCommandId?: any | null } | null } };

export type OrganizationContractsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type OrganizationContractsQuery = { __typename?: 'Query', organizationContracts: { __typename?: 'OrganizationContracts', availability: BillingAvailability, organizationName?: string | null, nextCursor?: string | null, items: Array<{ __typename?: 'OrganizationContractItem', id: string, name: string, startDate: any, endDate?: any | null, status: string, product: string, productName?: string | null, flavour?: string | null, plan?: string | null, sponsoringOrganization?: string | null }> } };

export type OrganizationBillingQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type OrganizationBillingQuery = { __typename?: 'Query', organizationBilling: { __typename?: 'OrganizationBilling', availability: BillingAvailability, organizationName?: string | null, nextCursor?: string | null, invoices: Array<{ __typename?: 'BillingInvoice', id: string, number?: string | null, documentDate: any, totalGross: string, currency: string }> } };

export type CustomerServiceOrganizationBillingAccessQueryVariables = Exact<{
  organizationIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CustomerServiceOrganizationBillingAccessQuery = { __typename?: 'Query', customerServiceOrganizationBillingAccess: Array<{ __typename?: 'OrganizationBillingAccess', organizationId: any, accessEnabled: boolean, mappingConfigured: boolean, invoiceAccountConfigured: boolean, salesforceAccountId?: string | null, salesforceAccountName?: string | null, frisbiiCustomerId?: string | null, mappingVersion?: any | null }> };

export type CustomerServiceBillingSalesforceAccountsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type CustomerServiceBillingSalesforceAccountsQuery = { __typename?: 'Query', customerServiceBillingSalesforceAccounts: Array<{ __typename?: 'BillingSalesforceAccount', id: string, name: string }> };

export type CustomerServiceBillingCustomerQueryVariables = Exact<{
  salesforceAccountId: Scalars['String']['input'];
  frisbiiCustomerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerServiceBillingCustomerQuery = { __typename?: 'Query', customerServiceBillingCustomer?: { __typename?: 'BillingCustomer', id: string, externalCustomerId?: string | null, displayName?: string | null, debtorAccount?: string | null } | null };

export type CustomerServiceSalesforceDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerServiceSalesforceDashboardQuery = { __typename?: 'Query', customerServiceSalesforceDashboard: { __typename?: 'SalesforceDashboard', lastSyncedAt?: any | null, contractCount: number, subscriptionCount: number, unclassifiedSubscriptions: number, currency: string, activeB2BProducts: Array<{ __typename?: 'SalesforceLabelCount', label?: string | null, count: number }>, activeB2CProducts: Array<{ __typename?: 'SalesforceLabelCount', label?: string | null, count: number }>, activeLicenceProducts: Array<{ __typename?: 'SalesforceLabelCount', label?: string | null, count: number }>, contractSegments: Array<{ __typename?: 'SalesforceContractSegment', recordType: SalesforceSegment, eligibleContracts: number, missingMrrContracts: number, missingSubscriptionCountContracts: number, totalMrr?: any | null, averageMrr?: any | null, averageActiveSubscriptionItems?: any | null }>, history: { __typename?: 'SalesforceSubscriptionHistory', missingCreatedDates: number, missingCancellationDates: number, missingEndDates: number, createdDaily: Array<{ __typename?: 'SalesforcePeriodCount', periodStart: any, segment: SalesforceSegment, category?: string | null, count: number }>, createdWeekly: Array<{ __typename?: 'SalesforcePeriodCount', periodStart: any, segment: SalesforceSegment, category?: string | null, count: number }>, createdMonthly: Array<{ __typename?: 'SalesforcePeriodCount', periodStart: any, segment: SalesforceSegment, category?: string | null, count: number }>, cancelledMonthly: Array<{ __typename?: 'SalesforcePeriodCount', periodStart: any, segment: SalesforceSegment, category?: string | null, count: number }>, endedMonthly: Array<{ __typename?: 'SalesforcePeriodCount', periodStart: any, segment: SalesforceSegment, category?: string | null, count: number }> } } };

export type SalesforceReportDashboardQueryVariables = Exact<{
  dashboard: SalesforceReportDashboard;
}>;


export type SalesforceReportDashboardQuery = { __typename?: 'Query', salesforceReportDashboard: { __typename?: 'SalesforceReportDashboardData', dashboard: SalesforceReportDashboard, salesforceId: string, lastSyncedAt?: any | null, components: Array<{ __typename?: 'SalesforceReportComponent', key: SalesforceReportComponentKey, reportId: string, chart?: SalesforceReportChart | null, unavailable?: SalesforceReportUnavailable | null, sortByValue: boolean, showPercentages: boolean, source?: SalesforceReportSource | null, unreadableFields: Array<string>, missingFields: Array<string>, pendingObjects: Array<string>, blockKey?: string | null, showValues?: boolean | null, sortLegendValues?: boolean | null, layout: { __typename?: 'SalesforceReportLayout', column: number, row: number, width: number, height: number }, groupings: Array<{ __typename?: 'SalesforceReportGrouping', field: string, granularity?: SalesforceReportGranularity | null }>, measures: Array<{ __typename?: 'SalesforceReportMeasure', aggregate: SalesforceReportAggregate, field?: string | null }>, points: Array<{ __typename?: 'SalesforceReportPoint', group?: string | null, series?: string | null, values: Array<number | null> }>, table?: { __typename?: 'SalesforceReportSection', reportId: string, type: SalesforceReportType, format: SalesforceReportFormat, source: SalesforceReportSource, filterLogic?: string | null, showSubtotals: boolean, showGrandTotal: boolean, hasMoreRows: boolean, rowLimit: number, chart?: SalesforceReportChart | null, lastSyncedAt?: any | null, unreadableFields: Array<string>, blockKey?: string | null, unavailable?: SalesforceReportUnavailable | null, missingFields: Array<string>, pendingObjects: Array<string>, chartUnavailable?: SalesforceReportUnavailable | null, chartMissingFields: Array<string>, chartPendingObjects: Array<string>, showValues?: boolean | null, sortLegendValues?: boolean | null, dateRange?: { __typename?: 'SalesforceReportDateRange', field: string, relative?: SalesforceReportRelativeRange | null, lastDays?: number | null, from?: string | null, to?: string | null } | null, filters: Array<{ __typename?: 'SalesforceReportFilter', field: string, operator: SalesforceReportFilterOperator, values: Array<string> }>, linkedFilters: Array<{ __typename?: 'SalesforceReportFilter', field: string, operator: SalesforceReportFilterOperator, values: Array<string> }>, down: Array<{ __typename?: 'SalesforceReportTableGrouping', field: string, granularity?: SalesforceReportGranularity | null, descending: boolean, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, across: Array<{ __typename?: 'SalesforceReportTableGrouping', field: string, granularity?: SalesforceReportGranularity | null, descending: boolean, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, summaries: Array<{ __typename?: 'SalesforceReportSummary', aggregate: SalesforceReportAggregate, field?: string | null, formula?: string | null }>, columns: Array<{ __typename?: 'SalesforceReportColumn', field: string, type: SalesforceReportFieldType, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, groups: Array<{ __typename?: 'SalesforceReportGroup', count: number, values: Array<number | null>, down: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }>, across: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }> }>, rows: Array<{ __typename?: 'SalesforceReportRow', values: Array<string | null>, links: Array<string | null>, down: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }> }>, chartGroupings: Array<{ __typename?: 'SalesforceReportGrouping', field: string, granularity?: SalesforceReportGranularity | null }>, chartMeasures: Array<{ __typename?: 'SalesforceReportMeasure', aggregate: SalesforceReportAggregate, field?: string | null }>, chartPoints: Array<{ __typename?: 'SalesforceReportPoint', group?: string | null, series?: string | null, values: Array<number | null> }> } | null }> } };

export type SalesforceReportQueryVariables = Exact<{
  reportId: Scalars['String']['input'];
  component?: InputMaybe<SalesforceReportComponentKey>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  columnFilters?: InputMaybe<Array<SalesforceReportColumnFilterInput> | SalesforceReportColumnFilterInput>;
}>;


export type SalesforceReportQuery = { __typename?: 'Query', salesforceReport: { __typename?: 'SalesforceReportData', reportId: string, type: SalesforceReportType, format: SalesforceReportFormat, source: SalesforceReportSource, filterLogic?: string | null, showSubtotals: boolean, showGrandTotal: boolean, hasMoreRows: boolean, rowLimit: number, chart?: SalesforceReportChart | null, lastSyncedAt?: any | null, unreadableFields: Array<string>, blockKey?: string | null, unavailable?: SalesforceReportUnavailable | null, missingFields: Array<string>, pendingObjects: Array<string>, chartUnavailable?: SalesforceReportUnavailable | null, chartMissingFields: Array<string>, chartPendingObjects: Array<string>, showValues?: boolean | null, sortLegendValues?: boolean | null, selectedBlock?: string | null, dateRange?: { __typename?: 'SalesforceReportDateRange', field: string, relative?: SalesforceReportRelativeRange | null, lastDays?: number | null, from?: string | null, to?: string | null } | null, filters: Array<{ __typename?: 'SalesforceReportFilter', field: string, operator: SalesforceReportFilterOperator, values: Array<string> }>, linkedFilters: Array<{ __typename?: 'SalesforceReportFilter', field: string, operator: SalesforceReportFilterOperator, values: Array<string> }>, down: Array<{ __typename?: 'SalesforceReportTableGrouping', field: string, granularity?: SalesforceReportGranularity | null, descending: boolean, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, across: Array<{ __typename?: 'SalesforceReportTableGrouping', field: string, granularity?: SalesforceReportGranularity | null, descending: boolean, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, summaries: Array<{ __typename?: 'SalesforceReportSummary', aggregate: SalesforceReportAggregate, field?: string | null, formula?: string | null }>, columns: Array<{ __typename?: 'SalesforceReportColumn', field: string, type: SalesforceReportFieldType, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, groups: Array<{ __typename?: 'SalesforceReportGroup', count: number, values: Array<number | null>, down: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }>, across: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }> }>, rows: Array<{ __typename?: 'SalesforceReportRow', values: Array<string | null>, links: Array<string | null>, down: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }> }>, chartGroupings: Array<{ __typename?: 'SalesforceReportGrouping', field: string, granularity?: SalesforceReportGranularity | null }>, chartMeasures: Array<{ __typename?: 'SalesforceReportMeasure', aggregate: SalesforceReportAggregate, field?: string | null }>, chartPoints: Array<{ __typename?: 'SalesforceReportPoint', group?: string | null, series?: string | null, values: Array<number | null> }>, blocks?: Array<{ __typename?: 'SalesforceReportSection', reportId: string, type: SalesforceReportType, format: SalesforceReportFormat, source: SalesforceReportSource, filterLogic?: string | null, showSubtotals: boolean, showGrandTotal: boolean, hasMoreRows: boolean, rowLimit: number, chart?: SalesforceReportChart | null, lastSyncedAt?: any | null, unreadableFields: Array<string>, blockKey?: string | null, unavailable?: SalesforceReportUnavailable | null, missingFields: Array<string>, pendingObjects: Array<string>, chartUnavailable?: SalesforceReportUnavailable | null, chartMissingFields: Array<string>, chartPendingObjects: Array<string>, showValues?: boolean | null, sortLegendValues?: boolean | null, dateRange?: { __typename?: 'SalesforceReportDateRange', field: string, relative?: SalesforceReportRelativeRange | null, lastDays?: number | null, from?: string | null, to?: string | null } | null, filters: Array<{ __typename?: 'SalesforceReportFilter', field: string, operator: SalesforceReportFilterOperator, values: Array<string> }>, linkedFilters: Array<{ __typename?: 'SalesforceReportFilter', field: string, operator: SalesforceReportFilterOperator, values: Array<string> }>, down: Array<{ __typename?: 'SalesforceReportTableGrouping', field: string, granularity?: SalesforceReportGranularity | null, descending: boolean, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, across: Array<{ __typename?: 'SalesforceReportTableGrouping', field: string, granularity?: SalesforceReportGranularity | null, descending: boolean, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, summaries: Array<{ __typename?: 'SalesforceReportSummary', aggregate: SalesforceReportAggregate, field?: string | null, formula?: string | null }>, columns: Array<{ __typename?: 'SalesforceReportColumn', field: string, type: SalesforceReportFieldType, link?: { __typename?: 'SalesforceReportColumnLink', kind: SalesforceReportLinkKind, object?: CrmObject | null } | null }>, groups: Array<{ __typename?: 'SalesforceReportGroup', count: number, values: Array<number | null>, down: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }>, across: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }> }>, rows: Array<{ __typename?: 'SalesforceReportRow', values: Array<string | null>, links: Array<string | null>, down: Array<{ __typename?: 'SalesforceReportGroupValue', value?: string | null, label?: string | null }> }>, chartGroupings: Array<{ __typename?: 'SalesforceReportGrouping', field: string, granularity?: SalesforceReportGranularity | null }>, chartMeasures: Array<{ __typename?: 'SalesforceReportMeasure', aggregate: SalesforceReportAggregate, field?: string | null }>, chartPoints: Array<{ __typename?: 'SalesforceReportPoint', group?: string | null, series?: string | null, values: Array<number | null> }> }> | null } };

export type CustomerServiceSalesforceRecordsQueryVariables = Exact<{
  input: SalesforceRecordsInput;
}>;


export type CustomerServiceSalesforceRecordsQuery = { __typename?: 'Query', customerServiceSalesforceRecords: { __typename?: 'SalesforceSubscriptionRecordList', totalCount: number, records: Array<{ __typename?: 'SalesforceSubscriptionRecord', salesforceId: string, name?: string | null, recordType?: string | null, status?: string | null, productName?: string | null, productFamily?: string | null, segment?: string | null, sponsoringKrankenkasse?: string | null, createdAt?: any | null, startDate?: any | null, endDate?: any | null, cancellationDate?: any | null, cancellationType?: string | null, contractSalesforceId?: string | null, contractStatus?: string | null, contractNumber?: string | null, contractName?: string | null, contractRecordType?: string | null, trialPeriodDays?: number | null, billingStartDate?: any | null, price?: any | null, assetType?: string | null, changedFromSalesforceId?: string | null, changedFromName?: string | null, changedIntoSalesforceId?: string | null, changedIntoName?: string | null, inTrial?: boolean | null, lostReason?: string | null, billingStarted?: boolean | null, productSalesforceId?: string | null }> } };

export type CustomerServiceSalesforceContractsQueryVariables = Exact<{
  segment: SalesforceSegment;
}>;


export type CustomerServiceSalesforceContractsQuery = { __typename?: 'Query', customerServiceSalesforceContracts: { __typename?: 'SalesforceContractRecordList', totalCount: number, records: Array<{ __typename?: 'SalesforceContractRecord', salesforceId: string, status?: string | null, recordType?: string | null, startDate?: any | null, endDate?: any | null, mrr?: any | null, activeSubscriptionItems?: any | null }> } };

export type LearningViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type LearningViewerQuery = { __typename?: 'Query', learningViewer: { __typename?: 'LearningViewer', id: any, firstName?: string | null, lastName?: string | null, organizationId: any } };

export type CustomerServiceOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerServiceOrganizationsQuery = { __typename?: 'Query', customerServiceLearningOrganizations: Array<{ __typename?: 'LearningOrganization', id: any, name?: string | null }> };

export type CustomerServiceOrganizationLearningQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
}>;


export type CustomerServiceOrganizationLearningQuery = { __typename?: 'Query', customerServiceLearningCatalog: { __typename?: 'LearningCatalog', courses: Array<{ __typename?: 'LearningCourseMetadata', id: any, version: string, locale: string, title: string, description: string, thumbnailFilename: string, lessonCount: number, estimatedDurationMinutes: number, tags: Array<string> }>, learningPaths: Array<{ __typename?: 'LearningPathMetadata', id: any, version: string, locale: string, title: string, description: string, thumbnailFilename: string, enforceOrder: boolean, courses: Array<{ __typename?: 'LearningPathCourseMetadata', courseId: any, position: number }> }> }, organizationLearningGrants: { __typename?: 'OrganizationLearningGrants', organizationId: any, grants: Array<{ __typename?: 'LearningGrant', id?: any | null, itemKind: LearningItemKind, courseId?: any | null, learningPathId?: any | null, active: boolean }> } };

export type ManagerLearningCatalogAndCaregiversQueryVariables = Exact<{ [key: string]: never; }>;


export type ManagerLearningCatalogAndCaregiversQuery = { __typename?: 'Query', managerLearningCatalog: { __typename?: 'LearningCatalog', courses: Array<{ __typename?: 'LearningCourseMetadata', id: any, version: string, locale: string, title: string, description: string, thumbnailFilename: string, lessonCount: number, estimatedDurationMinutes: number, passingScorePercent: number, tags: Array<string> }>, learningPaths: Array<{ __typename?: 'LearningPathMetadata', id: any, version: string, locale: string, title: string, description: string, thumbnailFilename: string, enforceOrder: boolean, courses: Array<{ __typename?: 'LearningPathCourseMetadata', courseId: any, position: number }> }>, courseAccess: Array<{ __typename?: 'LearningCourseAccess', courseId: any, directAccess: boolean, pathAccess: boolean }> }, managerLearningCaregivers: Array<{ __typename?: 'LearningCaregiver', userId: any, organizationId: any, firstName?: string | null, lastName?: string | null, displayName: string }> };

export type ManagerLearningAssignmentsQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type ManagerLearningAssignmentsQuery = { __typename?: 'Query', managerLearningAssignments: Array<{ __typename?: 'LearningAssignment', id?: any | null, organizationId: any, userId: any, itemKind: LearningItemKind, courseId?: any | null, learningPathId?: any | null, learningPathVersion?: string | null, kind: LearningAssignmentKind, assignedBy?: any | null, assignedAt?: any | null, unassignedBy?: any | null, unassignedAt?: any | null, active: boolean, enrollmentIds: Array<any> }> };

export type ManagerLearningProgressQueryVariables = Exact<{
  filter: LearningProgressFilter;
  assignmentUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type ManagerLearningProgressQuery = { __typename?: 'Query', managerLearningCatalog: { __typename?: 'LearningCatalog', courses: Array<{ __typename?: 'LearningCourseMetadata', id: any, title: string }>, learningPaths: Array<{ __typename?: 'LearningPathMetadata', id: any, version: string, title: string, courses: Array<{ __typename?: 'LearningPathCourseMetadata', courseId: any, position: number }> }> }, managerLearningCaregivers: Array<{ __typename?: 'LearningCaregiver', userId: any, organizationId: any, displayName: string, locationNames: Array<string> }>, managerLearningAssignments: Array<{ __typename?: 'LearningAssignment', id?: any | null, userId: any, itemKind: LearningItemKind, learningPathId?: any | null, learningPathVersion?: string | null, active: boolean, enrollmentIds: Array<any> }>, learningProgressReport: { __typename?: 'LearningProgressReport', entries: Array<{ __typename?: 'LearningCourseProgress', enrollmentId: any, organizationId: any, userId: any, courseId: any, status: LearningEnrollmentStatus, firstStartedAt?: any | null, completedAt?: any | null, bestScorePercent?: number | null, quizAttempts: Array<{ __typename?: 'LearningQuizAttempt', id: any, courseVersion: string, serverScorePercent: number, serverPassed: boolean, finishedAt: any }> }> } };

export type MyLearningCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLearningCatalogQuery = { __typename?: 'Query', myLearningCatalog: { __typename?: 'LearningCatalog', selfEnrollCourseIds: Array<any>, selfEnrollPathIds: Array<any>, courses: Array<{ __typename?: 'LearningCourseMetadata', id: any, version: string, locale: string, title: string, description: string, thumbnailFilename: string, estimatedDurationMinutes: number, passingScorePercent: number, tags: Array<string> }>, learningPaths: Array<{ __typename?: 'LearningPathMetadata', id: any, version: string, locale: string, title: string, description: string, thumbnailFilename: string, enforceOrder: boolean, courses: Array<{ __typename?: 'LearningPathCourseMetadata', courseId: any, position: number }> }>, courseAccess: Array<{ __typename?: 'LearningCourseAccess', courseId: any, currentVersion: string, directAccess: boolean, selfAccess: boolean, pathAccess: boolean, locked: boolean }> } };

export type LearningCoursePayloadQueryVariables = Exact<{
  courseId: Scalars['UUID']['input'];
  version: Scalars['String']['input'];
}>;


export type LearningCoursePayloadQuery = { __typename?: 'Query', learningCoursePayload: { __typename?: 'LearningCoursePayload', courseId: any, version: string, payload: string } };

export type MyLearningQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLearningQuery = { __typename?: 'Query', myLearning: { __typename?: 'MyLearning', courses: Array<{ __typename?: 'MyLearningCourseState', courseId: any, currentVersion: string, startedVersions: Array<string>, status: LearningEnrollmentStatus, completedLessonIds: Array<any>, bestScorePercent?: number | null, directAccess: boolean }>, pathSources: Array<{ __typename?: 'MyLearningPathSource', assignmentId: any, pathId: any, pathVersion: string, orderedCourses: Array<{ __typename?: 'MyLearningPathCourse', courseId: any, available: boolean, locked: boolean }> }> } };

export type OrganizationsQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationsQueryQuery = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Organization', id: any, name?: string | null, externalId?: string | null, postalCode?: string | null, patients: { __typename?: 'PatientsConnection', totalCount: number }, practitioners: { __typename?: 'PractitionersConnection', totalCount: number, nodes: Array<{ __typename?: 'Practitioner', id: any, role: string }> }, organizationManagers: { __typename?: 'OrganizationManagersConnection', nodes: Array<{ __typename?: 'OrganizationManager', user?: { __typename?: 'User', email?: string | null, name: string } | null }> } }> } | null };

export type OrganizationQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OrganizationQueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: any, name?: string | null, externalId?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, additionalInfo?: string | null, locations: { __typename?: 'LocationsConnection', nodes: Array<{ __typename?: 'Location', id: any, name: string, externalId: string, type: LocationTypeEnum, status?: string | null, patients: { __typename?: 'PatientsConnection', totalCount: number }, locationPractitioners: { __typename?: 'LocationPractitionersConnection', totalCount: number }, devices: { __typename?: 'DevicesConnection', totalCount: number } }> }, patients: { __typename?: 'PatientsConnection', totalCount: number, nodes: Array<{ __typename?: 'Patient', user?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null }> }, practitioners: { __typename?: 'PractitionersConnection', totalCount: number, nodes: Array<{ __typename?: 'Practitioner', id: any, user?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null }> } } | null };

export type LocationsQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<LocationCondition>;
}>;


export type LocationsQueryQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Location', id: any, name: string, externalId: string, sourceSystem: DataSource, type: LocationTypeEnum, status?: string | null, partOfId?: any | null, mode: LocationModeEnum, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, patients: { __typename?: 'PatientsConnection', totalCount: number }, locationPractitioners: { __typename?: 'LocationPractitionersConnection', totalCount: number }, devices: { __typename?: 'DevicesConnection', totalCount: number } }> } | null };

export type LocationSummaryListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<LocationSummaryCondition>;
}>;


export type LocationSummaryListQuery = { __typename?: 'Query', locationSummaries?: { __typename?: 'LocationSummariesConnection', totalCount: number, nodes: Array<{ __typename?: 'LocationSummary', id: any, organizationId?: any | null, partOfId?: any | null, name?: string | null, type?: LocationTypeEnum | null, immediateChildCount?: number | null, patientCount?: number | null, practitionerCount?: number | null, deviceCount?: number | null }> } | null };

export type LocationOptionsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<LocationCondition>;
}>;


export type LocationOptionsListQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Location', id: any, name: string, type: LocationTypeEnum, partOfId?: any | null, organizationId: any }> } | null };

export type LocationQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LocationQueryQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: any, name: string, externalId: string, sourceSystem: DataSource, type: LocationTypeEnum, status?: string | null, partOfId?: any | null, mode: LocationModeEnum, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, patients: { __typename?: 'PatientsConnection', nodes: Array<{ __typename?: 'Patient', id: any, patientNumber?: string | null, gender?: GenderEnum | null, birthDate?: any | null, user?: { __typename?: 'User', id: any, name: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null }> }, locationPractitioners: { __typename?: 'LocationPractitionersConnection', nodes: Array<{ __typename?: 'LocationPractitioner', practitioner?: { __typename?: 'Practitioner', id: any, status: PractitionerStatusEnum, employeeNumber?: string | null, emailAddress?: string | null, user?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null } | null }> }, devices: { __typename?: 'DevicesConnection', nodes: Array<{ __typename?: 'Device', id: any, deviceId: string, status: string, manufacturer?: string | null, model?: string | null, osVersion?: string | null, appVersion?: string | null, contentVersion?: string | null, name?: string | null }> } } | null };

export type PatientsQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<PatientCondition>;
}>;


export type PatientsQueryQuery = { __typename?: 'Query', patients?: { __typename?: 'PatientsConnection', totalCount: number, nodes: Array<{ __typename?: 'Patient', id: any, sourceSystem: DataSource, gender?: GenderEnum | null, birthDate?: any | null, patientNumber?: string | null, location?: { __typename?: 'Location', id: any, type: LocationTypeEnum } | null, user?: { __typename?: 'User', id: any, name: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, locationHierarchy: { __typename?: 'PatientLocationHierarchyConnection', nodes: Array<{ __typename?: 'PatientLocationHierarchyRecord', level?: number | null, locationId?: any | null, locationName?: string | null, locationType?: LocationTypeEnum | null, externalId?: string | null }> } }> } | null };

export type DashboardPatientCountQueryVariables = Exact<{
  targetOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
  selectedLocationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type DashboardPatientCountQuery = { __typename?: 'Query', dashboardPatients?: { __typename?: 'PatientsConnection', totalCount: number } | null };

export type DashboardPatientListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  targetOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
  selectedLocationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type DashboardPatientListQuery = { __typename?: 'Query', dashboardPatients?: { __typename?: 'PatientsConnection', totalCount: number, nodes: Array<{ __typename?: 'Patient', id: any, sourceSystem: DataSource, gender?: GenderEnum | null, birthDate?: any | null, patientNumber?: string | null, location?: { __typename?: 'Location', id: any, type: LocationTypeEnum } | null, user?: { __typename?: 'User', id: any, name: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, locationHierarchy: { __typename?: 'PatientLocationHierarchyConnection', nodes: Array<{ __typename?: 'PatientLocationHierarchyRecord', level?: number | null, locationId?: any | null, locationName?: string | null, locationType?: LocationTypeEnum | null, externalId?: string | null }> } }> } | null };

export type PatientQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PatientQueryQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', id: any, sourceSystem: DataSource, externalId: string, gender?: GenderEnum | null, birthDate?: any | null, patientNumber?: string | null, location?: { __typename?: 'Location', id: any, type: LocationTypeEnum } | null, user?: { __typename?: 'User', id: any, name: string, firstName?: string | null, lastName?: string | null, email?: string | null, avatarUrl?: string | null, avatar?: any | null, salutation?: string | null } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, locationHierarchy: { __typename?: 'PatientLocationHierarchyConnection', nodes: Array<{ __typename?: 'PatientLocationHierarchyRecord', level?: number | null, locationId?: any | null, locationName?: string | null, locationType?: LocationTypeEnum | null, externalId?: string | null }> } } | null };

export type ActivityGoalsListQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type ActivityGoalsListQuery = { __typename?: 'Query', activityGoalsList?: Array<{ __typename?: 'ActivityGoal', id: any, userId: any, kind: ActivityGoalEnum, weeklyGoal?: number | null }> | null };

export type ActivityGoalProgressQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type ActivityGoalProgressQuery = { __typename?: 'Query', activityGoalProgress: Array<{ __typename?: 'ActivityGoalProgress', kind: ActivityGoalEnum, weeklyGoalMinutes: number, doneMinutes: number }> };

export type ActivityRecommendationsQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
  kind: ActivityGoalEnum;
  limit?: InputMaybe<Scalars['Int']['input']>;
  targetDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  excludeContentIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type ActivityRecommendationsQuery = { __typename?: 'Query', activityRecommendations: Array<{ __typename?: 'ActivityRecommendation', cmsContentId: number, cmsContentKind: string, contentUuid: any, title: string, durationMinutes: number, kind: ActivityGoalEnum, thumbnailFilename?: string | null, isPlanned: boolean }> };

export type PatientProceduresQueryVariables = Exact<{
  patientId: Scalars['UUID']['input'];
}>;


export type PatientProceduresQuery = { __typename?: 'Query', procedureParticipants?: { __typename?: 'ProcedureParticipantsConnection', nodes: Array<{ __typename?: 'ProcedureParticipant', procedure?: { __typename?: 'Procedure', id: any, codeDisplay?: string | null, plannedStart?: any | null, status: ProcedureStatusEnum } | null }> } | null };

export type PractitionersQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<PractitionerCondition>;
}>;


export type PractitionersQueryQuery = { __typename?: 'Query', practitioners?: { __typename?: 'PractitionersConnection', totalCount: number, nodes: Array<{ __typename?: 'Practitioner', id: any, sourceSystem: DataSource, status: PractitionerStatusEnum, birthDate?: any | null, emailAddress?: string | null, employeeNumber?: string | null, gender: GenderEnum, user?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, authStatus?: AuthStatus | null } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, practitioners: { __typename?: 'PractitionerPractitionersManyToManyConnection', nodes: Array<{ __typename?: 'Location', name: string, id: any, type: LocationTypeEnum, partOfId?: any | null }> } }> } | null };

export type DashboardPractitionerCountQueryVariables = Exact<{
  targetOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
  selectedLocationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type DashboardPractitionerCountQuery = { __typename?: 'Query', dashboardPractitioners?: { __typename?: 'PractitionersConnection', totalCount: number } | null };

export type DashboardPractitionerListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  targetOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
  selectedLocationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type DashboardPractitionerListQuery = { __typename?: 'Query', dashboardPractitioners?: { __typename?: 'PractitionersConnection', totalCount: number, nodes: Array<{ __typename?: 'Practitioner', id: any, sourceSystem: DataSource, status: PractitionerStatusEnum, birthDate?: any | null, emailAddress?: string | null, employeeNumber?: string | null, gender: GenderEnum, user?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, authStatus?: AuthStatus | null } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, practitioners: { __typename?: 'PractitionerPractitionersManyToManyConnection', nodes: Array<{ __typename?: 'Location', name: string, id: any, type: LocationTypeEnum, partOfId?: any | null }> } }> } | null };

export type PractitionerQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PractitionerQueryQuery = { __typename?: 'Query', practitioner?: { __typename?: 'Practitioner', id: any, sourceSystem: DataSource, externalId: string, birthDate?: any | null, emailAddress?: string | null, employeeNumber?: string | null, telephoneNumber?: string | null, gender: GenderEnum, status: PractitionerStatusEnum, role: string, motherTongue?: string | null, user?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, avatar?: any | null, salutation?: string | null, authStatus?: AuthStatus | null, authStatusValidUntil?: any | null } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, practitioners: { __typename?: 'PractitionerPractitionersManyToManyConnection', nodes: Array<{ __typename?: 'Location', name: string, id: any, type: LocationTypeEnum }> } } | null };

export type GetUploadLinksWithKeysQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type GetUploadLinksWithKeysQuery = { __typename?: 'Query', getUploadLinksWithKeys?: Array<{ __typename?: 'UploadLink', key: string, url: string }> | null };

export type DevicesQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<DeviceCondition>;
}>;


export type DevicesQueryQuery = { __typename?: 'Query', devices?: { __typename?: 'DevicesConnection', totalCount: number, nodes: Array<{ __typename?: 'Device', id: any, deviceId: string, status: string, unenrolledAt?: any | null, manufacturer?: string | null, model?: string | null, osVersion?: string | null, appVersion?: string | null, contentVersion?: string | null, name?: string | null, location?: { __typename?: 'Location', id: any, name: string } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null }> } | null };

export type DeviceQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeviceQueryQuery = { __typename?: 'Query', device?: { __typename?: 'Device', id: any, deviceId: string, status: string, unenrolledAt?: any | null, manufacturer?: string | null, model?: string | null, osVersion?: string | null, appVersion?: string | null, contentVersion?: string | null, name?: string | null, location?: { __typename?: 'Location', id: any, name: string } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null } | null };

export type DocumentationSyncFieldsFragment = { __typename?: 'DocumentationSync', id: any, kind: DocumentationSyncKind, seniorId?: any | null, provider?: DataSource | null, status: DocumentationSyncStatus, skipReason?: DocumentationSyncSkipReason | null, attempts: number, lastError?: string | null, sentAt?: any | null, outcomeAt?: any | null, updatedAt: any };

export type SalesforceIntegrationFieldsFragment = { __typename?: 'SalesforceIntegration', loginUrl?: string | null, clientId?: string | null, hasClientSecret: boolean, anonymize: boolean, anonymizationRequired: boolean, schedule: SalesforceSyncSchedule, dailyTime?: string | null, intervalHours?: number | null, windowStart?: string | null, windowEnd?: string | null, windowIntervalMinutes?: number | null, outsideIntervalHours?: number | null, updatedAt?: any | null, nextRunAt?: any | null };

export type SalesforceSyncRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesforceSyncRunsQuery = { __typename?: 'Query', salesforceSyncRuns: Array<{ __typename?: 'SalesforceSyncRun', id: any, trigger: SalesforceSyncTrigger, status: SalesforceSyncStatus, mode?: SalesforceSyncMode | null, anonymized: boolean, startedAt: any, finishedAt?: any | null, phase?: SalesforceSyncPhase | null, phaseRecords: number, progressAt?: any | null, unavailable?: Array<string> | null, apiCalls?: number | null, apiRequestsRemaining?: number | null, apiRequestsMax?: number | null, errorCode?: string | null, counts?: { __typename?: 'SalesforceSyncCounts', products: number, accounts: number, contracts: number, items: number, users: number, contacts: number, leads: number, orders: number, cases: number, emails: number, caseComments: number, caseHistories: number, calls: number } | null }> };

export type SalesforceIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesforceIntegrationQuery = { __typename?: 'Query', salesforceIntegration: { __typename?: 'SalesforceIntegration', loginUrl?: string | null, clientId?: string | null, hasClientSecret: boolean, anonymize: boolean, anonymizationRequired: boolean, schedule: SalesforceSyncSchedule, dailyTime?: string | null, intervalHours?: number | null, windowStart?: string | null, windowEnd?: string | null, windowIntervalMinutes?: number | null, outsideIntervalHours?: number | null, updatedAt?: any | null, nextRunAt?: any | null } };

export type MarketingDeliverySettingsFieldsFragment = { __typename?: 'MarketingDeliverySettings', provider?: MarketingDeliveryProviderType | null, hasApiKey: boolean, hasApiSecret: boolean, hasWebhookSecret: boolean, sendingDomain?: string | null, fromAddress?: string | null, fromName?: string | null, replyToAddress?: string | null, updatedAt?: any | null, recipientsRestricted: boolean, allowedRecipients: Array<string>, availableProviders: Array<{ __typename?: 'MarketingDeliveryProviderOption', type: MarketingDeliveryProviderType, name: string }> };

export type MarketingDeliverySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingDeliverySettingsQuery = { __typename?: 'Query', marketingDeliverySettings: { __typename?: 'MarketingDeliverySettings', provider?: MarketingDeliveryProviderType | null, hasApiKey: boolean, hasApiSecret: boolean, hasWebhookSecret: boolean, sendingDomain?: string | null, fromAddress?: string | null, fromName?: string | null, replyToAddress?: string | null, updatedAt?: any | null, recipientsRestricted: boolean, allowedRecipients: Array<string>, availableProviders: Array<{ __typename?: 'MarketingDeliveryProviderOption', type: MarketingDeliveryProviderType, name: string }> } };

export type MarketingSendingDomainQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingSendingDomainQuery = { __typename?: 'Query', marketingSendingDomain?: { __typename?: 'MarketingSendingDomain', domain: string, checkedAt: any, records: Array<{ __typename?: 'MarketingDnsRecord', purpose: MarketingDnsPurpose, type: MarketingDnsRecordType, name: string, value: string, status: MarketingDnsRecordStatus, found: Array<string> }> } | null };

export type PractitionerActivitiesQueryQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy> | ActivitySessionsOrderBy>;
  condition?: InputMaybe<ActivitySessionCondition>;
}>;


export type PractitionerActivitiesQueryQuery = { __typename?: 'Query', user?: { __typename?: 'User', activitySessionsByCaregiverId: { __typename?: 'ActivitySessionsConnection', totalCount: number, nodes: Array<{ __typename?: 'ActivitySession', id: any, beganAt?: any | null, endedAt?: any | null, kind: SessionKind, activity?: { __typename?: 'Activity', id: any, kind: ActivityKind, contentActivity?: { __typename?: 'ContentActivity', content?: { __typename?: 'Content', cmsContentId?: number | null, cmsContentKind?: string | null, cmsNextContentId?: number | null, cmsNextContentKind?: string | null, title?: string | null, metaTags: { __typename?: 'ContentMetaTagsConnection', nodes: Array<{ __typename?: 'ContentMetaTag', metaTag?: { __typename?: 'MetaTag', tag: string, kind: MetaTagKind } | null }> } } | null } | null, customActivity?: { __typename?: 'CustomActivity', name: string } | null, featureActivity?: { __typename?: 'FeatureActivity', kind: FeatureActivityKind } | null } | null, activityParticipants: { __typename?: 'ActivityParticipantsConnection', nodes: Array<{ __typename?: 'ActivityParticipant', senior?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, name: string, avatarUrl?: string | null } | null }> }, noteList: Array<{ __typename?: 'Note', id: any, note: string, kind: NoteKind, generationStatus?: NoteGenerationStatus | null, publishedAt?: any | null, mdDocumentation?: string | null, createdAt: any, updatedAt: any, documentationSyncsList: Array<{ __typename?: 'DocumentationSync', id: any, kind: DocumentationSyncKind, seniorId?: any | null, provider?: DataSource | null, status: DocumentationSyncStatus, skipReason?: DocumentationSyncSkipReason | null, attempts: number, lastError?: string | null, sentAt?: any | null, outcomeAt?: any | null, updatedAt: any }>, author?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, name: string } | null }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: any | null } } } | null };

export type PatientActivitiesQueryQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitySessionsOrderBy> | ActivitySessionsOrderBy>;
  condition?: InputMaybe<ActivitySessionCondition>;
}>;


export type PatientActivitiesQueryQuery = { __typename?: 'Query', user?: { __typename?: 'User', activitySessionsByActivityParticipantSeniorIdAndActivitySessionId: { __typename?: 'UserActivitySessionsByActivityParticipantSeniorIdAndActivitySessionIdManyToManyConnection', totalCount: number, nodes: Array<{ __typename?: 'ActivitySession', id: any, beganAt?: any | null, endedAt?: any | null, kind: SessionKind, activity?: { __typename?: 'Activity', id: any, kind: ActivityKind, contentActivity?: { __typename?: 'ContentActivity', content?: { __typename?: 'Content', cmsContentId?: number | null, cmsContentKind?: string | null, cmsNextContentId?: number | null, cmsNextContentKind?: string | null, title?: string | null, metaTags: { __typename?: 'ContentMetaTagsConnection', nodes: Array<{ __typename?: 'ContentMetaTag', metaTag?: { __typename?: 'MetaTag', tag: string, kind: MetaTagKind } | null }> } } | null } | null, customActivity?: { __typename?: 'CustomActivity', name: string } | null, featureActivity?: { __typename?: 'FeatureActivity', kind: FeatureActivityKind } | null } | null, noteList: Array<{ __typename?: 'Note', id: any, note: string, kind: NoteKind, generationStatus?: NoteGenerationStatus | null, publishedAt?: any | null, mdDocumentation?: string | null, createdAt: any, updatedAt: any, documentationSyncsList: Array<{ __typename?: 'DocumentationSync', id: any, kind: DocumentationSyncKind, seniorId?: any | null, provider?: DataSource | null, status: DocumentationSyncStatus, skipReason?: DocumentationSyncSkipReason | null, attempts: number, lastError?: string | null, sentAt?: any | null, outcomeAt?: any | null, updatedAt: any }>, author?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, name: string } | null }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: any | null } } } | null };

export type PractitionerNotesQueryQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PractitionerNotesQueryQuery = { __typename?: 'Query', notes?: { __typename?: 'NotesConnection', totalCount: number, nodes: Array<{ __typename?: 'Note', id: any, note: string, createdAt: any, updatedAt: any, author?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, name: string } | null, activitySessionList: Array<{ __typename?: 'ActivitySession', activity?: { __typename?: 'Activity', contentActivity?: { __typename?: 'ContentActivity', content?: { __typename?: 'Content', metaTags: { __typename?: 'ContentMetaTagsConnection', nodes: Array<{ __typename?: 'ContentMetaTag', metaTag?: { __typename?: 'MetaTag', tag: string, kind: MetaTagKind } | null }> } } | null } | null, customActivity?: { __typename?: 'CustomActivity', name: string } | null, featureActivity?: { __typename?: 'FeatureActivity', kind: FeatureActivityKind } | null } | null }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: any | null } } | null };

export type ManagerInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ManagerInvitationsQuery = { __typename?: 'Query', managerInvitations: Array<{ __typename?: 'ManagerInvitation', id: any, email: string, status: string, createdAt: string, salesforceAccountId?: string | null, salesforceAccountName?: string | null }> };

export type DeviceEnrollmentTokenFieldsFragment = { __typename?: 'DeviceEnrollmentToken', id: any, organizationId: any, scopeType: DeviceEnrollmentScopeType, expiresAt: any, maxUses?: number | null, useCount: number, status: DeviceEnrollmentTokenStatus, implicit: boolean, createdAt: any, revokedAt?: any | null, scopeLocation?: { __typename?: 'DeviceEnrollmentLocation', id: any, name: string, type: LocationTypeEnum } | null, createdBy?: { __typename?: 'DeviceEnrollmentActor', id: any, name?: string | null } | null, redemptions: Array<{ __typename?: 'DeviceEnrollmentRedemption', id: any, redeemedAt: any, targetLocation?: { __typename?: 'DeviceEnrollmentLocation', id: any, name: string, type: LocationTypeEnum } | null, device?: { __typename?: 'DeviceEnrollmentRedemptionDevice', id: any, deviceId: string, name?: string | null, model?: string | null, manufacturer?: string | null, status: string } | null }>, emailDeliveries: Array<{ __typename?: 'DeviceEnrollmentEmailDelivery', id: any, recipientEmail: string, queuedAt: any, sentAt?: any | null, failedAt?: any | null, status: DeviceEnrollmentEmailDeliveryStatus, sentBy?: { __typename?: 'DeviceEnrollmentActor', id: any, name?: string | null } | null }> };

export type DeviceEnrollmentTokensQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
}>;


export type DeviceEnrollmentTokensQuery = { __typename?: 'Query', deviceEnrollmentTokens: Array<{ __typename?: 'DeviceEnrollmentToken', id: any, organizationId: any, scopeType: DeviceEnrollmentScopeType, expiresAt: any, maxUses?: number | null, useCount: number, status: DeviceEnrollmentTokenStatus, implicit: boolean, createdAt: any, revokedAt?: any | null, scopeLocation?: { __typename?: 'DeviceEnrollmentLocation', id: any, name: string, type: LocationTypeEnum } | null, createdBy?: { __typename?: 'DeviceEnrollmentActor', id: any, name?: string | null } | null, redemptions: Array<{ __typename?: 'DeviceEnrollmentRedemption', id: any, redeemedAt: any, targetLocation?: { __typename?: 'DeviceEnrollmentLocation', id: any, name: string, type: LocationTypeEnum } | null, device?: { __typename?: 'DeviceEnrollmentRedemptionDevice', id: any, deviceId: string, name?: string | null, model?: string | null, manufacturer?: string | null, status: string } | null }>, emailDeliveries: Array<{ __typename?: 'DeviceEnrollmentEmailDelivery', id: any, recipientEmail: string, queuedAt: any, sentAt?: any | null, failedAt?: any | null, status: DeviceEnrollmentEmailDeliveryStatus, sentBy?: { __typename?: 'DeviceEnrollmentActor', id: any, name?: string | null } | null }> }> };

export type CustomerServiceOrganizationAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerServiceOrganizationAccountsQuery = { __typename?: 'Query', customerServiceOrganizationAccounts: Array<{ __typename?: 'CustomerServiceOrganizationAccount', organizationId: any, organizationName?: string | null, salesforceAccountId?: string | null, salesforceAccountName?: string | null }> };

export type CustomerServiceAccountManagersQueryVariables = Exact<{
  salesforceAccountId: Scalars['String']['input'];
}>;


export type CustomerServiceAccountManagersQuery = { __typename?: 'Query', customerServiceAccountManagers: { __typename?: 'CustomerServiceAccountManagers', salesforceAccountId: string, eligible: boolean, ambulant: boolean, organization?: { __typename?: 'AccountManagerOrganization', id: any, name?: string | null } | null, contacts: Array<{ __typename?: 'AccountContact', contactId: string, name: string, email?: string | null, invitationState: AccountContactInvitationState }>, invitations: Array<{ __typename?: 'AccountManagerInvitation', id: any, email: string, status: string, createdAt: string }>, managers: Array<{ __typename?: 'AccountManager', userId: any, name: string, email?: string | null, registeredAt: string, lastSignInAt?: string | null }> } };

export type ManagerRegistrationCandidateQueryVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ManagerRegistrationCandidateQuery = { __typename?: 'Query', managerRegistrationCandidate: { __typename?: 'ManagerRegistrationCandidate', managerName: string, organizationName: string } };

export type StaffRegistrationCandidateQueryVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type StaffRegistrationCandidateQuery = { __typename?: 'Query', staffRegistrationCandidate?: { __typename?: 'StaffRegistrationCandidate', roles: Array<StaffRole> } | null };

export type StaffMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type StaffMembersQuery = { __typename?: 'Query', staffMembers: Array<{ __typename?: 'StaffMember', id: any, name: string, email?: string | null, roles: Array<StaffRole> }> };

export type StaffInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type StaffInvitationsQuery = { __typename?: 'Query', staffInvitations: Array<{ __typename?: 'StaffInvitation', id: any, email: string, roles: Array<StaffRole>, status: StaffInvitationStatus, createdAt: any, invitedByName?: string | null }> };

export type AnalyticsDailyQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsDailyQueryQuery = { __typename?: 'Query', dailiesList?: Array<{ __typename?: 'Daily', date: any, appId: string, dau: number, mau: number, messagesSent: number, picturesSent: number, notesCreated: number, b2BSeniorsCreated: number }> | null };

export type AnalyticsDistributionQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsDistributionQueryQuery = { __typename?: 'Query', distributionsList?: Array<{ __typename?: 'Distribution', date: any, appId: string, dimension: string, label: string, count: number }> | null };

export type AnalyticsContentUsageDailyQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsContentUsageDailyQueryQuery = { __typename?: 'Query', contentUsageDailiesList?: Array<{ __typename?: 'ContentUsageDaily', date: any, appId: string, contentId: any, cmsContentKind: string, contentSubtype?: string | null, title?: string | null, completedSessionCount: number, unfinishedSessionCount: number, completedDurationSecondsSum: any, completedDurationSessionCount: number }> | null };

export type MostUsedYoutubeContentQueryVariables = Exact<{
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
}>;


export type MostUsedYoutubeContentQuery = { __typename?: 'Query', mostUsedYoutubeContent: Array<{ __typename?: 'MostUsedYoutubeContentItem', contentId: any, title: string, completedSessionCount: any, unfinishedSessionCount: any, averageCompletedDurationSeconds?: number | null }> };

export type LeastUsedContentReportQueryVariables = Exact<{
  contentKind?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type LeastUsedContentReportQuery = { __typename?: 'Query', leastUsedContentReport: { __typename?: 'LeastUsedContentReport', periodStart: any, periodEnd: any, contentTypes: Array<string>, totalCount: number, items: Array<{ __typename?: 'LeastUsedContentItem', contentId: any, title: string, contentKind: string, contentSubtype?: string | null, sessionCount: any, lastUsedAt?: any | null }> } };

export type MeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQueryQuery = { __typename?: 'Query', hasLearningContent: boolean, me?: { __typename?: 'User', id: any, kind: UserType, firstName?: string | null, lastName?: string | null, name: string, email?: string | null, organizationManager?: { __typename?: 'OrganizationManager', organizationId: any, organization?: { __typename?: 'Organization', name?: string | null } | null } | null } | null };

export type PortalAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalAccessQuery = { __typename?: 'Query', hasLearningContent: boolean, currentUserPermissions: Array<string>, me?: { __typename?: 'User', id: any, kind: UserType } | null };

export type GetIntegrationSettingsQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
}>;


export type GetIntegrationSettingsQuery = { __typename?: 'Query', getIntegrationSettings?: { __typename?: 'IntegrationSettings', organizationId: any, hasClientSecret: boolean, provider: IntegrationProvider, credentials: { __typename?: 'IntegrationCredentials', serverUrl?: string | null, clientId?: string | null, clientSecret?: string | null } } | null };

export type PlacetelIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type PlacetelIntegrationQuery = { __typename?: 'Query', placetelIntegration: { __typename?: 'PlacetelIntegration', enabled: boolean, organizationId?: string | null, clientId?: string | null, hasClientSecret: boolean, hasRefreshToken: boolean, hasWebhookSecret: boolean, phoneClientId?: string | null, hasPhoneClientSecret: boolean, updatedAt?: any | null } };

export type PlacetelHotlineNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type PlacetelHotlineNumbersQuery = { __typename?: 'Query', placetelHotlineNumbers: Array<string> };

export type PlacetelOpeningHoursQueryVariables = Exact<{ [key: string]: never; }>;


export type PlacetelOpeningHoursQuery = { __typename?: 'Query', placetelOpeningHours: Array<{ __typename?: 'PlacetelOpeningDay', weekday: number, opens: string, closes: string }> };

export type PlacetelPhoneAccountFieldsFragment = { __typename?: 'PlacetelPhoneAccount', available: boolean, connected: boolean, email?: string | null, connectedAt?: any | null };

export type PlacetelPhoneAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type PlacetelPhoneAccountQuery = { __typename?: 'Query', placetelPhoneAccount: { __typename?: 'PlacetelPhoneAccount', available: boolean, connected: boolean, email?: string | null, connectedAt?: any | null } };

export type GetIntegrationExecutionsQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
  input?: InputMaybe<IntegrationExecutionsInput>;
}>;


export type GetIntegrationExecutionsQuery = { __typename?: 'Query', integrationExecutions: Array<{ __typename?: 'IntegrationExecution', organizationId: any, id: any, userId?: any | null, provider: IntegrationProvider, status: IntegrationExecutionStatus, result?: IntegrationExecutionResult | null, jobId?: string | null, summary?: any | null, errorMessage?: string | null, startedAt: any, completedAt?: any | null, duration?: number | null }> };

export type GetIntegrationExecutionQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
}>;


export type GetIntegrationExecutionQuery = { __typename?: 'Query', integrationExecution?: { __typename?: 'IntegrationExecution', id: any, organizationId: any, kind: IntegrationExecutionKind, status: IntegrationExecutionStatus } | null };

export type GetIntegrationImportPreviewQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
}>;


export type GetIntegrationImportPreviewQuery = { __typename?: 'Query', integrationImportPreview?: { __typename?: 'IntegrationImportPreview', executionId: any, organizationId: any, provider: IntegrationProvider, createdAt: any, expiresAt: any, procedureCount: number, locations: Array<{ __typename?: 'IntegrationPreviewLocation', externalId: string, type: LocationTypeEnum, name: string, change: IntegrationPreviewChange, parent?: { __typename?: 'IntegrationPreviewLocationRef', type: LocationTypeEnum, externalId: string } | null }>, patients: Array<{ __typename?: 'IntegrationPreviewPerson', externalId: string, number?: string | null, displayName: string, change: IntegrationPreviewChange, reason?: string | null, locations: Array<{ __typename?: 'IntegrationPreviewLocationRef', type: LocationTypeEnum, externalId: string }> }>, practitioners: Array<{ __typename?: 'IntegrationPreviewPerson', externalId: string, number?: string | null, displayName: string, change: IntegrationPreviewChange, reason?: string | null, locations: Array<{ __typename?: 'IntegrationPreviewLocationRef', type: LocationTypeEnum, externalId: string }> }>, warnings: Array<{ __typename?: 'IntegrationPreviewIssue', entity: string, reference?: string | null, reason: string }>, failures: Array<{ __typename?: 'IntegrationPreviewIssue', entity: string, reference?: string | null, reason: string }> } | null };

export type ProceduresQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<ProcedureCondition>;
  orderBy?: InputMaybe<Array<ProceduresOrderBy> | ProceduresOrderBy>;
}>;


export type ProceduresQueryQuery = { __typename?: 'Query', procedures?: { __typename?: 'ProceduresConnection', totalCount: number, nodes: Array<{ __typename?: 'Procedure', id: any, status: ProcedureStatusEnum, sourceSystem: DataSource, externalId: string, codeSystem?: string | null, codeValue?: string | null, codeDisplay?: string | null, description?: string | null, plannedStart?: any | null, plannedEnd?: any | null, performedStart?: any | null, performedEnd?: any | null, notes?: string | null, documentation?: string | null, createdAt: any, updatedAt: any, acknowledgedAt?: any | null, documentationSyncsList: Array<{ __typename?: 'DocumentationSync', id: any, kind: DocumentationSyncKind, seniorId?: any | null, provider?: DataSource | null, status: DocumentationSyncStatus, skipReason?: DocumentationSyncSkipReason | null, attempts: number, lastError?: string | null, sentAt?: any | null, outcomeAt?: any | null, updatedAt: any }>, procedureNotesList: Array<{ __typename?: 'NoteProcedure', procedureNotes?: { __typename?: 'Note', id: any, note: string, kind: NoteKind, createdAt: any, publishedAt?: any | null, documentationSyncsList: Array<{ __typename?: 'DocumentationSync', id: any, kind: DocumentationSyncKind, seniorId?: any | null, provider?: DataSource | null, status: DocumentationSyncStatus, skipReason?: DocumentationSyncSkipReason | null, attempts: number, lastError?: string | null, sentAt?: any | null, outcomeAt?: any | null, updatedAt: any }>, seniorList: Array<{ __typename?: 'User', id: any, name: string }> } | null }>, procedureParticipants: { __typename?: 'ProcedureParticipantsConnection', nodes: Array<{ __typename?: 'ProcedureParticipant', patient?: { __typename?: 'Patient', id: any, patientNumber?: string | null, location?: { __typename?: 'Location', id: any, partOfId?: any | null } | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, name: string } | null } | null }> }, performer?: { __typename?: 'Practitioner', id: any, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, name: string } | null } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, activitySessions: { __typename?: 'ActivitySessionsConnection', nodes: Array<{ __typename?: 'ActivitySession', id: any, beganAt?: any | null, endedAt?: any | null, activity?: { __typename?: 'Activity', id: any, kind: ActivityKind, contentActivity?: { __typename?: 'ContentActivity', content?: { __typename?: 'Content', title?: string | null } | null } | null, featureActivity?: { __typename?: 'FeatureActivity', kind: FeatureActivityKind } | null, customActivity?: { __typename?: 'CustomActivity', name: string } | null } | null }> } }> } | null };

export type ProcedureQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ProcedureQueryQuery = { __typename?: 'Query', procedure?: { __typename?: 'Procedure', id: any, status: ProcedureStatusEnum, sourceSystem: DataSource, externalId: string, codeSystem?: string | null, codeValue?: string | null, codeDisplay?: string | null, description?: string | null, plannedStart?: any | null, plannedEnd?: any | null, performedStart?: any | null, performedEnd?: any | null, acknowledgedAt?: any | null, notes?: string | null, documentation?: string | null, sourceData?: any | null, createdAt: any, updatedAt: any, documentationSyncsList: Array<{ __typename?: 'DocumentationSync', id: any, kind: DocumentationSyncKind, seniorId?: any | null, provider?: DataSource | null, status: DocumentationSyncStatus, skipReason?: DocumentationSyncSkipReason | null, attempts: number, lastError?: string | null, sentAt?: any | null, outcomeAt?: any | null, updatedAt: any }>, procedureNotesList: Array<{ __typename?: 'NoteProcedure', procedureNotes?: { __typename?: 'Note', id: any, note: string, kind: NoteKind, createdAt: any, publishedAt?: any | null, documentationSyncsList: Array<{ __typename?: 'DocumentationSync', id: any, kind: DocumentationSyncKind, seniorId?: any | null, provider?: DataSource | null, status: DocumentationSyncStatus, skipReason?: DocumentationSyncSkipReason | null, attempts: number, lastError?: string | null, sentAt?: any | null, outcomeAt?: any | null, updatedAt: any }>, seniorList: Array<{ __typename?: 'User', id: any, name: string }>, author?: { __typename?: 'User', id: any, firstName?: string | null, lastName?: string | null, name: string } | null } | null }>, procedureParticipants: { __typename?: 'ProcedureParticipantsConnection', nodes: Array<{ __typename?: 'ProcedureParticipant', patient?: { __typename?: 'Patient', id: any, patientNumber?: string | null, location?: { __typename?: 'Location', id: any, partOfId?: any | null } | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, name: string, avatarUrl?: string | null } | null } | null }> }, performer?: { __typename?: 'Practitioner', id: any, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, name: string } | null } | null, organization?: { __typename?: 'Organization', id: any, name?: string | null } | null, activitySessions: { __typename?: 'ActivitySessionsConnection', nodes: Array<{ __typename?: 'ActivitySession', id: any, beganAt?: any | null, endedAt?: any | null, sessionStatus?: SessionStatus | null, caregiver?: { __typename?: 'User', id: any, name: string, firstName?: string | null, lastName?: string | null } | null, activity?: { __typename?: 'Activity', id: any, kind: ActivityKind, contentActivity?: { __typename?: 'ContentActivity', content?: { __typename?: 'Content', id: any, title?: string | null, cmsContentId?: number | null, cmsContentKind?: string | null, cmsNextContentKind?: string | null, thumbnailFilename?: string | null } | null } | null, featureActivity?: { __typename?: 'FeatureActivity', kind: FeatureActivityKind } | null, customActivity?: { __typename?: 'CustomActivity', name: string } | null } | null, activityParticipants: { __typename?: 'ActivityParticipantsConnection', nodes: Array<{ __typename?: 'ActivityParticipant', senior?: { __typename?: 'User', id: any, name: string, firstName?: string | null, lastName?: string | null } | null }> } }> } } | null };

export type RevealDeviceEnrollmentTokenQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RevealDeviceEnrollmentTokenQuery = { __typename?: 'Query', deviceEnrollmentToken?: { __typename?: 'DeviceEnrollmentToken', id: any, code?: string | null, qrPayload?: string | null } | null };

export type CrmValueFieldsFragment = { __typename?: 'CrmValue', key: string, type: CrmFieldType, value?: string | null, referenceObject?: CrmObject | null, referenceTitle?: string | null };

export type CrmRowFieldsFragment = { __typename?: 'CrmRow', salesforceId: string, title: string, deletedInSalesforceAt?: any | null, values: Array<{ __typename?: 'CrmValue', key: string, type: CrmFieldType, value?: string | null, referenceObject?: CrmObject | null, referenceTitle?: string | null }> };

export type CustomerServiceCrmListQueryVariables = Exact<{
  input: CrmListInput;
}>;


export type CustomerServiceCrmListQuery = { __typename?: 'Query', customerServiceCrmList: { __typename?: 'CrmList', object: CrmObject, listView: string, listViews: Array<string>, totalCount: number, columns: Array<{ __typename?: 'CrmColumn', key: string, type: CrmFieldType }>, rows: Array<{ __typename?: 'CrmRow', salesforceId: string, title: string, deletedInSalesforceAt?: any | null, values: Array<{ __typename?: 'CrmValue', key: string, type: CrmFieldType, value?: string | null, referenceObject?: CrmObject | null, referenceTitle?: string | null }> }> } };

export type CrmInventoryUnitFieldsFragment = { __typename?: 'CrmInventoryUnit', id: any, name?: string | null, type?: string | null, status?: string | null, imei?: string | null, serialNumber?: string | null, hardwareSerialNumber?: string | null, simIccid?: string | null, deletedInSalesforceAt?: any | null };

export type CustomerServiceCrmRecordQueryVariables = Exact<{
  object: CrmObject;
  salesforceId: Scalars['String']['input'];
}>;


export type CustomerServiceCrmRecordQuery = { __typename?: 'Query', customerServiceCrmRecord?: { __typename?: 'CrmRecord', object: CrmObject, salesforceId: string, title: string, salesforceUrl: string, syncedAt?: any | null, deletedInSalesforceAt?: any | null, hasTimeline: boolean, contractItemInventoryHistory: Array<{ __typename?: 'CrmContractItemInventoryHistory', id: any, atClientDate?: any | null, removedFromClientDate?: any | null, inStockDate?: any | null, deletedInSalesforceAt?: any | null, inventory: { __typename?: 'CrmInventoryUnit', id: any, name?: string | null, type?: string | null, status?: string | null, imei?: string | null, serialNumber?: string | null, hardwareSerialNumber?: string | null, simIccid?: string | null, deletedInSalesforceAt?: any | null } }>, contractItemOrders: Array<{ __typename?: 'CrmContractItemOrder', id: any, orderSalesforceId?: string | null, orderNumber?: string | null, recordType?: string | null, status?: string | null, exchangeStatus?: string | null, orderRejected?: boolean | null, createdBy?: string | null, createdAt?: any | null, deletedInSalesforceAt?: any | null }>, contractItemAsset?: { __typename?: 'CrmContractItemAsset', salesforceId: string, name?: string | null, deletedInSalesforceAt?: any | null, tablet?: { __typename?: 'CrmInventoryUnit', id: any, name?: string | null, type?: string | null, status?: string | null, imei?: string | null, serialNumber?: string | null, hardwareSerialNumber?: string | null, simIccid?: string | null, deletedInSalesforceAt?: any | null } | null, sim?: { __typename?: 'CrmInventoryUnit', id: any, name?: string | null, type?: string | null, status?: string | null, imei?: string | null, serialNumber?: string | null, hardwareSerialNumber?: string | null, simIccid?: string | null, deletedInSalesforceAt?: any | null } | null, hardware?: { __typename?: 'CrmInventoryUnit', id: any, name?: string | null, type?: string | null, status?: string | null, imei?: string | null, serialNumber?: string | null, hardwareSerialNumber?: string | null, simIccid?: string | null, deletedInSalesforceAt?: any | null } | null } | null, mergedInto?: { __typename?: 'CrmMergeTarget', salesforceId: string, title?: string | null } | null, highlights: Array<{ __typename?: 'CrmValue', key: string, type: CrmFieldType, value?: string | null, referenceObject?: CrmObject | null, referenceTitle?: string | null }>, path?: { __typename?: 'CrmPath', stages: Array<string>, current?: string | null } | null, sections: Array<{ __typename?: 'CrmSection', key: string, values: Array<{ __typename?: 'CrmValue', key: string, type: CrmFieldType, value?: string | null, referenceObject?: CrmObject | null, referenceTitle?: string | null }> }>, related: Array<{ __typename?: 'CrmRelatedList', key: string, object: CrmObject, totalCount: number, columns: Array<{ __typename?: 'CrmColumn', key: string, type: CrmFieldType }>, rows: Array<{ __typename?: 'CrmRow', salesforceId: string, title: string, deletedInSalesforceAt?: any | null, values: Array<{ __typename?: 'CrmValue', key: string, type: CrmFieldType, value?: string | null, referenceObject?: CrmObject | null, referenceTitle?: string | null }> }> }>, appOrganizations: Array<{ __typename?: 'CrmAppOrganization', id: any, name?: string | null }> } | null };

export type CustomerServiceCrmTimelineQueryVariables = Exact<{
  object: CrmObject;
  salesforceId: Scalars['String']['input'];
  kinds?: InputMaybe<Array<CrmTimelineKind> | CrmTimelineKind>;
  after?: InputMaybe<CrmTimelineCursorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerServiceCrmTimelineQuery = { __typename?: 'Query', customerServiceCrmTimeline: Array<{ __typename?: 'CrmTimelineEntry', kind: CrmTimelineKind, salesforceId: string, at?: any | null, title?: string | null, body?: string | null, bodyNotImported: boolean, inbound?: boolean | null, actor?: string | null, counterpart?: string | null, durationSeconds?: number | null, recorded?: boolean | null, field?: string | null, oldValue?: string | null, newValue?: string | null, caseId?: string | null, caseTitle?: string | null, provider?: CrmCallProvider | null }> };

export type CustomerServiceCrmSearchQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type CustomerServiceCrmSearchQuery = { __typename?: 'Query', customerServiceCrmSearch: Array<{ __typename?: 'CrmSearchHit', object: CrmObject, salesforceId: string, title: string, subtitle?: string | null, deletedInSalesforceAt?: any | null }> };

export type CustomerServiceCrmPhoneMatchesQueryVariables = Exact<{
  number: Scalars['String']['input'];
}>;


export type CustomerServiceCrmPhoneMatchesQuery = { __typename?: 'Query', customerServiceCrmPhoneMatches: Array<{ __typename?: 'CrmSearchHit', object: CrmObject, salesforceId: string, title: string, subtitle?: string | null }> };

export type CustomerServiceCallKpisQueryVariables = Exact<{
  range: CallKpiRange;
}>;


export type CustomerServiceCallKpisQuery = { __typename?: 'Query', customerServiceCallKpis?: { __typename?: 'CallKpis', hotlineConfigured: boolean, inbound: number, answered: number, missed: number, abandoned: number, notRouted: number, reachability?: number | null, averageWaitSeconds?: number | null, maxWaitSeconds?: number | null, averageHandleSeconds?: number | null, outbound: number, syncedAt?: any | null, syncError?: string | null, agents: Array<{ __typename?: 'CallKpiAgent', agentKey: string, name: string, answered: number, outbound: number, averageHandleSeconds?: number | null }> } | null };

export type CustomerServiceProviderCallsQueryVariables = Exact<{
  range: CallKpiRange;
  filter: CallListFilter;
  agentKey?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerServiceProviderCallsQuery = { __typename?: 'Query', customerServiceProviderCalls?: { __typename?: 'ProviderCallList', totalCount: number, endCursor?: string | null, hasMore: boolean, rows: Array<{ __typename?: 'ProviderCallRow', id: string, startedAt: any, direction: string, outcome?: string | null, customerNumber?: string | null, agentName?: string | null, waitSeconds?: number | null, handleSeconds?: number | null, withinOpeningHours: boolean }> } | null };

export type BillwerkPlanVariantFieldsFragment = { __typename?: 'BillwerkPlanVariant', state: BillwerkPlanVariantState, planVariantId?: string | null, name?: string | null, hidden?: boolean | null, url?: string | null, billwerkPlanId?: string | null, priceBookId?: string | null, priceBookName?: string | null };

export type FinanceContractItemFieldsFragment = { __typename?: 'FinanceContractItem', salesforceId: string, salesforceUrl: string, name?: string | null, status?: string | null, contractNumber?: string | null, accountName?: string | null, accountRecordType?: string | null, productName?: string | null, price?: any | null, startDate?: any | null, endDate?: any | null, billingStartDate?: any | null, billingTool?: string | null, billingStarted?: boolean | null, billingStopped?: boolean | null, cancellationType?: string | null, cancellationDate?: any | null, lostReason?: string | null, planVariant: { __typename?: 'BillwerkPlanVariant', state: BillwerkPlanVariantState, planVariantId?: string | null, name?: string | null, hidden?: boolean | null, url?: string | null, billwerkPlanId?: string | null, priceBookId?: string | null, priceBookName?: string | null } };

export type FinanceNotificationsQueryVariables = Exact<{
  rule?: InputMaybe<FinanceNotificationRule>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinanceNotificationsQuery = { __typename?: 'Query', financeNotifications: { __typename?: 'FinanceNotificationPage', totalCount: number, hasNextPage: boolean, endCursor?: string | null, nodes: Array<{ __typename?: 'FinanceNotification', id: any, rule: FinanceNotificationRule, openedAt: any, billwerkEffectiveFrom?: any | null, noCompletedReturn: boolean, handledStatus?: string | null, handledEndDate?: any | null, handledAt?: any | null, item?: { __typename?: 'FinanceContractItem', salesforceId: string, salesforceUrl: string, name?: string | null, status?: string | null, contractNumber?: string | null, accountName?: string | null, accountRecordType?: string | null, productName?: string | null, price?: any | null, startDate?: any | null, endDate?: any | null, billingStartDate?: any | null, billingTool?: string | null, billingStarted?: boolean | null, billingStopped?: boolean | null, cancellationType?: string | null, cancellationDate?: any | null, lostReason?: string | null, planVariant: { __typename?: 'BillwerkPlanVariant', state: BillwerkPlanVariantState, planVariantId?: string | null, name?: string | null, hidden?: boolean | null, url?: string | null, billwerkPlanId?: string | null, priceBookId?: string | null, priceBookName?: string | null } } | null, returnOrder?: { __typename?: 'FinanceReturnOrder', salesforceId?: string | null, salesforceUrl?: string | null, orderNumber?: string | null, status?: string | null, completedDate?: any | null } | null, changedInto?: { __typename?: 'FinanceContractItem', salesforceId: string, salesforceUrl: string, name?: string | null, status?: string | null, contractNumber?: string | null, accountName?: string | null, accountRecordType?: string | null, productName?: string | null, price?: any | null, startDate?: any | null, endDate?: any | null, billingStartDate?: any | null, billingTool?: string | null, billingStarted?: boolean | null, billingStopped?: boolean | null, cancellationType?: string | null, cancellationDate?: any | null, lostReason?: string | null, planVariant: { __typename?: 'BillwerkPlanVariant', state: BillwerkPlanVariantState, planVariantId?: string | null, name?: string | null, hidden?: boolean | null, url?: string | null, billwerkPlanId?: string | null, priceBookId?: string | null, priceBookName?: string | null } } | null }>, sync: { __typename?: 'FinanceNotificationSync', lastSucceededAt?: any | null, lastRunFailed: boolean, unreadableFields: Array<string> } } };

export type FinanceNotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceNotificationCountQuery = { __typename?: 'Query', financeNotificationCount: number };

export type BillwerkMatchAccountFieldsFragment = { __typename?: 'BillwerkMatchAccount', salesforceId: string, name?: string | null, recordType?: string | null, b2c: boolean, debitorAccount?: string | null, oldCustomerNumber?: string | null, billed: boolean };

export type BillwerkPlanVariantsQueryVariables = Exact<{
  view: BillwerkPlanVariantView;
  state?: InputMaybe<BillwerkPlanVariantState>;
  search?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BillwerkPlanVariantsQuery = { __typename?: 'Query', billwerkPlanVariants: { __typename?: 'BillwerkPlanVariants', withheld: boolean, totalCount: number, billwerk: { __typename?: 'BillwerkPlanVariantListState', status: BillwerkListStatus, loadedAt?: any | null, variantCount?: number | null }, salesforceSync: { __typename?: 'BillwerkPlanVariantSync', lastSucceededAt?: any | null, unreadableFields: Array<string>, entriesCopied: boolean }, entryCounts: Array<{ __typename?: 'BillwerkPlanVariantCount', state: BillwerkPlanVariantState, count: number }>, itemCounts: Array<{ __typename?: 'BillwerkPlanVariantCount', state: BillwerkPlanVariantState, count: number }>, entries: Array<{ __typename?: 'BillwerkPriceBookEntry', salesforceId: string, salesforceUrl: string, priceBookId: string, priceBookName?: string | null, priceBookActive?: boolean | null, priceBookStandard?: boolean | null, productId: string, productName?: string | null, productFamily?: string | null, active?: boolean | null, currency?: string | null, billingItems: number, planVariant: { __typename?: 'BillwerkPlanVariant', state: BillwerkPlanVariantState, planVariantId?: string | null, name?: string | null, hidden?: boolean | null, url?: string | null, billwerkPlanId?: string | null, priceBookId?: string | null, priceBookName?: string | null } }>, items: Array<{ __typename?: 'BillwerkPlanVariantItem', salesforceId: string, salesforceUrl: string, name?: string | null, status?: string | null, accountName?: string | null, contractNumber?: string | null, contractUrl?: string | null, productName?: string | null, billed: boolean, openNotification: boolean, planVariant: { __typename?: 'BillwerkPlanVariant', state: BillwerkPlanVariantState, planVariantId?: string | null, name?: string | null, hidden?: boolean | null, url?: string | null, billwerkPlanId?: string | null, priceBookId?: string | null, priceBookName?: string | null } }> } };

export type BillwerkCustomerMatchQueryVariables = Exact<{
  group?: InputMaybe<BillwerkCustomerMatchGroup>;
  reason?: InputMaybe<BillwerkCustomerMatchReason>;
  search?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  refreshAfter?: InputMaybe<Scalars['Datetime']['input']>;
}>;


export type BillwerkCustomerMatchQuery = { __typename?: 'Query', billwerkCustomerMatch: { __typename?: 'BillwerkCustomerMatch', withheld: boolean, totalCount: number, billwerk: { __typename?: 'BillwerkCustomerListState', status: BillwerkListStatus, loadedAt?: any | null, failedAt?: any | null, contracts: BillwerkListStatus, customerCount?: number | null, checkedAt: any }, salesforceSync: { __typename?: 'BillwerkCustomerMatchSync', lastSucceededAt?: any | null, unreadableFields: Array<string>, accountFieldsCopied: boolean }, counts: Array<{ __typename?: 'BillwerkCustomerMatchCount', group: BillwerkCustomerMatchGroup, reason: BillwerkCustomerMatchReason, count: number }>, rows: Array<{ __typename?: 'BillwerkCustomerMatchRow', group?: BillwerkCustomerMatchGroup | null, reason?: BillwerkCustomerMatchReason | null, debitorAccount?: string | null, mappedCustomerIds: Array<string>, billedFacilities: number, accounts: Array<{ __typename?: 'BillwerkMatchAccount', salesforceId: string, name?: string | null, recordType?: string | null, b2c: boolean, debitorAccount?: string | null, oldCustomerNumber?: string | null, billed: boolean }>, payer?: { __typename?: 'BillwerkMatchAccount', salesforceId: string, name?: string | null, recordType?: string | null, b2c: boolean, debitorAccount?: string | null, oldCustomerNumber?: string | null, billed: boolean } | null, customers: Array<{ __typename?: 'BillwerkMatchCustomer', id: string, url?: string | null, name?: string | null, debitorAccount?: string | null, oldCustomerNumber?: string | null, externalCustomerId?: string | null, activeContract?: boolean | null }> }> } };

export type CustomerServiceCrmOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerServiceCrmOverviewQuery = { __typename?: 'Query', customerServiceCrmOverview: { __typename?: 'CrmServiceOverview', syncedAt?: any | null, openCases: number, waitingCases: number, escalatedCases: number, outsideSlaCases: number, createdToday: number, closedToday: number, openByType: Array<{ __typename?: 'CrmCount', label?: string | null, count: number }>, openByStatus: Array<{ __typename?: 'CrmCount', label?: string | null, count: number }>, openByOwner: Array<{ __typename?: 'CrmCount', label?: string | null, count: number }>, oldestOpen: Array<{ __typename?: 'CrmRow', salesforceId: string, title: string, deletedInSalesforceAt?: any | null, values: Array<{ __typename?: 'CrmValue', key: string, type: CrmFieldType, value?: string | null, referenceObject?: CrmObject | null, referenceTitle?: string | null }> }>, callsPerDay: Array<{ __typename?: 'CrmDayCount', day: any, inbound: number, outbound: number }> } };

export type MarketingOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingOverviewQuery = { __typename?: 'Query', marketingOverview: { __typename?: 'MarketingOverview', syncedAt?: any | null, months: Array<string>, medianDaysToConvert?: number | null, medianDaysToConvertByMonth: Array<number | null>, newLeads: Array<{ __typename?: 'MarketingSourceSeries', label?: string | null, total: number, months: Array<number>, details: Array<{ __typename?: 'MarketingSeries', label?: string | null, total: number, months: Array<number> }> }>, conversions: Array<{ __typename?: 'MarketingSeries', label?: string | null, total: number, months: Array<number> }>, openByStatus: Array<{ __typename?: 'MarketingCount', label?: string | null, count: number }> } };

export type MarketingWebOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingWebOrdersQuery = { __typename?: 'Query', marketingWebOrders: { __typename?: 'MarketingWebOrders', syncedAt?: any | null, stuckAfterMinutes: number, planVariantIdsKnown: boolean, weeks: Array<{ __typename?: 'WebOrderWeek', week: any, orders: number, stuck: number }>, orders: Array<{ __typename?: 'WebOrder', salesforceId: string, title: string, company?: string | null, status?: string | null, createdAt?: any | null, planVariantCount: number, stuck: boolean, markers: Array<WebOrderMarker>, salesforceUrl: string, products: Array<{ __typename?: 'WebOrderProduct', name?: string | null, quantity?: number | null, unitPrice?: number | null }>, steps: Array<{ __typename?: 'WebOrderStep', kind: WebOrderStepKind, done: boolean, at?: any | null, on?: any | null, object?: CrmObject | null, salesforceId?: string | null, title?: string | null, salesforceUrl?: string | null }> }> } };

export type FinanceAccountRefFieldsFragment = { __typename?: 'FinanceAccountRef', salesforceId: string, name?: string | null, url: string };

export type FinanceCustomerRefFieldsFragment = { __typename?: 'FinanceCustomerRef', id: string, name?: string | null, debitorAccount?: string | null, url?: string | null };

export type FinanceOverviewQueryVariables = Exact<{
  list: FinanceOverviewList;
  reconciliationStatus?: InputMaybe<FinanceReconciliationStatus>;
  salesforceCheck?: InputMaybe<FinanceSalesforceCheck>;
  billwerkCheck?: InputMaybe<FinanceBillwerkCheck>;
  search?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FinanceOverviewSort>;
  recentOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FinanceOverviewQuery = { __typename?: 'Query', financeOverview: { __typename?: 'FinanceOverview', withheld: boolean, recentDays: number, totalCount: number, billwerk: { __typename?: 'FinanceOverviewBillwerk', status: BillwerkListStatus, loadedAt?: any | null, contracts: BillwerkListStatus, customerCount?: number | null, contractCount?: number | null }, salesforceSync: { __typename?: 'FinanceOverviewSync', lastSucceededAt?: any | null, unreadableFields: Array<string> }, kpis: { __typename?: 'FinanceOverviewKpis', billedMonthlyValue: number, billedItems: number, billwerkActiveContracts?: number | null, billwerkActiveCustomers?: number | null, dunningContracts?: number | null, dunningRemaining?: number | null }, toDos: Array<{ __typename?: 'FinanceOverviewToDo', rule: FinanceNotificationRule, count: number, monthlyValue: number, legacy: number, upcoming: number }>, reconciliationCounts: Array<{ __typename?: 'FinanceReconciliationCount', status: FinanceReconciliationStatus, count: number, monthlyValue: number }>, salesforceCounts: Array<{ __typename?: 'FinanceSalesforceCheckCount', check: FinanceSalesforceCheck, count: number, monthlyValue: number }>, billwerkCounts: Array<{ __typename?: 'FinanceBillwerkCheckCount', check: FinanceBillwerkCheck, count: number, amount: number }>, planVariantGaps: { __typename?: 'FinancePlanVariantGaps', count: number, monthlyValue: number }, reconciliation: Array<{ __typename?: 'FinanceReconciliationRow', status: FinanceReconciliationStatus, matchGroup?: BillwerkCustomerMatchGroup | null, matchReason?: BillwerkCustomerMatchReason | null, debitorAccount?: string | null, salesforceItems: number, monthlyValue: number, billwerkContracts: number, salesforceCreatedAt?: any | null, billwerkStartedAt?: any | null, accounts: Array<{ __typename?: 'FinanceAccountRef', salesforceId: string, name?: string | null, url: string }>, customer?: { __typename?: 'FinanceCustomerRef', id: string, name?: string | null, debitorAccount?: string | null, url?: string | null } | null, variants: Array<{ __typename?: 'FinanceReconciliationVariant', planVariantId?: string | null, name?: string | null, known?: boolean | null, url?: string | null, salesforceItems: number, salesforceMonthlyValue: number, billwerkQuantity: number, billwerkContracts: number }> }>, salesforceItems: Array<{ __typename?: 'FinanceCheckItem', salesforceId: string, salesforceUrl: string, name?: string | null, status?: string | null, accountName?: string | null, contractNumber?: string | null, contractUrl?: string | null, productName?: string | null, price?: number | null, startDate?: string | null, endDate?: string | null, billingTool?: string | null, createdAt?: any | null }>, billwerkContracts: Array<{ __typename?: 'FinanceBillwerkContract', id: string, lifecycleStatus?: string | null, planVariantId?: string | null, planVariantName?: string | null, quantity?: number | null, startDate?: string | null, endDate?: string | null, billingSuspended: boolean, dunningLevel?: number | null, dunningRemaining?: number | null, dunningSince?: string | null, customer: { __typename?: 'FinanceCustomerRef', id: string, name?: string | null, debitorAccount?: string | null, url?: string | null }, accounts: Array<{ __typename?: 'FinanceAccountRef', salesforceId: string, name?: string | null, url: string }> }> } };

export type CrmDuplicateRecordFieldsFragment = { __typename?: 'CrmDuplicateRecord', object: CrmObject, salesforceId: string, kind: string, name: string, createdAt?: any | null, createdByName?: string | null, company?: string | null, email?: string | null, phone?: string | null, addresses: Array<{ __typename?: 'CrmDuplicateAddress', street?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }>, normalized: { __typename?: 'CrmDuplicateNormalizedRecord', name?: string | null, company?: string | null, email?: string | null, phone?: { __typename?: 'CrmDuplicatePhone', base: string, extension?: string | null } | null, addresses: Array<{ __typename?: 'CrmDuplicateNormalizedAddress', street?: string | null, house?: string | null, unit?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }> } };

export type CrmDuplicateCandidateFieldsFragment = { __typename?: 'CrmDuplicateCandidate', id: string, fingerprint: string, score: number, status: CrmDuplicateStatus, reviewedAt?: any | null, reasons: Array<{ __typename?: 'CrmDuplicateReason', code: string, similarity?: number | null }>, left: { __typename?: 'CrmDuplicateRecord', object: CrmObject, salesforceId: string, kind: string, name: string, createdAt?: any | null, createdByName?: string | null, company?: string | null, email?: string | null, phone?: string | null, addresses: Array<{ __typename?: 'CrmDuplicateAddress', street?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }>, normalized: { __typename?: 'CrmDuplicateNormalizedRecord', name?: string | null, company?: string | null, email?: string | null, phone?: { __typename?: 'CrmDuplicatePhone', base: string, extension?: string | null } | null, addresses: Array<{ __typename?: 'CrmDuplicateNormalizedAddress', street?: string | null, house?: string | null, unit?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }> } }, right: { __typename?: 'CrmDuplicateRecord', object: CrmObject, salesforceId: string, kind: string, name: string, createdAt?: any | null, createdByName?: string | null, company?: string | null, email?: string | null, phone?: string | null, addresses: Array<{ __typename?: 'CrmDuplicateAddress', street?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }>, normalized: { __typename?: 'CrmDuplicateNormalizedRecord', name?: string | null, company?: string | null, email?: string | null, phone?: { __typename?: 'CrmDuplicatePhone', base: string, extension?: string | null } | null, addresses: Array<{ __typename?: 'CrmDuplicateNormalizedAddress', street?: string | null, house?: string | null, unit?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }> } } };

export type CustomerServiceCrmDuplicatesQueryVariables = Exact<{
  input?: InputMaybe<CrmDuplicateListInput>;
}>;


export type CustomerServiceCrmDuplicatesQuery = { __typename?: 'Query', customerServiceCrmDuplicates: { __typename?: 'CrmDuplicateList', totalCount: number, scannedAt?: any | null, scanState: CrmDuplicateScanState, candidates: Array<{ __typename?: 'CrmDuplicateCandidate', id: string, fingerprint: string, score: number, status: CrmDuplicateStatus, reviewedAt?: any | null, reasons: Array<{ __typename?: 'CrmDuplicateReason', code: string, similarity?: number | null }>, left: { __typename?: 'CrmDuplicateRecord', object: CrmObject, salesforceId: string, kind: string, name: string, createdAt?: any | null, createdByName?: string | null, company?: string | null, email?: string | null, phone?: string | null, addresses: Array<{ __typename?: 'CrmDuplicateAddress', street?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }>, normalized: { __typename?: 'CrmDuplicateNormalizedRecord', name?: string | null, company?: string | null, email?: string | null, phone?: { __typename?: 'CrmDuplicatePhone', base: string, extension?: string | null } | null, addresses: Array<{ __typename?: 'CrmDuplicateNormalizedAddress', street?: string | null, house?: string | null, unit?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }> } }, right: { __typename?: 'CrmDuplicateRecord', object: CrmObject, salesforceId: string, kind: string, name: string, createdAt?: any | null, createdByName?: string | null, company?: string | null, email?: string | null, phone?: string | null, addresses: Array<{ __typename?: 'CrmDuplicateAddress', street?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }>, normalized: { __typename?: 'CrmDuplicateNormalizedRecord', name?: string | null, company?: string | null, email?: string | null, phone?: { __typename?: 'CrmDuplicatePhone', base: string, extension?: string | null } | null, addresses: Array<{ __typename?: 'CrmDuplicateNormalizedAddress', street?: string | null, house?: string | null, unit?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null }> } } }> } };

export type LogisticsInventoryQueryVariables = Exact<{
  input: LogisticsInventoryInput;
}>;


export type LogisticsInventoryQuery = { __typename?: 'Query', logisticsInventory: { __typename?: 'LogisticsInventoryList', totalCount: number, syncedAt?: any | null, deviceFilterSources: Array<{ __typename?: 'LogisticsInventoryDeviceFilterSource', provider: LogisticsInventoryDeviceFilterProvider, state: LogisticsInventoryDeviceFilterSourceState, syncedAt?: any | null, stale?: boolean | null }>, counts: Array<{ __typename?: 'LogisticsInventoryCount', type?: string | null, status?: string | null, count: number }>, stock: Array<{ __typename?: 'LogisticsInventoryStock', type?: string | null, free: number, readyToShip?: number | null, needsStaging?: number | null, inStockAtClient: number }>, rows: Array<{ __typename?: 'LogisticsInventoryRow', id: any, name?: string | null, type?: string | null, status?: string | null, imei?: string | null, serialNumber?: string | null, hardwareSerialNumber?: string | null, simIccid?: string | null, appVersion?: string | null, qualityCheckDoneAt?: any | null, lastInStockAt?: any | null, deletedInSalesforceAt?: any | null, simProvider?: { __typename?: 'LogisticsSimProvider', listed: boolean, status?: string | null, connectivityStatus?: string | null, lastOnlineAt?: any | null } | null, hexnode?: { __typename?: 'LogisticsHexnodeDevice', state: LogisticsHexnodeState, deviceId?: string | null, url?: string | null, enrollmentStatus?: string | null, active?: boolean | null, lastSeenAt?: any | null, syncedAt?: any | null, stale: boolean } | null, workspaceOne?: { __typename?: 'LogisticsWorkspaceOneMatch', state: LogisticsWorkspaceOneMatchState, syncedAt?: any | null, stale: boolean, device?: { __typename?: 'LogisticsWorkspaceOneDevice', deviceId: string, deviceUuid: string, imei?: string | null, serialNumber?: string | null, name?: string | null, model?: string | null, operatingSystem?: string | null, organizationGroupName?: string | null, enrollmentStatus?: string | null, complianceStatus?: string | null, lastSeenAt?: any | null, url: string, apps: Array<{ __typename?: 'LogisticsWorkspaceOneApp', bundleId: string, appUuid: string, installedVersion?: string | null, assignedVersion?: string | null, installedStatus?: string | null, assignmentStatus?: string | null, lastReportedAt?: any | null }> } | null } | null }> } };

export type LogisticsInventoryItemQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LogisticsInventoryItemQuery = { __typename?: 'Query', logisticsInventoryItem?: { __typename?: 'LogisticsInventoryItem', id: any, salesforceUrl?: string | null, name?: string | null, type?: string | null, status?: string | null, inactiveReason?: string | null, inactiveDate?: any | null, imei?: string | null, serialNumber?: string | null, hardwareSerialNumber?: string | null, simIccid?: string | null, newDevice?: boolean | null, lastInStockAt?: any | null, lastInTransferAt?: any | null, appVersion?: string | null, appFlavour?: string | null, contentVersion?: string | null, createdAt?: any | null, modifiedAt?: any | null, deletedInSalesforceAt?: any | null, simProvider?: { __typename?: 'LogisticsSimProvider', listed: boolean, status?: string | null, connectivityStatus?: string | null, lastOnlineAt?: any | null, scannedAt: any, checkedAt?: any | null } | null, hexnode?: { __typename?: 'LogisticsHexnodeDevice', state: LogisticsHexnodeState, deviceId?: string | null, url?: string | null, enrollmentStatus?: string | null, active?: boolean | null, lastSeenAt?: any | null, syncedAt?: any | null, stale: boolean } | null, workspaceOne?: { __typename?: 'LogisticsWorkspaceOneMatch', state: LogisticsWorkspaceOneMatchState, syncedAt?: any | null, stale: boolean, device?: { __typename?: 'LogisticsWorkspaceOneDevice', deviceId: string, deviceUuid: string, imei?: string | null, serialNumber?: string | null, name?: string | null, model?: string | null, operatingSystem?: string | null, organizationGroupName?: string | null, enrollmentStatus?: string | null, complianceStatus?: string | null, lastSeenAt?: any | null, url: string, apps: Array<{ __typename?: 'LogisticsWorkspaceOneApp', bundleId: string, appUuid: string, installedVersion?: string | null, assignedVersion?: string | null, installedStatus?: string | null, assignmentStatus?: string | null, lastReportedAt?: any | null }> } | null } | null, qualityCheck: { __typename?: 'LogisticsQualityCheck', doneAt?: any | null, doneBy?: string | null, sticker?: boolean | null, mdmRemoved?: boolean | null, knoxRemoved?: boolean | null, noOpenAndroidUpdates?: boolean | null, unknownSourcesAllowed?: boolean | null, accessPointConfigured?: boolean | null, roamingActive?: boolean | null, screenTimeout30Min?: boolean | null, appAsStartApp?: boolean | null, cameraInAppAllowed?: boolean | null }, location?: { __typename?: 'LogisticsInventoryLocation', accountSalesforceId: string, accountName?: string | null, contractSalesforceId?: string | null, contractNumber?: string | null, contractItemSalesforceId?: string | null, contractItemName?: string | null, contractItemStatus?: string | null, atClientDate?: any | null, asset?: { __typename?: 'LogisticsInventoryAsset', salesforceUrl?: string | null, name?: string | null, assetType?: string | null, slot: LogisticsAssetSlot, latestOrder?: { __typename?: 'LogisticsAssetOrder', salesforceId?: string | null, orderNumber?: string | null, name?: string | null, recordType?: string | null, status?: string | null, shippingDate?: any | null, completedDate?: any | null } | null } | null } | null, history: Array<{ __typename?: 'LogisticsInventoryHistoryEntry', salesforceId?: string | null, accountSalesforceId?: string | null, accountName?: string | null, contractSalesforceId?: string | null, contractNumber?: string | null, contractItemSalesforceId?: string | null, contractItemName?: string | null, shippingDate?: any | null, atClientDate?: any | null, removedFromClientDate?: any | null, inStockDate?: any | null, endUserChange?: boolean | null, deletedInSalesforceAt?: any | null }> } | null };

export type LogisticsWhereverSimDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LogisticsWhereverSimDetailsQuery = { __typename?: 'Query', logisticsWhereverSimDetails: { __typename?: 'LogisticsWhereverSimDetails', state: LogisticsWhereverSimDetailsState, sim?: { __typename?: 'LogisticsWhereverSimSection', data?: any | null, errorCode?: string | null } | null, endpoint?: { __typename?: 'LogisticsWhereverSimSection', data?: any | null, errorCode?: string | null } | null, connectivity?: { __typename?: 'LogisticsWhereverSimSection', data?: any | null, errorCode?: string | null } | null } };

export type ContentAnalyticsReportQueryVariables = Exact<{
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  mode: ContentAnalyticsMode;
  contentKind?: InputMaybe<Scalars['String']['input']>;
  contentSubtype?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ContentAnalyticsReportQuery = { __typename?: 'Query', contentAnalyticsReport: { __typename?: 'ContentAnalyticsReport', periodStart: any, periodEnd: any, latestDataDate?: any | null, contentTypes: Array<string>, contentSubtypes: Array<string>, totalCount: number, usedCount: number, unusedCount: number, overview: Array<{ __typename?: 'ContentAnalyticsOverviewItem', contentKind: string, sessionCount: any, completedSessionCount: any, unfinishedSessionCount: any }>, items: Array<{ __typename?: 'ContentAnalyticsItem', contentId: any, title: string, contentKind: string, contentSubtype?: string | null, thumbnailFilename?: string | null, sessionCount: any, completedSessionCount: any, unfinishedSessionCount: any }> } };

export type AccountBillingInvoicesFieldsFragment = { __typename?: 'AccountBillingInvoicePage', nextCursor?: string | null, items: Array<{ __typename?: 'AccountBillingInvoice', id: string, number?: string | null, documentDate: any, dueDate?: any | null, totalGross: string, currency: string }> };

export type AccountBillingProfileFieldsFragment = { __typename?: 'AccountBillingProfile', id: string, displayName?: string | null, externalCustomerId?: string | null, debtorAccount?: string | null, email?: string | null, phone?: string | null, vatId?: string | null, buyerReference?: string | null, deliveryMethod?: string | null, address?: { __typename?: 'AccountBillingAddress', addressLine1?: string | null, addressLine2?: string | null, street?: string | null, houseNumber?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null } | null };

export type AccountBillingSubscriptionsFieldsFragment = { __typename?: 'AccountBillingSubscriptionPage', nextCursor?: string | null, items: Array<{ __typename?: 'AccountBillingSubscription', id: string, lifecycleStatus?: string | null, planVariantId?: string | null, planName?: string | null, startDate?: any | null, endDate?: any | null, lastBillingDate?: any | null, nextBillingDate?: any | null, billedUntil?: any | null, currency?: string | null, balance?: string | null, paymentMethod?: string | null, billingSuspended?: boolean | null, recurringPaymentsPaused?: boolean | null, billingPeriod?: { __typename?: 'AccountBillingPeriod', unit?: string | null, quantity?: number | null } | null, dunning?: { __typename?: 'AccountBillingDunning', level?: number | null, remaining?: string | null, since?: any | null } | null }> };

export type AccountBillingLedgerFieldsFragment = { __typename?: 'AccountBillingLedgerPage', nextCursor?: string | null, items: Array<{ __typename?: 'AccountBillingLedgerEntry', id: string, contractId?: string | null, timestamp?: any | null, type?: string | null, description?: string | null, amount?: string | null, currency?: string | null, paymentTransactionStatus?: string | null, paymentStatus?: string | null, invoiceId?: string | null }> };

export type AccountBillingQueryVariables = Exact<{
  salesforceId: Scalars['String']['input'];
}>;


export type AccountBillingQuery = { __typename?: 'Query', customerServiceAccountBilling: { __typename?: 'CrmAccountBilling', availability: AccountBillingAvailability, matchingReason?: BillwerkCustomerMatchReason | null, account: { __typename?: 'AccountBillingAccount', salesforceId: string, name?: string | null }, billedThrough?: { __typename?: 'AccountBillingAccount', salesforceId: string, name?: string | null } | null, customer?: { __typename?: 'AccountBillingCustomer', id: string, displayName?: string | null, externalCustomerId?: string | null, debtorAccount?: string | null, url: string } | null, invoices?: { __typename?: 'AccountBillingInvoicePage', nextCursor?: string | null, items: Array<{ __typename?: 'AccountBillingInvoice', id: string, number?: string | null, documentDate: any, dueDate?: any | null, totalGross: string, currency: string }> } | null, profile?: { __typename?: 'AccountBillingProfile', id: string, displayName?: string | null, externalCustomerId?: string | null, debtorAccount?: string | null, email?: string | null, phone?: string | null, vatId?: string | null, buyerReference?: string | null, deliveryMethod?: string | null, address?: { __typename?: 'AccountBillingAddress', addressLine1?: string | null, addressLine2?: string | null, street?: string | null, houseNumber?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null } | null } | null, subscriptions?: { __typename?: 'AccountBillingSubscriptionPage', nextCursor?: string | null, items: Array<{ __typename?: 'AccountBillingSubscription', id: string, lifecycleStatus?: string | null, planVariantId?: string | null, planName?: string | null, startDate?: any | null, endDate?: any | null, lastBillingDate?: any | null, nextBillingDate?: any | null, billedUntil?: any | null, currency?: string | null, balance?: string | null, paymentMethod?: string | null, billingSuspended?: boolean | null, recurringPaymentsPaused?: boolean | null, billingPeriod?: { __typename?: 'AccountBillingPeriod', unit?: string | null, quantity?: number | null } | null, dunning?: { __typename?: 'AccountBillingDunning', level?: number | null, remaining?: string | null, since?: any | null } | null }> } | null, ledger?: { __typename?: 'AccountBillingLedgerPage', nextCursor?: string | null, items: Array<{ __typename?: 'AccountBillingLedgerEntry', id: string, contractId?: string | null, timestamp?: any | null, type?: string | null, description?: string | null, amount?: string | null, currency?: string | null, paymentTransactionStatus?: string | null, paymentStatus?: string | null, invoiceId?: string | null }> } | null } };

export type AccountBillingInvoicesQueryVariables = Exact<{
  salesforceId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountBillingInvoicesQuery = { __typename?: 'Query', customerServiceAccountBilling: { __typename?: 'CrmAccountBilling', availability: AccountBillingAvailability, matchingReason?: BillwerkCustomerMatchReason | null, billedThrough?: { __typename?: 'AccountBillingAccount', salesforceId: string } | null, customer?: { __typename?: 'AccountBillingCustomer', id: string } | null, invoices?: { __typename?: 'AccountBillingInvoicePage', nextCursor?: string | null, items: Array<{ __typename?: 'AccountBillingInvoice', id: string, number?: string | null, documentDate: any, dueDate?: any | null, totalGross: string, currency: string }> } | null } };

export type AccountBillingProfileQueryVariables = Exact<{
  salesforceId: Scalars['String']['input'];
}>;


export type AccountBillingProfileQuery = { __typename?: 'Query', customerServiceAccountBilling: { __typename?: 'CrmAccountBilling', availability: AccountBillingAvailability, matchingReason?: BillwerkCustomerMatchReason | null, billedThrough?: { __typename?: 'AccountBillingAccount', salesforceId: string } | null, customer?: { __typename?: 'AccountBillingCustomer', id: string } | null, profile?: { __typename?: 'AccountBillingProfile', id: string, displayName?: string | null, externalCustomerId?: string | null, debtorAccount?: string | null, email?: string | null, phone?: string | null, vatId?: string | null, buyerReference?: string | null, deliveryMethod?: string | null, address?: { __typename?: 'AccountBillingAddress', addressLine1?: string | null, addressLine2?: string | null, street?: string | null, houseNumber?: string | null, postalCode?: string | null, city?: string | null, state?: string | null, country?: string | null } | null } | null } };

export type AccountBillingSubscriptionsQueryVariables = Exact<{
  salesforceId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountBillingSubscriptionsQuery = { __typename?: 'Query', customerServiceAccountBilling: { __typename?: 'CrmAccountBilling', availability: AccountBillingAvailability, matchingReason?: BillwerkCustomerMatchReason | null, billedThrough?: { __typename?: 'AccountBillingAccount', salesforceId: string } | null, customer?: { __typename?: 'AccountBillingCustomer', id: string } | null, subscriptions?: { __typename?: 'AccountBillingSubscriptionPage', nextCursor?: string | null, items: Array<{ __typename?: 'AccountBillingSubscription', id: string, lifecycleStatus?: string | null, planVariantId?: string | null, planName?: string | null, startDate?: any | null, endDate?: any | null, lastBillingDate?: any | null, nextBillingDate?: any | null, billedUntil?: any | null, currency?: string | null, balance?: string | null, paymentMethod?: string | null, billingSuspended?: boolean | null, recurringPaymentsPaused?: boolean | null, billingPeriod?: { __typename?: 'AccountBillingPeriod', unit?: string | null, quantity?: number | null } | null, dunning?: { __typename?: 'AccountBillingDunning', level?: number | null, remaining?: string | null, since?: any | null } | null }> } | null } };

export type AccountBillingLedgerQueryVariables = Exact<{
  salesforceId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountBillingLedgerQuery = { __typename?: 'Query', customerServiceAccountBilling: { __typename?: 'CrmAccountBilling', availability: AccountBillingAvailability, matchingReason?: BillwerkCustomerMatchReason | null, billedThrough?: { __typename?: 'AccountBillingAccount', salesforceId: string } | null, customer?: { __typename?: 'AccountBillingCustomer', id: string } | null, ledger?: { __typename?: 'AccountBillingLedgerPage', nextCursor?: string | null, items: Array<{ __typename?: 'AccountBillingLedgerEntry', id: string, contractId?: string | null, timestamp?: any | null, type?: string | null, description?: string | null, amount?: string | null, currency?: string | null, paymentTransactionStatus?: string | null, paymentStatus?: string | null, invoiceId?: string | null }> } | null } };

export type LogisticsWorkspaceOneDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type LogisticsWorkspaceOneDevicesQuery = { __typename?: 'Query', logisticsWorkspaceOneDevices: { __typename?: 'LogisticsWorkspaceOneOverview', state: LogisticsWorkspaceOneFleetState, syncedAt?: any | null, stale: boolean, devices: Array<{ __typename?: 'LogisticsWorkspaceOneOverviewDevice', matchState: LogisticsWorkspaceOneMatchState, contradictions: Array<LogisticsWorkspaceOneContradiction>, device: { __typename?: 'LogisticsWorkspaceOneDevice', deviceId: string, deviceUuid: string, imei?: string | null, serialNumber?: string | null, name?: string | null, model?: string | null, operatingSystem?: string | null, organizationGroupName?: string | null, enrollmentStatus?: string | null, complianceStatus?: string | null, lastSeenAt?: any | null, url: string, apps: Array<{ __typename?: 'LogisticsWorkspaceOneApp', bundleId: string, appUuid: string, installedVersion?: string | null, assignedVersion?: string | null, installedStatus?: string | null, assignmentStatus?: string | null, lastReportedAt?: any | null }> }, inventory?: { __typename?: 'LogisticsWorkspaceOneInventoryUnit', id: any, name?: string | null, hardwareSerialNumber?: string | null, deletedInSalesforceAt?: any | null } | null, customer?: { __typename?: 'LogisticsWorkspaceOneCustomer', accountSalesforceId: string, accountName?: string | null } | null }> } };

export type LogisticsDhlShippingSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type LogisticsDhlShippingSettingsQuery = { __typename?: 'Query', logisticsDhlShippingSettings: { __typename?: 'LogisticsDhlShippingSettings', labelPrintFormat: string, returnLabelPrintFormat: string, labelPrintFormats: Array<string>, returnLabelPrintFormats: Array<string>, missingSettings: Array<LogisticsDhlSetting>, updatedAt?: any | null, shipper?: { __typename?: 'LogisticsDhlAddress', name: string, street: string, postalCode: string, city: string } | null, returnAddress?: { __typename?: 'LogisticsDhlAddress', name: string, street: string, postalCode: string, city: string } | null } };

export type LogisticsDhlAccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type LogisticsDhlAccountSettingsQuery = { __typename?: 'Query', logisticsDhlAccountSettings: { __typename?: 'LogisticsDhlAccountSettings', gateway: LogisticsDhlGateway, clientId?: string | null, hasClientSecret: boolean, username?: string | null, hasPassword: boolean, billingNumberPaket?: string | null, billingNumberPaketInternational?: string | null, billingNumberRetoure?: string | null, returnReceiverIdAustria?: string | null, missingSettings: Array<LogisticsDhlSetting>, updatedAt?: any | null } };

export type LogisticsOrderCommandStatusQueryVariables = Exact<{
  salesforceId: Scalars['String']['input'];
}>;


export type LogisticsOrderCommandStatusQuery = { __typename?: 'Query', logisticsOrderCommandStatus?: { __typename?: 'LogisticsOrderCommandStatus', orderId: any, commandId: any, state: LogisticsOrderCommandState, refusal?: string | null, messages: Array<string> } | null };

export type LogisticsShippingLabelStateQueryVariables = Exact<{
  salesforceId: Scalars['String']['input'];
}>;


export type LogisticsShippingLabelStateQuery = { __typename?: 'Query', logisticsShippingLabelState?: { __typename?: 'LogisticsShippingLabelState', orderId: any, enabled: boolean, pilot: boolean, refusal?: string | null, label?: { __typename?: 'LogisticsShippingLabel', id: any, orderId: any, product: string, shipmentNumber: string, returnShipmentNumber?: string | null, printFormat: string, returnPrintFormat?: string | null, weightKg: number, createdAt: any, cancelledAt?: any | null, labelPdf: string, returnLabelPdf?: string | null } | null, attempt?: { __typename?: 'LogisticsShippingLabelAttempt', requestId?: any | null, command: string, labelId?: any | null, returnLabel?: boolean | null, outcome: LogisticsShippingLabelPilotOutcome, refusal?: string | null, messages: Array<string>, salesforceCommandId?: any | null } | null } | null };

export const LogisticsHexnodeDeviceFragmentDoc = gql`
    fragment LogisticsHexnodeDevice on LogisticsHexnodeDevice {
  state
  deviceId
  url
  enrollmentStatus
  active
  lastSeenAt
  syncedAt
  stale
}
    `;
export const LogisticsWorkspaceOneAppFragmentDoc = gql`
    fragment LogisticsWorkspaceOneApp on LogisticsWorkspaceOneApp {
  bundleId
  appUuid
  installedVersion
  assignedVersion
  installedStatus
  assignmentStatus
  lastReportedAt
}
    `;
export const LogisticsWorkspaceOneDeviceFragmentDoc = gql`
    fragment LogisticsWorkspaceOneDevice on LogisticsWorkspaceOneDevice {
  deviceId
  deviceUuid
  imei
  serialNumber
  name
  model
  operatingSystem
  organizationGroupName
  enrollmentStatus
  complianceStatus
  lastSeenAt
  url
  apps {
    ...LogisticsWorkspaceOneApp
  }
}
    ${LogisticsWorkspaceOneAppFragmentDoc}`;
export const LogisticsWorkspaceOneMatchFragmentDoc = gql`
    fragment LogisticsWorkspaceOneMatch on LogisticsWorkspaceOneMatch {
  state
  syncedAt
  stale
  device {
    ...LogisticsWorkspaceOneDevice
  }
}
    ${LogisticsWorkspaceOneDeviceFragmentDoc}`;
export const SalesforceReportSectionFragmentDoc = gql`
    fragment SalesforceReportSection on SalesforceReportSection {
  reportId
  type
  format
  source
  dateRange {
    field
    relative
    lastDays
    from
    to
  }
  filters {
    field
    operator
    values
  }
  filterLogic
  linkedFilters {
    field
    operator
    values
  }
  down {
    field
    granularity
    descending
    link {
      kind
      object
    }
  }
  across {
    field
    granularity
    descending
    link {
      kind
      object
    }
  }
  summaries {
    aggregate
    field
    formula
  }
  columns {
    field
    type
    link {
      kind
      object
    }
  }
  showSubtotals
  showGrandTotal
  groups {
    down {
      value
      label
    }
    across {
      value
      label
    }
    count
    values
  }
  rows {
    down {
      value
      label
    }
    values
    links
  }
  hasMoreRows
  rowLimit
  chart
  chartGroupings {
    field
    granularity
  }
  chartMeasures {
    aggregate
    field
  }
  chartPoints {
    group
    series
    values
  }
  lastSyncedAt
  unreadableFields
  blockKey
  unavailable
  missingFields
  pendingObjects
  chartUnavailable
  chartMissingFields
  chartPendingObjects
  showValues
  sortLegendValues
}
    `;
export const LogisticsDhlShippingSettingsFieldsFragmentDoc = gql`
    fragment LogisticsDhlShippingSettingsFields on LogisticsDhlShippingSettings {
  shipper {
    name
    street
    postalCode
    city
  }
  returnAddress {
    name
    street
    postalCode
    city
  }
  labelPrintFormat
  returnLabelPrintFormat
  labelPrintFormats
  returnLabelPrintFormats
  missingSettings
  updatedAt
}
    `;
export const LogisticsDhlAccountSettingsFieldsFragmentDoc = gql`
    fragment LogisticsDhlAccountSettingsFields on LogisticsDhlAccountSettings {
  gateway
  clientId
  hasClientSecret
  username
  hasPassword
  billingNumberPaket
  billingNumberPaketInternational
  billingNumberRetoure
  returnReceiverIdAustria
  missingSettings
  updatedAt
}
    `;
export const LogisticsShippingLabelFieldsFragmentDoc = gql`
    fragment LogisticsShippingLabelFields on LogisticsShippingLabel {
  id
  orderId
  product
  shipmentNumber
  returnShipmentNumber
  printFormat
  returnPrintFormat
  weightKg
  createdAt
  cancelledAt
  labelPdf
  returnLabelPdf
}
    `;
export const ManagerLearningAssignmentFieldsFragmentDoc = gql`
    fragment ManagerLearningAssignmentFields on LearningAssignment {
  id
  organizationId
  userId
  itemKind
  courseId
  learningPathId
  learningPathVersion
  kind
  assignedBy
  assignedAt
  unassignedBy
  unassignedAt
  active
  enrollmentIds
}
    `;
export const DocumentationSyncFieldsFragmentDoc = gql`
    fragment DocumentationSyncFields on DocumentationSync {
  id
  kind
  seniorId
  provider
  status
  skipReason
  attempts
  lastError
  sentAt
  outcomeAt
  updatedAt
}
    `;
export const SalesforceIntegrationFieldsFragmentDoc = gql`
    fragment SalesforceIntegrationFields on SalesforceIntegration {
  loginUrl
  clientId
  hasClientSecret
  anonymize
  anonymizationRequired
  schedule
  dailyTime
  intervalHours
  windowStart
  windowEnd
  windowIntervalMinutes
  outsideIntervalHours
  updatedAt
  nextRunAt
}
    `;
export const MarketingDeliverySettingsFieldsFragmentDoc = gql`
    fragment MarketingDeliverySettingsFields on MarketingDeliverySettings {
  availableProviders {
    type
    name
  }
  provider
  hasApiKey
  hasApiSecret
  hasWebhookSecret
  sendingDomain
  fromAddress
  fromName
  replyToAddress
  updatedAt
  recipientsRestricted
  allowedRecipients
}
    `;
export const DeviceEnrollmentTokenFieldsFragmentDoc = gql`
    fragment DeviceEnrollmentTokenFields on DeviceEnrollmentToken {
  id
  organizationId
  scopeType
  scopeLocation {
    id
    name
    type
  }
  expiresAt
  maxUses
  useCount
  status
  implicit
  createdBy {
    id
    name
  }
  createdAt
  revokedAt
  redemptions {
    id
    redeemedAt
    targetLocation {
      id
      name
      type
    }
    device {
      id
      deviceId
      name
      model
      manufacturer
      status
    }
  }
  emailDeliveries {
    id
    recipientEmail
    queuedAt
    sentAt
    failedAt
    status
    sentBy {
      id
      name
    }
  }
}
    `;
export const PlacetelPhoneAccountFieldsFragmentDoc = gql`
    fragment PlacetelPhoneAccountFields on PlacetelPhoneAccount {
  available
  connected
  email
  connectedAt
}
    `;
export const CrmValueFieldsFragmentDoc = gql`
    fragment CrmValueFields on CrmValue {
  key
  type
  value
  referenceObject
  referenceTitle
}
    `;
export const CrmRowFieldsFragmentDoc = gql`
    fragment CrmRowFields on CrmRow {
  salesforceId
  title
  deletedInSalesforceAt
  values {
    ...CrmValueFields
  }
}
    ${CrmValueFieldsFragmentDoc}`;
export const CrmInventoryUnitFieldsFragmentDoc = gql`
    fragment CrmInventoryUnitFields on CrmInventoryUnit {
  id
  name
  type
  status
  imei
  serialNumber
  hardwareSerialNumber
  simIccid
  deletedInSalesforceAt
}
    `;
export const BillwerkPlanVariantFieldsFragmentDoc = gql`
    fragment BillwerkPlanVariantFields on BillwerkPlanVariant {
  state
  planVariantId
  name
  hidden
  url
  billwerkPlanId
  priceBookId
  priceBookName
}
    `;
export const FinanceContractItemFieldsFragmentDoc = gql`
    fragment FinanceContractItemFields on FinanceContractItem {
  salesforceId
  salesforceUrl
  name
  status
  contractNumber
  accountName
  accountRecordType
  productName
  price
  startDate
  endDate
  billingStartDate
  billingTool
  billingStarted
  billingStopped
  cancellationType
  cancellationDate
  lostReason
  planVariant {
    ...BillwerkPlanVariantFields
  }
}
    ${BillwerkPlanVariantFieldsFragmentDoc}`;
export const BillwerkMatchAccountFieldsFragmentDoc = gql`
    fragment BillwerkMatchAccountFields on BillwerkMatchAccount {
  salesforceId
  name
  recordType
  b2c
  debitorAccount
  oldCustomerNumber
  billed
}
    `;
export const FinanceAccountRefFieldsFragmentDoc = gql`
    fragment FinanceAccountRefFields on FinanceAccountRef {
  salesforceId
  name
  url
}
    `;
export const FinanceCustomerRefFieldsFragmentDoc = gql`
    fragment FinanceCustomerRefFields on FinanceCustomerRef {
  id
  name
  debitorAccount
  url
}
    `;
export const CrmDuplicateRecordFieldsFragmentDoc = gql`
    fragment CrmDuplicateRecordFields on CrmDuplicateRecord {
  object
  salesforceId
  kind
  name
  createdAt
  createdByName
  company
  email
  phone
  addresses {
    street
    city
    state
    postalCode
    country
  }
  normalized {
    name
    company
    email
    phone {
      base
      extension
    }
    addresses {
      street
      house
      unit
      city
      state
      postalCode
      country
    }
  }
}
    `;
export const CrmDuplicateCandidateFieldsFragmentDoc = gql`
    fragment CrmDuplicateCandidateFields on CrmDuplicateCandidate {
  id
  fingerprint
  score
  reasons {
    code
    similarity
  }
  status
  reviewedAt
  left {
    ...CrmDuplicateRecordFields
  }
  right {
    ...CrmDuplicateRecordFields
  }
}
    ${CrmDuplicateRecordFieldsFragmentDoc}`;
export const AccountBillingInvoicesFieldsFragmentDoc = gql`
    fragment AccountBillingInvoicesFields on AccountBillingInvoicePage {
  items {
    id
    number
    documentDate
    dueDate
    totalGross
    currency
  }
  nextCursor
}
    `;
export const AccountBillingProfileFieldsFragmentDoc = gql`
    fragment AccountBillingProfileFields on AccountBillingProfile {
  id
  displayName
  externalCustomerId
  debtorAccount
  email
  phone
  vatId
  buyerReference
  deliveryMethod
  address {
    addressLine1
    addressLine2
    street
    houseNumber
    postalCode
    city
    state
    country
  }
}
    `;
export const AccountBillingSubscriptionsFieldsFragmentDoc = gql`
    fragment AccountBillingSubscriptionsFields on AccountBillingSubscriptionPage {
  items {
    id
    lifecycleStatus
    planVariantId
    planName
    billingPeriod {
      unit
      quantity
    }
    startDate
    endDate
    lastBillingDate
    nextBillingDate
    billedUntil
    currency
    balance
    paymentMethod
    billingSuspended
    recurringPaymentsPaused
    dunning {
      level
      remaining
      since
    }
  }
  nextCursor
}
    `;
export const AccountBillingLedgerFieldsFragmentDoc = gql`
    fragment AccountBillingLedgerFields on AccountBillingLedgerPage {
  items {
    id
    contractId
    timestamp
    type
    description
    amount
    currency
    paymentTransactionStatus
    paymentStatus
    invoiceId
  }
  nextCursor
}
    `;
export const CreateBillingInvoiceDownloadDocument = gql`
    mutation CreateBillingInvoiceDownload($invoiceId: String!, $organizationId: UUID) {
  createBillingInvoiceDownload(
    invoiceId: $invoiceId
    organizationId: $organizationId
  ) {
    url
    expiresAt
  }
}
    `;
export type CreateBillingInvoiceDownloadMutationFn = Apollo.MutationFunction<CreateBillingInvoiceDownloadMutation, CreateBillingInvoiceDownloadMutationVariables>;
export type CreateBillingInvoiceDownloadMutationResult = Apollo.MutationResult<CreateBillingInvoiceDownloadMutation>;
export type CreateBillingInvoiceDownloadMutationOptions = Apollo.BaseMutationOptions<CreateBillingInvoiceDownloadMutation, CreateBillingInvoiceDownloadMutationVariables>;
export const SetOrganizationBillingAccessDocument = gql`
    mutation SetOrganizationBillingAccess($organizationId: UUID!, $accessEnabled: Boolean!, $expectedMappingVersion: UUID!) {
  setOrganizationBillingAccess(
    organizationId: $organizationId
    accessEnabled: $accessEnabled
    expectedMappingVersion: $expectedMappingVersion
  ) {
    organizationId
    accessEnabled
    mappingConfigured
    invoiceAccountConfigured
    salesforceAccountId
    salesforceAccountName
    frisbiiCustomerId
    mappingVersion
  }
}
    `;
export type SetOrganizationBillingAccessMutationFn = Apollo.MutationFunction<SetOrganizationBillingAccessMutation, SetOrganizationBillingAccessMutationVariables>;
export type SetOrganizationBillingAccessMutationResult = Apollo.MutationResult<SetOrganizationBillingAccessMutation>;
export type SetOrganizationBillingAccessMutationOptions = Apollo.BaseMutationOptions<SetOrganizationBillingAccessMutation, SetOrganizationBillingAccessMutationVariables>;
export const SetOrganizationBillingAccountDocument = gql`
    mutation SetOrganizationBillingAccount($organizationId: UUID!, $salesforceAccountId: String!, $frisbiiCustomerId: String, $expectedMappingVersion: UUID, $confirmed: Boolean!) {
  setOrganizationBillingAccount(
    organizationId: $organizationId
    salesforceAccountId: $salesforceAccountId
    frisbiiCustomerId: $frisbiiCustomerId
    expectedMappingVersion: $expectedMappingVersion
    confirmed: $confirmed
  ) {
    organizationId
    accessEnabled
    mappingConfigured
    invoiceAccountConfigured
    salesforceAccountId
    salesforceAccountName
    frisbiiCustomerId
    mappingVersion
  }
}
    `;
export type SetOrganizationBillingAccountMutationFn = Apollo.MutationFunction<SetOrganizationBillingAccountMutation, SetOrganizationBillingAccountMutationVariables>;
export type SetOrganizationBillingAccountMutationResult = Apollo.MutationResult<SetOrganizationBillingAccountMutation>;
export type SetOrganizationBillingAccountMutationOptions = Apollo.BaseMutationOptions<SetOrganizationBillingAccountMutation, SetOrganizationBillingAccountMutationVariables>;
export const StartLearningCourseDocument = gql`
    mutation StartLearningCourse($input: StartLearningCourseInput!) {
  startLearningCourse(input: $input) {
    courseId
    courseVersion
    effect
    startedAt
    payload
    progress {
      enrollmentId
      status
      completedAt
      bestScorePercent
      lessons {
        courseVersion
        lessonId
        completedAt
      }
      quizAttempts {
        id
        courseVersion
        serverScorePercent
        serverPassed
        finishedAt
      }
    }
  }
}
    `;
export type StartLearningCourseMutationFn = Apollo.MutationFunction<StartLearningCourseMutation, StartLearningCourseMutationVariables>;
export type StartLearningCourseMutationResult = Apollo.MutationResult<StartLearningCourseMutation>;
export type StartLearningCourseMutationOptions = Apollo.BaseMutationOptions<StartLearningCourseMutation, StartLearningCourseMutationVariables>;
export const CompleteLearningLessonDocument = gql`
    mutation CompleteLearningLesson($input: CompleteLearningLessonInput!) {
  completeLearningLesson(input: $input) {
    courseId
    courseVersion
    lessonId
    effect
    completedAt
    progress {
      enrollmentId
      status
      completedAt
      bestScorePercent
      lessons {
        courseVersion
        lessonId
        completedAt
      }
    }
  }
}
    `;
export type CompleteLearningLessonMutationFn = Apollo.MutationFunction<CompleteLearningLessonMutation, CompleteLearningLessonMutationVariables>;
export type CompleteLearningLessonMutationResult = Apollo.MutationResult<CompleteLearningLessonMutation>;
export type CompleteLearningLessonMutationOptions = Apollo.BaseMutationOptions<CompleteLearningLessonMutation, CompleteLearningLessonMutationVariables>;
export const SubmitLearningQuizAttemptDocument = gql`
    mutation SubmitLearningQuizAttempt($input: SubmitLearningQuizAttemptInput!) {
  submitLearningQuizAttempt(input: $input) {
    attemptId
    courseId
    courseVersion
    effect
    clientScorePercent
    clientPassed
    serverCorrect
    serverTotal
    serverScorePercent
    serverPassed
    startedAt
    finishedAt
    progress {
      enrollmentId
      status
      completedAt
      bestScorePercent
      quizAttempts {
        id
        courseVersion
        serverScorePercent
        serverPassed
        finishedAt
      }
    }
  }
}
    `;
export type SubmitLearningQuizAttemptMutationFn = Apollo.MutationFunction<SubmitLearningQuizAttemptMutation, SubmitLearningQuizAttemptMutationVariables>;
export type SubmitLearningQuizAttemptMutationResult = Apollo.MutationResult<SubmitLearningQuizAttemptMutation>;
export type SubmitLearningQuizAttemptMutationOptions = Apollo.BaseMutationOptions<SubmitLearningQuizAttemptMutation, SubmitLearningQuizAttemptMutationVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($input: CreateLocationInput!) {
  createLocation(input: $input) {
    location {
      id
      name
      externalId
      type
      status
      partOfId
      organization {
        id
        name
      }
    }
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($input: UpdateLocationInput!) {
  updateLocation(input: $input) {
    location {
      id
      name
      externalId
      type
      partOfId
    }
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const UpsertPatientDocument = gql`
    mutation UpsertPatient($input: UpsertPatientInput!) {
  upsertPatient(input: $input) {
    id
  }
}
    `;
export type UpsertPatientMutationFn = Apollo.MutationFunction<UpsertPatientMutation, UpsertPatientMutationVariables>;
export type UpsertPatientMutationResult = Apollo.MutationResult<UpsertPatientMutation>;
export type UpsertPatientMutationOptions = Apollo.BaseMutationOptions<UpsertPatientMutation, UpsertPatientMutationVariables>;
export const AddActivityGoalsDocument = gql`
    mutation AddActivityGoals($activityGoals: [ActivityGoalItem!]!) {
  addActivityGoals(input: {activityGoals: $activityGoals})
}
    `;
export type AddActivityGoalsMutationFn = Apollo.MutationFunction<AddActivityGoalsMutation, AddActivityGoalsMutationVariables>;
export type AddActivityGoalsMutationResult = Apollo.MutationResult<AddActivityGoalsMutation>;
export type AddActivityGoalsMutationOptions = Apollo.BaseMutationOptions<AddActivityGoalsMutation, AddActivityGoalsMutationVariables>;
export const UpsertPractitionerDocument = gql`
    mutation UpsertPractitioner($input: UpsertPractitionerInput!) {
  upsertPractitioner(input: $input) {
    id
    warningCode
  }
}
    `;
export type UpsertPractitionerMutationFn = Apollo.MutationFunction<UpsertPractitionerMutation, UpsertPractitionerMutationVariables>;
export type UpsertPractitionerMutationResult = Apollo.MutationResult<UpsertPractitionerMutation>;
export type UpsertPractitionerMutationOptions = Apollo.BaseMutationOptions<UpsertPractitionerMutation, UpsertPractitionerMutationVariables>;
export const UpsertLocationDocument = gql`
    mutation UpsertLocation($input: UpsertLocationInput!) {
  upsertLocation(input: $input) {
    id
  }
}
    `;
export type UpsertLocationMutationFn = Apollo.MutationFunction<UpsertLocationMutation, UpsertLocationMutationVariables>;
export type UpsertLocationMutationResult = Apollo.MutationResult<UpsertLocationMutation>;
export type UpsertLocationMutationOptions = Apollo.BaseMutationOptions<UpsertLocationMutation, UpsertLocationMutationVariables>;
export const CompleteOnboardingDocument = gql`
    mutation CompleteOnboarding($input: CompleteOnboardingInput!) {
  completeOnboarding(input: $input) {
    locationIds
    patientIds
    practitionerIds
  }
}
    `;
export type CompleteOnboardingMutationFn = Apollo.MutationFunction<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>;
export type CompleteOnboardingMutationResult = Apollo.MutationResult<CompleteOnboardingMutation>;
export type CompleteOnboardingMutationOptions = Apollo.BaseMutationOptions<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>;
export const ResetPractitionerPasswordOtpDocument = gql`
    mutation ResetPractitionerPasswordOTP($input: ResetPractitionerPasswordOTPInput!) {
  resetPractitionerPasswordOTP(input: $input) {
    warningCode
  }
}
    `;
export type ResetPractitionerPasswordOtpMutationFn = Apollo.MutationFunction<ResetPractitionerPasswordOtpMutation, ResetPractitionerPasswordOtpMutationVariables>;
export type ResetPractitionerPasswordOtpMutationResult = Apollo.MutationResult<ResetPractitionerPasswordOtpMutation>;
export type ResetPractitionerPasswordOtpMutationOptions = Apollo.BaseMutationOptions<ResetPractitionerPasswordOtpMutation, ResetPractitionerPasswordOtpMutationVariables>;
export const RevealPractitionerPasswordOtpDocument = gql`
    mutation RevealPractitionerPasswordOTP($input: RevealPractitionerPasswordOTPInput!) {
  revealPractitionerPasswordOTP(input: $input) {
    otp
    status
  }
}
    `;
export type RevealPractitionerPasswordOtpMutationFn = Apollo.MutationFunction<RevealPractitionerPasswordOtpMutation, RevealPractitionerPasswordOtpMutationVariables>;
export type RevealPractitionerPasswordOtpMutationResult = Apollo.MutationResult<RevealPractitionerPasswordOtpMutation>;
export type RevealPractitionerPasswordOtpMutationOptions = Apollo.BaseMutationOptions<RevealPractitionerPasswordOtpMutation, RevealPractitionerPasswordOtpMutationVariables>;
export const UpdateImportedPractitionerStatusDocument = gql`
    mutation UpdateImportedPractitionerStatus($input: UpdateImportedPractitionerStatusInput!) {
  updateImportedPractitionerStatus(input: $input) {
    id
    warningCode
  }
}
    `;
export type UpdateImportedPractitionerStatusMutationFn = Apollo.MutationFunction<UpdateImportedPractitionerStatusMutation, UpdateImportedPractitionerStatusMutationVariables>;
export type UpdateImportedPractitionerStatusMutationResult = Apollo.MutationResult<UpdateImportedPractitionerStatusMutation>;
export type UpdateImportedPractitionerStatusMutationOptions = Apollo.BaseMutationOptions<UpdateImportedPractitionerStatusMutation, UpdateImportedPractitionerStatusMutationVariables>;
export const SetupAccountPortalAccessDocument = gql`
    mutation SetupAccountPortalAccess($salesforceAccountId: String!) {
  setupAccountPortalAccess(salesforceAccountId: $salesforceAccountId)
}
    `;
export type SetupAccountPortalAccessMutationFn = Apollo.MutationFunction<SetupAccountPortalAccessMutation, SetupAccountPortalAccessMutationVariables>;
export type SetupAccountPortalAccessMutationResult = Apollo.MutationResult<SetupAccountPortalAccessMutation>;
export type SetupAccountPortalAccessMutationOptions = Apollo.BaseMutationOptions<SetupAccountPortalAccessMutation, SetupAccountPortalAccessMutationVariables>;
export const SetAccountAmbulantDocument = gql`
    mutation SetAccountAmbulant($salesforceAccountId: String!, $ambulant: Boolean!) {
  setAccountAmbulant(
    salesforceAccountId: $salesforceAccountId
    ambulant: $ambulant
  )
}
    `;
export type SetAccountAmbulantMutationFn = Apollo.MutationFunction<SetAccountAmbulantMutation, SetAccountAmbulantMutationVariables>;
export type SetAccountAmbulantMutationResult = Apollo.MutationResult<SetAccountAmbulantMutation>;
export type SetAccountAmbulantMutationOptions = Apollo.BaseMutationOptions<SetAccountAmbulantMutation, SetAccountAmbulantMutationVariables>;
export const InviteManagerDocument = gql`
    mutation InviteManager($salesforceAccountId: String!, $email: String!) {
  inviteManager(salesforceAccountId: $salesforceAccountId, email: $email)
}
    `;
export type InviteManagerMutationFn = Apollo.MutationFunction<InviteManagerMutation, InviteManagerMutationVariables>;
export type InviteManagerMutationResult = Apollo.MutationResult<InviteManagerMutation>;
export type InviteManagerMutationOptions = Apollo.BaseMutationOptions<InviteManagerMutation, InviteManagerMutationVariables>;
export const SetOrganizationSalesforceAccountDocument = gql`
    mutation SetOrganizationSalesforceAccount($salesforceAccountId: String!, $organizationId: UUID!) {
  setOrganizationSalesforceAccount(
    salesforceAccountId: $salesforceAccountId
    organizationId: $organizationId
  )
}
    `;
export type SetOrganizationSalesforceAccountMutationFn = Apollo.MutationFunction<SetOrganizationSalesforceAccountMutation, SetOrganizationSalesforceAccountMutationVariables>;
export type SetOrganizationSalesforceAccountMutationResult = Apollo.MutationResult<SetOrganizationSalesforceAccountMutation>;
export type SetOrganizationSalesforceAccountMutationOptions = Apollo.BaseMutationOptions<SetOrganizationSalesforceAccountMutation, SetOrganizationSalesforceAccountMutationVariables>;
export const CreateTestLicensingCustomerDocument = gql`
    mutation CreateTestLicensingCustomer($email: String!, $organizationName: String!, $managerName: String!) {
  createTestLicensingCustomer(
    email: $email
    organizationName: $organizationName
    managerName: $managerName
  )
}
    `;
export type CreateTestLicensingCustomerMutationFn = Apollo.MutationFunction<CreateTestLicensingCustomerMutation, CreateTestLicensingCustomerMutationVariables>;
export type CreateTestLicensingCustomerMutationResult = Apollo.MutationResult<CreateTestLicensingCustomerMutation>;
export type CreateTestLicensingCustomerMutationOptions = Apollo.BaseMutationOptions<CreateTestLicensingCustomerMutation, CreateTestLicensingCustomerMutationVariables>;
export const CreateUserWithValidationCodeDocument = gql`
    mutation CreateUserWithValidationCode($email: String!, $name: String!, $kind: UserType!, $password: String!, $code: String!, $organizationName: String) {
  createUserWithValidationCode(
    email: $email
    name: $name
    kind: $kind
    password: $password
    code: $code
    organizationName: $organizationName
  ) {
    jwtToken
  }
}
    `;
export type CreateUserWithValidationCodeMutationFn = Apollo.MutationFunction<CreateUserWithValidationCodeMutation, CreateUserWithValidationCodeMutationVariables>;
export type CreateUserWithValidationCodeMutationResult = Apollo.MutationResult<CreateUserWithValidationCodeMutation>;
export type CreateUserWithValidationCodeMutationOptions = Apollo.BaseMutationOptions<CreateUserWithValidationCodeMutation, CreateUserWithValidationCodeMutationVariables>;
export const SaveIntegrationSettingsDocument = gql`
    mutation SaveIntegrationSettings($organizationId: UUID!, $provider: IntegrationProvider!, $credentials: IntegrationCredentialsInput!) {
  saveIntegrationSettings(
    organizationId: $organizationId
    provider: $provider
    credentials: $credentials
  ) {
    organizationId
    hasClientSecret
    provider
    credentials {
      serverUrl
      clientId
      clientSecret
    }
  }
}
    `;
export type SaveIntegrationSettingsMutationFn = Apollo.MutationFunction<SaveIntegrationSettingsMutation, SaveIntegrationSettingsMutationVariables>;
export type SaveIntegrationSettingsMutationResult = Apollo.MutationResult<SaveIntegrationSettingsMutation>;
export type SaveIntegrationSettingsMutationOptions = Apollo.BaseMutationOptions<SaveIntegrationSettingsMutation, SaveIntegrationSettingsMutationVariables>;
export const UpdatePlacetelIntegrationDocument = gql`
    mutation UpdatePlacetelIntegration($input: PlacetelIntegrationInput!) {
  updatePlacetelIntegration(input: $input) {
    enabled
    organizationId
    clientId
    hasClientSecret
    hasRefreshToken
    hasWebhookSecret
    phoneClientId
    hasPhoneClientSecret
    updatedAt
  }
}
    `;
export type UpdatePlacetelIntegrationMutationFn = Apollo.MutationFunction<UpdatePlacetelIntegrationMutation, UpdatePlacetelIntegrationMutationVariables>;
export type UpdatePlacetelIntegrationMutationResult = Apollo.MutationResult<UpdatePlacetelIntegrationMutation>;
export type UpdatePlacetelIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdatePlacetelIntegrationMutation, UpdatePlacetelIntegrationMutationVariables>;
export const CheckPlacetelConnectionDocument = gql`
    mutation CheckPlacetelConnection {
  checkPlacetelConnection {
    ok
    accountName
    errorCode
    callHistory
  }
}
    `;
export type CheckPlacetelConnectionMutationFn = Apollo.MutationFunction<CheckPlacetelConnectionMutation, CheckPlacetelConnectionMutationVariables>;
export type CheckPlacetelConnectionMutationResult = Apollo.MutationResult<CheckPlacetelConnectionMutation>;
export type CheckPlacetelConnectionMutationOptions = Apollo.BaseMutationOptions<CheckPlacetelConnectionMutation, CheckPlacetelConnectionMutationVariables>;
export const UpdatePlacetelHotlineNumbersDocument = gql`
    mutation UpdatePlacetelHotlineNumbers($numbers: [String!]!) {
  updatePlacetelHotlineNumbers(numbers: $numbers)
}
    `;
export type UpdatePlacetelHotlineNumbersMutationFn = Apollo.MutationFunction<UpdatePlacetelHotlineNumbersMutation, UpdatePlacetelHotlineNumbersMutationVariables>;
export type UpdatePlacetelHotlineNumbersMutationResult = Apollo.MutationResult<UpdatePlacetelHotlineNumbersMutation>;
export type UpdatePlacetelHotlineNumbersMutationOptions = Apollo.BaseMutationOptions<UpdatePlacetelHotlineNumbersMutation, UpdatePlacetelHotlineNumbersMutationVariables>;
export const UpdatePlacetelOpeningHoursDocument = gql`
    mutation UpdatePlacetelOpeningHours($input: [PlacetelOpeningDayInput!]!) {
  updatePlacetelOpeningHours(input: $input) {
    weekday
    opens
    closes
  }
}
    `;
export type UpdatePlacetelOpeningHoursMutationFn = Apollo.MutationFunction<UpdatePlacetelOpeningHoursMutation, UpdatePlacetelOpeningHoursMutationVariables>;
export type UpdatePlacetelOpeningHoursMutationResult = Apollo.MutationResult<UpdatePlacetelOpeningHoursMutation>;
export type UpdatePlacetelOpeningHoursMutationOptions = Apollo.BaseMutationOptions<UpdatePlacetelOpeningHoursMutation, UpdatePlacetelOpeningHoursMutationVariables>;
export const BeginPlacetelPhoneSignInDocument = gql`
    mutation BeginPlacetelPhoneSignIn($redirectUri: String!) {
  beginPlacetelPhoneSignIn(redirectUri: $redirectUri) {
    authorizationUrl
  }
}
    `;
export type BeginPlacetelPhoneSignInMutationFn = Apollo.MutationFunction<BeginPlacetelPhoneSignInMutation, BeginPlacetelPhoneSignInMutationVariables>;
export type BeginPlacetelPhoneSignInMutationResult = Apollo.MutationResult<BeginPlacetelPhoneSignInMutation>;
export type BeginPlacetelPhoneSignInMutationOptions = Apollo.BaseMutationOptions<BeginPlacetelPhoneSignInMutation, BeginPlacetelPhoneSignInMutationVariables>;
export const CompletePlacetelPhoneSignInDocument = gql`
    mutation CompletePlacetelPhoneSignIn($input: CompletePlacetelPhoneSignInInput!) {
  completePlacetelPhoneSignIn(input: $input) {
    account {
      ...PlacetelPhoneAccountFields
    }
    errorCode
  }
}
    ${PlacetelPhoneAccountFieldsFragmentDoc}`;
export type CompletePlacetelPhoneSignInMutationFn = Apollo.MutationFunction<CompletePlacetelPhoneSignInMutation, CompletePlacetelPhoneSignInMutationVariables>;
export type CompletePlacetelPhoneSignInMutationResult = Apollo.MutationResult<CompletePlacetelPhoneSignInMutation>;
export type CompletePlacetelPhoneSignInMutationOptions = Apollo.BaseMutationOptions<CompletePlacetelPhoneSignInMutation, CompletePlacetelPhoneSignInMutationVariables>;
export const DisconnectPlacetelPhoneDocument = gql`
    mutation DisconnectPlacetelPhone {
  disconnectPlacetelPhone {
    ...PlacetelPhoneAccountFields
  }
}
    ${PlacetelPhoneAccountFieldsFragmentDoc}`;
export type DisconnectPlacetelPhoneMutationFn = Apollo.MutationFunction<DisconnectPlacetelPhoneMutation, DisconnectPlacetelPhoneMutationVariables>;
export type DisconnectPlacetelPhoneMutationResult = Apollo.MutationResult<DisconnectPlacetelPhoneMutation>;
export type DisconnectPlacetelPhoneMutationOptions = Apollo.BaseMutationOptions<DisconnectPlacetelPhoneMutation, DisconnectPlacetelPhoneMutationVariables>;
export const IssuePlacetelPhoneAccessTokenDocument = gql`
    mutation IssuePlacetelPhoneAccessToken($renew: Boolean) {
  issuePlacetelPhoneAccessToken(renew: $renew) {
    accessToken
    expiresAt
    errorCode
  }
}
    `;
export type IssuePlacetelPhoneAccessTokenMutationFn = Apollo.MutationFunction<IssuePlacetelPhoneAccessTokenMutation, IssuePlacetelPhoneAccessTokenMutationVariables>;
export type IssuePlacetelPhoneAccessTokenMutationResult = Apollo.MutationResult<IssuePlacetelPhoneAccessTokenMutation>;
export type IssuePlacetelPhoneAccessTokenMutationOptions = Apollo.BaseMutationOptions<IssuePlacetelPhoneAccessTokenMutation, IssuePlacetelPhoneAccessTokenMutationVariables>;
export const RecordPlacetelCallEventDocument = gql`
    mutation RecordPlacetelCallEvent($input: PlacetelCallEventInput!) {
  recordPlacetelCallEvent(input: $input) {
    id
    remoteNumber
  }
}
    `;
export type RecordPlacetelCallEventMutationFn = Apollo.MutationFunction<RecordPlacetelCallEventMutation, RecordPlacetelCallEventMutationVariables>;
export type RecordPlacetelCallEventMutationResult = Apollo.MutationResult<RecordPlacetelCallEventMutation>;
export type RecordPlacetelCallEventMutationOptions = Apollo.BaseMutationOptions<RecordPlacetelCallEventMutation, RecordPlacetelCallEventMutationVariables>;
export const AddPlacetelCallNoteDocument = gql`
    mutation AddPlacetelCallNote($input: PlacetelCallNoteInput!) {
  addPlacetelCallNote(input: $input) {
    id
    callId
    createdAt
  }
}
    `;
export type AddPlacetelCallNoteMutationFn = Apollo.MutationFunction<AddPlacetelCallNoteMutation, AddPlacetelCallNoteMutationVariables>;
export type AddPlacetelCallNoteMutationResult = Apollo.MutationResult<AddPlacetelCallNoteMutation>;
export type AddPlacetelCallNoteMutationOptions = Apollo.BaseMutationOptions<AddPlacetelCallNoteMutation, AddPlacetelCallNoteMutationVariables>;
export const SyncIntegrationDataDocument = gql`
    mutation SyncIntegrationData($organizationId: String!) {
  syncIntegrationData(organizationId: $organizationId) {
    organizationId
    id
    userId
    provider
    status
    result
    jobId
    summary
    errorMessage
    startedAt
    completedAt
    duration
  }
}
    `;
export type SyncIntegrationDataMutationFn = Apollo.MutationFunction<SyncIntegrationDataMutation, SyncIntegrationDataMutationVariables>;
export type SyncIntegrationDataMutationResult = Apollo.MutationResult<SyncIntegrationDataMutation>;
export type SyncIntegrationDataMutationOptions = Apollo.BaseMutationOptions<SyncIntegrationDataMutation, SyncIntegrationDataMutationVariables>;
export const TestIntegrationConnectionDocument = gql`
    mutation TestIntegrationConnection($organizationId: UUID!) {
  testIntegrationConnection(organizationId: $organizationId) {
    ok
    provider
    stage
    error
    httpStatus
    locationCount
    durationMs
  }
}
    `;
export type TestIntegrationConnectionMutationFn = Apollo.MutationFunction<TestIntegrationConnectionMutation, TestIntegrationConnectionMutationVariables>;
export type TestIntegrationConnectionMutationResult = Apollo.MutationResult<TestIntegrationConnectionMutation>;
export type TestIntegrationConnectionMutationOptions = Apollo.BaseMutationOptions<TestIntegrationConnectionMutation, TestIntegrationConnectionMutationVariables>;
export const PreviewIntegrationImportDocument = gql`
    mutation PreviewIntegrationImport($organizationId: UUID!) {
  previewIntegrationImport(organizationId: $organizationId) {
    id
    organizationId
    kind
    status
  }
}
    `;
export type PreviewIntegrationImportMutationFn = Apollo.MutationFunction<PreviewIntegrationImportMutation, PreviewIntegrationImportMutationVariables>;
export type PreviewIntegrationImportMutationResult = Apollo.MutationResult<PreviewIntegrationImportMutation>;
export type PreviewIntegrationImportMutationOptions = Apollo.BaseMutationOptions<PreviewIntegrationImportMutation, PreviewIntegrationImportMutationVariables>;
export const RequestPasswordResetOtpDocument = gql`
    mutation RequestPasswordResetOTP($email: String!) {
  requestPasswordResetOTP(input: {email: $email})
}
    `;
export type RequestPasswordResetOtpMutationFn = Apollo.MutationFunction<RequestPasswordResetOtpMutation, RequestPasswordResetOtpMutationVariables>;
export type RequestPasswordResetOtpMutationResult = Apollo.MutationResult<RequestPasswordResetOtpMutation>;
export type RequestPasswordResetOtpMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetOtpMutation, RequestPasswordResetOtpMutationVariables>;
export const ResetPasswordWithValidationCodeDocument = gql`
    mutation ResetPasswordWithValidationCode($code: String!, $email: String!, $password: String!) {
  resetPasswordWithValidationCode(code: $code, email: $email, password: $password) {
    jwtToken
  }
}
    `;
export type ResetPasswordWithValidationCodeMutationFn = Apollo.MutationFunction<ResetPasswordWithValidationCodeMutation, ResetPasswordWithValidationCodeMutationVariables>;
export type ResetPasswordWithValidationCodeMutationResult = Apollo.MutationResult<ResetPasswordWithValidationCodeMutation>;
export type ResetPasswordWithValidationCodeMutationOptions = Apollo.BaseMutationOptions<ResetPasswordWithValidationCodeMutation, ResetPasswordWithValidationCodeMutationVariables>;
export const PlanRecommendedActivityDocument = gql`
    mutation PlanRecommendedActivity($input: PlanRecommendedActivityInput!) {
  planRecommendedActivity(input: $input) {
    procedureId
    sessionId
  }
}
    `;
export type PlanRecommendedActivityMutationFn = Apollo.MutationFunction<PlanRecommendedActivityMutation, PlanRecommendedActivityMutationVariables>;
export type PlanRecommendedActivityMutationResult = Apollo.MutationResult<PlanRecommendedActivityMutation>;
export type PlanRecommendedActivityMutationOptions = Apollo.BaseMutationOptions<PlanRecommendedActivityMutation, PlanRecommendedActivityMutationVariables>;
export const RemovePlannedProcedureActivitySessionDocument = gql`
    mutation RemovePlannedProcedureActivitySession($input: RemovePlannedProcedureActivitySessionInput!) {
  removePlannedProcedureActivitySession(input: $input)
}
    `;
export type RemovePlannedProcedureActivitySessionMutationFn = Apollo.MutationFunction<RemovePlannedProcedureActivitySessionMutation, RemovePlannedProcedureActivitySessionMutationVariables>;
export type RemovePlannedProcedureActivitySessionMutationResult = Apollo.MutationResult<RemovePlannedProcedureActivitySessionMutation>;
export type RemovePlannedProcedureActivitySessionMutationOptions = Apollo.BaseMutationOptions<RemovePlannedProcedureActivitySessionMutation, RemovePlannedProcedureActivitySessionMutationVariables>;
export const SubmitAdminPortalFeedbackDocument = gql`
    mutation SubmitAdminPortalFeedback($input: SubmitAdminPortalFeedbackInput!) {
  submitAdminPortalFeedback(input: $input) {
    feedbackId
  }
}
    `;
export type SubmitAdminPortalFeedbackMutationFn = Apollo.MutationFunction<SubmitAdminPortalFeedbackMutation, SubmitAdminPortalFeedbackMutationVariables>;
export type SubmitAdminPortalFeedbackMutationResult = Apollo.MutationResult<SubmitAdminPortalFeedbackMutation>;
export type SubmitAdminPortalFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitAdminPortalFeedbackMutation, SubmitAdminPortalFeedbackMutationVariables>;
export const GrantOrganizationLearningCourseDocument = gql`
    mutation GrantOrganizationLearningCourse($input: OrganizationCourseGrantInput!) {
  grantLearningCourse(input: $input) {
    grant {
      id
      courseId
      active
    }
  }
}
    `;
export type GrantOrganizationLearningCourseMutationFn = Apollo.MutationFunction<GrantOrganizationLearningCourseMutation, GrantOrganizationLearningCourseMutationVariables>;
export type GrantOrganizationLearningCourseMutationResult = Apollo.MutationResult<GrantOrganizationLearningCourseMutation>;
export type GrantOrganizationLearningCourseMutationOptions = Apollo.BaseMutationOptions<GrantOrganizationLearningCourseMutation, GrantOrganizationLearningCourseMutationVariables>;
export const RevokeOrganizationLearningCourseDocument = gql`
    mutation RevokeOrganizationLearningCourse($input: OrganizationCourseGrantInput!) {
  revokeLearningCourse(input: $input) {
    grant {
      id
      courseId
      active
    }
  }
}
    `;
export type RevokeOrganizationLearningCourseMutationFn = Apollo.MutationFunction<RevokeOrganizationLearningCourseMutation, RevokeOrganizationLearningCourseMutationVariables>;
export type RevokeOrganizationLearningCourseMutationResult = Apollo.MutationResult<RevokeOrganizationLearningCourseMutation>;
export type RevokeOrganizationLearningCourseMutationOptions = Apollo.BaseMutationOptions<RevokeOrganizationLearningCourseMutation, RevokeOrganizationLearningCourseMutationVariables>;
export const GrantOrganizationLearningPathDocument = gql`
    mutation GrantOrganizationLearningPath($input: OrganizationPathGrantInput!) {
  grantLearningPath(input: $input) {
    grant {
      id
      learningPathId
      active
    }
  }
}
    `;
export type GrantOrganizationLearningPathMutationFn = Apollo.MutationFunction<GrantOrganizationLearningPathMutation, GrantOrganizationLearningPathMutationVariables>;
export type GrantOrganizationLearningPathMutationResult = Apollo.MutationResult<GrantOrganizationLearningPathMutation>;
export type GrantOrganizationLearningPathMutationOptions = Apollo.BaseMutationOptions<GrantOrganizationLearningPathMutation, GrantOrganizationLearningPathMutationVariables>;
export const RevokeOrganizationLearningPathDocument = gql`
    mutation RevokeOrganizationLearningPath($input: OrganizationPathGrantInput!) {
  revokeLearningPath(input: $input) {
    grant {
      id
      learningPathId
      active
    }
  }
}
    `;
export type RevokeOrganizationLearningPathMutationFn = Apollo.MutationFunction<RevokeOrganizationLearningPathMutation, RevokeOrganizationLearningPathMutationVariables>;
export type RevokeOrganizationLearningPathMutationResult = Apollo.MutationResult<RevokeOrganizationLearningPathMutation>;
export type RevokeOrganizationLearningPathMutationOptions = Apollo.BaseMutationOptions<RevokeOrganizationLearningPathMutation, RevokeOrganizationLearningPathMutationVariables>;
export const AssignManagerLearningCourseDocument = gql`
    mutation AssignManagerLearningCourse($input: CourseAssignmentInput!) {
  assignLearningCourse(input: $input) {
    assignment {
      ...ManagerLearningAssignmentFields
    }
  }
}
    ${ManagerLearningAssignmentFieldsFragmentDoc}`;
export type AssignManagerLearningCourseMutationFn = Apollo.MutationFunction<AssignManagerLearningCourseMutation, AssignManagerLearningCourseMutationVariables>;
export type AssignManagerLearningCourseMutationResult = Apollo.MutationResult<AssignManagerLearningCourseMutation>;
export type AssignManagerLearningCourseMutationOptions = Apollo.BaseMutationOptions<AssignManagerLearningCourseMutation, AssignManagerLearningCourseMutationVariables>;
export const UnassignManagerLearningCourseDocument = gql`
    mutation UnassignManagerLearningCourse($input: CourseAssignmentInput!) {
  unassignLearningCourse(input: $input) {
    assignment {
      ...ManagerLearningAssignmentFields
    }
  }
}
    ${ManagerLearningAssignmentFieldsFragmentDoc}`;
export type UnassignManagerLearningCourseMutationFn = Apollo.MutationFunction<UnassignManagerLearningCourseMutation, UnassignManagerLearningCourseMutationVariables>;
export type UnassignManagerLearningCourseMutationResult = Apollo.MutationResult<UnassignManagerLearningCourseMutation>;
export type UnassignManagerLearningCourseMutationOptions = Apollo.BaseMutationOptions<UnassignManagerLearningCourseMutation, UnassignManagerLearningCourseMutationVariables>;
export const AssignManagerLearningPathDocument = gql`
    mutation AssignManagerLearningPath($input: PathAssignmentInput!) {
  assignLearningPath(input: $input) {
    assignment {
      ...ManagerLearningAssignmentFields
    }
  }
}
    ${ManagerLearningAssignmentFieldsFragmentDoc}`;
export type AssignManagerLearningPathMutationFn = Apollo.MutationFunction<AssignManagerLearningPathMutation, AssignManagerLearningPathMutationVariables>;
export type AssignManagerLearningPathMutationResult = Apollo.MutationResult<AssignManagerLearningPathMutation>;
export type AssignManagerLearningPathMutationOptions = Apollo.BaseMutationOptions<AssignManagerLearningPathMutation, AssignManagerLearningPathMutationVariables>;
export const UnassignManagerLearningPathDocument = gql`
    mutation UnassignManagerLearningPath($input: PathAssignmentInput!) {
  unassignLearningPath(input: $input) {
    assignment {
      ...ManagerLearningAssignmentFields
    }
  }
}
    ${ManagerLearningAssignmentFieldsFragmentDoc}`;
export type UnassignManagerLearningPathMutationFn = Apollo.MutationFunction<UnassignManagerLearningPathMutation, UnassignManagerLearningPathMutationVariables>;
export type UnassignManagerLearningPathMutationResult = Apollo.MutationResult<UnassignManagerLearningPathMutation>;
export type UnassignManagerLearningPathMutationOptions = Apollo.BaseMutationOptions<UnassignManagerLearningPathMutation, UnassignManagerLearningPathMutationVariables>;
export const CreateDeviceEnrollmentTokenDocument = gql`
    mutation CreateDeviceEnrollmentToken($input: CreateDeviceEnrollmentTokenInput!) {
  createDeviceEnrollmentToken(input: $input) {
    token {
      ...DeviceEnrollmentTokenFields
    }
    code
    qrPayload
  }
}
    ${DeviceEnrollmentTokenFieldsFragmentDoc}`;
export type CreateDeviceEnrollmentTokenMutationFn = Apollo.MutationFunction<CreateDeviceEnrollmentTokenMutation, CreateDeviceEnrollmentTokenMutationVariables>;
export type CreateDeviceEnrollmentTokenMutationResult = Apollo.MutationResult<CreateDeviceEnrollmentTokenMutation>;
export type CreateDeviceEnrollmentTokenMutationOptions = Apollo.BaseMutationOptions<CreateDeviceEnrollmentTokenMutation, CreateDeviceEnrollmentTokenMutationVariables>;
export const RevokeDeviceEnrollmentTokenDocument = gql`
    mutation RevokeDeviceEnrollmentToken($id: UUID!) {
  revokeDeviceEnrollmentToken(id: $id) {
    id
    status
    revokedAt
  }
}
    `;
export type RevokeDeviceEnrollmentTokenMutationFn = Apollo.MutationFunction<RevokeDeviceEnrollmentTokenMutation, RevokeDeviceEnrollmentTokenMutationVariables>;
export type RevokeDeviceEnrollmentTokenMutationResult = Apollo.MutationResult<RevokeDeviceEnrollmentTokenMutation>;
export type RevokeDeviceEnrollmentTokenMutationOptions = Apollo.BaseMutationOptions<RevokeDeviceEnrollmentTokenMutation, RevokeDeviceEnrollmentTokenMutationVariables>;
export const UnenrollDeviceDocument = gql`
    mutation UnenrollDevice($id: UUID!) {
  unenrollDevice(id: $id) {
    id
    status
  }
}
    `;
export type UnenrollDeviceMutationFn = Apollo.MutationFunction<UnenrollDeviceMutation, UnenrollDeviceMutationVariables>;
export type UnenrollDeviceMutationResult = Apollo.MutationResult<UnenrollDeviceMutation>;
export type UnenrollDeviceMutationOptions = Apollo.BaseMutationOptions<UnenrollDeviceMutation, UnenrollDeviceMutationVariables>;
export const SendDeviceEnrollmentTokenEmailDocument = gql`
    mutation SendDeviceEnrollmentTokenEmail($input: SendDeviceEnrollmentTokenEmailInput!) {
  sendDeviceEnrollmentTokenEmail(input: $input) {
    id
    recipientEmail
    queuedAt
    sentAt
    failedAt
    status
    sentBy {
      id
      name
    }
  }
}
    `;
export type SendDeviceEnrollmentTokenEmailMutationFn = Apollo.MutationFunction<SendDeviceEnrollmentTokenEmailMutation, SendDeviceEnrollmentTokenEmailMutationVariables>;
export type SendDeviceEnrollmentTokenEmailMutationResult = Apollo.MutationResult<SendDeviceEnrollmentTokenEmailMutation>;
export type SendDeviceEnrollmentTokenEmailMutationOptions = Apollo.BaseMutationOptions<SendDeviceEnrollmentTokenEmailMutation, SendDeviceEnrollmentTokenEmailMutationVariables>;
export const StartSalesforceSyncDocument = gql`
    mutation StartSalesforceSync {
  startSalesforceSync
}
    `;
export type StartSalesforceSyncMutationFn = Apollo.MutationFunction<StartSalesforceSyncMutation, StartSalesforceSyncMutationVariables>;
export type StartSalesforceSyncMutationResult = Apollo.MutationResult<StartSalesforceSyncMutation>;
export type StartSalesforceSyncMutationOptions = Apollo.BaseMutationOptions<StartSalesforceSyncMutation, StartSalesforceSyncMutationVariables>;
export const StartFullSalesforceSyncDocument = gql`
    mutation StartFullSalesforceSync {
  startFullSalesforceSync
}
    `;
export type StartFullSalesforceSyncMutationFn = Apollo.MutationFunction<StartFullSalesforceSyncMutation, StartFullSalesforceSyncMutationVariables>;
export type StartFullSalesforceSyncMutationResult = Apollo.MutationResult<StartFullSalesforceSyncMutation>;
export type StartFullSalesforceSyncMutationOptions = Apollo.BaseMutationOptions<StartFullSalesforceSyncMutation, StartFullSalesforceSyncMutationVariables>;
export const CheckSalesforceConnectionDocument = gql`
    mutation CheckSalesforceConnection($input: SalesforceConnectionInput!) {
  checkSalesforceConnection(input: $input) {
    ok
    errorCode
    dailyApiRequestsMax
    dailyApiRequestsRemaining
  }
}
    `;
export type CheckSalesforceConnectionMutationFn = Apollo.MutationFunction<CheckSalesforceConnectionMutation, CheckSalesforceConnectionMutationVariables>;
export type CheckSalesforceConnectionMutationResult = Apollo.MutationResult<CheckSalesforceConnectionMutation>;
export type CheckSalesforceConnectionMutationOptions = Apollo.BaseMutationOptions<CheckSalesforceConnectionMutation, CheckSalesforceConnectionMutationVariables>;
export const UpdateSalesforceIntegrationDocument = gql`
    mutation UpdateSalesforceIntegration($input: SalesforceIntegrationInput!) {
  updateSalesforceIntegration(input: $input) {
    ...SalesforceIntegrationFields
  }
}
    ${SalesforceIntegrationFieldsFragmentDoc}`;
export type UpdateSalesforceIntegrationMutationFn = Apollo.MutationFunction<UpdateSalesforceIntegrationMutation, UpdateSalesforceIntegrationMutationVariables>;
export type UpdateSalesforceIntegrationMutationResult = Apollo.MutationResult<UpdateSalesforceIntegrationMutation>;
export type UpdateSalesforceIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateSalesforceIntegrationMutation, UpdateSalesforceIntegrationMutationVariables>;
export const UpdateMarketingDeliverySettingsDocument = gql`
    mutation UpdateMarketingDeliverySettings($input: MarketingDeliverySettingsInput!) {
  updateMarketingDeliverySettings(input: $input) {
    ...MarketingDeliverySettingsFields
  }
}
    ${MarketingDeliverySettingsFieldsFragmentDoc}`;
export type UpdateMarketingDeliverySettingsMutationFn = Apollo.MutationFunction<UpdateMarketingDeliverySettingsMutation, UpdateMarketingDeliverySettingsMutationVariables>;
export type UpdateMarketingDeliverySettingsMutationResult = Apollo.MutationResult<UpdateMarketingDeliverySettingsMutation>;
export type UpdateMarketingDeliverySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateMarketingDeliverySettingsMutation, UpdateMarketingDeliverySettingsMutationVariables>;
export const SendMarketingTestEmailDocument = gql`
    mutation SendMarketingTestEmail($input: MarketingTestEmailInput!) {
  sendMarketingTestEmail(input: $input) {
    ok
    providerMessageId
    errorCode
  }
}
    `;
export type SendMarketingTestEmailMutationFn = Apollo.MutationFunction<SendMarketingTestEmailMutation, SendMarketingTestEmailMutationVariables>;
export type SendMarketingTestEmailMutationResult = Apollo.MutationResult<SendMarketingTestEmailMutation>;
export type SendMarketingTestEmailMutationOptions = Apollo.BaseMutationOptions<SendMarketingTestEmailMutation, SendMarketingTestEmailMutationVariables>;
export const AddStaffRoleDocument = gql`
    mutation AddStaffRole($userId: UUID!, $role: StaffRole!) {
  addStaffRole(userId: $userId, role: $role)
}
    `;
export type AddStaffRoleMutationFn = Apollo.MutationFunction<AddStaffRoleMutation, AddStaffRoleMutationVariables>;
export type AddStaffRoleMutationResult = Apollo.MutationResult<AddStaffRoleMutation>;
export type AddStaffRoleMutationOptions = Apollo.BaseMutationOptions<AddStaffRoleMutation, AddStaffRoleMutationVariables>;
export const RemoveStaffRoleDocument = gql`
    mutation RemoveStaffRole($userId: UUID!, $role: StaffRole!) {
  removeStaffRole(userId: $userId, role: $role)
}
    `;
export type RemoveStaffRoleMutationFn = Apollo.MutationFunction<RemoveStaffRoleMutation, RemoveStaffRoleMutationVariables>;
export type RemoveStaffRoleMutationResult = Apollo.MutationResult<RemoveStaffRoleMutation>;
export type RemoveStaffRoleMutationOptions = Apollo.BaseMutationOptions<RemoveStaffRoleMutation, RemoveStaffRoleMutationVariables>;
export const InviteStaffDocument = gql`
    mutation InviteStaff($email: String!, $roles: [StaffRole!]!) {
  inviteStaff(email: $email, roles: $roles)
}
    `;
export type InviteStaffMutationFn = Apollo.MutationFunction<InviteStaffMutation, InviteStaffMutationVariables>;
export type InviteStaffMutationResult = Apollo.MutationResult<InviteStaffMutation>;
export type InviteStaffMutationOptions = Apollo.BaseMutationOptions<InviteStaffMutation, InviteStaffMutationVariables>;
export const CancelStaffInvitationDocument = gql`
    mutation CancelStaffInvitation($id: UUID!) {
  cancelStaffInvitation(id: $id)
}
    `;
export type CancelStaffInvitationMutationFn = Apollo.MutationFunction<CancelStaffInvitationMutation, CancelStaffInvitationMutationVariables>;
export type CancelStaffInvitationMutationResult = Apollo.MutationResult<CancelStaffInvitationMutation>;
export type CancelStaffInvitationMutationOptions = Apollo.BaseMutationOptions<CancelStaffInvitationMutation, CancelStaffInvitationMutationVariables>;
export const DismissFinanceNotificationDocument = gql`
    mutation DismissFinanceNotification($id: UUID!, $reason: String!) {
  dismissFinanceNotification(id: $id, reason: $reason) {
    id
    dismissedAt
  }
}
    `;
export type DismissFinanceNotificationMutationFn = Apollo.MutationFunction<DismissFinanceNotificationMutation, DismissFinanceNotificationMutationVariables>;
export type DismissFinanceNotificationMutationResult = Apollo.MutationResult<DismissFinanceNotificationMutation>;
export type DismissFinanceNotificationMutationOptions = Apollo.BaseMutationOptions<DismissFinanceNotificationMutation, DismissFinanceNotificationMutationVariables>;
export const ReviewCustomerServiceCrmDuplicateDocument = gql`
    mutation ReviewCustomerServiceCrmDuplicate($input: CrmDuplicateReviewInput!) {
  reviewCustomerServiceCrmDuplicate(input: $input) {
    ...CrmDuplicateCandidateFields
  }
}
    ${CrmDuplicateCandidateFieldsFragmentDoc}`;
export type ReviewCustomerServiceCrmDuplicateMutationFn = Apollo.MutationFunction<ReviewCustomerServiceCrmDuplicateMutation, ReviewCustomerServiceCrmDuplicateMutationVariables>;
export type ReviewCustomerServiceCrmDuplicateMutationResult = Apollo.MutationResult<ReviewCustomerServiceCrmDuplicateMutation>;
export type ReviewCustomerServiceCrmDuplicateMutationOptions = Apollo.BaseMutationOptions<ReviewCustomerServiceCrmDuplicateMutation, ReviewCustomerServiceCrmDuplicateMutationVariables>;
export const CreateAccountBillingInvoiceDownloadDocument = gql`
    mutation CreateAccountBillingInvoiceDownload($salesforceId: String!, $invoiceId: String!) {
  createAccountBillingInvoiceDownload(
    salesforceId: $salesforceId
    invoiceId: $invoiceId
  ) {
    url
    expiresAt
  }
}
    `;
export type CreateAccountBillingInvoiceDownloadMutationFn = Apollo.MutationFunction<CreateAccountBillingInvoiceDownloadMutation, CreateAccountBillingInvoiceDownloadMutationVariables>;
export type CreateAccountBillingInvoiceDownloadMutationResult = Apollo.MutationResult<CreateAccountBillingInvoiceDownloadMutation>;
export type CreateAccountBillingInvoiceDownloadMutationOptions = Apollo.BaseMutationOptions<CreateAccountBillingInvoiceDownloadMutation, CreateAccountBillingInvoiceDownloadMutationVariables>;
export const UpdateLogisticsDhlShippingSettingsDocument = gql`
    mutation UpdateLogisticsDhlShippingSettings($input: UpdateLogisticsDhlShippingSettingsInput!) {
  updateLogisticsDhlShippingSettings(input: $input) {
    ...LogisticsDhlShippingSettingsFields
  }
}
    ${LogisticsDhlShippingSettingsFieldsFragmentDoc}`;
export type UpdateLogisticsDhlShippingSettingsMutationFn = Apollo.MutationFunction<UpdateLogisticsDhlShippingSettingsMutation, UpdateLogisticsDhlShippingSettingsMutationVariables>;
export type UpdateLogisticsDhlShippingSettingsMutationResult = Apollo.MutationResult<UpdateLogisticsDhlShippingSettingsMutation>;
export type UpdateLogisticsDhlShippingSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateLogisticsDhlShippingSettingsMutation, UpdateLogisticsDhlShippingSettingsMutationVariables>;
export const UpdateLogisticsDhlAccountSettingsDocument = gql`
    mutation UpdateLogisticsDhlAccountSettings($input: UpdateLogisticsDhlAccountSettingsInput!) {
  updateLogisticsDhlAccountSettings(input: $input) {
    ...LogisticsDhlAccountSettingsFields
  }
}
    ${LogisticsDhlAccountSettingsFieldsFragmentDoc}`;
export type UpdateLogisticsDhlAccountSettingsMutationFn = Apollo.MutationFunction<UpdateLogisticsDhlAccountSettingsMutation, UpdateLogisticsDhlAccountSettingsMutationVariables>;
export type UpdateLogisticsDhlAccountSettingsMutationResult = Apollo.MutationResult<UpdateLogisticsDhlAccountSettingsMutation>;
export type UpdateLogisticsDhlAccountSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateLogisticsDhlAccountSettingsMutation, UpdateLogisticsDhlAccountSettingsMutationVariables>;
export const CheckLogisticsDhlConnectionDocument = gql`
    mutation CheckLogisticsDhlConnection {
  checkLogisticsDhlConnection {
    ok
    failure
    missingSettings
    gateway
    storedReturnReceiverFound
    austrianReturnReceivers {
      receiverId
      shipperCountry
      billingNumber
      name
      street
      houseNumber
      postalCode
      city
    }
  }
}
    `;
export type CheckLogisticsDhlConnectionMutationFn = Apollo.MutationFunction<CheckLogisticsDhlConnectionMutation, CheckLogisticsDhlConnectionMutationVariables>;
export type CheckLogisticsDhlConnectionMutationResult = Apollo.MutationResult<CheckLogisticsDhlConnectionMutation>;
export type CheckLogisticsDhlConnectionMutationOptions = Apollo.BaseMutationOptions<CheckLogisticsDhlConnectionMutation, CheckLogisticsDhlConnectionMutationVariables>;
export const CreateLogisticsShippingLabelDocument = gql`
    mutation CreateLogisticsShippingLabel($input: CreateLogisticsShippingLabelInput!) {
  createLogisticsShippingLabel(input: $input) {
    outcome
    refusal
    missingAddressFields
    failure
    messages {
      property
      message
      state
    }
    label {
      ...LogisticsShippingLabelFields
    }
    pilot {
      requestId
      outcome
      refusal
      messages
      salesforceCommandId
    }
  }
}
    ${LogisticsShippingLabelFieldsFragmentDoc}`;
export type CreateLogisticsShippingLabelMutationFn = Apollo.MutationFunction<CreateLogisticsShippingLabelMutation, CreateLogisticsShippingLabelMutationVariables>;
export type CreateLogisticsShippingLabelMutationResult = Apollo.MutationResult<CreateLogisticsShippingLabelMutation>;
export type CreateLogisticsShippingLabelMutationOptions = Apollo.BaseMutationOptions<CreateLogisticsShippingLabelMutation, CreateLogisticsShippingLabelMutationVariables>;
export const CancelLogisticsShippingLabelDocument = gql`
    mutation CancelLogisticsShippingLabel($input: CancelLogisticsShippingLabelInput!) {
  cancelLogisticsShippingLabel(input: $input) {
    outcome
    refusal
    missingAddressFields
    failure
    messages {
      property
      message
      state
    }
    label {
      ...LogisticsShippingLabelFields
    }
    pilot {
      requestId
      outcome
      refusal
      messages
      salesforceCommandId
    }
  }
}
    ${LogisticsShippingLabelFieldsFragmentDoc}`;
export type CancelLogisticsShippingLabelMutationFn = Apollo.MutationFunction<CancelLogisticsShippingLabelMutation, CancelLogisticsShippingLabelMutationVariables>;
export type CancelLogisticsShippingLabelMutationResult = Apollo.MutationResult<CancelLogisticsShippingLabelMutation>;
export type CancelLogisticsShippingLabelMutationOptions = Apollo.BaseMutationOptions<CancelLogisticsShippingLabelMutation, CancelLogisticsShippingLabelMutationVariables>;
export const OrganizationContractsDocument = gql`
    query OrganizationContracts($after: String, $organizationId: UUID) {
  organizationContracts(after: $after, organizationId: $organizationId) {
    availability
    organizationName
    items {
      id
      name
      startDate
      endDate
      status
      product
      productName
      flavour
      plan
      sponsoringOrganization
    }
    nextCursor
  }
}
    `;
export type OrganizationContractsQueryResult = Apollo.QueryResult<OrganizationContractsQuery, OrganizationContractsQueryVariables>;
export const OrganizationBillingDocument = gql`
    query OrganizationBilling($after: String, $organizationId: UUID) {
  organizationBilling(after: $after, organizationId: $organizationId) {
    availability
    organizationName
    invoices {
      id
      number
      documentDate
      totalGross
      currency
    }
    nextCursor
  }
}
    `;
export type OrganizationBillingQueryResult = Apollo.QueryResult<OrganizationBillingQuery, OrganizationBillingQueryVariables>;
export const CustomerServiceOrganizationBillingAccessDocument = gql`
    query CustomerServiceOrganizationBillingAccess($organizationIds: [UUID!]!) {
  customerServiceOrganizationBillingAccess(organizationIds: $organizationIds) {
    organizationId
    accessEnabled
    mappingConfigured
    invoiceAccountConfigured
    salesforceAccountId
    salesforceAccountName
    frisbiiCustomerId
    mappingVersion
  }
}
    `;
export type CustomerServiceOrganizationBillingAccessQueryResult = Apollo.QueryResult<CustomerServiceOrganizationBillingAccessQuery, CustomerServiceOrganizationBillingAccessQueryVariables>;
export const CustomerServiceBillingSalesforceAccountsDocument = gql`
    query CustomerServiceBillingSalesforceAccounts($search: String!) {
  customerServiceBillingSalesforceAccounts(search: $search) {
    id
    name
  }
}
    `;
export type CustomerServiceBillingSalesforceAccountsQueryResult = Apollo.QueryResult<CustomerServiceBillingSalesforceAccountsQuery, CustomerServiceBillingSalesforceAccountsQueryVariables>;
export const CustomerServiceBillingCustomerDocument = gql`
    query CustomerServiceBillingCustomer($salesforceAccountId: String!, $frisbiiCustomerId: String) {
  customerServiceBillingCustomer(
    salesforceAccountId: $salesforceAccountId
    frisbiiCustomerId: $frisbiiCustomerId
  ) {
    id
    externalCustomerId
    displayName
    debtorAccount
  }
}
    `;
export type CustomerServiceBillingCustomerQueryResult = Apollo.QueryResult<CustomerServiceBillingCustomerQuery, CustomerServiceBillingCustomerQueryVariables>;
export const CustomerServiceSalesforceDashboardDocument = gql`
    query CustomerServiceSalesforceDashboard {
  customerServiceSalesforceDashboard {
    lastSyncedAt
    contractCount
    subscriptionCount
    unclassifiedSubscriptions
    activeB2BProducts {
      label
      count
    }
    activeB2CProducts {
      label
      count
    }
    activeLicenceProducts {
      label
      count
    }
    contractSegments {
      recordType
      eligibleContracts
      missingMrrContracts
      missingSubscriptionCountContracts
      totalMrr
      averageMrr
      averageActiveSubscriptionItems
    }
    currency
    history {
      createdDaily {
        periodStart
        segment
        category
        count
      }
      createdWeekly {
        periodStart
        segment
        category
        count
      }
      createdMonthly {
        periodStart
        segment
        category
        count
      }
      cancelledMonthly {
        periodStart
        segment
        category
        count
      }
      endedMonthly {
        periodStart
        segment
        category
        count
      }
      missingCreatedDates
      missingCancellationDates
      missingEndDates
    }
  }
}
    `;
export type CustomerServiceSalesforceDashboardQueryResult = Apollo.QueryResult<CustomerServiceSalesforceDashboardQuery, CustomerServiceSalesforceDashboardQueryVariables>;
export const SalesforceReportDashboardDocument = gql`
    query SalesforceReportDashboard($dashboard: SalesforceReportDashboard!) {
  salesforceReportDashboard(dashboard: $dashboard) {
    dashboard
    salesforceId
    lastSyncedAt
    components {
      key
      reportId
      layout {
        column
        row
        width
        height
      }
      chart
      unavailable
      sortByValue
      showPercentages
      source
      groupings {
        field
        granularity
      }
      measures {
        aggregate
        field
      }
      points {
        group
        series
        values
      }
      unreadableFields
      missingFields
      pendingObjects
      blockKey
      showValues
      sortLegendValues
      table {
        ...SalesforceReportSection
      }
    }
  }
}
    ${SalesforceReportSectionFragmentDoc}`;
export type SalesforceReportDashboardQueryResult = Apollo.QueryResult<SalesforceReportDashboardQuery, SalesforceReportDashboardQueryVariables>;
export const SalesforceReportDocument = gql`
    query SalesforceReport($reportId: String!, $component: SalesforceReportComponentKey, $values: [String], $columnFilters: [SalesforceReportColumnFilterInput!]) {
  salesforceReport(
    reportId: $reportId
    component: $component
    values: $values
    columnFilters: $columnFilters
  ) {
    reportId
    type
    format
    source
    dateRange {
      field
      relative
      lastDays
      from
      to
    }
    filters {
      field
      operator
      values
    }
    filterLogic
    linkedFilters {
      field
      operator
      values
    }
    down {
      field
      granularity
      descending
      link {
        kind
        object
      }
    }
    across {
      field
      granularity
      descending
      link {
        kind
        object
      }
    }
    summaries {
      aggregate
      field
      formula
    }
    columns {
      field
      type
      link {
        kind
        object
      }
    }
    showSubtotals
    showGrandTotal
    groups {
      down {
        value
        label
      }
      across {
        value
        label
      }
      count
      values
    }
    rows {
      down {
        value
        label
      }
      values
      links
    }
    hasMoreRows
    rowLimit
    chart
    chartGroupings {
      field
      granularity
    }
    chartMeasures {
      aggregate
      field
    }
    chartPoints {
      group
      series
      values
    }
    lastSyncedAt
    unreadableFields
    blockKey
    unavailable
    missingFields
    pendingObjects
    chartUnavailable
    chartMissingFields
    chartPendingObjects
    showValues
    sortLegendValues
    selectedBlock
    blocks {
      ...SalesforceReportSection
    }
  }
}
    ${SalesforceReportSectionFragmentDoc}`;
export type SalesforceReportQueryResult = Apollo.QueryResult<SalesforceReportQuery, SalesforceReportQueryVariables>;
export const CustomerServiceSalesforceRecordsDocument = gql`
    query CustomerServiceSalesforceRecords($input: SalesforceRecordsInput!) {
  customerServiceSalesforceRecords(input: $input) {
    totalCount
    records {
      salesforceId
      name
      recordType
      status
      productName
      productFamily
      segment
      sponsoringKrankenkasse
      createdAt
      startDate
      endDate
      cancellationDate
      cancellationType
      contractSalesforceId
      contractStatus
      contractNumber
      contractName
      contractRecordType
      trialPeriodDays
      billingStartDate
      price
      assetType
      changedFromSalesforceId
      changedFromName
      changedIntoSalesforceId
      changedIntoName
      inTrial
      lostReason
      billingStarted
      productSalesforceId
    }
  }
}
    `;
export type CustomerServiceSalesforceRecordsQueryResult = Apollo.QueryResult<CustomerServiceSalesforceRecordsQuery, CustomerServiceSalesforceRecordsQueryVariables>;
export const CustomerServiceSalesforceContractsDocument = gql`
    query CustomerServiceSalesforceContracts($segment: SalesforceSegment!) {
  customerServiceSalesforceContracts(segment: $segment) {
    totalCount
    records {
      salesforceId
      status
      recordType
      startDate
      endDate
      mrr
      activeSubscriptionItems
    }
  }
}
    `;
export type CustomerServiceSalesforceContractsQueryResult = Apollo.QueryResult<CustomerServiceSalesforceContractsQuery, CustomerServiceSalesforceContractsQueryVariables>;
export const LearningViewerDocument = gql`
    query LearningViewer {
  learningViewer {
    id
    firstName
    lastName
    organizationId
  }
}
    `;
export type LearningViewerQueryResult = Apollo.QueryResult<LearningViewerQuery, LearningViewerQueryVariables>;
export const CustomerServiceOrganizationsDocument = gql`
    query CustomerServiceOrganizations {
  customerServiceLearningOrganizations {
    id
    name
  }
}
    `;
export type CustomerServiceOrganizationsQueryResult = Apollo.QueryResult<CustomerServiceOrganizationsQuery, CustomerServiceOrganizationsQueryVariables>;
export const CustomerServiceOrganizationLearningDocument = gql`
    query CustomerServiceOrganizationLearning($organizationId: UUID!) {
  customerServiceLearningCatalog(organizationId: $organizationId) {
    courses {
      id
      version
      locale
      title
      description
      thumbnailFilename
      lessonCount
      estimatedDurationMinutes
      tags
    }
    learningPaths {
      id
      version
      locale
      title
      description
      thumbnailFilename
      enforceOrder
      courses {
        courseId
        position
      }
    }
  }
  organizationLearningGrants(organizationId: $organizationId) {
    organizationId
    grants {
      id
      itemKind
      courseId
      learningPathId
      active
    }
  }
}
    `;
export type CustomerServiceOrganizationLearningQueryResult = Apollo.QueryResult<CustomerServiceOrganizationLearningQuery, CustomerServiceOrganizationLearningQueryVariables>;
export const ManagerLearningCatalogAndCaregiversDocument = gql`
    query ManagerLearningCatalogAndCaregivers {
  managerLearningCatalog {
    courses {
      id
      version
      locale
      title
      description
      thumbnailFilename
      lessonCount
      estimatedDurationMinutes
      passingScorePercent
      tags
    }
    learningPaths {
      id
      version
      locale
      title
      description
      thumbnailFilename
      enforceOrder
      courses {
        courseId
        position
      }
    }
    courseAccess {
      courseId
      directAccess
      pathAccess
    }
  }
  managerLearningCaregivers {
    userId
    organizationId
    firstName
    lastName
    displayName
  }
}
    `;
export type ManagerLearningCatalogAndCaregiversQueryResult = Apollo.QueryResult<ManagerLearningCatalogAndCaregiversQuery, ManagerLearningCatalogAndCaregiversQueryVariables>;
export const ManagerLearningAssignmentsDocument = gql`
    query ManagerLearningAssignments($userIds: [UUID!]) {
  managerLearningAssignments(userIds: $userIds) {
    id
    organizationId
    userId
    itemKind
    courseId
    learningPathId
    learningPathVersion
    kind
    assignedBy
    assignedAt
    unassignedBy
    unassignedAt
    active
    enrollmentIds
  }
}
    `;
export type ManagerLearningAssignmentsQueryResult = Apollo.QueryResult<ManagerLearningAssignmentsQuery, ManagerLearningAssignmentsQueryVariables>;
export const ManagerLearningProgressDocument = gql`
    query ManagerLearningProgress($filter: LearningProgressFilter!, $assignmentUserIds: [UUID!]) {
  managerLearningCatalog {
    courses {
      id
      title
    }
    learningPaths {
      id
      version
      title
      courses {
        courseId
        position
      }
    }
  }
  managerLearningCaregivers {
    userId
    organizationId
    displayName
    locationNames
  }
  managerLearningAssignments(userIds: $assignmentUserIds) {
    id
    userId
    itemKind
    learningPathId
    learningPathVersion
    active
    enrollmentIds
  }
  learningProgressReport(filter: $filter) {
    entries {
      enrollmentId
      organizationId
      userId
      courseId
      status
      firstStartedAt
      completedAt
      bestScorePercent
      quizAttempts {
        id
        courseVersion
        serverScorePercent
        serverPassed
        finishedAt
      }
    }
  }
}
    `;
export type ManagerLearningProgressQueryResult = Apollo.QueryResult<ManagerLearningProgressQuery, ManagerLearningProgressQueryVariables>;
export const MyLearningCatalogDocument = gql`
    query MyLearningCatalog {
  myLearningCatalog {
    courses {
      id
      version
      locale
      title
      description
      thumbnailFilename
      estimatedDurationMinutes
      passingScorePercent
      tags
    }
    learningPaths {
      id
      version
      locale
      title
      description
      thumbnailFilename
      enforceOrder
      courses {
        courseId
        position
      }
    }
    courseAccess {
      courseId
      currentVersion
      directAccess
      selfAccess
      pathAccess
      locked
    }
    selfEnrollCourseIds
    selfEnrollPathIds
  }
}
    `;
export type MyLearningCatalogQueryResult = Apollo.QueryResult<MyLearningCatalogQuery, MyLearningCatalogQueryVariables>;
export const LearningCoursePayloadDocument = gql`
    query LearningCoursePayload($courseId: UUID!, $version: String!) {
  learningCoursePayload(courseId: $courseId, version: $version) {
    courseId
    version
    payload
  }
}
    `;
export type LearningCoursePayloadQueryResult = Apollo.QueryResult<LearningCoursePayloadQuery, LearningCoursePayloadQueryVariables>;
export const MyLearningDocument = gql`
    query MyLearning {
  myLearning {
    courses {
      courseId
      currentVersion
      startedVersions
      status
      completedLessonIds
      bestScorePercent
      directAccess
    }
    pathSources {
      assignmentId
      pathId
      pathVersion
      orderedCourses {
        courseId
        available
        locked
      }
    }
  }
}
    `;
export type MyLearningQueryResult = Apollo.QueryResult<MyLearningQuery, MyLearningQueryVariables>;
export const OrganizationsQueryDocument = gql`
    query OrganizationsQuery($first: Int, $offset: Int) {
  organizations(first: $first, offset: $offset) {
    nodes {
      id
      name
      externalId
      postalCode
      patients {
        totalCount
      }
      practitioners {
        totalCount
        nodes {
          id
          role
        }
      }
      organizationManagers {
        nodes {
          user {
            email
            name
          }
        }
      }
    }
    totalCount
  }
}
    `;
export type OrganizationsQueryQueryResult = Apollo.QueryResult<OrganizationsQueryQuery, OrganizationsQueryQueryVariables>;
export const OrganizationQueryDocument = gql`
    query OrganizationQuery($id: UUID!) {
  organization(id: $id) {
    id
    name
    externalId
    street
    postalCode
    city
    additionalInfo
    locations {
      nodes {
        id
        name
        externalId
        type
        status
        patients {
          totalCount
        }
        locationPractitioners {
          totalCount
        }
        devices(condition: {unenrolledAt: null}) {
          totalCount
        }
      }
    }
    patients {
      totalCount
      nodes {
        user {
          id
          firstName
          lastName
          avatarUrl
        }
      }
    }
    practitioners {
      totalCount
      nodes {
        id
        user {
          id
          firstName
          lastName
          avatarUrl
        }
      }
    }
  }
}
    `;
export type OrganizationQueryQueryResult = Apollo.QueryResult<OrganizationQueryQuery, OrganizationQueryQueryVariables>;
export const LocationsQueryDocument = gql`
    query LocationsQuery($first: Int, $offset: Int, $condition: LocationCondition) {
  locations(first: $first, offset: $offset, condition: $condition) {
    nodes {
      id
      name
      externalId
      sourceSystem
      type
      status
      partOfId
      mode
      organization {
        id
        name
      }
      patients {
        totalCount
      }
      locationPractitioners {
        totalCount
      }
      devices(condition: {unenrolledAt: null}) {
        totalCount
      }
    }
    totalCount
  }
}
    `;
export type LocationsQueryQueryResult = Apollo.QueryResult<LocationsQueryQuery, LocationsQueryQueryVariables>;
export const LocationSummaryListDocument = gql`
    query LocationSummaryList($first: Int, $offset: Int, $condition: LocationSummaryCondition) {
  locationSummaries(
    first: $first
    offset: $offset
    condition: $condition
    orderBy: [NAME_ASC]
  ) {
    nodes {
      id
      organizationId
      partOfId
      name
      type
      immediateChildCount
      patientCount
      practitionerCount
      deviceCount
    }
    totalCount
  }
}
    `;
export type LocationSummaryListQueryResult = Apollo.QueryResult<LocationSummaryListQuery, LocationSummaryListQueryVariables>;
export const LocationOptionsListDocument = gql`
    query LocationOptionsList($first: Int, $offset: Int, $condition: LocationCondition) {
  locations(first: $first, offset: $offset, condition: $condition) {
    nodes {
      id
      name
      type
      partOfId
      organizationId
    }
    totalCount
  }
}
    `;
export type LocationOptionsListQueryResult = Apollo.QueryResult<LocationOptionsListQuery, LocationOptionsListQueryVariables>;
export const LocationQueryDocument = gql`
    query LocationQuery($id: UUID!) {
  location(id: $id) {
    id
    name
    externalId
    sourceSystem
    type
    status
    partOfId
    mode
    organization {
      id
      name
    }
    patients {
      nodes {
        id
        patientNumber
        gender
        birthDate
        user {
          id
          name
          firstName
          lastName
          avatarUrl
        }
      }
    }
    locationPractitioners {
      nodes {
        practitioner {
          id
          status
          employeeNumber
          emailAddress
          user {
            id
            firstName
            lastName
            avatarUrl
          }
        }
      }
    }
    devices {
      nodes {
        id
        deviceId
        status
        manufacturer
        model
        osVersion
        appVersion
        contentVersion
        name
      }
    }
  }
}
    `;
export type LocationQueryQueryResult = Apollo.QueryResult<LocationQueryQuery, LocationQueryQueryVariables>;
export const PatientsQueryDocument = gql`
    query PatientsQuery($first: Int, $offset: Int, $condition: PatientCondition) {
  patients(first: $first, offset: $offset, condition: $condition) {
    nodes {
      id
      sourceSystem
      gender
      birthDate
      patientNumber
      location {
        id
        type
      }
      user {
        id
        name
        firstName
        lastName
        avatarUrl
      }
      organization {
        id
        name
      }
      locationHierarchy {
        nodes {
          level
          locationId
          locationName
          locationType
          externalId
        }
      }
    }
    totalCount
  }
}
    `;
export type PatientsQueryQueryResult = Apollo.QueryResult<PatientsQueryQuery, PatientsQueryQueryVariables>;
export const DashboardPatientCountDocument = gql`
    query DashboardPatientCount($targetOrganizationId: UUID, $selectedLocationId: UUID) {
  dashboardPatients(
    targetOrganizationId: $targetOrganizationId
    selectedLocationId: $selectedLocationId
    first: 0
  ) {
    totalCount
  }
}
    `;
export type DashboardPatientCountQueryResult = Apollo.QueryResult<DashboardPatientCountQuery, DashboardPatientCountQueryVariables>;
export const DashboardPatientListDocument = gql`
    query DashboardPatientList($first: Int, $offset: Int, $targetOrganizationId: UUID, $selectedLocationId: UUID) {
  dashboardPatients(
    targetOrganizationId: $targetOrganizationId
    selectedLocationId: $selectedLocationId
    first: $first
    offset: $offset
  ) {
    nodes {
      id
      sourceSystem
      gender
      birthDate
      patientNumber
      location {
        id
        type
      }
      user {
        id
        name
        firstName
        lastName
        avatarUrl
      }
      organization {
        id
        name
      }
      locationHierarchy {
        nodes {
          level
          locationId
          locationName
          locationType
          externalId
        }
      }
    }
    totalCount
  }
}
    `;
export type DashboardPatientListQueryResult = Apollo.QueryResult<DashboardPatientListQuery, DashboardPatientListQueryVariables>;
export const PatientQueryDocument = gql`
    query PatientQuery($id: UUID!) {
  patient(id: $id) {
    id
    sourceSystem
    externalId
    gender
    birthDate
    patientNumber
    location {
      id
      type
    }
    user {
      id
      name
      firstName
      lastName
      email
      avatarUrl
      avatar
      salutation
    }
    organization {
      id
      name
    }
    locationHierarchy {
      nodes {
        level
        locationId
        locationName
        locationType
        externalId
      }
    }
  }
}
    `;
export type PatientQueryQueryResult = Apollo.QueryResult<PatientQueryQuery, PatientQueryQueryVariables>;
export const ActivityGoalsListDocument = gql`
    query ActivityGoalsList($userId: UUID!) {
  activityGoalsList(condition: {userId: $userId}) {
    id
    userId
    kind
    weeklyGoal
  }
}
    `;
export type ActivityGoalsListQueryResult = Apollo.QueryResult<ActivityGoalsListQuery, ActivityGoalsListQueryVariables>;
export const ActivityGoalProgressDocument = gql`
    query ActivityGoalProgress($userId: UUID!) {
  activityGoalProgress(userId: $userId) {
    kind
    weeklyGoalMinutes
    doneMinutes
  }
}
    `;
export type ActivityGoalProgressQueryResult = Apollo.QueryResult<ActivityGoalProgressQuery, ActivityGoalProgressQueryVariables>;
export const ActivityRecommendationsDocument = gql`
    query ActivityRecommendations($userId: UUID!, $kind: ActivityGoalEnum!, $limit: Int, $targetDurationMinutes: Int, $excludeContentIds: [Int!]) {
  activityRecommendations(
    userId: $userId
    kind: $kind
    limit: $limit
    targetDurationMinutes: $targetDurationMinutes
    excludeContentIds: $excludeContentIds
  ) {
    cmsContentId
    cmsContentKind
    contentUuid
    title
    durationMinutes
    kind
    thumbnailFilename
    isPlanned
  }
}
    `;
export type ActivityRecommendationsQueryResult = Apollo.QueryResult<ActivityRecommendationsQuery, ActivityRecommendationsQueryVariables>;
export const PatientProceduresDocument = gql`
    query PatientProcedures($patientId: UUID!) {
  procedureParticipants(condition: {patientId: $patientId}) {
    nodes {
      procedure {
        id
        codeDisplay
        plannedStart
        status
      }
    }
  }
}
    `;
export type PatientProceduresQueryResult = Apollo.QueryResult<PatientProceduresQuery, PatientProceduresQueryVariables>;
export const PractitionersQueryDocument = gql`
    query PractitionersQuery($first: Int, $offset: Int, $condition: PractitionerCondition) {
  practitioners(first: $first, offset: $offset, condition: $condition) {
    nodes {
      id
      sourceSystem
      status
      birthDate
      emailAddress
      employeeNumber
      gender
      user {
        id
        firstName
        lastName
        avatarUrl
        authStatus
      }
      organization {
        id
        name
      }
      practitioners {
        nodes {
          name
          id
          type
          partOfId
        }
      }
    }
    totalCount
  }
}
    `;
export type PractitionersQueryQueryResult = Apollo.QueryResult<PractitionersQueryQuery, PractitionersQueryQueryVariables>;
export const DashboardPractitionerCountDocument = gql`
    query DashboardPractitionerCount($targetOrganizationId: UUID, $selectedLocationId: UUID) {
  dashboardPractitioners(
    targetOrganizationId: $targetOrganizationId
    selectedLocationId: $selectedLocationId
    first: 0
  ) {
    totalCount
  }
}
    `;
export type DashboardPractitionerCountQueryResult = Apollo.QueryResult<DashboardPractitionerCountQuery, DashboardPractitionerCountQueryVariables>;
export const DashboardPractitionerListDocument = gql`
    query DashboardPractitionerList($first: Int, $offset: Int, $targetOrganizationId: UUID, $selectedLocationId: UUID) {
  dashboardPractitioners(
    targetOrganizationId: $targetOrganizationId
    selectedLocationId: $selectedLocationId
    first: $first
    offset: $offset
  ) {
    nodes {
      id
      sourceSystem
      status
      birthDate
      emailAddress
      employeeNumber
      gender
      user {
        id
        firstName
        lastName
        avatarUrl
        authStatus
      }
      organization {
        id
        name
      }
      practitioners {
        nodes {
          name
          id
          type
          partOfId
        }
      }
    }
    totalCount
  }
}
    `;
export type DashboardPractitionerListQueryResult = Apollo.QueryResult<DashboardPractitionerListQuery, DashboardPractitionerListQueryVariables>;
export const PractitionerQueryDocument = gql`
    query PractitionerQuery($id: UUID!) {
  practitioner(id: $id) {
    id
    sourceSystem
    externalId
    birthDate
    emailAddress
    employeeNumber
    telephoneNumber
    gender
    status
    role
    motherTongue
    user {
      id
      firstName
      lastName
      avatarUrl
      avatar
      salutation
      authStatus
      authStatusValidUntil
    }
    organization {
      id
      name
    }
    practitioners {
      nodes {
        name
        id
        type
      }
    }
  }
}
    `;
export type PractitionerQueryQueryResult = Apollo.QueryResult<PractitionerQueryQuery, PractitionerQueryQueryVariables>;
export const GetUploadLinksWithKeysDocument = gql`
    query GetUploadLinksWithKeys($key: String!) {
  getUploadLinksWithKeys(keys: [$key]) {
    key
    url
  }
}
    `;
export type GetUploadLinksWithKeysQueryResult = Apollo.QueryResult<GetUploadLinksWithKeysQuery, GetUploadLinksWithKeysQueryVariables>;
export const DevicesQueryDocument = gql`
    query DevicesQuery($first: Int, $offset: Int, $condition: DeviceCondition) {
  devices(first: $first, offset: $offset, condition: $condition) {
    nodes {
      id
      deviceId
      status
      unenrolledAt
      manufacturer
      model
      osVersion
      appVersion
      contentVersion
      name
      location {
        id
        name
      }
      organization {
        id
        name
      }
    }
    totalCount
  }
}
    `;
export type DevicesQueryQueryResult = Apollo.QueryResult<DevicesQueryQuery, DevicesQueryQueryVariables>;
export const DeviceQueryDocument = gql`
    query DeviceQuery($id: UUID!) {
  device(id: $id) {
    id
    deviceId
    status
    unenrolledAt
    manufacturer
    model
    osVersion
    appVersion
    contentVersion
    name
    location {
      id
      name
    }
    organization {
      id
      name
    }
  }
}
    `;
export type DeviceQueryQueryResult = Apollo.QueryResult<DeviceQueryQuery, DeviceQueryQueryVariables>;
export const SalesforceSyncRunsDocument = gql`
    query SalesforceSyncRuns {
  salesforceSyncRuns {
    id
    trigger
    status
    mode
    anonymized
    startedAt
    finishedAt
    phase
    phaseRecords
    progressAt
    counts {
      products
      accounts
      contracts
      items
      users
      contacts
      leads
      orders
      cases
      emails
      caseComments
      caseHistories
      calls
    }
    unavailable
    apiCalls
    apiRequestsRemaining
    apiRequestsMax
    errorCode
  }
}
    `;
export type SalesforceSyncRunsQueryResult = Apollo.QueryResult<SalesforceSyncRunsQuery, SalesforceSyncRunsQueryVariables>;
export const SalesforceIntegrationDocument = gql`
    query SalesforceIntegration {
  salesforceIntegration {
    ...SalesforceIntegrationFields
  }
}
    ${SalesforceIntegrationFieldsFragmentDoc}`;
export type SalesforceIntegrationQueryResult = Apollo.QueryResult<SalesforceIntegrationQuery, SalesforceIntegrationQueryVariables>;
export const MarketingDeliverySettingsDocument = gql`
    query MarketingDeliverySettings {
  marketingDeliverySettings {
    ...MarketingDeliverySettingsFields
  }
}
    ${MarketingDeliverySettingsFieldsFragmentDoc}`;
export type MarketingDeliverySettingsQueryResult = Apollo.QueryResult<MarketingDeliverySettingsQuery, MarketingDeliverySettingsQueryVariables>;
export const MarketingSendingDomainDocument = gql`
    query MarketingSendingDomain {
  marketingSendingDomain {
    domain
    checkedAt
    records {
      purpose
      type
      name
      value
      status
      found
    }
  }
}
    `;
export type MarketingSendingDomainQueryResult = Apollo.QueryResult<MarketingSendingDomainQuery, MarketingSendingDomainQueryVariables>;
export const PractitionerActivitiesQueryDocument = gql`
    query PractitionerActivitiesQuery($userId: UUID!, $first: Int, $offset: Int, $orderBy: [ActivitySessionsOrderBy!], $condition: ActivitySessionCondition) {
  user(id: $userId) {
    activitySessionsByCaregiverId(
      first: $first
      offset: $offset
      orderBy: $orderBy
      condition: $condition
    ) {
      nodes {
        id
        beganAt
        endedAt
        kind
        activity {
          id
          kind
          contentActivity {
            content {
              cmsContentId
              cmsContentKind
              cmsNextContentId
              cmsNextContentKind
              title
              metaTags {
                nodes {
                  metaTag {
                    tag
                    kind
                  }
                }
              }
            }
          }
          customActivity {
            name
          }
          featureActivity {
            kind
          }
        }
        activityParticipants {
          nodes {
            senior {
              id
              firstName
              lastName
              name
              avatarUrl
            }
          }
        }
        noteList {
          id
          note
          kind
          generationStatus
          publishedAt
          documentationSyncsList {
            ...DocumentationSyncFields
          }
          mdDocumentation
          createdAt
          updatedAt
          author {
            id
            firstName
            lastName
            name
          }
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    ${DocumentationSyncFieldsFragmentDoc}`;
export type PractitionerActivitiesQueryQueryResult = Apollo.QueryResult<PractitionerActivitiesQueryQuery, PractitionerActivitiesQueryQueryVariables>;
export const PatientActivitiesQueryDocument = gql`
    query PatientActivitiesQuery($userId: UUID!, $first: Int, $offset: Int, $orderBy: [ActivitySessionsOrderBy!], $condition: ActivitySessionCondition) {
  user(id: $userId) {
    activitySessionsByActivityParticipantSeniorIdAndActivitySessionId(
      first: $first
      offset: $offset
      orderBy: $orderBy
      condition: $condition
    ) {
      nodes {
        id
        beganAt
        endedAt
        kind
        activity {
          id
          kind
          contentActivity {
            content {
              cmsContentId
              cmsContentKind
              cmsNextContentId
              cmsNextContentKind
              title
              metaTags {
                nodes {
                  metaTag {
                    tag
                    kind
                  }
                }
              }
            }
          }
          customActivity {
            name
          }
          featureActivity {
            kind
          }
        }
        noteList {
          id
          note
          kind
          generationStatus
          publishedAt
          documentationSyncsList {
            ...DocumentationSyncFields
          }
          mdDocumentation
          createdAt
          updatedAt
          author {
            id
            firstName
            lastName
            name
          }
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    ${DocumentationSyncFieldsFragmentDoc}`;
export type PatientActivitiesQueryQueryResult = Apollo.QueryResult<PatientActivitiesQueryQuery, PatientActivitiesQueryQueryVariables>;
export const PractitionerNotesQueryDocument = gql`
    query PractitionerNotesQuery($userId: UUID!, $first: Int, $offset: Int) {
  notes(
    first: $first
    offset: $offset
    orderBy: UPDATED_AT_DESC
    condition: {authorId: $userId, excludeEmptyNote: true}
  ) {
    nodes {
      id
      note
      createdAt
      updatedAt
      author {
        id
        firstName
        lastName
        name
      }
      activitySessionList {
        activity {
          contentActivity {
            content {
              metaTags {
                nodes {
                  metaTag {
                    tag
                    kind
                  }
                }
              }
            }
          }
          customActivity {
            name
          }
          featureActivity {
            kind
          }
        }
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    `;
export type PractitionerNotesQueryQueryResult = Apollo.QueryResult<PractitionerNotesQueryQuery, PractitionerNotesQueryQueryVariables>;
export const ManagerInvitationsDocument = gql`
    query ManagerInvitations {
  managerInvitations {
    id
    email
    status
    createdAt
    salesforceAccountId
    salesforceAccountName
  }
}
    `;
export type ManagerInvitationsQueryResult = Apollo.QueryResult<ManagerInvitationsQuery, ManagerInvitationsQueryVariables>;
export const DeviceEnrollmentTokensDocument = gql`
    query DeviceEnrollmentTokens($organizationId: UUID!) {
  deviceEnrollmentTokens(organizationId: $organizationId) {
    ...DeviceEnrollmentTokenFields
  }
}
    ${DeviceEnrollmentTokenFieldsFragmentDoc}`;
export type DeviceEnrollmentTokensQueryResult = Apollo.QueryResult<DeviceEnrollmentTokensQuery, DeviceEnrollmentTokensQueryVariables>;
export const CustomerServiceOrganizationAccountsDocument = gql`
    query CustomerServiceOrganizationAccounts {
  customerServiceOrganizationAccounts {
    organizationId
    organizationName
    salesforceAccountId
    salesforceAccountName
  }
}
    `;
export type CustomerServiceOrganizationAccountsQueryResult = Apollo.QueryResult<CustomerServiceOrganizationAccountsQuery, CustomerServiceOrganizationAccountsQueryVariables>;
export const CustomerServiceAccountManagersDocument = gql`
    query CustomerServiceAccountManagers($salesforceAccountId: String!) {
  customerServiceAccountManagers(salesforceAccountId: $salesforceAccountId) {
    salesforceAccountId
    eligible
    ambulant
    organization {
      id
      name
    }
    contacts {
      contactId
      name
      email
      invitationState
    }
    invitations {
      id
      email
      status
      createdAt
    }
    managers {
      userId
      name
      email
      registeredAt
      lastSignInAt
    }
  }
}
    `;
export type CustomerServiceAccountManagersQueryResult = Apollo.QueryResult<CustomerServiceAccountManagersQuery, CustomerServiceAccountManagersQueryVariables>;
export const ManagerRegistrationCandidateDocument = gql`
    query ManagerRegistrationCandidate($email: String!, $code: String!) {
  managerRegistrationCandidate(email: $email, code: $code) {
    managerName
    organizationName
  }
}
    `;
export type ManagerRegistrationCandidateQueryResult = Apollo.QueryResult<ManagerRegistrationCandidateQuery, ManagerRegistrationCandidateQueryVariables>;
export const StaffRegistrationCandidateDocument = gql`
    query StaffRegistrationCandidate($email: String!, $code: String!) {
  staffRegistrationCandidate(email: $email, code: $code) {
    roles
  }
}
    `;
export type StaffRegistrationCandidateQueryResult = Apollo.QueryResult<StaffRegistrationCandidateQuery, StaffRegistrationCandidateQueryVariables>;
export const StaffMembersDocument = gql`
    query StaffMembers {
  staffMembers {
    id
    name
    email
    roles
  }
}
    `;
export type StaffMembersQueryResult = Apollo.QueryResult<StaffMembersQuery, StaffMembersQueryVariables>;
export const StaffInvitationsDocument = gql`
    query StaffInvitations {
  staffInvitations {
    id
    email
    roles
    status
    createdAt
    invitedByName
  }
}
    `;
export type StaffInvitationsQueryResult = Apollo.QueryResult<StaffInvitationsQuery, StaffInvitationsQueryVariables>;
export const AnalyticsDailyQueryDocument = gql`
    query AnalyticsDailyQuery {
  dailiesList(orderBy: DATE_DESC) {
    date
    appId
    dau
    mau
    messagesSent
    picturesSent
    notesCreated
    b2BSeniorsCreated
  }
}
    `;
export type AnalyticsDailyQueryQueryResult = Apollo.QueryResult<AnalyticsDailyQueryQuery, AnalyticsDailyQueryQueryVariables>;
export const AnalyticsDistributionQueryDocument = gql`
    query AnalyticsDistributionQuery {
  distributionsList(orderBy: DATE_DESC) {
    date
    appId
    dimension
    label
    count
  }
}
    `;
export type AnalyticsDistributionQueryQueryResult = Apollo.QueryResult<AnalyticsDistributionQueryQuery, AnalyticsDistributionQueryQueryVariables>;
export const AnalyticsContentUsageDailyQueryDocument = gql`
    query AnalyticsContentUsageDailyQuery {
  contentUsageDailiesList(first: 20000, orderBy: DATE_DESC) {
    date
    appId
    contentId
    cmsContentKind
    contentSubtype
    title
    completedSessionCount
    unfinishedSessionCount
    completedDurationSecondsSum
    completedDurationSessionCount
  }
}
    `;
export type AnalyticsContentUsageDailyQueryQueryResult = Apollo.QueryResult<AnalyticsContentUsageDailyQueryQuery, AnalyticsContentUsageDailyQueryQueryVariables>;
export const MostUsedYoutubeContentDocument = gql`
    query MostUsedYoutubeContent($dateFrom: Date!, $dateTo: Date!) {
  mostUsedYoutubeContent(dateFrom: $dateFrom, dateTo: $dateTo) {
    contentId
    title
    completedSessionCount
    unfinishedSessionCount
    averageCompletedDurationSeconds
  }
}
    `;
export type MostUsedYoutubeContentQueryResult = Apollo.QueryResult<MostUsedYoutubeContentQuery, MostUsedYoutubeContentQueryVariables>;
export const LeastUsedContentReportDocument = gql`
    query LeastUsedContentReport($contentKind: String, $first: Int!, $offset: Int!) {
  leastUsedContentReport(
    contentKind: $contentKind
    first: $first
    offset: $offset
  ) {
    periodStart
    periodEnd
    contentTypes
    totalCount
    items {
      contentId
      title
      contentKind
      contentSubtype
      sessionCount
      lastUsedAt
    }
  }
}
    `;
export type LeastUsedContentReportQueryResult = Apollo.QueryResult<LeastUsedContentReportQuery, LeastUsedContentReportQueryVariables>;
export const MeQueryDocument = gql`
    query MeQuery {
  me {
    id
    kind
    firstName
    lastName
    name
    email
    organizationManager {
      organizationId
      organization {
        name
      }
    }
  }
  hasLearningContent
}
    `;
export type MeQueryQueryResult = Apollo.QueryResult<MeQueryQuery, MeQueryQueryVariables>;
export const PortalAccessDocument = gql`
    query PortalAccess {
  me {
    id
    kind
  }
  hasLearningContent
  currentUserPermissions
}
    `;
export type PortalAccessQueryResult = Apollo.QueryResult<PortalAccessQuery, PortalAccessQueryVariables>;
export const GetIntegrationSettingsDocument = gql`
    query GetIntegrationSettings($organizationId: UUID!) {
  getIntegrationSettings(organizationId: $organizationId) {
    organizationId
    hasClientSecret
    provider
    credentials {
      serverUrl
      clientId
      clientSecret
    }
  }
}
    `;
export type GetIntegrationSettingsQueryResult = Apollo.QueryResult<GetIntegrationSettingsQuery, GetIntegrationSettingsQueryVariables>;
export const PlacetelIntegrationDocument = gql`
    query PlacetelIntegration {
  placetelIntegration {
    enabled
    organizationId
    clientId
    hasClientSecret
    hasRefreshToken
    hasWebhookSecret
    phoneClientId
    hasPhoneClientSecret
    updatedAt
  }
}
    `;
export type PlacetelIntegrationQueryResult = Apollo.QueryResult<PlacetelIntegrationQuery, PlacetelIntegrationQueryVariables>;
export const PlacetelHotlineNumbersDocument = gql`
    query PlacetelHotlineNumbers {
  placetelHotlineNumbers
}
    `;
export type PlacetelHotlineNumbersQueryResult = Apollo.QueryResult<PlacetelHotlineNumbersQuery, PlacetelHotlineNumbersQueryVariables>;
export const PlacetelOpeningHoursDocument = gql`
    query PlacetelOpeningHours {
  placetelOpeningHours {
    weekday
    opens
    closes
  }
}
    `;
export type PlacetelOpeningHoursQueryResult = Apollo.QueryResult<PlacetelOpeningHoursQuery, PlacetelOpeningHoursQueryVariables>;
export const PlacetelPhoneAccountDocument = gql`
    query PlacetelPhoneAccount {
  placetelPhoneAccount {
    ...PlacetelPhoneAccountFields
  }
}
    ${PlacetelPhoneAccountFieldsFragmentDoc}`;
export type PlacetelPhoneAccountQueryResult = Apollo.QueryResult<PlacetelPhoneAccountQuery, PlacetelPhoneAccountQueryVariables>;
export const GetIntegrationExecutionsDocument = gql`
    query GetIntegrationExecutions($organizationId: UUID!, $input: IntegrationExecutionsInput) {
  integrationExecutions(organizationId: $organizationId, input: $input) {
    organizationId
    id
    userId
    provider
    status
    result
    jobId
    summary
    errorMessage
    startedAt
    completedAt
    duration
  }
}
    `;
export type GetIntegrationExecutionsQueryResult = Apollo.QueryResult<GetIntegrationExecutionsQuery, GetIntegrationExecutionsQueryVariables>;
export const GetIntegrationExecutionDocument = gql`
    query GetIntegrationExecution($organizationId: UUID!, $id: UUID!) {
  integrationExecution(organizationId: $organizationId, id: $id) {
    id
    organizationId
    kind
    status
  }
}
    `;
export type GetIntegrationExecutionQueryResult = Apollo.QueryResult<GetIntegrationExecutionQuery, GetIntegrationExecutionQueryVariables>;
export const GetIntegrationImportPreviewDocument = gql`
    query GetIntegrationImportPreview($organizationId: UUID!) {
  integrationImportPreview(organizationId: $organizationId) {
    executionId
    organizationId
    provider
    createdAt
    expiresAt
    procedureCount
    locations {
      externalId
      type
      name
      change
      parent {
        type
        externalId
      }
    }
    patients {
      externalId
      number
      displayName
      change
      reason
      locations {
        type
        externalId
      }
    }
    practitioners {
      externalId
      number
      displayName
      change
      reason
      locations {
        type
        externalId
      }
    }
    warnings {
      entity
      reference
      reason
    }
    failures {
      entity
      reference
      reason
    }
  }
}
    `;
export type GetIntegrationImportPreviewQueryResult = Apollo.QueryResult<GetIntegrationImportPreviewQuery, GetIntegrationImportPreviewQueryVariables>;
export const ProceduresQueryDocument = gql`
    query ProceduresQuery($first: Int, $offset: Int, $condition: ProcedureCondition, $orderBy: [ProceduresOrderBy!]) {
  procedures(
    first: $first
    offset: $offset
    condition: $condition
    orderBy: $orderBy
  ) {
    nodes {
      id
      status
      sourceSystem
      externalId
      codeSystem
      codeValue
      codeDisplay
      description
      plannedStart
      plannedEnd
      performedStart
      performedEnd
      notes
      documentation
      createdAt
      updatedAt
      acknowledgedAt
      documentationSyncsList {
        ...DocumentationSyncFields
      }
      procedureNotesList {
        procedureNotes {
          id
          note
          kind
          createdAt
          publishedAt
          documentationSyncsList {
            ...DocumentationSyncFields
          }
          seniorList {
            id
            name
          }
        }
      }
      procedureParticipants {
        nodes {
          patient {
            id
            patientNumber
            location {
              id
              partOfId
            }
            user {
              firstName
              lastName
              name
            }
          }
        }
      }
      performer {
        id
        user {
          firstName
          lastName
          name
        }
      }
      organization {
        id
        name
      }
      activitySessions {
        nodes {
          id
          beganAt
          endedAt
          activity {
            id
            kind
            contentActivity {
              content {
                title
              }
            }
            featureActivity {
              kind
            }
            customActivity {
              name
            }
          }
        }
      }
    }
    totalCount
  }
}
    ${DocumentationSyncFieldsFragmentDoc}`;
export type ProceduresQueryQueryResult = Apollo.QueryResult<ProceduresQueryQuery, ProceduresQueryQueryVariables>;
export const ProcedureQueryDocument = gql`
    query ProcedureQuery($id: UUID!) {
  procedure(id: $id) {
    id
    status
    sourceSystem
    externalId
    codeSystem
    codeValue
    codeDisplay
    description
    plannedStart
    plannedEnd
    performedStart
    performedEnd
    acknowledgedAt
    documentationSyncsList {
      ...DocumentationSyncFields
    }
    notes
    documentation
    sourceData
    createdAt
    updatedAt
    procedureNotesList {
      procedureNotes {
        id
        note
        kind
        createdAt
        publishedAt
        documentationSyncsList {
          ...DocumentationSyncFields
        }
        seniorList {
          id
          name
        }
        author {
          id
          firstName
          lastName
          name
        }
      }
    }
    procedureParticipants {
      nodes {
        patient {
          id
          patientNumber
          location {
            id
            partOfId
          }
          user {
            firstName
            lastName
            name
            avatarUrl
          }
        }
      }
    }
    performer {
      id
      user {
        firstName
        lastName
        name
      }
    }
    organization {
      id
      name
    }
    activitySessions {
      nodes {
        id
        beganAt
        endedAt
        sessionStatus
        caregiver {
          id
          name
          firstName
          lastName
        }
        activity {
          id
          kind
          contentActivity {
            content {
              id
              title
              cmsContentId
              cmsContentKind
              cmsNextContentKind
              thumbnailFilename
            }
          }
          featureActivity {
            kind
          }
          customActivity {
            name
          }
        }
        activityParticipants {
          nodes {
            senior {
              id
              name
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    ${DocumentationSyncFieldsFragmentDoc}`;
export type ProcedureQueryQueryResult = Apollo.QueryResult<ProcedureQueryQuery, ProcedureQueryQueryVariables>;
export const RevealDeviceEnrollmentTokenDocument = gql`
    query RevealDeviceEnrollmentToken($id: UUID!) {
  deviceEnrollmentToken(id: $id) {
    id
    code
    qrPayload
  }
}
    `;
export type RevealDeviceEnrollmentTokenQueryResult = Apollo.QueryResult<RevealDeviceEnrollmentTokenQuery, RevealDeviceEnrollmentTokenQueryVariables>;
export const CustomerServiceCrmListDocument = gql`
    query CustomerServiceCrmList($input: CrmListInput!) {
  customerServiceCrmList(input: $input) {
    object
    listView
    listViews
    totalCount
    columns {
      key
      type
    }
    rows {
      ...CrmRowFields
    }
  }
}
    ${CrmRowFieldsFragmentDoc}`;
export type CustomerServiceCrmListQueryResult = Apollo.QueryResult<CustomerServiceCrmListQuery, CustomerServiceCrmListQueryVariables>;
export const CustomerServiceCrmRecordDocument = gql`
    query CustomerServiceCrmRecord($object: CrmObject!, $salesforceId: String!) {
  customerServiceCrmRecord(
    object: $object
    salesforceId: $salesforceId
    includeOpportunities: true
  ) {
    contractItemInventoryHistory {
      id
      inventory {
        ...CrmInventoryUnitFields
      }
      atClientDate
      removedFromClientDate
      inStockDate
      deletedInSalesforceAt
    }
    contractItemOrders {
      id
      orderSalesforceId
      orderNumber
      recordType
      status
      exchangeStatus
      orderRejected
      createdBy
      createdAt
      deletedInSalesforceAt
    }
    contractItemAsset {
      salesforceId
      name
      deletedInSalesforceAt
      tablet {
        ...CrmInventoryUnitFields
      }
      sim {
        ...CrmInventoryUnitFields
      }
      hardware {
        ...CrmInventoryUnitFields
      }
    }
    object
    salesforceId
    title
    salesforceUrl
    syncedAt
    deletedInSalesforceAt
    mergedInto {
      salesforceId
      title
    }
    hasTimeline
    highlights {
      ...CrmValueFields
    }
    path {
      stages
      current
    }
    sections {
      key
      values {
        ...CrmValueFields
      }
    }
    related {
      key
      object
      totalCount
      columns {
        key
        type
      }
      rows {
        ...CrmRowFields
      }
    }
    appOrganizations {
      id
      name
    }
  }
}
    ${CrmInventoryUnitFieldsFragmentDoc}
${CrmValueFieldsFragmentDoc}
${CrmRowFieldsFragmentDoc}`;
export type CustomerServiceCrmRecordQueryResult = Apollo.QueryResult<CustomerServiceCrmRecordQuery, CustomerServiceCrmRecordQueryVariables>;
export const CustomerServiceCrmTimelineDocument = gql`
    query CustomerServiceCrmTimeline($object: CrmObject!, $salesforceId: String!, $kinds: [CrmTimelineKind!], $after: CrmTimelineCursorInput, $limit: Int) {
  customerServiceCrmTimeline(
    object: $object
    salesforceId: $salesforceId
    kinds: $kinds
    after: $after
    limit: $limit
  ) {
    kind
    salesforceId
    at
    title
    body
    bodyNotImported
    inbound
    actor
    counterpart
    durationSeconds
    recorded
    field
    oldValue
    newValue
    caseId
    caseTitle
    provider
  }
}
    `;
export type CustomerServiceCrmTimelineQueryResult = Apollo.QueryResult<CustomerServiceCrmTimelineQuery, CustomerServiceCrmTimelineQueryVariables>;
export const CustomerServiceCrmSearchDocument = gql`
    query CustomerServiceCrmSearch($term: String!) {
  customerServiceCrmSearch(term: $term, includeOpportunities: true) {
    object
    salesforceId
    title
    subtitle
    deletedInSalesforceAt
  }
}
    `;
export type CustomerServiceCrmSearchQueryResult = Apollo.QueryResult<CustomerServiceCrmSearchQuery, CustomerServiceCrmSearchQueryVariables>;
export const CustomerServiceCrmPhoneMatchesDocument = gql`
    query CustomerServiceCrmPhoneMatches($number: String!) {
  customerServiceCrmPhoneMatches(number: $number) {
    object
    salesforceId
    title
    subtitle
  }
}
    `;
export type CustomerServiceCrmPhoneMatchesQueryResult = Apollo.QueryResult<CustomerServiceCrmPhoneMatchesQuery, CustomerServiceCrmPhoneMatchesQueryVariables>;
export const CustomerServiceCallKpisDocument = gql`
    query CustomerServiceCallKpis($range: CallKpiRange!) {
  customerServiceCallKpis(range: $range) {
    hotlineConfigured
    inbound
    answered
    missed
    abandoned
    notRouted
    reachability
    averageWaitSeconds
    maxWaitSeconds
    averageHandleSeconds
    outbound
    agents {
      agentKey
      name
      answered
      outbound
      averageHandleSeconds
    }
    syncedAt
    syncError
  }
}
    `;
export type CustomerServiceCallKpisQueryResult = Apollo.QueryResult<CustomerServiceCallKpisQuery, CustomerServiceCallKpisQueryVariables>;
export const CustomerServiceProviderCallsDocument = gql`
    query CustomerServiceProviderCalls($range: CallKpiRange!, $filter: CallListFilter!, $agentKey: String, $first: Int, $after: String) {
  customerServiceProviderCalls(
    range: $range
    filter: $filter
    agentKey: $agentKey
    first: $first
    after: $after
  ) {
    totalCount
    rows {
      id
      startedAt
      direction
      outcome
      customerNumber
      agentName
      waitSeconds
      handleSeconds
      withinOpeningHours
    }
    endCursor
    hasMore
  }
}
    `;
export type CustomerServiceProviderCallsQueryResult = Apollo.QueryResult<CustomerServiceProviderCallsQuery, CustomerServiceProviderCallsQueryVariables>;
export const FinanceNotificationsDocument = gql`
    query FinanceNotifications($rule: FinanceNotificationRule, $after: String) {
  financeNotifications(rule: $rule, after: $after) {
    nodes {
      id
      rule
      openedAt
      item {
        ...FinanceContractItemFields
      }
      billwerkEffectiveFrom
      returnOrder {
        salesforceId
        salesforceUrl
        orderNumber
        status
        completedDate
      }
      noCompletedReturn
      changedInto {
        ...FinanceContractItemFields
      }
      handledStatus
      handledEndDate
      handledAt
    }
    totalCount
    hasNextPage
    endCursor
    sync {
      lastSucceededAt
      lastRunFailed
      unreadableFields
    }
  }
}
    ${FinanceContractItemFieldsFragmentDoc}`;
export type FinanceNotificationsQueryResult = Apollo.QueryResult<FinanceNotificationsQuery, FinanceNotificationsQueryVariables>;
export const FinanceNotificationCountDocument = gql`
    query FinanceNotificationCount {
  financeNotificationCount
}
    `;
export type FinanceNotificationCountQueryResult = Apollo.QueryResult<FinanceNotificationCountQuery, FinanceNotificationCountQueryVariables>;
export const BillwerkPlanVariantsDocument = gql`
    query BillwerkPlanVariants($view: BillwerkPlanVariantView!, $state: BillwerkPlanVariantState, $search: String, $offset: Int) {
  billwerkPlanVariants(
    view: $view
    state: $state
    search: $search
    offset: $offset
  ) {
    billwerk {
      status
      loadedAt
      variantCount
    }
    salesforceSync {
      lastSucceededAt
      unreadableFields
      entriesCopied
    }
    withheld
    entryCounts {
      state
      count
    }
    itemCounts {
      state
      count
    }
    totalCount
    entries {
      salesforceId
      salesforceUrl
      priceBookId
      priceBookName
      priceBookActive
      priceBookStandard
      productId
      productName
      productFamily
      active
      currency
      billingItems
      planVariant {
        ...BillwerkPlanVariantFields
      }
    }
    items {
      salesforceId
      salesforceUrl
      name
      status
      accountName
      contractNumber
      contractUrl
      productName
      billed
      openNotification
      planVariant {
        ...BillwerkPlanVariantFields
      }
    }
  }
}
    ${BillwerkPlanVariantFieldsFragmentDoc}`;
export type BillwerkPlanVariantsQueryResult = Apollo.QueryResult<BillwerkPlanVariantsQuery, BillwerkPlanVariantsQueryVariables>;
export const BillwerkCustomerMatchDocument = gql`
    query BillwerkCustomerMatch($group: BillwerkCustomerMatchGroup, $reason: BillwerkCustomerMatchReason, $search: String, $offset: Int, $refreshAfter: Datetime) {
  billwerkCustomerMatch(
    group: $group
    reason: $reason
    search: $search
    offset: $offset
    refreshAfter: $refreshAfter
  ) {
    billwerk {
      status
      loadedAt
      failedAt
      contracts
      customerCount
      checkedAt
    }
    salesforceSync {
      lastSucceededAt
      unreadableFields
      accountFieldsCopied
    }
    withheld
    counts {
      group
      reason
      count
    }
    totalCount
    rows {
      group
      reason
      debitorAccount
      accounts {
        ...BillwerkMatchAccountFields
      }
      payer {
        ...BillwerkMatchAccountFields
      }
      customers {
        id
        url
        name
        debitorAccount
        oldCustomerNumber
        externalCustomerId
        activeContract
      }
      mappedCustomerIds
      billedFacilities
    }
  }
}
    ${BillwerkMatchAccountFieldsFragmentDoc}`;
export type BillwerkCustomerMatchQueryResult = Apollo.QueryResult<BillwerkCustomerMatchQuery, BillwerkCustomerMatchQueryVariables>;
export const CustomerServiceCrmOverviewDocument = gql`
    query CustomerServiceCrmOverview {
  customerServiceCrmOverview {
    syncedAt
    openCases
    waitingCases
    escalatedCases
    outsideSlaCases
    createdToday
    closedToday
    openByType {
      label
      count
    }
    openByStatus {
      label
      count
    }
    openByOwner {
      label
      count
    }
    oldestOpen {
      ...CrmRowFields
    }
    callsPerDay {
      day
      inbound
      outbound
    }
  }
}
    ${CrmRowFieldsFragmentDoc}`;
export type CustomerServiceCrmOverviewQueryResult = Apollo.QueryResult<CustomerServiceCrmOverviewQuery, CustomerServiceCrmOverviewQueryVariables>;
export const MarketingOverviewDocument = gql`
    query MarketingOverview {
  marketingOverview {
    syncedAt
    months
    newLeads {
      label
      total
      months
      details {
        label
        total
        months
      }
    }
    conversions {
      label
      total
      months
    }
    medianDaysToConvert
    medianDaysToConvertByMonth
    openByStatus {
      label
      count
    }
  }
}
    `;
export type MarketingOverviewQueryResult = Apollo.QueryResult<MarketingOverviewQuery, MarketingOverviewQueryVariables>;
export const MarketingWebOrdersDocument = gql`
    query MarketingWebOrders {
  marketingWebOrders {
    syncedAt
    stuckAfterMinutes
    planVariantIdsKnown
    weeks {
      week
      orders
      stuck
    }
    orders {
      salesforceId
      title
      company
      status
      createdAt
      products {
        name
        quantity
        unitPrice
      }
      planVariantCount
      steps {
        kind
        done
        at
        on
        object
        salesforceId
        title
        salesforceUrl
      }
      stuck
      markers
      salesforceUrl
    }
  }
}
    `;
export type MarketingWebOrdersQueryResult = Apollo.QueryResult<MarketingWebOrdersQuery, MarketingWebOrdersQueryVariables>;
export const FinanceOverviewDocument = gql`
    query FinanceOverview($list: FinanceOverviewList!, $reconciliationStatus: FinanceReconciliationStatus, $salesforceCheck: FinanceSalesforceCheck, $billwerkCheck: FinanceBillwerkCheck, $search: String, $offset: Int, $sort: FinanceOverviewSort, $recentOnly: Boolean) {
  financeOverview(
    list: $list
    reconciliationStatus: $reconciliationStatus
    salesforceCheck: $salesforceCheck
    billwerkCheck: $billwerkCheck
    search: $search
    offset: $offset
    sort: $sort
    recentOnly: $recentOnly
  ) {
    billwerk {
      status
      loadedAt
      contracts
      customerCount
      contractCount
    }
    salesforceSync {
      lastSucceededAt
      unreadableFields
    }
    withheld
    kpis {
      billedMonthlyValue
      billedItems
      billwerkActiveContracts
      billwerkActiveCustomers
      dunningContracts
      dunningRemaining
    }
    toDos {
      rule
      count
      monthlyValue
      legacy
      upcoming
    }
    reconciliationCounts {
      status
      count
      monthlyValue
    }
    salesforceCounts {
      check
      count
      monthlyValue
    }
    billwerkCounts {
      check
      count
      amount
    }
    planVariantGaps {
      count
      monthlyValue
    }
    recentDays
    totalCount
    reconciliation {
      status
      matchGroup
      matchReason
      debitorAccount
      accounts {
        ...FinanceAccountRefFields
      }
      customer {
        ...FinanceCustomerRefFields
      }
      variants {
        planVariantId
        name
        known
        url
        salesforceItems
        salesforceMonthlyValue
        billwerkQuantity
        billwerkContracts
      }
      salesforceItems
      monthlyValue
      billwerkContracts
      salesforceCreatedAt
      billwerkStartedAt
    }
    salesforceItems {
      salesforceId
      salesforceUrl
      name
      status
      accountName
      contractNumber
      contractUrl
      productName
      price
      startDate
      endDate
      billingTool
      createdAt
    }
    billwerkContracts {
      id
      customer {
        ...FinanceCustomerRefFields
      }
      accounts {
        ...FinanceAccountRefFields
      }
      lifecycleStatus
      planVariantId
      planVariantName
      quantity
      startDate
      endDate
      billingSuspended
      dunningLevel
      dunningRemaining
      dunningSince
    }
  }
}
    ${FinanceAccountRefFieldsFragmentDoc}
${FinanceCustomerRefFieldsFragmentDoc}`;
export type FinanceOverviewQueryResult = Apollo.QueryResult<FinanceOverviewQuery, FinanceOverviewQueryVariables>;
export const CustomerServiceCrmDuplicatesDocument = gql`
    query CustomerServiceCrmDuplicates($input: CrmDuplicateListInput) {
  customerServiceCrmDuplicates(input: $input) {
    totalCount
    scannedAt
    scanState
    candidates {
      ...CrmDuplicateCandidateFields
    }
  }
}
    ${CrmDuplicateCandidateFieldsFragmentDoc}`;
export type CustomerServiceCrmDuplicatesQueryResult = Apollo.QueryResult<CustomerServiceCrmDuplicatesQuery, CustomerServiceCrmDuplicatesQueryVariables>;
export const LogisticsInventoryDocument = gql`
    query LogisticsInventory($input: LogisticsInventoryInput!) {
  logisticsInventory(input: $input) {
    deviceFilterSources {
      provider
      state
      syncedAt
      stale
    }
    counts {
      type
      status
      count
    }
    stock {
      type
      free
      readyToShip
      needsStaging
      inStockAtClient
    }
    totalCount
    rows {
      id
      name
      type
      status
      imei
      serialNumber
      hardwareSerialNumber
      simIccid
      appVersion
      qualityCheckDoneAt
      lastInStockAt
      simProvider {
        listed
        status
        connectivityStatus
        lastOnlineAt
      }
      hexnode {
        ...LogisticsHexnodeDevice
      }
      workspaceOne {
        ...LogisticsWorkspaceOneMatch
      }
      deletedInSalesforceAt
    }
    syncedAt
  }
}
    ${LogisticsHexnodeDeviceFragmentDoc}
${LogisticsWorkspaceOneMatchFragmentDoc}`;
export type LogisticsInventoryQueryResult = Apollo.QueryResult<LogisticsInventoryQuery, LogisticsInventoryQueryVariables>;
export const LogisticsInventoryItemDocument = gql`
    query LogisticsInventoryItem($id: UUID!) {
  logisticsInventoryItem(id: $id) {
    id
    salesforceUrl
    name
    type
    status
    inactiveReason
    inactiveDate
    imei
    serialNumber
    hardwareSerialNumber
    simIccid
    newDevice
    lastInStockAt
    lastInTransferAt
    appVersion
    appFlavour
    contentVersion
    createdAt
    modifiedAt
    simProvider {
      listed
      status
      connectivityStatus
      lastOnlineAt
      scannedAt
      checkedAt
    }
    hexnode {
      ...LogisticsHexnodeDevice
    }
    workspaceOne {
      ...LogisticsWorkspaceOneMatch
    }
    deletedInSalesforceAt
    qualityCheck {
      doneAt
      doneBy
      sticker
      mdmRemoved
      knoxRemoved
      noOpenAndroidUpdates
      unknownSourcesAllowed
      accessPointConfigured
      roamingActive
      screenTimeout30Min
      appAsStartApp
      cameraInAppAllowed
    }
    location {
      accountSalesforceId
      accountName
      contractSalesforceId
      contractNumber
      contractItemSalesforceId
      contractItemName
      contractItemStatus
      atClientDate
      asset {
        salesforceUrl
        name
        assetType
        slot
        latestOrder {
          salesforceId
          orderNumber
          name
          recordType
          status
          shippingDate
          completedDate
        }
      }
    }
    history {
      salesforceId
      accountSalesforceId
      accountName
      contractSalesforceId
      contractNumber
      contractItemSalesforceId
      contractItemName
      shippingDate
      atClientDate
      removedFromClientDate
      inStockDate
      endUserChange
      deletedInSalesforceAt
    }
  }
}
    ${LogisticsHexnodeDeviceFragmentDoc}
${LogisticsWorkspaceOneMatchFragmentDoc}`;
export type LogisticsInventoryItemQueryResult = Apollo.QueryResult<LogisticsInventoryItemQuery, LogisticsInventoryItemQueryVariables>;
export const LogisticsWhereverSimDetailsDocument = gql`
    query LogisticsWhereverSimDetails($id: UUID!) {
  logisticsWhereverSimDetails(id: $id) {
    state
    sim {
      data
      errorCode
    }
    endpoint {
      data
      errorCode
    }
    connectivity {
      data
      errorCode
    }
  }
}
    `;
export type LogisticsWhereverSimDetailsQueryResult = Apollo.QueryResult<LogisticsWhereverSimDetailsQuery, LogisticsWhereverSimDetailsQueryVariables>;
export const ContentAnalyticsReportDocument = gql`
    query ContentAnalyticsReport($dateFrom: Date!, $dateTo: Date!, $mode: ContentAnalyticsMode!, $contentKind: String, $contentSubtype: String, $first: Int!, $offset: Int!) {
  contentAnalyticsReport(
    dateFrom: $dateFrom
    dateTo: $dateTo
    mode: $mode
    contentKind: $contentKind
    contentSubtype: $contentSubtype
    first: $first
    offset: $offset
  ) {
    periodStart
    periodEnd
    latestDataDate
    contentTypes
    contentSubtypes
    totalCount
    usedCount
    unusedCount
    overview {
      contentKind
      sessionCount
      completedSessionCount
      unfinishedSessionCount
    }
    items {
      contentId
      title
      contentKind
      contentSubtype
      thumbnailFilename
      sessionCount
      completedSessionCount
      unfinishedSessionCount
    }
  }
}
    `;
export type ContentAnalyticsReportQueryResult = Apollo.QueryResult<ContentAnalyticsReportQuery, ContentAnalyticsReportQueryVariables>;
export const AccountBillingDocument = gql`
    query AccountBilling($salesforceId: String!) {
  customerServiceAccountBilling(salesforceId: $salesforceId) {
    availability
    matchingReason
    account {
      salesforceId
      name
    }
    billedThrough {
      salesforceId
      name
    }
    customer {
      id
      displayName
      externalCustomerId
      debtorAccount
      url
    }
    invoices {
      ...AccountBillingInvoicesFields
    }
    profile {
      ...AccountBillingProfileFields
    }
    subscriptions {
      ...AccountBillingSubscriptionsFields
    }
    ledger {
      ...AccountBillingLedgerFields
    }
  }
}
    ${AccountBillingInvoicesFieldsFragmentDoc}
${AccountBillingProfileFieldsFragmentDoc}
${AccountBillingSubscriptionsFieldsFragmentDoc}
${AccountBillingLedgerFieldsFragmentDoc}`;
export type AccountBillingQueryResult = Apollo.QueryResult<AccountBillingQuery, AccountBillingQueryVariables>;
export const AccountBillingInvoicesDocument = gql`
    query AccountBillingInvoices($salesforceId: String!, $after: String, $dateFrom: String, $dateTo: String) {
  customerServiceAccountBilling(salesforceId: $salesforceId) {
    availability
    matchingReason
    billedThrough {
      salesforceId
    }
    customer {
      id
    }
    invoices(after: $after, dateFrom: $dateFrom, dateTo: $dateTo) {
      ...AccountBillingInvoicesFields
    }
  }
}
    ${AccountBillingInvoicesFieldsFragmentDoc}`;
export type AccountBillingInvoicesQueryResult = Apollo.QueryResult<AccountBillingInvoicesQuery, AccountBillingInvoicesQueryVariables>;
export const AccountBillingProfileDocument = gql`
    query AccountBillingProfile($salesforceId: String!) {
  customerServiceAccountBilling(salesforceId: $salesforceId) {
    availability
    matchingReason
    billedThrough {
      salesforceId
    }
    customer {
      id
    }
    profile {
      ...AccountBillingProfileFields
    }
  }
}
    ${AccountBillingProfileFieldsFragmentDoc}`;
export type AccountBillingProfileQueryResult = Apollo.QueryResult<AccountBillingProfileQuery, AccountBillingProfileQueryVariables>;
export const AccountBillingSubscriptionsDocument = gql`
    query AccountBillingSubscriptions($salesforceId: String!, $after: String) {
  customerServiceAccountBilling(salesforceId: $salesforceId) {
    availability
    matchingReason
    billedThrough {
      salesforceId
    }
    customer {
      id
    }
    subscriptions(after: $after) {
      ...AccountBillingSubscriptionsFields
    }
  }
}
    ${AccountBillingSubscriptionsFieldsFragmentDoc}`;
export type AccountBillingSubscriptionsQueryResult = Apollo.QueryResult<AccountBillingSubscriptionsQuery, AccountBillingSubscriptionsQueryVariables>;
export const AccountBillingLedgerDocument = gql`
    query AccountBillingLedger($salesforceId: String!, $after: String) {
  customerServiceAccountBilling(salesforceId: $salesforceId) {
    availability
    matchingReason
    billedThrough {
      salesforceId
    }
    customer {
      id
    }
    ledger(after: $after) {
      ...AccountBillingLedgerFields
    }
  }
}
    ${AccountBillingLedgerFieldsFragmentDoc}`;
export type AccountBillingLedgerQueryResult = Apollo.QueryResult<AccountBillingLedgerQuery, AccountBillingLedgerQueryVariables>;
export const LogisticsWorkspaceOneDevicesDocument = gql`
    query LogisticsWorkspaceOneDevices {
  logisticsWorkspaceOneDevices {
    state
    syncedAt
    stale
    devices {
      device {
        ...LogisticsWorkspaceOneDevice
      }
      matchState
      inventory {
        id
        name
        hardwareSerialNumber
        deletedInSalesforceAt
      }
      customer {
        accountSalesforceId
        accountName
      }
      contradictions
    }
  }
}
    ${LogisticsWorkspaceOneDeviceFragmentDoc}`;
export type LogisticsWorkspaceOneDevicesQueryResult = Apollo.QueryResult<LogisticsWorkspaceOneDevicesQuery, LogisticsWorkspaceOneDevicesQueryVariables>;
export const LogisticsDhlShippingSettingsDocument = gql`
    query LogisticsDhlShippingSettings {
  logisticsDhlShippingSettings {
    ...LogisticsDhlShippingSettingsFields
  }
}
    ${LogisticsDhlShippingSettingsFieldsFragmentDoc}`;
export type LogisticsDhlShippingSettingsQueryResult = Apollo.QueryResult<LogisticsDhlShippingSettingsQuery, LogisticsDhlShippingSettingsQueryVariables>;
export const LogisticsDhlAccountSettingsDocument = gql`
    query LogisticsDhlAccountSettings {
  logisticsDhlAccountSettings {
    ...LogisticsDhlAccountSettingsFields
  }
}
    ${LogisticsDhlAccountSettingsFieldsFragmentDoc}`;
export type LogisticsDhlAccountSettingsQueryResult = Apollo.QueryResult<LogisticsDhlAccountSettingsQuery, LogisticsDhlAccountSettingsQueryVariables>;
export const LogisticsOrderCommandStatusDocument = gql`
    query LogisticsOrderCommandStatus($salesforceId: String!) {
  logisticsOrderCommandStatus(salesforceId: $salesforceId) {
    orderId
    commandId
    state
    refusal
    messages
  }
}
    `;
export type LogisticsOrderCommandStatusQueryResult = Apollo.QueryResult<LogisticsOrderCommandStatusQuery, LogisticsOrderCommandStatusQueryVariables>;
export const LogisticsShippingLabelStateDocument = gql`
    query LogisticsShippingLabelState($salesforceId: String!) {
  logisticsShippingLabelState(salesforceId: $salesforceId) {
    orderId
    enabled
    pilot
    refusal
    label {
      ...LogisticsShippingLabelFields
    }
    attempt {
      requestId
      command
      labelId
      returnLabel
      outcome
      refusal
      messages
      salesforceCommandId
    }
  }
}
    ${LogisticsShippingLabelFieldsFragmentDoc}`;
export type LogisticsShippingLabelStateQueryResult = Apollo.QueryResult<LogisticsShippingLabelStateQuery, LogisticsShippingLabelStateQueryVariables>;